import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const translationEn = {
  "LOGIN": "LOGIN",
  "REGISTER": "REGISTER",
  "SKIP TO PAYMENT": "SKIP TO PAYMENT",
  "Continue as guest": "Continue as guest",
  "WELCOME": "WELCOME",
  "Error": "Error",
  "Please enter the correct phone number format. <br /><br /> <small>Example: 0129465628</small>": "Please enter the correct phone number format. <br /><br /> <small>Example: 0129465628</small>",
  "Info": "Info",
  "Please scan QRCode to Login": "Please scan QRCode to Login",
  "Forgot Password": "Forgot Password",
  "Seems like you have forgotten your password<br />Create a temporary password?": "Seems like you have forgotten your password<br />Create a temporary password?",
  "Cancel": "Cancel",
  "Confirm": "Confirm",
  "Reset Your Password": "Reset Your Password",
  "Enter Your Phone Number / Email Address": "Enter Your Phone Number / Email Address",
  "Enter Your Email Address": "Enter Your Email Address",
  "Please enter phone number / email address": "Please enter phone number / email address",
  "Please enter email address": "Please enter email address",
  "Submit": "Submit",
  "Please enter a valid phone number": "Please enter a valid phone number",
  "Please enter a valid email address": "Please enter a valid email address",
  "Success!": "Success!",
  "You may login using your one time password now.": "You may login using your one time password now.",
  "Phone Number": "Phone Number",
  "Password": "Password",
  "Don't have an account?": "Don't have an account?",
  "Forgot password?": "Forgot password?",
  "Unable to register without a QRCode": "Unable to register without a QRCode",
  "Please read and agree to the privacy policies, terms and conditions": "Please read and agree to the privacy policies, terms and conditions",
  "Password length must be at least 6 characters": "Password length must be at least 6 characters",
  "Please enter the confirmation code that was sent to your phone": "Please enter the confirmation code that was sent to your phone",
  "Example: 012xxxxxxx": "Example: 012xxxxxxx",
  "Example: 09xxxxxxxx": "Example: 09xxxxxxxx",
  "Verification Method": "Verification Method",
  "Name": "Name",
  "Email": "Email",
  "optional": "optional",
  "Birth Year": "Birth Year",
  "Year": "Year",
  "Birth Month": "Birth Month",
  "Month": "Month",
  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "Mar",
  "April": "April",
  "May": "May",
  "June": "June",
  "July": "July",
  "Aug": "Aug",
  "Sept": "Sept",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Dec",
  "Birth Day": "Birth Day",
  "Day": "Day",
  "OTP": "OTP",
  "OTP Confirmation": "OTP Confirmation",
  "I agree to the": "I agree to the",
  "Privacy Policy": "Privacy Policy",
  "PRIVACY POLICY": "PRIVACY POLICY",
  "and": "and",
  "Terms": "Terms",
  "Conditions": "Conditions",
  "SEND CODE": "SEND CODE",
  "Our One-Time Password (OTP) emails might end up in your spam or junk folder. We kindly ask you to take a moment to check your spam mailbox.": "Our One-Time Password (OTP) emails might end up in your spam or junk folder. We kindly ask you to take a moment to check your spam mailbox.",
  "Already have an account? Login": "Already have an account? Login",
  "Didn't receive a code?": "Didn't receive a code?",
  "Resend Code": "Resend Code",
  "collected": "collected",
  "Collect": "Collect",
  "stamps": "stamps",
  "get 1 voucher": "get 1 voucher",
  "Minimum": "Minimum",
  "spending to collect each washer stamp": "spending to collect each washer stamp",
  "spending to collect each dryer stamp": "spending to collect each dryer stamp",
  "spending to collect each stamp": "spending to collect each stamp",
  "Device don't have a camera": "Device don't have a camera",
  "This is not a valid QRCode": "This is not a valid QRCode",
  "Select Camera": "Select Camera",
  "Switch": "Switch",
  "Camera": "Camera",
  "Loading": "Loading",
  "Scan the QR code on the machine.": "Scan the QR code on the machine.",
  "Switch Camera": "Switch Camera",
  "Off torch light": "Off torch light",
  "On torch light": "On torch light",
  "switch camera if your camera is not clear": "switch camera if your camera is not clear",
  "Switch your camera if the display is not clear": "Switch your camera if the display is not clear",
  "Please allow this webapp to access your camera": "Please allow this webapp to access your camera",
  "DISCOUNT": "DISCOUNT",
  "Congratulation": "Congratulation",
  "Expired Date": "Expired Date",
  "Voucher": "Voucher",
  "Vouchers": "Vouchers",
  "Something went wrong": "Something went wrong",
  "Stamping Collection": "Stamping Collection",
  "Total e-Token": "Total e-Token",
  "Total Wash": "Total Wash",
  "Total Dry": "Total Dry",
  "Reload": "Reload",
  "Washer": "Washer",
  "Dryer": "Dryer",
  "Congratulations!": "Congratulations!",
  "You have completed your Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "You have completed your Stamp collection.<br />Granted a voucher and stamp collection is refreshed",
  "You have completed Washer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "You have completed Washer Stamp collection.<br />Granted a voucher and stamp collection is refreshed",
  "You have completed Dryer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "You have completed Dryer Stamp collection.<br />Granted a voucher and stamp collection is refreshed",
  "Latest News": "Latest News",
  "Transaction History": "Transaction History",
  "Stamping": "Stamping",
  "Transaction": "Transaction",
  "News": "News",
  "Confirmation": "Confirmation",
  "Logout Session?": "Logout Session?",
  "NO": "NO",
  "OK": "OK",
  "Account": "Account",
  "FAQs": "FAQs",
  "Feedback": "Feedback",
  "LOGOUT": "LOGOUT",
  "Logout": "Logout",
  "Are you sure you want to submit your feedback?": "Are you sure you want to submit your feedback?",
  "No": "No",
  "Yes": "Yes",
  "Success": "Success",
  "Failed": "Failed",
  "Pending": "Pending",
  "Your feedback is submitted successfully": "Your feedback is submitted successfully",
  "Please fill in all the required fields before submit.": "Please fill in all the required fields before submit.",
  "Give us your feedback!": "Give us your feedback!",
  "Type your name here (optional)": "Type your name here (optional)",
  "required": "required",
  "Type your number here": "Type your number here",
  "Outlet": "Outlet",
  "Select an outlet": "Select an outlet",
  "Outlet Cleanliness": "Outlet Cleanliness",
  "Washer Machine Performance": "Washer Machine Performance",
  "Dryer Machine Performance": "Dryer Machine Performance",
  "Customer Service": "Customer Service",
  "Comment": "Comment",
  "Type your comment here (optional)": "Type your comment here (optional)",
  "SUBMIT": "SUBMIT",
  "Join as a member now!": "Join as a member now!",
  "Join as a loyalty member now to get more benefits such as vouchers and free machine usage!<br /><br /><strong>Register as loyalty member?</strong>": "Join as a loyalty member now to get more benefits such as vouchers and free machine usage!<br /><br /><strong>Register as loyalty member?</strong>",
  "Maybe Next Time": "Maybe Next Time",
  "Yes, Register Now": "Yes, Register Now",
  "Washer Payment": "Washer Payment",
  "Dryer Payment": "Dryer Payment",
  "Vending Machine Payment": "Vending Machine Payment",
  "Online": "Online",
  "Offline": "Offline",
  "Running": "Running",
  "Vacant": "Vacant",
  "Vending Machine": "Vending Machine",
  "Discount": "Discount",
  "No Vouchers Available": "No Vouchers Available",
  "Payment Method": "Payment Method",
  "Would you like to pay with?": "Would you like to pay with?",
  "e-Token": "e-Token",
  "E-TOKEN": "E-TOKEN",
  "E-Wallet": "E-Wallet",
  "E-Wallet & Online Banking": "E-Wallet & Online Banking",
  "Duitnow QR code": "Duitnow QR code",
  "PromptPay QR Code": "PromptPay QR Code",
  "The Duitnow QR code will be downloaded and you need to open your banking app to make the payment. Pay {{ currency }}{{ totalPaymentAmount }} to {{ machineName }}?": "The Duitnow QR code will be downloaded and you need to open your banking app to make the payment. Pay {{ currency }}{{ totalPaymentAmount }} to {{ machineName }}?",
  "Pay": "Pay",
  "to": "to",
  "You may under utilized the voucher.": "You may under utilized the voucher.",
  "Proceed to pay": "Proceed to pay",
  "Processing ...": "Processing ...",
  "You can't pay with e-token if voucher is in used, please remove your voucher to pay with e-token.": "You can't pay with e-token if voucher is in used, please remove your voucher to pay with e-token.",
  "Insufficient e-Tokens": "Insufficient e-Tokens",
  "Reload your e-token now?": "Reload your e-token now?",
  "Reload now!": "Reload now!",
  "You have": "You have",
  "e-Tokens": "e-Tokens",
  "Tokens to": "Tokens to",
  "This machine is currently offline, please try again later.": "This machine is currently offline, please try again later.",
  "MACHINE": "MACHINE",
  "Machine": "Machine",
  "TYPE": "TYPE",
  "CAPACITY": "CAPACITY",
  "DURATION": "DURATION",
  "Select Duration": "Select Duration",
  "AMOUNT TO PAY": "AMOUNT TO PAY",
  "PRICE": "PRICE",
  "VOUCHER": "VOUCHER",
  "Select Voucher >": "Select Voucher >",
  "TOTAL": "TOTAL",
  "PAY": "PAY",
  "Remove Voucher": "Remove Voucher",
  "Select Your Voucher": "Select Your Voucher",
  "min": "min",
  "MIN": "MIN",
  "Select Payment Amount": "Select Payment Amount",
  "Select Water Temperature": "Select Water Temperature",
  "Select temperature": "Select temperature",
  "Select Temperature": "Select Temperature",
  "Cold": "Cold",
  "Warm": "Warm",
  "Hot": "Hot",
  "e-Tokens to": "e-Tokens to",
  "No Purchase History": "No Purchase History",
  "e-tokens": "e-tokens",
  "No Promotions": "No Promotions",
  "New Password": "New Password",
  "Back": "Back",
  "Buy this package?": "Buy this package?",
  "Purchase": "Purchase",
  "e-Tokens for": "e-Tokens for",
  "Reload Tokens": "Reload Tokens",
  "Are you sure you want to purchase {{ tokenAmount }} e-Token for {{ currency }}{{ paymentAmount }}?": "Are you sure you want to purchase {{ tokenAmount }} e-Token for {{ currency }}{{ paymentAmount }}?",
  "Current e-Token": "Current e-Token",
  "Current point": "Current point",
  "History": "History",
  "Your profile picture has been updated!": "Your profile picture has been updated!",
  "Please only use png, jpg or jpeg file extension type": "Please only use png, jpg or jpeg file extension type",
  "Please only use image type file": "Please only use image type file",
  "User name has updated successfully!": "User name has updated successfully!",
  "Email Address updated successfully": "Email Address updated successfully",
  "Phone number updated successfully": "Phone number updated successfully",
  "Password must be at least 6 characters": "Password must be at least 6 characters",
  "Password updated successfully": "Password updated successfully",
  "User Settings": "User Settings",
  "Profile Picture": "Profile Picture",
  "Change Password": "Change Password",
  "Do you want to submit your feedback?": "Do you want to submit your feedback?",
  "Thank You!": "Thank You!",
  "Thank you for using our services.": "Thank you for using our services.",
  "BACK TO HOMEPAGE": "BACK TO HOMEPAGE",
  "How to pay?": "How to pay?",
  "Step 1": "Step 1",
  "After scan the QR code on the machine, select either register new account, login your account or skip to payment.": "After scan the QR code on the machine, select either register new account, login your account or skip to payment.",
  "Step 2-1": "Step 2-1",
  "For Dryer – Select your desired duration. Different duration will have different prices.": "For Dryer – Select your desired duration. Different duration will have different prices.",
  "Step 2-2": "Step 2-2",
  "For Washer – Select your desired water temperature. Different water temperature will have different prices.": "For Washer – Select your desired water temperature. Different water temperature will have different prices.",
  "Step 3": "Step 3",
  "For login user, Click on ‘Select Voucher’ to select your voucher.": "For login user, Click on ‘Select Voucher’ to select your voucher.",
  "Step 4": "Step 4",
  "Click on ‘PAY’ button to pay. For login user, select your payment method to pay.": "Click on ‘PAY’ button to pay. For login user, select your payment method to pay.",
  "Step 5": "Step 5",
  "After confirm the price and machine details, click on ‘OK’ button to pay.": "After confirm the price and machine details, click on ‘OK’ button to pay.",
  "How to reload your e-Token?": "How to reload your e-Token?",
  'Click on the "Reload" button.': 'Click on the "Reload" button.',
  "Select the package that you wish to purchase.": "Select the package that you wish to purchase.",
  'Click on "Purchase" as confirmation before payment page.': 'Click on "Purchase" as confirmation before payment page.',
  "Is e-token can be refund/transfer back to e-wallet?": "Is e-token can be refund/transfer back to e-wallet?",
  "Why can't I applied my voucher?": "Why can't I applied my voucher?",
  "When there is a Happy Hour Promotion is on going, you are unable to apply your voucher temporarily.": "When there is a Happy Hour Promotion is on going, you are unable to apply your voucher temporarily.",
  "How to apply my voucher?": "How to apply my voucher?",
  'Click on the "Select Voucher" button.': 'Click on the "Select Voucher" button.',
  "Select the voucher that you wish to apply.": "Select the voucher that you wish to apply.",
  'Click on "Pay" once you have verified the voucher is successfully applied.': 'Click on "Pay" once you have verified the voucher is successfully applied.',
  "Step 2": "Step 2",
  "Language has updated successfully!": "Language has updated successfully!",
  "Change Language": "Change Language",
  "Language": "Language",
  "Select language": "Select language",
  "Referral Code": "Referral Code",
  "Copied!": "Copied!",
  "Inviting friends to get more benefits!": "Inviting friends to get more benefits!",
  "Would you like to share your referral code to your friends & family?": "Would you like to share your referral code to your friends & family?",
  "Refer a friend and get": "Refer a friend and get",
  "Share the love to your friends & family?": "Share the love to your friends & family?",
  "voucher": "voucher",
  "token": "token",
  "stamp": "stamp",
  "washer stamp": "washer stamp",
  "dryer stamp": "dryer stamp",
  "Learn More": "Learn More",
  "Welcome Gift": "Welcome Gift",
  "Share Your Referral Code Now": "Share Your Referral Code Now",
  "Birthday Gift for You": "Birthday Gift for You",
  "Let's Pay with E-Token": "Let's Pay with E-Token",
  "Collect 10 Stamps and Get Voucher": "Collect 10 Stamps and Get Voucher",
  "The voucher will be given if you registered your account successfully.": "The voucher will be given if you registered your account successfully.",
  "There is no expiration date for this voucher.": "There is no expiration date for this voucher.",
  "The voucher can be used for dryer machine only.": "The voucher can be used for dryer machine only.",
  "The voucher can be used for washer machine only.": "The voucher can be used for washer machine only.",
  "The voucher can be used for Drop n Go transaction only.": "The voucher can be used for Drop n Go transaction only.",
  "The voucher can be used for vending transaction only.": "The voucher can be used for vending transaction only.",
  "The voucher can be used for detergent vending transaction only.": "The voucher can be used for detergent vending transaction only.",
  "The voucher can be used for car wash transaction only.": "The voucher can be used for car wash transaction only.",
  "The voucher can be used for washer machine or Drop n Go transaction.": "The voucher can be used for washer machine or Drop n Go transaction.",
  "The voucher can be used for dryer machine or Drop n Go transaction.": "The voucher can be used for dryer machine or Drop n Go transaction.",
  "The voucher can be used for dryer or washer machine.": "The voucher can be used for dryer or washer machine.",
  "The voucher can be used for washer machine, dryer machine or Drop n Go transaction.": "The voucher can be used for washer machine, dryer machine or Drop n Go transaction.",
  "The voucher can be used for washer machine or vending machine transaction.": "The voucher can be used for washer machine or vending machine transaction.",
  "The voucher can be used for washer machine or detergent vending machine transaction.": "The voucher can be used for washer machine or detergent vending machine transaction.",
  "The voucher can be used for washer machine or car wash transaction.": "The voucher can be used for washer machine or car wash transaction.",
  "The voucher can be used for dryer machine or vending machine transaction.": "The voucher can be used for dryer machine or vending machine transaction.",
  "The voucher can be used for dryer machine or detergent vending machine transaction.": "The voucher can be used for dryer machine or detergent vending machine transaction.",
  "The voucher can be used for dryer machine or car wash transaction.": "The voucher can be used for dryer machine or car wash transaction.",
  "The voucher can be used for vending machine or Drop n Go transaction.": "The voucher can be used for vending machine or Drop n Go transaction.",
  "The voucher can be used for detergent vending machine or Drop n Go transaction.": "The voucher can be used for detergent vending machine or Drop n Go transaction.",
  "The voucher can be used for car wash or Drop n Go transaction.": "The voucher can be used for car wash or Drop n Go transaction.",
  "The voucher can be used for vending machine or detergent vending machine transaction.": "The voucher can be used for vending machine or detergent vending machine transaction.",
  "The voucher can be used for vending machine or car wash transaction.": "The voucher can be used for vending machine or car wash transaction.",
  "The voucher can be used for detergent vending machine or car wash transaction.": "The voucher can be used for detergent vending machine or car wash transaction.",
  "The voucher can be used for washer machine, dryer machine or vending machine transaction.": "The voucher can be used for washer machine, dryer machine or vending machine transaction.",
  "The voucher can be used for washer machine, dryer machine or detergent vending machine transaction.": "The voucher can be used for washer machine, dryer machine or detergent vending machine transaction.",
  "The voucher can be used for washer machine, dryer machine or car wash transaction.": "The voucher can be used for washer machine, dryer machine or car wash transaction.",
  "The voucher can be used for washer machine, vending machine or Drop n Go transaction.": "The voucher can be used for washer machine, vending machine or Drop n Go transaction.",
  "The voucher can be used for washer machine, detergent vending machine or Drop n Go transaction.": "The voucher can be used for washer machine, detergent vending machine or Drop n Go transaction.",
  "The voucher can be used for washer machine, car wash or Drop n Go transaction.": "The voucher can be used for washer machine, car wash or Drop n Go transaction.",
  "The voucher can be used for washer machine, vending machine or detergent vending transaction.": "The voucher can be used for washer machine, vending machine or detergent vending transaction.",
  "The voucher can be used for washer machine, vending machine or car wash transaction.": "The voucher can be used for washer machine, vending machine or car wash transaction.",
  "The voucher can be used for washer machine, detergent vending machine or car wash transaction.": "The voucher can be used for washer machine, detergent vending machine or car wash transaction.",
  "The voucher can be used for dryer machine, vending machine or Drop n Go transaction.": "The voucher can be used for dryer machine, vending machine or Drop n Go transaction.",
  "The voucher can be used for dryer machine, detergent vending machine or Drop n Go transaction.": "The voucher can be used for dryer machine, detergent vending machine or Drop n Go transaction.",
  "The voucher can be used for dryer machine, car wash or Drop n Go transaction.": "The voucher can be used for dryer machine, car wash or Drop n Go transaction.",
  "The voucher can be used for dryer machine, vending machine or detergent vending machine transaction.": "The voucher can be used for dryer machine, vending machine or detergent vending machine transaction.",
  "The voucher can be used for dryer machine, vending machine or car wash transaction.": "The voucher can be used for dryer machine, vending machine or car wash transaction.",
  "The voucher can be used for dryer machine, detergent vending machine or car wash transaction.": "The voucher can be used for dryer machine, detergent vending machine or car wash transaction.",
  "The voucher can be used for vending machine, detergent vending machine or Drop n Go transaction.": "The voucher can be used for vending machine, detergent vending machine or Drop n Go transaction.",
  "The voucher can be used for vending machine, car wash or Drop n Go transaction.": "The voucher can be used for vending machine, car wash or Drop n Go transaction.",
  "The voucher can be used for detergent vending machine, car wash or Drop n Go transaction.": "The voucher can be used for detergent vending machine, car wash or Drop n Go transaction.",
  "The voucher can be used for vending machine, detergent vending machine or car wash transaction.": "The voucher can be used for vending machine, detergent vending machine or car wash transaction.",
  "The voucher can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "The voucher can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.",
  "The voucher can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction.": "The voucher can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction.",
  "The voucher can be used for washer machine, dryer machine, vending machine or car wash transaction.": "The voucher can be used for washer machine, dryer machine, vending machine or car wash transaction.",
  "The voucher can be used for washer machine, dryer machine, detergent vending machine or car wash transaction.": "The voucher can be used for washer machine, dryer machine, detergent vending machine or car wash transaction.",
  "The voucher can be used for washer machine, vending machine, detergent vending machine or Drop n Go transaction.": "The voucher can be used for washer machine, vending machine, detergent vending machine or Drop n Go transaction.",
  "The voucher can be used for washer machine, vending machine, car wash or Drop n Go transaction.": "The voucher can be used for washer machine, vending machine, car wash or Drop n Go transaction.",
  "The voucher can be used for washer machine, vending machine, detergent vending machine or car wash transaction.": "The voucher can be used for washer machine, vending machine, detergent vending machine or car wash transaction.",
  "The voucher can be used for dryer machine, vending machine, detergent vending machine or Drop n Go transaction.": "The voucher can be used for dryer machine, vending machine, detergent vending machine or Drop n Go transaction.",
  "The voucher can be used for dryer machine, vending machine, car wash or Drop n Go transaction.": "The voucher can be used for dryer machine, vending machine, car wash or Drop n Go transaction.",
  "The voucher can be used for dryer machine, detergent vending machine, car wash or Drop n Go transaction.": "The voucher can be used for dryer machine, detergent vending machine, car wash or Drop n Go transaction.",
  "The voucher can be used for dryer machine, vending machine, detergent vending machine or car wash transaction.": "The voucher can be used for dryer machine, vending machine, detergent vending machine or car wash transaction.",
  "The voucher can be used for vending machine, detergent vending machine, car wash or Drop n Go transaction.": "The voucher can be used for vending machine, detergent vending machine, car wash or Drop n Go transaction.",
  "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine or Drop n Go transaction.": "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine or Drop n Go transaction.",
  "The voucher can be used for washer machine, dryer machine, vending machine, car wash or Drop n Go transaction.": "The voucher can be used for washer machine, dryer machine, vending machine, car wash or Drop n Go transaction.",
  "The voucher can be used for washer machine, dryer machine, detergent vending machine, car wash or Drop n Go transaction.": "The voucher can be used for washer machine, dryer machine, detergent vending machine, car wash or Drop n Go transaction.",
  "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine or car wash transaction.": "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine or car wash transaction.",
  "The voucher can be used for washer machine, vending macihne, detergent vending machine, car wash or Drop n Go transaction.": "The voucher can be used for washer machine, vending macihne, detergent vending machine, car wash or Drop n Go transaction.",
  "The voucher can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "The voucher can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.",
  "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.",
  "When you applied the voucher during payment, it will give you": "When you applied the voucher during payment, it will give you",
  "discount.": "discount.",
  "When promotion is on going, the voucher is not applicable.": "When promotion is on going, the voucher is not applicable.",
  "The voucher cannot be used if your payment method is E-Token.": "The voucher cannot be used if your payment method is E-Token.",
  "Your referral code can be found in user settings page.": "Your referral code can be found in user settings page.",
  "You can get": "You can get",
  "stamp for the reward.": "stamp for the reward.",
  "e-token for the reward.": "e-token for the reward.",
  "e-token based on transaction payment amount for the reward.": "e-token based on transaction payment amount for the reward.",
  "for the reward.": "for the reward.",
  "based on transaction payment amount for the reward.": "based on transaction payment amount for the reward.",
  "You can get a voucher for the reward": "You can get a voucher for the reward",
  "which have": "which have",
  "it can be used for dryer machine only.": "it can be used for dryer machine only.",
  "it can be used for washer machine only.": "it can be used for washer machine only.",
  "it can be used for Drop n Go transaction only.": "it can be used for Drop n Go transaction only.",
  "it can be used for vending machine only.": "it can be used for vending machine only.",
  "it can be used for car wash transaction only.": "it can be used for car wash transaction only.",
  "it can be used for detergent vending machine only.": "it can be used for detergent vending machine only.",
  "it can be used for dryer or washer machine.": "it can be used for dryer or washer machine.",
  "it can be used for dryer machine or Drop n Go transaction.": "it can be used for dryer machine or Drop n Go transaction.",
  "it can be used for washer machine or Drop n Go transaction.": "it can be used for washer machine or Drop n Go transaction.",
  "it can be used for washer machine, dryer machine or Drop n Go transaction.": "it can be used for washer machine, dryer machine or Drop n Go transaction.",
  "it can be used for washer machine, dryer machine or vending machine transaction.": "it can be used for washer machine, dryer machine or vending machine transaction.",
  "it can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "it can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.",
  "washer stamp for the reward.": "washer stamp for the reward.",
  "dryer stamp for the reward.": "dryer stamp for the reward.",
  "washer stamp and": "washer stamp and",
  "cleanproBirthdayShortDesc_one": "Redeem {{ birthdayVoucherAmount }} credit birthday voucher on your special day with Cleanpro Plus. Tap to learn more.",
  "cleanproBirthdayShortDesc_other": "Redeem {{ birthdayVoucherAmount }} credits birthday voucher on your special day with Cleanpro Plus. Tap to learn more.",
  'When you click on "PAY" button on the payment page, you can choose either using E-wallet or E-token to pay.': 'When you click on "PAY" button on the payment page, you can choose either using E-wallet or E-token to pay.',
  "When you using your voucher during payment, you will be unable to pay with E-token.": "When you using your voucher during payment, you will be unable to pay with E-token.",
  "You can reload your E-token by clicking the reload button in the stamping page and select the package to purchase.": "You can reload your E-token by clicking the reload button in the stamping page and select the package to purchase.",
  "You can reload your E-token by clicking the reload button in the home page and select the package to purchase.": "You can reload your E-token by clicking the reload button in the home page and select the package to purchase.",
  "You can view your E-token reload history and E-token transaction history in transaction page.": "You can view your E-token reload history and E-token transaction history in transaction page.",
  "You can view your E-token transaction history in transaction page.": "You can view your E-token transaction history in transaction page.",
  "Using either dryer machine or washer machine with the minimum spending of": "Using either dryer machine or washer machine with the minimum spending of",
  "to collect one stamp.": "to collect one stamp.",
  "The voucher will be given if you have collected 10 stamps.": "The voucher will be given if you have collected 10 stamps.",
  "Using dryer machine with the minimum spending of": "Using dryer machine with the minimum spending of",
  "Using washer machine with the minimum spending of": "Using washer machine with the minimum spending of",
  "to collect one dryer stamp.": "to collect one dryer stamp.",
  "to collect one washer stamp.": "to collect one washer stamp.",
  "The voucher will be given if you have collected 10 dryer stamps or 10 washer stamps.": "The voucher will be given if you have collected 10 dryer stamps or 10 washer stamps.",
  "For the voucher given by the dryer stamps,": "For the voucher given by the dryer stamps,",
  "For the voucher given by the washer stamps,": "For the voucher given by the washer stamps,",
  "When promotion is on going, all the vouchers is not applicable.": "When promotion is on going, all the vouchers is not applicable.",
  "All the vouchers cannot be used if your payment method is E-Token.": "All the vouchers cannot be used if your payment method is E-Token.",
  "Description": "Description",
  "Refer Friends": "Refer Friends",
  "View our guideline": "View our guideline",
  "When a friend / family register using your referral code, and completed a transaction with a minimum spending of": "When a friend / family register using your referral code, and completed a transaction with a minimum spending of",
  ", you will be rewarded automatically.": ", you will be rewarded automatically.",
  "One user only allow to have": "One user only allow to have",
  "referrals.": "referrals.",
  "Confirmation Password": "Confirmation Password",
  "Password and confirmation password should be same.": "Password and confirmation password should be same.",
  "You haven't applied your voucher": "You haven't applied your voucher",
  "Would you like to continue your payment without using your voucher?": "Would you like to continue your payment without using your voucher?",
  "Continue": "Continue",
  "Apply voucher": "Apply voucher",
  "Transfer": "Transfer",
  "Transfer Tokens": "Transfer Tokens",
  "Please fill in the phone number": "Please fill in the phone number",
  "Please fill in the email": "Please fill in the email",
  "Please enter the phone number / email that you want to transfer to": "Please enter the phone number / email that you want to transfer to",
  "Please fill in the transfer amount": "Please fill in the transfer amount",
  "Transfer amount should be more than 0 and less than your current e-Token": "Transfer amount should be more than 0 and less than your current e-Token",
  "Please enter your password": "Please enter your password",
  "Member ID": "Member ID",
  "E-Token Transfer Amount": "E-Token Transfer Amount",
  "Please confirm the details before proceeding": "Please confirm the details before proceeding",
  "Transfer From": "Transfer From",
  "Transfer To": "Transfer To",
  "Transfer Amount": "Transfer Amount",
  "Transfer Successfully!": "Transfer Successfully!",
  "Transfer Time": "Transfer Time",
  "Token": "Token",
  "Done": "Done",
  "Next": "Next",
  "Enter Password": "Enter Password",
  "Transfer E-Token Amount": "Transfer E-Token Amount",
  "User not found": "User not found",
  "Password is incorrect": "Password is incorrect",
  "Please go to your account setting and reset your password": "Please go to your account setting and reset your password",
  "Only up to last 3 months transaction history": "Only up to last 3 months transaction history",
  "Reload History": "Reload History",
  "Transfer History": "Transfer History",
  "{{ point }} History": "{{ point }} History",
  "Only up to last 3 months reload history": "Only up to last 3 months reload history",
  "Only up to last 3 months transfer history": "Only up to last 3 months transfer history",
  "Only up to last 3 months {{ point }} history": "Only up to last 3 months {{ point }} history",
  "Only up to last 3 months laundry pass history": "Only up to last 3 months laundry pass history",
  "If require urgent response, please contact us through whatapp": "If require urgent response, please contact us through whatapp",
  "Please scan the QR code again": "Please scan the QR code again",
  "Home": "Home",
  "Quick": "Quick",
  "Super": "Super",
  "Premium": "Premium",
  "All users will have infinite referrals.": "All users will have infinite referrals.",
  "Collect 10 stamps to get 1 Voucher": "Collect 10 stamps to get 1 Voucher",
  "The voucher is only for customer use only, not for sale.": "The voucher is only for customer use only, not for sale.",
  "Outlet is currently offline, please try again later": "Outlet is currently offline, please try again later",
  "The voucher will be given if you completed a transaction with a minimum spending of": "The voucher will be given if you completed a transaction with a minimum spending of",
  "The birthday voucher will be given on the first day of your birthday month.": "The birthday voucher will be given on the first day of your birthday month.",
  "The voucher only will be given if you have exceed spending amount of": "The voucher only will be given if you have exceed spending amount of",
  "Pay with KiplePay": "Pay with KiplePay",
  "Pay with Scan2Pay": "Pay with Scan2Pay",
  "Pay with Razer": "Pay with Razer",
  "Pay with HitPay": "Pay with HitPay",
  "Pay with Duitnow QR": "Pay with Duitnow QR",
  "Pay with PagBank": "Pay with PagBank",
  "Pay with PromptPay QR": "Pay with PromptPay QR",
  "Pay with Card": "Pay with Card",
  "Pay with PayWay": "Pay with PayWay",
  "DISCOUNT CODE": "DISCOUNT CODE",
  "Enter code >": "Enter code >",
  "Enter Discount Code": "Enter Discount Code",
  "Remove Code": "Remove Code",
  "Discount Code": "Discount Code",
  "Close": "Close",
  "Please fill in your email address": "Please fill in your email address",
  "Notification": "Notification",
  "Do you want to receive notification when wash cycle done?": "Do you want to receive notification when wash cycle done?",
  "pay extra": "pay extra",
  "Email Address": "Email Address",
  "Please fill in your phone number": "Please fill in your phone number",
  "Invalid Phone Number": "Invalid Phone Number",
  "Washing Complete": "Washing Complete",
  "Drying Complete": "Drying Complete",
  "The voucher will be given if you registered your account successfully, but it only can be used when your total transaction spending reach": "The voucher will be given if you registered your account successfully, but it only can be used when your total transaction spending reach",
  "and above.": "and above.",
  "This voucher is not applicable": "This voucher is not applicable",
  "Finish in": "Finish in",
  "Need to refresh to update": "Need to refresh to update",
  "It's indicative and may change based on washer load": "It's indicative and may change based on washer load",
  "We'll let you know when it's ready to pick up": "We'll let you know when it's ready to pick up",
  "FREE": "FREE",
  "Enter voucher code (if got any)": "Enter voucher code (if got any)",
  "Please fill in the voucher code": "Please fill in the voucher code",
  "Available On": "Available On",
  "Apply": "Apply",
  "Enter a code": "Enter a code",
  "Input Promo Code": "Input Promo Code",
  "Voucher is redeemed successfully!": "Voucher is redeemed successfully!",
  "Not available": "Not available",
  "Unable to register": "Unable to register",
  "Drop n Go Service": "Drop n Go Service",
  "Select Mode": "Select Mode",
  "Quantity": "Quantity",
  "Pack": "Pack",
  "Add more": "Add more",
  "Select Size": "Select Size",
  "Select Services": "Select Services",
  "Are you sure to delete the item?": "Are you sure to delete the item?",
  "Delete": "Delete",
  "Your Duitnow QR code": "Your Duitnow QR code",
  "Your PromptPay QR code": "Your PromptPay QR code",
  "How to pay using Duitnow QR code?": "How to pay using Duitnow QR code?",
  "How to pay using PromptPay QR code?": "How to pay using PromptPay QR code?",
  "Launch": "Launch",
  "Launch your preferred Mobile Banking or eWallet app.": "Launch your preferred Mobile Banking or eWallet app.",
  "Scan QR code from Gallery": "Scan QR code from Gallery",
  "Choose DuitNow QR from your gallery.": "Choose DuitNow QR from your gallery.",
  "Confirm payment details and pay.": "Confirm payment details and pay.",
  "Receive payment confirmation.": "Receive payment confirmation.",
  "expiring on": "expiring on",
  "Expired on": "Expired on",
  "based on transaction payment amount": "based on transaction payment amount",
  "Join as our": "Join as our",
  "Loyalty Member": "Loyalty Member",
  "now to get more reward": "now to get more reward",
  "Payment amount should be greater than 0": "Payment amount should be greater than 0",
  // admin portal
  "Dashboard": "Dashboard",
  "Report": "Report",
  "Store Performance": "Store Performance",
  "User Performance": "User Performance",
  "Voucher Redemption": "Voucher Redemption",
  "Token Report": "Token Report",
  "SMS Report": "SMS Report",
  "Discount Code Report": "Discount Code Report",
  "User Details": "User Details",
  "User Compensation": "User Compensation",
  "Voucher Settings": "Voucher Settings",
  "Token Settings": "Token Settings",
  "Referral Settings": "Referral Settings",
  "Voucher Code": "Voucher Code",
  "Customize Color": "Customize Color",
  "User Migration": "User Migration",
  "Back To": "Back To",
  "Eligibility": "Eligibility",
  "If ticked, the voucher will have expired date": "If ticked, the voucher will have expired date",
  "Expiry": "Expiry",
  "If ticked, the voucher can apply to washer machine transaction": "If ticked, the voucher can apply to washer machine transaction",
  "Washer Use": "Washer Use",
  "If ticked, the voucher can apply to dryer machine transaction": "If ticked, the voucher can apply to dryer machine transaction",
  "Dryer Use": "Dryer Use",
  "If ticked, the voucher can apply to Drop n Go transaction": "If ticked, the voucher can apply to Drop n Go transaction",
  "Package Use": "Package Use",
  "If ticked, the voucher can apply to vending machine transaction": "If ticked, the voucher can apply to vending machine transaction",
  "Vending Use": "Vending Use",
  "If ticked, the voucher can apply to detergent vending machine transaction": "If ticked, the voucher can apply to detergent vending machine transaction",
  "Detergent Use": "Detergent Use",
  "If ticked, the voucher can apply to car wash transaction": "If ticked, the voucher can apply to car wash transaction",
  "Car Wash Use": "Car Wash Use",
  "Voucher Lifespan": "Voucher Lifespan",
  "days": "days",
  "Discount Type": "Discount Type",
  "Select a discount type": "Select a discount type",
  "Flat": "Flat",
  "Rate": "Rate",
  "Voucher Title": "Voucher Title",
  "Voucher Description": "Voucher Description",
  "Voucher Amount": "Voucher Amount",
  "CONFIRM": "CONFIRM",
  "If ticked, the system will give voucher to user who completed washer stamp collection": "If ticked, the system will give voucher to user who completed washer stamp collection",
  "If ticked, the system will give voucher to user who completed dryer stamp collection": "If ticked, the system will give voucher to user who completed dryer stamp collection",
  "If ticked, the user only can get/use the voucher after make a transaction": "If ticked, the user only can get/use the voucher after make a transaction",
  "Pay And Get Voucher": "Pay And Get Voucher",
  "Pay And Use Code": "Pay And Use Code",
  "If ticked, the system will only give the voucher to user after the user make a transaction": "If ticked, the system will only give the voucher to user after the user make a transaction",
  "If ticked, the system will give voucher to user who completed registration process": "If ticked, the system will give voucher to user who completed registration process",
  "If ticked, the system will give voucher to user on their birthday month": "If ticked, the system will give voucher to user on their birthday month",
  "If ticked, the system will give voucher to user who completed stamp collection": "If ticked, the system will give voucher to user who completed stamp collection",
  "Minimum Payment Amount To Get/Use Register Voucher": "Minimum Payment Amount To Get/Use Register Voucher",
  "Voucher Method": "Voucher Method",
  "Select a voucher method": "Select a voucher method",
  "The user directly get the voucher after register but only can use it after make transaction": "The user directly get the voucher after register but only can use it after make transaction",
  "The user only can get voucher after make a transaction": "The user only can get voucher after make a transaction",
  "Minimum Payment Amount To Get Birthday Voucher": "Minimum Payment Amount To Get Birthday Voucher",
  "Minimum Payment Amount To Use Discount Code": "Minimum Payment Amount To Use Discount Code",
  "Outlets": "Outlets",
  "E-Payment Sales": "E-Payment Sales",
  "Number of stamps granted to users": "Number of stamps granted to users",
  "Total number of stamps granted": "Total number of stamps granted",
  "Registered Users": "Registered Users",
  "Stamps": "Stamps",
  "Referral": "Referral",
  "Register": "Register",
  "Top Outlets": "Top Outlets",
  "Users": "Users",
  "Sort by": "Sort by",
  "Top Users": "Top Users",
  "User name": "User name",
  "Number": "Number",
  "Spending": "Spending",
  "Number of registered users": "Number of registered users",
  "Number of voucher given to users": "Number of voucher given to users",
  "Total number of voucher given": "Total number of voucher given",
  "Voucher Type": "Voucher Type",
  "Voucher Value": "Voucher Value",
  "Date": "Date",
  "Discount Code Type": "Discount Code Type",
  "Discount Code Amount": "Discount Code Amount",
  "Number of Redemption": "Number of Redemption",
  "Total Discount Amount": "Total Discount Amount",
  "Select Outlet": "Select Outlet",
  "Select Date": "Select Date",
  "Select Transaction Date": "Select Transaction Date",
  "Reset": "Reset",
  "Download Report": "Download Report",
  "Please fill in the remark": "Please fill in the remark",
  "Transaction Date": "Transaction Date",
  "Machine Type": "Machine Type",
  "Machine Capacity": "Machine Capacity",
  "Total Amount": "Total Amount",
  "Payment Amount": "Payment Amount",
  "Discount From": "Discount From",
  "Discount Amount": "Discount Amount",
  "Action": "Action",
  "Remark": "Remark",
  "Refund Date": "Refund Date",
  "Refund": "Refund",
  "Purchase Date": "Purchase Date",
  "e-Token Purchased (Tokens)": "e-Token Purchased (Tokens)",
  "Bought e-Token using": "Bought e-Token using",
  "Transaction ID": "Transaction ID",
  "Method": "Method",
  "Requery": "Requery",
  "Reward Date": "Reward Date",
  "Reward Type": "Reward Type",
  "Notification Method": "Notification Method",
  "Email Preview": "Email Preview",
  "Message for User": "Message for User",
  "SMS will send to user, please enter the message less than 130 characters": "SMS will send to user, please enter the message less than 130 characters",
  "Enter the message to be sent to the user": "Enter the message to be sent to the user",
  "Email Address to show on Email Template": "Email Address to show on Email Template",
  "Input Company Email Address": "Input Company Email Address",
  "Company Name to show on Email Template": "Company Name to show on Email Template",
  "Input Company Name": "Input Company Name",
  "Company Phone No. to show on Email Template": "Company Phone No. to show on Email Template",
  "Input Company Phone No.": "Input Company Phone No.",
  "Voucher ID": "Voucher ID",
  "Washer Stamp": "Washer Stamp",
  "Dryer Stamp": "Dryer Stamp",
  "e-Token Amount": "e-Token Amount",
  "Transfer Date": "Transfer Date",
  "Transfer Amount (Token)": "Transfer Amount (Token)",
  "Number (Transfer From)": "Number (Transfer From)",
  "Name (Transfer From)": "Name (Transfer From)",
  "Member ID (Transfer From)": "Member ID (Transfer From)",
  "Number (Transfer To)": "Number (Transfer To)",
  "Name (Transfer To)": "Name (Transfer To)",
  "Member ID (Transfer To)": "Member ID (Transfer To)",
  "Grant Date": "Grant Date",
  "Claim Date": "Claim Date",
  "Member Details Report": "Member Details Report",
  "Transaction Status": "Transaction Status",
  "Token Reload": "Token Reload",
  "Token Transfer": "Token Transfer",
  "Voucher History": "Voucher History",
  "TOKEN": "TOKEN",
  "Message Sent": "Message Sent",
  "Date Sent": "Date Sent",
  "Remaining SMS Credit": "Remaining SMS Credit",
  "Store": "Store",
  "Total Registered Users": "Total Registered Users",
  "User registered but no transaction record": "User registered but no transaction record",
  "Registered": "Registered",
  "User spending is less than": "User spending is less than",
  "Active": "Active",
  "User spending is from": "User spending is from",
  "until": "until",
  "Tier 1": "Tier 1",
  "User spending is": "User spending is",
  "and above": "and above",
  "Tier 2": "Tier 2",
  "Average spending in each transaction": "Average spending in each transaction",
  "Average Spending": "Average Spending",
  "Total number of transactions": "Total number of transactions",
  "Total Transactions": "Total Transactions",
  "Number of vouchers used in all the transactions": "Number of vouchers used in all the transactions",
  "Voucher Claimed": "Voucher Claimed",
  "Total number of washer machine transactions": "Total number of washer machine transactions",
  "Washer Usage": "Washer Usage",
  "Total number of dryer machine transactions": "Total number of dryer machine transactions",
  "Dryer Usage": "Dryer Usage",
  "User Name": "User Name",
  "e-Token Spent": "e-Token Spent",
  "e-Token Detailed Report": "e-Token Detailed Report",
  "e-Token Purchase History": "e-Token Purchase History",
  "Select Purchase Date": "Select Purchase Date",
  "Outlet Name": "Outlet Name",
  "Total number of e-token used in all the transactions": "Total number of e-token used in all the transactions",
  "Total e-Token Collected": "Total e-Token Collected",
  "Total number of e-token used in washer machine transactions": "Total number of e-token used in washer machine transactions",
  "Washer e-Token Collected": "Washer e-Token Collected",
  "Total number of e-token used in dryer machine transactions": "Total number of e-token used in dryer machine transactions",
  "Dryer e-Token Collected": "Dryer e-Token Collected",
  "Vending Machine e-Token Collected": "Vending Machine e-Token Collected",
  "Purchase History": "Purchase History",
  "All": "All",
  "Most Bought e-Token Package": "Most Bought e-Token Package",
  "for": "for",
  "Tokens": "Tokens",
  "Total Earned from users buying e-Tokens": "Total Earned from users buying e-Tokens",
  "Total e-Tokens Bought from you": "Total e-Tokens Bought from you",
  "Join Date": "Join Date",
  "Channel": "Channel",
  "Tier": "Tier",
  "Referrer": "Referrer",
  "Referrals": "Referrals",
  "Number of transactions for last 7 days": "Number of transactions for last 7 days",
  "Number of Usage (in week)": "Number of Usage (in week)",
  "Number of transactions for last 1 month": "Number of transactions for last 1 month",
  "Number of Usage (in month)": "Number of Usage (in month)",
  "Total amount spent in all the transactions": "Total amount spent in all the transactions",
  "Total Spent": "Total Spent",
  "Last Transaction Date": "Last Transaction Date",
  "Number of vouchers collected": "Number of vouchers collected",
  "Voucher Collected": "Voucher Collected",
  "Number of vouchers used": "Number of vouchers used",
  "Voucher Spent": "Voucher Spent",
  "Washer Used": "Washer Used",
  "Dryer Used": "Dryer Used",
  "Total number of e-Token spent in all the transactions": "Total number of e-Token spent in all the transactions",
  "Total number of stamps collected": "Total number of stamps collected",
  "Total Stamps": "Total Stamps",
  "Select Join Date": "Select Join Date",
  "Select Grant Date": "Select Grant Date",
  "Amount": "Amount",
  "The image size is over 2MB": "The image size is over 2MB",
  "Duplicate language selected": "Duplicate language selected",
  "Are you sure you want to add FAQ?": "Are you sure you want to add FAQ?",
  "FAQ added successfully": "FAQ added successfully",
  "FAQ Group added successfully": "FAQ Group added successfully",
  "Please provide the faq with the default language": "Please provide the faq with the default language",
  "Add FAQ": "Add FAQ",
  "Default Language": "Default Language",
  "Select Default Language": "Select Default Language",
  "Image (Optional)": "Image (Optional)",
  "max": "max",
  "Question": "Question",
  "Select Language": "Select Language",
  "Remove": "Remove",
  "Answer": "Answer",
  "Add Translation": "Add Translation",
  "Are you sure you want to add FAQ Group?": "Are you sure you want to add FAQ Group?",
  "Please provide the faq group with the default language": "Please provide the faq group with the default language",
  "Add FAQ Group": "Add FAQ Group",
  "Title": "Title",
  "Title Language": "Title Language",
  "Please fill in the title": "Please fill in the title",
  "Please fill in the description": "Please fill in the description",
  "Please fill in the short description": "Please fill in the short description",
  "Please select the end date for your news": "Please select the end date for your news",
  "Please provide the news with the default language": "Please provide the news with the default language",
  "Please provide the banner image": "Please provide the banner image",
  "Please provide the news image": "Please provide the news image",
  "Are you sure you want to add news?": "Are you sure you want to add news?",
  "News added successfully": "News added successfully",
  "Please fill in all the required fields before submit": "Please fill in all the required fields before submit",
  "Add News": "Add News",
  "Banner Image": "Banner Image",
  "News Image": "News Image",
  "Banner": "Banner",
  "aspect ratio": "aspect ratio",
  "Image": "Image",
  "Display in": "Display in",
  "Inbox Page": "Inbox Page",
  "Promotion Banner": "Promotion Banner",
  "Select Period: (optional)": "Select Period: (optional)",
  "Short Description": "Short Description",
  "Your theme has been updated successfully": "Your theme has been updated successfully",
  "Default Theme": "Default Theme",
  "Change Logo": "Change Logo",
  "REMOVE LOGO": "REMOVE LOGO",
  "Sms credit used up": "Sms credit used up",
  "Please top up your sms credit": "Please top up your sms credit",
  "Please": "Please",
  "Again": "Again",
  "Welcome": "Welcome",
  "Ranking": "Ranking",
  "Select Year": "Select Year",
  "Missing Field": "Missing Field",
  "Please select can be used for which type of transaction": "Please select can be used for which type of transaction",
  "Please fill in the start date and end date": "Please fill in the start date and end date",
  "Discount amount should be more than 0": "Discount amount should be more than 0",
  "Redeem per user should be more than 0": "Redeem per user should be more than 0",
  "Redeem per day should be more than 0": "Redeem per day should be more than 0",
  "Your discount code have edited successfully": "Your discount code have edited successfully",
  "Your discount code have added successfully": "Your discount code have added successfully",
  "Delete this entry?": "Delete this entry?",
  "Your discount code have deleted successfully": "Your discount code have deleted successfully",
  "Created Date": "Created Date",
  "Discount code": "Discount code",
  "General Discount Code": "General Discount Code",
  "Unique Discount Code": "Unique Discount Code",
  "Start Date": "Start Date",
  "End Date": "End Date",
  "Redeem Per User": "Redeem Per User",
  "Redeem Per Day": "Redeem Per Day",
  "Add Discount Code": "Add Discount Code",
  "Generate Discount Code": "Generate Discount Code",
  "No Discount Code": "No Discount Code",
  "Edit Discount Code": "Edit Discount Code",
  "Select Period": "Select Period",
  "Redeem per user": "Redeem per user",
  "How many times the discount code can be used for each user": "How many times the discount code can be used for each user",
  "Redeem per day": "Redeem per day",
  "How many times the discount code can be used in one day": "How many times the discount code can be used in one day",
  "If ticked, the discount code can apply to washer machine transaction": "If ticked, the discount code can apply to washer machine transaction",
  "If ticked, the discount code can apply to dryer machine transaction": "If ticked, the discount code can apply to dryer machine transaction",
  "If ticked, the discount code can apply to Drop n Go transaction": "If ticked, the discount code can apply to Drop n Go transaction",
  "If ticked, the discount code can apply to vending machine transaction": "If ticked, the discount code can apply to vending machine transaction",
  "If ticked, the discount code can apply to detergent vending machine transaction": "If ticked, the discount code can apply to detergent vending machine transaction",
  "If ticked, the discount code can apply to car wash transaction": "If ticked, the discount code can apply to car wash transaction",
  "The user enter the discount code": "The user enter the discount code",
  "in the payment page will get": "in the payment page will get",
  "discount": "discount",
  "The discount code only can be used start from {{ start_date }} until {{ end_date }}": "The discount code only can be used start from {{ start_date }} until {{ end_date }}",
  "Every user only can use the discount code {{ redeem_per_user }} times": "Every user only can use the discount code {{ redeem_per_user }} times",
  "Every user only can use {{ redeem_per_user }} discount code from this batch of code": "Every user only can use {{ redeem_per_user }} discount code from this batch of code",
  "Only {{ redeem_per_day }} transactions can use the discount code in one day_one": "Only {{ redeem_per_day }} transaction can use the discount code in one day",
  "Only {{ redeem_per_day }} transactions can use the discount code in one day_other": "Only {{ redeem_per_day }} transactions can use the discount code in one day",
  "The discount code only can be used for washer machine": "The discount code only can be used for washer machine",
  "The discount code only can be used for dryer machine": "The discount code only can be used for dryer machine",
  "The discount code only can be used for Drop n Go transaction": "The discount code only can be used for Drop n Go transaction",
  "The discount code only can be used for vending machine transaction": "The discount code only can be used for vending machine transaction",
  "The discount code only can be used for detergent vending machine transaction": "The discount code only can be used for detergent vending machine transaction",
  "The discount code only can be used for car wash transaction": "The discount code only can be used for car wash transaction",
  "The discount code can be used for washer machine or Drop n Go transaction": "The discount code can be used for washer machine or Drop n Go transaction",
  "The discount code can be used for dryer machine or Drop n Go transaction": "The discount code can be used for dryer machine or Drop n Go transaction",
  "The discount code can be used for washer machine, dryer machine or Drop n Go transaction": "The discount code can be used for washer machine, dryer machine or Drop n Go transaction",
  "The discount code can be used for washer or dryer machine": "The discount code can be used for washer or dryer machine",
  "The discount code can be used for washer machine or vending machine transaction": "The discount code can be used for washer machine or vending machine transaction",
  "The discount code can be used for washer machine or detergent vending machine transaction": "The discount code can be used for washer machine or detergent vending machine transaction",
  "The discount code can be used for washer machine or car wash transaction": "The discount code can be used for washer machine or car wash transaction",
  "The discount code can be used for dryer machine or vending machine transaction": "The discount code can be used for dryer machine or vending machine transaction",
  "The discount code can be used for dryer machine or detergent vending machine transaction": "The discount code can be used for dryer machine or detergent vending machine transaction",
  "The discount code can be used for dryer machine or car wash transaction": "The discount code can be used for dryer machine or car wash transaction",
  "The discount code can be used for vending machine or Drop n Go transaction": "The discount code can be used for vending machine or Drop n Go transaction",
  "The discount code can be used for detergent vending machine or Drop n Go transaction": "The discount code can be used for detergent vending machine or Drop n Go transaction",
  "The discount code can be used for car wash or Drop n Go transaction": "The discount code can be used for car wash or Drop n Go transaction",
  "The discount code can be used for vending machine or detergent vending machine transaction": "The discount code can be used for vending machine or detergent vending machine transaction",
  "The discount code can be used for vending machine or car wash transaction": "The discount code can be used for vending machine or car wash transaction",
  "The discount code can be used for detergent vending machine or car wash transaction": "The discount code can be used for detergent vending machine or car wash transaction",
  "The discount code can be used for washer machine, dryer machine or vending machine transaction": "The discount code can be used for washer machine, dryer machine or vending machine transaction",
  "The discount code can be used for washer machine, dryer machine or detergent vending machine transaction": "The discount code can be used for washer machine, dryer machine or detergent vending machine transaction",
  "The discount code can be used for washer machine, dryer machine or car wash transaction": "The discount code can be used for washer machine, dryer machine or car wash transaction",
  "The discount code can be used for washer machine, vending machine or Drop n Go transaction": "The discount code can be used for washer machine, vending machine or Drop n Go transaction",
  "The discount code can be used for washer machine, detergent vending machine or Drop n Go transaction": "The discount code can be used for washer machine, detergent vending machine or Drop n Go transaction",
  "The discount code can be used for washer machine, car wash or Drop n Go transaction": "The discount code can be used for washer machine, car wash or Drop n Go transaction",
  "The discount code can be used for washer machine, vending machine or detergent vending machine transaction": "The discount code can be used for washer machine, vending machine or detergent vending machine transaction",
  "The discount code can be used for washer machine, vending machine or car wash transaction": "The discount code can be used for washer machine, vending machine or car wash transaction",
  "The discount code can be used for washer machine, detergent vending machine or car wash transaction": "The discount code can be used for washer machine, detergent vending machine or car wash transaction",
  "The discount code can be used for dryer machine, vending machine or Drop n Go transaction": "The discount code can be used for dryer machine, vending machine or Drop n Go transaction",
  "The discount code can be used for dryer machine, detergent vending machine or Drop n Go transaction": "The discount code can be used for dryer machine, detergent vending machine or Drop n Go transaction",
  "The discount code can be used for dryer machine, car wash or Drop n Go transaction": "The discount code can be used for dryer machine, car wash or Drop n Go transaction",
  "The discount code can be used for dryer machine, vending machine or detergent vending machine transaction": "The discount code can be used for dryer machine, vending machine or detergent vending machine transaction",
  "The discount code can be used for dryer machine, vending machine or car wash transaction": "The discount code can be used for dryer machine, vending machine or car wash transaction",
  "The discount code can be used for dryer machine, detergent vending machine or car wash transaction": "The discount code can be used for dryer machine, detergent vending machine or car wash transaction",
  "The discount code can be used for vending machine, detergent vending machine or Drop n Go transaction": "The discount code can be used for vending machine, detergent vending machine or Drop n Go transaction",
  "The discount code can be used for vending machine, car wash or Drop n Go transaction": "The discount code can be used for vending machine, car wash or Drop n Go transaction",
  "The discount code can be used for detergent vending machine, car wash or Drop n Go transaction": "The discount code can be used for detergent vending machine, car wash or Drop n Go transaction",
  "The discount code can be used for vending machine, detergent vending machine or car wash transaction": "The discount code can be used for vending machine, detergent vending machine or car wash transaction",
  "The discount code can be used for washer machine, dryer machine, vending machine or Drop n Go transaction": "The discount code can be used for washer machine, dryer machine, vending machine or Drop n Go transaction",
  "The discount code can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction": "The discount code can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction",
  "The discount code can be used for washer machine, dryer machine, vending machine or car wash transaction": "The discount code can be used for washer machine, dryer machine, vending machine or car wash transaction",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine or car wash transaction": "The discount code can be used for washer machine, dryer machine, detergent vending machine or car wash transaction",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or Drop n Go transaction": "The discount code can be used for washer machine, vending machine, detergent vending machine or Drop n Go transaction",
  "The discount code can be used for washer machine, vending machine, car wash or Drop n Go transaction": "The discount code can be used for washer machine, vending machine, car wash or Drop n Go transaction",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or car wash transaction": "The discount code can be used for washer machine, vending machine, detergent vending machine or car wash transaction",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "The discount code can be used for dryer machine, vending machine, detergent vending machine or Drop n Go transaction",
  "The discount code can be used for dryer machine, vending machine, car wash or Drop n Go transaction": "The discount code can be used for dryer machine, vending machine, car wash or Drop n Go transaction",
  "The discount code can be used for dryer machine, detergent vending machine, car wash machine or Drop n Go transaction": "The discount code can be used for dryer machine, detergent vending machine, car wash machine or Drop n Go transaction",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or car wash transaction": "The discount code can be used for dryer machine, vending machine, detergent vending machine or car wash transaction",
  "The discount code can be used for vending machine, detergent vending machine, car wash or Drop n Go transaction": "The discount code can be used for vending machine, detergent vending machine, car wash or Drop n Go transaction",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or Drop n Go transaction",
  "The discount code can be used for washer machine, dryer machine, vending machine, car wash or Drop n Go transaction": "The discount code can be used for washer machine, dryer machine, vending machine, car wash or Drop n Go transaction",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine, car wash or Drop n Go transaction": "The discount code can be used for washer machine, dryer machine, detergent vending machine, car wash or Drop n Go transaction",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or car wash transaction": "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or car wash transaction",
  "The discount code can be used for washer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "The discount code can be used for washer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "The discount code can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction",
  "The discount code only can be used after user spending {{ currency }} {{ pay_and_use_amount }}": "The discount code only can be used after user spending {{ currency }} {{ pay_and_use_amount }}",
  "Are you sure you want to edit FAQ?": "Are you sure you want to edit FAQ?",
  "FAQ updated successfully": "FAQ updated successfully",
  "Edit FAQ": "Edit FAQ",
  "Are you sure you want to edit FAQ Group?": "Are you sure you want to edit FAQ Group?",
  "FAQ Group updated successfully": "FAQ Group updated successfully",
  "Edit FAQ Group": "Edit FAQ Group",
  "Are you sure you want to edit news?": "Are you sure you want to edit news?",
  "News edit successfully": "News edit successfully",
  "Edit News": "Edit News",
  "All the FAQ under this group will be deleted. Are you sure you want to delete FAQ Group?": "All the FAQ under this group will be deleted. Are you sure you want to delete FAQ Group?",
  "FAQ Group deleted successfully": "FAQ Group deleted successfully",
  "FAQ List": "FAQ List",
  "NO FAQ GROUP": "NO FAQ GROUP",
  "FAQ Group": "FAQ Group",
  "Are you sure you want to delete FAQ?": "Are you sure you want to delete FAQ?",
  "FAQ deleted successfully": "FAQ deleted successfully",
  "NO FAQs": "NO FAQs",
  "FAQ": "FAQ",
  "Easy": "Easy",
  "Fast Laundromate": "Fast Laundromate",
  "Smart Laundry Management System": "Smart Laundry Management System",
  "Enter your username and password to login": "Enter your username and password to login",
  "Username": "Username",
  "Are you sure you want to delete news?": "Are you sure you want to delete news?",
  "News deleted successfully": "News deleted successfully",
  "NO NEWS": "NO NEWS",
  "The referral setting has been updated successfully!": "The referral setting has been updated successfully!",
  "Number of Stamp": "Number of Stamp",
  "Number of Washer Stamp": "Number of Washer Stamp",
  "Number of Dryer Stamp": "Number of Dryer Stamp",
  "Enable Referral Feature?": "Enable Referral Feature?",
  "Are you sure you want to delete the tier setting?": "Are you sure you want to delete the tier setting?",
  "Minimum referee transaction amount for referrer to get referral rewards": "Minimum referee transaction amount for referrer to get referral rewards",
  "Maximum number of reward within this tier": "Maximum number of reward within this tier",
  "Maximum number of reward can get from same user": "Maximum number of reward can get from same user",
  "Point Grant Type": "Point Grant Type",
  "Select Point Grant Type": "Select Point Grant Type",
  "Token Grant Type": "Token Grant Type",
  "Select Token Grant Type": "Select Token Grant Type",
  "Add Tier": "Add Tier",
  "Stamp": "Stamp",
  "If ticked, the system will give stamp to user": "If ticked, the system will give stamp to user",
  "If ticked, the system will give e-Token to user": "If ticked, the system will give e-Token to user",
  "If ticked, the system will give voucher to user": "If ticked, the system will give voucher to user",
  "Number of E-Token": "Number of E-Token",
  "Reward Giveaway": "Reward Giveaway",
  "Which type of reward you want to give to customer?": "Which type of reward you want to give to customer?",
  "For machine uses (required)": "For machine uses (required)",
  "leave blank if no expiry date": "leave blank if no expiry date",
  "Remarks": "Remarks",
  "Reward": "Reward",
  "Please fill in all the required field. (Title, description, and amount must be more than 0)": "Please fill in all the required field. (Title, description, and amount must be more than 0)",
  "Checkbox required": "Checkbox required",
  "Must select voucher can be used for washer, dryer or package": "Must select voucher can be used for washer, dryer or package",
  "How many e-token?": "How many e-token?",
  "Number of e-Token": "Number of e-Token",
  "Token value must be more than 0": "Token value must be more than 0",
  "STAMP": "STAMP",
  "Please fill in at least one of the required field": "Please fill in at least one of the required field",
  "The value must be more than 0": "The value must be more than 0",
  "How many times rewarded to user": "How many times rewarded to user",
  "Rewarded Times": "Rewarded Times",
  "How many times rewarded voucher to user": "How many times rewarded voucher to user",
  "Voucher Rewarded (times)": "Voucher Rewarded (times)",
  "How many times rewarded stamp to user": "How many times rewarded stamp to user",
  "Stamps Rewarded (times)": "Stamps Rewarded (times)",
  "Total number of washer stamps rewarded to user": "Total number of washer stamps rewarded to user",
  "Washer Stamps Granted (stamp)": "Washer Stamps Granted (stamp)",
  "Total number of dryer stamps rewarded to user": "Total number of dryer stamps rewarded to user",
  "Dryer Stamps Granted (stamp)": "Dryer Stamps Granted (stamp)",
  "How many times rewarded e-Token to user": "How many times rewarded e-Token to user",
  "e-Token Rewarded (times)": "e-Token Rewarded (times)",
  "Total number of e-Token rewarded to user": "Total number of e-Token rewarded to user",
  "Total e-Token Granted (token)": "Total e-Token Granted (token)",
  "Point Rewarded (times)": "Point Rewarded (times)",
  "How many times rewarded point to user": "How many times rewarded point to user",
  "Total Point Granted (point)": "Total Point Granted (point)",
  "Total number of point rewarded to user": "Total number of point rewarded to user",
  "Point Amount": "Point Amount",
  "Reward History": "Reward History",
  "Are you sure you want to change how the stamping mechanics works?": "Are you sure you want to change how the stamping mechanics works?",
  "The stamping mechanics setting has updated successfully!": "The stamping mechanics setting has updated successfully!",
  "The voucher setting has been updated successfully!": "The voucher setting has been updated successfully!",
  "Mechanics Settings": "Mechanics Settings",
  "Minimum transaction amount for getting stamp": "Minimum transaction amount for getting stamp",
  "Select User Stamping Mechanic": "Select User Stamping Mechanic",
  "Separated Stamping": "Separated Stamping",
  "Combined Stamping": "Combined Stamping",
  "Stamp for?": "Stamp for?",
  "Both": "Both",
  "Washer Only": "Washer Only",
  "Dryer Only": "Dryer Only",
  "Separated Stamping = Different washer and dryer stamp collection. (example: Using Washer will gain 1 washer's stamp, and Dryer will gain 1 dryer stamp)": "Separated Stamping = Different washer and dryer stamp collection. (example: Using Washer will gain 1 washer's stamp, and Dryer will gain 1 dryer stamp)",
  "Combined Stamping = Washer and dryer has the same collection. (example: Using Washer or Dryer will gain 1 stamp)": "Combined Stamping = Washer and dryer has the same collection. (example: Using Washer or Dryer will gain 1 stamp)",
  "Stamp for": "Stamp for",
  "User will be able to collect both washer stamp and dryer stamp": "User will be able to collect both washer stamp and dryer stamp",
  "User will only able to collect Washer stamp": "User will only able to collect Washer stamp",
  "User will only able to collect Dryer stamp": "User will only able to collect Dryer stamp",
  "Registration": "Registration",
  "Birthday": "Birthday",
  "Please choose at least one payment method": "Please choose at least one payment method",
  "Please choose at least one member or non-member payment": "Please choose at least one member or non-member payment",
  "Are you sure you want to change the payment setting?": "Are you sure you want to change the payment setting?",
  "The payment setting has updated successfully!": "The payment setting has updated successfully!",
  "Invalid input": "Invalid input",
  "The price and token must be more than 0": "The price and token must be more than 0",
  "Maximum number of purchase must be more than 0": "Maximum number of purchase must be more than 0",
  "Point amount must be more than 1": "Point amount must be more than 1",
  "Added a new Token Bundle Package": "Added a new Token Bundle Package",
  "Bundle deleted successfully!": "Bundle deleted successfully!",
  "Reload voucher setting have edited successfully!": "Reload voucher setting have edited successfully!",
  "Added on": "Added on",
  "remove": "remove",
  "edit": "edit",
  "NO PACKAGES ON SALES": "NO PACKAGES ON SALES",
  "Point Settings": "Point Settings",
  "Enable Loyalty Point": "Enable Loyalty Point",
  "Point Name": "Point Name",
  "Number Of Point Equals To": "Number Of Point Equals To",
  "If ticked, the point will have expired date": "If ticked, the point will have expired date",
  "Point Lifespan": "Point Lifespan",
  "months": "months",
  "Minimum Transaction Amount To Get Point": "Minimum Transaction Amount To Get Point",
  "Point Grant Amount": "Point Grant Amount",
  "Point Grant Period": "Point Grant Period",
  "Optional": "Optional",
  "Drop n Go Eligibility": "Drop n Go Eligibility",
  "If ticked, Drop n Go transaction will get the point": "If ticked, Drop n Go transaction will get the point",
  "Washer Eligibility": "Washer Eligibility",
  "If ticked, washer transaction will get the point": "If ticked, washer transaction will get the point",
  "Dryer Eligibility": "Dryer Eligibility",
  "If ticked, dryer transaction will get the point": "If ticked, dryer transaction will get the point",
  "Point settings updated successfully!": "Point settings updated successfully!",
  "Point Eligibility": "Point Eligibility",
  "If ticked, the system will give point to user when user reload token successfully": "If ticked, the system will give point to user when user reload token successfully",
  "{{ point_amount }} point will be given after user reload token successfully": "{{ point_amount }} point will be given after user reload token successfully",
  "Payment Settings": "Payment Settings",
  "Select Payment Method": "Select Payment Method",
  "Enable E-Payment?": "Enable E-Payment?",
  "Enable Token Currency?": "Enable Token Currency?",
  "Enable Cash Payment?": "Enable Cash Payment?",
  "Enable QR Payment?": "Enable QR Payment?",
  "Member and Non-Member Settings": "Member and Non-Member Settings",
  "Enable Member Payment?": "Enable Member Payment?",
  "Enable Non-Member Payment?": "Enable Non-Member Payment?",
  "Promotion Settings": "Promotion Settings",
  "Enable Non Member Promotion?": "Enable Non Member Promotion?",
  "Enable Notification When Cycle Done?": "Enable Notification When Cycle Done?",
  "SMS charges": "SMS charges",
  "SMS Settings": "SMS Settings",
  "Enable Free Sms For Members": "Enable Free Sms For Members",
  "If enable notification, user can choose either receive email or sms when complete washing or drying": "If enable notification, user can choose either receive email or sms when complete washing or drying",
  "If user choose sms, non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "If user choose sms, non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms",
  "If user choose sms, member and non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "If user choose sms, member and non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms",
  "Add Package": "Add Package",
  "Edit e-Token Package": "Edit e-Token Package",
  "Add e-Token Package": "Add e-Token Package",
  "Please only input numberic value to prevent any bugs.": "Please only input numberic value to prevent any bugs.",
  "Price": "Price",
  "If ticked, the system will limit the number of purchase": "If ticked, the system will limit the number of purchase",
  "Limit Number of Purchase": "Limit Number of Purchase",
  "Number of maximum purchase": "Number of maximum purchase",
  "Reload Voucher": "Reload Voucher",
  "If ticked, the system will give voucher to user when user reload token successfully": "If ticked, the system will give voucher to user when user reload token successfully",
  "If ticked, the system will give voucher repeatly": "If ticked, the system will give voucher repeatly",
  "Recurring": "Recurring",
  "Total number of voucher given to user": "Total number of voucher given to user",
  "Period for giving next voucher": "Period for giving next voucher",
  "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens_one": "Token package {{ currency }}{{ price }} for {{ numberOfToken }} token",
  "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens_other": "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens",
  "Each user only can purchase {{ max_purchase }} times for the token package": "Each user only can purchase {{ max_purchase }} times for the token package",
  "Voucher will be given after user reload token successfully": "Voucher will be given after user reload token successfully",
  "Voucher will not given after user reload tokens successfully": "Voucher will not given after user reload tokens successfully",
  "The voucher will be expired after {{ voucher_duration }} days_one": "The voucher will be expired after {{ voucher_duration }} day",
  "The voucher will be expired after {{ voucher_duration }} days_other": "The voucher will be expired after {{ voucher_duration }} days",
  "The voucher will not expired": "The voucher will not expired",
  "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount_one": "Total {{ recurring_number }} voucher will be given to user and each voucher will discount",
  "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount_other": "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount",
  "Edit Package": "Edit Package",
  "Age": "Age",
  "Total number of vouchers collected": "Total number of vouchers collected",
  "Vouchers Acquired": "Vouchers Acquired",
  "Total amount spent in washer machine transactions": "Total amount spent in washer machine transactions",
  "Total Washer Payment": "Total Washer Payment",
  "Total amount spent in dryer machine transactions": "Total amount spent in dryer machine transactions",
  "Total Dryer Payment": "Total Dryer Payment",
  "Total amount spent in all transactions": "Total amount spent in all transactions",
  "Total Payment": "Total Payment",
  "report": "report",
  "Total amount spent for buying e-Token": "Total amount spent for buying e-Token",
  "Total number of e-Token purchased": "Total number of e-Token purchased",
  "Total e-Token Purchased (Tokens)": "Total e-Token Purchased (Tokens)",
  "Total number of e-Token used in washer machine transactions": "Total number of e-Token used in washer machine transactions",
  "Washer Payment (Tokens)": "Washer Payment (Tokens)",
  "Total number of e-Token used in dryer machine transactions": "Total number of e-Token used in dryer machine transactions",
  "Dryer Payment (Tokens)": "Dryer Payment (Tokens)",
  "Total number of e-Token used in all the transactions": "Total number of e-Token used in all the transactions",
  "Total Payment (Tokens)": "Total Payment (Tokens)",
  "Number of washer stamp collected currently": "Number of washer stamp collected currently",
  "Number of dryer stamp collected currently": "Number of dryer stamp collected currently",
  "User Phone Number / Member ID / Email": "User Phone Number / Member ID / Email",
  "Example: 0123456789,A123456": "Example: 0123456789,A123456",
  "SEARCH": "SEARCH",
  "Total Users Registered": "Total Users Registered",
  "Total Active Outlets": "Total Active Outlets",
  "Total Vouchers Given": "Total Vouchers Given",
  "Total Transaction Counts": "Total Transaction Counts",
  "Total User Stamps Collected": "Total User Stamps Collected",
  "Distributor Login": "Distributor Login",
  "Client Login": "Client Login",
  "Kiosk Login": "Kiosk Login",
  "Promotion": "Promotion",
  "Please select operator": "Please select operator",
  "Please select distributor": "Please select distributor",
  "Select Operator": "Select Operator",
  "Select Distributor": "Select Distributor",
  "User can login or skip to payment without login to make the payment": "User can login or skip to payment without login to make the payment",
  "User have to login only can make the payment": "User have to login only can make the payment",
  "User only can skip to payment without login to make the payment": "User only can skip to payment without login to make the payment",
  "Only CSV file is accepted": "Only CSV file is accepted",
  "The user and the balance have updated": "The user and the balance have updated",
  "Register Time": "Register Time",
  "Upload User CSV file": "Upload User CSV file",
  "Sample CSV file": "Sample CSV file",
  "Please follow the CSV file format": "Please follow the CSV file format",
  "User CSV file": "User CSV file",
  "Only CSV file (comma delimited) is support now": "Only CSV file (comma delimited) is support now",
  "Confirm uploaded data": "Confirm uploaded data",
  "Operator": "Operator",
  "Distributor": "Distributor",
  "Refund By": "Refund By",
  "Reward By": "Reward By",
  "Number Of Voucher Code": "Number Of Voucher Code",
  "Number Of Discount Code": "Number Of Discount Code",
  "New User Only": "New User Only",
  "Minimum Transaction Amount To Redeem": "Minimum Transaction Amount To Redeem",
  "Download": "Download",
  "Generate Voucher Code": "Generate Voucher Code",
  "Your voucher code is generating": "Your voucher code is generating",
  "Your discount code is generating": "Your discount code is generating",
  "Voucher Code Settings": "Voucher Code Settings",
  "If ticked, the voucher code only can redeem in register page": "If ticked, the voucher code only can redeem in register page",
  "If ticked, the user only can use the voucher after make a transaction": "If ticked, the user only can use the voucher after make a transaction",
  "If ticked, the user only can use the discount code after make a transaction": "If ticked, the user only can use the discount code after make a transaction",
  "Expired Date Of Voucher Code": "Expired Date Of Voucher Code",
  "Minimum Transaction Amount To Use Voucher": "Minimum Transaction Amount To Use Voucher",
  "Minimum Transaction Amount To Use Code": "Minimum Transaction Amount To Use Code",
  "Max redemption per user in this batch voucher code": "Max redemption per user in this batch voucher code",
  "Max redemption per user in this batch discount code": "Max redemption per user in this batch discount code",
  "Add Voucher": "Add Voucher",
  "Completed": "Completed",
  "Voucher Code Report": "Voucher Code Report",
  "Floating Token Report": "Floating Token Report",
  "Floating Point Report": "Floating Point Report",
  "E-Payment Report": "E-Payment Report",
  "Referral Reward History Report": "Referral Reward History Report",
  "Redemption Date": "Redemption Date",
  "Redemption Code": "Redemption Code",
  "Select Redemption Date": "Select Redemption Date",
  "Select Voucher Type": "Select Voucher Type",
  "Giveaway": "Giveaway",
  "Select Name": "Select Name",
  "Amount must be more than 1": "Amount must be more than 1",
  "Payment method setting have updated successfully!": "Payment method setting have updated successfully!",
  "Edit Payment Method": "Edit Payment Method",
  "Minimum payment amount to include all the payment methods": "Minimum payment amount to include all the payment methods",
  "Exclude Payment Method in Revenue Monster": "Exclude Payment Method in Revenue Monster",
  "Welcome to": "Welcome to",
  "Instruction": "Instruction",
  "Please select the machine": "Please select the machine",
  "Login your account": "Login your account",
  "Select the setting and make the payment": "Select the setting and make the payment",
  "Phone Number / Email": "Phone Number / Email",
  "Reload & Transfer In": "Reload & Transfer In",
  "Usage & Transfer Out": "Usage & Transfer Out",
  "Usage": "Usage",
  "Remaining": "Remaining",
  "Gain": "Gain",
  "Type": "Type",
  "Order Date": "Order Date",
  "Pack Number": "Pack Number",
  "Pack Details": "Pack Details",
  "Size": "Size",
  "Mode": "Mode",
  "Machine Payment": "Machine Payment",
  "DNG History": "DNG History",
  "Token History": "Token History",
  "Stamp History": "Stamp History",
  "Staff Login": "Staff Login",
  "Drop And Go Portal": "Drop And Go Portal",
  "Available Task": "Available Task",
  "Completed Task": "Completed Task",
  "Task ID": "Task ID",
  "Task": "Task",
  "Start Task": "Start Task",
  "Select Machine": "Select Machine",
  "Start Machine": "Start Machine",
  "Reward To": "Reward To",
  "Reward From": "Reward From",
  "Transaction Account": "Transaction Account",
  "Point": "Point",
  "POINT": "POINT",
  "Number of Point": "Number of Point",
  "Point History": "Point History",
  "Customer Name": "Customer Name",
  "Number of Washer Transactions": "Number of Washer Transactions",
  "Number of Dryer Transactions": "Number of Dryer Transactions",
  "Vouchers Redeemed": "Vouchers Redeemed",
  "Discount Code Redemption": "Discount Code Redemption",
  "Total Spend": "Total Spend",
  "Select Outlet(s)": "Select Outlet(s)",
  "User Usage Report": "User Usage Report",
  // cleanpro plus en
  "Wash": "Wash",
  "Dry": "Dry",
  "Fold": "Fold",
  "Scan QR": "Scan QR",
  "Capacity": "Capacity",
  "Duration": "Duration",
  "Custom duration": "Custom duration",
  "Choose duration": "Choose duration",
  "Select the correct amount on the machine after payment.": "Select the correct amount on the machine after payment.",
  "Offers": "Offers",
  "Voucher Offers": "Voucher Offers",
  "Discount Code Offers": "Discount Code Offers",
  "An easier way to pay": "An easier way to pay",
  "Create account": "Create account",
  "Login": "Login",
  "By signing up, you agree to": "By signing up, you agree to",
  "Amount to Pay": "Amount to Pay",
  "1 voucher selected": "1 voucher selected",
  "No voucher selected": "No voucher selected",
  "Credits": "Credits",
  "credits": "credits",
  "credit": "credit",
  "Credit balance": "Credit balance",
  "Please ensure that the machine door is shut & your laundry is inside.": "Please ensure that the machine door is shut & your laundry is inside.",
  "Insufficient balance": "Insufficient balance",
  "Topup now": "Topup now",
  "Copyright © {{ year }} Cleanpro Laundry Holdings Sdn Bhd (821842-P) All rights reserved.": "Copyright © {{ year }} Cleanpro Laundry Holdings Sdn Bhd (821842-P) All rights reserved.",
  "Good Evening!": "Good Evening!",
  "Hello": "Hello",
  "Wallet Balance": "Wallet Balance",
  "Topup": "Topup",
  "More details": "More details",
  "Collect 10 e-stamps to earn x1 FREE wash or dry voucher": "Collect 10 e-stamps to earn x1 FREE wash or dry voucher",
  "For every wash or dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "For every wash or dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!",
  "For every wash cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "For every wash cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!",
  "For every dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "For every dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!",
  "Credits OFF": "Credits OFF",
  "% OFF": "% OFF",
  "Valid Till": "Valid Till",
  "Used On": "Used On",
  "Expired On": "Expired On",
  "Available": "Available",
  "Expired": "Expired",
  "Used": "Used",
  "Promotions": "Promotions",
  "Rewards": "Rewards",
  "Inbox": "Inbox",
  "Activities": "Activities",
  "Support": "Support",
  "Active Rewards": "Active Rewards",
  "Past Rewards": "Past Rewards",
  "Get rewarded for your loyalty with Cleanpro Plus Rewards!": "Get rewarded for your loyalty with Cleanpro Plus Rewards!",
  "Earn vouchers and redeem them for discounts, freebies and more. The more you use our services the more you save!": "Earn vouchers and redeem them for discounts, freebies and more. The more you use our services the more you save!",
  "Up to 3 months history": "Up to 3 months history",
  "Filter": "Filter",
  "All Transactions": "All Transactions",
  "Transactions": "Transactions",
  "Select amount to topup": "Select amount to topup",
  "Balance": "Balance",
  "You've just paid": "You've just paid",
  "Need help?": "Need help?",
  "24-Hour Careline Number": "24-Hour Careline Number",
  "Email Us": "Email Us",
  "Call Now": "Call Now",
  "Email Now": "Email Now",
  "Update name": "Update name",
  "Update email address": "Update email address",
  "Update phone number": "Update phone number",
  "Change password": "Change password",
  "Change language": "Change language",
  "User ID": "User ID",
  "Let us know your feedback": "Let us know your feedback",
  "Poor": "Poor",
  "Good": "Good",
  "Leave addtional feedback here (optional)": "Leave addtional feedback here (optional)",
  "Submit feedback": "Submit feedback",
  "Pay as guest": "Pay as guest",
  "Pay now": "Pay now",
  "Select voucher to use": "Select voucher to use",
  "Use voucher": "Use voucher",
  "Total": "Total",
  "Transaction Type": "Transaction Type",
  "E-Token Topup": "E-Token Topup",
  "Credit Topup": "Credit Topup",
  "Credit topup": "Credit topup",
  "Credit Transfer": "Credit Transfer",
  "E-Token Transfer": "E-Token Transfer",
  "Date/Time": "Date/Time",
  "Reference ID": "Reference ID",
  "Status": "Status",
  "Share Your Referral Code": "Share Your Referral Code",
  "cleanproReferralShortDesc_one": "Get free {{ voucherAmount }} credit when you share your referral code to friends and family after a successful transaction. Tap to learn more.",
  "cleanproReferralShortDesc_other": "Get free {{ voucherAmount }} credits when you share your referral code to friends and family after a successful transaction. Tap to learn more.",
  "Use": "Use",
  "dryer or washer": "dryer or washer",
  "washer": "washer",
  "dryer": "dryer",
  "dryer and washer": "dryer and washer",
  "machine with the minimum spending of": "machine with the minimum spending of",
  // "Welcome to Cleanpro Plus": "Welcome to Cleanpro Plus",
  // "Only scan, set & pay! An easier, more convenient way to pay with Cleanpro Plus! No need to download an app. Enjoy more rewards when you use Cleanpro Plus today! Tap to learn more.": "Only scan, set & pay! An easier, more convenient way to pay with Cleanpro Plus! No need to download an app. Enjoy more rewards when you use Cleanpro Plus today! Tap to learn more.",
  // "Cleanpro Pay Migration Notice": "Cleanpro Pay Migration Notice",
  // "Dear valued Cleanpro customers, please be informed that as of 22 June 2023, the Cleanpro Pay app will be upgraded and and no longer available for use. Tap to learn more.": "Dear valued Cleanpro customers, please be informed that as of 22 June 2023, the Cleanpro Pay app will be upgraded and and no longer available for use. Tap to learn more.",
  // "Answer simple questions and win credits for your next wash or dry! This contest is only available for selected outlets only. Tap to learn more.": "Answer simple questions and win credits for your next wash or dry! This contest is only available for selected outlets only. Tap to learn more.",
  // "The all-new Cleanpro Plus is a new payment method that includes loyalty features built into the app. The more you use our services and pay using Cleanpro Plus, the more you can save. With every transaction, you can earn rewards that will help you save on your next laundry expenses.": "The all-new Cleanpro Plus is a new payment method that includes loyalty features built into the app. The more you use our services and pay using Cleanpro Plus, the more you can save. With every transaction, you can earn rewards that will help you save on your next laundry expenses.",
  // "To use Cleanpro Plus, simply scan the QR code on the machines and pay using your preferred credit/debit card or e-wallet. We hope that Cleanpro Plus will help simplify your laundry routine and give you more time for the things that matter.": "To use Cleanpro Plus, simply scan the QR code on the machines and pay using your preferred credit/debit card or e-wallet. We hope that Cleanpro Plus will help simplify your laundry routine and give you more time for the things that matter.",
  // "If you have any questions about Cleanpro Plus, please read our FAQ in the menu or contact our careline at +603 2770 0100 or email us at info@cleanprolaundry.com. Thank you for choosing Cleanpro.": "If you have any questions about Cleanpro Plus, please read our FAQ in the menu or contact our careline at +603 2770 0100 or email us at info@cleanprolaundry.com. Thank you for choosing Cleanpro.",
  // "Dear valued Cleanpro customers, please be informed that as of 22 June 2023, the existing Cleanpro Pay mobile app will be upgraded and no longer available for use.": "Dear valued Cleanpro customers, please be informed that as of 22 June 2023, the existing Cleanpro Pay mobile app will be upgraded and no longer available for use.",
  // "We are migrating to the all-new Cleanpro Plus. It is a new cashless payment method, without the need to download apps.": "We are migrating to the all-new Cleanpro Plus. It is a new cashless payment method, without the need to download apps.",
  // "If you are the existing user of Cleanpro Pay, any of your remaining balance in the app will be transferred to your Cleanpro Plus account. You are required to use the same mobile number to sign up for Cleanpro Plus for balance transfer.": "If you are the existing user of Cleanpro Pay, any of your remaining balance in the app will be transferred to your Cleanpro Plus account. You are required to use the same mobile number to sign up for Cleanpro Plus for balance transfer.",
  // "If you need help on Cleanpro Plus, please feel free to call our careline at +603 2770 0100 or email us at info@cleanprolaundry.com": "If you need help on Cleanpro Plus, please feel free to call our careline at +603 2770 0100 or email us at info@cleanprolaundry.com",
  // "Answer simple questions and win credits for your next wash or dry!": "Answer simple questions and win credits for your next wash or dry!",
  // "Step 1 : Scan the Jawab & Gerenti Menang QR code in the participated outlets.": "Step 1 : Scan the Jawab & Gerenti Menang QR code in the participated outlets.",
  // "Step 2 : Answer 3 simple questions.": "Step 2 : Answer 3 simple questions.",
  // "Step 3 : Submit and stand a chance to win prizes.": "Step 3 : Submit and stand a chance to win prizes.",
  // "Grand Prize :": "Grand Prize :",
  // "x10 per outlet - 100 credits worth of vouchers in Cleanpro Plus": "x10 per outlet - 100 credits worth of vouchers in Cleanpro Plus",
  // "Consolation Prize :": "Consolation Prize :",
  // "X25 per outlet - 50 credits worth of vouchers in Cleanpro Plus": "X25 per outlet - 50 credits worth of vouchers in Cleanpro Plus",
  //"Participation prize:": "Participation prize:",
  // "Every participants are eligible to receive a FREE 3 credits voucher (worth RM3) in Cleanpro Plus.": "Every participants are eligible to receive a FREE 3 credits voucher (worth RM3) in Cleanpro Plus.",
  // "If you have any questions please don't hesitate to contact our careline at +603 2770 0100 or email us at info@cleanprolaundry.com. Thank you for choosing Cleanpro.": "If you have any questions please don't hesitate to contact our careline at +603 2770 0100 or email us at info@cleanprolaundry.com. Thank you for choosing Cleanpro.",
  "Payment Confirmation": "Payment Confirmation",
  "This campaign is only eligible for users who use the all-new Cleanpro Plus web application.": "This campaign is only eligible for users who use the all-new Cleanpro Plus web application.",
  "ONE e-stamp will be rewarded for each wash or dry cycle.": "ONE e-stamp will be rewarded for each wash or dry cycle.",
  "ONE e-stamp will be rewarded for each wash cycle.": "ONE e-stamp will be rewarded for each wash cycle.",
  "ONE e-stamp will be rewarded for each dry cycle.": "ONE e-stamp will be rewarded for each dry cycle.",
  "Regardless of the washer or dryer settings, the number of e-stamps being collected is the same.": "Regardless of the washer or dryer settings, the number of e-stamps being collected is the same.",
  "The type of e-stamp collected is based on the services that you have used.": "The type of e-stamp collected is based on the services that you have used.",
  "Washing service will reward washer e-stamp and drying service will reward dryer e-stamp.": "Washing service will reward washer e-stamp and drying service will reward dryer e-stamp.",
  "Washing service will reward washer e-stamp.": "Washing service will reward washer e-stamp.",
  "Drying service will reward dryer e-stamp.": "Drying service will reward dryer e-stamp.",
  "E-stamps will automatically be added to your account once the condition has been fulfilled.": "E-stamps will automatically be added to your account once the condition has been fulfilled.",
  "There is no limit on how many e-stamps can be gathered in a single day. So long as you meet the requirements to collect the e-stamps.": "There is no limit on how many e-stamps can be gathered in a single day. So long as you meet the requirements to collect the e-stamps.",
  "The type of e-stamps that have been collected is final and cannot be changed.": "The type of e-stamps that have been collected is final and cannot be changed.",
  "There is no expiration for the e-stamps; only till the discontinuation of the campaign.": "There is no expiration for the e-stamps; only till the discontinuation of the campaign.",
  "E-stamps do not have any currency value, and they cannot be converted to cash or credits.": "E-stamps do not have any currency value, and they cannot be converted to cash or credits.",
  "This campaign is not applicable with any other ongoing promotions, offers, vouchers, and/or discounts provided by the participating outlets.": "This campaign is not applicable with any other ongoing promotions, offers, vouchers, and/or discounts provided by the participating outlets.",
  "These terms and conditions are subject to change at any time without prior notice.": "These terms and conditions are subject to change at any time without prior notice.",
  "Press START on the machine to begin washing.": "Press START on the machine to begin washing.",
  "Press START on the machine to begin drying.": "Press START on the machine to begin drying.",
  "Reminder": "Reminder",
  "Remember to select the same settings you have paid for on the corresponding machine.": "Remember to select the same settings you have paid for on the corresponding machine.",
  "Please ensure that your laundry is inside the machine and door is properly shut.": "Please ensure that your laundry is inside the machine and door is properly shut.",
  "voucherCreditsOff_one": "{{currentVoucherAmount}} Credit OFF",
  "voucherCreditsOff_other": "{{currentVoucherAmount}} Credits OFF",
  "voucherPercentageOff": "{{currentVoucherAmount}}% OFF",
  "cleanproReferralFlatVoucher_one": "Get free credits when you share your Cleanpro Plus referral code to your friends and family! For each successful referral who completes their first transaction, you’ll get free {{ referralVoucherAmount }} credit voucher.",
  "cleanproReferralFlatVoucher_other": "Get free credits when you share your Cleanpro Plus referral code to your friends and family! For each successful referral who completes their first transaction, you’ll get free {{ referralVoucherAmount }} credits voucher.",
  "cleanproReferralRateVoucher": "Get free credits when you share your Cleanpro Plus referral code to your friends and family! For each successful referral who completes their first transaction, you’ll get free {{ referralVoucherAmount }}% Off voucher.",
  "cleanproReferralTokenReward_one": "Get free credits when you share your Cleanpro Plus referral code to your friends and family! For each successful referral who completes their first transaction, you’ll get free {{ referralToken }} credit.",
  "cleanproReferralTokenReward_other": "Get free credits when you share your Cleanpro Plus referral code to your friends and family! For each successful referral who completes their first transaction, you’ll get free {{ referralToken }} credits.",
  "How to get & use code:": "How to get & use code:",
  'Go to menu = icon and click “Refer friends”': 'Go to menu = icon and click “Refer friends”',
  "Share with everyone who will likely to use Cleanpro Plus.": "Share with everyone who will likely to use Cleanpro Plus.",
  "Referral Terms & Conditions:": "Referral Terms & Conditions:",
  "When your friend or family register using your referral code, and completed a transaction (a minimum spending of {{ currency }}{{ referralTransactionAmount }}) , you will be rewarded automatically.": "When your friend or family register using your referral code, and completed a transaction (a minimum spending of {{ currency }}{{ referralTransactionAmount }}) , you will be rewarded automatically.",
  "cleanproNumberOfReferralReward": "You may share with as many people as you want, but each user is ONLY able to receive {{ numberOfReferral }} referral reward.",
  "cleanproNumberOfReferral_one": "You may share with as many people as you want, but each user is ONLY able to receive {{ numberOfReferral }} referral voucher.",
  "cleanproNumberOfReferral_other": "You may share with as many people as you want, but each user is ONLY able to receive {{ numberOfReferral }} referral vouchers.",
  "The voucher is valid for {{ duration }} days from the day voucher be given._one": "The voucher is valid for {{ duration }} day from the day voucher be given.",
  "The voucher is valid for {{ duration }} days from the day voucher be given._other": "The voucher is valid for {{ duration }} days from the day voucher be given.",
  "The voucher is for customer use only and not for sale.": "The voucher is for customer use only and not for sale.",
  "We believe that your special day deserves a little extra sparkle! That's why we're thrilled to introduce our exclusive birthday rewards program just for you! Starting this year, and every year thereafter, we're giving away {{ currency }}{{ voucherAmount }} credit vouchers to you on your birthday.": "We believe that your special day deserves a little extra sparkle! That's why we're thrilled to introduce our exclusive birthday rewards program just for you! Starting this year, and every year thereafter, we're giving away {{ currency }}{{ voucherAmount }} credit vouchers to you on your birthday.",
  "cleanproBirthdayRateAmount": "We believe that your special day deserves a little extra sparkle! That's why we're thrilled to introduce our exclusive birthday rewards program just for you! Starting this year, and every year thereafter, we're giving away {{ voucherAmount }}% vouchers to you on your birthday.",
  "Make sure your account details include your birthdate. This way, we'll know exactly when to send you your special birthday surprise.": "Make sure your account details include your birthdate. This way, we'll know exactly when to send you your special birthday surprise.",
  "Birthday Voucher Terms & Conditions:": "Birthday Voucher Terms & Conditions:",
  "The voucher will be given on the first day of your birthday month.": "The voucher will be given on the first day of your birthday month.",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount._one": "When you applied the voucher during payment, it will give you {{ voucherAmount }} credit ({{ currency }}{{ voucherAmount }}) discount.",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount._other": "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount.",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }}% discount.": "When you applied the voucher during payment, it will give you {{ voucherAmount }}% discount.",
  "All vouchers is not valid with other ongoing promotions, discounts and offers.": "All vouchers is not valid with other ongoing promotions, discounts and offers.",
  "Claim a complimentary wash and dry for every 10 e-stamps collected! We value your loyalty and want to reward you for choosing Cleanpro Plus. Tap to learn more.": "Claim a complimentary wash and dry for every 10 e-stamps collected! We value your loyalty and want to reward you for choosing Cleanpro Plus. Tap to learn more.",
  "cleanproStampFlat_one": "With every 10 e-stamps that you collected, you can claim up to {{ voucherAmount }} credit of free wash or dry session with Cleanpro Plus. Make your laundry routine not just hassle-free, but also rewarding.",
  "cleanproStampFlat_other": "With every 10 e-stamps that you collected, you can claim up to {{ voucherAmount }} credits of free wash or dry session with Cleanpro Plus. Make your laundry routine not just hassle-free, but also rewarding.",
  "cleanproStampRate": "With every 10 e-stamps that you collected, you can claim up to {{ voucherAmount }}% of free wash or dry session with Cleanpro Plus. Make your laundry routine not just hassle-free, but also rewarding.",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "A voucher will be instantly added to your Rewards page when you reach 10 washes. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.",
  "A voucher will be instantly added to your Rewards page when you reach 10 drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "A voucher will be instantly added to your Rewards page when you reach 10 drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes or drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "A voucher will be instantly added to your Rewards page when you reach 10 washes or drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.",
  "Terms & Conditions:": "Terms & Conditions:",
  "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session._one": "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credit ({{ currency }}{{ stampTransactionAmount }}) per session.",
  "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session._other": "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session.",
  "You will be automatically issued a voucher if you have collected 10 washer stamps.": "You will be automatically issued a voucher if you have collected 10 washer stamps.",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps.": "You will be automatically issued a voucher if you have collected 10 dryer stamps.",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps or 10 washer stamps.": "You will be automatically issued a voucher if you have collected 10 dryer stamps or 10 washer stamps.",
  "You will be automatically issued a voucher if you have collected 10 stamps.": "You will be automatically issued a voucher if you have collected 10 stamps.",
  "The voucher is non-refundable and cannot be exchanged for cash; in part or in full.": "The voucher is non-refundable and cannot be exchanged for cash; in part or in full.",
  "This voucher is valid for single transaction only.": "This voucher is valid for single transaction only.",
  "General questions": "General questions",
  "E-stamps collection": "E-stamps collection",
  "Coin exchange machines": "Coin exchange machines",
  "Washer machines": "Washer machines",
  "Dryer machines": "Dryer machines",
  "Paywave issues": "Paywave issues",
  "Cleanpro franchise": "Cleanpro franchise",
  "How can I wash my laundry using Cleanpro Plus?": "How can I wash my laundry using Cleanpro Plus?",
  "Here are the steps to wash your laundry using Cleanpro Plus:": "Here are the steps to wash your laundry using Cleanpro Plus:",
  "Find an unoccupied washing machine in the store, and insert your laundry in the washer.": "Find an unoccupied washing machine in the store, and insert your laundry in the washer.",
  "Select the desired temperature that you would like to use for your laundry.": "Select the desired temperature that you would like to use for your laundry.",
  "Using the scanner in the app, scan the QR code provided on the washing machine. Then select the same settings that you have pressed on the machine.": "Using the scanner in the app, scan the QR code provided on the washing machine. Then select the same settings that you have pressed on the machine.",
  'Tap on “Pay with credits” to pay the amount shown on the app.': 'Tap on “Pay with credits” to pay the amount shown on the app.',
  "Once the payment has been accepted, press the START button on the washer machine.": "Once the payment has been accepted, press the START button on the washer machine.",
  "After the washing cycle ends, you can just remove your laundry from the machine.": "After the washing cycle ends, you can just remove your laundry from the machine.",
  "How can I dry my laundry using Cleanpro Plus?": "How can I dry my laundry using Cleanpro Plus?",
  "Here are the steps to dry your laundry using Cleanpro Plus:": "Here are the steps to dry your laundry using Cleanpro Plus:",
  "Find an unoccupied drying machine in the store, and insert your laundry in the dryer.": "Find an unoccupied drying machine in the store, and insert your laundry in the dryer.",
  "Select the desired temperature and duration that you would like to use for your laundry.": "Select the desired temperature and duration that you would like to use for your laundry.",
  "Using the scanner in the app, scan the QR code provided on the drying machine. Then select the same settings that you have pressed on the machine.": "Using the scanner in the app, scan the QR code provided on the drying machine. Then select the same settings that you have pressed on the machine.",
  "Once the payment has been accepted, press the START button on the dryer machine.": "Once the payment has been accepted, press the START button on the dryer machine.",
  "After the drying cycle ends, you can just remove your laundry from the machine.": "After the drying cycle ends, you can just remove your laundry from the machine.",
  "Why does the QR code I scanned take me to a different machine?": "Why does the QR code I scanned take me to a different machine?",
  "Here are the steps to solve it:": "Here are the steps to solve it:",
  "Make sure that the number on the QR code (e.g. W1, W2, etc) is the same as the machine that you would like to use.": "Make sure that the number on the QR code (e.g. W1, W2, etc) is the same as the machine that you would like to use.",
  "If the QR code number does not match the machine you want, use the other machine. Please contact our customer service line at 03-27700100 to report this issue.": "If the QR code number does not match the machine you want, use the other machine. Please contact our customer service line at 03-27700100 to report this issue.",
  "How can I add more time to the washer that I am currently using?": "How can I add more time to the washer that I am currently using?",
  "The washing time for our washer is fixed and cannot add any additional time.": "The washing time for our washer is fixed and cannot add any additional time.",
  "How can I add more time to the dryer that I am currently using?": "How can I add more time to the dryer that I am currently using?",
  "Here are the steps to add more time to the dryer machine:": "Here are the steps to add more time to the dryer machine:",
  "By using the scanner in the app, scan the QR code provided at the dryer machine.": "By using the scanner in the app, scan the QR code provided at the dryer machine.",
  "Select the amount of time that you would like to add to the machine.": "Select the amount of time that you would like to add to the machine.",
  "After the drying cycle ends, you can just remove the clothes from the machine.": "After the drying cycle ends, you can just remove the clothes from the machine.",
  "REMINDER - It is recommended to add drying time 5 minutes before the cycle ends. And you cannot add tokens for extra times when the machine finishes the drying cycle.": "REMINDER - It is recommended to add drying time 5 minutes before the cycle ends. And you cannot add tokens for extra times when the machine finishes the drying cycle.",
  "Will the timer keep running when I have stopped the drying machine?": "Will the timer keep running when I have stopped the drying machine?",
  "Yes. Even after you stop the machine, the timer will continue to run. If you want to extend the drying time, add drying time 5 minutes before the cycle ends. This prevents the cycle from ending before your clothes are completely dried.": "Yes. Even after you stop the machine, the timer will continue to run. If you want to extend the drying time, add drying time 5 minutes before the cycle ends. This prevents the cycle from ending before your clothes are completely dried.",
  "How do I reload my credits for Cleanpro Plus?": "How do I reload my credits for Cleanpro Plus?",
  "Here are the steps to reload your credits:": "Here are the steps to reload your credits:",
  'Select the "Top Up Credit" button on the homepage.': 'Select the "Top Up Credit" button on the homepage.',
  "Choose the amount you want to reload and the payment method you want to use.": "Choose the amount you want to reload and the payment method you want to use.",
  "You will be taken to the payment page. The screen will return to Cleanpro Plus once the transaction is completed.": "You will be taken to the payment page. The screen will return to Cleanpro Plus once the transaction is completed.",
  "How many credits can I reload in one transaction?": "How many credits can I reload in one transaction?",
  "Reloading credits requires a minimum of RM 10 and a maximum of RM 50.": "Reloading credits requires a minimum of RM 10 and a maximum of RM 50.",
  "Can I pay using credits in the Cleanpro Plus app along with tokens or coins in a single transaction?": "Can I pay using credits in the Cleanpro Plus app along with tokens or coins in a single transaction?",
  "No. Only a single payment method may be chosen when performing any transactions.": "No. Only a single payment method may be chosen when performing any transactions.",
  "The amount I have reloaded in my account was not reflected in the app.": "The amount I have reloaded in my account was not reflected in the app.",
  "Please close and restart the application and check if the new balance has been updated.": "Please close and restart the application and check if the new balance has been updated.",
  "If the amount is still not updated, please contact our customer service line at 03-27700110 to receive further assistance.": "If the amount is still not updated, please contact our customer service line at 03-27700110 to receive further assistance.",
  "Can I cash out the credits I reloaded in my account for this app?": "Can I cash out the credits I reloaded in my account for this app?",
  "No. The credits that you have reloaded will remain in your Cleanpro Plus account.": "No. The credits that you have reloaded will remain in your Cleanpro Plus account.",
  "I have requested a refund, but I still have not received it.": "I have requested a refund, but I still have not received it.",
  "Please contact our customer service line at 03-27700100 to receive further assistance.": "Please contact our customer service line at 03-27700100 to receive further assistance.",
  "I have made the payment, and the app double or triple charged me.": "I have made the payment, and the app double or triple charged me.",
  "The washing machine cannot start even after I have paid using the app.": "The washing machine cannot start even after I have paid using the app.",
  "Ensure that the temperature settings you have selected and paid for on the application are the same as what you have pressed on the washing machine. If not, select the correct temperature settings on the washing machine and try again.": "Ensure that the temperature settings you have selected and paid for on the application are the same as what you have pressed on the washing machine. If not, select the correct temperature settings on the washing machine and try again.",
  "If the machine is still not able to be started, please contact our customer service line at 03-27700100 to receive further assistance.": "If the machine is still not able to be started, please contact our customer service line at 03-27700100 to receive further assistance.",
  "Can I use multiple vouchers together in the same washing or drying cycle?": "Can I use multiple vouchers together in the same washing or drying cycle?",
  "No. Only a single voucher can be used for each washing and drying cycle.": "No. Only a single voucher can be used for each washing and drying cycle.",
  "Why can't I use my free wash voucher that I received after signing up?": "Why can't I use my free wash voucher that I received after signing up?",
  "To redeem or use the voucher, you must complete at least one washing or drying cycle.": "To redeem or use the voucher, you must complete at least one washing or drying cycle.",
  "Can I change my phone number even after registering my account?": "Can I change my phone number even after registering my account?",
  "No. Once registered to an account, the phone number is locked into the account.": "No. Once registered to an account, the phone number is locked into the account.",
  "I have problems in the store, and who can I refer to for help?": "I have problems in the store, and who can I refer to for help?",
  "Do not worry, as you can contact our customer service line at 03-27700100 to receive assistance at any time.": "Do not worry, as you can contact our customer service line at 03-27700100 to receive assistance at any time.",
  "Should I add my own laundry detergent and softeners to the washing machine?": "Should I add my own laundry detergent and softeners to the washing machine?",
  "There is no need for that, as all you have to do is bring your dirty clothes and put them in the washer. The detergent and softeners will be provided by us, and you can rest assured that the laundry detergents we used are certified industrial grade.": "There is no need for that, as all you have to do is bring your dirty clothes and put them in the washer. The detergent and softeners will be provided by us, and you can rest assured that the laundry detergents we used are certified industrial grade.",
  "I would like to add my own laundry detergent and softener to the washing machine.": "I would like to add my own laundry detergent and softener to the washing machine.",
  "We do not recommend our customers add their own detergent, as the mixture of different detergents may affect the wash quality. And you can rest assured that the laundry detergent we used is certified industrial grade.": "We do not recommend our customers add their own detergent, as the mixture of different detergents may affect the wash quality. And you can rest assured that the laundry detergent we used is certified industrial grade.",
  "What time does the store close?": "What time does the store close?",
  "Our self-service laundry operation is open 24 hours a day, which means you can always be sure to go back home with a fresh set of laundry.": "Our self-service laundry operation is open 24 hours a day, which means you can always be sure to go back home with a fresh set of laundry.",
  "Are you open on weekends?": "Are you open on weekends?",
  "Yes. Cleanpro is also open on weekends and even on public holidays.": "Yes. Cleanpro is also open on weekends and even on public holidays.",
  "How many clothes can I fit in the washing or drying machine?": "How many clothes can I fit in the washing or drying machine?",
  "To ensure that your laundry is properly washed or dried, keep the amount of laundry inside the machine lower than the line of guide sticker on the machine.": "To ensure that your laundry is properly washed or dried, keep the amount of laundry inside the machine lower than the line of guide sticker on the machine.",
  "How many e-stamps can I collect in a single day?": "How many e-stamps can I collect in a single day?",
  "There is no limit to the amount of stamps that can be collected in a single day; ONE stamp will be awarded with every wash or dry.": "There is no limit to the amount of stamps that can be collected in a single day; ONE stamp will be awarded with every wash or dry.",
  "When I use the washing service, can I change the collected stamp to a dryer stamp, and vice versa?": "When I use the washing service, can I change the collected stamp to a dryer stamp, and vice versa?",
  "No, the type of stamp collected is only applied to the service that you have used.": "No, the type of stamp collected is only applied to the service that you have used.",
  "What temperatures can I choose when I claim the free washing e-stamp reward?": "What temperatures can I choose when I claim the free washing e-stamp reward?",
  "Any washing temperature is available for the e-stamp reward.": "Any washing temperature is available for the e-stamp reward.",
  "What temperatures can I choose when I claim the free drying e-stamp reward? And how long can I set the time?": "What temperatures can I choose when I claim the free drying e-stamp reward? And how long can I set the time?",
  "Any drying temperature and duration can be selected for the e-stamp reward.": "Any drying temperature and duration can be selected for the e-stamp reward.",
  "I'm unable to change the coin.": "I'm unable to change the coin.",
  "What colour is the light shown on the machine, red or green? If it is a red light, please contact our customer service line at 03-27700100 to receive further assistance.": "What colour is the light shown on the machine, red or green? If it is a red light, please contact our customer service line at 03-27700100 to receive further assistance.",
  "Green Light": "Green Light",
  "Red Light": "Red Light",
  "Machine functions as normal. Please try again.": "Machine functions as normal. Please try again.",
  "(flashing 2x) - There are no coins/tokens in the machine.": "(flashing 2x) - There are no coins/tokens in the machine.",
  "OR": "OR",
  "Note is jammed, please proceed to contact customer service": "Note is jammed, please proceed to contact customer service",
  "(flashing 3x) - Note is jammed, please proceed to contact customer service": "(flashing 3x) - Note is jammed, please proceed to contact customer service",
  "My notes are stuck in the machine.": "My notes are stuck in the machine.",
  "My detergent is not dispensing in the vending machine.": "My detergent is not dispensing in the vending machine.",
  "The water is leaking out of the washing machine.": "The water is leaking out of the washing machine.",
  "Please check the washer machine to see whether there are any clothes that are stuck at the door side.": "Please check the washer machine to see whether there are any clothes that are stuck at the door side.",
  "If yes, here are the steps to solve it:": "If yes, here are the steps to solve it:",
  "Press the emergency stop button (RED Button) for 3 seconds.": "Press the emergency stop button (RED Button) for 3 seconds.",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at 03-27700100 to receive further assistance)": "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at 03-27700100 to receive further assistance)",
  "Ensure the door is closed tightly, and press the START button.": "Ensure the door is closed tightly, and press the START button.",
  "REMINDER - The emergency stop button can only be used once.": "REMINDER - The emergency stop button can only be used once.",
  "There is no detergent dispensing in the washing machine.": "There is no detergent dispensing in the washing machine.",
  "Ensure that the machine is in operation and that the START button was pressed.": "Ensure that the machine is in operation and that the START button was pressed.",
  "If the detergent is still not dispensing, please contact our customer service department at 03-27700100 for further assistance.": "If the detergent is still not dispensing, please contact our customer service department at 03-27700100 for further assistance.",
  "The price displayed on the machine's screen did not change after inserting the token.": "The price displayed on the machine's screen did not change after inserting the token.",
  "Press the small button (in the centre) to reject the tokens that have been inserted. Press a few times till the coins come out.": "Press the small button (in the centre) to reject the tokens that have been inserted. Press a few times till the coins come out.",
  "If the coins still cannot come out or the button is not functioning, please contact our customer service line at 03-27700110 to receive further assistance.": "If the coins still cannot come out or the button is not functioning, please contact our customer service line at 03-27700110 to receive further assistance.",
  "The machine is not starting, and it displays an error code.": "The machine is not starting, and it displays an error code.",
  "We would like to apologise for any inconvenience caused. Please contact our customer service line at 03-27700100 to receive further assistance.": "We would like to apologise for any inconvenience caused. Please contact our customer service line at 03-27700100 to receive further assistance.",
  "I want to wash the clothes again, but why couldn't the machine start even after I added tokens to the machine?": "I want to wash the clothes again, but why couldn't the machine start even after I added tokens to the machine?",
  "Try opening and closing the door again before starting the machine.": "Try opening and closing the door again before starting the machine.",
  "Can I change the water temperature of the machine?": "Can I change the water temperature of the machine?",
  "Yes, but the washer temperature can only be changed from hot to cold after the machine has been started, and not from cold to hot.": "Yes, but the washer temperature can only be changed from hot to cold after the machine has been started, and not from cold to hot.",
  "Can I stop the machine?": "Can I stop the machine?",
  "Here are the steps to stop the machine:": "Here are the steps to stop the machine:",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at to receive further assistance)": "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at to receive further assistance)",
  "There is no water supply on the machine used.": "There is no water supply on the machine used.",
  "Why is the washing temperature cold even when I have selected HOT.": "Why is the washing temperature cold even when I have selected HOT.",
  "The water temperature is HOT or WARM only during washing. The water will turn COLD during rinsing.": "The water temperature is HOT or WARM only during washing. The water will turn COLD during rinsing.",
  "The machine has already finished washing, but it does not spin well, and there is water left on the load.": "The machine has already finished washing, but it does not spin well, and there is water left on the load.",
  "Can I put wet laundry into the dryer to dry?": "Can I put wet laundry into the dryer to dry?",
  "No, as the dripping wet laundry might cause the dryer to short circuit.": "No, as the dripping wet laundry might cause the dryer to short circuit.",
  "REMINDER - Refer to the labels on your clothes to know what kind of temperature is best for the kind of fabric that it uses. Then select the temperature on the machine accordingly.": "REMINDER - Refer to the labels on your clothes to know what kind of temperature is best for the kind of fabric that it uses. Then select the temperature on the machine accordingly.",
  "My clothes are still wet even after drying.": "My clothes are still wet even after drying.",
  "How can I stop the dryer when the machine is still running?": "How can I stop the dryer when the machine is still running?",
  "Just open the door and the machine will automatically stop.": "Just open the door and the machine will automatically stop.",
  "I added extra tokens for extra times, but the machine did not update the time.": "I added extra tokens for extra times, but the machine did not update the time.",
  "For the time to be reflected accurately, it is recommended for you to add tokens 5 minutes before the services end.": "For the time to be reflected accurately, it is recommended for you to add tokens 5 minutes before the services end.",
  "REMINDER - You cannot add tokens for extra times when the machine finishes the drying cycle.": "REMINDER - You cannot add tokens for extra times when the machine finishes the drying cycle.",
  "Why is the machine making noise?": "Why is the machine making noise?",
  "Please check the drum to see if there are any coins or other small things inside.": "Please check the drum to see if there are any coins or other small things inside.",
  "I have pressed the START button on the dryer, but it is still not working.": "I have pressed the START button on the dryer, but it is still not working.",
  "Please try to open the door and close it again. Next, press the START button again to start drying.": "Please try to open the door and close it again. Next, press the START button again to start drying.",
  "If the dryer is still not functioning, please contact our customer service line at 03-27700100 to receive further assistance.": "If the dryer is still not functioning, please contact our customer service line at 03-27700100 to receive further assistance.",
  "Paywave has deducted an amount from the card but the machine did not reflect the transaction.": "Paywave has deducted an amount from the card but the machine did not reflect the transaction.",
  "The Paywave transaction has failed but the amount has still been deducted from my card.": "The Paywave transaction has failed but the amount has still been deducted from my card.",
  "Paywave has double/triple charge but the machine cannot start.": "Paywave has double/triple charge but the machine cannot start.",
  "Paywave after double/triple charge machines can't start.": "Paywave after double/triple charge machines can't start.",
  "Paywave is offline": "Paywave is offline",
  "Do Cleanpro Express offer franchise business/selling machines/laundry products?": "Do Cleanpro Express offer franchise business/selling machines/laundry products?",
  "For further inquiries, please email to info@cleanproexpress.com": "For further inquiries, please email to info@cleanproexpress.com",
  "Step 6": "Step 6",
  "User Existed": "User Existed",
  "This email is registered": "This email is registered",
  "This phone number is registered": "This phone number is registered",
  "Invalid Email Address": "Invalid Email Address",
  "Let's get started!": "Let's get started!",
  "Enter your e-mail/mobile number": "Enter your e-mail/mobile number",
  "Enter your e-mail": "Enter your e-mail",
  "Enter your mobile number": "Enter your mobile number",
  "Enter your e-mail address": "Enter your e-mail address",
  "Proceed": "Proceed",
  "Enter OTP number": "Enter OTP number",
  "You will receive a six-digit OTP via SMS sent to": "You will receive a six-digit OTP via SMS sent to",
  "You will receive a six-digit OTP via e-mail sent to": "You will receive a six-digit OTP via e-mail sent to",
  "Verify": "Verify",
  "Resend OTP": "Resend OTP",
  "Welcome onboard!": "Welcome onboard!",
  "Please fill in the info below": "Please fill in the info below",
  "Enter your name*": "Enter your name*",
  "Enter your email address*": "Enter your email address*",
  "Please enter either phone number or email address": "Please enter either phone number or email address",
  "Create a password*": "Create a password*",
  "Enter referral code (if got any)": "Enter referral code (if got any)",
  "Get started": "Get started",
  "Birthday updated successfully": "Birthday updated successfully",
  "Date of birth": "Date of birth",
  "Enter your date of birth": "Enter your date of birth",
  "Select your birth date": "Select your birth date",
  "Update date of birth": "Update date of birth",
  "Update birth date": "Update birth date",
  "Already have an account?": "Already have an account?",
  "Login now": "Login now",
  "Sign in": "Sign in",
  "Sign up now": "Sign up now",
  "COMPLETED": "COMPLETED",
  "WASHING NOW": "WASHING NOW",
  "DRYING NOW": "DRYING NOW",
  "It's done!": "It's done!",
  "Please collect your fresh, clean laundry in order to leave the machine available for the next person to use!": "Please collect your fresh, clean laundry in order to leave the machine available for the next person to use!",
  "Leave a feedback": "Leave a feedback",
  "Time left": "Time left",
  "Add drying time": "Add drying time",
  "Hi": "Hi",
  "customer": "customer",
  "Thank you for your payment. Don't forget to select the <b>correct temperature</b> and press <b>START</b> when you're ready.": "Thank you for your payment. Don't forget to select the <b>correct temperature</b> and press <b>START</b> when you're ready.",
  "Select how you want to receive a notification when your laundry is finished": "Select how you want to receive a notification when your laundry is finished",
  "Sign up": "Sign up",
  "Continue to pay": "Continue to pay",
  "Register as a member to enjoy more benefits!": "Register as a member to enjoy more benefits!",
  "Get FREE {{ voucherAmount }} credits per new user_one": "Get FREE {{ voucherAmount }} credit per new user",
  "Get FREE {{ voucherAmount }} credits per new user_other": "Get FREE {{ voucherAmount }} credits per new user",
  "Get FREE {{ voucherAmount }}% per new user": "Get FREE {{ voucherAmount }}% per new user",
  "Enjoy exclusive promotions": "Enjoy exclusive promotions",
  "FREE voucher on your birthday": "FREE voucher on your birthday",
  "and more": "and more",
  "Denied camera access": "Denied camera access",
  'Permission to access the camera has been denied. Please try again and click "Allow" to scan the QR code.': 'Permission to access the camera has been denied. Please try again and click "Allow" to scan the QR code.',
  "Okay": "Okay",
  "Oops. You don't have enough balance to make the payment": "Oops. You don't have enough balance to make the payment",
  "Please confirm": "Please confirm",
  "Do you want to proceed with this feedback?": "Do you want to proceed with this feedback?",
  "Are you sure to purchase": "Are you sure to purchase",
  "credits for": "credits for",
  "Topup credit": "Topup credit",
  "Extended duration will be instantly reflected on machine after payment": "Extended duration will be instantly reflected on machine after payment",
  "Machine is currently busy": "Machine is currently busy",
  "Do you want to extend drying time?": "Do you want to extend drying time?",
  // "Cuci Hari-Hari Bersama Cleanpro!": "Cuci Hari-Hari Bersama Cleanpro!",
  // "Ready for a challenge?": "Ready for a challenge?",
  // "Here's one for you - all you need to do is wash your laundry 10 times in 20 days at participating Cleanpro outlets. Stand a chance to win a Limited Edition Cleanpro Designer Laundry Bag worth up to RM40!": "Here's one for you - all you need to do is wash your laundry 10 times in 20 days at participating Cleanpro outlets. Stand a chance to win a Limited Edition Cleanpro Designer Laundry Bag worth up to RM40!",
  // "Here's how to participate:": "Here's how to participate:",
  // "Step 1: Scan the QR Code on the washer to launch Cleanpro Plus": "Step 1: Scan the QR Code on the washer to launch Cleanpro Plus",
  // "Step 2: Pay for your wash with Cleanpro Plus": "Step 2: Pay for your wash with Cleanpro Plus",
  // "Step 3: Complete x10 washes within 20 days to win": "Step 3: Complete x10 washes within 20 days to win",
  // "Challenge Period: 01 July - 31 August 2023": "Challenge Period: 01 July - 31 August 2023",
  // "Drop by your nearest Cleanpro outlet to wash your laundry with us for 20 days straight! Good luck!": "Drop by your nearest Cleanpro outlet to wash your laundry with us for 20 days straight! Good luck!",
  // "TERMS & CONDITIONS": "TERMS & CONDITIONS",
  // "PARTICIPATION CRITERIA": "PARTICIPATION CRITERIA",
  // "1) Participant needs to register an account in Cleanpro Plus web app.": "1) Participant needs to register an account in Cleanpro Plus web app.",
  // "2) Participant can use any washer of any capacity in any participating outlets to qualify for entries.": "2) Participant can use any washer of any capacity in any participating outlets to qualify for entries.",
  // "3) Payment needs to be made with Cleanpro Plus web app.": "3) Payment needs to be made with Cleanpro Plus web app.",
  // "4) Washes must be completed and paid (with no dispute whatsoever) within campaign period.": "4) Washes must be completed and paid (with no dispute whatsoever) within campaign period.",
  // "5) Campaign period starts from 1st July 2023 at 00:00 and ends at 31st August 2023 at 23:59.": "5) Campaign period starts from 1st July 2023 at 00:00 and ends at 31st August 2023 at 23:59.",
  // "WINNERS & PRIZES": "WINNERS & PRIZES",
  // "1) Cleanpro will notify the winners of the campaign via registered WhatsApp number or email address provided, within 4 weeks after the campaign ends.": "1) Cleanpro will notify the winners of the campaign via registered WhatsApp number or email address provided, within 4 weeks after the campaign ends.",
  // "2) Any unclaimed prizes after 2 weeks from notification date will not be entertained thereafter.": "2) Any unclaimed prizes after 2 weeks from notification date will not be entertained thereafter.",
  // "3) Upon completing the ten (10) washes within twenty (20) days campaign, participants will be a winner and be eligible to win ONE (1) Cleanpro Designer Laundry Bag.": "3) Upon completing the ten (10) washes within twenty (20) days campaign, participants will be a winner and be eligible to win ONE (1) Cleanpro Designer Laundry Bag.",
  // "4) Winners are eligible to win more than ONE (1) Cleanpro Designer Laundry Bag in this campaign.": "4) Winners are eligible to win more than ONE (1) Cleanpro Designer Laundry Bag in this campaign.",
  // "5) Winners will be given the choice of his/her preferred laundry bag size; but only ONE (1) can be selected for each qualified win.": "5) Winners will be given the choice of his/her preferred laundry bag size; but only ONE (1) can be selected for each qualified win.",
  // "A) XL Size - Blue bag with up to 20KG in capacity": "A) XL Size - Blue bag with up to 20KG in capacity",
  // "B) L Size - White bag with up to 12KG in capacity": "B) L Size - White bag with up to 12KG in capacity",
  // "6) Time and location for collection of prize will be informed via Whatsapp number and/or email address provided.": "6) Time and location for collection of prize will be informed via Whatsapp number and/or email address provided.",
  "OTHER": "OTHER",
  // "1) Changes to the terms and conditions will be at Cleanpro's discretion; without prior notice.": "1) Changes to the terms and conditions will be at Cleanpro's discretion; without prior notice.",
  // "2) Completed wash is defined by washes performed with Cleanpro's washer and payments within Cleanpro Plus web app are made with no disputes.": "2) Completed wash is defined by washes performed with Cleanpro's washer and payments within Cleanpro Plus web app are made with no disputes.",
  // "3) By participating in this campaign automatically indicates that the Participant has agreed to all the campaign's Terms and Conditions as stipulated.": "3) By participating in this campaign automatically indicates that the Participant has agreed to all the campaign's Terms and Conditions as stipulated.",
  "Welcome Voucher": "Welcome Voucher",
  "Welcome to the Cleanpro Plus family! This first gift is just the beginning. Stay tuned for a series of exciting promotions and campaigns, exclusively for Cleanpro Plus users.": "Welcome to the Cleanpro Plus family! This first gift is just the beginning. Stay tuned for a series of exciting promotions and campaigns, exclusively for Cleanpro Plus users.",
  "Terms & Conditions": "Terms & Conditions",
  "TERMS AND CONDITIONS": "TERMS AND CONDITIONS",
  "Welcome Voucher is valid for one-time use only.": "Welcome Voucher is valid for one-time use only.",
  "There is no minimum spend required for the voucher to be used.": "There is no minimum spend required for the voucher to be used.",
  "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only._one": "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} day only.",
  "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only._other": "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only.",
  "Users are eligible to use their Welcome Voucher AFTER the completion of their first wash or dry cycle using the same Cleanpro Plus account.": "Users are eligible to use their Welcome Voucher AFTER the completion of their first wash or dry cycle using the same Cleanpro Plus account.",
  "Welcome Voucher cannot be used together with any ongoing promotions or any other promotional vouchers.": "Welcome Voucher cannot be used together with any ongoing promotions or any other promotional vouchers.",
  "The voucher is final and cannot be refunded in form of cash or credit to the user.": "The voucher is final and cannot be refunded in form of cash or credit to the user.",
  "Cleanpro reserves the right to change the terms and conditions without prior notice.": "Cleanpro reserves the right to change the terms and conditions without prior notice.",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})_one": "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credit voucher (worth {{ currency }}{{ voucherAmount }})",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})_other": "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }}% voucher (worth {{ voucherAmount }}%)": "Collect 10 e-stamps to earn FREE {{ voucherAmount }}% voucher (worth {{ voucherAmount }}%)",
  "Collect 10 e-Stamp to earn FREE Voucher": "Collect 10 e-Stamp to earn FREE Voucher",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding._one": "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credit voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding.",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding._other": "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding.",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }}% credits voucher (worth {{ voucherAmount }}%). Make your laundry routine not just hassle-free, but also rewarding.": "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }}% credits voucher (worth {{ voucherAmount }}%). Make your laundry routine not just hassle-free, but also rewarding.",
  // "How to participate:": "How to participate:",
  // "Prizes to be won:": "Prizes to be won:",
  "RM10 OFF Welcome Voucher": "RM10 OFF Welcome Voucher",
  "Welcome to the Cleanpro family, here is an appreciation voucher from us. Thank you for attending the COPE Investors Conference.": "Welcome to the Cleanpro family, here is an appreciation voucher from us. Thank you for attending the COPE Investors Conference.",
  "Welcome Voucher | COPE Investors Conference": "Welcome Voucher | COPE Investors Conference",
  "Payment methods": "Payment methods",
  "Tap to proceed with your preferred mode of payment": "Tap to proceed with your preferred mode of payment",
  "Cleanpro Plus credits": "Cleanpro Plus credits",
  "E-wallet or credit/debit cards": "E-wallet or credit/debit cards",
  "Go to homepage": "Go to homepage",
  // backend response or error
  "Admin is unauthorized to login": "Admin is unauthorized to login",
  "Internal Error": "Internal Error",
  "Please enter the correct credentials": "Please enter the correct credentials",
  "Operator not found": "Operator not found",
  "Admin not found": "Admin not found",
  "Distributor not found": "Distributor not found",
  "Client not found": "Client not found",
  "Outlet not found": "Outlet not found",
  "Token Package not found": "Token Package not found",
  "Top up history not found": "Top up history not found",
  "Voucher not found": "Voucher not found",
  "Faq not found": "Faq not found",
  "Faq Group not found": "Faq Group not found",
  "News not found": "News not found",
  "Transaction not found": "Transaction not found",
  "Please Login Again": "Please Login Again",
  "Decoding Error": "Decoding Error",
  "Some error occured, please contact the dev team if this error continues.": "Some error occured, please contact the dev team if this error continues.",
  "Please fill in all the required fields": "Please fill in all the required fields",
  "Only success transaction can be refund": "Only success transaction can be refund",
  "Only token payment method can be refund": "Only token payment method can be refund",
  "The discount code has been used, please change to other code": "The discount code has been used, please change to other code",
  "Cannot use ewallet in sandbox": "Cannot use ewallet in sandbox",
  "Please close the door to proceed your payment": "Please close the door to proceed your payment",
  "Under Maintenance": "Under Maintenance",
  "This machine is being fixed. Please use another machine.": "This machine is being fixed. Please use another machine.",
  "Machine is currently running, please try again later": "Machine is currently running, please try again later",
  "Machine is currently offline, please try again later": "Machine is currently offline, please try again later",
  "Outlet not participating in Loyalty program": "Outlet not participating in Loyalty program",
  "Please log in to make the payment": "Please log in to make the payment",
  "Package not found, please refresh and try again": "Package not found, please refresh and try again",
  "You have reached the maximum number of purchase": "You have reached the maximum number of purchase",
  "Store not found, please try again later": "Store not found, please try again later",
  "Incorrect Password": "Incorrect Password",
  "Token already top up": "Token already top up",
  "Payment failed": "Payment failed",
  "Transaction Failure": "Transaction Failure",
  "Transaction Refunded": "Transaction Refunded",
  "Transaction Pending": "Transaction Pending",
  "Please enter your mobile number": "Please enter your mobile number",
  "User is unauthorized to register": "User is unauthorized to register",
  "Please proceed to sign up": "Please proceed to sign up",
  "OTP expired, please request a new OTP": "OTP expired, please request a new OTP",
  "Incorrect verification code": "Incorrect verification code",
  "This referrer ID is not valid": "This referrer ID is not valid",
  "This referrer ID is different operator": "This referrer ID is different operator",
  "This referrer ID is exceed the limit": "This referrer ID is exceed the limit",
  "User is unauthorized to login": "User is unauthorized to login",
  "Click here to register": "Click here to register",
  "User is unauthorized to login. Please contact the admin": "User is unauthorized to login. Please contact the admin",
  "User is unauthorized": "User is unauthorized",
  "This outlet does not participate in the Loyalty Program": "This outlet does not participate in the Loyalty Program",
  "This outlet is not belongs to the operator": "This outlet is not belongs to the operator",
  "Processing request": "Processing request",
  "This user is not verified": "This user is not verified",
  "Insufficient token to make payment": "Insufficient token to make payment",
  "Insufficient token to transfer": "Insufficient token to transfer",
  "Insufficient point to make payment": "Insufficient point to make payment",
  "This voucher is not available for use": "This voucher is not available for use",
  "This voucher is belongs to other user": "This voucher is belongs to other user",
  "Invalid Discount Code": "Invalid Discount Code",
  "This discount code cannot use in this outlet": "This discount code cannot use in this outlet",
  "This discount code was expired": "This discount code was expired",
  "This discount code cannot use in washer machine transaction": "This discount code cannot use in washer machine transaction",
  "This discount code cannot use in dryer machine transaction": "This discount code cannot use in dryer machine transaction",
  "This discount code was fully redeemed today, try again tomorrow": "This discount code was fully redeemed today, try again tomorrow",
  "You have fully redeemed this discount code": "You have fully redeemed this discount code",
  "This discount code have been redeemed": "This discount code have been redeemed",
  "This discount code is not applicable": "This discount code is not applicable",
  "Insufficient stamp": "Insufficient stamp",
  "Please provide at least one voucher setting": "Please provide at least one voucher setting",
  "Previous batch are still generating, please try again later": "Previous batch are still generating, please try again later",
  "Number of voucher code should be more than 0": "Number of voucher code should be more than 0",
  "Number of voucher code should be less than 50000": "Number of voucher code should be less than 50000",
  "Number of discount code should be more than 0": "Number of discount code should be more than 0",
  "Number of discount code should be less than 50000": "Number of discount code should be less than 50000",
  "No Item": "No Item",
  "Please add item": "Please add item",
  "Staff not found": "Staff not found",
  "This task already completed": "This task already completed",
  "Please complete the wash task first": "Please complete the wash task first",
  "Please complete the dry task first": "Please complete the dry task first",
  "Please select at least one outlet": "Please select at least one outlet",
  "Touch to Start": "Touch to Start",
  "New Users": "New Users",
  "Get {{ voucher_amount }} FREE Credits!": "Get {{ voucher_amount }} FREE Credits!",
  "Get {{ voucher_amount }}% FREE!": "Get {{ voucher_amount }}% FREE!",
  "Load your clothes into the washing machine & note the machine number": "Load your clothes into the washing machine & note the machine number",
  "T&C Apply": "T&C Apply",
  "Mobile Number": "Mobile Number",
  "Member": "Member",
  "Please enter your mobile phone number / e-mail": "Please enter your mobile phone number / e-mail",
  "Please verify your number": "Please verify your number",
  "Please verify your e-mail": "Please verify your e-mail",
  "Please enter the correct phone number format. Example: 01xxxxxxxx": "Please enter the correct phone number format. Example: 01xxxxxxxx",
  "Please enter the correct phone number format. Example: 09xxxxxxxx": "Please enter the correct phone number format. Example: 09xxxxxxxx",
  "Scan QR to Complete your signup & access more benefits!": "Scan QR to Complete your signup & access more benefits!",
  "Please choose your service": "Please choose your service",
  "WASHER": "WASHER",
  "DRYER": "DRYER",
  "VENDING MACHINE": "VENDING MACHINE",
  "Please tap your card on the reader": "Please tap your card on the reader",
  "Payment Option": "Payment Option",
  "Thank you for payment!": "Thank you for payment!",
  "Please select your items at the vending machine": "Please select your items at the vending machine",
  "Please choose the temperature on the machine and press": "Please choose the temperature on the machine and press",
  "START": "START",
  "Need Help?": "Need Help?",
  "Please choose the temperature": "Please choose the temperature",
  "Confirm Payment": "Confirm Payment",
  "Select the time for": "Select the time for",
  "Do you want to add drying time?": "Do you want to add drying time?",
  "minutes": "minutes",
  "Your machine is": "Your machine is",
  "Please Collect your item from the vending machine": "Please Collect your item from the vending machine",
  "You've earned 1 e-stamp for your wash!": "You've earned 1 e-stamp for your wash!",
  "You've earned 1 e-stamp for your dry!": "You've earned 1 e-stamp for your dry!",
  "You've missed 1 e-stamp for your wash!": "You've missed 1 e-stamp for your wash!",
  "You've missed 1 e-stamp for your dry!": "You've missed 1 e-stamp for your dry!",
  "Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.",
  "Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.",
  "Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.",
  "Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.",
  "Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.",
  "Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "Sign Up & Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "Sign Up & Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.",
  "Sign Up & Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "Sign Up & Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.",
  "Sign Up & Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "Sign Up & Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.",
  "Sign Up & Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "Sign Up & Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.",
  "Sign Up & Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "Sign Up & Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.",
  'For iOS users, press and hold the image, then choose "Add to Photos" or "Save in Photos" from the menu.': 'For iOS users, press and hold the image, then choose "Add to Photos" or "Save in Photos" from the menu.',
  "Scan the QR code to pay": "Scan the QR code to pay",
  "QR Code expires in {{ countdown }} seconds": "QR Code expires in {{ countdown }} seconds",
  "Transfer In": "Transfer In",
  "Migrate": "Migrate",
  "Update": "Update",
  "Transfer Out": "Transfer Out",
  "Total In": "Total In",
  "Total Out": "Total Out",
  "Laundry Pass": "Laundry Pass",
  "Number of wash": "Number of wash",
  "Number of Wash": "Number of Wash",
  "Number of dry": "Number of dry",
  "Number of Dry": "Number of Dry",
  "Laundry Pass Purchase": "Laundry Pass Purchase",
  "Laundry Pass Purchase Report": "Laundry Pass Purchase Report",
  "Please select distributor or operator": "Please select distributor or operator",
  "Price should be more than 0": "Price should be more than 0",
  "Number of wash or dry should be more than 0": "Number of wash or dry should be more than 0",
  "Number of wash should be more than 0": "Number of wash should be more than 0",
  "Number of dry should be more than 0": "Number of dry should be more than 0",
  "Duration must be more than 0": "Duration must be more than 0",
  "Please fill in the name": "Please fill in the name",
  "Purchase Start Date": "Purchase Start Date",
  "Purchase End Date": "Purchase End Date",
  "Number of Maximum Purchase": "Number of Maximum Purchase",
  "Create Laundry Pass": "Create Laundry Pass",
  "Select Purchase Period": "Select Purchase Period",
  "If ticked, the Laundry Pass will have expired date": "If ticked, the Laundry Pass will have expired date",
  "Laundry Pass Lifespan": "Laundry Pass Lifespan",
  "Edit Laundry Pass": "Edit Laundry Pass",
  "Washer Used Date": "Washer Used Date",
  "Dryer Used Date": "Dryer Used Date",
  "Laundry Pass Purchase History": "Laundry Pass Purchase History",
  "Laundry Pass Usage Report": "Laundry Pass Usage Report",
  "Please Note! (Stacked Dryer)": "Please Note! (Stacked Dryer)",
  "Ensure machine is vacant and select correct machine after payment press START": "Ensure machine is vacant and select correct machine after payment press START",
  "Start date": "Start date",
  "End date": "End date",
  "Today": "Today",
  "Yesterday": "Yesterday",
  "Last 7 Days": "Last 7 Days",
  "Last 30 Days": "Last 30 Days",
  "This Month": "This Month",
  "Last Month": "Last Month",
  "Use Per Day": "Use Per Day",
  "Maximum use per day must be more than 0": "Maximum use per day must be more than 0",
  "Only applicable to selected outlet": "Only applicable to selected outlet",
  "Applicable to all the outlets except selected outlet": "Applicable to all the outlets except selected outlet",
  "If applicable to all the outlet, leave it blank": "If applicable to all the outlet, leave it blank",
  "Only applicable to selected weight": "Only applicable to selected weight",
  "Applicable to all the weight except selected weight": "Applicable to all the weight except selected weight",
  "Weight": "Weight",
  "If applicable to all the weight, leave it blank": "If applicable to all the weight, leave it blank",
  "Add Weight": "Add Weight",
  "Only applicable to selected mode": "Only applicable to selected mode",
  "Applicable to all the modes except selected mode": "Applicable to all the modes except selected mode",
  "If applicable to all the mode, leave it blank": "If applicable to all the mode, leave it blank",
  "Add Mode": "Add Mode",
  "Laundry Pass not applicable in this outlet": "Laundry Pass not applicable in this outlet",
  "Discounted price should be more than 0": "Discounted price should be more than 0",
  "Discounted Price": "Discounted Price",
  "Logo (Optional)": "Logo (Optional)",
  "Save": "Save",
  "Cleanpro Laundry Pass": "Cleanpro Laundry Pass",
  "Save more with the Laundry Pass — ": "Save more with the Laundry Pass — ",
  "wash and dry more clothes at a lower price while enjoying extra rewards from Cleanpro Plus!": "wash and dry more clothes at a lower price while enjoying extra rewards from Cleanpro Plus!",
  "How to Purchase Laundry Pass": "How to Purchase Laundry Pass",
  "Step 1: Register as a Cleanpro Plus user.": "Step 1: Register as a Cleanpro Plus user.",
  "Step 2: Choose the Laundry Pass package you wish to purchase.": "Step 2: Choose the Laundry Pass package you wish to purchase.",
  "Step 3: Make the payment through Cleanpro Plus.": "Step 3: Make the payment through Cleanpro Plus.",
  "Step 4: Enjoy washing and drying services at any Cleanpro outlet in Malaysia with exclusive discounted prices!": "Step 4: Enjoy washing and drying services at any Cleanpro outlet in Malaysia with exclusive discounted prices!",
  "By purchasing and/or using the Cleanpro Laundry Pass, you agree to be bound by the following terms and conditions:": "By purchasing and/or using the Cleanpro Laundry Pass, you agree to be bound by the following terms and conditions:",
  "Definitions": "Definitions",
  '"Laundry Pass" refers to the package(s) for specific laundry services offered by Cleanpro.': '"Laundry Pass" refers to the package(s) for specific laundry services offered by Cleanpro.',
  '"Subscriber" refers to the individual(s) purchasing and/or using the Laundry Pass.': '"Subscriber" refers to the individual(s) purchasing and/or using the Laundry Pass.',
  "Pass Description": "Pass Description",
  "The Laundry Pass is a promotional package that offers laundry services at any Cleanpro outlet in Malaysia.": "The Laundry Pass is a promotional package that offers laundry services at any Cleanpro outlet in Malaysia.",
  'The Laundry Pass is valid for both Malaysians and non-Malaysians; and is exclusively available to Cleanpro Plus members.': 'The Laundry Pass is valid for both Malaysians and non-Malaysians; and is exclusively available to Cleanpro Plus members.',
  "The campaign of Laundry Pass is valid from": "The campaign of Laundry Pass is valid from",
  "1 March 2025 to 31 May 2025.": "1 March 2025 to 31 May 2025.",
  'Each Laundry Pass subscription is': 'Each Laundry Pass subscription is',
  'valid for 30 days from the start date,': 'valid for 30 days from the start date,',
  'allowing subscribers to use the package': 'allowing subscribers to use the package',
  'up to 4 times per day.': 'up to 4 times per day.',
  'During the promotional period, subscribers can repurchase the package unlimited times, but only after fully utilizing your current subscription.': 'During the promotional period, subscribers can repurchase the package unlimited times, but only after fully utilizing your current subscription.',
  "The Laundry Pass is": "The Laundry Pass is",
  "valid only for cold wash and drying of machines under 25kg.": "valid only for cold wash and drying of machines under 25kg.",
  "Additional charges will apply for warm and hot wash services, based on the temperature selected.": "Additional charges will apply for warm and hot wash services, based on the temperature selected.",
  'Unused wash or dry session(s) from the Laundry Pass cannot be carried forward to the next purchase, and are non-refundable, non-exchangeable for cash, and non-transferable.': 'Unused wash or dry session(s) from the Laundry Pass cannot be carried forward to the next purchase, and are non-refundable, non-exchangeable for cash, and non-transferable.',
  'The Laundry Pass is valid for washing and/or drying standard laundry items only (e.g., clothing, linens), excluding large items (e.g., rugs), heavily soiled items (e.g., pet bedding), or specialty items requiring special treatment.': 'The Laundry Pass is valid for washing and/or drying standard laundry items only (e.g., clothing, linens), excluding large items (e.g., rugs), heavily soiled items (e.g., pet bedding), or specialty items requiring special treatment.',
  'The Laundry Pass can be cancelled within the first 7 days of subscription for a full refund, provided the subscriber has not used the Laundry Pass during this period. No refunds or transfers will be issued after the first 7 days.': 'The Laundry Pass can be cancelled within the first 7 days of subscription for a full refund, provided the subscriber has not used the Laundry Pass during this period. No refunds or transfers will be issued after the first 7 days.',
  "Refund process may take up to 21 working days.": "Refund process may take up to 21 working days.",
  'Subscribers are encouraged to regularly check Cleanpro Plus for reminders regarding the expiry date of their laundry pass.': 'Subscribers are encouraged to regularly check Cleanpro Plus for reminders regarding the expiry date of their laundry pass.',
  "This promotion is not valid in conjunction with the '10 Free 1 e-Stamp Campaign'.": "This promotion is not valid in conjunction with the '10 Free 1 e-Stamp Campaign'.",
  "Any misuse of the Laundry Pass will result in the immediate termination of the subscription without prior notice. Payments for the Laundry Pass are non-refundable, non-exchangeable for cash, and non-transferable.": "Any misuse of the Laundry Pass will result in the immediate termination of the subscription without prior notice. Payments for the Laundry Pass are non-refundable, non-exchangeable for cash, and non-transferable.",
  "Payment must be made in full at the time of subscription via Cleanpro Plus.": "Payment must be made in full at the time of subscription via Cleanpro Plus.",
  "For any questions or assistance regarding the Laundry Pass, please email Cleanpro Customer Service at enquiry@cleanpro.asia.": "For any questions or assistance regarding the Laundry Pass, please email Cleanpro Customer Service at enquiry@cleanpro.asia.",
  "Cleanpro reserves the right to change the terms and conditions at any time without prior notice.": "Cleanpro reserves the right to change the terms and conditions at any time without prior notice.",
  "Search": "Search",
  "Scan to register as a member": "Scan to register as a member",
  "Select Product / Key in Amount": "Select Product / Key in Amount",
  "Discount code is not available in this payment type": "Discount code is not available in this payment type",
  "This voucher is not available use in washer payment": "This voucher is not available use in washer payment",
  "This voucher is not available use in dryer payment": "This voucher is not available use in dryer payment",
  "This voucher is not available use in Drop n Go payment": "This voucher is not available use in Drop n Go payment",
  "Voucher is not available in this payment type": "Voucher is not available in this payment type",
  "Select the price for": "Select the price for",
  "Enable Stamping": "Enable Stamping",
  "Please select your preferred outlet": "Please select your preferred outlet",
  "Select your preferred outlet": "Select your preferred outlet",
  "State": "State",
  "Select State": "Select State",
  "Payment Successful!": "Payment Successful!",
  "Thank you for purchasing Laundry Pass!": "Thank you for purchasing Laundry Pass!",
  "Your Laundry Pass expired on": "Your Laundry Pass expired on",
  "You have used all your Laundry Pass": "You have used all your Laundry Pass",
  "Purchase Again": "Purchase Again",
  "Save Big!": "Save Big!",
  "You've saved": "You've saved",
  "on your package!": "on your package!",
  "Please select distributor, operator or outlet": "Please select distributor, operator or outlet",
  "Please enter your mobile phone number or e-mail": "Please enter your mobile phone number or e-mail",
  "We’ll send you an SMS when your laundry’s ready": "We’ll send you an SMS when your laundry’s ready",
  "Skip": "Skip",
  "Notice": "Notice",
  "User exists but not verified. Please verify your account by scanning the QR Code at Thank You Page.": "User exists but not verified. Please verify your account by scanning the QR Code at Thank You Page.",
  "User registered successfully. Please complete verification by scanning the QR Code at Thank You Page.": "User registered successfully. Please complete verification by scanning the QR Code at Thank You Page.",
  "Please enter email address to register": "Please enter email address to register",
  "Please enter phone number to register": "Please enter phone number to register",
  "Camera permission is denied": "Camera permission is denied",
  "No camera device found": "No camera device found",
  "Camera is already in use by another app": "Camera is already in use by another app",
  "Preferred Outlet": "Preferred Outlet",
  "Purchase Now": "Purchase Now",
  "Cancel Date": "Cancel Date",
  "Cancel Laundry Pass": "Cancel Laundry Pass",
  "Download or takes a screenshot of the QR code.": "Download or takes a screenshot of the QR code.",
  "Launch and login banking app.": "Launch and login banking app.",
  "Choose QR code from your gallery.": "Choose QR code from your gallery.",
  "1 March 2025 - 30 April 2025": "1 March 2025 - 30 April 2025",
  "Payment Method to get point": "Payment Method to get point",
  "Payment Method to get voucher": "Payment Method to get voucher",
  "If applicable to all the payment method, leave it blank": "If applicable to all the payment method, leave it blank",
  "Add {{ currency }} {{ amount }} for {{ mode }} Wash": "Add {{ currency }} {{ amount }} for {{ mode }} Wash",
  "Add {{ currency }} {{ amount }} for an extra {{ runtime }} minutes!": "Add {{ currency }} {{ amount }} for an extra {{ runtime }} minutes!",
  "via": "via",
  "Cash": "Cash",
  "Are you sure you have collected your laundry?": "Are you sure you have collected your laundry?",
  "Collected All": "Collected All",
  "Collected": "Collected",
  "Are you sure the customer have collected the laundry?": "Are you sure the customer have collected the laundry?",
  "Pending Payment (Cash)": "Pending Payment (Cash)",
  "You have received the cash payment": "You have received the cash payment",
  "Print Receipt": "Print Receipt",
  "Are you sure you want to print receipt?": "Are you sure you want to print receipt?",
  "Are you sure you want to print sticker?": "Are you sure you want to print sticker?",
  "Copy": "Copy",
  "low": "low",
  "medium": "medium",
  "high": "high",
  "About Us": "About Us",
  "ABOUT US": "ABOUT US",
  "Only can request einvoice for Malaysia Outlet": "Only can request einvoice for Malaysia Outlet",
  "E-Invoice requested successfully": "E-Invoice requested successfully",
  "Select machine": "Select machine",
  "Select transaction date": "Select transaction date",
  "Transaction Time": "Transaction Time",
  "Select transaction time": "Select transaction time",
  "Transaction Amount": "Transaction Amount",
  "Enter Transaction Amount, Example: 1.50": "Enter Transaction Amount, Example: 1.50",
  "Select payment method": "Select payment method",
  "Cashless (e-Wallet / DuitNow QR)": "Cashless (e-Wallet / DuitNow QR)",
  "Paywave (Tap with Debit/Credit Card)": "Paywave (Tap with Debit/Credit Card)",
  "Request as": "Request as",
  "Individual": "Individual",
  "Company": "Company",
  "ID Type": "ID Type",
  "Select ID Type": "Select ID Type",
  "Company Name": "Company Name",
  "Phone": "Phone",
  "Address": "Address",
  "City": "City",
  "Postcode": "Postcode",
  "Request E-Invoice": "Request E-Invoice",
  "Request e-Invoice": "Request e-Invoice",
  "e-Invoice Validation Link": "e-Invoice Validation Link",
  "Credit Card": "Credit Card",
  "Credit Card Number": "Credit Card Number",
  "Credit Card Expiry Month": "Credit Card Expiry Month",
  "Credit Card Expiry Year": "Credit Card Expiry Year",
  "Credit Card Securtiy Code": "Credit Card Securtiy Code",
  "Credit Card Holder Name": "Credit Card Holder Name",
  "Settlement Amount": "Settlement Amount",
  "Paid": "Paid",
  "Enable E-Wallet Payment?": "Enable E-Wallet Payment?",
  "Enable DuitNow Payment?": "Enable DuitNow Payment?",
  "Enable Credit Card Terminal Payment?": "Enable Credit Card Terminal Payment?",
  "Transaction date is more than 3 days": "Transaction date is more than 3 days",
  "Select Recurrence Type": "Select Recurrence Type",
  "Multiple Voucher": "Multiple Voucher",
  "Period for giving next voucher (days)": "Period for giving next voucher (days)",
  "General Voucher Code Report": "General Voucher Code Report",
  "Unique Voucher Code Report": "Unique Voucher Code Report",
  "Select Code": "Select Code",
  "Minimum transaction amount to use code cannot be negative": "Minimum transaction amount to use code cannot be negative",
  "Redeem per user must at least 1": "Redeem per user must at least 1",
  "Start date must before end date": "Start date must before end date",
  "Please select the start date and end date": "Please select the start date and end date",
  "Please enter the voucher code": "Please enter the voucher code",
  "Successfully create the voucher code": "Successfully create the voucher code",
  "General Voucher Code": "General Voucher Code",
  "Unique Voucher Code": "Unique Voucher Code",
  "Add Voucher Code": "Add Voucher Code",
  "How many times the voucher code can be used for each user": "How many times the voucher code can be used for each user",
  "Update Version": "Update Version",
  "User profile updated successfully": "User profile updated successfully",
  "Salutation": "Salutation",
  "Nationality": "Nationality",
  "Race": "Race",
  "Gender": "Gender",
  "Update salutation": "Update salutation",
  "Update ID Type": "Update ID Type",
  "Update Address": "Update Address",
  "Update nationality": "Update nationality",
  "Male": "Male",
  "Female": "Female",
  "Update gender": "Update gender",
  "Number of Point cannot be 0": "Number of Point cannot be 0",
  "Token value cannot be 0": "Token value cannot be 0",
  "Activate": "Activate",
  "Deactivate": "Deactivate",
  "Activate User": "Activate User",
  "Deactivate User": "Deactivate User",
  "Are you sure you want to activate the user account?": "Are you sure you want to activate the user account?",
  "Are you sure you want to deactivate the user account?": "Are you sure you want to deactivate the user account?",
  "Your point redemption is successful": "Your point redemption is successful",
  "Point Redemption": "Point Redemption",
  "This redemption has already been completed": "This redemption has already been completed",
  "Transaction Details": "Transaction Details",
  "Please login to redeem point": "Please login to redeem point",
  "Login as {{name}}": "Login as {{name}}",
  "Payment Amount Settings": "Payment Amount Settings",
  "Allow washer pay less than cheapest mode price?": "Allow washer pay less than cheapest mode price?",
  "Allow dryer pay less than minimum price?": "Allow dryer pay less than minimum price?",
  "Drop n Go Settings": "Drop n Go Settings",
  "Allow user pay for specific service only?": "Allow user pay for specific service only?",
  "Display pricing for each service?": "Display pricing for each service?",
  "Delete Voucher": "Delete Voucher",
  "Are you sure you want to delete this voucher?": "Are you sure you want to delete this voucher?",
  "Display in Promotion Page": "Display in Promotion Page",
  "Add Promotion": "Add Promotion",
  "Select Transaction Status": "Select Transaction Status",
  "Give Stamp for Drop n Go Transaction?": "Give Stamp for Drop n Go Transaction?",
  "Display machine capacity?": "Display machine capacity?",
  "External Voucher Code": "External Voucher Code",
  "Import Voucher Code": "Import Voucher Code",
  "Voucher Code Stamp Settings": "Voucher Code Stamp Settings",
  "Upload Date": "Upload Date",
  "Import External Voucher Code": "Import External Voucher Code",
  "Import": "Import",
  "Please select a valid CSV file": "Please select a valid CSV file",
  "Redeemed": "Redeemed",
  "Sales": "Sales",
  "Drop N Go Dashboard": "Drop N Go Dashboard",
  "Total Drop N Go Sales by Month": "Total Drop N Go Sales by Month",
  "Total Drop N Go Sales by Day": "Total Drop N Go Sales by Day",
}


const translationMs = {
  "LOGIN": "LOG MASUK",
  "REGISTER": "DAFTAR",
  "SKIP TO PAYMENT": "LANGKAU KE BAYARAN",
  "Continue as guest": "Teruskan sebagai tetamu",
  "WELCOME": "SELAMAT DATANG",
  "Error": "Ralat",
  "Please enter the correct phone number format. <br /><br /> <small>Example: 0129465628</small>": "Sila masukkan format nombor telefon yang betul. <br /><br /> <small>Contoh: 0129465628</small>",
  "Info": "Maklumat",
  "Please scan QRCode to Login": "Sila mengimbas Kod QR untuk Log Masuk",
  "Forgot Password": "Lupa kata laluan",
  "Seems like you have forgotten your password<br />Create a temporary password?": "Nampaknya anda terlupa kata laluan anda<br />Adakah anda ingin membuat kata laluan sementara?",
  "Cancel": "Batal",
  "Confirm": "Sahkan",
  "Reset Your Password": "Reset kata laluan anda",
  "Enter Your Phone Number / Email Address": "Masukkan Nombor Telefon / Alamat E-mel Anda",
  "Enter Your Email Address": "Masukkan Alamat E-mel Anda",
  "Please enter phone number / email address": "Sila masukkan nomber telefon / alamat e-mel",
  "Please enter email address": "Sila masukkan alamat e-mel",
  "Submit": "Hantar",
  "Please enter a valid phone number": "Sila masukkan nombor telefon yang sah",
  "Please enter a valid email address": "Sila masukkan alamat emel yang sah",
  "Success!": "Berjaya!",
  "You may login using your one time password now.": "Anda boleh log masuk menggunakan kata laluan sekali anda sekarang.",
  "Phone Number": "Nombor telefon",
  "Password": "Kata Laluan",
  "Don't have an account?": "Tidak mempunyai akaun?",
  "Forgot password?": "Lupa kata laluan?",
  "Unable to register without a QRCode": "Tidak dapat mendaftar tanpa Kod QR",
  "Please read and agree to the privacy policies, terms and conditions": "Sila baca dan setuju dengan polisi privasi, terma dan syarat",
  "Password length must be at least 6 characters": "Panjang kata laluan mestilah sekurang-kurangnya 6 huruf",
  "Please enter the confirmation code that was sent to your phone": "Sila masukkan kod pengesahan yang dihantar ke telefon anda",
  "Example: 012xxxxxxx": "Contoh: 012xxxxxxx",
  "Example: 09xxxxxxxx": "Contoh: 09xxxxxxxx",
  "Verification Method": "Kaedah Pengesahan",
  "Name": "Nama",
  "Email": "E-mel",
  "optional": "Tidak wajib diisi",
  "Birth Year": "Tahun lahir",
  "Year": "Tahun",
  "Birth Month": "Bulan Lahir",
  "Month": "Bulan",
  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "Mac",
  "April": "April",
  "May": "Mei",
  "June": "Jun",
  "July": "Julai",
  "Aug": "Ogos",
  "Sept": "Sept",
  "Oct": "Okt",
  "Nov": "Nov",
  "Dec": "Dis",
  "Birth Day": "Hari Lahir",
  "Day": "Hari",
  "OTP": "OTP",
  "OTP Confirmation": "Pengesahan OTP",
  "I agree to the": "Saya setuju dengan",
  "Privacy Policy": "Polisi Privasi",
  "PRIVACY POLICY": "POLISI PRIVASI",
  "and": "dan",
  "Terms": "Terma",
  "Conditions": "Syarat",
  "SEND CODE": "HANTAR KOD",
  "Our One-Time Password (OTP) emails might end up in your spam or junk folder. We kindly ask you to take a moment to check your spam mailbox.": "E-mel Kata Laluan Satu Masa (OTP) kami mungkin berada dalam folder spam atau sampah anda. Kami mohon anda meluangkan sedikit masa untuk menyemak peti mel spam anda.",
  "Already have an account? Login": "Sudah mempunyai akaun? Log masuk",
  "Didn't receive a code?": "Tidak menerima kod?",
  "Resend Code": "Hantar semula Kod",
  "collected": "dikumpulkan",
  "Collect": "Kumpulkan",
  "stamps": "setem",
  "get 1 voucher": "dapatkan 1 baucar",
  "Minimum": "Perbelanjaan minimum",
  "spending to collect each washer stamp": "untuk mengumpulkan setiap setem mesin basuh",
  "spending to collect each dryer stamp": "untuk mengumpulkan setiap setem pengering",
  "spending to collect each stamp": "untuk mengumpulkan setiap setem",
  "Device don't have a camera": "Peranti tidak mempunyai kamera",
  "This is not a valid QRCode": "Ini bukan Kod QR yang sah",
  "Select Camera": "Pilih Kamera",
  "Switch": "Tukar",
  "Camera": "Kamera",
  "Loading": "Memuatkan",
  "Scan the QR code on the machine.": "Imbas Kod QR pada mesin.",
  "Switch Camera": "Tukar Kamera",
  "Off torch light": "Matikan lampu suluh",
  "On torch light": "Hidupkan lampu suluh",
  "switch camera if your camera is not clear": "tukar kamera jika kamera anda tidak jelas",
  "Switch your camera if the display is not clear": "Tukar kamera anda jika paparan tidak jelas",
  "Please allow this webapp to access your camera": "Sila berikan kebenaran untuk aplikasi ini mengakses kamera anda",
  "DISCOUNT": "DISKAUN",
  "Congratulation": "Tahniah",
  "Expired Date": "Tarikh luput",
  "Voucher": "Baucar",
  "Vouchers": "Baucar",
  "Something went wrong": "Hadapi masalah",
  "Stamping Collection": "Koleksi Setem",
  "Total e-Token": "Jumlah Token",
  "Total Wash": "Jumlah Cuci",
  "Total Dry": "Jumlah Kering",
  "Reload": "Tambah nilai",
  "Washer": "Mesin basuh",
  "Dryer": "Pengering",
  "Congratulations!": "Tahniah!",
  "You have completed your Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "Anda telah melengkapkan koleksi setem anda.<br />Pemberian baucar akan diberikan dan koleksi setem anda telah di set semula",
  "You have completed Washer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "Anda telah melengkapkan koleksi setem mesin basuh.<br />Pemberian baucar akan diberikan dan koleksi setem anda telah di set semula",
  "You have completed Dryer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "Anda telah melengkapkan koleksi setem pengering.<br />Pemberian baucar akan diberikan dan koleksi setem anda telah di set semula",
  "Latest News": "Berita Terkini",
  "Transaction History": "Sejarah Transaksi",
  "Stamping": "Setem",
  "Transaction": "Transaksi",
  "News": "Berita",
  "Confirmation": "Pengesahan",
  "Logout Session?": "Sesi Log Keluar?",
  "NO": "TIDAK",
  "OK": "OK",
  "Account": "Akaun",
  "FAQs": "Soalan Lazim",
  "Feedback": "Maklum balas",
  "LOGOUT": "LOG KELUAR",
  "Logout": "Log Keluar",
  "Are you sure you want to submit your feedback?": "Adakah anda pasti mahu menghantar maklum balas anda?",
  "No": "Tidak",
  "Yes": "Ya",
  "Success": "Berjaya",
  "Failed": "Gagal",
  "Pending": "Belum Selesai",
  "Your feedback is submitted successfully": "Maklum balas anda berjaya dihantar",
  "Please fill in all the required fields before submit.": "Sila isi semua ruangan yang diperlukan sebelum menghantar.",
  "Give us your feedback!": "Beri kami maklum balas anda!",
  "Type your name here (optional)": "Taipkan nama anda di sini (Tidak wajib diisi)",
  "required": "diperlukan",
  "Type your number here": "Taipkan nombor anda di sini",
  "Outlet": "Kedai",
  "Select an outlet": "Pilih kedai",
  "Outlet Cleanliness": "Kebersihan Kedai",
  "Washer Machine Performance": "Prestasi Mesin Basuh",
  "Dryer Machine Performance": "Prestasi Mesin Pengering",
  "Customer Service": "Khidmat Pelanggan",
  "Comment": "Komen",
  "Type your comment here (optional)": "Taipkan komen anda di sini (Tidak wajib diisi)",
  "SUBMIT": "HANTAR",
  "Join as a member now!": "Sertailah sebagai ahli sekarang!",
  "Join as a loyalty member now to get more benefits such as vouchers and free machine usage!<br /><br /><strong>Register as loyalty member?</strong>": "Sertailah sebagai ahli sekarang untuk mendapatkan lebih banyak faedah seperti baucar dan penggunaan mesin secara percuma!<br /><br /><strong>Daftar sebagai ahli?</strong>",
  "Maybe Next Time": "Mungkin lain kali",
  "Yes, Register Now": "Ya, Daftar Sekarang",
  "Washer Payment": "Bayaran Mesin Basuh",
  "Dryer Payment": "Bayaran Pengering",
  "Vending Machine Payment": "Bayaran Mesin Layan Diri",
  "Online": "Dalam talian",
  "Offline": "Luar talian",
  "Running": "Berjalan",
  "Vacant": "Kosong",
  "Vending Machine": "Mesin Layan Diri",
  "Discount": "Diskaun",
  "No Vouchers Available": " Tidak Ada Baucar",
  "Payment Method": "Kaedah Pembayaran",
  "Would you like to pay with?": "Anda ingin membayar dengan?",
  "e-Token": "e-Token",
  "E-TOKEN": "E-TOKEN",
  "E-Wallet": "E-Dompet",
  "E-Wallet & Online Banking": "E-Dompet & Perbankan Dalam Talian",
  "Duitnow QR code": "Kod QR Duitnow",
  "PromptPay QR Code": "Kod QR PromptPay",
  "The Duitnow QR code will be downloaded and you need to open your banking app to make the payment. Pay {{ currency }}{{ totalPaymentAmount }} to {{ machineName }}?": "Kod QR Duitnow akan dimuat turun dan anda perlu membuka apl perbankan anda untuk membuat pembayaran. Bayar {{ currency }}{{ totalPaymentAmount }} kepada {{ machineName }}?",
  "Pay": "Bayar",
  "to": "kepada",
  "You may under utilized the voucher.": "Anda kurang menggunakan baucar.",
  "Proceed to pay": "Teruskan membayar",
  "Processing ...": "Memproses ...",
  "You can't pay with e-token if voucher is in used, please remove your voucher to pay with e-token.": "Anda tidak boleh membayar dengan penggunaan e-token jika menggunakan baucar, sila keluarkan baucar anda untuk membayar dengan e-token.",
  "Insufficient e-Tokens": "E-Token tidak mencukupi",
  "Reload your e-token now?": "Tambah nilai e-token anda sekarang?",
  "Reload now!": "Tambah nilai sekarang!",
  "You have": "Anda ada",
  "e-Tokens": "e-Token",
  "Tokens to": "Token kepada",
  "This machine is currently offline, please try again later.": "Mesin ini tiada dalam talian, sila cuba sebentar lagi.",
  "MACHINE": "MESIN",
  "Machine": "Mesin",
  "TYPE": "JENIS",
  "CAPACITY": "KAPASITI",
  "DURATION": "JANGKA MASA",
  "Select Duration": "Pilih Jangka Masa",
  "AMOUNT TO PAY": "JUMLAH BAYARAN",
  "PRICE": "HARGA",
  "VOUCHER": "BAUCAR",
  "Select Voucher >": "Pilih Baucar >",
  "TOTAL": "JUMLAH",
  "PAY": "BAYAR",
  "Remove Voucher": "Keluarkan Baucar",
  "Select Your Voucher": "Pilih Baucar Anda",
  "min": "min",
  "MIN": "MIN",
  "Select Payment Amount": "Pilih Jumlah Pembayaran",
  "Select Water Temperature": "Pilih Suhu Air",
  "Select temperature": "Pilih suhu",
  "Select Temperature": "Pilih suhu",
  "Cold": "Sejuk",
  "Warm": "Suam",
  "Hot": "Panas",
  "e-Tokens to": "e-Token kepada",
  "No Purchase History": "Tiada Sejarah Pembelian",
  "e-tokens": "e-token",
  "No Promotions": "Tiada Promosi",
  "New Password": "Kata laluan baharu",
  "Back": "Kembali",
  "Buy this package?": "Beli pakej ini?",
  "Purchase": "Beli",
  "e-Tokens for": "e-Token dengan",
  "Reload Tokens": "Tambah nilai kepada token",
  "Are you sure you want to purchase {{ tokenAmount }} e-Token for {{ currency }}{{ paymentAmount }}?": "Adakah anda pasti mahu membeli {{ tokenAmount }} e-Token untuk {{ currency }}{{ paymentAmount }}?",
  "Current e-Token": "E-Token Sekarang",
  "Current point": "Point Sekarang",
  "History": "Sejarah",
  "Your profile picture has been updated!": "Gambar profil anda telah dikemas kini!",
  "Please only use png, jpg or jpeg file extension type": "Sila gunakan jenis sambungan fail png, jpg atau jpeg",
  "Please only use image type file": "Sila gunakan fail jenis gambar sahaja",
  "User name has updated successfully!": "Nama pengguna berjaya dikemas kini!",
  "Email Address updated successfully": "E-mel berjaya dikemas kini",
  "Phone number updated successfully": "Nombor telefon dikemas kini",
  "Password must be at least 6 characters": "Kata laluan mestilah sekurang-kurangnya 6 huruf",
  "Password updated successfully": "Kata laluan berjaya dikemas kini",
  "User Settings": "Tetapan Pengguna",
  "Profile Picture": "Gambar profil",
  "Change Password": "Tukar kata laluan",
  "Do you want to submit your feedback?": "Adakah anda ingin menghantar maklum balas anda?",
  "Thank You!": "Terima Kasih!",
  "Thank you for using our services.": "Terima kasih kerana menggunakan perkhidmatan kami.",
  "BACK TO HOMEPAGE": "KEMBALI KE HALAMAN UTAMA",
  "How to pay?": "Bagaimana untuk membayar?",
  "Step 1": "Langkah 1",
  "After scan the QR code on the machine, select either register new account, login your account or skip to payment.": "Setelah mengimbas kod QR pada mesin, pilih sama ada daftar akaun baru, log masuk akaun anda atau langkau ke pembayaran.",
  "Step 2-1": "Langkah 2-1",
  "For Dryer – Select your desired duration. Different duration will have different prices.": "Untuk Pengering - Pilih jangka masa yang anda inginkan. Tempoh yang berbeza akan mempunyai harga yang berbeza.",
  "Step 2-2": "Langkah 2-2",
  "For Washer – Select your desired water temperature. Different water temperature will have different prices.": "Untuk Mesin Basuh - Pilih suhu air yang anda inginkan. Suhu air yang berbeza akan mempunyai harga yang berbeza.",
  "Step 3": "Langkah 3",
  "For login user, Click on ‘Select Voucher’ to select your voucher.": "Untuk pengguna log masuk, Klik pada ‘Pilih Baucar’ untuk memilih baucar anda.",
  "Step 4": "Langkah 4",
  "Click on ‘PAY’ button to pay. For login user, select your payment method to pay.": "Klik butang ‘BAYAR’ untuk membayar. Untuk pengguna log masuk, pilih kaedah pembayaran anda untuk membayar.",
  "Step 5": "Langkah 5",
  "After confirm the price and machine details, click on ‘OK’ button to pay.": "Selepas mengesahkan harga dan butiran mesin, klik butang ‘OK’ untuk membayar.",
  "How to reload your e-Token?": "Bagaimana tambah nilai e-Token anda?",
  'Click on the "Reload" button.': 'Klik pada butang "Tambah Nilai".',
  "Select the package that you wish to purchase.": "Pilih pakej yang ingin anda beli.",
  'Click on "Purchase" as confirmation before payment page.': 'Klik pada "Beli" sebagai pengesahan sebelum halaman pembayaran.',
  "Is e-token can be refund/transfer back to e-wallet?": "Adakah e-token boleh dipulangkan/pindah semula ke e-dompet?",
  "Why can't I applied my voucher?": "Mengapakah saya tidak boleh menggunakan baucar saya?",
  "When there is a Happy Hour Promotion is on going, you are unable to apply your voucher temporarily.": "Setiap kali promosi sedang berlangsung, anda tidak dapat menggunakan baucar anda.",
  "How to apply my voucher?": "Bagaimanakah mengguna baucar saya?",
  'Click on the "Select Voucher" button.': 'Klik pada butang "Pilih Baucar".',
  "Select the voucher that you wish to apply.": "Pilih baucar yang ingin anda gunakan.",
  'Click on "Pay" once you have verified the voucher is successfully applied.': 'Klik "Bayar" setelah anda mengesahkan baucar berjaya digunakan.',
  "Step 2": "Langkah 2",
  "Language has updated successfully!": "Bahasa berjaya dikemas kini!",
  "Change Language": "Tukar Bahasa",
  "Language": "Bahasa",
  "Select language": "Pilih Bahasa",
  "Referral Code": "Kod Rujukan",
  "Copied!": "Disalin!",
  "Inviting friends to get more benefits!": "Jemput rakan-rakan untuk mendapatkan lebih banyak faedah!",
  "Would you like to share your referral code to your friends & family?": "Adakah anda ingin berkongsi kod rujukan anda kepada rakan & keluarga anda?",
  "Refer a friend and get": "Rujuk rakan dan dapatkan",
  "Share the love to your friends & family?": "Kongsi kasih sayang kepada rakan & keluarga anda?",
  "voucher": "baucar",
  "token": "token",
  "stamp": "setem",
  "washer stamp": "setem mesin basuh",
  "dryer stamp": "setem pengering",
  "Learn More": "Ketahui Lebih Lanjut",
  "Welcome Gift": "Hadiah Selamat Datang",
  "Share Your Referral Code Now": "Kongsi Kod Rujukan Anda Sekarang",
  "Birthday Gift for You": "Hadiah Hari Lahir untuk Anda",
  "Let's Pay with E-Token": "Marilah Bayar dengan E-Token",
  "Collect 10 Stamps and Get Voucher": "Kumpul 10 Setem dan Dapatkan Baucar",
  "The voucher will be given if you registered your account successfully.": "Baucar akan diberikan jika anda berjaya mendaftar akaun anda.",
  "There is no expiration date for this voucher.": "Tiada tarikh luput bagi baucar ini.",
  "The voucher can be used for dryer machine only.": "Baucar boleh digunakan untuk mesin pengering sahaja.",
  "The voucher can be used for washer machine only.": "Baucar boleh digunakan untuk mesin basuh sahaja.",
  "The voucher can be used for Drop n Go transaction only.": "Baucar boleh digunakan untuk transaksi Drop n Go sahaja.",
  "The voucher can be used for vending transaction only.": "Baucar hanya boleh digunakan untuk transaksi mesin layan diri.",
  "The voucher can be used for detergent vending transaction only.": "Baucar hanya boleh digunakan untuk transaksi mesin layan diri detergen.",
  "The voucher can be used for car wash transaction only.": "Baucar hanya boleh digunakan untuk transaksi cuci kereta.",
  "The voucher can be used for washer machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin basuh atau transaksi Drop n Go.",
  "The voucher can be used for dryer machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin pengering atau transaksi Drop n Go.",
  "The voucher can be used for dryer or washer machine.": "Baucar boleh digunakan untuk mesin pengering atau mesin basuh.",
  "The voucher can be used for washer machine, dryer machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin pengering atau transaksi Drop n Go.",
  "The voucher can be used for washer machine or vending machine transaction.": "Baucar boleh digunakan untuk mesin basuh atau mesin layan diri.",
  "The voucher can be used for washer machine or detergent vending machine transaction.": "Baucar boleh digunakan untuk mesin basuh atau mesin layan diri detergen.",
  "The voucher can be used for washer machine or car wash transaction.": "Baucar boleh digunakan untuk mesin basuh atau cuci kereta.",
  "The voucher can be used for dryer machine or vending machine transaction.": "Baucar boleh digunakan untuk mesin pengering atau mesin layan diri.",
  "The voucher can be used for dryer machine or detergent vending machine transaction.": "Baucar boleh digunakan untuk mesin pengering atau mesin layan diri detergen.",
  "The voucher can be used for dryer machine or car wash transaction.": "Baucar boleh digunakan untuk mesin pengering atau cuci kereta.",
  "The voucher can be used for vending machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin layan diri atau transaksi Drop n Go.",
  "The voucher can be used for detergent vending machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin layan diri detergen atau transaksi Drop n Go.",
  "The voucher can be used for car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk cuci kereta atau transaksi Drop n Go.",
  "The voucher can be used for vending machine or detergent vending machine transaction.": "Baucar boleh digunakan untuk mesin layan diri atau mesin layan diri detergen.",
  "The voucher can be used for vending machine or car wash transaction.": "Baucar boleh digunakan untuk mesin layan diri atau cuci kereta.",
  "The voucher can be used for detergent vending machine or car wash transaction.": "Baucar boleh digunakan untuk mesin layan diri detergen atau cuci kereta.",
  "The voucher can be used for washer machine, dryer machine or vending machine transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin pengering atau mesin layan diri.",
  "The voucher can be used for washer machine, dryer machine or detergent vending machine transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin pengering atau mesin layan diri detergen.",
  "The voucher can be used for washer machine, dryer machine or car wash transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin pengering atau cuci kereta.",
  "The voucher can be used for washer machine, vending machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin layan diri atau transaksi Drop n Go.",
  "The voucher can be used for washer machine, detergent vending machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin layan diri detergen atau transaksi Drop n Go.",
  "The voucher can be used for washer machine, car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin basuh, cuci kereta atau transaksi Drop n Go.",
  "The voucher can be used for washer machine, vending machine or detergent vending transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin layan diri atau mesin layan diri detergen.",
  "The voucher can be used for washer machine, vending machine or car wash transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin layan diri atau cuci kereta.",
  "The voucher can be used for washer machine, detergent vending machine or car wash transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin layan diri detergen atau cuci kereta.",
  "The voucher can be used for dryer machine, vending machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin pengering, mesin layan diri atau transaksi Drop n Go.",
  "The voucher can be used for dryer machine, detergent vending machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin pengering, mesin layan diri detergen atau transaksi Drop n Go.",
  "The voucher can be used for dryer machine, car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin pengering, cuci kereta atau transaksi Drop n Go.",
  "The voucher can be used for dryer machine, vending machine or detergent vending machine transaction.": "Baucar boleh digunakan untuk mesin pengering, mesin layan diri atau mesin layan diri detergen.",
  "The voucher can be used for dryer machine, vending machine or car wash transaction.": "Baucar boleh digunakan untuk mesin pengering, mesin layan diri atau cuci kereta.",
  "The voucher can be used for dryer machine, detergent vending machine or car wash transaction.": "Baucar boleh digunakan untuk mesin pengering, mesin layan diri detergen atau cuci kereta.",
  "The voucher can be used for vending machine, detergent vending machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin layan diri, mesin layan diri detergen atau transaksi Drop n Go.",
  "The voucher can be used for vending machine, car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin layan diri, cuci kereta atau transaksi Drop n Go.",
  "The voucher can be used for detergent vending machine, car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin layan diri detergen, cuci kereta atau transaksi Drop n Go.",
  "The voucher can be used for vending machine, detergent vending machine or car wash transaction.": "Baucar boleh digunakan untuk mesin layan diri, mesin layan diri detergen atau cuci kereta.",
  "The voucher can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri atau transaksi Drop n Go.",
  "The voucher can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri atau mesin layan diri detergen.",
  "The voucher can be used for washer machine, dryer machine, vending machine or car wash transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri atau cuci kereta.",
  "The voucher can be used for washer machine, dryer machine, detergent vending machine or car wash transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri detergen atau cuci kereta.",
  "The voucher can be used for washer machine, vending machine, detergent vending machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin layan diri, mesin layan diri detergen atau transaksi Drop n Go.",
  "The voucher can be used for washer machine, vending machine, car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin layan diri, cuci kereta atau transaksi Drop n Go.",
  "The voucher can be used for washer machine, vending machine, detergent vending machine or car wash transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin layan diri, mesin layan diri detergen atau cuci kereta.",
  "The voucher can be used for dryer machine, vending machine, detergent vending machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin pengering, mesin layan diri, mesin layan diri detergen atau transaksi Drop n Go.",
  "The voucher can be used for dryer machine, vending machine, car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin pengering, mesin layan diri, cuci kereta atau transaksi Drop n Go.",
  "The voucher can be used for dryer machine, detergent vending machine, car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin pengering, mesin layan diri detergen, cuci kereta atau transaksi Drop n Go.",
  "The voucher can be used for dryer machine, vending machine, detergent vending machine or car wash transaction.": "Baucar boleh digunakan untuk mesin pengering, mesin layan diri, mesin layan diri detergen atau cuci kereta.",
  "The voucher can be used for vending machine, detergent vending machine, car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin layan diri, mesin layan diri detergen, cuci kereta atau transaksi Drop n Go.",
  "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri, mesin layan diri detergen atau transaksi Drop n Go.",
  "The voucher can be used for washer machine, dryer machine, vending machine, car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri, cuci kereta atau transaksi Drop n Go.",
  "The voucher can be used for washer machine, dryer machine, detergent vending machine, car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri detergen, cuci kereta atau transaksi Drop n Go.",
  "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine or car wash transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri, mesin layan diri detergen atau cuci kereta.",
  "The voucher can be used for washer machine, vending macihne, detergent vending machine, car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin layan diri, mesin layan diri detergen, cuci kereta atau transaksi Drop n Go.",
  "The voucher can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin pengering, mesin layan diri, mesin layan diri detergen, cuci kereta atau transaksi Drop n Go.",
  "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "Baucar boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri, mesin layan diri detergen, cuci kereta atau transaksi Drop n Go.",
  "When you applied the voucher during payment, it will give you": "Apabila anda menggunakan baucar semasa pembayaran, ia akan memberi anda",
  "discount.": "diskaun.",
  "When promotion is on going, the voucher is not applicable.": "Apabila promosi sedang berjalan, baucar tidak boleh diguna.",
  "The voucher cannot be used if your payment method is E-Token.": "Baucar tidak boleh digunakan jika kaedah pembayaran anda ialah E-Token.",
  "Your referral code can be found in user settings page.": "Kod rujukan anda boleh didapatkan dalam halaman tetapan pengguna.",
  "You can get": "Anda boleh dapatkan",
  "stamp for the reward.": "setem sebagai ganjaran.",
  "e-token for the reward.": "e-token sebagai ganjaran.",
  "e-token based on transaction payment amount for the reward.": "e-token berdasarkan jumlah pembayaran transaksi sebagai ganjaran.",
  "for the reward.": "sebagai ganjaran.",
  "based on transaction payment amount for the reward.": "berdasarkan jumlah pembayaran transaksi sebagai ganjaran.",
  "You can get a voucher for the reward": "Anda boleh mendapatkan baucar",
  "which have": "yang mempunyai",
  "it can be used for dryer machine only.": "ia boleh digunakan untuk mesin pengering sahaja.",
  "it can be used for washer machine only.": "ia boleh digunakan untuk mesin basuh sahaja.",
  "it can be used for Drop n Go transaction only.": "ia boleh digunakan untuk transaksi Drop n Go sahaja.",
  "it can be used for vending machine only.": "ia hanya boleh digunakan untuk mesin layan diri.",
  "it can be used for car wash transaction only.": "ia hanya boleh digunakan untuk transaksi cuci kereta.",
  "it can be used for detergent vending machine only.": "ia hanya boleh digunakan untuk mesin layan diri detergen.",
  "it can be used for dryer or washer machine.": "ia boleh digunakan untuk pengering atau mesin basuh.",
  "it can be used for dryer machine or Drop n Go transaction.": "ia boleh digunakan untuk pengering atau transaksi Drop n Go.",
  "it can be used for washer machine or Drop n Go transaction.": "ia boleh digunakan untuk mesin basuh atau transaksi Drop n Go.",
  "it can be used for washer machine, dryer machine or Drop n Go transaction.": "ia boleh digunakan untuk mesin basuh, pengering atau transaksi Drop n Go.",
  "it can be used for washer machine, dryer machine or vending machine transaction.": "ia boleh digunakan untuk mesin basuh, mesin pengering atau mesin layan diri.",
  "it can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "ia boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri atau transaksi Drop n Go.",
  "washer stamp for the reward.": "setem mesin basuh sebagai ganjaran.",
  "dryer stamp for the reward.": "setem pengering sebagai ganjaran.",
  "washer stamp and": "setem pencuci dan",
  "cleanproBirthdayShortDesc": "Tebus baucar hari jadi bernilai {{ birthdayVoucherAmount }} kredit pada hari istimewa anda dengan Cleanpro Plus. Klik  untuk maklumat lebih lanjut.",
  'When you click on "PAY" button on the payment page, you can choose either using E-wallet or E-token to pay.': 'Apabila anda mengklik butang "BAYAR" pada halaman pembayaran, anda boleh memilih sama ada menggunakan E-dompet atau E-token untuk membayar.',
  "When you using your voucher during payment, you will be unable to pay with E-token.": "Apabila anda menggunakan baucar anda semasa pembayaran, anda tidak dapat membayar dengan E-token.",
  "You can reload your E-token by clicking the reload button in the stamping page and select the package to purchase.": "Anda boleh tambah nilai E-token anda dengan mengklik butang tambah nilai dalam halaman setem dan pilih pakej untuk dibeli.",
  "You can reload your E-token by clicking the reload button in the home page and select the package to purchase.": "Anda boleh tambah nilai E-token anda dengan mengklik butang tambah nilai dalam laman utama dan pilih pakej untuk dibeli.",
  "You can view your E-token reload history and E-token transaction history in transaction page.": "Anda boleh melihat sejarah tambah nilai E-token dan sejarah transaksi E-token anda dalam halaman transaksi.",
  "You can view your E-token transaction history in transaction page.": "Anda boleh melihat sejarah transaksi E-token anda dalam halaman transaksi.",
  "Using either dryer machine or washer machine with the minimum spending of": "Menggunakan sama ada mesin pengering atau mesin basuh dengan perbelanjaan minimum",
  "to collect one stamp.": "untuk mengumpulkan satu setem.",
  "The voucher will be given if you have collected 10 stamps.": "Baucar akan diberikan sekiranya anda telah mengumpulkan 10 keping setem.",
  "Using dryer machine with the minimum spending of": "Menggunakan mesin pengering dengan perbelanjaan minimum",
  "Using washer machine with the minimum spending of": "Menggunakan mesin basuh dengan perbelanjaan minimum",
  "to collect one dryer stamp.": "untuk mengumpulkan satu setem pengering.",
  "to collect one washer stamp.": "untuk mengumpulkan satu setem mesin basuh.",
  "The voucher will be given if you have collected 10 dryer stamps or 10 washer stamps.": "Baucar akan diberikan jika anda telah mengumpulkan 10 setem pengering atau 10 setem mesin basuh.",
  "For the voucher given by the dryer stamps,": "Bagi baucar yang diberikan oleh setem pengering,",
  "For the voucher given by the washer stamps,": "Bagi baucar yang diberikan oleh setem mesin basuh,",
  "When promotion is on going, all the vouchers is not applicable.": "Apabila promosi sedang berjalan, semua baucar tidak boleh digunakan.",
  "All the vouchers cannot be used if your payment method is E-Token.": "Semua baucar tidak boleh digunakan jika kaedah pembayaran anda adalah E-Token.",
  "Description": "Penerangan",
  "Refer Friends": "Rujuk Kawan",
  "View our guideline": "Lihat garis panduan kami",
  "When a friend / family register using your referral code, and completed a transaction with a minimum spending of": "Apabila rakan / keluarga mendaftar menggunakan kod rujukan anda, dan menyelesaikan transaksi dengan perbelanjaan minimum",
  ", you will be rewarded automatically.": ", anda akan diberi ganjaran secara automatik.",
  "One user only allow to have": "Setiap pengguna hanya membenarkan untuk memiliki",
  "referrals.": "rujukan.",
  "Confirmation Password": "Pengesahan Kata Laluan",
  "Password and confirmation password should be same.": "Kata laluan dan pengesahan kata laluan hendaklah sama.",
  "You haven't applied your voucher": "Anda mempunyai baucar yang belum digunakan",
  "Would you like to continue your payment without using your voucher?": "Adakah anda pasti ingin meneruskan pembayaran tanpa menggunakan baucar?",
  "Continue": "Teruskan",
  "Apply voucher": "Gunakan baucar",
  "Transfer": "Pemindahan",
  "Transfer Tokens": "Token Penmindahan",
  "Please fill in the phone number": "Sila isikan nombor telefon",
  "Please fill in the email": "Sila isikan emel",
  "Please enter the phone number / email that you want to transfer to": "Sila masukkan nombor telefon / e-mel yang anda ingin pindahkan",
  "Please fill in the transfer amount": "Sila isikan jumlah pemindahan",
  "Transfer amount should be more than 0 and less than your current e-Token": "Jumlah pemindahan hendaklah lebih daripada 0 dan kurang daripada e-Token anda",
  "Please enter your password": "Sila masukkan kata laluan anda",
  "Member ID": "ID ahli",
  "E-Token Transfer Amount": "Jumlah Pemindahan E-Token",
  "Please confirm the details before proceeding": "Sila sahkan butiran sebelum meneruskan",
  "Transfer From": "Pemindahan Dari",
  "Transfer To": "Pemindahan Kepada",
  "Transfer Amount": "Jumlah Pemindahan",
  "Transfer Successfully!": "Pemindahan Berjaya!",
  "Transfer Time": "Masa Pemindahan",
  "Token": "Token",
  "Done": "Selesai",
  "Next": "Seterusnya",
  "Enter Password": "Masukkan kata laluan",
  "Transfer E-Token Amount": "Pindahkan Amaun E-Token",
  "User not found": "Pengguna tidak dijumpai",
  "Password is incorrect": "Kata laluan salah",
  "Please go to your account setting and reset your password": "Sila pergi ke tetapan akaun anda dan tetapkan semula kata laluan anda",
  "Only up to last 3 months transaction history": "Hanya sejarah transaksi 3 bulan lepas",
  "Reload History": "Sejarah Tambah Nilai",
  "Transfer History": "Sejarah Pemindahan",
  "{{ point }} History": "Sejarah {{ point }}",
  "Only up to last 3 months reload history": "Hanya sejarah tambah nilai 3 bulan lepas",
  "Only up to last 3 months transfer history": "Hanya sejarah pemindahan 3 bulan lepas",
  "Only up to last 3 months {{ point }} history": "Hanya sejarah {{ point }} 3 bulan lepas",
  "Only up to last 3 months laundry pass history": "Hanya sejarah pas dobi 3 bulan lepas",
  "If require urgent response, please contact us through whatapp": "Jika memerlukan maklum balas segera, sila hubungi kami melalui whatsapp",
  "Please scan the QR code again": "Sila imbas kod QR sekali lagi",
  "Home": "Laman Utama",
  "Quick": "Cepat",
  "Super": "Super",
  "Premium": "Premium",
  "All users will have infinite referrals.": "Semua pengguna akan mempunyai rujukan yang tidak terhingga.",
  "Collect 10 stamps to get 1 Voucher": "Kumpulkan 10 setem untuk dapatkan 1 baucar",
  "The voucher is only for customer use only, not for sale.": "Baucar itu hanya untuk kegunaan pelanggan sahaja, bukan untuk dijual.",
  "Outlet is currently offline, please try again later": "Kedai sedang di luar talian, sila cuba sebentar lagi",
  "The voucher will be given if you completed a transaction with a minimum spending of": "Baucar akan diberikan jika anda menyelesaikan transaksi dengan perbelanjaan minimum",
  "The birthday voucher will be given on the first day of your birthday month.": "Baucar hari jadi akan diberikan pada hari pertama bulan hari lahir anda.",
  "The voucher only will be given if you have exceed spending amount of": "Baucar hanya akan diberikan jika anda mempunyai jumlah perbelanjaan sebanyak",
  "Pay with KiplePay": "Bayar dengan KiplePay",
  "Pay with Scan2Pay": "Bayar dengan Scan2Pay",
  "Pay with Razer": "Bayar dengan Razer",
  "Pay with HitPay": "Bayar dengan HitPay",
  "Pay with Duitnow QR": "Bayar dengan Duitnow QR",
  "Pay with PagBank": "Bayar dengan PagBank",
  "Pay with PromptPay QR": "Bayar dengan PromptPay QR",
  "Pay with Card": "Bayar dengan Kad",
  "Pay with PayWay": "Bayar dengan PayWay",
  "DISCOUNT CODE": "KOD DISKAUN",
  "Enter code >": "Masukkan kod >",
  "Enter Discount Code": "Masukkan Kod Diskaun",
  "Remove Code": "Keluarkan kod",
  "Discount Code": "Kod diskaun",
  "Close": "Tutup",
  "Please fill in your email address": "Sila isikan alamat e-mel anda",
  "Notification": "Pemberitahuan",
  "Do you want to receive notification when wash cycle done?": "Adakah anda mahu menerima pemberitahuan apabila kitaran basuh selesai?",
  "pay extra": "bayar tambahan",
  "Email Address": "Alamat emel",
  "Please fill in your phone number": "Sila isikan nombor telefon anda",
  "Invalid Phone Number": "Nombor Telefon Tidak Sah",
  "Washing Complete": "Mencuci Selesai",
  "Drying Complete": "Pengeringan Selesai",
  "The voucher will be given if you registered your account successfully, but it only can be used when your total transaction spending reach": "Baucar akan diberikan jika anda berjaya mendaftar akaun anda, tetapi ia hanya boleh digunakan apabila jumlah perbelanjaan transaksi anda mencapai",
  "and above.": "dan ke atas.",
  "This voucher is not applicable": "Baucar ini tidak berkenaan",
  "Finish in": "Selesai dalam",
  "Need to refresh to update": "Perlu memuat semula untuk mengemas kini",
  "It's indicative and may change based on washer load": "Ia menunjukkan dan mungkin berubah berdasarkan beban mesin basuh",
  "We'll let you know when it's ready to pick up": "Kami akan memberitahu anda apabila ia sedia untuk diambil",
  "FREE": "PERCUMA",
  "Enter voucher code (if got any)": "Masukkan kod baucar (jika ada)",
  "Please fill in the voucher code": "Sila isikan kod baucar",
  "Available On": "Tersedia pada",
  "Apply": "Guna",
  "Enter a code": "Masukkan kod",
  "Input Promo Code": "Masukkan Kod Promosi",
  "Voucher is redeemed successfully!": "Baucar berjaya ditebus!",
  "Not available": "Tidak tersedia",
  "Unable to register": "Tidak dapat mendaftar",
  "Drop n Go Service": "Perkhidmatan Drop n Go",
  "Select Mode": "Pilih Mod",
  "Quantity": "Kuantiti",
  "Pack": "Pek",
  "Add more": "Tambah lagi",
  "Select Size": "Pilih Saiz",
  "Select Services": "Pilih Perkhidmatan",
  "Are you sure to delete the item?": "Adakah anda pasti akan memadamkan item tersebut?",
  "Delete": "Padam",
  "Your Duitnow QR code": "Kod QR Duitnow anda",
  "Your PromptPay QR code": "Kod QR PromptPay anda",
  "How to pay using Duitnow QR code?": "Bagaimanakah menggunakan kod QR Duitnow untuk membayar?",
  "How to pay using PromptPay QR code?": "Bagaimanakah menggunakan kod QR PromptPay untuk membayar?",
  "Launch": "Pelancaran",
  "Launch your preferred Mobile Banking or eWallet app.": "Lancarkan aplikasi Perbankan Mudah Alih atau eWallet pilihan anda.",
  "Scan QR code from Gallery": "Imbas kod QR dari Galeri",
  "Choose DuitNow QR from your gallery.": "Pilih QR DuitNow daripada galeri anda.",
  "Confirm payment details and pay.": "Sahkan butiran pembayaran dan bayar.",
  "Receive payment confirmation.": "Terima pengesahan pembayaran.",
  "expiring on": "tamat tempoh pada",
  "Expired on": "Tamat tempoh pada",
  "based on transaction payment amount": "berdasarkan jumlah pembayaran transaksi",
  "Join as our": "Sertai sebagai",
  "Loyalty Member": "Ahli Kesetiaan",
  "now to get more reward": "kami sekarang untuk mendapatkan lebih banyak ganjaran",
  "Payment amount should be greater than 0": "Amaun pembayaran hendaklah lebih besar daripada 0",
  // admin portal
  "Dashboard": "Papan pemuka",
  "Report": "Laporan",
  "Store Performance": "Prestasi Kedai",
  "User Performance": "Prestasi Pengguna",
  "Voucher Redemption": "Penebusan Baucar",
  "Token Report": "Laporan Token",
  "SMS Report": "Laporan SMS",
  "Discount Code Report": "Laporan Kod Diskaun",
  "User Details": "Butiran Pengguna",
  "User Compensation": "Pampasan Pengguna",
  "Voucher Settings": "Tetapan Baucar",
  "Token Settings": "Tetapan Token",
  "Referral Settings": "Tetapan Rujukan",
  "Voucher Code": "Kod Baucar",
  "Customize Color": "Sesuaikan Warna",
  "User Migration": "Migrasi Pengguna",
  "Back To": "Kembali ke",
  "Eligibility": "Kelayakan",
  "If ticked, the voucher will have expired date": "Jika ditanda, baucar akan mempunyai tarikh luput",
  "Expiry": "Luput",
  "If ticked, the voucher can apply to washer machine transaction": "Jika ditanda, baucar boleh digunakan untuk transaksi mesin basuh",
  "Washer Use": "Penggunaan Pencuci",
  "If ticked, the voucher can apply to dryer machine transaction": "Jika ditanda, baucar boleh digunakan untuk transaksi mesin pengering",
  "Dryer Use": "Penggunaan Pengering",
  "If ticked, the voucher can apply to Drop n Go transaction": "Jika ditanda, baucar boleh digunakan untuk transaksi Drop n Go",
  "Package Use": "Penggunaan Pakej",
  "If ticked, the voucher can apply to vending machine transaction": "Jika ditanda, baucar boleh digunakan untuk transaksi mesin layan diri",
  "Vending Use": "Penggunaan Mesin Layan Diri",
  "If ticked, the voucher can apply to detergent vending machine transaction": "Jika ditanda, baucar boleh digunakan untuk transaksi mesin layan diri detergen",
  "Detergent Use": "Penggunaan Mesin Layan Diri Detergen",
  "If ticked, the voucher can apply to car wash transaction": "Jika ditanda, baucar boleh digunakan untuk transaksi cuci kereta",
  "Car Wash Use": "Penggunaan Cuci Kereta",
  "Voucher Lifespan": "Jangka Hayat Baucar",
  "days": "hari",
  "Discount Type": "Jenis Diskaun",
  "Select a discount type": "Pilih jenis diskaun",
  "Flat": "Rata",
  "Rate": "Kadar",
  "Voucher Title": "Tajuk Baucar",
  "Voucher Description": "Penerangan Baucar",
  "Voucher Amount": "Nilai Baucar",
  "CONFIRM": "SAHKAN",
  "If ticked, the system will give voucher to user who completed washer stamp collection": "Jika ditanda, sistem akan memberikan baucar kepada pengguna yang telah melengkapkan pengumpulan setem mesin basuh",
  "If ticked, the system will give voucher to user who completed dryer stamp collection": "Jika ditanda, sistem akan memberikan baucar kepada pengguna yang telah melengkapkan pengumpulan setem pengering",
  "If ticked, the user only can get/use the voucher after make a transaction": "Jika ditanda, pengguna hanya boleh mendapatkan/menggunakan baucar selepas membuat transaksi",
  "Pay And Get Voucher": "Bayar Untuk Dapatkan Baucar",
  "Pay And Use Code": "Bayar Untuk Guna Kod",
  "If ticked, the system will only give the voucher to user after the user make a transaction": "Jika ditanda, sistem hanya akan memberikan baucar kepada pengguna selepas pengguna membuat transaksi",
  "If ticked, the system will give voucher to user who completed registration process": "Jika ditanda, sistem akan memberikan baucar kepada pengguna yang telah menyelesaikan proses pendaftaran",
  "If ticked, the system will give voucher to user on their birthday month": "Jika ditanda, sistem akan memberikan baucar kepada pengguna pada bulan hari lahir mereka",
  "If ticked, the system will give voucher to user who completed stamp collection": "Jika ditanda, sistem akan memberikan baucar kepada pengguna yang telah melengkapkan kutipan setem",
  "Minimum Payment Amount To Get/Use Register Voucher": "Jumlah Bayaran Minimum Untuk Mendapat/Menggunakan Baucar Daftar",
  "Voucher Method": "Kaedah Baucar",
  "Select a voucher method": "Pilih kaedah baucar",
  "The user directly get the voucher after register but only can use it after make transaction": "Pengguna terus mendapat baucar selepas mendaftar tetapi hanya boleh menggunakannya selepas membuat transaksi",
  "The user only can get voucher after make a transaction": "Pengguna hanya boleh mendapatkan baucar selepas membuat transaksi",
  "Minimum Payment Amount To Get Birthday Voucher": "Jumlah Bayaran Minimum Untuk Mendapat Baucar Hari Lahir",
  "Minimum Payment Amount To Use Discount Code": "Jumlah Bayaran Minimum Untuk Menguna Kod Diskaun",
  "Outlets": "Outlet",
  "E-Payment Sales": "Jualan E-Bayaran",
  "Number of stamps granted to users": "Bilangan setem yang diberikan kepada pengguna",
  "Total number of stamps granted": "Jumlah bilangan setem yang diberikan",
  "Registered Users": "Pengguna Berdaftar",
  "Stamps": "Setem",
  "Referral": "Rujukan",
  "Register": "Daftar",
  "Top Outlets": "Outlet Teratas",
  "Users": "Pengguna",
  "Sort by": "Disusun mengikut",
  "Top Users": "Pengguna Teratas",
  "User name": "Nama pengguna",
  "Number": "Nombor",
  "Spending": "Perbelanjaan",
  "Number of registered users": "Bilangan pengguna berdaftar",
  "Number of voucher given to users": "Bilangan baucar yang diberikan kepada pengguna",
  "Total number of voucher given": "Jumlah bilangan baucar yang diberikan",
  "Voucher Type": "Jenis Baucar",
  "Voucher Value": "Nilai Baucar",
  "Date": "Tarikh",
  "Discount Code Type": "Jenis Kod Diskaun",
  "Discount Code Amount": "Nilai Kod Diskaun",
  "Number of Redemption": "Bilangan Penebusan",
  "Total Discount Amount": "Jumlah Nilai Diskaun",
  "Select Outlet": "Pilih Outlet",
  "Select Date": "Pilih Tarikh",
  "Select Transaction Date": "Pilih Tarikh Transaksi",
  "Reset": "Tetapkan semula",
  "Download Report": "Muat Turun Laporan",
  "Please fill in the remark": "Sila isikan catatan",
  "Transaction Date": "Tarikh transaksi",
  "Machine Type": "Jenis Mesin",
  "Machine Capacity": "Kapasiti Mesin",
  "Total Amount": "Jumlah amaun",
  "Payment Amount": "Amaun pembayaran",
  "Discount From": "Diskaun Dari",
  "Discount Amount": "Amaun diskaun",
  "Action": "Tindakan",
  "Remark": "Catatan",
  "Refund Date": "Tarikh Bayaran Balik",
  "Refund": "Bayaran balik",
  "Purchase Date": "Tarikh Pembelian",
  "e-Token Purchased (Tokens)": "e-Token Dibeli (Token)",
  "Bought e-Token using": "Membeli e-Token menggunakan",
  "Transaction ID": "ID Transaksi",
  "Method": "Kaedah",
  "Requery": "Pertanyaan semula",
  "Reward Date": "Tarikh Ganjaran",
  "Reward Type": "Jenis Ganjaran",
  "Notification Method": "Kaedah Pemberitahuan",
  "Email Preview": "Pratonton E-mel",
  "Message for User": "Mesej untuk Pengguna",
  "SMS will send to user, please enter the message less than 130 characters": "SMS akan dihantar kepada pengguna, sila masukkan mesej kurang daripada 130 aksara",
  "Enter the message to be sent to the user": "Masukkan mesej yang akan dihantar kepada pengguna",
  "Email Address to show on Email Template": "Alamat E-mel untuk ditunjukkan pada Templat E-mel",
  "Input Company Email Address": "Masukkan Alamat E-mel Syarikat",
  "Company Name to show on Email Template": "Nama Syarikat untuk ditunjukkan pada Templat E-mel",
  "Input Company Name": "Masukkan Nama Syarikat",
  "Company Phone No. to show on Email Template": "No. Telefon Syarikat untuk ditunjukkan pada Templat E-mel",
  "Input Company Phone No.": "Input No Telefon Syarikat.",
  "Voucher ID": "ID baucar",
  "Washer Stamp": "Setem Pencuci",
  "Dryer Stamp": "Setem Pengering",
  "e-Token Amount": "Jumlah e-Token",
  "Transfer Date": "Tarikh Pemindahan",
  "Transfer Amount (Token)": "Jumlah Pindahan (Token)",
  "Number (Transfer From)": "Nombor (Pindah Daripada)",
  "Name (Transfer From)": "Nama (Pindah Daripada)",
  "Member ID (Transfer From)": "ID Ahli (Pindah Daripada)",
  "Number (Transfer To)": "Nombor (Pindah Kepada)",
  "Name (Transfer To)": "Nama (Pindah Kepada)",
  "Member ID (Transfer To)": "ID Ahli (Pindah Kepada)",
  "Grant Date": "Tarikh Pemberian",
  "Claim Date": "Tarikh Penggunaan",
  "Member Details Report": "Laporan Butiran Ahli",
  "Transaction Status": "Status Transaksi",
  "Token Reload": "Token Tambah Nilai",
  "Token Transfer": "Pemindahan Token",
  "Voucher History": "Sejarah Baucar",
  "TOKEN": "TOKEN",
  "Message Sent": "Mesej dihantar",
  "Date Sent": "Tarikh Dihantar",
  "Remaining SMS Credit": "Baki Kredit SMS",
  "Store": "Kedai",
  "Total Registered Users": "Jumlah Pengguna Berdaftar",
  "User registered but no transaction record": "Pengguna berdaftar tetapi tiada rekod transaksi",
  "Registered": "Berdaftar",
  "User spending is less than": "Perbelanjaan pengguna kurang dari",
  "Active": "Aktif",
  "User spending is from": "Perbelanjaan pengguna adalah dari",
  "until": "sehingga",
  "Tier 1": "Tahap 1",
  "User spending is": "Perbelanjaan pengguna ialah",
  "and above": "dan ke atas",
  "Tier 2": "Tahap 2",
  "Average spending in each transaction": "Perbelanjaan purata dalam setiap transaksi",
  "Average Spending": "Perbelanjaan Purata",
  "Total number of transactions": "Jumlah bilangan transaksi",
  "Total Transactions": "Jumlah Transaksi",
  "Number of vouchers used in all the transactions": "Bilangan baucar yang digunakan dalam semua transaksi",
  "Voucher Claimed": "Baucar Diguna",
  "Total number of washer machine transactions": "Jumlah bilangan transaksi mesin basuh",
  "Washer Usage": "Penggunaan Pencuci",
  "Total number of dryer machine transactions": "Jumlah bilangan transaksi mesin pengering",
  "Dryer Usage": "Penggunaan Pengering",
  "User Name": "Nama Pengguna",
  "e-Token Spent": "e-Token Dibelanjakan",
  "e-Token Detailed Report": "Laporan Terperinci e-Token",
  "e-Token Purchase History": "Sejarah Pembelian e-Token",
  "Select Purchase Date": "Pilih Tarikh Beli",
  "Outlet Name": "Nama Outlet",
  "Total number of e-token used in all the transactions": "Jumlah bilangan e-token yang digunakan dalam semua transaksi",
  "Total e-Token Collected": "Jumlah e-Token Dikumpul",
  "Total number of e-token used in washer machine transactions": "Jumlah bilangan e-token yang digunakan dalam transaksi mesin basuh",
  "Washer e-Token Collected": "e-Token pencuci Dikumpul",
  "Total number of e-token used in dryer machine transactions": "Jumlah bilangan e-token yang digunakan dalam transaksi mesin pengering",
  "Dryer e-Token Collected": "e-Token pengering Dikumpul",
  "Vending Machine e-Token Collected": "Mesin layan diri e-Token Dikumpul",
  "Purchase History": "Sejarah pembelian",
  "All": "Semua",
  "Most Bought e-Token Package": "Pakej e-Token Paling Banyak Dibeli",
  "for": "untuk",
  "Tokens": "Token",
  "Total Earned from users buying e-Tokens": "Jumlah Diperolehi daripada pengguna yang membeli e-Token",
  "Total e-Tokens Bought from you": "Jumlah e-Token yang Dibeli daripada anda",
  "Join Date": "Tarikh menyertai",
  "Channel": "Saluran",
  "Tier": "Peringkat",
  "Referrer": "Perujuk",
  "Referrals": "Rujukan",
  "Number of transactions for last 7 days": "Bilangan transaksi untuk 7 hari terkini",
  "Number of Usage (in week)": "Bilangan Penggunaan (dalam minggu)",
  "Number of transactions for last 1 month": "Bilangan transaksi untuk 1 bulan lepas",
  "Number of Usage (in month)": "Bilangan Penggunaan (dalam bulan)",
  "Total amount spent in all the transactions": "Jumlah amaun yang dibelanjakan dalam semua transaksi",
  "Total Spent": "Jumlah yang Dibelanjakan",
  "Last Transaction Date": "Tarikh Transaksi Terakhir",
  "Number of vouchers collected": "Bilangan baucar yang dikumpul",
  "Voucher Collected": "Baucar Dikumpul",
  "Number of vouchers used": "Bilangan baucar yang digunakan",
  "Voucher Spent": "Baucar Dibelanjakan",
  "Washer Used": "Pencuci Digunakan",
  "Dryer Used": "Pengering Digunakan",
  "Total number of e-Token spent in all the transactions": "Jumlah bilangan e-Token yang dibelanjakan dalam semua transaksi",
  "Total number of stamps collected": "Jumlah bilangan setem yang dikumpul",
  "Total Stamps": "Jumlah Setem",
  "Select Join Date": "Pilih Tarikh Sertai",
  "Select Grant Date": "Pilih Tarikh Pemberian",
  "Amount": "Amaun",
  "The image size is over 2MB": "Saiz imej melebihi 2MB",
  "Duplicate language selected": "Bahasa pendua dipilih",
  "Are you sure you want to add FAQ?": "Adakah anda pasti mahu menambah Soalan Lazim?",
  "FAQ added successfully": "Soalan lazim berjaya ditambahkan",
  "FAQ Group added successfully": "Kumpulan soalan lazim berjaya ditambahkan",
  "Please provide the faq with the default language": "Sila berikan soalan dengan bahasa lalai",
  "Add FAQ": "Tambah Soalan Lazim",
  "Default Language": "Bahasa Lalai",
  "Select Default Language": "Pilih Bahasa Lalai",
  "Image (Optional)": "Imej (Pilihan)",
  "max": "maks",
  "Question": "Soalan",
  "Select Language": "Pilih Bahasa",
  "Remove": "keluarkan",
  "Answer": "Jawapan",
  "Add Translation": "Tambah Terjemahan",
  "Are you sure you want to add FAQ Group?": "Adakah anda pasti mahu menambah Kumpulan Soalan Lazim?",
  "Please provide the faq group with the default language": "Sila berikan kumpulan soalan dengan bahasa lalai",
  "Add FAQ Group": "Tambah Kumpulan Soalan Lazim",
  "Title": "Tajuk",
  "Title Language": "Bahasa Tajuk",
  "Please fill in the title": "Sila isikan tajuk",
  "Please fill in the description": "Sila isi penerangan",
  "Please fill in the short description": "Sila isi penerangan ringkas",
  "Please select the end date for your news": "Sila pilih tarikh tamat untuk berita anda",
  "Please provide the news with the default language": "Sila berikan berita dengan bahasa lalai",
  "Please provide the banner image": "Sila berikan imej sepanduk",
  "Please provide the news image": "Sila berikan imej berita",
  "Are you sure you want to add news?": "Adakah anda pasti mahu menambah berita?",
  "News added successfully": "Berita berjaya ditambahkan",
  "Please fill in all the required fields before submit": "Sila isi semua medan yang diperlukan sebelum menghantar",
  "Add News": "Tambah Berita",
  "Banner Image": "Imej Sepanduk",
  "News Image": "Imej Berita",
  "Banner": "Sepanduk",
  "aspect ratio": "Nisbah aspek",
  "Image": "Imej",
  "Display in": "Paparkan dalam",
  "Inbox Page": "Halaman Peti Masuk",
  "Promotion Banner": "Sepanduk Promosi",
  "Select Period: (optional)": "Pilih Tempoh: (pilihan)",
  "Short Description": "Penerangan Ringkas",
  "Your theme has been updated successfully": "Tema anda telah berjaya dikemas kini",
  "Default Theme": "Tema Lalai",
  "Change Logo": "Tukar Logo",
  "REMOVE LOGO": "KELUARKAN LOGO",
  "Sms credit used up": "Kredit sms habis",
  "Please top up your sms credit": "Sila tambah nilai kredit sms anda",
  "Please": "Sila",
  "Again": "Semula",
  "Welcome": "Selamat datang",
  "Ranking": "Kedudukan",
  "Select Year": "Pilih Tahun",
  "Missing Field": "Medan Hilang",
  "Please select can be used for which type of transaction": "Sila pilih boleh digunakan untuk jenis transaksi yang mana",
  "Please fill in the start date and end date": "Sila isikan tarikh mula dan tarikh tamat",
  "Discount amount should be more than 0": "Amaun diskaun hendaklah lebih daripada 0",
  "Redeem per user should be more than 0": "Tebus setiap pengguna hendaklah lebih daripada 0",
  "Redeem per day should be more than 0": "Tebus setiap hari hendaklah lebih daripada 0",
  "Your discount code have edited successfully": "Kod diskaun anda telah berjaya diedit",
  "Your discount code have added successfully": "Kod diskaun anda telah berjaya ditambahkan",
  "Delete this entry?": "Padamkan entri ini?",
  "Your discount code have deleted successfully": "Kod diskaun anda telah berjaya dipadamkan",
  "Created Date": "Tarikh Dicipta",
  "Discount code": "Kod diskaun",
  "General Discount Code": "Kod Diskaun Am",
  "Unique Discount Code": "Kod Diskaun Unik",
  "Start Date": "Tarikh mula",
  "End Date": "Tarikh tamat",
  "Redeem Per User": "Tebus Setiap Pengguna",
  "Redeem Per Day": "Tebus Setiap hari",
  "Add Discount Code": "Tambah Kod Diskaun",
  "Generate Discount Code": "Jana Kod Diskaun",
  "No Discount Code": "Tiada Kod Diskaun",
  "Edit Discount Code": "Edit Kod Diskaun",
  "Select Period": "Pilih Tempoh",
  "Redeem per user": "Tebus setiap pengguna",
  "How many times the discount code can be used for each user": "Berapa kali kod diskaun boleh digunakan untuk setiap pengguna",
  "Redeem per day": "Tebus setiap hari",
  "How many times the discount code can be used in one day": "Berapa kali kod diskaun boleh digunakan dalam satu hari",
  "If ticked, the discount code can apply to washer machine transaction": "Jika ditanda, kod diskaun boleh digunakan untuk transaksi mesin basuh",
  "If ticked, the discount code can apply to dryer machine transaction": "Jika ditanda, kod diskaun boleh digunakan untuk transaksi mesin pengering",
  "If ticked, the discount code can apply to Drop n Go transaction": "Jika ditanda, kod diskaun boleh digunakan untuk transaksi Drop n Go",
  "If ticked, the discount code can apply to vending machine transaction": "Jika ditanda, kod diskaun boleh digunakan untuk transaksi mesin layan diri",
  "If ticked, the discount code can apply to detergent vending machine transaction": "Jika ditanda, kod diskaun boleh digunakan untuk transaksi mesin layan diri detergen",
  "If ticked, the discount code can apply to car wash transaction": "Jika ditanda, kod diskaun boleh digunakan untuk transaksi cuci kereta",
  "The user enter the discount code": "Pengguna memasukkan kod diskaun",
  "in the payment page will get": "dalam halaman pembayaran akan mendapat",
  "discount": "diskaun",
  "The discount code only can be used start from {{ start_date }} until {{ end_date }}": "Kod diskaun hanya boleh digunakan bermula dari {{ start_date }} hingga {{ end_date }}",
  "Every user only can use the discount code {{ redeem_per_user }} times": "Setiap pengguna hanya boleh menggunakan kod diskaun {{ redeem_per_user }} kali",
  "Every user only can use {{ redeem_per_user }} discount code from this batch of code": "Setiap pengguna hanya boleh menggunakan {{ redeem_per_user }} kod diskaun daripada kumpulan kod ini",
  "Only {{ redeem_per_day }} transactions can use the discount code in one day": "Hanya {{ redeem_per_day }} transaksi boleh menggunakan kod diskaun dalam satu hari",
  "The discount code only can be used for washer machine": "Kod diskaun hanya boleh digunakan untuk mesin basuh",
  "The discount code only can be used for dryer machine": "Kod diskaun hanya boleh digunakan untuk mesin pengering",
  "The discount code only can be used for Drop n Go transaction": "Kod diskaun hanya boleh digunakan untuk transaksi Drop n Go",
  "The discount code only can be used for vending machine transaction": "Kod diskaun hanya boleh digunakan untuk transaksi mesin layan diri",
  "The discount code only can be used for detergent vending machine transaction": "Kod diskaun hanya boleh digunakan untuk transaksi mesin layan diri detergen",
  "The discount code only can be used for car wash transaction": "Kod diskaun hanya boleh digunakan untuk transaksi cuci kereta",
  "The discount code can be used for washer machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin basuh atau transaksi Drop n Go",
  "The discount code can be used for dryer machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin pengering atau transaksi Drop n Go",
  "The discount code can be used for washer machine, dryer machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin pengering atau transaksi Drop n Go",
  "The discount code can be used for washer or dryer machine": "Kod diskaun boleh digunakan untuk mesin basuh atau pengering",
  "The discount code can be used for washer machine or vending machine transaction": "Kod diskaun boleh digunakan untuk mesin basuh atau mesin layan diri.",
  "The discount code can be used for washer machine or detergent vending machine transaction": "Kod diskaun boleh digunakan untuk mesin basuh atau mesin layan diri detergen.",
  "The discount code can be used for washer machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin basuh atau cuci kereta.",
  "The discount code can be used for dryer machine or vending machine transaction": "Kod diskaun boleh digunakan untuk mesin pengering atau mesin layan diri.",
  "The discount code can be used for dryer machine or detergent vending machine transaction": "Kod diskaun boleh digunakan untuk mesin pengering atau mesin layan diri detergen.",
  "The discount code can be used for dryer machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin pengering atau cuci kereta.",
  "The discount code can be used for vending machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin layan diri atau transaksi Drop n Go.",
  "The discount code can be used for detergent vending machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin layan diri detergen atau transaksi Drop n Go.",
  "The discount code can be used for car wash or Drop n Go transaction": "Kod diskaun boleh digunakan untuk cuci kereta atau transaksi Drop n Go.",
  "The discount code can be used for vending machine or detergent vending machine transaction": "Kod diskaun boleh digunakan untuk mesin layan diri atau mesin layan diri detergen.",
  "The discount code can be used for vending machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin layan diri atau cuci kereta.",
  "The discount code can be used for detergent vending machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin layan diri detergen atau cuci kereta.",
  "The discount code can be used for washer machine, dryer machine or vending machine transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin pengering atau mesin layan diri.",
  "The discount code can be used for washer machine, dryer machine or detergent vending machine transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin pengering atau mesin layan diri detergen.",
  "The discount code can be used for washer machine, dryer machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin pengering atau cuci kereta.",
  "The discount code can be used for washer machine, vending machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin layan diri atau transaksi Drop n Go.",
  "The discount code can be used for washer machine, detergent vending machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin layan diri detergen atau transaksi Drop n Go.",
  "The discount code can be used for washer machine, car wash or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin basuh, cuci kereta atau transaksi Drop n Go.",
  "The discount code can be used for washer machine, vending machine or detergent vending machine transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin layan diri atau mesin layan diri detergen.",
  "The discount code can be used for washer machine, vending machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin layan diri atau cuci kereta.",
  "The discount code can be used for washer machine, detergent vending machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin layan diri detergen atau cuci kereta.",
  "The discount code can be used for dryer machine, vending machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin pengering, mesin layan diri atau transaksi Drop n Go.",
  "The discount code can be used for dryer machine, detergent vending machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin pengering, mesin layan diri detergen atau transaksi Drop n Go.",
  "The discount code can be used for dryer machine, car wash or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin pengering, cuci kereta atau transaksi Drop n Go.",
  "The discount code can be used for dryer machine, vending machine or detergent vending machine transaction": "Kod diskaun boleh digunakan untuk mesin pengering, mesin layan diri atau mesin layan diri detergen.",
  "The discount code can be used for dryer machine, vending machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin pengering, mesin layan diri atau cuci kereta.",
  "The discount code can be used for dryer machine, detergent vending machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin pengering, mesin layan diri detergen atau cuci kereta.",
  "The discount code can be used for vending machine, detergent vending machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin layan diri, mesin layan diri detergen atau transaksi Drop n Go.",
  "The discount code can be used for vending machine, car wash or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin layan diri, cuci kereta atau transaksi Drop n Go.",
  "The discount code can be used for detergent vending machine, car wash or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin layan diri detergen, cuci kereta atau transaksi Drop n Go.",
  "The discount code can be used for vending machine, detergent vending machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin layan diri, mesin layan diri detergen atau cuci kereta.",
  "The discount code can be used for washer machine, dryer machine, vending machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri atau transaksi Drop n Go.",
  "The discount code can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri atau mesin layan diri detergen.",
  "The discount code can be used for washer machine, dryer machine, vending machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri atau cuci kereta.",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri detergen atau cuci kereta.",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin layan diri, mesin layan diri detergen atau transaksi Drop n Go.",
  "The discount code can be used for washer machine, vending machine, car wash or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin layan diri, cuci kereta atau transaksi Drop n Go.",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin layan diri, mesin layan diri detergen atau cuci kereta.",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin pengering, mesin layan diri, mesin layan diri detergen atau transaksi Drop n Go.",
  "The discount code can be used for dryer machine, vending machine, car wash or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin pengering, mesin layan diri, cuci kereta atau transaksi Drop n Go.",
  "The discount code can be used for dryer machine, detergent vending machine, car wash machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin pengering, mesin layan diri detergen, mesin cuci kereta atau transaksi Drop n Go.",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin pengering, mesin layan diri, mesin layan diri detergen atau cuci kereta.",
  "The discount code can be used for vending machine, detergent vending machine, car wash or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin layan diri, mesin layan diri detergen, cuci kereta atau transaksi Drop n Go.",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri, mesin layan diri detergen atau transaksi Drop n Go.",
  "The discount code can be used for washer machine, dryer machine, vending machine, car wash or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri, cuci kereta atau transaksi Drop n Go.",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine, car wash or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri detergen, cuci kereta atau transaksi Drop n Go.",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or car wash transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri, mesin layan diri detergen atau cuci kereta.",
  "The discount code can be used for washer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin layan diri, mesin layan diri detergen, cuci kereta atau transaksi Drop n Go.",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin pengering, mesin layan diri, mesin layan diri detergen, cuci kereta atau transaksi Drop n Go.",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "Kod diskaun boleh digunakan untuk mesin basuh, mesin pengering, mesin layan diri, mesin layan diri detergen, cuci kereta atau transaksi Drop n Go.",
  "The discount code only can be used after user spending {{ currency }} {{ pay_and_use_amount }}": "Kod diskaun hanya boleh digunakan selepas pengguna membelanjakan {{ currency }} {{ pay_and_use_amount }}",
  "Are you sure you want to edit FAQ?": "Adakah anda pasti mahu mengedit Soalan Lazim?",
  "FAQ updated successfully": "Soalan lazim berjaya dikemas kini",
  "Edit FAQ": "Edit Soalan Lazim",
  "Are you sure you want to edit FAQ Group?": "Adakah anda pasti mahu mengedit Kumpulan Soalan Lazim?",
  "FAQ Group updated successfully": "Kumpulan Soalan Lazim berjaya dikemas kini",
  "Edit FAQ Group": "Edit Kumpulan Soalan Lazim",
  "Are you sure you want to edit news?": "Adakah anda pasti mahu mengedit berita?",
  "News edit successfully": "Pengeditan berita berjaya",
  "Edit News": "Edit Berita",
  "All the FAQ under this group will be deleted. Are you sure you want to delete FAQ Group?": "Semua Soalan Lazim di bawah kumpulan ini akan dipadamkan. Adakah anda pasti mahu memadamkan Kumpulan Soalan Lazim?",
  "FAQ Group deleted successfully": "Kumpulan Soalan Lazim berjaya dipadamkan",
  "FAQ List": "Senarai Soalan Lazim",
  "NO FAQ GROUP": "TIADA KUMPULAN FAQ",
  "FAQ Group": "Kumpulan Soalan Lazim",
  "Are you sure you want to delete FAQ?": "Adakah anda pasti mahu memadamkan Soalan Lazim?",
  "FAQ deleted successfully": "Soalan lazim berjaya dipadamkan",
  "NO FAQs": "TIADA Soalan Lazim",
  "FAQ": "Soalan Lazim",
  "Easy": "Mudah",
  "Fast Laundromate": "Cepat Kedai Dobi",
  "Smart Laundry Management System": "Sistem Pengurusan Cucian Pintar",
  "Enter your username and password to login": "Masukkan nama pengguna dan kata laluan anda untuk log masuk",
  "Username": "Nama pengguna",
  "Are you sure you want to delete news?": "Adakah anda pasti mahu memadamkan berita?",
  "News deleted successfully": "Berita berjaya dipadamkan",
  "NO NEWS": "TIADA BERITA",
  "The referral setting has been updated successfully!": "Tetapan rujukan telah berjaya dikemas kini!",
  "Number of Stamp": "Bilangan Setem",
  "Number of Washer Stamp": "Bilangan Setem Pencuci",
  "Number of Dryer Stamp": "Bilangan Setem Pengering",
  "Enable Referral Feature?": "Membolehkan Rujukan?",
  "Are you sure you want to delete the tier setting?": "Adakah anda pasti mahu memadamkan tetapan peringkat?",
  "Minimum referee transaction amount for referrer to get referral rewards": "Minimum amaun transaksi untuk perujuk untuk mendapatkan ganjaran rujukan",
  "Maximum number of reward within this tier": "Bilangan maksimum ganjaran dalam peringkat ini",
  "Maximum number of reward can get from same user": "Bilangan maksimum ganjaran boleh diperoleh daripada pengguna yang sama",
  "Point Grant Type": "Jenis Pemberian Mata",
  "Select Point Grant Type": "Pilih Jenis Pemberian Mata",
  "Token Grant Type": "Jenis Pemberian Token",
  "Select Token Grant Type": "Pilih Jenis Pemberian Token",
  "Add Tier": "Tambah Peringkat",
  "Stamp": "Setem",
  "If ticked, the system will give stamp to user": "Jika ditanda, sistem akan memberikan setem kepada pengguna",
  "If ticked, the system will give e-Token to user": "Jika ditanda, sistem akan memberikan e-Token kepada pengguna",
  "If ticked, the system will give voucher to user": "Jika ditanda, sistem akan memberikan baucar kepada pengguna",
  "Number of E-Token": "Bilangan E-Token",
  "Reward Giveaway": "Pemberian Ganjaran",
  "Which type of reward you want to give to customer?": "Apakah jenis ganjaran anda ingin berikan kepada pelanggan?",
  "For machine uses (required)": "Untuk kegunaan mesin (diperlukan)",
  "leave blank if no expiry date": "biarkan kosong jika tiada tarikh luput",
  "Remarks": "Catatan",
  "Reward": "Ganjaran",
  "Please fill in all the required field. (Title, description, and amount must be more than 0)": "Sila isi semua medan yang diperlukan. (Tajuk, penerangan dan amaun mestilah lebih daripada 0)",
  "Checkbox required": "Kotak semak diperlukan",
  "Must select voucher can be used for washer, dryer or package": "Baucar perlu dipilih boleh digunakan untuk mesin basuh, pengering atau pakej",
  "How many e-token?": "Berapa banyak e-token?",
  "Number of e-Token": "Bilangan e-Token",
  "Token value must be more than 0": "Nilai token mestilah lebih daripada 0",
  "STAMP": "SETEM",
  "Please fill in at least one of the required field": "Sila isikan sekurang-kurangnya satu daripada medan yang diperlukan",
  "The value must be more than 0": "Nilai mestilah lebih daripada 0",
  "How many times rewarded to user": "Berapa kali ganjaran kepada pengguna",
  "Rewarded Times": "Kali Ganjaran",
  "How many times rewarded voucher to user": "Berapa kali ganjaran baucar kepada pengguna",
  "Voucher Rewarded (times)": "Baucar Diberi (kali)",
  "How many times rewarded stamp to user": "Berapa kali ganjaran setem kepada pengguna",
  "Stamps Rewarded (times)": "Setem Diberi (kali)",
  "Total number of washer stamps rewarded to user": "Jumlah bilangan setem pencuci yang diberi kepada pengguna",
  "Washer Stamps Granted (stamp)": "Setem Pencuci Diberikan (setem)",
  "Total number of dryer stamps rewarded to user": "Jumlah bilangan setem pengering yang diberi kepada pengguna",
  "Dryer Stamps Granted (stamp)": "Setem Pengering Diberikan (setem)",
  "How many times rewarded e-Token to user": "Berapa kali ganjaran e-Token kepada pengguna",
  "e-Token Rewarded (times)": "Ganjaran e-Token (kali)",
  "Total number of e-Token rewarded to user": "Jumlah bilangan e-Token yang diberi kepada pengguna",
  "Total e-Token Granted (token)": "Jumlah e-Token Diberikan (token)",
  "Point Rewarded (times)": "Mata Ganjaran (kali)",
  "How many times rewarded point to user": "Berapa kali ganjaran mata kepada pengguna",
  "Total Point Granted (point)": "Jumlah Mata Diberi (mata)",
  "Total number of point rewarded to user": "Jumlah bilangan mata ganjaran kepada pengguna",
  "Point Amount": "Jumlah Mata",
  "Reward History": "Sejarah Ganjaran",
  "Are you sure you want to change how the stamping mechanics works?": "Adakah anda pasti mahu menukar cara mekanik pengecapan berfungsi?",
  "The stamping mechanics setting has updated successfully!": "Tetapan mekanik pengecap telah berjaya dikemas kini!",
  "The voucher setting has been updated successfully!": "Tetapan baucar telah berjaya dikemas kini!",
  "Mechanics Settings": "Tetapan Mekanik",
  "Minimum transaction amount for getting stamp": "Minimum amaun transaksi untuk mendapatkan setem",
  "Select User Stamping Mechanic": "Pilih Mekanik Setem Pengguna",
  "Separated Stamping": "Setem Berpisah",
  "Combined Stamping": "Setem Gabungan",
  "Stamp for?": "Setem untuk?",
  "Both": "Kedua-duanya",
  "Washer Only": "Pencuci Sahaja",
  "Dryer Only": "Pengering Sahaja",
  "Separated Stamping = Different washer and dryer stamp collection. (example: Using Washer will gain 1 washer's stamp, and Dryer will gain 1 dryer stamp)": "Setem Berpisah = Koleksi setem pencuci dan pengering yang berbeza. (contoh: Menggunakan Mesin Cuci akan mendapat 1 setem mesin basuh, dan Pengering akan mendapat 1 setem pengering)",
  "Combined Stamping = Washer and dryer has the same collection. (example: Using Washer or Dryer will gain 1 stamp)": "Setem Gabungan = Mesin basuh dan pengering mempunyai koleksi yang sama. (contoh: Menggunakan Mesin Cuci atau Pengering akan mendapat 1 setem)",
  "Stamp for": "Setem untuk",
  "User will be able to collect both washer stamp and dryer stamp": "Pengguna akan dapat mengumpul kedua-dua setem pencuci dan setem pengering",
  "User will only able to collect Washer stamp": "Pengguna hanya boleh mengumpul setem Pencuci",
  "User will only able to collect Dryer stamp": "Pengguna hanya boleh mengumpul setem Pengering",
  "Registration": "Pendaftaran",
  "Birthday": "Hari jadi",
  "Please choose at least one payment method": "Sila pilih sekurang-kurangnya satu kaedah pembayaran",
  "Please choose at least one member or non-member payment": "Sila pilih sekurang-kurangnya satu pembayaran ahli atau bukan ahli",
  "Are you sure you want to change the payment setting?": "Adakah anda pasti mahu menukar tetapan pembayaran?",
  "The payment setting has updated successfully!": "Tetapan pembayaran telah berjaya dikemas kini!",
  "Invalid input": "Input tidak sah",
  "The price and token must be more than 0": "Harga dan token mestilah lebih daripada 0",
  "Maximum number of purchase must be more than 0": "Bilangan maksimum pembelian mestilah lebih daripada 0",
  "Point amount must be more than 1": "Jumlah mata mestilah lebih daripada 1",
  "Added a new Token Bundle Package": "Menambah Pakej Token baharu",
  "Bundle deleted successfully!": "Pakej Token berjaya dipadamkan!",
  "Reload voucher setting have edited successfully!": "Tetapan baucar tambah nilai telah berjaya diedit!",
  "Added on": "Ditambah pada",
  "remove": "keluarkan",
  "edit": "edit",
  "NO PACKAGES ON SALES": "TIADA PAKEJ UNTUK JUALAN",
  "Point Settings": "Tetapan Mata",
  "Enable Loyalty Point": "Membolehkan Mata",
  "Point Name": "Nama Mata",
  "Number Of Point Equals To": "Bilangan Mata Sama Dengan",
  "If ticked, the point will have expired date": "Jika ditanda, mata itu akan mempunyai tarikh luput",
  "Point Lifespan": "Jangka Hayat Mata",
  "months": "bulan",
  "Minimum Transaction Amount To Get Point": "Jumlah Transaksi Minimum Untuk Mendapat Mata",
  "Point Grant Amount": "Jumlah Pemberian Mata",
  "Point Grant Period": "Tempoh Pemberian Mata",
  "Optional": "Pilihan",
  "Drop n Go Eligibility": "Kelayakan Drop n Go",
  "If ticked, Drop n Go transaction will get the point": "Jika ditanda, transaksi Drop n Go akan mendapat mata",
  "Washer Eligibility": "Kelayakan Pencuci",
  "If ticked, washer transaction will get the point": "Jika ditanda, transaksi mesin basuh akan mendapat mata",
  "Dryer Eligibility": "Kelayakan Pengering",
  "If ticked, dryer transaction will get the point": "Jika ditanda, transaksi pengering akan mendapat mata",
  "Point settings updated successfully!": "Tetapan mata berjaya dikemas kini!",
  "Point Eligibility": "Kelayakan Mata",
  "If ticked, the system will give point to user when user reload token successfully": "Jika ditanda, sistem akan memberikan mata kepada pengguna apabila pengguna memuat semula token berjaya",
  "{{ point_amount }} point will be given after user reload token successfully": "{{ point_amount }} mata akan diberikan selepas pengguna memuat semula token berjaya",
  "Payment Settings": "Tetapan Pembayaran",
  "Select Payment Method": "Pilih Kaedah Pembayaran",
  "Enable E-Payment?": "Membolehkan E-Pembayaran?",
  "Enable Token Currency?": "Membolehkan E-Token?",
  "Enable Cash Payment?": "Membolehkan Pembayaran Tunai?",
  "Enable QR Payment?": "Membolehkan Pembayaran QR?",
  "Member and Non-Member Settings": "Tetapan Ahli dan Bukan Ahli",
  "Enable Member Payment?": "Membolehkan Pembayaran Ahli?",
  "Enable Non-Member Payment?": "Membolehkan Pembayaran Bukan Ahli?",
  "Promotion Settings": "Tetapan Promosi",
  "Enable Non Member Promotion?": "Membolehkan Promosi Bukan Ahli?",
  "Enable Notification When Cycle Done?": "Membolehkan Pemberitahuan Apabila Kitaran Selesai?",
  "SMS charges": "Caj SMS",
  "SMS Settings": "Tetapan SMS",
  "Enable Free Sms For Members": "Membolehkan Sms Percuma Untuk Ahli",
  "If enable notification, user can choose either receive email or sms when complete washing or drying": "Jika membolehkan pemberitahuan, pengguna boleh memilih sama ada menerima e-mel atau sms apabila selesai mencuci atau mengeringkan",
  "If user choose sms, non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "Jika pengguna memilih sms, bukan ahli perlu membayar tambahan {{ currency }}{{ sms_notification_amount }} untuk sms tersebut",
  "If user choose sms, member and non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "Jika pengguna memilih sms, ahli dan bukan ahli perlu membayar tambahan {{ currency }}{{ sms_notification_amount }} untuk sms tersebut",
  "Add Package": "Tambah Pakej",
  "Edit e-Token Package": "Edit Pakej e-Token",
  "Add e-Token Package": "Tambah Pakej e-Token",
  "Please only input numberic value to prevent any bugs.": "Sila hanya masukkan nilai nombor untuk mengelakkan sebarang pepijat.",
  "Price": "Harga",
  "If ticked, the system will limit the number of purchase": "Jika ditanda, sistem akan mengehadkan bilangan pembelian",
  "Limit Number of Purchase": "Hadkan Bilangan Pembelian",
  "Number of maximum purchase": "Bilangan pembelian maksimum",
  "Reload Voucher": "Baucar Tambah Nilai",
  "If ticked, the system will give voucher to user when user reload token successfully": "Jika ditanda, sistem akan memberikan baucar kepada pengguna apabila pengguna tambah nilai token berjaya",
  "If ticked, the system will give voucher repeatly": "Jika ditanda, sistem akan memberikan baucar berulang kali",
  "Recurring": "Berulang",
  "Total number of voucher given to user": "Jumlah bilangan baucar yang diberikan kepada pengguna",
  "Period for giving next voucher": "Tempoh untuk memberikan baucar seterusnya",
  "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens": "Pakej token {{ currency }}{{ price }} untuk {{ numberOfToken }} token",
  "Each user only can purchase {{ max_purchase }} times for the token package": "Setiap pengguna hanya boleh membeli {{ max_purchase }} kali untuk pakej token",
  "Voucher will be given after user reload token successfully": "Baucar akan diberikan selepas pengguna berjaya tambah nilai token",
  "Voucher will not given after user reload tokens successfully": "Baucar tidak akan diberikan selepas pengguna berjaya tambah nilai token",
  "The voucher will be expired after {{ voucher_duration }} days": "Baucar akan tamat tempoh selepas {{ voucher_duration }} hari",
  "The voucher will not expired": "Baucar tidak akan tamat tempoh",
  "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount": "Jumlah {{ recurring_number }} baucar akan diberikan kepada pengguna dan setiap baucar akan diskaun",
  "Edit Package": "Edit Pakej",
  "Age": "Umur",
  "Total number of vouchers collected": "Jumlah baucar yang dikumpul",
  "Vouchers Acquired": "Baucar Diperolehi",
  "Total amount spent in washer machine transactions": "Jumlah amaun yang dibelanjakan dalam transaksi mesin basuh",
  "Total Washer Payment": "Jumlah Bayaran Mesin Cuci",
  "Total amount spent in dryer machine transactions": "Jumlah amaun yang dibelanjakan dalam transaksi mesin pengering",
  "Total Dryer Payment": "Jumlah Bayaran Pengering",
  "Total amount spent in all transactions": "Jumlah amaun yang dibelanjakan dalam semua transaksi",
  "Total Payment": "Jumlah bayaran",
  "report": "laporan",
  "Total amount spent for buying e-Token": "Jumlah amaun yang dibelanjakan untuk membeli e-Token",
  "Total number of e-Token purchased": "Jumlah bilangan e-Token yang dibeli",
  "Total e-Token Purchased (Tokens)": "Jumlah e-Token yang Dibeli (Token)",
  "Total number of e-Token used in washer machine transactions": "Jumlah bilangan e-Token yang digunakan dalam transaksi mesin basuh",
  "Washer Payment (Tokens)": "Bayaran Pencuci (Token)",
  "Total number of e-Token used in dryer machine transactions": "Jumlah bilangan e-Token yang digunakan dalam transaksi mesin pengering",
  "Dryer Payment (Tokens)": "Bayaran Pengering (Token)",
  "Total number of e-Token used in all the transactions": "Jumlah bilangan e-Token yang digunakan dalam semua transaksi",
  "Total Payment (Tokens)": "Jumlah Bayaran (Token)",
  "Number of washer stamp collected currently": "Bilangan setem mesin basuh yang dikumpul sekarang",
  "Number of dryer stamp collected currently": "Bilangan setem pengering yang dikumpul sekarang",
  "User Phone Number / Member ID / Email": "Nombor Telefon Pengguna / ID Ahli / E-mel",
  "Example: 0123456789,A123456": "Contoh: 0123456789,A123456",
  "SEARCH": "CARIAN",
  "Total Users Registered": "Jumlah Pengguna Berdaftar",
  "Total Active Outlets": "Jumlah Outlet Aktif",
  "Total Vouchers Given": "Jumlah Baucar Diberi",
  "Total Transaction Counts": "Jumlah Transaksi",
  "Total User Stamps Collected": "Jumlah Setem Pengguna Dikumpul",
  "Distributor Login": "Log Masuk Pengedar",
  "Client Login": "Log Masuk Pelanggan",
  "Kiosk Login": "Log Masuk Kiosk",
  "Promotion": "Promosi",
  "Please select operator": "Sila pilih operator",
  "Please select distributor": "Sila pilih pengedar",
  "Select Operator": "Pilih Operator",
  "Select Distributor": "Pilih Pengedar",
  "User can login or skip to payment without login to make the payment": "Pengguna boleh log masuk atau melangkau ke pembayaran tanpa log masuk untuk membuat pembayaran",
  "User have to login only can make the payment": "Pengguna perlu log masuk baru boleh membuat pembayaran",
  "User only can skip to payment without login to make the payment": "Pengguna hanya boleh melangkau ke pembayaran tanpa log masuk untuk membuat pembayaran",
  "Only CSV file is accepted": "Hanya fail CSV diterima",
  "The user and the balance have updated": "Pengguna dan baki telah dikemas kini",
  "Register Time": "Masa Daftar",
  "Upload User CSV file": "Muat naik fail CSV Pengguna",
  "Sample CSV file": "Contoh fail CSV",
  "Please follow the CSV file format": "Sila ikut format fail CSV",
  "User CSV file": "Fail CSV pengguna",
  "Only CSV file (comma delimited) is support now": "Hanya fail CSV (dibataskan koma) disokong sekarang",
  "Confirm uploaded data": "Sahkan data yang dimuat naik",
  "Operator": "Operator",
  "Distributor": "Pengedar",
  "Refund By": "Bayaran Balik Oleh",
  "Reward By": "Ganjaran Oleh",
  "Number Of Voucher Code": "Bilangan Kod Baucar",
  "Number Of Discount Code": "Bilangan Kod Diskaun",
  "New User Only": "Pengguna Baru Sahaja",
  "Minimum Transaction Amount To Redeem": "Jumlah Minimum Transaksi Untuk Menebus",
  "Download": "Muat turun",
  "Generate Voucher Code": "Jana Kod Baucar",
  "Your voucher code is generating": "Kod baucar anda sedang dijana",
  "Your discount code is generating": "Kod diskaun anda sedang dijana",
  "Voucher Code Settings": "Tetapan Kod Baucar",
  "If ticked, the voucher code only can redeem in register page": "Jika ditanda, kod baucar hanya boleh ditebus di halaman daftar",
  "If ticked, the user only can use the voucher after make a transaction": "Jika ditanda, pengguna hanya boleh menggunakan baucar selepas membuat transaksi",
  "If ticked, the user only can use the discount code after make a transaction": "Jika ditanda, pengguna hanya boleh menggunakan kod diskaun selepas membuat transaksi",
  "Expired Date Of Voucher Code": "Tarikh Luput Kod Baucar",
  "Minimum Transaction Amount To Use Voucher": "Jumlah Transaksi Minimum Untuk Menggunakan Baucar",
  "Minimum Transaction Amount To Use Code": "Jumlah Transaksi Minimum Untuk Guna Kod",
  "Max redemption per user in this batch voucher code": "Penebusan maksimum bagi setiap pengguna dalam kod baucar kelompok ini",
  "Max redemption per user in this batch discount code": "Penebusan maksimum bagi setiap pengguan dalam kod diskaun kelompok ini",
  "Add Voucher": "Tambah Baucar",
  "Completed": "Selesai",
  "Voucher Code Report": "Laporan Kod Baucar",
  "Floating Token Report": "Laporan Token Terapung",
  "Floating Point Report": "Laporan Mata Terapung",
  "E-Payment Report": "Laporan E-Payment",
  "Referral Reward History Report": "Laporan Sejarah Ganjaran Rujukan",
  "Redemption Date": "Tarikh Penebusan",
  "Redemption Code": "Kod Penebusan",
  "Select Redemption Date": "Pilih Tarikh Penebusan",
  "Select Voucher Type": "Pilih Jenis Baucar",
  "Giveaway": "Pampasan",
  "Select Name": "Pilih Nama",
  "Amount must be more than 1": "Jumlah mestilah lebih daripada 1",
  "Payment method setting have updated successfully!": "Tetapan kaedah pembayaran telah berjaya dikemas kini!",
  "Edit Payment Method": "Edit Kaedah Pembayaran",
  "Minimum payment amount to include all the payment methods": "Jumlah pembayaran minimum untuk memasukkan semua kaedah pembayaran",
  "Exclude Payment Method in Revenue Monster": "Kecualikan Kaedah Pembayaran dalam Revenue Monster",
  "Welcome to": "Selamat datang ke",
  "Instruction": "Arahan",
  "Please select the machine": "Sila pilih mesin",
  "Login your account": "Log masuk akaun anda",
  "Select the setting and make the payment": "Pilih tetapan dan buat pembayaran",
  "Phone Number / Email": "Nombor Telefon / E-mel",
  "Reload & Transfer In": "Muat Semula & Pemindahan Masuk",
  "Usage & Transfer Out": "Penggunaan & Pemindahan Keluar",
  "Usage": "Penggunaan",
  "Remaining": "Tinggal",
  "Gain": "Keuntungan",
  "Type": "Jenis",
  "Order Date": "Tarikh pesanan",
  "Pack Number": "Nombor Pek",
  "Pack Details": "Butiran Pek",
  "Size": "Saiz",
  "Mode": "Mod",
  "Machine Payment": "Bayaran Mesin",
  "DNG History": "Sejarah DNG",
  "Token History": "Sejarah Token",
  "Stamp History": "Sejarah Setem",
  "Staff Login": "Log Masuk Kakitangan",
  "Drop And Go Portal": "Portal Drop And Go",
  "Available Task": "Tugasan Yang Ada",
  "Completed Task": "Tugasan Yang Selesai",
  "Task ID": "ID Tugas",
  "Task": "Tugas",
  "Start Task": "Mulakan Tugas",
  "Select Machine": "Pilih Mesin",
  "Start Machine": "Mulakan Mesin",
  "Reward To": "Ganjaran Kepada",
  "Reward From": "Ganjaran Daripada",
  "Transaction Account": "Akaun Transaksi",
  "Point": "Mata",
  "POINT": "Mata",
  "Number of Point": "Bilangan Mata",
  "Point History": "Sejarah Mata",
  "Customer Name": "Nama Pelanggan",
  "Number of Washer Transactions": "Bilangan Transaksi Pencuci",
  "Number of Dryer Transactions": "Bilangan Transaksi Pengering",
  "Vouchers Redeemed": "Baucar Ditebus",
  "Discount Code Redemption": "Penebusan Kod Diskaun",
  "Total Spend": "Jumlah Perbelanjaan",
  "Select Outlet(s)": "Pilih Outlet",
  "User Usage Report": "Laporan Penggunaan Pengguna",
  // cleanpro plus bm
  "Wash": "Basuh",
  "Dry": "Kering",
  "Fold": "Lipat",
  "Scan QR": "Imbas QR",
  "Capacity": "Kapasiti",
  "Duration": "Tempoh",
  "Custom duration": "Ubahsuai masa",
  "Choose duration": "Pilih masa",
  "Select the correct amount on the machine after payment.": "Pilih jumlah masa yang betul pada mesin selepas membuat pembayaran",
  "Offers": "Tawaran",
  "Voucher Offers": "Tawaran Baucar",
  "Discount Code Offers": "Tawaran Kod Diskaun",
  "An easier way to pay": "Cara pembayaran yang lebih mudah",
  "Create account": "Buka akaun",
  "Login": "Log masuk",
  "By signing up, you agree to": "Dengan mendaftar anda bersetuju untuk",
  "Amount to Pay": "Jumlah yang Perlu Dibayar",
  "1 voucher selected": "1 Baucar Dipilih",
  "No voucher selected": "Tiada baucar dipilih",
  "Credits": "Kredit",
  "credits": "kredit",
  "credit": "kredit",
  "Credit balance": "Baki kredit",
  "Please ensure that the machine door is shut & your laundry is inside.": "Pastikan pintu mesin ditutup & pakaian anda ada di dalam.",
  "Insufficient balance": "Baki tidak mencukupi",
  "Topup now": "Topup sekarang",
  "Copyright © {{ year }} Cleanpro Laundry Holdings Sdn Bhd (821842-P) All rights reserved.": "Hak Cipta © {{ year }} Cleanpro Laundry Holdings Sdn Bhd (821842-P) Hak cipta terpelihara.",
  "Good Evening!": "Selamat petang!",
  "Hello": "Halo",
  "Wallet Balance": "Baki Wallet",
  "Topup": "Topup",
  "More details": "Maklumat lanjut",
  "Collect 10 e-stamps to earn x1 FREE wash or dry voucher": "Kumpul 10 e-setem untuk dapatkan x1 baucar basuhan atau keringan secara PERCUMA",
  "For every wash or dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "Anda akan dapat satu e-setem selepas setiap penggunaan basuh atau kering dengan Cleanpro Plus. Kumpul 10 e-setem dan dapatkan 1 baucar basuhan atau keringan secara percuma! Ini adalah tanda penghargaan kami kerana menggunakan Cleanpro.",
  "For every wash cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "Anda akan dapat satu e-setem selepas setiap penggunaan basuh dengan Cleanpro Plus. Kumpul 10 e-setem dan dapatkan 1 baucar basuhan atau keringan secara percuma! Ini adalah tanda penghargaan kami kerana menggunakan Cleanpro.",
  "For every dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "Anda akan dapat satu e-setem selepas setiap penggunaan kering dengan Cleanpro Plus. Kumpul 10 e-setem dan dapatkan 1 baucar basuhan atau keringan secara percuma! Ini adalah tanda penghargaan kami kerana menggunakan Cleanpro.",
  "Credits OFF": "Kredit Potongan",
  "% OFF": "% Potongan",
  "Valid Till": "Sah sehingga",
  "Used On": "Digunakan Pada",
  "Expired On": "Tamat Tempoh Pada",
  "Available": "Tersedia",
  "Expired": "Tamat tempoh",
  "Used": "Terpakai",
  "Promotions": "Promosi",
  "Rewards": "Ganjaran",
  "Inbox": "Peti masuk",
  "Activities": "Aktiviti",
  "Support": "Sokongan",
  "Active Rewards": "Ganjaran Aktif",
  "Past Rewards": "Ganjaran Terdahulu",
  "Get rewarded for your loyalty with Cleanpro Plus Rewards!": "Dapatkan ganjaran kesetiaan anda dengan Cleanpro Plus Rewards!",
  "Earn vouchers and redeem them for discounts, freebies and more. The more you use our services the more you save!": "Dapatkan baucar dan tebus diskaun, hadiah percuma dan banyak lagi. Lebih banyak anda menggunakan servis kami, lebih banyak penjimatan!",
  "Up to 3 months history": "Sejarah 3 bulan lepas",
  "Filter": "Penapis",
  "All Transactions": "Semua Urus Niaga",
  "Transactions": "Transaksi",
  "Select amount to topup": "Pilih jumlah untuk topup",
  "Balance": "Baki",
  "You've just paid": "Awak baru bayar",
  "Need help?": "Perlukan bantuan?",
  "24-Hour Careline Number": "Talian Careline 24 jam",
  "Email Us": "Emel Kami",
  "Call Now": "Hubungi Sekarang",
  "Email Now": "E-mel Sekarang",
  "Update name": "Kemas kini nama",
  "Update email address": "Kemas kini alamat e-mel",
  "Update phone number": "Kemas kini nombor telefon",
  "Change password": "Tukar kata laluan",
  "Change language": "Tukar bahasa",
  "User ID": "ID Pengguna",
  "Let us know your feedback": "Beritahu kami maklum balas anda",
  "Poor": "Teruk",
  "Good": "Baik",
  "Leave addtional feedback here (optional)": "Tinggalkan maklum balas tambahan di sini (Tidak wajib diisi)",
  "Submit feedback": "Hantar Maklum Balas",
  "Pay as guest": "Bayar sebagai tetamu",
  "Pay now": "Bayar sekarang",
  "Select voucher to use": "Pilih baucar untuk digunakan",
  "Use voucher": "Gunakan baucar",
  "Total": "Jumlah",
  "Transaction Type": "Jenis Transaksi",
  "E-Token Topup": "Topup E-Token",
  "Credit Topup": "Topup Kredit",
  "Credit topup": "Topup Kredit",
  "Credit Transfer": "Pemindahan Kredit",
  "E-Token Transfer": "Pemindahan E-Token",
  "Date/Time": "Tarikh/Masa",
  "Reference ID": "ID Rujukan",
  "Status": "Status",
  "Share Your Referral Code": "Kongsi Kod Rujukan Anda",
  "cleanproReferralShortDesc": "Dapatkan {{ voucherAmount }} kredit percuma apabila anda berkongsi kod rujukan anda kepada rakan dan keluarga selepas transaksi yang berjaya. Klik untuk maklumat lebih lanjut.",
  "Use": "Gunakan",
  "dryer or washer": "pengering atau mesin basuh",
  "washer": "mesin basuh",
  "dryer": "pengering",
  "dryer and washer": "pengering dan mesin basuh",
  "machine with the minimum spending of": "dengan perbelanjaan minimum",
  // "Welcome to Cleanpro Plus": "Selamat datang ke Cleanpro Plus",
  // "Only scan, set & pay! An easier, more convenient way to pay with Cleanpro Plus! No need to download an app. Enjoy more rewards when you use Cleanpro Plus today! Tap to learn more.": "Hanya imbas, tetap dan bayar! Cara yang lebih mudah dan senang untuk membayar dengan Cleanpro Plus! Tidak perlu memuat turun aplikasi. Nikmati lebih banyak ganjaran apabila anda menggunakan Cleanpro Plus hari ini! Klik untuk maklumat lebih lanjut.",
  // "Cleanpro Pay Migration Notice": "Notis Penghijrahan Cleanpro Pay",
  // "Dear valued Cleanpro customers, please be informed that as of 22 June 2023, the Cleanpro Pay app will be upgraded and and no longer available for use. Tap to learn more.": "Pelanggan Cleanpro yang dihormati, sila ambil maklum bahawa mulai 22 Jun 2023, aplikasi Cleanpro Pay akan dinaik taraf dan tidak lagi boleh untuk digunakan. Klik untuk maklumat lebih lanjut.",
  // "Answer simple questions and win credits for your next wash or dry! This contest is only available for selected outlets only. Tap to learn more.": "Jawab soalan mudah dan menangi kredit untuk cucian atau pengeringan! Peraduan ini hanya tersedia untuk cawangan terpilih sahaja. Klik untuk maklumat lebih lanjut.",
  // "The all-new Cleanpro Plus is a new payment method that includes loyalty features built into the app. The more you use our services and pay using Cleanpro Plus, the more you can save. With every transaction, you can earn rewards that will help you save on your next laundry expenses.": "Cleanpro Plus adalah kaedah pembayaran baharu yang mempunyai program kesetiaan terbina dalam aplikasi. Lebih banyak anda menggunakan dan membayar melalui Cleanpro Plus, lebih banyak anda boleh berjimat. Dengan setiap transaksi, anda akan memperoleh ganjaran yang boleh menjimatkan perbelanjaan dobi anda yang seterusnya.",
  // "To use Cleanpro Plus, simply scan the QR code on the machines and pay using your preferred credit/debit card or e-wallet. We hope that Cleanpro Plus will help simplify your laundry routine and give you more time for the things that matter.": "Untuk menggunakan Cleanpro Plus, hanya imbas kod QR pada mesin dan bayar menggunakan kad kredit/debit atau e-dompet pilihan anda. Kami berharap Cleanpro Plus akan membantu memudahkan rutin cucian dan memberi anda lebih masa untuk perkara yang penting.",
  // "If you have any questions about Cleanpro Plus, please read our FAQ in the menu or contact our careline at +603 2770 0100 or email us at info@cleanprolaundry.com. Thank you for choosing Cleanpro.": "Jika anda mempunyai sebarang soalan tentang Cleanpro Plus, sila baca FAQ kami di menu atau hubungi talian khidmat pelanggan kami di +603 2770 0100 atau e-mel kami di info@cleanprolaundry.com. Terima kasih kerana memilih Cleanpro.",
  // "Dear valued Cleanpro customers, please be informed that as of 22 June 2023, the existing Cleanpro Pay mobile app will be upgraded and no longer available for use.": "Pelanggan Cleanpro yang dihormati, sila ambil maklum bahawa mulai 22 Jun 2023, Cleanpro Pay akan dinaik taraf dan tidak lagi boleh untuk digunakan.",
  // "We are migrating to the all-new Cleanpro Plus. It is a new cashless payment method, without the need to download apps.": "Kami akan bertukar ke Cleanpro Plus yang serba baharu. Ini adalah kaedah baru pembayaran tanpa tunai, tanpa perlu memuat turun aplikasi.",
  // "If you are the existing user of Cleanpro Pay, any of your remaining balance in the app will be transferred to your Cleanpro Plus account. You are required to use the same mobile number to sign up for Cleanpro Plus for balance transfer.": "Jika anda adalah pengguna Cleanpro Pay, sebarang baki yang tinggal dalam aplikasi  akan dipindahkan ke akaun Cleanpro Plus anda. Anda dikehendaki menggunakan nombor telefon yang sama untuk mendaftar Cleanpro Plus bagi pemindahan baki.",
  // "If you need help on Cleanpro Plus, please feel free to call our careline at +603 2770 0100 or email us at info@cleanprolaundry.com": "Jika anda memerlukan bantuan mengenai Cleanpro Plus, sila hubungi talian penjagaan kami di +603 2770 0100 atau e-mel kami di info@cleanprolaundry.com",
  // "Answer simple questions and win credits for your next wash or dry!": "Jawab soalan mudah dan menangi kredit untuk cucian atau pengeringan seterusnya!",
  // "Step 1 : Scan the Jawab & Gerenti Menang QR code in the participated outlets.": "Langkah 1 : Imbas kod QR Jawab & Gerenti Menang di mana-mana cawangan yang mengambil bahagian.",
  // "Step 2 : Answer 3 simple questions.": "Langkah 2 : Jawab 3 soalan mudah.",
  // "Step 3 : Submit and stand a chance to win prizes.": "Langkah 3 : Hantar dan anda berpeluang memenangi hadiah.",
  // "Grand Prize :": "Hadiah utama :",
  // "x10 per outlet - 100 credits worth of vouchers in Cleanpro Plus": "x10 setiap outlet - Kredit bernilai RM100 dalam Cleanpro Plus",
  // "Consolation Prize :": "Hadiah saguhati :",
  // "X25 per outlet - 50 credits worth of vouchers in Cleanpro Plus": "X25 setiap outlet - Kredit bernilai RM50 dalam Cleanpro Plus",
  // "Participation prize:": "Hadiah penyertaan:",
  // "Every participants are eligible to receive a FREE 3 credits voucher (worth RM3) in Cleanpro Plus.": "Kredit PERCUMA bernilai RM3 dalam Cleanpro Plus untuk setiap peserta.",
  // "If you have any questions please don't hesitate to contact our careline at +603 2770 0100 or email us at info@cleanprolaundry.com. Thank you for choosing Cleanpro.": "Jika anda mempunyai sebarang pertanyaan sila hubungi talian penjagaan kami di +603 2770 0100 atau e-mel kami di info@cleanprolaundry.com. Terima kasih kerana memilih Cleanpro.",
  "Payment Confirmation": "Pengesahan Pembayaran",
  "This campaign is only eligible for users who use the all-new Cleanpro Plus web application.": "Kempen ini hanya layak untuk pengguna yang menggunakan aplikasi web Cleanpro Plus serba baharu.",
  "ONE e-stamp will be rewarded for each wash or dry cycle.": "SATU e-cop akan diberi ganjaran untuk setiap kitaran basuh atau kering.",
  "ONE e-stamp will be rewarded for each wash cycle.": "SATU e-cop akan diberi ganjaran untuk setiap kitaran cucian.",
  "ONE e-stamp will be rewarded for each dry cycle.": "SATU e-cop akan diberi ganjaran untuk setiap kitaran kering.",
  "Regardless of the washer or dryer settings, the number of e-stamps being collected is the same.": "Tidak kira tetapan mesin basuh atau pengering, bilangan e-setem yang dikumpul adalah sama.",
  "The type of e-stamp collected is based on the services that you have used.": "Jenis e-setem yang dikumpul adalah berdasarkan perkhidmatan yang telah anda gunakan.",
  "Washing service will reward washer e-stamp and drying service will reward dryer e-stamp.": "Perkhidmatan mencuci akan memberi ganjaran kepada e-cop mesin basuh dan perkhidmatan pengeringan akan memberi ganjaran kepada e-cop pengering.",
  "Washing service will reward washer e-stamp.": "Perkhidmatan mencuci akan memberi ganjaran kepada e-cop mesin basuh.",
  "Drying service will reward dryer e-stamp.": "Perkhidmatan pengeringan akan memberi ganjaran kepada e-cop pengering.",
  "E-stamps will automatically be added to your account once the condition has been fulfilled.": "E-setem akan ditambahkan secara automatik ke akaun anda setelah syarat telah dipenuhi.",
  "There is no limit on how many e-stamps can be gathered in a single day. So long as you meet the requirements to collect the e-stamps.": "Tiada had berapa banyak e-setem boleh dikumpulkan dalam satu hari. Selagi anda memenuhi syarat untuk mengumpul e-setem.",
  "The type of e-stamps that have been collected is final and cannot be changed.": "Jenis e-setem yang telah dikumpul adalah muktamad dan tidak boleh diubah.",
  "There is no expiration for the e-stamps; only till the discontinuation of the campaign.": "Tiada tamat tempoh untuk e-setem; hanya sehingga pemberhentian kempen.",
  "E-stamps do not have any currency value, and they cannot be converted to cash or credits.": "E-setem tidak mempunyai sebarang nilai mata wang, dan ia tidak boleh ditukar kepada tunai atau kredit.",
  "This campaign is not applicable with any other ongoing promotions, offers, vouchers, and/or discounts provided by the participating outlets.": "Kempen ini tidak terpakai dengan mana-mana promosi, tawaran, baucar dan/atau diskaun berterusan lain yang disediakan oleh cawangan yang mengambil bahagian.",
  "These terms and conditions are subject to change at any time without prior notice.": "Terma dan syarat ini tertakluk kepada perubahan pada bila-bila masa tanpa notis terlebih dahulu.",
  "Press START on the machine to begin washing.": "Tekan START pada mesin untuk mula membasuh.",
  "Press START on the machine to begin drying.": "Tekan START pada mesin untuk mula mengeringkan.",
  "Reminder": "Peringatan",
  "Remember to select the same settings you have paid for on the corresponding machine.": "Ingat untuk memilih tetapan yang sama yang telah anda bayar pada mesin yang sepadan.",
  "Please ensure that your laundry is inside the machine and door is properly shut.": "Sila pastikan pakaian anda berada di dalam mesin dan pintu ditutup dengan betul.",
  "voucherCreditsOff_one": "Potongan {{currentVoucherAmount}} kredit",
  "voucherCreditsOff_other": "Potongan {{currentVoucherAmount}} kredit",
  "voucherPercentageOff": "Potongan {{currentVoucherAmount}}%",
  "cleanproReferralFlatVoucher_one": "Dapatkan kredit percuma apabila anda berkongsi kod rujukan Cleanpro Plus kepada rakan dan keluarga anda! Bagi setiap rujukan yang berjaya selepas transaksi pertama mereka, anda akan mendapat baucar {{ referralVoucherAmount }} kredit percuma.",
  "cleanproReferralFlatVoucher_other": "Dapatkan kredit percuma apabila anda berkongsi kod rujukan Cleanpro Plus kepada rakan dan keluarga anda! Bagi setiap rujukan yang berjaya selepas transaksi pertama mereka, anda akan mendapat baucar {{ referralVoucherAmount }} kredit percuma.",
  "cleanproReferralRateVoucher": "Dapatkan kredit percuma apabila anda berkongsi kod rujukan Cleanpro Plus kepada rakan dan keluarga anda! Bagi setiap rujukan yang berjaya selepas transaksi pertama mereka, anda akan mendapat baucar {{ referralVoucherAmount }}% percuma.",
  "cleanproReferralTokenReward_one": "Dapatkan kredit percuma apabila anda berkongsi kod rujukan Cleanpro Plus kepada rakan dan keluarga anda! Bagi setiap rujukan yang berjaya selepas transaksi pertama mereka, anda akan mendapat {{ referralToken }} kredit percuma.",
  "cleanproReferralTokenReward_other": "Dapatkan kredit percuma apabila anda berkongsi kod rujukan Cleanpro Plus kepada rakan dan keluarga anda! Bagi setiap rujukan yang berjaya selepas transaksi pertama mereka, anda akan mendapat {{ referralToken }} kredit percuma.",
  "How to get & use code:": "Cara dapatkan & gunakan kod:",
  'Go to menu = icon and click “Refer friends”': 'Pergi ke ikon menu = dan klik "Rujuk rakan"',
  "Share with everyone who will likely to use Cleanpro Plus.": "Kongsikan kepada mereka yang mungkin akan menggunakan Cleanpro Plus.",
  "Referral Terms & Conditions:": "Terma & Syarat Rujukan:",
  "When your friend or family register using your referral code, and completed a transaction (a minimum spending of {{ currency }}{{ referralTransactionAmount }}) , you will be rewarded automatically.": "Apabila rakan atau keluarga anda mendaftar menggunakan kod rujukan anda, dan menyelesaikan transaksi (perbelanjaan minimum {{ currency }}{{ referralTransactionAmount }}), anda akan diberi ganjaran secara automatik.",
  "cleanproNumberOfReferralReward": "Anda boleh berkongsi dengan seberapa ramai yang anda mahu, tetapi setiap pengguna HANYA terhad untuk mendapat {{ numberOfReferral }} ganjaran rujukan sahaja.",
  "cleanproNumberOfReferral_one": "Anda boleh berkongsi dengan seberapa ramai yang anda mahu, tetapi setiap pengguna HANYA terhad untuk mendapat {{ numberOfReferral }} baucar rujukan sahaja.",
  "cleanproNumberOfReferral_other": "Anda boleh berkongsi dengan seberapa ramai yang anda mahu, tetapi setiap pengguna HANYA terhad untuk mendapat {{ numberOfReferral }} baucar rujukan sahaja.",
  "The voucher is valid for {{ duration }} days from the day voucher be given.": "Baucar sah selama {{ duration }} hari dari hari baucar diberikan.",
  "The voucher is for customer use only and not for sale.": "Baucar adalah untuk kegunaan pelanggan sahaja dan bukan untuk dijual.",
  "We believe that your special day deserves a little extra sparkle! That's why we're thrilled to introduce our exclusive birthday rewards program just for you! Starting this year, and every year thereafter, we're giving away {{ currency }}{{ voucherAmount }} credit vouchers to you on your birthday.": "Kami percaya hari istimewa anda perlu diraikan dengan penuh bermakna. Kami teruja untuk memperkenalkan program ganjaran ekslusif hari lahir hanya untuk anda! Mulai tahun ini, dan tahun berikutnya, kami akan berikan baucar kredit {{ currency }}{{ voucherAmount }} pada hari lahir anda.",
  "cleanproBirthdayRateAmount": "Kami percaya hari istimewa anda perlu diraikan dengan penuh bermakna. Kami teruja untuk memperkenalkan program ganjaran ekslusif hari lahir hanya untuk anda! Mulai tahun ini, dan tahun berikutnya, kami akan berikan baucar {{ voucherAmount }}% pada hari lahir anda.",
  "Make sure your account details include your birthdate. This way, we'll know exactly when to send you your special birthday surprise.": "Pastikan tarikh lahir diisi dalam butiran akaun anda. Dengan cara ini, kami akan mengetahui dengan tepat hari untuk memberi baucar istimewa hari jadi anda.",
  "Birthday Voucher Terms & Conditions:": "Terma & Syarat Baucar Hari Lahir:",
  "The voucher will be given on the first day of your birthday month.": "Baucar akan diberikan pada hari pertama bulan lahir anda.",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount.": "Apabila anda menggunakan baucar semasa pembayaran, ia akan memberi anda diskaun {{ voucherAmount }} kredit ({{ currency }}{{ voucherAmount }}).",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }}% discount.": "Apabila anda menggunakan baucar semasa pembayaran, ia akan memberi anda diskaun {{ voucherAmount }}%.",
  "All vouchers is not valid with other ongoing promotions, discounts and offers.": "Baucar ini tidak boleh digunakan ketika promosi lain sedang berlangsung.",
  "Claim a complimentary wash and dry for every 10 e-stamps collected! We value your loyalty and want to reward you for choosing Cleanpro Plus. Tap to learn more.": "Tebus basuhan dan keringan percuma untuk setiap 10 e-setem yang terkumpul! Kami menghargai kesetiaan anda dan ingin memberi ganjaran kerana setia memilih Cleanpro Plus. Klik untuk maklumat lebih lanjut.",
  "cleanproStampFlat_one": "Dengan setiap 10 e-setem yang anda kumpulkan, anda boleh menebus sehingga {{ voucherAmount }} kredit untuk sesi basuhan atau keringan secara percuma dengan Cleanpro Plus. Jadikan rutin cucian anda bukan sahaja mudah, tetapi juga bermanfaat.",
  "cleanproStampFlat_other": "Dengan setiap 10 e-setem yang anda kumpulkan, anda boleh menebus sehingga {{ voucherAmount }} kredit untuk sesi basuhan atau keringan secara percuma dengan Cleanpro Plus. Jadikan rutin cucian anda bukan sahaja mudah, tetapi juga bermanfaat.",
  "cleanproStampRate": "Dengan setiap 10 e-setem yang anda kumpulkan, anda boleh menebus sehingga {{ voucherAmount }}% untuk sesi basuhan atau keringan secara percuma dengan Cleanpro Plus. Jadikan rutin cucian anda bukan sahaja mudah, tetapi juga bermanfaat.",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "Baucar akan ditambah serta-merta pada halaman Ganjaran anda apabila anda mencapai 10 basuhan. Meter e-setem anda akan kembali kepada sifar untuk koleksi seterusnya. Dapatkan baucar dalam halaman Imbas QR apabila anda melakukan cucian seterusnya.",
  "A voucher will be instantly added to your Rewards page when you reach 10 drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "Baucar akan ditambah serta-merta pada halaman Ganjaran anda apabila anda mencapai 10 keringan. Meter e-setem anda akan kembali kepada sifar untuk koleksi seterusnya. Dapatkan baucar dalam halaman Imbas QR apabila anda melakukan cucian seterusnya.",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes or drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "Baucar akan ditambah serta-merta pada halaman Ganjaran anda apabila anda mencapai 10 basuhan atau keringan. Meter e-setem anda akan kembali kepada sifar untuk koleksi seterusnya. Dapatkan baucar dalam halaman Imbas QR apabila anda melakukan cucian seterusnya.",
  "Terms & Conditions:": "Terma & Syarat:",
  "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session.": "Untuk mendapatkan SATU e-setem, anda harus berbelanja sekurang-kurangnya {{ stampTransactionAmount }} kredit ({{ currency }}{{ stampTransactionAmount }}) untuk setiap sesi.",
  "You will be automatically issued a voucher if you have collected 10 washer stamps.": "Anda akan diberikan baucar secara automatik jika anda berjaya mengumpul 10 setem mesin basuh.",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps.": "Anda akan diberikan baucar secara automatik jika anda berjaya mengumpul 10 e-setem pengering",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps or 10 washer stamps.": "Anda akan diberikan baucar secara automatik jika anda berjaya mengumpul 10 e-setem pengering atau 10 setem mesin basuh.",
  "You will be automatically issued a voucher if you have collected 10 stamps.": "Anda akan diberikan baucar secara automatik jika anda berjaya mengumpul 10 e-setem.",
  "The voucher is non-refundable and cannot be exchanged for cash; in part or in full.": "Baucar tidak boleh dikembalikan dan tidak boleh ditukar dengan wang tunai; sebahagian atau sepenuhnya.",
  "This voucher is valid for single transaction only.": "Baucar ini sah untuk satu transaksi sahaja.",
  "General questions": "Soalan umum",
  "E-stamps collection": "Koleksi e-setem",
  "Coin exchange machines": "Mesin tukar syiling",
  "Washer machines": "Mesin basuh",
  "Dryer machines": "Mesin pengering",
  "Paywave issues": "Isu paywave",
  "Cleanpro franchise": "Francais Cleanpro",
  "How can I wash my laundry using Cleanpro Plus?": "Bagaimanakah saya boleh membasuh pakaian saya menggunakan Cleanpro Plus?",
  "Here are the steps to wash your laundry using Cleanpro Plus:": "Berikut ialah langkah-langkah untuk mencuci pakaian anda menggunakan Cleanpro Plus:",
  "Find an unoccupied washing machine in the store, and insert your laundry in the washer.": "Cari mesin basuh yang tidak berpenghuni di kedai, dan masukkan pakaian anda ke dalam mesin basuh.",
  "Select the desired temperature that you would like to use for your laundry.": "Pilih suhu yang diingini yang anda ingin gunakan untuk cucian anda.",
  "Using the scanner in the app, scan the QR code provided on the washing machine. Then select the same settings that you have pressed on the machine.": "Menggunakan pengimbas dalam apl, imbas kod QR yang disediakan pada mesin basuh. Kemudian pilih tetapan yang sama yang telah anda tekan pada mesin.",
  'Tap on “Pay with credits” to pay the amount shown on the app.': 'Ketik pada "Bayar dengan kredit" untuk membayar jumlah yang ditunjukkan pada apl.',
  "Once the payment has been accepted, press the START button on the washer machine.": "Setelah pembayaran diterima, tekan butang MULA pada mesin basuh.",
  "After the washing cycle ends, you can just remove your laundry from the machine.": "Selepas kitaran basuh tamat, anda hanya boleh mengeluarkan pakaian anda dari mesin.",
  "How can I dry my laundry using Cleanpro Plus?": "Bagaimanakah saya boleh mengeringkan pakaian saya menggunakan Cleanpro Plus?",
  "Here are the steps to dry your laundry using Cleanpro Plus:": "Berikut ialah langkah untuk mengeringkan pakaian anda menggunakan Cleanpro Plus:",
  "Find an unoccupied drying machine in the store, and insert your laundry in the dryer.": "Cari mesin pengering yang tidak berpenghuni di kedai, dan masukkan pakaian anda ke dalam mesin pengering.",
  "Select the desired temperature and duration that you would like to use for your laundry.": "Pilih suhu dan tempoh yang diingini yang anda ingin gunakan untuk cucian anda.",
  "Using the scanner in the app, scan the QR code provided on the drying machine. Then select the same settings that you have pressed on the machine.": "Menggunakan pengimbas dalam apl, imbas kod QR yang disediakan pada mesin pengering. Kemudian pilih tetapan yang sama yang telah anda tekan pada mesin.",
  "Once the payment has been accepted, press the START button on the dryer machine.": "Setelah pembayaran diterima, tekan butang MULA pada mesin pengering.",
  "After the drying cycle ends, you can just remove your laundry from the machine.": "Selepas kitaran pengeringan tamat, anda hanya boleh mengeluarkan pakaian anda dari mesin.",
  "Why does the QR code I scanned take me to a different machine?": "Mengapa kod QR yang saya imbas membawa saya ke mesin lain?",
  "Here are the steps to solve it:": "Berikut adalah langkah-langkah untuk menyelesaikannya:",
  "Make sure that the number on the QR code (e.g. W1, W2, etc) is the same as the machine that you would like to use.": "Pastikan nombor pada kod QR (cth. W1, W2, dll) adalah sama dengan mesin yang anda ingin gunakan.",
  "If the QR code number does not match the machine you want, use the other machine. Please contact our customer service line at 03-27700100 to report this issue.": "Jika nombor kod QR tidak sepadan dengan mesin yang anda mahu, gunakan mesin yang lain. Sila hubungi talian khidmat pelanggan kami di 03-27700100 untuk melaporkan isu ini.",
  "How can I add more time to the washer that I am currently using?": "Bagaimanakah saya boleh menambah lebih banyak masa pada mesin basuh yang sedang saya gunakan?",
  "The washing time for our washer is fixed and cannot add any additional time.": "Masa basuh untuk mesin basuh kami adalah tetap dan tidak boleh menambah sebarang masa tambahan.",
  "How can I add more time to the dryer that I am currently using?": "Bagaimanakah saya boleh menambah lebih banyak masa pada pengering yang sedang saya gunakan?",
  "Here are the steps to add more time to the dryer machine:": "Berikut ialah langkah-langkah untuk menambahkan lebih banyak masa pada mesin pengering:",
  "By using the scanner in the app, scan the QR code provided at the dryer machine.": "Dengan menggunakan pengimbas dalam apl, imbas kod QR yang disediakan di mesin pengering.",
  "Select the amount of time that you would like to add to the machine.": "Pilih jumlah masa yang anda ingin tambahkan pada mesin.",
  "After the drying cycle ends, you can just remove the clothes from the machine.": "Selepas kitaran pengeringan tamat, anda hanya boleh mengeluarkan pakaian dari mesin.",
  "REMINDER - It is recommended to add drying time 5 minutes before the cycle ends. And you cannot add tokens for extra times when the machine finishes the drying cycle.": "PERINGATAN - Adalah disyorkan untuk menambah masa pengeringan 5 minit sebelum kitaran tamat. Dan anda tidak boleh menambah token untuk masa tambahan apabila mesin menamatkan kitaran pengeringan.",
  "Will the timer keep running when I have stopped the drying machine?": "Adakah pemasa akan terus berjalan apabila saya telah menghentikan mesin pengering?",
  "Yes. Even after you stop the machine, the timer will continue to run. If you want to extend the drying time, add drying time 5 minutes before the cycle ends. This prevents the cycle from ending before your clothes are completely dried.": "Ya. Walaupun selepas anda menghentikan mesin, pemasa akan terus berjalan. Jika anda ingin memanjangkan masa pengeringan, tambahkan masa pengeringan 5 minit sebelum kitaran tamat. Ini menghalang kitaran daripada berakhir sebelum pakaian anda kering sepenuhnya.",
  "How do I reload my credits for Cleanpro Plus?": "Bagaimanakah saya boleh memuatkan semula kredit saya untuk Cleanpro Plus?",
  "Here are the steps to reload your credits:": "Berikut ialah langkah-langkah untuk memuat semula kredit anda:",
  'Select the "Top Up Credit" button on the homepage.': 'Pilih butang "Top Up Credit" di halaman utama.',
  "Choose the amount you want to reload and the payment method you want to use.": "Pilih amaun yang ingin anda muat semula dan kaedah pembayaran yang ingin anda gunakan.",
  "You will be taken to the payment page. The screen will return to Cleanpro Plus once the transaction is completed.": "Anda akan dibawa ke halaman pembayaran. Skrin akan kembali ke Cleanpro Plus setelah transaksi selesai.",
  "How many credits can I reload in one transaction?": "Berapa banyak kredit yang boleh saya muatkan semula dalam satu transaksi?",
  "Reloading credits requires a minimum of RM 10 and a maximum of RM 50.": "Muat semula kredit memerlukan minimum RM 10 dan maksimum RM 50.",
  "Can I pay using credits in the Cleanpro Plus app along with tokens or coins in a single transaction?": "Bolehkah saya membayar menggunakan kredit dalam apl Cleanpro Plus bersama-sama dengan token atau syiling dalam satu transaksi?",
  "No. Only a single payment method may be chosen when performing any transactions.": "Tidak. Hanya satu kaedah pembayaran boleh dipilih semasa melakukan sebarang transaksi.",
  "The amount I have reloaded in my account was not reflected in the app.": "Jumlah yang saya muatkan semula dalam akaun saya tidak ditunjukkan dalam apl.",
  "Please close and restart the application and check if the new balance has been updated.": "Sila tutup dan mulakan semula aplikasi dan semak sama ada baki baharu telah dikemas kini.",
  "If the amount is still not updated, please contact our customer service line at 03-27700110 to receive further assistance.": "Jika jumlah masih tidak dikemas kini, sila hubungi talian khidmat pelanggan kami di 03-27700110 untuk menerima bantuan lanjut.",
  "Can I cash out the credits I reloaded in my account for this app?": "Bolehkah saya tunaikan kredit yang saya muatkan semula dalam akaun saya untuk apl ini?",
  "No. The credits that you have reloaded will remain in your Cleanpro Plus account.": "Tidak. Kredit yang telah anda muatkan semula akan kekal dalam akaun Cleanpro Plus anda.",
  "I have requested a refund, but I still have not received it.": "Saya telah meminta bayaran balik, tetapi saya masih belum menerimanya.",
  "Please contact our customer service line at 03-27700100 to receive further assistance.": "Sila hubungi talian khidmat pelanggan kami di 03-27700100 untuk menerima bantuan lanjut.",
  "I have made the payment, and the app double or triple charged me.": "Saya telah membuat pembayaran dan apl itu mengenakan caj dua kali ganda atau tiga kali ganda kepada saya.",
  "The washing machine cannot start even after I have paid using the app.": "Mesin basuh tidak boleh dimulakan walaupun saya telah membayar menggunakan aplikasinya.",
  "Ensure that the temperature settings you have selected and paid for on the application are the same as what you have pressed on the washing machine. If not, select the correct temperature settings on the washing machine and try again.": "Pastikan tetapan suhu yang telah anda pilih dan bayar pada aplikasi adalah sama dengan apa yang telah anda tekan pada mesin basuh. Jika tidak, pilih tetapan suhu yang betul pada mesin basuh dan cuba lagi.",
  "If the machine is still not able to be started, please contact our customer service line at 03-27700100 to receive further assistance.": "Jika mesin masih tidak dapat dihidupkan, sila hubungi talian khidmat pelanggan kami di 03-27700100 untuk menerima bantuan lanjut.",
  "Can I use multiple vouchers together in the same washing or drying cycle?": "Bolehkah saya menggunakan berbilang baucar bersama-sama dalam kitaran basuh atau pengeringan yang sama?",
  "No. Only a single voucher can be used for each washing and drying cycle.": "Tidak. Hanya satu baucar boleh digunakan untuk setiap kitaran pencucian dan pengeringan.",
  "Why can't I use my free wash voucher that I received after signing up?": "Mengapa saya tidak boleh menggunakan baucar basuh percuma saya yang saya terima selepas mendaftar?",
  "To redeem or use the voucher, you must complete at least one washing or drying cycle.": "Untuk menebus atau menggunakan baucar, anda mesti melengkapkan sekurang-kurangnya satu kitaran basuh atau pengeringan.",
  "Can I change my phone number even after registering my account?": "Bolehkah saya menukar nombor telefon saya walaupun selepas mendaftar akaun saya?",
  "No. Once registered to an account, the phone number is locked into the account.": "Tidak. Setelah mendaftar ke akaun, nombor telefon dikunci ke dalam akaun.",
  "I have problems in the store, and who can I refer to for help?": "Saya mempunyai masalah di kedai, dan siapa yang boleh saya rujuk untuk mendapatkan bantuan?",
  "Do not worry, as you can contact our customer service line at 03-27700100 to receive assistance at any time.": "Jangan risau, kerana anda boleh menghubungi talian khidmat pelanggan kami di 03-27700100 untuk menerima bantuan pada bila-bila masa.",
  "Should I add my own laundry detergent and softeners to the washing machine?": "Perlukah saya menambah detergen dan pelembut pakaian saya sendiri pada mesin basuh?",
  "There is no need for that, as all you have to do is bring your dirty clothes and put them in the washer. The detergent and softeners will be provided by us, and you can rest assured that the laundry detergents we used are certified industrial grade.": "Tidak perlu untuk itu, kerana anda hanya perlu membawa pakaian kotor anda dan memasukkannya ke dalam mesin basuh. Detergen dan pelembut akan disediakan oleh kami, dan anda boleh yakin bahawa detergen dobi yang kami gunakan adalah gred industri yang disahkan.",
  "I would like to add my own laundry detergent and softener to the washing machine.": "Saya ingin menambah detergen dan pelembut pakaian saya sendiri pada mesin basuh.",
  "We do not recommend our customers add their own detergent, as the mixture of different detergents may affect the wash quality. And you can rest assured that the laundry detergent we used is certified industrial grade.": "Kami tidak mengesyorkan pelanggan kami menambah detergen mereka sendiri, kerana campuran detergen yang berbeza boleh menjejaskan kualiti cucian. Dan anda boleh yakin bahawa detergen pakaian yang kami gunakan adalah gred industri yang disahkan.",
  "What time does the store close?": "Pukul berapa kedai tutup?",
  "Our self-service laundry operation is open 24 hours a day, which means you can always be sure to go back home with a fresh set of laundry.": "Operasi dobi layan diri kami dibuka 24 jam sehari, yang bermakna anda sentiasa yakin untuk pulang ke rumah dengan set pakaian yang segar.",
  "Are you open on weekends?": "Adakah anda buka pada hujung minggu?",
  "Yes. Cleanpro is also open on weekends and even on public holidays.": "Ya. Cleanpro juga dibuka pada hujung minggu dan juga pada cuti umum.",
  "How many clothes can I fit in the washing or drying machine?": "Berapa banyak pakaian yang boleh saya masukkan ke dalam mesin basuh atau pengering?",
  "To ensure that your laundry is properly washed or dried, keep the amount of laundry inside the machine lower than the line of guide sticker on the machine.": "Untuk memastikan pakaian anda dibasuh atau dikeringkan dengan betul, pastikan jumlah cucian di dalam mesin lebih rendah daripada garis pelekat panduan pada mesin.",
  "How many e-stamps can I collect in a single day?": "Berapa banyak e-setem yang boleh saya kumpulkan dalam satu hari?",
  "There is no limit to the amount of stamps that can be collected in a single day; ONE stamp will be awarded with every wash or dry.": "Tiada had kepada jumlah setem yang boleh dikutip dalam satu hari; SATU cop akan diberikan dengan setiap cucian atau pengeringan.",
  "When I use the washing service, can I change the collected stamp to a dryer stamp, and vice versa?": "Apabila saya menggunakan perkhidmatan mencuci, bolehkah saya menukar setem yang dikumpul kepada setem pengering, dan sebaliknya?",
  "No, the type of stamp collected is only applied to the service that you have used.": "Tidak, jenis setem yang dikumpul hanya digunakan pada perkhidmatan yang telah anda gunakan.",
  "What temperatures can I choose when I claim the free washing e-stamp reward?": "Apakah suhu yang boleh saya pilih apabila saya menuntut ganjaran e-setem cucian percuma?",
  "Any washing temperature is available for the e-stamp reward.": "Sebarang suhu basuhan tersedia untuk ganjaran e-setem.",
  "What temperatures can I choose when I claim the free drying e-stamp reward? And how long can I set the time?": "Apakah suhu yang boleh saya pilih apabila saya menuntut ganjaran e-setem pengeringan percuma? Dan berapa lama saya boleh menetapkan masa?",
  "Any drying temperature and duration can be selected for the e-stamp reward.": "Sebarang suhu dan tempoh pengeringan boleh dipilih untuk ganjaran e-setem.",
  "I'm unable to change the coin.": "Saya tidak dapat menukar syiling.",
  "What colour is the light shown on the machine, red or green? If it is a red light, please contact our customer service line at 03-27700100 to receive further assistance.": "Apakah warna cahaya yang ditunjukkan pada mesin, merah atau hijau? Jika lampu merah, sila hubungi talian khidmat pelanggan kami di 03-27700100 untuk menerima bantuan lanjut.",
  "Green Light": "Lampu hijau",
  "Red Light": "Lampu merah",
  "Machine functions as normal. Please try again.": "Mesin berfungsi seperti biasa. Sila cuba lagi.",
  "(flashing 2x) - There are no coins/tokens in the machine.": "(berkelip 2x) - Tiada syiling/token dalam mesin.",
  "OR": "ATAU",
  "Note is jammed, please proceed to contact customer service": "Nota tersekat, sila teruskan untuk menghubungi perkhidmatan pelanggan",
  "(flashing 3x) - Note is jammed, please proceed to contact customer service": "(berkelip 3x) - Nota tersekat, sila teruskan untuk menghubungi khidmat pelanggan",
  "My notes are stuck in the machine.": "Nota saya tersangkut dalam mesin.",
  "My detergent is not dispensing in the vending machine.": "Detergen saya tidak mendispens dalam mesin layan diri.",
  "The water is leaking out of the washing machine.": "Air keluar dari mesin basuh.",
  "Please check the washer machine to see whether there are any clothes that are stuck at the door side.": "Sila periksa mesin basuh untuk melihat sama ada terdapat pakaian yang tersangkut di bahagian pintu.",
  "If yes, here are the steps to solve it:": "Jika ya, berikut adalah langkah-langkah untuk menyelesaikannya:",
  "Press the emergency stop button (RED Button) for 3 seconds.": "Tekan butang berhenti kecemasan (Butang MERAH) selama 3 saat.",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at 03-27700100 to receive further assistance)": "Tunggu bunyi berhenti, dan kemudian buka pintu sahaja. (Jika selepas 30 minit bunyi masih tidak berhenti, sila hubungi talian khidmat pelanggan kami di 03-27700100 untuk menerima bantuan lanjut)",
  "Ensure the door is closed tightly, and press the START button.": "Pastikan pintu ditutup rapat, dan tekan butang MULA.",
  "REMINDER - The emergency stop button can only be used once.": "PERINGATAN - Butang berhenti kecemasan hanya boleh digunakan sekali sahaja.",
  "There is no detergent dispensing in the washing machine.": "Tiada pendispensan detergen dalam mesin basuh.",
  "Ensure that the machine is in operation and that the START button was pressed.": "Pastikan mesin beroperasi dan butang START ditekan.",
  "If the detergent is still not dispensing, please contact our customer service department at 03-27700100 for further assistance.": "Jika detergen masih tidak mengeluarkan, sila hubungi bahagian perkhidmatan pelanggan kami di 03-27700100 untuk bantuan lanjut.",
  "The price displayed on the machine's screen did not change after inserting the token.": "Harga yang dipaparkan pada skrin mesin tidak berubah selepas memasukkan token.",
  "Press the small button (in the centre) to reject the tokens that have been inserted. Press a few times till the coins come out.": "Tekan butang kecil (di tengah) untuk menolak token yang telah dimasukkan. Tekan beberapa kali sehingga syiling keluar.",
  "If the coins still cannot come out or the button is not functioning, please contact our customer service line at 03-27700110 to receive further assistance.": "Jika syiling masih tidak dapat keluar atau butang tidak berfungsi, sila hubungi talian khidmat pelanggan kami di 03-27700110 untuk menerima bantuan lanjut.",
  "The machine is not starting, and it displays an error code.": "Mesin tidak dimulakan, dan ia memaparkan kod ralat.",
  "We would like to apologise for any inconvenience caused. Please contact our customer service line at 03-27700100 to receive further assistance.": "Kami ingin memohon maaf atas sebarang kesulitan yang berlaku. Sila hubungi talian khidmat pelanggan kami di 03-27700100 untuk menerima bantuan lanjut.",
  "I want to wash the clothes again, but why couldn't the machine start even after I added tokens to the machine?": "Saya ingin membasuh pakaian sekali lagi, tetapi mengapa mesin tidak dapat dihidupkan walaupun selepas saya menambah token pada mesin?",
  "Try opening and closing the door again before starting the machine.": "Cuba buka dan tutup pintu sekali lagi sebelum menghidupkan mesin.",
  "Can I change the water temperature of the machine?": "Bolehkah saya menukar suhu air mesin?",
  "Yes, but the washer temperature can only be changed from hot to cold after the machine has been started, and not from cold to hot.": "Ya, tetapi suhu mesin basuh hanya boleh ditukar daripada panas kepada sejuk selepas mesin dihidupkan, dan bukan dari sejuk kepada panas.",
  "Can I stop the machine?": "Bolehkah saya menghentikan mesin?",
  "Here are the steps to stop the machine:": "Berikut ialah langkah-langkah untuk menghentikan mesin:",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at to receive further assistance)": "Tunggu bunyi berhenti, dan kemudian buka pintu sahaja. (Jika selepas 30 minit bunyi masih tidak berhenti, sila hubungi talian khidmat pelanggan kami di untuk menerima bantuan lanjut)",
  "There is no water supply on the machine used.": "Tiada bekalan air pada mesin yang digunakan.",
  "Why is the washing temperature cold even when I have selected HOT.": "Mengapa suhu basuh sejuk walaupun saya telah memilih PANAS.",
  "The water temperature is HOT or WARM only during washing. The water will turn COLD during rinsing.": "Suhu air adalah PANAS atau SUAM hanya semasa mencuci. Air akan menjadi SEJUK semasa dibilas.",
  "The machine has already finished washing, but it does not spin well, and there is water left on the load.": "Mesin telah selesai mencuci, tetapi ia tidak berputar dengan baik, dan terdapat air yang tertinggal pada beban.",
  "Can I put wet laundry into the dryer to dry?": "Bolehkah saya memasukkan pakaian basah ke dalam pengering untuk dikeringkan?",
  "No, as the dripping wet laundry might cause the dryer to short circuit.": "Tidak, kerana cucian basah yang menitis mungkin menyebabkan pengering litar pintas.",
  "REMINDER - Refer to the labels on your clothes to know what kind of temperature is best for the kind of fabric that it uses. Then select the temperature on the machine accordingly.": "PERINGATAN - Rujuk label pada pakaian anda untuk mengetahui jenis suhu yang terbaik untuk jenis fabrik yang digunakan. Kemudian pilih suhu pada mesin dengan sewajarnya.",
  "My clothes are still wet even after drying.": "Pakaian saya masih basah walaupun sudah dijemur.",
  "How can I stop the dryer when the machine is still running?": "Bagaimanakah saya boleh menghentikan pengering apabila mesin masih berjalan?",
  "Just open the door and the machine will automatically stop.": "Buka sahaja pintu dan mesin akan berhenti secara automatik.",
  "I added extra tokens for extra times, but the machine did not update the time.": "Saya menambah token tambahan untuk masa tambahan, tetapi mesin tidak mengemas kini masa.",
  "For the time to be reflected accurately, it is recommended for you to add tokens 5 minutes before the services end.": "Untuk masa yang dapat dilihat dengan tepat, anda disyorkan untuk menambah token 5 minit sebelum perkhidmatan tamat.",
  "REMINDER - You cannot add tokens for extra times when the machine finishes the drying cycle.": "PERINGATAN - Anda tidak boleh menambah token untuk masa tambahan apabila mesin menamatkan kitaran pengeringan.",
  "Why is the machine making noise?": "Mengapa mesin membuat bising?",
  "Please check the drum to see if there are any coins or other small things inside.": "Sila periksa dram untuk melihat sama ada terdapat syiling atau benda kecil lain di dalamnya.",
  "I have pressed the START button on the dryer, but it is still not working.": "Saya telah menekan butang MULA pada pengering, tetapi ia masih tidak berfungsi.",
  "Please try to open the door and close it again. Next, press the START button again to start drying.": "Sila cuba buka pintu dan tutup semula. Seterusnya, tekan butang MULA sekali lagi untuk mula mengeringkan.",
  "If the dryer is still not functioning, please contact our customer service line at 03-27700100 to receive further assistance.": "Jika mesin pengering masih tidak berfungsi, sila hubungi talian khidmat pelanggan kami di 03-27700100 untuk menerima bantuan lanjut.",
  "Paywave has deducted an amount from the card but the machine did not reflect the transaction.": "Paywave telah menolak amaun daripada kad tetapi mesin tidak menggambarkan transaksi tersebut.",
  "The Paywave transaction has failed but the amount has still been deducted from my card.": "Transaksi Paywave telah gagal tetapi jumlahnya masih ditolak daripada kad saya.",
  "Paywave has double/triple charge but the machine cannot start.": "Paywave mempunyai caj dua kali/tiga tetapi mesin tidak boleh dihidupkan.",
  "Paywave after double/triple charge machines can't start.": "Gelombang berbayar selepas mesin caj dua/tiga kali ganda tidak boleh dimulakan.",
  "Paywave is offline": "Paywave berada di luar talian",
  "Do Cleanpro Express offer franchise business/selling machines/laundry products?": "Adakah Cleanpro Express menawarkan perniagaan francais/menjual mesin/produk dobi?",
  "For further inquiries, please email to info@cleanproexpress.com": "Untuk pertanyaan lanjut, sila e-mel ke info@cleanproexpress.com",
  "Step 6": "Langkah 6",
  "User Existed": "Pengguna Wujud",
  "This email is registered": "E-mel ini telah didaftarkan",
  "This phone number is registered": "Nombor telefon ini telah didaftarkan",
  "Invalid Email Address": "Alamat email tidak sah",
  "Let's get started!": "Jom bermula sekarang!",
  "Enter your e-mail/mobile number": "Masukkan e-mel/no telefon anda",
  "Enter your e-mail": "Masukkan emel anda",
  "Enter your mobile number": "Masukkan no telefon anda",
  "Enter your e-mail address": "Masukkan emel anda",
  "Proceed": "Teruskan",
  "Enter OTP number": "Masukkan nombor OTP",
  "You will receive a six-digit OTP via SMS sent to": "Anda akan menerima OTP enam digit melalui SMS yang dihantar kepada",
  "You will receive a six-digit OTP via e-mail sent to": "Anda akan menerima OTP enam digit melalui emel yang dihantar kepada",
  "Verify": "Sahkan",
  "Resend OTP": "Hantar semula OTP",
  "Welcome onboard!": "Selamat datang!",
  "Please fill in the info below": "Sila isikan maklumat dibawah",
  "Enter your name*": "Masukkan nama anda*",
  "Enter your email address*": "Masukkan alamat emel anda*",
  "Please enter either phone number or email address": "Sila masukkan sama ada nombor telefon atau alamat e-mel",
  "Create a password*": "Cipta kata laluan*",
  "Enter referral code (if got any)": "Masukkan kod rujukan (jika ada)",
  "Get started": "Mulakan",
  "Birthday updated successfully": "Hari lahir berjaya dikemas kini",
  "Date of birth": "Tarikh lahir",
  "Enter your date of birth": "Masukkan tarikh lahir anda",
  "Select your birth date": "Pilih tarikh lahir anda",
  "Update date of birth": "Kemas kini tarikh lahir",
  "Update birth date": "Kemas kini tarikh lahir",
  "Already have an account?": "Sudah mempunyai akaun?",
  "Login now": "Log masuk",
  "Sign in": "Log masuk",
  "Sign up now": "Daftar sekarang",
  "COMPLETED": "SELESAI",
  "WASHING NOW": "MENCUCI SEKARANG",
  "DRYING NOW": "KERING SEKARANG",
  "It's done!": "Sudah selesai!",
  "Please collect your fresh, clean laundry in order to leave the machine available for the next person to use!": "Sila kumpulkan pakaian anda yang segar dan bersih untuk membiarkan mesin tersedia untuk digunakan oleh orang seterusnya!",
  "Leave a feedback": "Tinggalkan maklum balas",
  "Time left": "Masa tinggal",
  "Add drying time": "Tambah masa",
  "Hi": "Hai",
  "customer": "pelanggan",
  "Thank you for your payment. Don't forget to select the <b>correct temperature</b> and press <b>START</b> when you're ready.": "Terima kasih atas pembayaran anda. Jangan lupa untuk memilih <b>suhu yang betul</b> dan tekan <b>MULA</b> apabila anda sudah bersedia.",
  "Select how you want to receive a notification when your laundry is finished": "Pilih cara anda mahu menerima pemberitahuan apabila pakaian anda selesai",
  "Sign up": "Daftar",
  "Continue to pay": "Terus bayar",
  "Register as a member to enjoy more benefits!": "Daftar sebagai ahli untuk menikmati lebih banyak faedah!",
  "Get FREE {{ voucherAmount }} credits per new user": "Dapatkan {{ voucherAmount }} kredit PERCUMA bagi setiap pengguna baharu",
  "Get FREE {{ voucherAmount }}% per new user": "Dapatkan {{ voucherAmount }}% PERCUMA bagi setiap pengguna baharu",
  "Enjoy exclusive promotions": "Nikmati promosi eksklusif",
  "FREE voucher on your birthday": "baucar PERCUMA pada hari lahir anda",
  "and more": "dan banyak lagi",
  "Denied camera access": "Akses kamera dinafikan",
  'Permission to access the camera has been denied. Please try again and click "Allow" to scan the QR code.': 'Kebenaran untuk mengakses kamera telah ditolak. Sila cuba lagi dan klik "Benarkan" untuk mengimbas kod QR.',
  "Okay": "Okay",
  "Oops. You don't have enough balance to make the payment": "Anda tidak mempunyai baki yang mencukupi untuk membuat pembayaran",
  "Please confirm": "Tolong sahkan",
  "Do you want to proceed with this feedback?": "Adakah anda mahu meneruskan maklum balas ini?",
  "Are you sure to purchase": "Adakah anda pasti untuk membeli",
  "credits for": "kredit dengan harga",
  "Topup credit": "Kredit tambah nilai",
  "Extended duration will be instantly reflected on machine after payment": "Tempoh lanjutan akan ditunjukkan serta-merta pada mesin selepas pembayaran",
  "Machine is currently busy": "Mesin sedang sibuk",
  "Do you want to extend drying time?": "Adakah anda ingin memanjangkan masa pengeringan?",
  // "Cuci Hari-Hari Bersama Cleanpro!": "Cuci Hari-Hari Bersama Cleanpro!",
  // "Ready for a challenge?": "Bersedia untuk menyahut cabaran?",
  // "Here's one for you - all you need to do is wash your laundry 10 times in 20 days at participating Cleanpro outlets. Stand a chance to win a Limited Edition Cleanpro Designer Laundry Bag worth up to RM40!": "Anda hanya perlu mencuci pakaian anda 10 kali dalam tempoh 20 hari di cawangan Cleanpro yang terlibat. Sertai sekarang dan menangi Beg Dobi Jenama Cleanpro Edisi Terhad bernilai sehingga RM40!",
  // "Here's how to participate:": "Cara-cara penyertaan:",
  // "Step 1: Scan the QR Code on the washer to launch Cleanpro Plus": "Langkah 1: Imbas Kod QR pada mesin basuh untuk melancarkan Cleanpro Plus",
  // "Step 2: Pay for your wash with Cleanpro Plus": "Langkah 2: Bayar cucian anda dengan Cleanpro Plus",
  // "Step 3: Complete x10 washes within 20 days to win": "Langkah 3: Ulang 10 cucian dalam masa 20 hari untuk menang",
  // "Challenge Period: 01 July - 31 August 2023": "Tempoh penyertaan: 01 Julai - 31 Ogos 2023",
  // "Drop by your nearest Cleanpro outlet to wash your laundry with us for 20 days straight! Good luck!": "Cuci pakaian anda di outlet Cleanpro yang berdekatan selama 20 hari berturut-turut! Semoga berjaya!",
  // "TERMS & CONDITIONS": "TERMA & SYARAT",
  // "PARTICIPATION CRITERIA": "KRITERIA PENYERTAAN",
  // "1) Participant needs to register an account in Cleanpro Plus web app.": "1) Peserta perlu mendaftar akaun dalam aplikasi web Cleanpro Plus.",
  // "2) Participant can use any washer of any capacity in any participating outlets to qualify for entries.": "2) Peserta boleh menggunakan mana-mana mesin basuh dalam apa jua kapasiti di mana-mana cawangan yang mengambil bahagian untuk melayakkan diri untuk penyertaan.",
  // "3) Payment needs to be made with Cleanpro Plus web app.": "3) Pembayaran perlu dibuat dengan aplikasi web Cleanpro Plus.",
  // "4) Washes must be completed and paid (with no dispute whatsoever) within campaign period.": "4) Cucian mesti disiapkan dan dibayar (tanpa apa-apa pertikaian) dalam tempoh kempen berlangsung.",
  // "5) Campaign period starts from 1st July 2023 at 00:00 and ends at 31st August 2023 at 23:59.": "5) Tempoh kempen bermula dari 1 Julai 2023 jam 00:00 dan berakhir pada 31 Ogos 2023 jam 23:59.",
  // "WINNERS & PRIZES": "PEMENANG & HADIAH",
  // "1) Cleanpro will notify the winners of the campaign via registered WhatsApp number or email address provided, within 4 weeks after the campaign ends.": "1) Cleanpro akan menghubungi pemenang kempen melalui nombor WhatsApp berdaftar atau alamat e-mel yang diberikan, dalam tempoh 4 minggu selepas kempen tamat.",
  // "2) Any unclaimed prizes after 2 weeks from notification date will not be entertained thereafter.": "2) Sebarang hadiah yang tidak dituntut selepas 2 minggu dari tarikh pemberitahuan tidak akan dilayan selepas itu.",
  // "3) Upon completing the ten (10) washes within twenty (20) days campaign, participants will be a winner and be eligible to win ONE (1) Cleanpro Designer Laundry Bag.": "3) Setelah menyelesaikan sepuluh (10) cucian dalam tempoh dua puluh (20) hari kempen, peserta akan menjadi pemenang dan layak memenangi SATU (1) Beg Dobi Cleanpro Designer.",
  // "4) Winners are eligible to win more than ONE (1) Cleanpro Designer Laundry Bag in this campaign.": "4) Pemenang layak memenangi lebih daripada SATU (1) Beg Dobi Cleanpro Designer dalam kempen ini.",
  // "5) Winners will be given the choice of his/her preferred laundry bag size; but only ONE (1) can be selected for each qualified win.": "5) Pemenang akan diberi pilihan saiz beg pakaian pilihannya; tetapi hanya SATU (1) boleh dipilih untuk setiap kemenangan yang layak.",
  // "A) XL Size - Blue bag with up to 20KG in capacity": "A) Saiz XL - Beg biru dengan kapasiti sehingga 20KG",
  // "B) L Size - White bag with up to 12KG in capacity": "B) Saiz L - Beg putih dengan kapasiti sehingga 12KG",
  // "6) Time and location for collection of prize will be informed via Whatsapp number and/or email address provided.": "6) Masa dan lokasi pengambilan hadiah akan dimaklumkan melalui nombor Whatsapp dan/atau alamat emel yang diberikan.",
  "OTHER": "LAIN",
  // "1) Changes to the terms and conditions will be at Cleanpro's discretion; without prior notice.": "1) Perubahan kepada terma dan syarat adalah atas budi bicara Cleanpro; tanpa notis awal.",
  // "2) Completed wash is defined by washes performed with Cleanpro's washer and payments within Cleanpro Plus web app are made with no disputes.": "2) Kiraan cucian hanya diterima sah oleh cucian dengan mesin basuh Cleanpro dan pembayaran dalam aplikasi web Cleanpro Plus, tanpa sebarang pertikaian.",
  // "3) By participating in this campaign automatically indicates that the Participant has agreed to all the campaign's Terms and Conditions as stipulated.": "3) Dengan menyertai kempen ini secara automatik menunjukkan bahawa Peserta telah bersetuju dengan semua Terma dan Syarat kempen seperti yang ditetapkan.",
  "Welcome Voucher": "Baucar Selamat Datang",
  "Welcome to the Cleanpro Plus family! This first gift is just the beginning. Stay tuned for a series of exciting promotions and campaigns, exclusively for Cleanpro Plus users.": "Selamat datang ke keluarga Cleanpro Plus! Ini hanyalah hadiah permulaan. Nantikan lain-lain promosi dan kempen yang menarik, istimewa untuk pengguna Cleanpro Plus.",
  "Terms & Conditions": "Terma & Syarat",
  "TERMS AND CONDITIONS": "TERMA DAN SYARAT",
  "Welcome Voucher is valid for one-time use only.": "Baucar Selamat Datang ini hanya sah untuk digunakan sekali sahaja.",
  "There is no minimum spend required for the voucher to be used.": "Tiada perbelanjaan minimum diperlukan untuk menggunakan baucar ini.",
  "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only.": "Baucar Selamat Datang ini dikreditkan secara automatik ke akaun pengguna semasa pendaftaran di Cleanpro Plus dan sah selama {{ duration }} hari sahaja.",
  "Users are eligible to use their Welcome Voucher AFTER the completion of their first wash or dry cycle using the same Cleanpro Plus account.": "Pengguna layak menggunakan Baucar Selamat Datang mereka SETELAH selesai kitaran basuh atau kering pertama mereka menggunakan akaun Cleanpro Plus yang sama.",
  "Welcome Voucher cannot be used together with any ongoing promotions or any other promotional vouchers.": "Baucar Selamat Datang ini tidak boleh digunakan bersama-sama dengan mana-mana promosi yang sedang berjalan atau mana-mana baucar promosi lain.",
  "The voucher is final and cannot be refunded in form of cash or credit to the user.": "Baucar adalah muktamad dan tidak boleh dikembalikan dalam bentuk tunai atau kredit kepada pengguna.",
  "Cleanpro reserves the right to change the terms and conditions without prior notice.": "Cleanpro berhak untuk menukar terma dan syarat tanpa notis awal.",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})": "Kumpul 10 e-setem untuk mendapatkan baucar {{ voucherAmount }} kredit PERCUMA (bernilai {{ currency }}{{ voucherAmount }})",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }}% voucher (worth {{ voucherAmount }}%)": "Kumpul 10 e-setem untuk mendapatkan baucar {{ voucherAmount }}% PERCUMA (bernilai {{ voucherAmount }}%)",
  "Collect 10 e-Stamp to earn FREE Voucher": "Kumpul 10 e-setem untuk mendapatkan baucar PERCUMA",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding.": "Dengan setiap 10 e-setem yang terkumpul, anda akan menerima baucar PERCUMA {{ voucherAmount }} kredit (bernilai {{ currency }}{{ voucherAmount }}). Jadikan rutin cucian bukan sahaja mudah, tetapi juga bermanfaat untuk anda.",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }}% credits voucher (worth {{ voucherAmount }}%). Make your laundry routine not just hassle-free, but also rewarding.": "Dengan setiap 10 e-setem yang terkumpul, anda akan menerima baucar PERCUMA {{ voucherAmount }}% (bernilai {{ voucherAmount }}%). Jadikan rutin cucian bukan sahaja mudah, tetapi juga bermanfaat untuk anda.",
  // "How to participate:": "Cara-cara penyertaan:",
  // "Prizes to be won:": "Hadiah untuk dimenangi:",
  "RM10 OFF Welcome Voucher": "DISKAUN RM10 Baucar Selamat Datang",
  "Welcome to the Cleanpro family, here is an appreciation voucher from us. Thank you for attending the COPE Investors Conference.": "Selamat datang ke keluarga Cleanpro, berikut adalah baucar penghargaan daripada kami. Terima kasih kerana menghadiri Persidangan Pelabur COPE.",
  "Welcome Voucher | COPE Investors Conference": "Baucar Selamat Datang | Persidangan Pelabur COPE",
  "Payment methods": "Kaedah pembayaran",
  "Tap to proceed with your preferred mode of payment": "Pilih kaedah yang anda inginkan untuk meneruskan pembayaran",
  "Cleanpro Plus credits": "Kredit Cleanpro Plus",
  "E-wallet or credit/debit cards": "E-dompet atau kad debit/kredit",
  "Go to homepage": "Pergi ke laman utama",
  // backend response or error
  "Admin is unauthorized to login": "Admin tidak dibenarkan untuk log masuk",
  "Internal Error": "Masalah dalaman",
  "Please enter the correct credentials": "Sila masukkan bukti kelayakan yang betul",
  "Operator not found": "Operator tidak ditemui",
  "Admin not found": "Admin tidak ditemui",
  "Distributor not found": "Pengedar tidak ditemui",
  "Client not found": "Pelanggan tidak ditemui",
  "Outlet not found": "Outlet tidak ditemui",
  "Token Package not found": "Pakej Token tidak ditemui",
  "Top up history not found": "Sejarah tambah nilai tidak ditemui",
  "Voucher not found": "Baucar tidak ditemui",
  "Faq not found": "Soalan Lazim tidak ditemui",
  "Faq Group not found": "Kumpulan Soalan Lazim tidak ditemui",
  "News not found": "Berita tidak ditemui",
  "Transaction not found": "Transaksi tidak ditemui",
  "Please Login Again": "Sila Log Masuk Semula",
  "Decoding Error": "Ralat Penyahkodan",
  "Some error occured, please contact the dev team if this error continues.": "Beberapa ralat telah berlaku, sila hubungi pasukan pembangun jika ralat ini berterusan.",
  "Please fill in all the required fields": "Sila isi semua medan yang diperlukan",
  "Only success transaction can be refund": "Hanya transaksi yang berjaya boleh dikembalikan",
  "Only token payment method can be refund": "Hanya kaedah pembayaran token boleh dikembalikan",
  "The discount code has been used, please change to other code": "Kod diskaun telah digunakan, sila tukar kepada kod lain",
  "Cannot use ewallet in sandbox": "Tidak boleh menggunakan ewallet dalam sandbox",
  "Please close the door to proceed your payment": "Sila tutup pintu untuk meneruskan pembayaran anda",
  "Under Maintenance": "Sedang Dibaiki",
  "This machine is being fixed. Please use another machine.": "Mesin ini sedang dibaiki. Sila guna mesin lain.",
  "Machine is currently running, please try again later": "Mesin sedang berjalan, sila cuba sebentar lagi",
  "Machine is currently offline, please try again later": "Mesin sedang di luar talian, sila cuba sebentar lagi",
  "Outlet not participating in Loyalty program": "Outlet tidak menyertai program Kesetiaan",
  "Please log in to make the payment": "Sila log masuk untuk membuat pembayaran",
  "Package not found, please refresh and try again": "Pakej tidak ditemui, sila muat semula dan cuba lagi",
  "You have reached the maximum number of purchase": "Anda telah mencapai bilangan maksimum pembelian",
  "Store not found, please try again later": "Kedai tidak ditemui, sila cuba sebentar lagi",
  "Incorrect Password": "Kata laluan salah",
  "Token already top up": "Token sudah tambah nilai",
  "Payment failed": "Pembayaran gagal",
  "Transaction Failure": "Kegagalan Transaksi",
  "Transaction Refunded": "Transaksi telah dibayar balik",
  "Transaction Pending": "Transaksi Belum Selesai",
  "Please enter your mobile number": "Sila masukkan nombor telefon bimbit anda",
  "User is unauthorized to register": "Pengguna tidak dibenarkan mendaftar",
  "Please proceed to sign up": "Sila teruskan untuk mendaftar",
  "OTP expired, please request a new OTP": "OTP tamat tempoh, sila minta OTP baharu",
  "Incorrect verification code": "Kod pengesahan yang salah",
  "This referrer ID is not valid": "ID perujuk ini tidak sah",
  "This referrer ID is different operator": "ID perujuk ini adalah pengendali yang berbeza",
  "This referrer ID is exceed the limit": "ID perujuk ini melebihi had",
  "User is unauthorized to login": "Pengguna tidak dibenarkan untuk log masuk",
  "Click here to register": "Klik di sini untuk mendaftar",
  "User is unauthorized to login. Please contact the admin": "Pengguna tidak dibenarkan untuk log masuk. Sila hubungi admin",
  "User is unauthorized": "Pengguna tidak dibenarkan",
  "This outlet does not participate in the Loyalty Program": "Cawangan ini tidak menyertai Program Kesetiaan",
  "This outlet is not belongs to the operator": "Cawangan ini bukan milik pengendali",
  "Processing request": "Permintaan sedang memproses",
  "This user is not verified": "Pengguna ini tidak disahkan",
  "Insufficient token to make payment": "Token tidak mencukupi untuk membuat pembayaran",
  "Insufficient token to transfer": "Token tidak mencukupi untuk dipindahkan",
  "Insufficient point to make payment": "Point tidak mencukupi untuk membuat pembayaran",
  "This voucher is not available for use": "Baucar ini tidak tersedia untuk digunakan",
  "This voucher is belongs to other user": "Baucar ini adalah milik pengguna lain",
  "Invalid Discount Code": "Kod Diskaun Tidak Sah",
  "This discount code cannot use in this outlet": "Kod diskaun ini tidak boleh digunakan di kedai ini",
  "This discount code was expired": "Kod diskaun ini telah tamat tempoh",
  "This discount code cannot use in washer machine transaction": "Kod diskaun ini tidak boleh digunakan dalam transaksi mesin basuh",
  "This discount code cannot use in dryer machine transaction": "Kod diskaun ini tidak boleh digunakan dalam transaksi mesin pengering",
  "This discount code was fully redeemed today, try again tomorrow": "Kod diskaun ini telah ditebus sepenuhnya hari ini, esok cuba lagi",
  "You have fully redeemed this discount code": "Anda telah menebus sepenuhnya kod diskaun ini",
  "This discount code have been redeemed": "Kod diskaun ini telah ditebus",
  "This discount code is not applicable": "Kod diskaun ini tidak berkenaan",
  "Insufficient stamp": "Setem tidak mencukupi",
  "Please provide at least one voucher setting": "Sila berikan sekurang-kurangnya satu tetapan baucar",
  "Previous batch are still generating, please try again later": "Kumpulan sebelumnya masih menjana, sila cuba lagi kemudian",
  "Number of voucher code should be more than 0": "Bilangan kod baucar hendaklah lebih daripada 0",
  "Number of voucher code should be less than 50000": "Bilangan kod baucar hendaklah kurang daripada 50000",
  "Number of discount code should be more than 0": "Bilangan kod diskaun hendaklah lebih daripada 0",
  "Number of discount code should be less than 50000": "Bilangan kod diskaun hendaklah kurang daripada 50000",
  "No Item": "Tiada item",
  "Please add item": "Sila tambah item",
  "Staff not found": "Kakitangan tidak ditemui",
  "This task already completed": "Tugasan ini telah selesai",
  "Please complete the wash task first": "Sila selesaikan tugas mencuci dahulu",
  "Please complete the dry task first": "Sila selesaikan tugas kering dahulu",
  "Please select at least one outlet": "Sila pilih sekurang-kurangnya satu kedai",
  "Touch to Start": "Sentuh untuk Mulakan",
  "New Users": "Pengguna Baru",
  "Get {{ voucher_amount }} FREE Credits!": "Dapatkan {{ voucher_amount }} Kredit PERCUMA!",
  "Get {{ voucher_amount }}% FREE!": "Dapatkan {{ voucher_amount }}% PERCUMA!",
  "Load your clothes into the washing machine & note the machine number": "Muatkan pakaian anda ke dalam mesin basuh & catatkan nombor mesin",
  "T&C Apply": "T&S Terpakai",
  "Mobile Number": "Nombor Telefon Bimbit",
  "Member": "Ahli",
  "Please enter your mobile phone number / e-mail": "Sila masukkan nombor telefon bimbit / e-mel anda",
  "Please verify your number": "Sila sahkan nombor anda",
  "Please verify your e-mail": "Sila sahkan emel anda",
  "Please enter the correct phone number format. Example: 01xxxxxxxx": "Sila masukkan format nombor telefon yang betul. Contoh: 01xxxxxxxx",
  "Please enter the correct phone number format. Example: 09xxxxxxxx": "Sila masukkan format nombor telefon yang betul. Contoh: 09xxxxxxxx",
  "Scan QR to Complete your signup & access more benefits!": "Imbas QR untuk Menyelesaikan pendaftaran anda & akses lebih banyak faedah!",
  "Please choose your service": "Sila pilih perkhidmatan anda",
  "WASHER": "MESIN BASUH",
  "DRYER": "MESIN PENGERING",
  "VENDING MACHINE": "MESIN LAYAN DIRI",
  "Please tap your card on the reader": "Sila ketik kad anda pada pembaca",
  "Payment Option": "Pilihan Pembayaran",
  "Thank you for payment!": "Terima kasih atas pembayaran!",
  "Please select your items at the vending machine": "Sila pilih item anda di mesin layan diri",
  "Please choose the temperature on the machine and press": "Sila pilih suhu pada mesin dan tekan",
  "START": "MULA",
  "Need Help?": "Perlukan Bantuan?",
  "Please choose the temperature": "Sila pilih suhu",
  "Confirm Payment": "Sahkan Pembayaran",
  "Select the time for": "Pilih masa untuk",
  "Do you want to add drying time?": "Adakah anda mahu menambah masa pengeringan?",
  "minutes": "minit",
  "Your machine is": "Mesin anda ialah",
  "Please Collect your item from the vending machine": "Sila ambil barang anda dari mesin layan diri",
  "You've earned 1 e-stamp for your wash!": "Anda telah memperoleh 1 e-cop untuk cucian anda!",
  "You've earned 1 e-stamp for your dry!": "Anda telah memperoleh 1 e-setem untuk kering anda!",
  "You've missed 1 e-stamp for your wash!": "Anda telah terlepas 1 e-cop untuk cucian anda!",
  "You've missed 1 e-stamp for your dry!": "Anda telah terlepas 1 e-cop untuk kering anda!",
  "Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "Kumpul 10 e-setem Basuh untuk mendapatkan baucar kredit {{ amount }} PERCUMA.",
  "Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "Kumpul 10 e-setem Basuh untuk memperoleh baucar {{ amount }}%.",
  "Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "Kumpul 10 e-setem Kering untuk mendapatkan baucar kredit {{ amount }} PERCUMA.",
  "Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "Kumpul 10 e-setem Kering untuk memperoleh baucar {{ amount }}%.",
  "Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "Kumpul 10 e-setem Basuh & Kering untuk mendapatkan baucar kredit {{ amount }} PERCUMA.",
  "Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "Kumpul 10 e-setem Basuh & Kering untuk memperoleh baucar {{ amount }}%.",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "Daftar & Kumpul 10 e-setem Basuh & Kering untuk mendapatkan baucar kredit {{ amount }} PERCUMA.",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "Daftar & Kumpul 10 e-setem Basuh & Kering untuk memperoleh baucar {{ amount }}%.",
  "Sign Up & Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "Daftar & Kumpul 10 e-setem Basuh untuk mendapatkan baucar kredit {{ amount }} PERCUMA.",
  "Sign Up & Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "Daftar & Kumpul 10 e-setem Basuh untuk memperoleh baucar {{ amount }}%.",
  "Sign Up & Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "Daftar & Kumpul 10 e-setem Kering untuk mendapatkan baucar kredit {{ amount }} PERCUMA.",
  "Sign Up & Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "Daftar & Kumpul 10 e-setem Kering untuk memperoleh baucar {{ amount }}%.",
  'For iOS users, press and hold the image, then choose "Add to Photos" or "Save in Photos" from the menu.': 'Untuk pengguna iOS, tekan dan tahan imej, kemudian pilih "Add to Photos" atau "Save in Photos" daripada menu.',
  "Scan the QR code to pay": "Imbas kod QR untuk membayar",
  "QR Code expires in {{ countdown }} seconds": "Kod QR tamat tempoh dalam {{ countdown }} saat",
  "Transfer In": "Pindahan Masuk",
  "Migrate": "Migrasi",
  "Update": "Kemas Kini",
  "Transfer Out": "Pindahan Keluar",
  "Total In": "Jumlah Masuk",
  "Total Out": "Jumlah Keluar",
  "Laundry Pass": "Pas Dobi",
  "Number of wash": "Bilangan cucian",
  "Number of Wash": "Bilangan Cucian",
  "Number of dry": "Bilangan kering",
  "Number of Dry": "Bilangan Kering",
  "Laundry Pass Purchase": "Pembelian Pas Dobi",
  "Laundry Pass Purchase Report": "Laporan Pembelian Pas Dobi",
  "Please select distributor or operator": "Sila pilih pengedar atau operator",
  "Price should be more than 0": "Harga hendaklah lebih daripada 0",
  "Number of wash or dry should be more than 0": "Bilangan basuh atau kering hendaklah lebih daripada 0",
  "Number of wash should be more than 0": "Bilangan cucian hendaklah lebih daripada 0",
  "Number of dry should be more than 0": "Bilangan kering hendaklah lebih daripada 0",
  "Duration must be more than 0": "Tempoh mestilah lebih daripada 0",
  "Please fill in the name": "Sila isikan nama",
  "Purchase Start Date": "Tarikh Mula Pembelian",
  "Purchase End Date": "Tarikh Tamat Pembelian",
  "Number of Maximum Purchase": "Bilangan Pembelian Maksimum",
  "Create Laundry Pass": "Buat Pas Dobi",
  "Select Purchase Period": "Pilih Tempoh Pembelian",
  "If ticked, the Laundry Pass will have expired date": "Jika ditandakan, Pas Dobi akan mempunyai tarikh luput",
  "Laundry Pass Lifespan": "Jangka Hayat Pas Dobi",
  "Edit Laundry Pass": "Edit Pas Dobi",
  "Washer Used Date": "Tarikh Digunakan Pencuci",
  "Dryer Used Date": "Tarikh Digunakan Pengering",
  "Laundry Pass Purchase History": "Sejarah Pembelian Pas Dobi",
  "Laundry Pass Usage Report": "Laporan Penggunaan Pas Dobi",
  "Please Note! (Stacked Dryer)": "Sila Ambil Perhatian! (Pengering Bertindan)",
  "Ensure machine is vacant and select correct machine after payment press START": "Pastikan mesin kosong dan pilih mesin yang betul selepas pembayaran tekan START",
  "Start date": "Tarikh mula",
  "End date": "Tarikh tamat",
  "Today": "Hari ini",
  "Yesterday": "Semalam",
  "Last 7 Days": "7 Hari Lepas",
  "Last 30 Days": "30 Hari Lepas",
  "This Month": "Bulan Ini",
  "Last Month": "Bulan Lepas",
  "Use Per Day": "Penggunaan Maksimum Sehari",
  "Maximum use per day must be more than 0": "Penggunaan maksimum setiap hari mestilah lebih daripada 0",
  "Only applicable to selected outlet": "Hanya terpakai untuk outlet terpilih",
  "Applicable to all the outlets except selected outlet": "Terpakai untuk semua cawangan kecuali outlet terpilih",
  "If applicable to all the outlet, leave it blank": "Jika terpakai untuk semua cawangan, biarkan kosong",
  "Only applicable to selected weight": "Hanya terpakai untuk berat yang dipilih",
  "Applicable to all the weight except selected weight": "Terpakai untuk semua berat kecuali berat terpilih",
  "Weight": "Berat",
  "If applicable to all the weight, leave it blank": "Jika terpakai untuk semua berat, biarkan kosong",
  "Add Weight": "Tambah Berat",
  "Only applicable to selected mode": "Hanya terpakai untuk mod terpilih",
  "Applicable to all the modes except selected mode": "Terpakai untuk semua mod kecuali mod yang dipilih",
  "If applicable to all the mode, leave it blank": "Jika terpakai untuk semua mod, biarkan kosong",
  "Add Mode": "Tambah Mod",
  "Laundry Pass not applicable in this outlet": "Pas Dobi tidak terpakai di kedai ini",
  "Discounted price should be more than 0": "Harga diskaun hendaklah lebih daripada 0",
  "Discounted Price": "Harga Diskaun",
  "Logo (Optional)": "Logo (Pilihan)",
  "Save": "Jimat",
  "Cleanpro Laundry Pass": "Cleanpro Laundry Pass",
  "Save more with the Laundry Pass — ": "Jimat lebih banyak dengan pembelian Laundry Pass — ",
  "wash and dry more clothes at a lower price while enjoying extra rewards from Cleanpro Plus!": "cuci dan keringkan lebih banyak pakaian pada harga berpatutan serta nikmati lebih banyak ganjaran dari Cleanpro Plus!",
  "How to Purchase Laundry Pass": "Cara Membeli Laundry Pass",
  "Step 1: Register as a Cleanpro Plus user.": "Langkah 1: Mendaftar sebagai ahli Cleanpro Plus.",
  "Step 2: Choose the Laundry Pass package you wish to purchase.": "Langkah 2: Pilih pakej Laundry Pass yang ingin anda beli.",
  "Step 3: Make the payment through Cleanpro Plus.": "Langkah 3: Lakukan pembayaran melalui Cleanpro Plus.",
  "Step 4: Enjoy washing and drying services at any Cleanpro outlet in Malaysia with exclusive discounted prices!": "Langkah 4: Nikmati perkhidmatan cucian dan pengeringan di mana-mana cawangan Cleanpro di Malaysia dengan harga diskaun eksklusif!",
  "By purchasing and/or using the Cleanpro Laundry Pass, you agree to be bound by the following terms and conditions:": "Dengan membeli dan/atau menggunakan Cleanpro Laundry Pass, anda bersetuju untuk terikat dengan terma dan syarat berikut:",
  "Definitions": "Definisi",
  '"Laundry Pass" refers to the package(s) for specific laundry services offered by Cleanpro.': '"Laundry Pass" merujuk kepada pakej perkhidmatan dobi tertentu yang ditawarkan oleh Cleanpro.',
  '"Subscriber" refers to the individual(s) purchasing and/or using the Laundry Pass.': '"Pelanggan" merujuk kepada individu yang membeli dan/atau menggunakan Laundry Pass.',
  "Pass Description": "Penerangan Pass",
  "The Laundry Pass is a promotional package that offers laundry services at any Cleanpro outlet in Malaysia.": "Laundry Pass adalah pakej promosi yang menawarkan perkhidmatan dobi di mana-mana cawangan Cleanpro di Malaysia sahaja.",
  'The Laundry Pass is valid for both Malaysians and non-Malaysians; and is exclusively available to Cleanpro Plus members.': 'Laundry Pass sah untuk rakyat Malaysia dan bukan rakyat Malaysia; dan hanya tersedia untuk ahli Cleanpro Plus.',
  "The campaign of Laundry Pass is valid from": "Kempen Laundry Pass adalah sah dari",
  "1 March 2025 to 31 May 2025.": "1 Mac 2025 hingga 31 Mei 2025.",
  'Each Laundry Pass subscription is': 'Setiap langganan Laundry Pass',
  'valid for 30 days from the start date,': 'sah selama 30 hari dari tarikh mula,',
  'allowing subscribers to use the package': 'membolehkan pelanggan menggunakan pakej',
  'up to 4 times per day.': 'sehingga 4 kali sehari.',
  'During the promotional period, subscribers can repurchase the package unlimited times, but only after fully utilizing your current subscription.': 'Semasa tempoh promosi, pelanggan boleh membeli semula pakej ini tanpa had, tetapi hanya selepas sepenuhnya menggunakan langganan pelanggan yang sedia ada.',
  "The Laundry Pass is": "Laundry Pass",
  "valid only for cold wash and drying of machines under 25kg.": "sah untuk cucian sejuk dan pengering bagi mesin hanya dibawah 25kg sahaja.",
  "Additional charges will apply for warm and hot wash services, based on the temperature selected.": "Caj tambahan akan dikenakan untuk setiap cucian suam dan panas, bergantung kepada suhu yang dipilih.",
  'Unused wash or dry session(s) from the Laundry Pass cannot be carried forward to the next purchase, and are non-refundable, non-exchangeable for cash, and non-transferable.': 'Sesi cucian atau pengeringan yang tidak digunakan dari Laundry Pass tidak boleh dibawa ke pembelian seterusnya, dan tidak boleh dipulangkan, ditukar dengan wang tunai, atau dipindahkan.',
  'The Laundry Pass is valid for washing and/or drying standard laundry items only (e.g., clothing, linens), excluding large items (e.g., rugs), heavily soiled items (e.g., pet bedding), or specialty items requiring special treatment.': 'Laundry Pass sah hanya untuk mencuci dan/atau mengeringkan barangan dobi standard sahaja (contohnya, pakaian, linen), tidak termasuk barangan besar (contohnya, permaidani), barangan yang sangat kotor (contohnya, tempat tidur haiwan peliharaan), atau barangan khas yang memerlukan rawatan khas.',
  'The Laundry Pass can be cancelled within the first 7 days of subscription for a full refund, provided the subscriber has not used the Laundry Pass during this period. No refunds or transfers will be issued after the first 7 days.': 'Laundry Pass boleh dibatalkan dalam tempoh 7 hari pertama langganan untuk pemulangan penuh, dengan syarat pelanggan tidak menggunakan Laundry Pass dalam tempoh ini. Tiada pemulangan atau pemindahan akan diberikan selepas 7 hari pertama.',
  "Refund process may take up to 21 working days.": "Proses pemulangan wang mungkin mengambil masa sehingga 21 hari bekerja.",
  'Subscribers are encouraged to regularly check Cleanpro Plus for reminders regarding the expiry date of their laundry pass.': 'Pelanggan digalakkan untuk memeriksa Cleanpro Plus secara berkala untuk peringatan mengenai tarikh luput pas dobi mereka.',
  "This promotion is not valid in conjunction with the '10 Free 1 e-Stamp Campaign'.": "Promosi ini tidak sah bersama dengan Kempen '10 Percuma 1 e-Stamp'.",
  "Any misuse of the Laundry Pass will result in the immediate termination of the subscription without prior notice. Payments for the Laundry Pass are non-refundable, non-exchangeable for cash, and non-transferable.": "Sebarang penyalahgunaan Laundry Pass akan mengakibatkan pembatalan langganan serta-merta tanpa pemberitahuan terlebih dahulu. Pembayaran untuk Laundry Pass adalah tidak boleh dipulangkan, tidak boleh ditukar dengan wang tunai, dan tidak boleh dipindahkan.",
  "Payment must be made in full at the time of subscription via Cleanpro Plus.": "Pembayaran mestilah dibuat sepenuhnya semasa langganan melalui Cleanpro Plus.",
  "For any questions or assistance regarding the Laundry Pass, please email Cleanpro Customer Service at enquiry@cleanpro.asia.": "Untuk sebarang pertanyaan atau bantuan mengenai Laundry Pass, sila emel ke khidmat pelanggan Cleanpro di enquiry@cleanpro.asia.",
  "Cleanpro reserves the right to change the terms and conditions at any time without prior notice.": "Cleanpro berhak untuk mengubah terma dan syarat pada bila-bila masa tanpa pemberitahuan terlebih dahulu.",
  "Search": "Cari",
  "Scan to register as a member": "Imbas untuk mendaftar sebagai ahli",
  "Select Product / Key in Amount": "Pilih Produk / Masukkan Amaun",
  "Discount code is not available in this payment type": "Kod diskaun tidak tersedia dalam jenis pembayaran ini",
  "This voucher is not available use in washer payment": "Baucar ini tidak tersedia untuk digunakan dalam pembayaran mesin basuh",
  "This voucher is not available use in dryer payment": "Baucar ini tidak boleh digunakan dalam pembayaran pengering",
  "This voucher is not available use in Drop n Go payment": "Baucar ini tidak tersedia untuk digunakan dalam pembayaran Drop n Go",
  "Voucher is not available in this payment type": "Baucar tidak tersedia dalam jenis pembayaran ini",
  "Select the price for": "Pilih harga untuk",
  "Enable Stamping": "Dayakan Setem",
  "Please select your preferred outlet": "Sila pilih outlet pilihan anda",
  "Select your preferred outlet": "Pilih outlet pilihan anda",
  "State": "Negeri",
  "Select State": "Pilih Negeri",
  "Payment Successful!": "Pembayaran Berjaya!",
  "Thank you for purchasing Laundry Pass!": "Terima kasih kerana membeli Pas Dobi!",
  "Your Laundry Pass expired on": "Pas Dobi anda telah tamat tempoh pada",
  "You have used all your Laundry Pass": "Anda telah menggunakan semua Pas Dobi anda",
  "Purchase Again": "Beli Lagi",
  "Save Big!": "Jimat Besar!",
  "You've saved": "Anda telah jimat",
  "on your package!": "untuk pakej anda!",
  "Please select distributor, operator or outlet": "Sila pilih pengedar, pengendali atau kedai",
  "Please enter your mobile phone number or e-mail": "Sila masukkan nombor telefon bimbit atau e-mel anda",
  "We’ll send you an SMS when your laundry’s ready": "Kami akan menghantar SMS apabila cucian anda siap",
  "Skip": "Langkau",
  "Notice": "Notis",
  "User exists but not verified. Please verify your account by scanning the QR Code at Thank You Page.": "Pengguna wujud tetapi tidak disahkan. Sila sahkan akaun anda dengan mengimbas Kod QR di Halaman Terima Kasih.",
  "User registered successfully. Please complete verification by scanning the QR Code at Thank You Page.": "Pengguna berjaya mendaftar. Sila lengkapkan pengesahan dengan mengimbas Kod QR di Halaman Terima Kasih.",
  "Please enter email address to register": "Sila masukkan alamat e-mel untuk mendaftar",
  "Please enter phone number to register": "Sila masukkan nombor telefon untuk mendaftar",
  "Camera permission is denied": "Kebenaran kamera ditolak",
  "No camera device found": "Tiada peranti kamera ditemui",
  "Camera is already in use by another app": "Kamera sudah digunakan oleh apl lain",
  "Preferred Outlet": "Outlet Pilihan",
  "Purchase Now": "Beli Sekarang",
  "Cancel Date": "Tarikh Batal",
  "Cancel Laundry Pass": "Batal Laundry Pass",
  "Download or takes a screenshot of the QR code.": "Muat turun atau ambil tangkapan skrin kod QR.",
  "Launch and login banking app.": "Lancarkan dan log masuk aplikasi perbankan.",
  "Choose QR code from your gallery.": "Pilih kod QR daripada galeri anda.",
  "1 March 2025 - 30 April 2025": "1 Mac 2025 - 30 April 2025",
  "Payment Method to get point": "Kaedah Pembayaran untuk mendapatkan point",
  "Payment Method to get voucher": "Kaedah Pembayaran untuk mendapatkan baucar",
  "If applicable to all the payment method, leave it blank": "Jika berkenaan dengan semua kaedah pembayaran, biarkan ia kosong",
  "Add {{ currency }} {{ amount }} for {{ mode }} Wash": "Tambah {{ currency }} {{ amount }} untuk {{ mode }} Cuci",
  "Add {{ currency }} {{ amount }} for an extra {{ runtime }} minutes!": "Tambahkan {{ currency }} {{ amount }} untuk tambahan {{ runtime }} minit!",
  "via": "melalui",
  "Cash": "Wang tunai",
  "Are you sure you have collected your laundry?": "Adakah anda pasti anda telah mengumpul pakaian anda?",
  "Collected All": "Semua Dikumpulkan",
  "Collected": "Dikumpulkan",
  "Are you sure the customer have collected the laundry?": "Adakah anda pasti pelanggan telah mengumpul pakaian?",
  "Pending Payment (Cash)": "Pembayaran Menunggu (Tunai)",
  "You have received the cash payment": "Anda telah menerima bayaran tunai",
  "Print Receipt": "Cetak Resit",
  "Are you sure you want to print receipt?": "Adakah anda pasti mahu mencetak resit?",
  "Are you sure you want to print sticker?": "Adakah anda pasti mahu mencetak pelekat?",
  "Copy": "Salin",
  "low": "rendah",
  "medium": "sederhana",
  "high": "tinggi",
  "About Us": "Tentang Kami",
  "ABOUT US": "TENTANG KAMI",
  "Only can request einvoice for Malaysia Outlet": "Hanya boleh meminta einvois untuk Malaysia Outlet",
  "E-Invoice requested successfully": "E-Invois berjaya diminta",
  "Select machine": "Pilih mesin",
  "Select transaction date": "Pilih tarikh transaksi",
  "Transaction Time": "Masa Transaksi",
  "Select transaction time": "Pilih masa transaksi",
  "Transaction Amount": "Jumlah Transaksi",
  "Enter Transaction Amount, Example: 1.50": "Masukkan Jumlah Transaksi, Contoh: 1.50",
  "Select payment method": "Pilih kaedah pembayaran",
  "Cashless (e-Wallet / DuitNow QR)": "Tanpa Tunai (e-Dompet / DuitNow QR)",
  "Paywave (Tap with Debit/Credit Card)": "Paywave (Ketik dengan Kad Debit/Kredit)",
  "Request as": "Minta sebagai",
  "Individual": "Individu",
  "Company": "Syarikat",
  "ID Type": "Jenis ID",
  "Select ID Type": "Pilih Jenis ID",
  "Company Name": "Nama Syarikat",
  "Phone": "Telefon",
  "Address": "Alamat",
  "City": "Bandar",
  "Postcode": "Poskod",
  "Request E-Invoice": "Minta E-Invois",
  "Request e-Invoice": "Minta e-Invois",
  "e-Invoice Validation Link": "Pautan Pengesahan e-Invois",
  "Credit Card": "Kad Kredit",
  "Credit Card Number": "Nombor Kad Kredit",
  "Credit Card Expiry Month": "Bulan Tamat Kad Kredit",
  "Credit Card Expiry Year": "Tahun Tamat Kad Kredit",
  "Credit Card Securtiy Code": "Kod Keselamatan Kad Kredit",
  "Credit Card Holder Name": "Nama Pemegang Kad Kredit",
  "Settlement Amount": "Jumlah Penyelesaian",
  "Paid": "Bayar",
  "Enable E-Wallet Payment?": "Dayakan Pembayaran E-Dompet?",
  "Enable DuitNow Payment?": "Dayakan Pembayaran DuitNow?",
  "Enable Credit Card Terminal Payment?": "Dayakan Pembayaran Terminal Kad Kredit?",
  "Transaction date is more than 3 days": "Tarikh transaksi melebihi 3 hari",
  "Select Recurrence Type": "Pilih Jenis Kekerapan",
  "Multiple Voucher": "Baucar Berganda",
  "Period for giving next voucher (days)": "Tempoh untuk memberi baucar seterusnya (hari)",
  "General Voucher Code Report": "Laporan Kod Baucar Am",
  "Unique Voucher Code Report": "Laporan Kod Baucar Unik",
  "Select Code": "Pilih Kod",
  "Minimum transaction amount to use code cannot be negative": "Jumlah transaksi minimum untuk menggunakan kod tidak boleh negatif",
  "Redeem per user must at least 1": "Bilangan tebus setiap pengguna mestilah sekurang-kurangnya 1",
  "Start date must before end date": "Tarikh mula mestilah sebelum tarikh tamat",
  "Please select the start date and end date": "Sila pilih tarikh mula dan tarikh tamat",
  "Please enter the voucher code": "Sila masukkan kod baucar",
  "Successfully create the voucher code": "Berjaya mencipta kod baucar",
  "General Voucher Code": "Kod Baucar Am",
  "Unique Voucher Code": "Kod Baucar Unik",
  "Add Voucher Code": "Tambah Kod Baucar",
  "How many times the voucher code can be used for each user": "Berapa kali kod baucar boleh digunakan untuk setiap pengguna",
  "Update Version": "Kemas kini Versi",
  "User profile updated successfully": "Profil pengguna berjaya dikemas kini",
  "Salutation": "Gelaran",
  "Nationality": "Kewarganegaraan",
  "Race": "Bangsa",
  "Gender": "Jantina",
  "Update salutation": "Kemas kini gelaran",
  "Update ID Type": "Kemas kini Jenis ID",
  "Update Address": "Kemas kini Alamat",
  "Update nationality": "Kemas kini kewarganegaraan",
  "Male": "Lelaki",
  "Female": "Perempuan",
  "Update gender": "Kemas kini jantina",
  "Number of Point cannot be 0": "Bilangan Mata tidak boleh 0",
  "Token value cannot be 0": "Nilai token tidak boleh 0",
  "Activate": "Aktifkan",
  "Deactivate": "Nyahaktifkan",
  "Activate User": "Aktifkan Pengguna",
  "Deactivate User": "Nyahaktifkan Pengguna",
  "Are you sure you want to activate the user account?": "Adakah anda pasti mahu mengaktifkan akaun pengguna?",
  "Are you sure you want to deactivate the user account?": "Adakah anda pasti mahu menyahaktifkan akaun pengguna?",
  "Your point redemption is successful": "Penebusan mata anda berjaya",
  "Point Redemption": "Penebusan Mata",
  "This redemption has already been completed": "Penebusan ini telah selesai",
  "Transaction Details": "Butiran Transaksi",
  "Please login to redeem point": "Sila log masuk untuk menebus mata",
  "Login as {{name}}": "Log masuk sebagai {{name}}",
  "Payment Amount Settings": "Tetapan Jumlah Pembayaran",
  "Allow washer pay less than cheapest mode price?": "Benarkan mesin basuh membayar kurang daripada harga mod termurah?",
  "Allow dryer pay less than minimum price?": "Benarkan pengering membayar kurang daripada harga minimum?",
  "Drop n Go Settings": "Tetapan Drop n Go",
  "Allow user pay for specific service only?": "Benarkan pengguna membayar untuk perkhidmatan tertentu sahaja?",
  "Display pricing for each service?": "Papar harga untuk setiap perkhidmatan?",
  "Delete Voucher": "Hapuskan Baucar",
  "Are you sure you want to delete this voucher?": "Adakah anda pasti ingin menghapuskan baucar ini?",
  "Display in Promotion Page": "Tampilkan di Halaman Promosi",
  "Add Promotion": "Tambah Promosi",
  "Select Transaction Status": "Pilih Status Transaksi",
  "Give Stamp for Drop n Go Transaction?": "Berikan Setem untuk Transaksi Drop n Go?",
  "Display machine capacity?": "Papar kapasiti mesin?",
  "External Voucher Code": "Kod Baucar Luaran",
  "Import Voucher Code": "Import Kod Baucar",
  "Voucher Code Stamp Settings": "Tetapan Setem Kod Baucar",
  "Upload Date": "Tarikh Muat Naik",
  "Import External Voucher Code": "Import Kod Baucar Luaran",
  "Import": "Import",
  "Please select a valid CSV file": "Sila pilih fail CSV yang sah",
  "Redeemed": "Telah ditebus",
  "Sales": "Jualan",
  "Drop N Go Dashboard": "Drop N Go Papan Pemuka",
  "Total Drop N Go Sales by Month": "Jumlah Jualan Drop N Go Mengikut Bulan",
  "Total Drop N Go Sales by Day": "Jumlah Jualan Drop N Go Mengikut Hari",
}

const translationZh = {
  "LOGIN": "登录",
  "REGISTER": "注册",
  "SKIP TO PAYMENT": "直接付款",
  "Continue as guest": "以访客身份继续",
  "WELCOME": "欢迎",
  "Error": "错误",
  "Please enter the correct phone number format. <br /><br /> <small>Example: 0129465628</small>": "请输入正确的电话号码格式。 <br /><br /> <small>例如: 0129465628</small>",
  "Info": "信息",
  "Please scan QRCode to Login": "请扫描二维码登录",
  "Forgot Password": "忘记密码",
  "Seems like you have forgotten your password<br />Create a temporary password?": "好像忘记密码了<br />创建临时密码？",
  "Cancel": "取消",
  "Confirm": "确认",
  "Reset Your Password": "重置您的密码",
  "Enter Your Phone Number / Email Address": "输入您的电话号码/电子邮件地址",
  "Enter Your Email Address": "输入您的电子邮件地址",
  "Please enter phone number / email address": "请输入电话号码/电子邮件地址",
  "Please enter email address": "请输入电子邮件地址",
  "Submit": "提交",
  "Please enter a valid phone number": "请输入正确的电话号码格式",
  "Please enter a valid email address": "请输入有效的电子邮件地址",
  "Success!": "成功！",
  "You may login using your one time password now.": "您现在可以使用一次性密码登录。",
  "Phone Number": "电话号码",
  "Password": "密码",
  "Don't have an account?": "还未有账户？",
  "Forgot password?": "忘记密码？",
  "Unable to register without a QRCode": "没有二维码无法注册",
  "Please read and agree to the privacy policies, terms and conditions": "请阅读并同意隐私政策、条款和条件",
  "Password length must be at least 6 characters": "密码长度必须至少为 6 个字符",
  "Please enter the confirmation code that was sent to your phone": "请输入发送到您手机的验证码",
  "Example: 012xxxxxxx": "例如: 012xxxxxxx",
  "Example: 09xxxxxxxx": "例如: 09xxxxxxxx",
  "Verification Method": "验证方法",
  "Name": "姓名",
  "Email": "电子邮件",
  "optional": "选择性",
  "Birth Year": "出生年份",
  "Year": "年",
  "Birth Month": "出生月份",
  "Month": "月",
  "Jan": "一月",
  "Feb": "二月",
  "Mar": "三月",
  "April": "四月",
  "May": "五月",
  "June": "六月",
  "July": "七月",
  "Aug": "八月",
  "Sept": "九月",
  "Oct": "十月",
  "Nov": "十一月",
  "Dec": "十二月",
  "Birth Day": "出生日期",
  "Day": "日",
  "OTP": "验证码",
  "OTP Confirmation": "确认验证码",
  "I agree to the": "我同意",
  "Privacy Policy": "隐私政策",
  "PRIVACY POLICY": "隐私政策",
  "and": "和",
  "Terms": "条款",
  "Conditions": "条件",
  "SEND CODE": "发送验证码",
  "Our One-Time Password (OTP) emails might end up in your spam or junk folder. We kindly ask you to take a moment to check your spam mailbox.": "我们的一次性密码 (OTP) 电子邮件可能最终会进入您的垃圾邮件或垃圾文件夹。 我们恳请您花点时间检查您的垃圾邮件邮箱。",
  "Already have an account? Login": "已经有账户？登录",
  "Didn't receive a code?": "没有收到验证码？",
  "Resend Code": "重新发送验证码",
  "collected": "已收集",
  "Collect": "收集",
  "stamps": "印章",
  "get 1 voucher": "获得1张优惠券",
  "Minimum": "最低消费",
  "spending to collect each washer stamp": "以收集每个洗衣机印章",
  "spending to collect each dryer stamp": "以收集每个烘干机印章",
  "spending to collect each stamp": "以收集每个印章",
  "Device don't have a camera": "设备没有摄像头",
  "This is not a valid QRCode": "这不是有效的二维码",
  "Select Camera": "选择相机",
  "Switch": "切换",
  "Camera": "相机",
  "Loading": "加载中",
  "Scan the QR code on the machine.": "扫描机器上的二维码。",
  "Switch Camera": "切换相机",
  "Off torch light": "关闭手电筒",
  "On torch light": "开启手电筒",
  "switch camera if your camera is not clear": "如果您的相机不清晰，请切换相机",
  "Switch your camera if the display is not clear": "如果显示不清晰请切换相机",
  "Please allow this webapp to access your camera": "请允许此网络应用访问您的相机",
  "DISCOUNT": "折扣",
  "Congratulation": "恭喜",
  "Expired Date": "过期日期",
  "Voucher": "优惠券",
  "Vouchers": "优惠券",
  "Something went wrong": "出了些问题",
  "Stamping Collection": "印章收集",
  "Total e-Token": "总电子代币",
  "Total Wash": "洗衣机次数",
  "Total Dry": "烘干机次数",
  "Reload": "充值",
  "Washer": "洗衣机",
  "Dryer": "烘干机",
  "Congratulations!": "恭喜！",
  "You have completed your Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "您已完成印章收集。<br />优惠券已给出和印章收集已刷新",
  "You have completed Washer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "您已完成洗衣机印章收集。<br />优惠券已给出和印章收集已刷新",
  "You have completed Dryer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "您已完成烘干机印章收集。<br />优惠券已给出和印章收集已刷新",
  "Latest News": "最新消息",
  "Transaction History": "交易记录",
  "Stamping": "印章",
  "Transaction": "交易",
  "News": "消息",
  "Confirmation": "确认",
  "Logout Session?": "登出？",
  "NO": "否",
  "OK": "确定",
  "Account": "账户",
  "FAQs": "常见问题",
  "Feedback": "反馈",
  "LOGOUT": "登出",
  "Logout": "登出",
  "Are you sure you want to submit your feedback?": "您确定要提交反馈吗？",
  "No": "否",
  "Yes": "是",
  "Success": "成功",
  "Failed": "失败",
  "Pending": "待定",
  "Your feedback is submitted successfully": "您的反馈已成功提交",
  "Please fill in all the required fields before submit.": "请在提交前填写所有必填内容。",
  "Give us your feedback!": "您好，请对我们的服务提出宝贵建议，谢谢！",
  "Type your name here (optional)": "在此处输入您的姓名（选择性）",
  "required": "必填",
  "Type your number here": "在此处输入您的电话号码",
  "Outlet": "店铺",
  "Select an outlet": "选择店铺",
  "Outlet Cleanliness": "店铺清洁度",
  "Washer Machine Performance": "洗衣机性能",
  "Dryer Machine Performance": "烘干机性能",
  "Customer Service": "客户服务",
  "Comment": "评论",
  "Type your comment here (optional)": "在此处输入您的评论（选择性）",
  "SUBMIT": "提交",
  "Join as a member now!": "立即加入成为会员！",
  "Join as a loyalty member now to get more benefits such as vouchers and free machine usage!<br /><br /><strong>Register as loyalty member?</strong>": "现在加入会员，即可免费获得优惠券和免费机器使用等福利！<br /><br /><strong>注册成为会员？</strong>",
  "Maybe Next Time": "下一次吧",
  "Yes, Register Now": "是的，立即注册",
  "Washer Payment": "洗衣机支付",
  "Dryer Payment": "烘干机支付",
  "Vending Machine Payment": "自动贩卖机支付",
  "Online": "在线",
  "Offline": "离线",
  "Running": "运行",
  "Vacant": "空置",
  "Vending Machine": "自动贩卖机",
  "Discount": "折扣",
  "No Vouchers Available": "没有可用的优惠券",
  "Payment Method": "付款方法",
  "Would you like to pay with?": "您愿意使用哪种方式付款?",
  "e-Token": "电子代币",
  "E-TOKEN": "电子代币",
  "E-Wallet": "电子钱包",
  "E-Wallet & Online Banking": "电子钱包和网上银行",
  "Duitnow QR code": "Duitnow二维码",
  "PromptPay QR Code": "PromptPay二维码",
  "The Duitnow QR code will be downloaded and you need to open your banking app to make the payment. Pay {{ currency }}{{ totalPaymentAmount }} to {{ machineName }}?": "Duitnow 二维码将会下载，您需要打开银行应用程序进行付款。向 {{ machineName }} 支付 {{ currency }}{{ totalPaymentAmount }} 吗？",
  "Pay": "付",
  "to": "给",
  "You may under utilized the voucher.": "您尚未充分利用您的优惠券。",
  "Proceed to pay": "继续支付",
  "Processing ...": "支付中 ...",
  "You can't pay with e-token if voucher is in used, please remove your voucher to pay with e-token.": "您不能同时使用优惠劵和电子代币付款，请移除您的优惠卷以使用电子代币付款。",
  "Insufficient e-Tokens": "电子代币不足",
  "Reload your e-token now?": "现在充值您的电子代币？",
  "Reload now!": "现在充值！",
  "You have": "您有",
  "e-Tokens": "电子代币",
  "Tokens to": "代币给",
  "This machine is currently offline, please try again later.": "本机器当前离线，请稍后重试。",
  "MACHINE": "机器",
  "Machine": "机器",
  "TYPE": "类型",
  "CAPACITY": "容量",
  "DURATION": "时长",
  "Select Duration": "选择时长",
  "AMOUNT TO PAY": "支付总额",
  "PRICE": "价格",
  "VOUCHER": "优惠券",
  "Select Voucher >": "选择优惠券 >",
  "TOTAL": "总额",
  "PAY": "付款",
  "Remove Voucher": "移除优惠券",
  "Select Your Voucher": "选择您的优惠券",
  "min": "分钟",
  "MIN": "分钟",
  "Select Payment Amount": "选择支付总额",
  "Select Water Temperature": "选择水温",
  "Select temperature": "选择水温",
  "Select Temperature": "选择水温",
  "Cold": "冷",
  "Warm": "温",
  "Hot": "热",
  "e-Tokens to": "电子代币给",
  "No Purchase History": "无购买记录",
  "e-tokens": "电子代币",
  "No Promotions": "没有促销",
  "New Password": "新密码",
  "Back": "返回",
  "Buy this package?": "买这个配套？",
  "Purchase": "购买",
  "e-Tokens for": "电子代币以",
  "Reload Tokens": "充值电子代币",
  "Are you sure you want to purchase {{ tokenAmount }} e-Token for {{ currency }}{{ paymentAmount }}?": "您确定要以 {{ currency }}{{ paymentAmount }} 购买 {{ tokenAmount }} 电子代币吗？",
  "Current e-Token": "当前电子代币",
  "Current point": "当前积分",
  "History": "历史记录",
  "Your profile picture has been updated!": "您的头像已更新！",
  "Please only use png, jpg or jpeg file extension type": "请仅使用 png、jpg 或 jpeg 类型文件",
  "Please only use image type file": "请仅使用图像类型文件",
  "User name has updated successfully!": "用户名更新成功！",
  "Email Address updated successfully": "电子邮件更新成功",
  "Phone number updated successfully": "电话号码更新成功",
  "Password must be at least 6 characters": "密码必须至少6个字符",
  "Password updated successfully": "密码更新成功",
  "User Settings": "用户设置",
  "Profile Picture": "个人头像",
  "Change Password": "更改密码",
  "Do you want to submit your feedback?": "您想提交您的反馈吗？",
  "Thank You!": "谢谢你！",
  "Thank you for using our services.": "感谢您使用我们的服务。",
  "BACK TO HOMEPAGE": "返回主页",
  "How to pay?": "如何付款？",
  "Step 1": "步骤 1",
  "After scan the QR code on the machine, select either register new account, login your account or skip to payment.": "扫描机器上的二维码后，选择注册新帐户、登录您的帐户或直接付款。",
  "Step 2-1": "步骤 2-1",
  "For Dryer – Select your desired duration. Different duration will have different prices.": "对于烘干机 - 选择所需的时长。不同的时间会有不同的价格。",
  "Step 2-2": "步骤 2-2",
  "For Washer – Select your desired water temperature. Different water temperature will have different prices.": "对于洗衣机 - 选择您想要的水温。不同的水温会有不同的价格。",
  "Step 3": "步骤 3",
  "For login user, Click on ‘Select Voucher’ to select your voucher.": "对于所有登录用户，点击“选择优惠劵”以选择您的优惠劵。",
  "Step 4": "步骤 4",
  "Click on ‘PAY’ button to pay. For login user, select your payment method to pay.": "点击“付款”按钮进行支付。对于登录用户，选择您的支付方式进行支付。",
  "Step 5": "步骤 5",
  "After confirm the price and machine details, click on ‘OK’ button to pay.": "确认价格和机器详情后，点击“确定”按钮进行支付。",
  "How to reload your e-Token?": "如何充值您的电子代币？",
  'Click on the "Reload" button.': '点击“充值”按钮。',
  "Select the package that you wish to purchase.": "选择您要购买的配套。",
  'Click on "Purchase" as confirmation before payment page.': '在前往付款页面之前点击“购买”作为确认。',
  "Is e-token can be refund/transfer back to e-wallet?": "电子代币可以退款/转回电子钱包吗？",
  "Why can't I applied my voucher?": "为何不能使用我的优惠券？",
  "When there is a Happy Hour Promotion is on going, you are unable to apply your voucher temporarily.": "每当特别促销正在进行时，您暂时无法使用您的优惠劵。",
  "How to apply my voucher?": "如何使用我的优惠券？",
  'Click on the "Select Voucher" button.': '点击“选择优惠券”按钮。',
  "Select the voucher that you wish to apply.": "选择您要使用的优惠券。",
  'Click on "Pay" once you have verified the voucher is successfully applied.': '确认优惠劵已成功使用后，请点击“付款”。',
  "Step 2": "步骤 2",
  "Language has updated successfully!": "语言更新成功！",
  "Change Language": "更改语言",
  "Language": "语言",
  "Select language": "选择语言",
  "Referral Code": "邀请码",
  "Copied!": "已复制!",
  "Inviting friends to get more benefits!": "邀请好友以获取更多福利！",
  "Would you like to share your referral code to your friends & family?": "您要分享您的邀请码给朋友&家人吗？",
  "Refer a friend and get": "推荐朋友并获得",
  "Share the love to your friends & family?": "将爱分享给您的朋友和家人？",
  "voucher": "优惠劵",
  "token": "电子代币",
  "stamp": "印章",
  "washer stamp": "洗衣机印章",
  "dryer stamp": "烘干机印章",
  "Learn More": "了解更多",
  "Welcome Gift": "欢迎礼物",
  "Share Your Referral Code Now": "立即分享您的邀请码",
  "Birthday Gift for You": "给您的生日礼物",
  "Let's Pay with E-Token": "使用电子代币支付",
  "Collect 10 Stamps and Get Voucher": "收集 10 个印章并获得优惠劵",
  "The voucher will be given if you registered your account successfully.": "如果您成功注册了您的帐户，您将获得优惠券。",
  "There is no expiration date for this voucher.": "此优惠券没有过期日期。",
  "The voucher can be used for dryer machine only.": "优惠券仅可用于烘干机。",
  "The voucher can be used for washer machine only.": "优惠券仅可用于洗衣机。",
  "The voucher can be used for Drop n Go transaction only.": "优惠券仅可用于 Drop n Go 交易。",
  "The voucher can be used for vending transaction only.": "该优惠券仅可用于自动售货机交易。",
  "The voucher can be used for detergent vending transaction only.": "该优惠券仅可用于洗衣液自动售货机交易。",
  "The voucher can be used for car wash transaction only.": "该优惠券仅可用于洗车交易。",
  "The voucher can be used for washer machine or Drop n Go transaction.": "优惠券仅可用于洗衣机或 Drop n Go 交易。",
  "The voucher can be used for dryer machine or Drop n Go transaction.": "优惠券仅可用于烘干机或 Drop n Go 交易。",
  "The voucher can be used for dryer or washer machine.": "优惠券可用于烘干机或洗衣机。",
  "The voucher can be used for washer machine, dryer machine or Drop n Go transaction.": "优惠券可用于洗衣机、烘干机或 Drop n Go 交易。",
  "The voucher can be used for washer machine or vending machine transaction.": "该优惠券可用于洗衣机或自动售货机交易。",
  "The voucher can be used for washer machine or detergent vending machine transaction.": "该优惠券可用于洗衣机或洗衣液自动售货机交易。",
  "The voucher can be used for washer machine or car wash transaction.": "该优惠券可用于洗衣机或洗车交易。",
  "The voucher can be used for dryer machine or vending machine transaction.": "该优惠券可用于烘干机或自动售货机交易。",
  "The voucher can be used for dryer machine or detergent vending machine transaction.": "该优惠券可用于烘干机或洗衣液自动售货机交易。",
  "The voucher can be used for dryer machine or car wash transaction.": "该优惠券可用于烘干机或洗车交易。",
  "The voucher can be used for vending machine or Drop n Go transaction.": "该优惠券可用于自动售货机或Drop n Go交易。",
  "The voucher can be used for detergent vending machine or Drop n Go transaction.": "该优惠券可用于洗衣液自动售货机或Drop n Go交易。",
  "The voucher can be used for car wash or Drop n Go transaction.": "该优惠券可用于洗车或Drop n Go交易。",
  "The voucher can be used for vending machine or detergent vending machine transaction.": "该优惠券可用于自动售货机或洗衣液自动售货机交易。",
  "The voucher can be used for vending machine or car wash transaction.": "该优惠券可用于自动售货机或洗车交易。",
  "The voucher can be used for detergent vending machine or car wash transaction.": "该优惠券可用于洗衣液自动售货机或洗车交易。",
  "The voucher can be used for washer machine, dryer machine or vending machine transaction.": "该优惠券可用于洗衣机、烘干机或自动售货机交易。",
  "The voucher can be used for washer machine, dryer machine or detergent vending machine transaction.": "该优惠券可用于洗衣机、烘干机或洗衣液自动售货机交易。",
  "The voucher can be used for washer machine, dryer machine or car wash transaction.": "该优惠券可用于洗衣机、烘干机或洗车交易。",
  "The voucher can be used for washer machine, vending machine or Drop n Go transaction.": "该优惠券可用于洗衣机、自动售货机或Drop n Go交易。",
  "The voucher can be used for washer machine, detergent vending machine or Drop n Go transaction.": "该优惠券可用于洗衣机、洗衣液自动售货机或Drop n Go交易。",
  "The voucher can be used for washer machine, car wash or Drop n Go transaction.": "该优惠券可用于洗衣机、洗车或Drop n Go交易。",
  "The voucher can be used for washer machine, vending machine or detergent vending transaction.": "该优惠券可用于洗衣机、自动售货机或洗衣液自动售货机交易。",
  "The voucher can be used for washer machine, vending machine or car wash transaction.": "该优惠券可用于洗衣机、自动售货机或洗车交易。",
  "The voucher can be used for washer machine, detergent vending machine or car wash transaction.": "该优惠券可用于洗衣机、洗衣液自动售货机或洗车交易。",
  "The voucher can be used for dryer machine, vending machine or Drop n Go transaction.": "该优惠券可用于烘干机、自动售货机或Drop n Go交易。",
  "The voucher can be used for dryer machine, detergent vending machine or Drop n Go transaction.": "该优惠券可用于烘干机、洗衣液自动售货机或Drop n Go交易。",
  "The voucher can be used for dryer machine, car wash or Drop n Go transaction.": "该优惠券可用于烘干机、洗车或Drop n Go交易。",
  "The voucher can be used for dryer machine, vending machine or detergent vending machine transaction.": "该优惠券可用于烘干机、自动售货机或洗衣液自动售货机交易。",
  "The voucher can be used for dryer machine, vending machine or car wash transaction.": "该优惠券可用于烘干机、自动售货机或洗车交易。",
  "The voucher can be used for dryer machine, detergent vending machine or car wash transaction.": "该优惠券可用于烘干机、洗衣液自动售货机或洗车交易。",
  "The voucher can be used for vending machine, detergent vending machine or Drop n Go transaction.": "该优惠券可用于自动售货机、洗衣液自动售货机或Drop n Go交易。",
  "The voucher can be used for vending machine, car wash or Drop n Go transaction.": "该优惠券可用于自动售货机、洗车或Drop n Go交易。",
  "The voucher can be used for detergent vending machine, car wash or Drop n Go transaction.": "该优惠券可用于洗衣液自动售货机、洗车或Drop n Go交易。",
  "The voucher can be used for vending machine, detergent vending machine or car wash transaction.": "该优惠券可用于自动售货机、洗衣液自动售货机或洗车交易。",
  "The voucher can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "该优惠券可用于洗衣机、烘干机、自动售货机或Drop n Go交易。",
  "The voucher can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction.": "该优惠券可用于洗衣机、烘干机、自动售货机或洗衣液自动售货机交易。",
  "The voucher can be used for washer machine, dryer machine, vending machine or car wash transaction.": "该优惠券可用于洗衣机、烘干机、自动售货机或洗车交易。",
  "The voucher can be used for washer machine, dryer machine, detergent vending machine or car wash transaction.": "该优惠券可用于洗衣机、烘干机、洗衣液自动售货机或洗车交易。",
  "The voucher can be used for washer machine, vending machine, detergent vending machine or Drop n Go transaction.": "该优惠券可用于洗衣机、自动售货机、洗衣液自动售货机或Drop n Go交易。",
  "The voucher can be used for washer machine, vending machine, car wash or Drop n Go transaction.": "该优惠券可用于洗衣机、自动售货机、洗车或Drop n Go交易。",
  "The voucher can be used for washer machine, vending machine, detergent vending machine or car wash transaction.": "该优惠券可用于洗衣机、自动售货机、洗衣液自动售货机或洗车交易。",
  "The voucher can be used for dryer machine, vending machine, detergent vending machine or Drop n Go transaction.": "该优惠券可用于烘干机、自动售货机、洗衣液自动售货机或Drop n Go交易。",
  "The voucher can be used for dryer machine, vending machine, car wash or Drop n Go transaction.": "该优惠券可用于烘干机、自动售货机、洗车或Drop n Go交易。",
  "The voucher can be used for dryer machine, detergent vending machine, car wash or Drop n Go transaction.": "该优惠券可用于烘干机、洗衣液自动售货机、洗车或Drop n Go交易。",
  "The voucher can be used for dryer machine, vending machine, detergent vending machine or car wash transaction.": "该优惠券可用于烘干机、自动售货机、洗衣液自动售货机或洗车交易。",
  "The voucher can be used for vending machine, detergent vending machine, car wash or Drop n Go transaction.": "该优惠券可用于自动售货机、洗衣液自动售货机、洗车或Drop n Go交易。",
  "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine or Drop n Go transaction.": "该优惠券可用于洗衣机、烘干机、自动售货机、洗衣液自动售货机或Drop n Go交易。",
  "The voucher can be used for washer machine, dryer machine, vending machine, car wash or Drop n Go transaction.": "该优惠券可用于洗衣机、烘干机、自动售货机、洗车或Drop n Go交易。",
  "The voucher can be used for washer machine, dryer machine, detergent vending machine, car wash or Drop n Go transaction.": "该优惠券可用于洗衣机、烘干机、洗衣液自动售货机、洗车或Drop n Go交易。",
  "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine or car wash transaction.": "该优惠券可用于洗衣机、烘干机、自动售货机、洗衣液自动售货机或洗车交易。",
  "The voucher can be used for washer machine, vending macihne, detergent vending machine, car wash or Drop n Go transaction.": "该优惠券可用于洗衣机、自动售货机、洗衣液自动售货机、洗车或Drop n Go交易。",
  "The voucher can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "该优惠券可用于烘干机、自动售货机、洗衣液自动售货机、洗车或Drop n Go交易。",
  "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "该优惠券可用于洗衣机、烘干机、自动售货机、洗衣液自动售货机、洗车或Drop n Go交易。",
  "When you applied the voucher during payment, it will give you": "当您在付款期间使用您的优惠券时，它会给您",
  "discount.": "折扣。",
  "When promotion is on going, the voucher is not applicable.": "促销期间，优惠券不可使用。",
  "The voucher cannot be used if your payment method is E-Token.": "如果您的付款方式是电子代币，则不能使用该优惠券。",
  "Your referral code can be found in user settings page.": "您的邀请码可以在用户设置页面中找到。",
  "You can get": "你可以得到",
  "stamp for the reward.": "印章作为奖励。",
  "e-token for the reward.": "电子代币作为奖励。",
  "e-token based on transaction payment amount for the reward.": "电子代币根据交易的支付金额作为奖励。",
  "for the reward.": "以作为奖励。",
  "based on transaction payment amount for the reward.": "根据交易支付金额获得奖励。",
  "You can get a voucher for the reward": "您可以获得优惠券作为奖励",
  "which have": "此优惠劵将有",
  "it can be used for dryer machine only.": "它只能用于烘干机。",
  "it can be used for washer machine only.": "它只能用于洗衣机。",
  "it can be used for Drop n Go transaction only.": "它只能用于Drop n Go 交易。",
  "it can be used for vending machine only.": "仅可用于自动售货机。",
  "it can be used for car wash transaction only.": "仅可用于洗车交易。",
  "it can be used for detergent vending machine only.": "仅可用于洗衣液自动售货机。",
  "it can be used for dryer or washer machine.": "它可用于烘干机或洗衣机。",
  "it can be used for dryer machine or Drop n Go transaction.": "它可用于烘干机或Drop n Go 交易。",
  "it can be used for washer machine or Drop n Go transaction.": "它可用于洗衣机或Drop n Go 交易。",
  "it can be used for washer machine, dryer machine or Drop n Go transaction.": "它可用于洗衣机、烘干机或Drop n Go 交易。",
  "it can be used for washer machine, dryer machine or vending machine transaction.": "可用于洗衣机、烘干机或自动售货机交易。",
  "it can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "可用于洗衣机、烘干机、自动售货机或Drop n Go交易。",
  "washer stamp for the reward.": "洗衣机印章作为奖励。",
  "dryer stamp for the reward.": "烘干机印章作为奖励。",
  "washer stamp and": "洗衣机印章和",
  "cleanproBirthdayShortDesc": "使用 Cleanpro Plus 在您的特殊日子兑换 {{ birthdayVoucherAmount }} 货币的生日礼券。点击以了解更多信息。",
  'When you click on "PAY" button on the payment page, you can choose either using E-wallet or E-token to pay.': '当您在支付页面点击"付款"按钮时，您可以选择使用电子钱包或电子代币进行支付。',
  "When you using your voucher during payment, you will be unable to pay with E-token.": "当您在付款期间使用您的优惠券时，您将无法使用电子代币付款。",
  "You can reload your E-token by clicking the reload button in the stamping page and select the package to purchase.": "您可以通过点击印章页面中的充值按钮并选择要购买的配套来充值您的电子代币。",
  "You can reload your E-token by clicking the reload button in the home page and select the package to purchase.": "您可以通过点击主页中的充值按钮并选择要购买的配套来充值您的电子代币。",
  "You can view your E-token reload history and E-token transaction history in transaction page.": "您可以在交易页面查看您电子代币的充值记录和交易记录。",
  "You can view your E-token transaction history in transaction page.": "您可以在交易页面查看您电子代币的交易记录。",
  "Using either dryer machine or washer machine with the minimum spending of": "使用烘干机或洗衣机，最低消费",
  "to collect one stamp.": "即可收集一个印章。",
  "The voucher will be given if you have collected 10 stamps.": "如果您收集了 10 个印章，将获得优惠券。",
  "Using dryer machine with the minimum spending of": "使用烘干机最低消费",
  "Using washer machine with the minimum spending of": "使用洗衣机最低消费",
  "to collect one dryer stamp.": "即可获得一个烘干机印章。",
  "to collect one washer stamp.": "即可获得一个洗衣机印章。",
  "The voucher will be given if you have collected 10 dryer stamps or 10 washer stamps.": "如果您收集了 10 个烘干机印章或 10 个洗衣机印章，将获得优惠券。",
  "For the voucher given by the dryer stamps,": "对于烘干机印章给出的优惠劵，",
  "For the voucher given by the washer stamps,": "对于洗衣机印章给出的优惠劵，",
  "When promotion is on going, all the vouchers is not applicable.": "促销期间，所有优惠券均不可使用。",
  "All the vouchers cannot be used if your payment method is E-Token.": "如果您的付款方式是电子代币，则所有优惠券都不能使用。",
  "Description": "简介",
  "Refer Friends": "推荐给朋友",
  "View our guideline": "查看我们的指南",
  "When a friend / family register using your referral code, and completed a transaction with a minimum spending of": "当朋友/家人使用您的邀请码注册并完成最低消费",
  ", you will be rewarded automatically.": "的交易时，您将自动获得奖励。",
  "One user only allow to have": "一个用户只允许拥有",
  "referrals.": "邀请者。",
  "Confirmation Password": "确认密码",
  "Password and confirmation password should be same.": "密码和确认密码必须相同。",
  "You haven't applied your voucher": "您还没使用优惠劵",
  "Would you like to continue your payment without using your voucher?": "您想在不使用优惠券的情况下继续付款吗？",
  "Continue": "继续",
  "Apply voucher": "使用优惠劵",
  "Transfer": "转账",
  "Transfer Tokens": "转账电子代币",
  "Please fill in the phone number": "请填写电话号码",
  "Please fill in the email": "请填写电子邮件",
  "Please enter the phone number / email that you want to transfer to": "请输入您要转账的电话号码/电子邮件",
  "Please fill in the transfer amount": "请填写转账总额",
  "Transfer amount should be more than 0 and less than your current e-Token": "转账总额需大于0且小于您当前的电子代币",
  "Please enter your password": "请输入您的密码",
  "Member ID": "会员ID",
  "E-Token Transfer Amount": "电子代币转账总额",
  "Please confirm the details before proceeding": "请在继续之前确认详细信息",
  "Transfer From": "转账从",
  "Transfer To": "转账至",
  "Transfer Amount": "转账总额",
  "Transfer Successfully!": "转账成功！",
  "Transfer Time": "转账时间",
  "Token": "电子代币",
  "Done": "完成",
  "Next": "继续",
  "Enter Password": "输入密码",
  "Transfer E-Token Amount": "电子代币转账金额",
  "User not found": "找不到用户",
  "Password is incorrect": "密码不正确",
  "Please go to your account setting and reset your password": "请前往您的用户设置并重置您的密码",
  "Only up to last 3 months transaction history": "仅最近3个月的交易记录",
  "Reload History": "充值记录",
  "Transfer History": "转账记录",
  "{{ point }} History": "{{ point }}记录",
  "Only up to last 3 months reload history": "仅最近3个月的充值记录",
  "Only up to last 3 months transfer history": "仅最近3个月的转账记录",
  "Only up to last 3 months {{ point }} history": "仅最近3个月的{{ point }}记录",
  "Only up to last 3 months laundry pass history": "仅最近3个月的洗衣通行证记录",
  "If require urgent response, please contact us through whatapp": "如果需要紧急回应，请通过whatsapp与我们联系",
  "Please scan the QR code again": "请再次扫描二维码",
  "Home": "主页",
  "Quick": "快速",
  "Super": "超级",
  "Premium": "高级",
  "All users will have infinite referrals.": "所有用户都将获得无限邀请者。",
  "Collect 10 stamps to get 1 Voucher": "收集10个印章获得1张优惠劵",
  "The voucher is only for customer use only, not for sale.": "优惠券仅供客户使用，不用于销售。",
  "Outlet is currently offline, please try again later": "店铺目前处于离线状态，请稍后再试",
  "The voucher will be given if you completed a transaction with a minimum spending of": "您将获得优惠劵如果您完成交易以最低消费",
  "The birthday voucher will be given on the first day of your birthday month.": "生日券将在您生日月份的第一天发放。",
  "The voucher only will be given if you have exceed spending amount of": "优惠劵只会发放当您的消费超过",
  "Pay with KiplePay": "使用 KiplePay 付款",
  "Pay with Scan2Pay": "使用 Scan2Pay 付款",
  "Pay with Razer": "使用 Razer 付款",
  "Pay with HitPay": "使用 HitPay 付款",
  "Pay with Duitnow QR": "使用 Duitnow QR 付款",
  "Pay with PagBank": "使用 PagBank 付款",
  "Pay with PromptPay QR": "使用 PromptPay QR 付款",
  "Pay with Card": "使用银行卡付款",
  "Pay with PayWay": "使用 PayWay 付款",
  "DISCOUNT CODE": "优惠码",
  "Enter code >": "输入优惠码 >",
  "Enter Discount Code": "输入优惠码",
  "Remove Code": "移除优惠码",
  "Discount Code": "优惠码",
  "Close": "关闭",
  "Please fill in your email address": "请填写您的电子邮件地址",
  "Notification": "通知",
  "Do you want to receive notification when wash cycle done?": "您想在洗涤周期完成时收到通知吗？",
  "pay extra": "额外付费",
  "Email Address": "电子邮件地址",
  "Please fill in your phone number": "请填写您的电话号码",
  "Invalid Phone Number": "无效的电话号码",
  "Washing Complete": "洗涤完成",
  "Drying Complete": "烘干完成",
  "The voucher will be given if you registered your account successfully, but it only can be used when your total transaction spending reach": "成功注册账户即可获赠礼券，但仅能使用当交易总额达",
  "and above.": "或以上。",
  "This voucher is not applicable": "此优惠券不适用",
  "Finish in": "完成于",
  "Need to refresh to update": "需要刷新才能更新",
  "It's indicative and may change based on washer load": "这是指示性的，可能会根据洗衣机负载而变化",
  "We'll let you know when it's ready to pick up": "当准备好取衣物时，我们会通知您",
  "FREE": "免费",
  "Enter voucher code (if got any)": "输入优惠券兑换码（如果有）",
  "Please fill in the voucher code": "请输入优惠券兑换码",
  "Available On": "可用于",
  "Apply": "使用",
  "Enter a code": "输入兑换码",
  "Input Promo Code": "输入促销代码",
  "Voucher is redeemed successfully!": "优惠券兑换成功！",
  "Not available": "无法使用",
  "Unable to register": "无法注册",
  "Drop n Go Service": "Drop n Go 服务",
  "Select Mode": "选择模式",
  "Quantity": "数量",
  "Pack": "包裹",
  "Add more": "添加更多",
  "Select Size": "选择尺寸",
  "Select Services": "选择服务",
  "Are you sure to delete the item?": "您确定要删除该配套吗？",
  "Delete": "删除",
  "Your Duitnow QR code": "您的 Duitnow 二维码",
  "Your PromptPay QR code": "您的 PromptPay 二维码",
  "How to pay using Duitnow QR code?": "如何使用 Duitnow 二维码付款？",
  "How to pay using PromptPay QR code?": "如何使用 PromptPay 二维码付款？",
  "Launch": "运行",
  "Launch your preferred Mobile Banking or eWallet app.": "启动您喜欢的手机银行或电子钱包应用程序。",
  "Scan QR code from Gallery": "从图库扫描二维码",
  "Choose DuitNow QR from your gallery.": "从您的图库中选择 DuitNow 二维码。",
  "Confirm payment details and pay.": "确认付款细节并付款。",
  "Receive payment confirmation.": "收到付款确认。",
  "expiring on": "过期于",
  "Expired on": "过期于",
  "based on transaction payment amount": "根据交易支付金额",
  "Join as our": "立即加入我们的",
  "Loyalty Member": "忠诚会员",
  "now to get more reward": "以获得更多奖励",
  "Payment amount should be greater than 0": "付款金额应大于0",
  // admin portal
  "Dashboard": "概括",
  "Report": "报告",
  "Store Performance": "商店表现",
  "User Performance": "用户表现",
  "Voucher Redemption": "优惠券兑换",
  "Token Report": "电子代币报告",
  "SMS Report": "短信报告",
  "Discount Code Report": "优惠码报告",
  "User Details": "用户详细信息",
  "User Compensation": "用户补偿",
  "Voucher Settings": "优惠券设置",
  "Token Settings": "代币设置",
  "Referral Settings": "邀請碼设置",
  "Voucher Code": "优惠券兑换码",
  "Customize Color": "更换主题颜色",
  "User Migration": "用户迁移",
  "Back To": "返回",
  "Eligibility": "资格",
  "If ticked, the voucher will have expired date": "如果勾选，优惠券将有过期日期",
  "Expiry": "期限",
  "If ticked, the voucher can apply to washer machine transaction": "如果勾选，优惠劵可用于洗衣机交易",
  "Washer Use": "应用于洗衣机",
  "If ticked, the voucher can apply to dryer machine transaction": "如果勾选，优惠劵可用于烘干机交易",
  "Dryer Use": "应用于烘干机",
  "If ticked, the voucher can apply to Drop n Go transaction": "如果勾选，优惠劵可用于Drop n Go交易",
  "Package Use": "应用于配套",
  "If ticked, the voucher can apply to vending machine transaction": "勾选后，优惠券可用于自动售货机交易",
  "Vending Use": "应用于自动售货机",
  "If ticked, the voucher can apply to detergent vending machine transaction": "勾选后，优惠券可用于洗衣液自动售货机交易",
  "Detergent Use": "应用于洗衣液自动售货机",
  "If ticked, the voucher can apply to car wash transaction": "勾选后，优惠券可用于洗车交易",
  "Car Wash Use": "应用于洗车",
  "Voucher Lifespan": "优惠券有效期限",
  "days": "天",
  "Discount Type": "折扣类型",
  "Select a discount type": "选择折扣类型",
  "Flat": "扁平",
  "Rate": "率",
  "Voucher Title": "优惠券标题",
  "Voucher Description": "优惠券说明",
  "Voucher Amount": "优惠券金额",
  "CONFIRM": "确认",
  "If ticked, the system will give voucher to user who completed washer stamp collection": "如果勾选，系统将向完成洗衣机印章收集的用户发放优惠劵",
  "If ticked, the system will give voucher to user who completed dryer stamp collection": "如果勾选，系统将向完成烘干机印章收集的用户发放优惠劵",
  "If ticked, the user only can get/use the voucher after make a transaction": "如果勾选，用户只有在进行交易后才能获取/使用优惠券",
  "Pay And Get Voucher": "付款后获取优惠券",
  "Pay And Use Code": "消费后才能使用优惠码",
  "If ticked, the system will only give the voucher to user after the user make a transaction": "如果勾选，只有在用户进行交易后，系统才会将优惠券发放给用户",
  "If ticked, the system will give voucher to user who completed registration process": "如果勾选，系统将向完成注册的用户赠送优惠劵",
  "If ticked, the system will give voucher to user on their birthday month": "如果勾选，系统将在用户生日当月向用户赠送优惠券",
  "If ticked, the system will give voucher to user who completed stamp collection": "如果勾选，系统将赠送优惠劵给完成印章收集的用户",
  "Minimum Payment Amount To Get/Use Register Voucher": "获取/使用注册优惠券的最低付款金额",
  "Voucher Method": "优惠劵赠送方式",
  "Select a voucher method": "选择优惠券赠送方式",
  "The user directly get the voucher after register but only can use it after make transaction": "用户注册后直接获得优惠券，但需进行交易后才能使用",
  "The user only can get voucher after make a transaction": "用户只有在进行交易后才能获得优惠券",
  "Minimum Payment Amount To Get Birthday Voucher": "获得生日优惠劵的最低付款金额",
  "Minimum Payment Amount To Use Discount Code": "使用优惠码的最低交易金额",
  "Outlets": "商店",
  "E-Payment Sales": "电子支付销售",
  "Number of stamps granted to users": "赠送用户的印章数量",
  "Total number of stamps granted": "赠送印章总数",
  "Registered Users": "注册用户",
  "Stamps": "印章",
  "Referral": "邀请码",
  "Register": "注册",
  "Top Outlets": "热门商店",
  "Users": "用户",
  "Sort by": "排序方式",
  "Top Users": "热门用户",
  "User name": "用户名",
  "Number": "电话号码",
  "Spending": "花费",
  "Number of registered users": "注册用户数",
  "Number of voucher given to users": "给予用户的优惠券数量",
  "Total number of voucher given": "给予的优惠券总数",
  "Voucher Type": "优惠券类型",
  "Voucher Value": "优惠券的价值",
  "Date": "日期",
  "Discount Code Type": "优惠码类型",
  "Discount Code Amount": "优惠码金额",
  "Number of Redemption": "兑换次数",
  "Total Discount Amount": "总折扣金额",
  "Select Outlet": "选择商店",
  "Select Date": "选择日期",
  "Select Transaction Date": "选择交易日期",
  "Reset": "重置",
  "Download Report": "下载报告",
  "Please fill in the remark": "请填写备注",
  "Transaction Date": "交易日期",
  "Machine Type": "机器类型",
  "Machine Capacity": "机器容量",
  "Total Amount": "总金额",
  "Payment Amount": "支付金额",
  "Discount From": "折扣从",
  "Discount Amount": "折扣金额",
  "Action": "行动",
  "Remark": "备注",
  "Refund Date": "退款日期",
  "Refund": "退款",
  "Purchase Date": "购买日期",
  "e-Token Purchased (Tokens)": "购买的电子代币（电子代币）",
  "Bought e-Token using": "购买的电子代币",
  "Transaction ID": "交易ID",
  "Method": "方式",
  "Requery": "重新查询",
  "Reward Date": "奖励日期",
  "Reward Type": "奖励类型",
  "Notification Method": "通知方式",
  "Email Preview": "电子邮件预览",
  "Message for User": "给用户的留言",
  "SMS will send to user, please enter the message less than 130 characters": "短信将发送给用户，请输入少于130个字符的短信",
  "Enter the message to be sent to the user": "输入要发送给用户的留言",
  "Email Address to show on Email Template": "电子邮件模板上显示的电子邮件地址",
  "Input Company Email Address": "输入公司电子邮件地址",
  "Company Name to show on Email Template": "电子邮件模板上显示的公司名称",
  "Input Company Name": "输入公司名称",
  "Company Phone No. to show on Email Template": "电子邮件模板上显示的公司电话号码",
  "Input Company Phone No.": "输入公司电话号码",
  "Voucher ID": "优惠券ID",
  "Washer Stamp": "洗衣机印章",
  "Dryer Stamp": "烘干机印章",
  "e-Token Amount": "电子代币金额",
  "Transfer Date": "转账日期",
  "Transfer Amount (Token)": "转账金额（电子代币）",
  "Number (Transfer From)": "电话号码（转自）",
  "Name (Transfer From)": "姓名（转自）",
  "Member ID (Transfer From)": "会员ID（转自）",
  "Number (Transfer To)": "电话号码（转给）",
  "Name (Transfer To)": "姓名（转给）",
  "Member ID (Transfer To)": "会员ID（转给）",
  "Grant Date": "给予日期",
  "Claim Date": "使用日期",
  "Member Details Report": "会员详情报告",
  "Transaction Status": "交易状态",
  "Token Reload": "充值电子代币",
  "Token Transfer": "电子代币转账",
  "Voucher History": "优惠券历史记录",
  "TOKEN": "电子代币",
  "Message Sent": "发送的信息",
  "Date Sent": "发送日期",
  "Remaining SMS Credit": "短信余额",
  "Store": "商店",
  "Total Registered Users": "注册用户总数",
  "User registered but no transaction record": "用户已注册但无交易记录",
  "Registered": "已注册",
  "User spending is less than": "用户花费小于",
  "Active": "活跃",
  "User spending is from": "用户花费从",
  "until": "至",
  "Tier 1": "1 级",
  "User spending is": "用户花费",
  "and above": "或以上",
  "Tier 2": "2 级",
  "Average spending in each transaction": "每笔交易的平均花费",
  "Average Spending": "平均花费",
  "Total number of transactions": "交易总数",
  "Total Transactions": "总交易量",
  "Number of vouchers used in all the transactions": "所有交易中使用的优惠劵数量",
  "Voucher Claimed": "使用优惠劵数",
  "Total number of washer machine transactions": "洗衣机交易总数",
  "Washer Usage": "洗衣机使用次数",
  "Total number of dryer machine transactions": "烘干机交易总数",
  "Dryer Usage": "烘干机使用次数",
  "User Name": "用户名",
  "e-Token Spent": "花费的电子代币",
  "e-Token Detailed Report": "电子代币详细报告",
  "e-Token Purchase History": "电子代币购买历史记录",
  "Select Purchase Date": "选择购买日期",
  "Outlet Name": "店铺名称",
  "Total number of e-token used in all the transactions": "所有交易中使用的电子代币总数",
  "Total e-Token Collected": "收集到的电子代币总额",
  "Total number of e-token used in washer machine transactions": "所有洗衣机交易中使用的电子代币总数",
  "Washer e-Token Collected": "收集到的洗衣机电子代币总额",
  "Total number of e-token used in dryer machine transactions": "所有烘干机交易中使用的电子代币总数",
  "Dryer e-Token Collected": "收集到的洗烘干机电子代币总额",
  "Vending Machine e-Token Collected": "收集到的自动售货机电子代币总额",
  "Purchase History": "购买记录",
  "All": "全部",
  "Most Bought e-Token Package": "最受欢迎的电子代币配套",
  "for": "对于",
  "Tokens": "电子代币",
  "Total Earned from users buying e-Tokens": "用户购买电子代币的总收入",
  "Total e-Tokens Bought from you": "从您购买的电子代币总数",
  "Join Date": "加入日期",
  "Channel": "频道",
  "Tier": "等级",
  "Referrer": "邀请者",
  "Referrals": "邀请人数",
  "Number of transactions for last 7 days": "近7天的交易数",
  "Number of Usage (in week)": "使用次数（周）",
  "Number of transactions for last 1 month": "近1个月的交易数",
  "Number of Usage (in month)": "使用次数（月）",
  "Total amount spent in all the transactions": "所有交易花费的总金额",
  "Total Spent": "总花费",
  "Last Transaction Date": "最后交易日期",
  "Number of vouchers collected": "领取优惠券数量",
  "Voucher Collected": "优惠劵领取数",
  "Number of vouchers used": "使用优惠券数量",
  "Voucher Spent": "优惠券使用数",
  "Washer Used": "洗衣机使用次数",
  "Dryer Used": "烘干机使用次数",
  "Total number of e-Token spent in all the transactions": "所有交易中花费的电子代币总数",
  "Total number of stamps collected": "收集的印章总数",
  "Total Stamps": "印章总数",
  "Select Join Date": "选择加入日期",
  "Select Grant Date": "选择给予日期",
  "Amount": "价值",
  "The image size is over 2MB": "图片大小超过2MB",
  "Duplicate language selected": "您选择了重复的语言",
  "Are you sure you want to add FAQ?": "您确定要添加常见问题吗？",
  "FAQ added successfully": "常见问题添加成功",
  "FAQ Group added successfully": "常见问题组添加成功",
  "Please provide the faq with the default language": "请提供默认语言的常见问题",
  "Add FAQ": "添加常见问题",
  "Default Language": "默认语言",
  "Select Default Language": "选择默认语言",
  "Image (Optional)": "图片（可选）",
  "max": "最大",
  "Question": "问题",
  "Select Language": "选择语言",
  "Remove": "移除",
  "Answer": "回答",
  "Add Translation": "添加翻译",
  "Are you sure you want to add FAQ Group?": "您确定要添加常见问题组吗？",
  "Please provide the faq group with the default language": "请为常见问题组提供默认语言",
  "Add FAQ Group": "添加常见问题组",
  "Title": "标题",
  "Title Language": "标题语言",
  "Please fill in the title": "请填写标题",
  "Please fill in the description": "请填写描述",
  "Please fill in the short description": "请填写简短的描述",
  "Please select the end date for your news": "请选择消息的结束日期",
  "Please provide the news with the default language": "请提供默认语言的消息",
  "Please provide the banner image": "请提供横幅图片",
  "Please provide the news image": "请提供消息图片",
  "Are you sure you want to add news?": "您确定要添加消息吗？",
  "News added successfully": "消息添加成功",
  "Please fill in all the required fields before submit": "请在提交前填写所有必填选项",
  "Add News": "添加消息",
  "Banner Image": "横幅图片",
  "News Image": "消息图片",
  "Banner": "横幅",
  "aspect ratio": "纵横比",
  "Image": "图片",
  "Display in": "显示于",
  "Inbox Page": "收件箱页面",
  "Promotion Banner": "促销横幅",
  "Select Period: (optional)": "选择期间：（可选）",
  "Short Description": "简短的介绍",
  "Your theme has been updated successfully": "您的主题已成功更新",
  "Default Theme": "默认主题",
  "Change Logo": "更改标志",
  "REMOVE LOGO": "移除标志",
  "Sms credit used up": "短信额度已用完",
  "Please top up your sms credit": "请充值您的短信余额",
  "Please": "请",
  "Again": "多一次",
  "Welcome": "欢迎",
  "Ranking": "排行榜",
  "Select Year": "选择年份",
  "Missing Field": "选项未填",
  "Please select can be used for which type of transaction": "请选择可用于哪种类型的交易",
  "Please fill in the start date and end date": "请填写开始日期和结束日期",
  "Discount amount should be more than 0": "折扣金额应大于0",
  "Redeem per user should be more than 0": "每个用户兑换次数应大于0",
  "Redeem per day should be more than 0": "每日兑换次数必须大于0",
  "Your discount code have edited successfully": "您的优惠码已编辑成功",
  "Your discount code have added successfully": "您的优惠码已添加成功",
  "Delete this entry?": "删除此条目？",
  "Your discount code have deleted successfully": "您的优惠码已删除成功",
  "Created Date": "创建日期",
  "Discount code": "优惠码",
  "General Discount Code": "通用优惠码",
  "Unique Discount Code": "独特优惠码",
  "Start Date": "开始日期",
  "End Date": "结束日期",
  "Redeem Per User": "每个用户兑换次数",
  "Redeem Per Day": "每日兑换次数",
  "Add Discount Code": "添加优惠码",
  "Generate Discount Code": "生成优惠码",
  "No Discount Code": "没有优惠码",
  "Edit Discount Code": "编辑优惠码",
  "Select Period": "选择期间",
  "Redeem per user": "每个用户兑换次数",
  "How many times the discount code can be used for each user": "每个用户可以使用优惠码的次数",
  "Redeem per day": "每日兑换次数",
  "How many times the discount code can be used in one day": "优惠码一天内可以使用多少次",
  "If ticked, the discount code can apply to washer machine transaction": "如果勾选，优惠码可应用于洗衣机交易",
  "If ticked, the discount code can apply to dryer machine transaction": "如果勾选，优惠码可应用于烘干机交易",
  "If ticked, the discount code can apply to Drop n Go transaction": "如果勾选，优惠码可应用于Drop n Go交易",
  "If ticked, the discount code can apply to vending machine transaction": "勾选后，折扣码可用于自动售货机交易",
  "If ticked, the discount code can apply to detergent vending machine transaction": "勾选后，折扣码可用于洗衣液自动售货机交易",
  "If ticked, the discount code can apply to car wash transaction": "勾选后，折扣码可用于洗车交易",
  "The user enter the discount code": "用户输入优惠码",
  "in the payment page will get": "在支付页面会得到",
  "discount": "折扣",
  "The discount code only can be used start from {{ start_date }} until {{ end_date }}": "优惠码只能在 {{ start_date }} 至 {{ end_date }} 期间使用",
  "Every user only can use the discount code {{ redeem_per_user }} times": "每个用户只能使用优惠码 {{ redeem_per_user }} 次",
  "Every user only can use {{ redeem_per_user }} discount code from this batch of code": "每个用户只能使用这批优惠码中的 {{ redeem_per_user }} 个优惠码",
  "Only {{ redeem_per_day }} transactions can use the discount code in one day": "一天内只有 {{ redeem_per_day }} 笔交易可以使用优惠码",
  "The discount code only can be used for washer machine": "优惠码仅适用于洗衣机",
  "The discount code only can be used for dryer machine": "优惠码仅适用于烘干机",
  "The discount code only can be used for Drop n Go transaction": "优惠码仅适用于Drop n Go交易",
  "The discount code only can be used for vending machine transaction": "折扣码仅可用于自动售货机交易",
  "The discount code only can be used for detergent vending machine transaction": "折扣码仅可用于洗衣液自动售货机交易",
  "The discount code only can be used for car wash transaction": "折扣码仅可用于洗车交易",
  "The discount code can be used for washer machine or Drop n Go transaction": "优惠码可用于洗衣机或 Drop n Go 交易",
  "The discount code can be used for dryer machine or Drop n Go transaction": "优惠码可用于烘干机或 Drop n Go 交易",
  "The discount code can be used for washer machine, dryer machine or Drop n Go transaction": "优惠码可用于洗衣机、烘干机或 Drop n Go 交易",
  "The discount code can be used for washer or dryer machine": "优惠码可用于洗衣机或烘干机",
  "The discount code can be used for washer machine or vending machine transaction": "折扣码可用于洗衣机或自动售货机交易。",
  "The discount code can be used for washer machine or detergent vending machine transaction": "折扣码可用于洗衣机或洗衣液自动售货机交易。",
  "The discount code can be used for washer machine or car wash transaction": "折扣码可用于洗衣机或洗车交易。",
  "The discount code can be used for dryer machine or vending machine transaction": "折扣码可用于烘干机或自动售货机交易。",
  "The discount code can be used for dryer machine or detergent vending machine transaction": "折扣码可用于烘干机或洗衣液自动售货机交易。",
  "The discount code can be used for dryer machine or car wash transaction": "折扣码可用于烘干机或洗车交易。",
  "The discount code can be used for vending machine or Drop n Go transaction": "折扣码可用于自动售货机或Drop n Go交易。",
  "The discount code can be used for detergent vending machine or Drop n Go transaction": "折扣码可用于洗衣液自动售货机或Drop n Go交易。",
  "The discount code can be used for car wash or Drop n Go transaction": "折扣码可用于洗车或Drop n Go交易。",
  "The discount code can be used for vending machine or detergent vending machine transaction": "折扣码可用于自动售货机或洗衣液自动售货机交易。",
  "The discount code can be used for vending machine or car wash transaction": "折扣码可用于自动售货机或洗车交易。",
  "The discount code can be used for detergent vending machine or car wash transaction": "折扣码可用于洗衣液自动售货机或洗车交易。",
  "The discount code can be used for washer machine, dryer machine or vending machine transaction": "折扣码可用于洗衣机、烘干机或自动售货机交易。",
  "The discount code can be used for washer machine, dryer machine or detergent vending machine transaction": "折扣码可用于洗衣机、烘干机或洗衣液自动售货机交易。",
  "The discount code can be used for washer machine, dryer machine or car wash transaction": "折扣码可用于洗衣机、烘干机或洗车交易。",
  "The discount code can be used for washer machine, vending machine or Drop n Go transaction": "折扣码可用于洗衣机、自动售货机或Drop n Go交易。",
  "The discount code can be used for washer machine, detergent vending machine or Drop n Go transaction": "折扣码可用于洗衣机、洗衣液自动售货机或Drop n Go交易。",
  "The discount code can be used for washer machine, car wash or Drop n Go transaction": "折扣码可用于洗衣机、洗车或Drop n Go交易。",
  "The discount code can be used for washer machine, vending machine or detergent vending machine transaction": "折扣码可用于洗衣机、自动售货机或洗衣液自动售货机交易。",
  "The discount code can be used for washer machine, vending machine or car wash transaction": "折扣码可用于洗衣机、自动售货机或洗车交易。",
  "The discount code can be used for washer machine, detergent vending machine or car wash transaction": "折扣码可用于洗衣机、洗衣液自动售货机或洗车交易。",
  "The discount code can be used for dryer machine, vending machine or Drop n Go transaction": "折扣码可用于烘干机、自动售货机或Drop n Go交易。",
  "The discount code can be used for dryer machine, detergent vending machine or Drop n Go transaction": "折扣码可用于烘干机、洗衣液自动售货机或Drop n Go交易。",
  "The discount code can be used for dryer machine, car wash or Drop n Go transaction": "折扣码可用于烘干机、洗车或Drop n Go交易。",
  "The discount code can be used for dryer machine, vending machine or detergent vending machine transaction": "折扣码可用于烘干机、自动售货机或洗衣液自动售货机交易。",
  "The discount code can be used for dryer machine, vending machine or car wash transaction": "折扣码可用于烘干机、自动售货机或洗车交易。",
  "The discount code can be used for dryer machine, detergent vending machine or car wash transaction": "折扣码可用于烘干机、洗衣液自动售货机或洗车交易。",
  "The discount code can be used for vending machine, detergent vending machine or Drop n Go transaction": "折扣码可用于自动售货机、洗衣液自动售货机或Drop n Go交易。",
  "The discount code can be used for vending machine, car wash or Drop n Go transaction": "折扣码可用于自动售货机、洗车或Drop n Go交易。",
  "The discount code can be used for detergent vending machine, car wash or Drop n Go transaction": "折扣码可用于洗衣液自动售货机、洗车或Drop n Go交易。",
  "The discount code can be used for vending machine, detergent vending machine or car wash transaction": "折扣码可用于自动售货机、洗衣液自动售货机或洗车交易。",
  "The discount code can be used for washer machine, dryer machine, vending machine or Drop n Go transaction": "折扣码可用于洗衣机、烘干机、自动售货机或Drop n Go交易。",
  "The discount code can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction": "折扣码可用于洗衣机、烘干机、自动售货机或洗衣液自动售货机交易。",
  "The discount code can be used for washer machine, dryer machine, vending machine or car wash transaction": "折扣码可用于洗衣机、烘干机、自动售货机或洗车交易。",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine or car wash transaction": "折扣码可用于洗衣机、烘干机、洗衣液自动售货机或洗车交易。",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or Drop n Go transaction": "折扣码可用于洗衣机、自动售货机、洗衣液自动售货机或Drop n Go交易。",
  "The discount code can be used for washer machine, vending machine, car wash or Drop n Go transaction": "折扣码可用于洗衣机、自动售货机、洗车或Drop n Go交易。",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or car wash transaction": "折扣码可用于洗衣机、自动售货机、洗衣液自动售货机或洗车交易。",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "折扣码可用于烘干机、自动售货机、洗衣液自动售货机或Drop n Go交易。",
  "The discount code can be used for dryer machine, vending machine, car wash or Drop n Go transaction": "折扣码可用于烘干机、自动售货机、洗车或Drop n Go交易。",
  "The discount code can be used for dryer machine, detergent vending machine, car wash machine or Drop n Go transaction": "折扣码可用于烘干机、洗衣液自动售货机、洗车机或Drop n Go交易。",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or car wash transaction": "折扣码可用于烘干机、自动售货机、洗衣液自动售货机或洗车交易。",
  "The discount code can be used for vending machine, detergent vending machine, car wash or Drop n Go transaction": "折扣码可用于自动售货机、洗衣液自动售货机、洗车或Drop n Go交易。",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "折扣码可用于洗衣机、烘干机、自动售货机、洗衣液自动售货机或Drop n Go交易。",
  "The discount code can be used for washer machine, dryer machine, vending machine, car wash or Drop n Go transaction": "折扣码可用于洗衣机、烘干机、自动售货机、洗车或Drop n Go交易。",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine, car wash or Drop n Go transaction": "折扣码可用于洗衣机、烘干机、洗衣液自动售货机、洗车或Drop n Go交易。",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or car wash transaction": "折扣码可用于洗衣机、烘干机、自动售货机、洗衣液自动售货机或洗车交易。",
  "The discount code can be used for washer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "折扣码可用于洗衣机、自动售货机、洗衣液自动售货机、洗车或Drop n Go交易。",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "折扣码可用于烘干机、自动售货机、洗衣液自动售货机、洗车或Drop n Go交易。",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "折扣码可用于洗衣机、烘干机、自动售货机、洗衣液自动售货机、洗车或Drop n Go交易。",
  "The discount code only can be used after user spending {{ currency }} {{ pay_and_use_amount }}": "优惠码必须在消费满{{ currency }} {{ pay_and_use_amount }}后才能使用",
  "Are you sure you want to edit FAQ?": "您确定要编辑常见问题吗？",
  "FAQ updated successfully": "常见问题更新成功",
  "Edit FAQ": "编辑常见问题",
  "Are you sure you want to edit FAQ Group?": "您确定要编辑常见问题组吗？",
  "FAQ Group updated successfully": "常见问题组更新成功",
  "Edit FAQ Group": "编辑常见问题组",
  "Are you sure you want to edit news?": "您确定要编辑消息吗？",
  "News edit successfully": "消息编辑成功",
  "Edit News": "编辑消息",
  "All the FAQ under this group will be deleted. Are you sure you want to delete FAQ Group?": "该组下的所有常见问题将被删除。您确定要删除常见问题组吗？",
  "FAQ Group deleted successfully": "常见问题组删除成功",
  "FAQ List": "常见问题列表",
  "NO FAQ GROUP": "没有常见问题组",
  "FAQ Group": "常见问题组",
  "Are you sure you want to delete FAQ?": "您确定要删除常见问题吗？",
  "FAQ deleted successfully": "常见问题删除成功",
  "NO FAQs": "没有常见问题",
  "FAQ": "常见问题",
  "Easy": "便利",
  "Fast Laundromate": "快速洗衣店",
  "Smart Laundry Management System": "智能洗衣管理系统",
  "Enter your username and password to login": "请输入登录用户名和密码",
  "Username": "用户名",
  "Are you sure you want to delete news?": "您确定要删除消息吗？",
  "News deleted successfully": "消息删除成功",
  "NO NEWS": "没有消息",
  "The referral setting has been updated successfully!": "邀请码设置已更新成功！",
  "Number of Stamp": "印章数量",
  "Number of Washer Stamp": "洗衣机印章数量",
  "Number of Dryer Stamp": "烘干機印章數量",
  "Enable Referral Feature?": "开启邀请码功能吗？",
  "Are you sure you want to delete the tier setting?": "您确实要删除此等级设置吗？",
  "Minimum referee transaction amount for referrer to get referral rewards": "邀请者获得邀请奖励的最低交易金额",
  "Maximum number of reward within this tier": "此等级内的最大奖励数量",
  "Maximum number of reward can get from same user": "从同一用户可获得的最大奖励数量",
  "Point Grant Type": "积分授予类型",
  "Select Point Grant Type": "选择积分授予类型",
  "Token Grant Type": "电子代币授予类型",
  "Select Token Grant Type": "选择电子代币授予类型",
  "Add Tier": "添加等级",
  "Stamp": "印章",
  "If ticked, the system will give stamp to user": "如果勾选，系统将会给用户印章",
  "If ticked, the system will give e-Token to user": "如果勾选，系统将会给用户电子代币",
  "If ticked, the system will give voucher to user": "如果勾选，系统将会给用户优惠券",
  "Number of E-Token": "电子代币数量",
  "Reward Giveaway": "奖励赠品",
  "Which type of reward you want to give to customer?": "您想给予客户哪种类型的奖励？",
  "For machine uses (required)": "用于机器用途（必选）",
  "leave blank if no expiry date": "如果没有到期日则留空",
  "Remarks": "备注",
  "Reward": "奖励",
  "Please fill in all the required field. (Title, description, and amount must be more than 0)": "请填写所有必填选项。 （标题、描述、金额必须大于0）",
  "Checkbox required": "需要勾选复选框",
  "Must select voucher can be used for washer, dryer or package": "必须选择优惠券可用于洗衣机，烘干机或配套",
  "How many e-token?": "多少个电子代币？",
  "Number of e-Token": "电子代币数量",
  "Token value must be more than 0": "电子代币金额必须大于0",
  "STAMP": "印章",
  "Please fill in at least one of the required field": "请填写至少一项必填选项",
  "The value must be more than 0": "该值必须大于 0",
  "How many times rewarded to user": "给用户多少次奖励",
  "Rewarded Times": "奖励次数",
  "How many times rewarded voucher to user": "给用户多少次优惠券",
  "Voucher Rewarded (times)": "优惠券奖励（次）",
  "How many times rewarded stamp to user": "给用户多少次印章",
  "Stamps Rewarded (times)": "印章奖励（次）",
  "Total number of washer stamps rewarded to user": "奖励给用户的洗衣机印章总数",
  "Washer Stamps Granted (stamp)": "给予的洗衣机印章（印章）",
  "Total number of dryer stamps rewarded to user": "奖励给用户的烘干机印章总数",
  "Dryer Stamps Granted (stamp)": "给予的烘干机印章（印章）",
  "How many times rewarded e-Token to user": "给用户多少次电子代币",
  "e-Token Rewarded (times)": "电子代币奖励（次）",
  "Total number of e-Token rewarded to user": "奖励给用户的电子代币总数",
  "Total e-Token Granted (token)": "给予的电子代币总数（电子代币）",
  "Point Rewarded (times)": "积分奖励（次）",
  "How many times rewarded point to user": "给用户奖励积分多少次",
  "Total Point Granted (point)": "总积分奖励（积分）",
  "Total number of point rewarded to user": "奖励给用户的积分总数",
  "Point Amount": "积分数量",
  "Reward History": "奖励历史",
  "Are you sure you want to change how the stamping mechanics works?": "您确定要更改印章机制的运作方式吗？",
  "The stamping mechanics setting has updated successfully!": "印章机制设置已更新成功！",
  "The voucher setting has been updated successfully!": "优惠券设置已更新成功！",
  "Mechanics Settings": "印章机制设置",
  "Minimum transaction amount for getting stamp": "获得印章的最低交易金额",
  "Select User Stamping Mechanic": "选择用户的印章机制",
  "Separated Stamping": "分开印章",
  "Combined Stamping": "综合印章",
  "Stamp for?": "印章方式？",
  "Both": "两者",
  "Washer Only": "仅洗衣机",
  "Dryer Only": "仅烘干机",
  "Separated Stamping = Different washer and dryer stamp collection. (example: Using Washer will gain 1 washer's stamp, and Dryer will gain 1 dryer stamp)": "分开印章 = 不同的洗衣机和烘干机印章收集。 （例如：使用洗衣机将获得1个洗衣机印章，使用烘干机将获得1个烘干机印章）",
  "Combined Stamping = Washer and dryer has the same collection. (example: Using Washer or Dryer will gain 1 stamp)": "综合印章 = 洗衣机和烘干机有相同的印章收集。 （例如：使用洗衣机或烘干机将获得1个印章）",
  "Stamp for": "印章方式",
  "User will be able to collect both washer stamp and dryer stamp": "用户将能够收集洗衣机印章和烘干机印章",
  "User will only able to collect Washer stamp": "用户只能收集洗衣机印章",
  "User will only able to collect Dryer stamp": "用户只能收集烘干机印章",
  "Registration": "注册",
  "Birthday": "生日",
  "Please choose at least one payment method": "请至少选择一种付款方式",
  "Please choose at least one member or non-member payment": "请选择至少一个会员或非会员付款",
  "Are you sure you want to change the payment setting?": "您确定要更改付款设置吗？",
  "The payment setting has updated successfully!": "付款设置已更新成功！",
  "Invalid input": "不正确输入",
  "The price and token must be more than 0": "价格和电子代币必须大于0",
  "Maximum number of purchase must be more than 0": "最多购买的次数必须大于0",
  "Point amount must be more than 1": "积分数量必须大于 1",
  "Added a new Token Bundle Package": "添加了新的电子代币配套",
  "Bundle deleted successfully!": "配套删除成功！",
  "Reload voucher setting have edited successfully!": "充值优惠劵设置已编辑成功！",
  "Added on": "添加于",
  "remove": "移除",
  "edit": "编辑",
  "NO PACKAGES ON SALES": "没有销售配套",
  "Point Settings": "积分设置",
  "Enable Loyalty Point": "启用积分",
  "Point Name": "积分名称",
  "Number Of Point Equals To": "积分数量同等于",
  "If ticked, the point will have expired date": "如果勾选，积分将过期",
  "Point Lifespan": "积分寿命",
  "months": "月",
  "Minimum Transaction Amount To Get Point": "获取积分的最低交易金额",
  "Point Grant Amount": "积分赠予数量",
  "Point Grant Period": "积分赠予期",
  "Optional": "自选的",
  "Drop n Go Eligibility": "Drop n Go 资格",
  "If ticked, Drop n Go transaction will get the point": "如果勾选，Drop n Go 交易将获得积分",
  "Washer Eligibility": "洗衣机资格",
  "If ticked, washer transaction will get the point": "如果勾选，洗衣机交易将获得积分",
  "Dryer Eligibility": "烘干机资格",
  "If ticked, dryer transaction will get the point": "如果勾选，烘干机交易将获得积分",
  "Point settings updated successfully!": "积分设置更新成功！",
  "Point Eligibility": "积分资格",
  "If ticked, the system will give point to user when user reload token successfully": "如果勾选，当用户成功充值电子代币时系统会给用户积分",
  "{{ point_amount }} point will be given after user reload token successfully": "用户成功充值电子代币后将获得 {{ point_amount }} 积分",
  "Payment Settings": "付款设置",
  "Select Payment Method": "选择付款方式",
  "Enable E-Payment?": "启用电子支付吗？",
  "Enable Token Currency?": "启用电子代币吗？",
  "Enable Cash Payment?": "启用现金支付吗？",
  "Enable QR Payment?": "启用二维码支付吗？",
  "Member and Non-Member Settings": "会员和非会员设置",
  "Enable Member Payment?": "启用会员支付？",
  "Enable Non-Member Payment?": "启用非会员支付？",
  "Promotion Settings": "促销设置",
  "Enable Non Member Promotion?": "启用非会员促销吗？",
  "Enable Notification When Cycle Done?": "循环完成后启用通知吗？",
  "SMS charges": "短信收费",
  "SMS Settings": "短信设置",
  "Enable Free Sms For Members": "启用会员免费短信",
  "If enable notification, user can choose either receive email or sms when complete washing or drying": "如果启用通知，用户可以选择在完成洗涤或烘干时接收电子邮件或短信",
  "If user choose sms, non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "如果用户选择短信，非会员必须支付额外的{{ currency }}{{ sms_notification_amount }}短信费用",
  "If user choose sms, member and non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "如果用户选择短信，会员和非会员必须支付额外的{{ currency }}{{ sms_notification_amount }}短信费用",
  "Add Package": "添加配套",
  "Edit e-Token Package": "编辑电子代币配套",
  "Add e-Token Package": "添加电子代币配套",
  "Please only input numberic value to prevent any bugs.": "请仅输入数字值，以防止任何错误。",
  "Price": "价格",
  "If ticked, the system will limit the number of purchase": "如果勾选，系统会限制购买次数",
  "Limit Number of Purchase": "限制购买次数",
  "Number of maximum purchase": "最多的购买次数",
  "Reload Voucher": "充值优惠券",
  "If ticked, the system will give voucher to user when user reload token successfully": "如果勾选，当用户充值成功后，系统将向用户赠送优惠券",
  "If ticked, the system will give voucher repeatly": "如果勾选，系统会重复赠送优惠券",
  "Recurring": "反复",
  "Total number of voucher given to user": "给予用户的优惠券总数",
  "Period for giving next voucher": "发放下一张优惠券的期限",
  "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens": "{{ currency }}{{ price }} 的电子代币配套将获得 {{ numberOfToken }} 个电子代币",
  "Each user only can purchase {{ max_purchase }} times for the token package": "每个用户只能购买{{ max_purchase }}次此电子代币配套",
  "Voucher will be given after user reload token successfully": "用户充值成功后将获得优惠券",
  "Voucher will not given after user reload tokens successfully": "用户充值成功后将不会获得优惠券",
  "The voucher will be expired after {{ voucher_duration }} days": "优惠券将于 {{ voucher_duration }} 天后过期",
  "The voucher will not expired": "优惠券不会过期",
  "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount": "总共 {{ recurring_number }} 张优惠券将赠送给用户，每张优惠券将有折扣",
  "Edit Package": "编辑配套",
  "Age": "年龄",
  "Total number of vouchers collected": "已领取优惠券总数",
  "Vouchers Acquired": "已获得优惠券",
  "Total amount spent in washer machine transactions": "洗衣机交易总金额",
  "Total Washer Payment": "洗衣机总花费",
  "Total amount spent in dryer machine transactions": "烘干机交易总金额",
  "Total Dryer Payment": "烘干机总花费",
  "Total amount spent in all transactions": "所有交易花费的总金额",
  "Total Payment": "付款总额",
  "report": "报告",
  "Total amount spent for buying e-Token": "购买电子代币的总金额",
  "Total number of e-Token purchased": "购买的电子代币总数",
  "Total e-Token Purchased (Tokens)": "购买的电子代币总数（电子代币）",
  "Total number of e-Token used in washer machine transactions": "洗衣机交易中使用的电子代币总数",
  "Washer Payment (Tokens)": "洗衣机付款金额（电子代币）",
  "Total number of e-Token used in dryer machine transactions": "烘干机交易中使用的电子代币总数",
  "Dryer Payment (Tokens)": "烘干机付款金额（电子代币）",
  "Total number of e-Token used in all the transactions": "所有交易中使用的电子代币总数",
  "Total Payment (Tokens)": "付款总金额（电子代币）",
  "Number of washer stamp collected currently": "目前收集的洗衣机印章数量",
  "Number of dryer stamp collected currently": "目前收集的烘干机印章数量",
  "User Phone Number / Member ID / Email": "用户电话号码/会员ID/电子邮件",
  "Example: 0123456789,A123456": "例如: 0123456789,A123456",
  "SEARCH": "搜索",
  "Total Users Registered": "注册用户总数",
  "Total Active Outlets": "店铺总数",
  "Total Vouchers Given": "给予的优惠券总数",
  "Total Transaction Counts": "总交易量",
  "Total User Stamps Collected": "用户收集的印章总数",
  "Distributor Login": "经销商登录",
  "Client Login": "客户登录",
  "Kiosk Login": "自助服务终端登录",
  "Promotion": "促销",
  "Please select operator": "请选择运营商",
  "Please select distributor": "请选择经销商",
  "Select Operator": "选择运营商",
  "Select Distributor": "选择经销商",
  "User can login or skip to payment without login to make the payment": "用户可以登录或者无需登录即可跳转至支付页面进行支付",
  "User have to login only can make the payment": "用户必须登录才可以付款",
  "User only can skip to payment without login to make the payment": "用户只能直接跳至付款页面进行付款（无登录功能）",
  "Only CSV file is accepted": "仅接受 CSV 文件",
  "The user and the balance have updated": "用户和余额已更新",
  "Register Time": "注册时间",
  "Upload User CSV file": "上传用户 CSV 文件",
  "Sample CSV file": "示例 CSV 文件",
  "Please follow the CSV file format": "请遵循 CSV 文件格式",
  "User CSV file": "用户 CSV 文件",
  "Only CSV file (comma delimited) is support now": "现在仅支持 CSV 文件（逗号分隔）",
  "Confirm uploaded data": "确认上传的数据",
  "Operator": "运营商",
  "Distributor": "经销商",
  "Refund By": "退款者",
  "Reward By": "奖励者",
  "Number Of Voucher Code": "优惠券兑换码数量",
  "Number Of Discount Code": "折扣码数量",
  "New User Only": "仅限新用户",
  "Minimum Transaction Amount To Redeem": "兑换最低交易金额",
  "Download": "下载",
  "Generate Voucher Code": "生成优惠券兑换码",
  "Your voucher code is generating": "您的优惠券兑换码正在生成",
  "Your discount code is generating": "您的折扣码正在生成",
  "Voucher Code Settings": "优惠券兑换码设置",
  "If ticked, the voucher code only can redeem in register page": "如果勾选，兑换码只能在注册页面兑换",
  "If ticked, the user only can use the voucher after make a transaction": "如果勾选，用户只能在交易后使用该优惠券",
  "If ticked, the user only can use the discount code after make a transaction": "如果勾选，用户只能在交易后使用该优惠码",
  "Expired Date Of Voucher Code": "优惠券兑换码的失效日期",
  "Minimum Transaction Amount To Use Voucher": "使用优惠券的最低交易金额",
  "Minimum Transaction Amount To Use Code": "使用优惠码的最低交易金额",
  "Max redemption per user in this batch voucher code": "此批次优惠券兑换码中每个用户的最大兑换次数",
  "Max redemption per user in this batch discount code": "此批次优惠码中每个用户的最大兑换次数",
  "Add Voucher": "增加优惠券",
  "Completed": "完成",
  "Voucher Code Report": "优惠券兑换码报告",
  "Floating Token Report": "浮动电子代币报告",
  "Floating Point Report": "浮动积分报告",
  "E-Payment Report": "电子支付报告",
  "Referral Reward History Report": "邀请码奖励历史报告",
  "Redemption Date": "兑换日期",
  "Redemption Code": "兑换码",
  "Select Redemption Date": "选择兑换日期",
  "Select Voucher Type": "选择优惠券类型",
  "Giveaway": "补偿",
  "Select Name": "选择名称",
  "Amount must be more than 1": "金额必须大于1",
  "Payment method setting have updated successfully!": "付款方式设置已成功更新！",
  "Edit Payment Method": "编辑付款方式",
  "Minimum payment amount to include all the payment methods": "包含所有付款方式的最低付款金额",
  "Exclude Payment Method in Revenue Monster": "在 Revenue Monster 中排除的付款方式",
  "Welcome to": "欢迎来到",
  "Instruction": "操作说明",
  "Please select the machine": "请选择机器",
  "Login your account": "登录您的帐户",
  "Select the setting and make the payment": "选择设置并付款",
  "Phone Number / Email": "电话号码/电子邮件",
  "Reload & Transfer In": "充值及转入",
  "Usage & Transfer Out": "使用及转出",
  "Usage": "使用",
  "Remaining": "剩余",
  "Gain": "获得",
  "Type": "类型",
  "Order Date": "日期",
  "Pack Number": "包裹号码",
  "Pack Details": "包裹详情",
  "Size": "尺寸",
  "Mode": "模式",
  "Machine Payment": "机器支付总额",
  "DNG History": "DNG历史",
  "Token History": "电子代币历史记录",
  "Stamp History": "印章历史记录",
  "Staff Login": "员工登录",
  "Drop And Go Portal": "Drop And Go Portal",
  "Available Task": "可执行任务",
  "Completed Task": "已完成任务",
  "Task ID": "任务ID",
  "Task": "任务",
  "Start Task": "开始任务",
  "Select Machine": "选择机器",
  "Start Machine": "启动机器",
  "Reward To": "奖励给",
  "Reward From": "奖励来自",
  "Transaction Account": "交易账户",
  "Point": "积分",
  "POINT": "积分",
  "Number of Point": "积分数量",
  "Point History": "积分历史",
  "Customer Name": "客户姓名",
  "Number of Washer Transactions": "洗衣交易数量",
  "Number of Dryer Transactions": "烘干交易数量",
  "Vouchers Redeemed": "兑换的优惠券",
  "Discount Code Redemption": "折扣码兑换",
  "Total Spend": "总支出",
  "Select Outlet(s)": "选择店铺",
  "User Usage Report": "用户使用报告",
  // cleanpro plus zh
  "Wash": "洗涤",
  "Dry": "烘干",
  "Fold": "折叠",
  "Scan QR": "扫描二维码",
  "Capacity": "容量",
  "Duration": "时长",
  "Custom duration": "自定义持续时间",
  "Choose duration": "选择持续时间",
  "Select the correct amount on the machine after payment.": "付款后在机器上选择正确的金额。",
  "Offers": "优惠",
  "Voucher Offers": "优惠券优惠",
  "Discount Code Offers": "折扣码优惠",
  "An easier way to pay": "更简单的支付方式",
  "Create account": "创建账户",
  "Login": "登录",
  "By signing up, you agree to": "注册即表示您同意",
  "Amount to Pay": "支付总额",
  "1 voucher selected": "已选择 1 张优惠券",
  "No voucher selected": "未选择优惠券",
  "credit": "点数",
  "Credits": "点数",
  "credits": "点数",
  "Credit balance": "点数余额",
  "Please ensure that the machine door is shut & your laundry is inside.": "请确保机器门已关闭并且您的衣物在里面。",
  "Insufficient balance": "余额不足",
  "Topup now": "立即充值",
  "Copyright © {{ year }} Cleanpro Laundry Holdings Sdn Bhd (821842-P) All rights reserved.": "版权所有 © {{ year }} Cleanpro Laundry Holdings Sdn Bhd (821842-P) 保留所有权利。",
  "Good Evening!": "下午好！",
  "Hello": "你好",
  "Wallet Balance": "钱包余额",
  "Topup": "充值",
  "More details": "更多细节",
  "Collect 10 e-stamps to earn x1 FREE wash or dry voucher": "集齐 10 个电子印章即可获得 x1 免费洗或干优惠券",
  "For every wash or dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "您在我们这里完成的每一次洗涤或烘干循环，都将获得一个电子印章。集齐 10 个，您就可以兑换一次免费的洗涤或烘干周期。这是我们感谢您选择 Cleanpro 的方式！",
  "For every wash cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "您在我们这里完成的每一次洗涤循环，都将获得一个电子印章。集齐 10 个，您就可以兑换一次免费的洗涤或烘干周期。这是我们感谢您选择 Cleanpro 的方式！",
  "For every dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "您在我们这里完成的每一次烘干循环，都将获得一个电子印章。集齐 10 个，您就可以兑换一次免费的洗涤或烘干周期。这是我们感谢您选择 Cleanpro 的方式！",
  "Credits OFF": "点数折扣",
  "% OFF": "％ 折扣",
  "Valid Till": "有效期至",
  "Used On": "用于",
  "Expired On": "过期日期",
  "Available": "可用的",
  "Expired": "已过期",
  "Used": "已使用",
  "Promotions": "促销活动",
  "Rewards": "奖励",
  "Inbox": "收件箱",
  "Activities": "活动",
  "Support": "支持",
  "Active Rewards": "活跃奖励",
  "Past Rewards": "过往奖励",
  "Get rewarded for your loyalty with Cleanpro Plus Rewards!": "通过 Cleanpro Plus 奖励获得忠诚奖励！",
  "Earn vouchers and redeem them for discounts, freebies and more. The more you use our services the more you save!": "赚取优惠券并将其兑换为折扣、免费赠品等。您使用我们的服务越多，您节省的越多！",
  "Up to 3 months history": "最近3个月的历史记录",
  "Filter": "筛选",
  "All Transactions": "所有交易",
  "Transactions": "交易",
  "Select amount to topup": "选择充值金额",
  "Balance": "余额",
  "You've just paid": "你刚刚付款",
  "Need help?": "需要帮忙？",
  "24-Hour Careline Number": "24 小时服务热线号码",
  "Email Us": "给我们发电子邮件",
  "Call Now": "现在打电话",
  "Email Now": "立即发送电子邮件",
  "Update name": "更新名称",
  "Update email address": "更新电子邮件地址",
  "Update phone number": "更新电话号码",
  "Change password": "更改密码",
  "Change language": "改变语言",
  "User ID": "用户号",
  "Let us know your feedback": "让我们知道您的反馈",
  "Poor": "糟糕",
  "Good": "好的",
  "Leave addtional feedback here (optional)": "在此处留下其他反馈（可选)",
  "Submit feedback": "提交反馈",
  "Pay as guest": "以访客身份付款",
  "Pay now": "现在付款",
  "Select voucher to use": "选择要使用的优惠券",
  "Use voucher": "使用优惠券",
  "Total": "总共",
  "Transaction Type": "交易类型",
  "E-Token Topup": "电子代币充值",
  "Credit Topup": "点数充值",
  "Credit topup": "点数充值",
  "Credit Transfer": "点数转账",
  "E-Token Transfer": "电子代币转账",
  "Date/Time": "日期/时间",
  "Reference ID": "参考编号",
  "Status": "状态",
  "Share Your Referral Code": "分享您的邀请码",
  "cleanproReferralShortDesc": "将您的邀请码分享给亲朋好友，当完成交易后可免费获得 {{ voucherAmount }} 积分。点击以了解更多信息。",
  "Use": "使用",
  "dryer or washer": "烘干机或洗衣机",
  "washer": "洗衣机",
  "dryer": "烘干机",
  "dryer and washer": "烘干机和洗衣机",
  "machine with the minimum spending of": "以最低消费",
  // "Welcome to Cleanpro Plus": "欢迎来到 Cleanpro Plus",
  // "Only scan, set & pay! An easier, more convenient way to pay with Cleanpro Plus! No need to download an app. Enjoy more rewards when you use Cleanpro Plus today! Tap to learn more.": "只需扫描、设置和支付！使用 Cleanpro Plus 支付更简单、更方便的方式！无需下载应用程序。立即使用 Cleanpro Plus，享受更多奖励！点击以了解更多信息。",
  // "Cleanpro Pay Migration Notice": "Cleanpro Pay 迁移通知",
  // "Dear valued Cleanpro customers, please be informed that as of 22 June 2023, the Cleanpro Pay app will be upgraded and and no longer available for use. Tap to learn more.": "尊敬的 Cleanpro 客户，请注意，自 2023 年 6 月 22 日起，Cleanpro Pay 应用程序将升级并不再可用。点击以了解更多信息。",
  // "Answer simple questions and win credits for your next wash or dry! This contest is only available for selected outlets only. Tap to learn more.": "回答简单的问题并为您的下一次洗涤或烘干赢得点数！此竞赛仅适用于指定的商店。点击以了解更多信息。",
  // "The all-new Cleanpro Plus is a new payment method that includes loyalty features built into the app. The more you use our services and pay using Cleanpro Plus, the more you can save. With every transaction, you can earn rewards that will help you save on your next laundry expenses.": "全新的 Cleanpro Plus 是一种新的支付方式，包括内置于应用程序中的忠诚度功能。您使用我们的服务和使用 Cleanpro Plus 支付的次数越多，您节省的费用就越多。每笔交易，您都可以获得奖励，帮助您节省下一次洗衣费用。",
  // "To use Cleanpro Plus, simply scan the QR code on the machines and pay using your preferred credit/debit card or e-wallet. We hope that Cleanpro Plus will help simplify your laundry routine and give you more time for the things that matter.": "要使用 Cleanpro Plus，只需扫描机器上的二维码并使用您首选的信用卡/借记卡或电子钱包付款。我们希望 Cleanpro Plus 能够帮助简化您的洗衣程序，让您有更多时间处理重要的事情。",
  // "If you have any questions about Cleanpro Plus, please read our FAQ in the menu or contact our careline at +603 2770 0100 or email us at info@cleanprolaundry.com. Thank you for choosing Cleanpro.": "如果您对 Cleanpro Plus 有任何疑问，请阅读菜单中的常见问题解答或致电 +603 2770 0100 联系我们的客服热线或发送电子邮件至 info@cleanprolaundry.com。感谢您选择 Cleanpro。",
  // "Dear valued Cleanpro customers, please be informed that as of 22 June 2023, the existing Cleanpro Pay mobile app will be upgraded and no longer available for use.": "尊敬的 Cleanpro 客户，请注意，自 2023 年 6 月 22 日起，现有的 Cleanpro Pay 移动应用程序将升级并不再可用。",
  // "We are migrating to the all-new Cleanpro Plus. It is a new cashless payment method, without the need to download apps.": "我们正在迁移到全新的 Cleanpro Plus。这将是一种新的无现金支付方式，无需下载应用程序。",
  // "If you are the existing user of Cleanpro Pay, any of your remaining balance in the app will be transferred to your Cleanpro Plus account. You are required to use the same mobile number to sign up for Cleanpro Plus for balance transfer.": "如果您是 Cleanpro Pay 的现有用户，您在应用程序中的任何余额都将转移到您的 Cleanpro Plus 帐户。您需要使用相同的手机号码注册 Cleanpro Plus 进行余额转移。",
  // "If you need help on Cleanpro Plus, please feel free to call our careline at +603 2770 0100 or email us at info@cleanprolaundry.com": "如果您需要有关 Cleanpro Plus 的帮助，请随时拨打我们的服务热线 +603 2770 0100 或发送电子邮件至 info@cleanprolaundry.com",
  // "Answer simple questions and win credits for your next wash or dry!": "回答简单的问题并为您的下一次洗涤或烘干赢得点数！",
  // "Step 1 : Scan the Jawab & Gerenti Menang QR code in the participated outlets.": "第 1 步：在指定的商店里扫描Jawab & Gerenti Menang 二维码。",
  // "Step 2 : Answer 3 simple questions.": "第 2 步：回答 3 个简单问题。",
  // "Step 3 : Submit and stand a chance to win prizes.": "第 3 步：提交并有机会赢取奖品。",
  // "Grand Prize :": "大奖：",
  // "x10 per outlet - 100 credits worth of vouchers in Cleanpro Plus": "每个分店 x10 - Cleanpro Plus 中的 RM100 点数优惠劵",
  // "Consolation Prize :": "安慰奖：",
  // "X25 per outlet - 50 credits worth of vouchers in Cleanpro Plus": "每个分店 X25 - Cleanpro Plus 中的 RM50 点数优惠劵",
  // "Participation prize:": "参与奖：",
  // "Every participants are eligible to receive a FREE 3 credits voucher (worth RM3) in Cleanpro Plus.": "每位参与者都有资格在 Cleanpro Plus 中免费获得 3 个点数优惠券（价值 RM3）。",
  // "If you have any questions please don't hesitate to contact our careline at +603 2770 0100 or email us at info@cleanprolaundry.com. Thank you for choosing Cleanpro.": "如果您有任何疑问，请随时拨打我们的服务热线 +603 2770 0100 或发送电子邮件至 info@cleanprolaundry.com。感谢您选择 Cleanpro。",
  "Payment Confirmation": "付款确认",
  "This campaign is only eligible for users who use the all-new Cleanpro Plus web application.": "此活动仅适用于使用全新 Cleanpro Plus 网络应用程序的用户。",
  "ONE e-stamp will be rewarded for each wash or dry cycle.": "每次洗涤或干燥循环将奖励一个电子印章。",
  "ONE e-stamp will be rewarded for each wash cycle.": "每个洗涤循环将奖励一个电子印章。",
  "ONE e-stamp will be rewarded for each dry cycle.": "每个干燥循环将奖励一个电子印章。",
  "Regardless of the washer or dryer settings, the number of e-stamps being collected is the same.": "无论洗衣机或烘干机设置如何，收集的电子印章数量都是相同的。",
  "The type of e-stamp collected is based on the services that you have used.": "您所收集的电子印章种类取决于你所使用的服务而定。",
  "Washing service will reward washer e-stamp and drying service will reward dryer e-stamp.": "洗涤服务将奖励洗衣机电子印章，烘干服务将奖励烘干机电子印章。",
  "Washing service will reward washer e-stamp.": "洗涤服务将奖励洗衣机电子印章。",
  "Drying service will reward dryer e-stamp.": "烘干服务将奖励烘干机电子印章。",
  "E-stamps will automatically be added to your account once the condition has been fulfilled.": "满足条件后，电子印章将自动添加到您的帐户中。",
  "There is no limit on how many e-stamps can be gathered in a single day. So long as you meet the requirements to collect the e-stamps.": "只要您符合收集电子印章的条件，您将获得电子印章，一天内无收集电子印章数量限制",
  "The type of e-stamps that have been collected is final and cannot be changed.": "已收集的电子印章类型是最终的，不能更改。",
  "There is no expiration for the e-stamps; only till the discontinuation of the campaign.": "电子印章不会过期；直到活动停止为止。",
  "E-stamps do not have any currency value, and they cannot be converted to cash or credits.": "电子印章没有任何货币价值，也不能兑换成现金或点数。",
  "This campaign is not applicable with any other ongoing promotions, offers, vouchers, and/or discounts provided by the participating outlets.": "此活动不适用于参与商店提供的任何其他正在进行的促销、优惠、优惠券和/或折扣。",
  "These terms and conditions are subject to change at any time without prior notice.": "这些条款和条件可能随时更改，恕不另行通知。",
  "Press START on the machine to begin washing.": "按机器上的START开始洗涤。",
  "Press START on the machine to begin drying.": "按机器上的START开始烘干。",
  "Reminder": "提醒",
  "Remember to select the same settings you have paid for on the corresponding machine.": "请记住在相应的机器上选择您已支付的相同设置。",
  "Please ensure that your laundry is inside the machine and door is properly shut.": "请确保您的衣物在机器内并且门已正确关闭。",
  "voucherCreditsOff_one": "折扣 {{currentVoucherAmount}} 点数",
  "voucherCreditsOff_other": "折扣 {{currentVoucherAmount}} 点数",
  "voucherPercentageOff": "折扣 {{currentVoucherAmount}}%",
  "cleanproReferralFlatVoucher_one": "将您的 Cleanpro Plus 邀请码分享给您的朋友和家人，即可获得免费优惠劵！对于每个完成第一笔交易的成功推荐，您将获得一张价值折扣 {{ referralVoucherAmount }} 货币的优惠劵。",
  "cleanproReferralFlatVoucher_other": "将您的 Cleanpro Plus 邀请码分享给您的朋友和家人，即可获得免费优惠劵！对于每个完成第一笔交易的成功推荐，您将获得一张价值折扣 {{ referralVoucherAmount }} 货币的优惠劵。",
  "cleanproReferralRateVoucher": "将您的 Cleanpro Plus 邀请码分享给您的朋友和家人，即可获得免费优惠劵！对于每个完成第一笔交易的成功推荐，您将获得一张价值 {{ referralVoucherAmount }}% 折扣的优惠劵。",
  "cleanproReferralTokenReward_one": "将您的 Cleanpro Plus 邀请码分享给您的朋友和家人，即可获得免费货币！对于每个完成第一笔交易的成功推荐，您将获得免费的 {{ referralToken }} 货币。",
  "cleanproReferralTokenReward_other": "将您的 Cleanpro Plus 邀请码分享给您的朋友和家人，即可获得免费货币！对于每个完成第一笔交易的成功推荐，您将获得免费的 {{ referralToken }} 货币。",
  "How to get & use code:": "如何获取和使用邀请码：",
  'Go to menu = icon and click “Refer friends”': '在菜单 = 图标，然后单击“推荐给朋友”',
  "Share with everyone who will likely to use Cleanpro Plus.": "与所有可能使用 Cleanpro Plus 的人分享。",
  "Referral Terms & Conditions:": "推荐条款和条件：",
  "When your friend or family register using your referral code, and completed a transaction (a minimum spending of {{ currency }}{{ referralTransactionAmount }}) , you will be rewarded automatically.": "当您的朋友或家人使用您的邀请码注册并完成交易（最低消费 {{ currency }}{{ referralTransactionAmount }}）时，您将自动获得奖励。",
  "cleanproNumberOfReferralReward": "您可以与任意数量的人分享，但每个用户只能获得 {{ numberOfReferral }} 次推荐奖励。",
  "cleanproNumberOfReferral_one": "您可以与任意数量的人分享，但每个用户只能收到 {{ numberOfReferral }} 张推荐优惠券。",
  "cleanproNumberOfReferral_other": "您可以与任意数量的人分享，但每个用户只能收到 {{ numberOfReferral }} 张推荐优惠券。",
  "The voucher is valid for {{ duration }} days from the day voucher be given.": "优惠券自发放之日起 {{ duration }} 天内有效。",
  "The voucher is for customer use only and not for sale.": "优惠券仅供客户使用，不得出售。",
  "We believe that your special day deserves a little extra sparkle! That's why we're thrilled to introduce our exclusive birthday rewards program just for you! Starting this year, and every year thereafter, we're giving away {{ currency }}{{ voucherAmount }} credit vouchers to you on your birthday.": "我们相信您的特殊日子值得额外闪耀！这就是为什么我们很高兴为您推出独家生日奖励计划！从今年开始，之后的每一年，我们都会在您生日月份第一天赠送 {{ currency }}{{ voucherAmount }} 优惠券。",
  "cleanproBirthdayRateAmount": "我们相信您的特殊日子值得额外闪耀！这就是为什么我们很高兴为您推出独家生日奖励计划！从今年开始，之后的每一年，我们都会在您生日月份第一天赠送 {{ voucherAmount }}% 优惠券。",
  "Make sure your account details include your birthdate. This way, we'll know exactly when to send you your special birthday surprise.": "请确保您的账户已填写详细信息包括您的生日。这样，我们就能准确知道何时向您发送特别的生日惊喜。",
  "Birthday Voucher Terms & Conditions:": "生日礼券条款和条件：",
  "The voucher will be given on the first day of your birthday month.": "优惠券将在您生日月份的第一天发放。",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount.": "当您在付款时使用优惠劵，它会给您 {{ voucherAmount }} 货币（{{ currency }}{{ voucherAmount }}）折扣。",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }}% discount.": "当您在付款时使用优惠劵，它会给您 {{ voucherAmount }} %折扣。",
  "All vouchers is not valid with other ongoing promotions, discounts and offers.": "所有优惠券均不适用于当正在进行的促销、折扣和优惠。",
  "Claim a complimentary wash and dry for every 10 e-stamps collected! We value your loyalty and want to reward you for choosing Cleanpro Plus. Tap to learn more.": "每收集 10 张电子印章，即可获得免费清洗和烘干服务！我们重视您的忠诚度，并希望奖励您选择 Cleanpro Plus。点击以了解更多信息。",
  "cleanproStampFlat_one": "每收集 10 个电子印章，您就可以使用 Cleanpro Plus 申请高达 {{ voucherAmount }} 的免费洗或烘干货币。让您的洗衣程序不仅轻松无忧，而且收获颇丰。",
  "cleanproStampFlat_other": "每收集 10 个电子印章，您就可以使用 Cleanpro Plus 申请高达 {{ voucherAmount }} 的免费洗或烘干货币。让您的洗衣程序不仅轻松无忧，而且收获颇丰。",
  "cleanproStampRate": "每收集 10 个电子印章，您就可以使用 Cleanpro Plus 申请高达 {{ voucherAmount }}% 的折扣。让您的洗衣程序不仅轻松无忧，而且收获颇丰。",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "当您收集到 10 个洗涤印章时，优惠券将立即添加到您的奖励页面。您的电子印章计价器将在下次收集时归零。下次洗衣时，在扫描二维码页面领取优惠券。",
  "A voucher will be instantly added to your Rewards page when you reach 10 drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "当您收集到 10 个烘干印章时，优惠券将立即添加到您的奖励页面。您的电子印章计价器将在下次收集时归零。下次洗衣时，在扫描二维码页面领取优惠券。",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes or drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "当您收集到 10 个洗涤或10个烘干印章时，优惠券将立即添加到您的奖励页面。您的电子印章计价器将在下次收集时归零。下次洗衣时，在扫描二维码页面领取优惠券。",
  "Terms & Conditions:": "条款和条件：",
  "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session.": "要赚取一个电子印章，您必须在每次会话中花费至少 {{ stampTransactionAmount }} 货币（{{ currency }}{{ stampTransactionAmount }}）。",
  "You will be automatically issued a voucher if you have collected 10 washer stamps.": "如果您收集了 10 张洗衣机印章，您将自动获得一张优惠券。",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps.": "如果您收集了 10 张烘干机印章，您将自动获得一张优惠券。",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps or 10 washer stamps.": "如果您收集了 10 张洗衣机或10 张烘干机印章，您将自动获得一张优惠券。",
  "You will be automatically issued a voucher if you have collected 10 stamps.": "如果您收集了 10 张印章，您将自动获得一张优惠券。",
  "The voucher is non-refundable and cannot be exchanged for cash; in part or in full.": "此礼券不可退款，亦不可兑换现金；部分或全部。",
  "This voucher is valid for single transaction only.": "此优惠劵仅适用于单次交易。",
  "General questions": "常见问题",
  "E-stamps collection": "电子印章",
  "Coin exchange machines": "硬币兑换机",
  "Washer machines": "洗衣机",
  "Dryer machines": "烘干机",
  "Paywave issues": "Paywave问题",
  "Cleanpro franchise": "Cleanpro特许经营权",
  "How can I wash my laundry using Cleanpro Plus?": "如何使用 Cleanpro Plus 洗涤衣物？",
  "Here are the steps to wash your laundry using Cleanpro Plus:": "以下是使用 Cleanpro Plus 洗涤衣物的步骤：",
  "Find an unoccupied washing machine in the store, and insert your laundry in the washer.": "在商店里找一台无人使用的洗衣机，然后将要洗的衣服放入洗衣机。",
  "Select the desired temperature that you would like to use for your laundry.": "选择您想用于洗衣的所需温度。",
  "Using the scanner in the app, scan the QR code provided on the washing machine. Then select the same settings that you have pressed on the machine.": "使用应用程序中的扫描仪，扫描洗衣机上提供的二维码。然后选择您在机器上按下的相同设置。",
  'Tap on “Pay with credits” to pay the amount shown on the app.': '点击“使用点数支付”以支付应用程序上显示的金额。',
  "Once the payment has been accepted, press the START button on the washer machine.": "付款被接受后，按下洗衣机上的开始按钮。",
  "After the washing cycle ends, you can just remove your laundry from the machine.": "洗涤周期结束后，您只需将衣物从机器中取出即可。",
  "How can I dry my laundry using Cleanpro Plus?": "如何使用 Cleanpro Plus 烘干衣物？",
  "Here are the steps to dry your laundry using Cleanpro Plus:": "以下是使用 Cleanpro Plus 烘干衣物的步骤：",
  "Find an unoccupied drying machine in the store, and insert your laundry in the dryer.": "在商店里找一台无人使用的干衣机，然后将要烘干的衣服放入干衣机中。",
  "Select the desired temperature and duration that you would like to use for your laundry.": "选择您想用于洗衣的所需温度和持续时间。",
  "Using the scanner in the app, scan the QR code provided on the drying machine. Then select the same settings that you have pressed on the machine.": "使用应用程序中的扫描仪，扫描干衣机上提供的二维码。然后选择您在机器上按下的相同设置。",
  "Once the payment has been accepted, press the START button on the dryer machine.": "付款被接受后，按下干衣机上的开始按钮。",
  "After the drying cycle ends, you can just remove your laundry from the machine.": "烘干周期结束后，您只需将衣物从机器中取出即可。",
  "Why does the QR code I scanned take me to a different machine?": "为什么我扫描的二维码会将我带到另一台机器上？",
  "Here are the steps to solve it:": "以下是解决它的步骤：",
  "Make sure that the number on the QR code (e.g. W1, W2, etc) is the same as the machine that you would like to use.": "确保二维码上的数字（例如 W1、W2 等）与您要使用的机器相同。",
  "If the QR code number does not match the machine you want, use the other machine. Please contact our customer service line at 03-27700100 to report this issue.": "如果 QR 代码编号与您想要的机器不匹配，请使用其他机器。请联系我们的客户服务热线03-27700100报告此问题。",
  "How can I add more time to the washer that I am currently using?": "如何为当前使用的洗衣机增加更多使用时间？",
  "The washing time for our washer is fixed and cannot add any additional time.": "我们洗衣机的洗涤时间是固定的，不能增加任何额外的时间。",
  "How can I add more time to the dryer that I am currently using?": "如何为当前使用的干衣机增加更多使用时间？",
  "Here are the steps to add more time to the dryer machine:": "以下是为烘干机增加更多时间的步骤：",
  "By using the scanner in the app, scan the QR code provided at the dryer machine.": "使用应用程序中的扫描仪，扫描干衣机上提供的二维码。",
  "Select the amount of time that you would like to add to the machine.": "选择您要增加的时间到机器上。",
  "After the drying cycle ends, you can just remove the clothes from the machine.": "烘干周期结束后，您可以将衣物从机器中取出。",
  "REMINDER - It is recommended to add drying time 5 minutes before the cycle ends. And you cannot add tokens for extra times when the machine finishes the drying cycle.": "提醒 - 建议在循环结束前 5 分钟增加干燥时间。当机器完成干燥周期时，您不能增加额外时间。",
  "Will the timer keep running when I have stopped the drying machine?": "当我停止烘干机时，定时器会继续运行吗？",
  "Yes. Even after you stop the machine, the timer will continue to run. If you want to extend the drying time, add drying time 5 minutes before the cycle ends. This prevents the cycle from ending before your clothes are completely dried.": "是的。即使在您停止机器后，计时器仍会继续运行。如果您想延长干燥时间，请在循环结束前 5 分钟增加干燥时间。这可以防止您的衣服完全干燥之前结束烘干。",
  "How do I reload my credits for Cleanpro Plus?": "我如何为 Cleanpro Plus 充值？",
  "Here are the steps to reload your credits:": "以下是充值点数的步骤：",
  'Select the "Top Up Credit" button on the homepage.': '选择主页上的“充值”按钮。',
  "Choose the amount you want to reload and the payment method you want to use.": "选择您要充值的金额和您要使用的付款方式。",
  "You will be taken to the payment page. The screen will return to Cleanpro Plus once the transaction is completed.": "您将被带到付款页面。交易完成后，屏幕将返回 Cleanpro Plus。",
  "How many credits can I reload in one transaction?": "我可以在一次交易中充值多少点数？",
  "Reloading credits requires a minimum of RM 10 and a maximum of RM 50.": "充值点数需要最低 RM 10 和最高 RM 50。",
  "Can I pay using credits in the Cleanpro Plus app along with tokens or coins in a single transaction?": "我可以在单笔交易中使用 Cleanpro Plus 应用程序中的点数以及代币或硬币进行支付吗？",
  "No. Only a single payment method may be chosen when performing any transactions.": "不能。进行任何交易时只能选择一种付款方式。",
  "The amount I have reloaded in my account was not reflected in the app.": "我在我的账户中充值的金额没有反映在应用程序中。",
  "Please close and restart the application and check if the new balance has been updated.": "请关闭并重新启动应用程序并检查新余额是否已更新。",
  "If the amount is still not updated, please contact our customer service line at 03-27700110 to receive further assistance.": "如果金额仍未更新，请联系我们的客户服务热线03-27700110以获得进一步的帮助。",
  "Can I cash out the credits I reloaded in my account for this app?": "我可以兑现我为这个应用程序中充值的点数吗？",
  "No. The credits that you have reloaded will remain in your Cleanpro Plus account.": "不能。您充值的点数将保留在您的 Cleanpro Plus 账户中。",
  "I have requested a refund, but I still have not received it.": "我已申请退款，但仍未收到。",
  "Please contact our customer service line at 03-27700100 to receive further assistance.": "请联系我们的客户服务热线03-27700100以获得进一步的帮助。",
  "I have made the payment, and the app double or triple charged me.": "我已经付款，但应用程序向我收取了两倍或三倍的费用。",
  "The washing machine cannot start even after I have paid using the app.": "使用应用程序付款后洗衣机无法启动。",
  "Ensure that the temperature settings you have selected and paid for on the application are the same as what you have pressed on the washing machine. If not, select the correct temperature settings on the washing machine and try again.": "确保您在应用程序上选择和支付的温度设置与您在洗衣机上按下的温度设置相同。如果不是，请在洗衣机上选择正确的温度设置并重试。",
  "If the machine is still not able to be started, please contact our customer service line at 03-27700100 to receive further assistance.": "若机器仍无法启动，请联络我们的客服热线03-27700100以获得进一步协助。",
  "Can I use multiple vouchers together in the same washing or drying cycle?": "我可以在同一个洗涤或烘干程序中同时使用多张优惠券吗？",
  "No. Only a single voucher can be used for each washing and drying cycle.": "不能。每个洗涤和烘干周期只能使用一张优惠券。",
  "Why can't I use my free wash voucher that I received after signing up?": "为什么我不能使用注册后收到的免费洗涤券？",
  "To redeem or use the voucher, you must complete at least one washing or drying cycle.": "要兑换或使用优惠券，您必须至少完成一次洗涤或烘干程序。",
  "Can I change my phone number even after registering my account?": "我可以在注册账户后更改我的电话号码吗？",
  "No. Once registered to an account, the phone number is locked into the account.": "不能。一旦注册到帐户，电话号码就会被锁定到该账户中。",
  "I have problems in the store, and who can I refer to for help?": "我在店里遇到问题，我可以向谁寻求帮助？",
  "Do not worry, as you can contact our customer service line at 03-27700100 to receive assistance at any time.": "别担心，您可以随时拨打我们的客服热线03-27700100寻求帮助。",
  "Should I add my own laundry detergent and softeners to the washing machine?": "我应该在洗衣机中添加自己的洗衣液和柔顺剂吗？",
  "There is no need for that, as all you have to do is bring your dirty clothes and put them in the washer. The detergent and softeners will be provided by us, and you can rest assured that the laundry detergents we used are certified industrial grade.": "没有必要，因为您只需带上脏衣服并将它们放入洗衣机即可。洗涤剂和柔顺剂由我们提供，您可以放心，我们使用的洗衣液都是经过认证的工业级洗涤剂。",
  "I would like to add my own laundry detergent and softener to the washing machine.": "我想在洗衣机中添加自己的洗衣液和柔顺剂。",
  "We do not recommend our customers add their own detergent, as the mixture of different detergents may affect the wash quality. And you can rest assured that the laundry detergent we used is certified industrial grade.": "我们不建议客户自行添加洗涤剂，因为不同洗涤剂的混合可能会影响洗涤质量。您可以放心，我们使用的洗衣液是经过认证的工业级洗涤剂。",
  "What time does the store close?": "商店几点关门？",
  "Our self-service laundry operation is open 24 hours a day, which means you can always be sure to go back home with a fresh set of laundry.": "我们的自助洗衣店全天 24 小时开放，这意味着您回家时一定可以洗干净一整套新衣服。",
  "Are you open on weekends?": "你们周末营业吗？",
  "Yes. Cleanpro is also open on weekends and even on public holidays.": "是的。 Cleanpro 在周末甚至公共假期也营业。",
  "How many clothes can I fit in the washing or drying machine?": "我可以在洗衣机或烘干机中放入多少件衣服？",
  "To ensure that your laundry is properly washed or dried, keep the amount of laundry inside the machine lower than the line of guide sticker on the machine.": "为确保您的衣物得到正确洗涤或烘干，请使机器内的衣物量低于机器上的引导标签线。",
  "How many e-stamps can I collect in a single day?": "我一天可以收集多少个电子印章？",
  "There is no limit to the amount of stamps that can be collected in a single day; ONE stamp will be awarded with every wash or dry.": "一天内可以收集的印章数量没有限制；每次洗涤或烘干都会获得一枚印章。",
  "When I use the washing service, can I change the collected stamp to a dryer stamp, and vice versa?": "当我使用洗涤服务时，我可以将收集的印章换成烘干机印章，反之亦然吗？",
  "No, the type of stamp collected is only applied to the service that you have used.": "不能，所收集的印章类型只适用于您使用过的服务。",
  "What temperatures can I choose when I claim the free washing e-stamp reward?": "领取免费洗印章奖励时，我可以选择什么温度？",
  "Any washing temperature is available for the e-stamp reward.": "任何洗涤温度均可获得电子印章奖励。",
  "What temperatures can I choose when I claim the free drying e-stamp reward? And how long can I set the time?": "领取免费烘干印章奖励时，我可以选择什么温度？我可以设置多长时间？",
  "Any drying temperature and duration can be selected for the e-stamp reward.": "可以选择任何干燥温度和持续时间作为电子印章奖励。",
  "I'm unable to change the coin.": "我无法兑换硬币。",
  "What colour is the light shown on the machine, red or green? If it is a red light, please contact our customer service line at 03-27700100 to receive further assistance.": "机器上显示的灯是什么颜色，红色还是绿色？如果是红灯，请联系我们的客户服务热线03-27700100以获得进一步的帮助。",
  "Green Light": "绿灯",
  "Red Light": "红灯",
  "Machine functions as normal. Please try again.": "机器功能正常。请再试一次。",
  "(flashing 2x) - There are no coins/tokens in the machine.": "（闪烁 2 次）- 机器中没有硬币/代币。",
  "OR": "或者",
  "Note is jammed, please proceed to contact customer service": "纸币卡纸，请联系客服",
  "(flashing 3x) - Note is jammed, please proceed to contact customer service": "（闪烁 3 次）- 纸币卡住，请继续联系客户服务",
  "My notes are stuck in the machine.": "我的纸币卡在机器里了。",
  "My detergent is not dispensing in the vending machine.": "我的洗涤剂没有在自动售货机中分配。",
  "The water is leaking out of the washing machine.": "水从洗衣机中漏出。",
  "Please check the washer machine to see whether there are any clothes that are stuck at the door side.": "请检查洗衣机是否有衣服卡在门边。",
  "If yes, here are the steps to solve it:": "如果是，这里是解决它的步骤：",
  "Press the emergency stop button (RED Button) for 3 seconds.": "按下紧急停止按钮（红色按钮）3 秒钟。",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at 03-27700100 to receive further assistance)": "等声音停止，才打开门。 (若30分钟后声音仍未停止，请联络我们的客服热线03-27700100以获得进一步协助)",
  "Ensure the door is closed tightly, and press the START button.": "确保门紧闭，然后按下启动按钮。",
  "REMINDER - The emergency stop button can only be used once.": "提醒 - 紧急停止按钮只能使用一次。",
  "There is no detergent dispensing in the washing machine.": "洗衣机中没有洗涤剂配给。",
  "Ensure that the machine is in operation and that the START button was pressed.": "确保机器正在运行并且按下了启动按钮。",
  "If the detergent is still not dispensing, please contact our customer service department at 03-27700100 for further assistance.": "如果洗涤剂仍未配出，请致电03-27700100与我们的客户服务部联系以获得进一步的帮助。",
  "The price displayed on the machine's screen did not change after inserting the token.": "插入硬币后，机器屏幕上显示的价格没有变化。",
  "Press the small button (in the centre) to reject the tokens that have been inserted. Press a few times till the coins come out.": "按小按钮（在中心）拒绝已插入的硬币。按几次直到硬币出来。",
  "If the coins still cannot come out or the button is not functioning, please contact our customer service line at 03-27700110 to receive further assistance.": "若仍无法出币或按钮无法使用，请联络我们的客服热线03-27700110以获得进一步协助。",
  "The machine is not starting, and it displays an error code.": "机器未启动，并显示错误代码。",
  "We would like to apologise for any inconvenience caused. Please contact our customer service line at 03-27700100 to receive further assistance.": "对于由此造成的任何不便，我们深表歉意。请联系我们的客户服务热线03-27700100以获得进一步的帮助。",
  "I want to wash the clothes again, but why couldn't the machine start even after I added tokens to the machine?": "我又想洗衣服，为什么我给机器加了硬币后机器还是启动不了？",
  "Try opening and closing the door again before starting the machine.": "在启动机器之前再次尝试打开和关闭门。",
  "Can I change the water temperature of the machine?": "我可以改变机器的水温吗？",
  "Yes, but the washer temperature can only be changed from hot to cold after the machine has been started, and not from cold to hot.": "是的，但洗衣机温度只能在机器启动后由热变冷，而不能由冷变热。",
  "Can I stop the machine?": "我可以停止机器吗？",
  "Here are the steps to stop the machine:": "以下是停止机器的步骤：",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at to receive further assistance)": "等声音停止，才打开门。 （若30分钟后声音仍未停止，请联系我们的客服热线获取进一步帮助）",
  "There is no water supply on the machine used.": "使用的机器上没有供水。",
  "Why is the washing temperature cold even when I have selected HOT.": "为什么我选择了热，洗涤温度还是很冷。",
  "The water temperature is HOT or WARM only during washing. The water will turn COLD during rinsing.": "水温仅在洗涤期间为热或温。冲洗时水会变冷。",
  "The machine has already finished washing, but it does not spin well, and there is water left on the load.": "机器已经完成洗涤，但旋转不畅，衣物上还有水。",
  "Can I put wet laundry into the dryer to dry?": "我可以将湿衣物放入烘干机中烘干吗？",
  "No, as the dripping wet laundry might cause the dryer to short circuit.": "不能，因为滴水的湿衣物可能会导致干衣机短路。",
  "REMINDER - Refer to the labels on your clothes to know what kind of temperature is best for the kind of fabric that it uses. Then select the temperature on the machine accordingly.": "提醒 - 请参阅衣服上的标签，了解哪种温度最适合所使用的面料。然后相应地选择机器上的温度。",
  "My clothes are still wet even after drying.": "我的衣服烘干后还是湿的。",
  "How can I stop the dryer when the machine is still running?": "机器仍在运行时如何停止烘干机？",
  "Just open the door and the machine will automatically stop.": "只要打开门，机器就会自动停止。",
  "I added extra tokens for extra times, but the machine did not update the time.": "我为额外的时间添加了额外的货币，但机器没有更新时间。",
  "For the time to be reflected accurately, it is recommended for you to add tokens 5 minutes before the services end.": "为了准确反映时间，建议您在服务结束前5分钟添加货币。",
  "REMINDER - You cannot add tokens for extra times when the machine finishes the drying cycle.": "提醒 - 当机器完成烘干循环时，您不能为额外时间添加货币。",
  "Why is the machine making noise?": "为什么机器会发出噪音？",
  "Please check the drum to see if there are any coins or other small things inside.": "请检查滚筒，看看里面是否有任何硬币或其他小东西。",
  "I have pressed the START button on the dryer, but it is still not working.": "我已经按下烘干机上的启动按钮，但它仍然无法正常工作。",
  "Please try to open the door and close it again. Next, press the START button again to start drying.": "请尝试打开并再次关闭门。接下来，再次按下开始按钮开始干燥。",
  "If the dryer is still not functioning, please contact our customer service line at 03-27700100 to receive further assistance.": "如果干衣机仍然无法正常工作，请联系我们的客户服务热线 03-27700100 以获得进一步的帮助。",
  "Paywave has deducted an amount from the card but the machine did not reflect the transaction.": "Paywave 已从卡中扣除一笔金额，但机器未反映这笔交易。",
  "The Paywave transaction has failed but the amount has still been deducted from my card.": "Paywave 交易失败，但金额仍从我的卡中扣除。",
  "Paywave has double/triple charge but the machine cannot start.": "Paywave 有双倍/三倍收费但机器无法启动。",
  "Paywave after double/triple charge machines can't start.": "双倍/三倍收费后的 Paywave 机器无法启动。",
  "Paywave is offline": "Paywave 已离线",
  "Do Cleanpro Express offer franchise business/selling machines/laundry products?": "Cleanpro Express 是否提供特许经营/销售机器/洗衣产品？",
  "For further inquiries, please email to info@cleanproexpress.com": "如需进一步查询，请发送电子邮件至 info@cleanproexpress.com",
  "Step 6": "步骤 6",
  "User Existed": "用户已存在",
  "This email is registered": "该邮箱已注册",
  "This phone number is registered": "该电话号码已注册",
  "Invalid Email Address": "无效的邮件地址",
  "Let's get started!": "让我们开始吧！",
  "Enter your e-mail/mobile number": "输入您的电子邮件/手机号码",
  "Enter your e-mail": "输入你的电子邮箱",
  "Enter your mobile number": "输入你的手机号码",
  "Enter your e-mail address": "输入你的电子邮箱地址",
  "Proceed": "继续",
  "Enter OTP number": "输入一次性密码",
  "You will receive a six-digit OTP via SMS sent to": "您将收到一个六位数的一次性密码短信在",
  "You will receive a six-digit OTP via e-mail sent to": "您将收到一个六位数的一次性密码邮件在",
  "Verify": "验证",
  "Resend OTP": "重新发送一次性密码",
  "Welcome onboard!": "欢迎！",
  "Please fill in the info below": "请填写以下资料",
  "Enter your name*": "输入你的名字*",
  "Enter your email address*": "输入你的电子邮箱地址*",
  "Please enter either phone number or email address": "请输入电话号码或电子邮件地址",
  "Create a password*": "创建密码*",
  "Enter referral code (if got any)": "输入推荐码（如果有）",
  "Get started": "开始",
  "Birthday updated successfully": "生日更新成功",
  "Date of birth": "出生日期",
  "Enter your date of birth": "输入你的出生日期",
  "Select your birth date": "选择您的出生日期",
  "Update date of birth": "更新出生日期",
  "Update birth date": "更新出生日期",
  "Already have an account?": "已经有账户？",
  "Login now": "立即登录",
  "Sign in": "登入",
  "Sign up now": "立即注册",
  "COMPLETED": "完成",
  "WASHING NOW": "洗涤中",
  "DRYING NOW": "烘干中",
  "It's done!": "完成了！",
  "Please collect your fresh, clean laundry in order to leave the machine available for the next person to use!": "请收集您清新、干净的衣物，以便让机器可供下一个人使用！",
  "Leave a feedback": "留下反馈",
  "Time left": "剩余时间",
  "Add drying time": "增加烘干时间",
  "Hi": "你好",
  "customer": "顾客",
  "Thank you for your payment. Don't forget to select the <b>correct temperature</b> and press <b>START</b> when you're ready.": "谢谢您的付款。不要忘记选择<b>正确的温度</b>，并在准备就绪后按<b>开始</b>。",
  "Select how you want to receive a notification when your laundry is finished": "选择洗衣完成后您希望如何接收通知",
  "Sign up": "注册",
  "Continue to pay": "继续付款",
  "Register as a member to enjoy more benefits!": "注册成为会员，享受更多优惠！",
  "Get FREE {{ voucherAmount }} credits per new user": "每个新用户免费获得 {{ voucherAmount }} 个货币",
  "Get FREE {{ voucherAmount }}% per new user": "每个新用户免费获得 {{ voucherAmount }}%",
  "Enjoy exclusive promotions": "享受独家促销",
  "FREE voucher on your birthday": "生日当天可获赠免费优惠券",
  "and more": "和更多",
  "Denied camera access": "拒绝摄像头访问",
  'Permission to access the camera has been denied. Please try again and click "Allow" to scan the QR code.': '访问摄像头的权限已被拒绝。请重试并点击“允许”扫描二维码。',
  "Okay": "好的",
  "Oops. You don't have enough balance to make the payment": "您没有足够的余额来付款",
  "Please confirm": "请确认",
  "Do you want to proceed with this feedback?": "您想继续处理此反馈吗？",
  "Are you sure to purchase": "您确定购买",
  "credits for": "货币以",
  "Topup credit": "充值货币",
  "Extended duration will be instantly reflected on machine after payment": "付款后，延长的时间将立即反映在机器上",
  "Machine is currently busy": "机器当前正忙",
  "Do you want to extend drying time?": "您想延长烘干时间吗？",
  // "Cuci Hari-Hari Bersama Cleanpro!": "Cuci Hari-Hari Bersama Cleanpro!",
  // "Ready for a challenge?": "准备好迎接挑战了吗？",
  // "Here's one for you - all you need to do is wash your laundry 10 times in 20 days at participating Cleanpro outlets. Stand a chance to win a Limited Edition Cleanpro Designer Laundry Bag worth up to RM40!": "挑战如下 - 你只需在20天内于任何一家Cleanpro门店里洗衣10次，即可赢得一款价值高达RM40的限量版Cleanpro设计师系列洗衣袋。",
  // "Here's how to participate:": "参与方式：",
  // "Step 1: Scan the QR Code on the washer to launch Cleanpro Plus": "步骤1：扫描QR Code来启动Cleanpro Plus应用并注册账户。",
  // "Step 2: Pay for your wash with Cleanpro Plus": "步骤2：选择您需要充值的额度并支付。",
  // "Step 3: Complete x10 washes within 20 days to win": "步骤3：在20天内完成10次洗衣。",
  // "Challenge Period: 01 July - 31 August 2023": "挑战期：2023年7月1日 - 8月31日",
  // "Drop by your nearest Cleanpro outlet to wash your laundry with us for 20 days straight! Good luck!": "前往最近的Cleanpro门店，与我们一起“天天喜衣”！祝您好运！",
  // "TERMS & CONDITIONS": "条款及细则",
  // "PARTICIPATION CRITERIA": "参与条件",
  // "1) Participant needs to register an account in Cleanpro Plus web app.": "1）参与者需要在Cleanpro Plus应用上注册一个账户。",
  // "2) Participant can use any washer of any capacity in any participating outlets to qualify for entries.": "2）参与者在任何一间指定门店使用任何容量的洗衣机即符合资格。",
  // "3) Payment needs to be made with Cleanpro Plus web app.": "3）款项需通过Cleanpro Plus进行支付。",
  // "4) Washes must be completed and paid (with no dispute whatsoever) within campaign period.": "4）清洗及结账必须在活动期间内完成（绝无争议）。",
  // "5) Campaign period starts from 1st July 2023 at 00:00 and ends at 31st August 2023 at 23:59.": "5）活动将从2023年7月1日00:00开始，至2023年8月31日23:59结束。",
  // "WINNERS & PRIZES": "获奖者及奖品",
  // "1) Cleanpro will notify the winners of the campaign via registered WhatsApp number or email address provided, within 4 weeks after the campaign ends.": "1）Cleanpro将在活动结束后的4周内，通过注册的WhatsApp号码或所提供的电子邮件箱通知获奖者。",
  // "2) Any unclaimed prizes after 2 weeks from notification date will not be entertained thereafter.": "2）从通知日期起直至2周后仍未前来领取的奖品将不予理会。",
  // "3) Upon completing the ten (10) washes within twenty (20) days campaign, participants will be a winner and be eligible to win ONE (1) Cleanpro Designer Laundry Bag.": "3）参与者若在20天的活动期间内完成十（10）次洗衣次数后，将赢得一（1）款Cleanpro设计师系列洗衣袋。",
  // "4) Winners are eligible to win more than ONE (1) Cleanpro Designer Laundry Bag in this campaign.": "4）获奖者有资格在此活动中赢得多于一（1）个Cleanpro设计师系列洗衣袋。",
  // "5) Winners will be given the choice of his/her preferred laundry bag size; but only ONE (1) can be selected for each qualified win.": "5）获奖者将可选择自己喜欢的洗衣袋尺寸；但每次完成挑战只能在奖品中选择一（1）个。",
  // "A) XL Size - Blue bag with up to 20KG in capacity": "A）XL尺寸 - 蓝色洗衣袋，容量高达20公斤",
  // "B) L Size - White bag with up to 12KG in capacity": "B）L尺寸 - 白色洗衣袋，容量高达12公斤",
  // "6) Time and location for collection of prize will be informed via Whatsapp number and/or email address provided.": "6）奖品领取的时间和地点将通过参与者所提供的WhatsApp号码和/或电子邮件箱通知。",
  "OTHER": "其他",
  // "1) Changes to the terms and conditions will be at Cleanpro's discretion; without prior notice.": "1）Cleanpro有权不经通知修改本条款和细则。",
  // "2) Completed wash is defined by washes performed with Cleanpro's washer and payments within Cleanpro Plus web app are made with no disputes.": "2）完整的洗衣过程意指使用Cleanpro的洗衣机进行洗涤，并在Cleanpro Plus网页应用程序内进行付款 (绝无争议)。",
  // "3) By participating in this campaign automatically indicates that the Participant has agreed to all the campaign's Terms and Conditions as stipulated.": "3）参与此活动即表示参与者已同意所有活动条款及细则。",
  "Welcome Voucher": "“欢迎”礼券",
  "Welcome to the Cleanpro Plus family! This first gift is just the beginning. Stay tuned for a series of exciting promotions and campaigns, exclusively for Cleanpro Plus users.": "欢迎加入 Cleanpro Plus的大家庭！ 这份见面礼只是一个开始。 请继续关注 Cleanpro Plus以获得我们独家提供给用户的一系列激动人心的促销和活动。",
  "Terms & Conditions": "条款及细则",
  "TERMS AND CONDITIONS": "条款及细则",
  "Welcome Voucher is valid for one-time use only.": "“欢迎”礼券仅供一次性使用。",
  "There is no minimum spend required for the voucher to be used.": "使用礼券时，没有最低消费要求。",
  "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only.": "“欢迎”礼券在 Cleanpro Plus 注册时将会自动存入用户的帐户，有效期仅为 {{ duration }} 天。",
  "Users are eligible to use their Welcome Voucher AFTER the completion of their first wash or dry cycle using the same Cleanpro Plus account.": "用户需使用同一个 Cleanpro Plus 帐户完成第一次洗涤或烘干后，才能使用“欢迎”礼券。",
  "Welcome Voucher cannot be used together with any ongoing promotions or any other promotional vouchers.": "“欢迎”礼券不能与任何正在进行的促销活动或任何其他促销礼券一起使用。",
  "The voucher is final and cannot be refunded in form of cash or credit to the user.": "该礼券不能以现金或点数形式退还给用户。",
  "Cleanpro reserves the right to change the terms and conditions without prior notice.": "Cleanpro 保留更改条款和条件的权利，恕不另行通知。",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})": "收集 10 个电子邮票即可免费获得 {{ voucherAmount }} 点数礼券（价值 {{ currency }}{{ voucherAmount }}）",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }}% voucher (worth {{ voucherAmount }}%)": "收集 10 个电子邮票即可免费获得 {{ voucherAmount }}% 礼券（价值 {{ voucherAmount }}%）",
  "Collect 10 e-Stamp to earn FREE Voucher": "收集 10 个电子邮票即可免费获得礼券",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding.": "每收集 10 个电子印章，您将获得一张免费 {{ voucherAmount }} 点数礼券（价值 {{ currency }}{{ voucherAmount }}）。让您的洗衣程序不仅轻松无忧，而且收获颇丰。",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }}% credits voucher (worth {{ voucherAmount }}%). Make your laundry routine not just hassle-free, but also rewarding.": "每收集 10 个电子印章，您将获得一张免费 {{ voucherAmount }}% 礼券（价值 {{ voucherAmount }}%）。让您的洗衣程序不仅轻松无忧，而且收获颇丰。",
  // "How to participate:": "参与方式：",
  // "Prizes to be won:": "将赢得的奖品：",
  "RM10 OFF Welcome Voucher": "RM10 折扣欢迎礼券",
  "Welcome to the Cleanpro family, here is an appreciation voucher from us. Thank you for attending the COPE Investors Conference.": "欢迎加入 Cleanpro 大家庭，这是我们的感谢券。感谢您参加 COPE 投资者大会。",
  "Welcome Voucher | COPE Investors Conference": "欢迎券 | COPE投资者大会",
  "Payment methods": "付款方式",
  "Tap to proceed with your preferred mode of payment": "选择您喜欢的付款方式",
  "Cleanpro Plus credits": "Cleanpro Plus 点数",
  "E-wallet or credit/debit cards": "电子钱包或信用卡",
  "Go to homepage": "前往主页",
  // backend response or error
  "Admin is unauthorized to login": "管理员没有权限登录",
  "Internal Error": "内部错误",
  "Please enter the correct credentials": "请输入正确的密码",
  "Operator not found": "未找到运营商",
  "Admin not found": "未找到管理员",
  "Distributor not found": "未找到经销商",
  "Client not found": "未找到客户",
  "Outlet not found": "未找到店铺",
  "Token Package not found": "未找到电子代币配套",
  "Top up history not found": "未找到充值记录",
  "Voucher not found": "未找到优惠劵",
  "Faq not found": "未找到常见问题",
  "Faq Group not found": "未找到常见问题组",
  "News not found": "未找到新闻",
  "Transaction not found": "未找到交易",
  "Please Login Again": "请重新登录",
  "Decoding Error": "解码错误",
  "Some error occured, please contact the dev team if this error continues.": "发生了一些错误，如果此错误仍然存​​在，请联系开发团队。",
  "Please fill in all the required fields": "请填写所有必填选项",
  "Only success transaction can be refund": "只有成功的交易才能退款",
  "Only token payment method can be refund": "只有电子代币支付方式才能退款",
  "The discount code has been used, please change to other code": "该优惠码已被使用，请更换其他优惠码",
  "Cannot use ewallet in sandbox": "无法在沙盒中使用电子钱包",
  "Please close the door to proceed your payment": "请关上门以继续付款",
  "Under Maintenance": "正在维修",
  "This machine is being fixed. Please use another machine.": "此机器正在维修中，请使用其他机器。",
  "Machine is currently running, please try again later": "机器当前正在运行，请稍后重试",
  "Machine is currently offline, please try again later": "机器当前离线，请稍后重试",
  "Outlet not participating in Loyalty program": "商店未参与忠诚度计划",
  "Please log in to make the payment": "请登录后进行支付",
  "Package not found, please refresh and try again": "找不到配套，请刷新并重试",
  "You have reached the maximum number of purchase": "您已达到最大购买数量",
  "Store not found, please try again later": "找不到商店，请稍后重试",
  "Incorrect Password": "密码错误",
  "Token already top up": "电子代币已充值",
  "Payment failed": "支付失败",
  "Transaction Failure": "交易失败",
  "Transaction Refunded": "交易已退款",
  "Transaction Pending": "交易待处理",
  "Please enter your mobile number": "请输入您的手机号码",
  "User is unauthorized to register": "用户无权注册",
  "Please proceed to sign up": "请继续注册",
  "OTP expired, please request a new OTP": "OTP 已过期，请申请新的 OTP",
  "Incorrect verification code": "验证码不正确",
  "This referrer ID is not valid": "该推荐人 ID 无效",
  "This referrer ID is different operator": "该推荐人 ID 是不同的运营商",
  "This referrer ID is exceed the limit": "该推荐人 ID 超出限制",
  "User is unauthorized to login": "用户无权登录",
  "Click here to register": "点击此处注册",
  "User is unauthorized to login. Please contact the admin": "用户无权登录。请联系管理员",
  "User is unauthorized": "用户未经授权",
  "This outlet does not participate in the Loyalty Program": "该商店不参与忠诚度计划",
  "This outlet is not belongs to the operator": "该店铺不属于此运营商",
  "Processing request": "处理请求",
  "This user is not verified": "该用户未验证",
  "Insufficient token to make payment": "电子代币不足，无法付款",
  "Insufficient token to transfer": "电子代币不足，无法转账",
  "Insufficient point to make payment": "积分不足，无法付款",
  "This voucher is not available for use": "此优惠券不可使用",
  "This voucher is belongs to other user": "此优惠券属于其他用户",
  "Invalid Discount Code": "优惠码无效",
  "This discount code cannot use in this outlet": "该优惠码不能在该分店使用",
  "This discount code was expired": "该优惠码已过期",
  "This discount code cannot use in washer machine transaction": "此优惠码不能用于洗衣机交易",
  "This discount code cannot use in dryer machine transaction": "此优惠码不能用于烘干机交易",
  "This discount code was fully redeemed today, try again tomorrow": "该优惠码今天已完全兑换，明天再试",
  "You have fully redeemed this discount code": "您已完全兑换此优惠码",
  "This discount code have been redeemed": "此优惠码已兑换",
  "This discount code is not applicable": "此优惠码不适用",
  "Insufficient stamp": "印章不足",
  "Please provide at least one voucher setting": "请提供至少一项优惠券设置",
  "Previous batch are still generating, please try again later": "上一批仍在生成中，请稍后重试",
  "Number of voucher code should be more than 0": "兑换码数量必须大于0",
  "Number of voucher code should be less than 50000": "兑换码数量必须小于50000",
  "Number of discount code should be more than 0": "优惠码数量必须大于0",
  "Number of discount code should be less than 50000": "优惠码数量必须小于50000",
  "No Item": "没有配套",
  "Please add item": "请添加配套",
  "Staff not found": "未找到工作人员",
  "This task already completed": "此任务已经完成",
  "Please complete the wash task first": "请先完成洗涤任务",
  "Please complete the dry task first": "请先完成烘干任务",
  "Please select at least one outlet": "请至少选择一个店铺",
  "Touch to Start": "点击开始",
  "New Users": "新用户",
  "Get {{ voucher_amount }} FREE Credits!": "获得免费 {{ voucher_amount }} 点数！",
  "Get {{ voucher_amount }}% FREE!": "获得 {{ voucher_amount }}%折扣！",
  "Load your clothes into the washing machine & note the machine number": "将衣服放入洗衣机并记下机器编号",
  "T&C Apply": "适用条款和条件",
  "Mobile Number": "手机号码",
  "Member": "会员",
  "Please enter your mobile phone number / e-mail": "请输入您的手机号码/电子邮箱",
  "Please verify your number": "请确保您的电话号码正确",
  "Please verify your e-mail": "请确保您的电子邮件正确",
  "Please enter the correct phone number format. Example: 01xxxxxxxx": "请输入正确的电话号码格式。示例：01xxxxxxxx",
  "Please enter the correct phone number format. Example: 09xxxxxxxx": "请输入正确的电话号码格式。示例：09xxxxxxxx",
  "Scan QR to Complete your signup & access more benefits!": "扫描二维码完成注册并获得更多福利！",
  "Please choose your service": "请选择您的服务",
  "WASHER": "洗衣机",
  "DRYER": "烘干机",
  "VENDING MACHINE": "自动售货机",
  "Please tap your card on the reader": "请将您的卡轻触在读卡机上",
  "Payment Option": "付款方式",
  "Thank you for payment!": "感谢您的付款！",
  "Please select your items at the vending machine": "请在自动售货机上选择您的商品",
  "Please choose the temperature on the machine and press": "请选择机器上的温度并按",
  "START": "开始",
  "Need Help?": "需要帮助吗？",
  "Please choose the temperature": "请选择温度",
  "Confirm Payment": "确认付款",
  "Select the time for": "选择时间",
  "Do you want to add drying time?": "您是否想增加烘干时间？",
  "minutes": "分钟",
  "Your machine is": "您的机器是",
  "Please Collect your item from the vending machine": "请从自动售货机领取您的物品",
  "You've earned 1 e-stamp for your wash!": "您已获得 1 个洗涤电子印章！",
  "You've earned 1 e-stamp for your dry!": "您已获得 1 个烘干电子印章！",
  "You've missed 1 e-stamp for your wash!": "您错过了 1 个洗涤电子印章！",
  "You've missed 1 e-stamp for your dry!": "您错过了 1 个烘干电子印章！",
  "Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "收集 10 个洗涤电子印章，即可免费获得 {{ amount }} 点数优惠券。",
  "Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "收集 10 个洗涤电子印章即可赚取 {{ amount }}% 优惠券。",
  "Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "收集 10 个烘干电子印章，即可免费获得 {{ amount }} 点数优惠券。",
  "Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "收集 10 个烘干电子印章即可获得 {{ amount }}% 优惠券。",
  "Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "收集 10 个洗涤和烘干电子印章即可免费获得 {{ amount }} 点数优惠券。",
  "Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "收集 10 个洗涤和烘干电子印章即可获得 {{ amount }}% 优惠券。",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "注册并收集 10 个洗涤和烘干电子印章即可免费获得 {{ amount }} 点数优惠券。",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "注册并收集 10 个洗涤和烘干电子印章即可赚取 {{ amount }}% 优惠券。",
  "Sign Up & Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "注册并收集 10 个洗涤电子印章，即可免费获得 {{ amount }} 点数优惠券。",
  "Sign Up & Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "注册并收集 10 个洗涤电子印章即可赚取 {{ amount }}% 优惠券。",
  "Sign Up & Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "注册并收集 10 个烘干电子印章，即可免费获得 {{ amount }} 点数优惠券。",
  "Sign Up & Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "注册并收集 10 个烘干电子印章即可赚取 {{ amount }}% 优惠券。",
  'For iOS users, press and hold the image, then choose "Add to Photos" or "Save in Photos" from the menu.': '对于 iOS 用户，长按图像，然后从菜单中选择 "Add to Photos" 或者 "Save in Photos"。',
  "Scan the QR code to pay": "扫描二维码支付",
  "QR Code expires in {{ countdown }} seconds": "二维码将在 {{ countdown }} 秒后过期",
  "Transfer In": "转入",
  "Migrate": "迁移",
  "Update": "更新",
  "Transfer Out": "转出",
  "Total In": "总收入",
  "Total Out": "总支出",
  "Laundry Pass": "洗衣通行证",
  "Number of wash": "洗涤次数",
  "Number of Wash": "洗涤次数",
  "Number of dry": "烘干次数",
  "Number of Dry": "烘干次数",
  "Laundry Pass Purchase": "购买洗衣通行证",
  "Laundry Pass Purchase Report": "洗衣通行证购买报告",
  "Please select distributor or operator": "请选择经销商或运营商",
  "Price should be more than 0": "价格应该大于0",
  "Number of wash or dry should be more than 0": "洗涤或烘干次数应大于0",
  "Number of wash should be more than 0": "洗涤次数应大于0",
  "Number of dry should be more than 0": "烘干次数应大于0",
  "Duration must be more than 0": "持续时间必须大于 0",
  "Please fill in the name": "请填写姓名",
  "Purchase Start Date": "购买开始日期",
  "Purchase End Date": "购买结束日期",
  "Number of Maximum Purchase": "最大购买数量",
  "Create Laundry Pass": "创建洗衣通行证",
  "Select Purchase Period": "选择购买期间",
  "If ticked, the Laundry Pass will have expired date": "如果勾选，洗衣通行证将有过期日期",
  "Laundry Pass Lifespan": "洗衣通行证的使用寿命",
  "Edit Laundry Pass": "编辑洗衣通行证",
  "Washer Used Date": "洗涤使用日期",
  "Dryer Used Date": "烘干使用日期",
  "Laundry Pass Purchase History": "洗衣通行证购买历史记录",
  "Laundry Pass Usage Report": "洗衣通行证使用报告",
  "Please Note! (Stacked Dryer)": "请注意！ (堆叠式干燥机)",
  "Ensure machine is vacant and select correct machine after payment press START": "确保机器是空的，并在付款后选择正确的机器，然后按“开始”",
  "Start date": "开始日期",
  "End date": "结束日期",
  "Today": "今天",
  "Yesterday": "昨天",
  "Last 7 Days": "过去 7 天",
  "Last 30 Days": "过去 30 天",
  "This Month": "本月",
  "Last Month": "上个月",
  "Use Per Day": "每天最大使用次数",
  "Maximum use per day must be more than 0": "每日最大使用次数必须大于 0",
  "Only applicable to selected outlet": "只适用于指定分店",
  "Applicable to all the outlets except selected outlet": "适用于除指定分店外的所有分店",
  "If applicable to all the outlet, leave it blank": "如果适用于所有门店，请留空",
  "Only applicable to selected weight": "仅适用于选定重量",
  "Applicable to all the weight except selected weight": "适用于除选定重量以外的所有重量",
  "Weight": "重量",
  "If applicable to all the weight, leave it blank": "如果适用于所有重量，请留空",
  "Add Weight": "添加重量",
  "Only applicable to selected mode": "仅适用于选定模式",
  "Applicable to all the modes except selected mode": "适用于除选定模式外的所有模式",
  "If applicable to all the mode, leave it blank": "如果适用于所有模式，请留空",
  "Add Mode": "添加模式",
  "Laundry Pass not applicable in this outlet": "洗衣通行证不适用于此门店",
  "Discounted price should be more than 0": "折扣价应大于 0",
  "Discounted Price": "折扣价",
  "Logo (Optional)": "标志（可选）",
  "Save": "节省",
  "Cleanpro Laundry Pass": "Cleanpro Laundry Pass",
  "Save more with the Laundry Pass — ": "购买Laundry Pass",
  "wash and dry more clothes at a lower price while enjoying extra rewards from Cleanpro Plus!": "不仅能让您以更实惠的价格洗涤和烘干更多衣物，还能享受Cleanpro Plus带来的额外奖励，帮助您节省更多！",
  "How to Purchase Laundry Pass": "如何购买 Laundry Pass",
  "Step 1: Register as a Cleanpro Plus user.": "步骤 1：注册成为 Cleanpro Plus 用户。",
  "Step 2: Choose the Laundry Pass package you wish to purchase.": "步骤 2：选择您要购买的 Laundry Pass配套。",
  "Step 3: Make the payment through Cleanpro Plus.": "步骤 3：通过 Cleanpro Plus 进行全额付款。",
  "Step 4: Enjoy washing and drying services at any Cleanpro outlet in Malaysia with exclusive discounted prices!": "步骤 4：在马来西亚的任何 Cleanpro 分店以独家折扣价享受洗涤和烘干服务！",
  "By purchasing and/or using the Cleanpro Laundry Pass, you agree to be bound by the following terms and conditions:": "通过购买和/或使用Cleanpro Laundry Pass，您同意遵守以下条款和条件：",
  "Definitions": "定义",
  '"Laundry Pass" refers to the package(s) for specific laundry services offered by Cleanpro.': '“Laundry Pass”指Cleanpro提供的特定洗涤和烘干服务配套。',
  '"Subscriber" refers to the individual(s) purchasing and/or using the Laundry Pass.': '“购买者”指购买和/或使用Laundry Pass的人。',
  "Pass Description": "配套描述",
  "The Laundry Pass is a promotional package that offers laundry services at any Cleanpro outlet in Malaysia.": "Laundry Pass是一个促销配套，仅在马来西亚的任何Cleanpro门店有效，提供洗涤和烘干服务。",
  'The Laundry Pass is valid for both Malaysians and non-Malaysians; and is exclusively available to Cleanpro Plus members.': 'Laundry Pass适用于马来西亚公民和非马来西亚公民，仅限Cleanpro Plus会员使用。',
  "The campaign of Laundry Pass is valid from": "Laundry Pass的活动有效期为",
  "1 March 2025 to 31 May 2025.": "2025年3月1日至2025年5月31日。",
  'Each Laundry Pass subscription is': '从购买 Laundry Pass日期起，每个Laundry Pass',
  'valid for 30 days from the start date,': '可使用有效期为30天,',
  'allowing subscribers to use the package': '购买者可',
  'up to 4 times per day.': '每天使用配套最多4次',
  'During the promotional period, subscribers can repurchase the package unlimited times, but only after fully utilizing your current subscription.': '在促销期间，您可以无限次重新购买配套，但必须先完全使用当前的配套。',
  "The Laundry Pass is": "Laundry Pass ",
  "valid only for cold wash and drying of machines under 25kg.": "仅适用于冷水洗涤和25kg以下的机器。",
  "Additional charges will apply for warm and hot wash services, based on the temperature selected.": "温水洗涤和热水洗涤服务将额外收费。",
  'Unused wash or dry session(s) from the Laundry Pass cannot be carried forward to the next purchase, and are non-refundable, non-exchangeable for cash, and non-transferable.': '未使用的洗涤或烘干次数不可转移至下一次购买的配套里，且不可退款、不可兑换现金、不可转让。',
  'The Laundry Pass is valid for washing and/or drying standard laundry items only (e.g., clothing, linens), excluding large items (e.g., rugs), heavily soiled items (e.g., pet bedding), or specialty items requiring special treatment.': 'Laundry Pass仅适用于洗涤和/或烘干标准的衣物品，例如衣物、床单等，不包括大件物品（如地毯）、重污物品（如宠物床垫）或需要特别处理的特殊物品。',
  'The Laundry Pass can be cancelled within the first 7 days of subscription for a full refund, provided the subscriber has not used the Laundry Pass during this period. No refunds or transfers will be issued after the first 7 days.': '在购买配套后的前7天内，购买者可以取消Laundry Pass并获得全额退款，前提是购买者在此期间完全没有使用过Laundry Pass。超过7天后，购买的配套将不提供退款或转让。',
  "Refund process may take up to 21 working days.": "退款过程可能需要最多 21 个工作日。",
  'Subscribers are encouraged to regularly check Cleanpro Plus for reminders regarding the expiry date of their laundry pass.': '购买者可定期查看 Cleanpro Plus，以获取关于 Laundry Pass到期日期的提醒。',
  "This promotion is not valid in conjunction with the '10 Free 1 e-Stamp Campaign'.": "此促销配套不可与“10次免费1次电子印花活动”同时使用。",
  "Any misuse of the Laundry Pass will result in the immediate termination of the subscription without prior notice. Payments for the Laundry Pass are non-refundable, non-exchangeable for cash, and non-transferable.": "任何滥用Laundry Pass的行为将导致其 Laundry Pass立即被终止，且不提前通知。Laundry Pass的付款不可退款、不可兑换现金、不可转让。",
  "Payment must be made in full at the time of subscription via Cleanpro Plus.": "购买者必须通过Cleanpro Plus一次性支付全额以购买或使用 Laundry Pass。",
  "For any questions or assistance regarding the Laundry Pass, please email Cleanpro Customer Service at enquiry@cleanpro.asia.": "如有任何疑问，请通过发送电子邮件联系Cleanpro客服： enquiry@cleanpro.asia。",
  "Cleanpro reserves the right to change the terms and conditions at any time without prior notice.": "Cleanpro保留在任何时间更改条款和条件的权利，恕不另行通知。",
  "Search": "搜索",
  "Scan to register as a member": "扫描注册成为会员",
  "Select Product / Key in Amount": "选择产品/输入金额",
  "Discount code is not available in this payment type": "此交易类型不适用折扣码",
  "This voucher is not available use in washer payment": "此优惠券不可用于支付洗衣机交易",
  "This voucher is not available use in dryer payment": "此优惠券不可用于烘干机交易",
  "This voucher is not available use in Drop n Go payment": "此优惠券不适用于 Drop n Go 交易",
  "Voucher is not available in this payment type": "此交易类型不适用优惠券",
  "Select the price for": "选择价格",
  "Enable Stamping": "启用邮票",
  "Please select your preferred outlet": "请选择您喜爱的店铺",
  "Select your preferred outlet": "选择您喜爱的店铺",
  "State": "州",
  "Select State": "选择州",
  "Payment Successful!": "付款成功！",
  "Thank you for purchasing Laundry Pass!": "感谢您购买洗衣通行证！",
  "Your Laundry Pass expired on": "您的洗衣通行证已过期于",
  "You have used all your Laundry Pass": "您已使用完所有洗衣通行证",
  "Purchase Again": "再次购买",
  "Save Big!": "省大钱！",
  "You've saved": "您已节省",
  "on your package!": "在您的配套上",
  "Please select distributor, operator or outlet": "请选择经销商、运营商或店铺",
  "Please enter your mobile phone number or e-mail": "请输入您的手机号码或电子邮件",
  "We’ll send you an SMS when your laundry’s ready": "当您的洗衣完成时，我们会发送短信通知您",
  "Skip": "跳过",
  "Notice": "注意",
  "User exists but not verified. Please verify your account by scanning the QR Code at Thank You Page.": "用户存在但未验证。请扫描感谢页面的二维码来验证您的帐户。",
  "User registered successfully. Please complete verification by scanning the QR Code at Thank You Page.": "用户注册成功。请扫描感谢页面的二维码完成验证。",
  "Please enter email address to register": "请输入电子邮件地址进行注册",
  "Please enter phone number to register": "请输入手机号码进行注册",
  "Camera permission is denied": "相机权限被拒绝",
  "No camera device found": "未找到摄像头设备",
  "Camera is already in use by another app": "相机已被其他应用程序使用",
  "Preferred Outlet": "首选店铺",
  "Purchase Now": "赶快抢购",
  "Cancel Date": "取消日期",
  "Cancel Laundry Pass": "取消洗衣通行证",
  "Download or takes a screenshot of the QR code.": "下载或者截图二维码。",
  "Launch and login banking app.": "启动并登录银行应用程序。",
  "Choose QR code from your gallery.": "从您的图库中选择二维码。",
  "1 March 2025 - 30 April 2025": "2025年3月1日 - 2025年4月30日",
  "Payment Method to get point": "获取积分的付款方式",
  "Payment Method to get voucher": "获取优惠券的付款方式",
  "If applicable to all the payment method, leave it blank": "如果适用于所有付款方式，请留空",
  "Add {{ currency }} {{ amount }} for {{ mode }} Wash": "添加 {{ currency }} {{ amount }} 用于 {{ mode }} 洗涤",
  "Add {{ currency }} {{ amount }} for an extra {{ runtime }} minutes!": "添加 {{ currency }} {{ amount }} 即可获得额外的 {{ runtime }} 分钟！",
  "via": "通过",
  "Cash": "现金",
  "Are you sure you have collected your laundry?": "您确定您已经领取了您的衣物了吗？",
  "Collected All": "全部已领取",
  "Collected": "已领取",
  "Are you sure the customer have collected the laundry?": "您确定顾客已经领取了他们的衣物了吗？",
  "Pending Payment (Cash)": "待付款（现金）",
  "You have received the cash payment": "您已收到现金付款",
  "Print Receipt": "打印收据",
  "Are you sure you want to print receipt?": "您确实要打印收据吗？",
  "Are you sure you want to print sticker?": "您确定要打印贴纸吗？",
  "Copy": "复制",
  "low": "低",
  "medium": "中等",
  "high": "高",
  "About Us": "关于我们",
  "ABOUT US": "关于我们",
  "Only can request einvoice for Malaysia Outlet": "仅限马来西亚分店可申请电子发票",
  "E-Invoice requested successfully": "电子发票申请成功",
  "Select machine": "选择机器",
  "Select transaction date": "选择交易日期",
  "Transaction Time": "交易时间",
  "Select transaction time": "选择交易时间",
  "Transaction Amount": "交易金额",
  "Enter Transaction Amount, Example: 1.50": "输入交易金额，例如：1.50",
  "Select payment method": "选择付款方式",
  "Cashless (e-Wallet / DuitNow QR)": "非现金（电子钱包/DuitNow QR）",
  "Paywave (Tap with Debit/Credit Card)": "Paywave（使用借记卡/信用卡付款）",
  "Request as": "请求为",
  "Individual": "个人",
  "Company": "公司",
  "ID Type": "身份证类型",
  "Select ID Type": "选择身份证件类型",
  "Company Name": "公司名称",
  "Phone": "电话",
  "Address": "地址",
  "City": "城市",
  "Postcode": "邮政编码",
  "Request E-Invoice": "申请电子发票",
  "Request e-Invoice": "申请电子发票",
  "e-Invoice Validation Link": "电子发票验证链接",
  "Credit Card": "信用卡",
  "Credit Card Number": "信用卡号码",
  "Credit Card Expiry Month": "信用卡到期月份",
  "Credit Card Expiry Year": "信用卡到期年份",
  "Credit Card Securtiy Code": "信用卡安全码",
  "Credit Card Holder Name": "信用卡持有人姓名",
  "Settlement Amount": "结算金额",
  "Paid": "已付款",
  "Enable E-Wallet Payment?": "启用电子钱包支付？",
  "Enable DuitNow Payment?": "启用 DuitNow 支付？",
  "Enable Credit Card Terminal Payment?": "启用信用卡终端支付？",
  "Transaction date is more than 3 days": "交易日期超过3天",
  "Select Recurrence Type": "选择重复类型",
  "Multiple Voucher": "多重优惠券",
  "Period for giving next voucher (days)": "发放下一个优惠券的周期（天）",
  "General Voucher Code Report": "通用优惠券代码报告",
  "Unique Voucher Code Report": "独特优惠券代码报告",
  "Select Code": "选择代码",
  "Minimum transaction amount to use code cannot be negative": "使用代码的最低交易金额不能为负数",
  "Redeem per user must at least 1": "每用户兑换次数至少为1",
  "Start date must before end date": "开始日期必须早于结束日期",
  "Please select the start date and end date": "请选择开始日期和结束日期",
  "Please enter the voucher code": "请输入优惠券代码",
  "Successfully create the voucher code": "成功创建优惠券代码",
  "General Voucher Code": "通用优惠券代码",
  "Unique Voucher Code": "独特优惠券代码",
  "Add Voucher Code": "添加优惠券代码",
  "How many times the voucher code can be used for each user": "每个用户可以使用优惠券代码多少次",
  "Update Version": "更新版本",
  "User profile updated successfully": "用户资料更新成功",
  "Salutation": "称呼",
  "Nationality": "国籍",
  "Race": "种族",
  "Gender": "性别",
  "Update salutation": "更新称呼",
  "Update ID Type": "更新身份证类型",
  "Update Address": "更新地址",
  "Update nationality": "更新国籍",
  "Male": "男性",
  "Female": "女性",
  "Update gender": "更新性别",
  "Number of Point cannot be 0": "积分数量不能为0",
  "Token value cannot be 0": "代币价值不能为0",
  "Activate": "激活",
  "Deactivate": "停用",
  "Activate User": "激活用户",
  "Deactivate User": "停用用户",
  "Are you sure you want to activate the user account?": "您确定要激活用户账户吗？",
  "Are you sure you want to deactivate the user account?": "您确定要停用用户账户吗？",
  "Your point redemption is successful": "您的积分兑换成功",
  "Point Redemption": "积分兑换",
  "This redemption has already been completed": "此兑换已完成",
  "Transaction Details": "交易详情",
  "Please login to redeem point": "请登录以兑换积分",
  "Login as {{name}}": "以{{name}}身份登录",
  "Payment Amount Settings": "付款金额设置",
  "Allow washer pay less than cheapest mode price?": "允许洗衣机支付低于最便宜模式的价格？",
  "Allow dryer pay less than minimum price?": "允许烘干机支付低于最低价格？",
  "Drop n Go Settings": "自助投递设置",
  "Allow user pay for specific service only?": "仅允许用户为特定服务付款？",
  "Display pricing for each service?": "显示每项服务的价格？",
  "Delete Voucher": "删除优惠券",
  "Are you sure you want to delete this voucher?": "您确定要删除此优惠券吗？",
  "Display in Promotion Page": "在促销页面显示",
  "Add Promotion": "添加促销",
  "Select Transaction Status": "选择交易状态",
  "Give Stamp for Drop n Go Transaction?": "为自助投递交易提供印章？",
  "Display machine capacity?": "显示机器容量？",
  "External Voucher Code": "外部优惠券代码",
  "Import Voucher Code": "导入优惠券代码",
  "Voucher Code Stamp Settings": "优惠券代码印章设置",
  "Upload Date": "上传日期",
  "Import External Voucher Code": "导入外部优惠券代码",
  "Import": "导入",
  "Please select a valid CSV file": "请选择有效的CSV文件",
  "Redeemed": "已兑换",
  "Sales": "销售额",
  "Drop N Go Dashboard": "自助投递仪表板",
  "Total Drop N Go Sales by Month": "总自助投递销售额按月统计",
  "Total Drop N Go Sales by Day": "总自助投递销售额按天统计",
}

const translationZhtw = {
  "LOGIN": "登錄",
  "REGISTER": "註冊",
  "SKIP TO PAYMENT": "直接付款",
  "Continue as guest": "以訪客身份繼續",
  "WELCOME": "歡迎",
  "Error": "錯誤",
  "Please enter the correct phone number format. <br /><br /> <small>Example: 0129465628</small>": "請輸入正確的電話號碼格式。 <br /><br /> <small>例如: 0129465628</small>",
  "Info": "資訊",
  "Please scan QRCode to Login": "請掃描二維碼登錄",
  "Forgot Password": "忘記密碼",
  "Seems like you have forgotten your password<br />Create a temporary password?": "好像忘記密碼了<br />創建臨時密碼？",
  "Cancel": "取消",
  "Confirm": "确认",
  "Reset Your Password": "重置您的密碼",
  "Enter Your Phone Number / Email Address": "輸入您的電話號碼/電子郵件地址",
  "Enter Your Email Address": "輸入您的電子郵件地址",
  "Please enter phone number / email address": "請輸入電話號碼/電子郵件地址",
  "Please enter email address": "請輸入電子郵件地址",
  "Submit": "提交",
  "Please enter a valid phone number": "請輸入正確的電話號碼格式",
  "Please enter a valid email address": "請輸入有效的電子郵件地址",
  "Success!": "成功！",
  "You may login using your one time password now.": "您現在可以使用一次性密碼登錄。",
  "Phone Number": "電話號碼",
  "Password": "密碼",
  "Don't have an account?": "還未有賬戶？",
  "Forgot password?": "忘記密碼？",
  "Unable to register without a QRCode": "沒有二維碼無法註冊",
  "Please read and agree to the privacy policies, terms and conditions": "請閱讀並同意隱私政策、條款和條件",
  "Password length must be at least 6 characters": "密碼長度必須至少為 6 個字符",
  "Please enter the confirmation code that was sent to your phone": "請輸入發送到您手機的驗證碼",
  "Example: 012xxxxxxx": "例如: 012xxxxxxx",
  "Example: 09xxxxxxxx": "例如: 09xxxxxxxx",
  "Verification Method": "驗證方法",
  "Name": "姓名",
  "Email": "電子郵件",
  "optional": "選擇性",
  "Birth Year": "出生年份",
  "Year": "年",
  "Birth Month": "出生月份",
  "Month": "月",
  "Jan": "一月",
  "Feb": "二月",
  "Mar": "三月",
  "April": "四月",
  "May": "五月",
  "June": "六月",
  "July": "七月",
  "Aug": "八月",
  "Sept": "九月",
  "Oct": "十月",
  "Nov": "十一月",
  "Dec": "十二月",
  "Birth Day": "出生日期",
  "Day": "日",
  "OTP": "驗證碼",
  "OTP Confirmation": "確認驗證碼",
  "I agree to the": "我同意",
  "Privacy Policy": "隱私政策",
  "PRIVACY POLICY": "隱私政策",
  "and": "和",
  "Terms": "條款",
  "Conditions": "條件",
  "SEND CODE": "發送驗證碼",
  "Our One-Time Password (OTP) emails might end up in your spam or junk folder. We kindly ask you to take a moment to check your spam mailbox.": "我們的一次性密碼 (OTP) 電子郵件可能最終會進入您的垃圾郵件或垃圾郵件資料夾。 我們懇請您花點時間檢查您的垃圾郵件信箱。",
  "Already have an account? Login": "已經有賬戶？登錄",
  "Didn't receive a code?": "沒有收到驗證碼？",
  "Resend Code": "重新發送驗證碼",
  "collected": "已收集",
  "Collect": "收集",
  "stamps": "印章",
  "get 1 voucher": "獲得1張優惠券",
  "Minimum": "最低消費",
  "spending to collect each washer stamp": "以收集每個洗衣機印章",
  "spending to collect each dryer stamp": "以收集每個烘乾機印章",
  "spending to collect each stamp": "以收集每個印章",
  "Device don't have a camera": "設備沒有攝像頭",
  "This is not a valid QRCode": "這不是有效的二維碼",
  "Select Camera": "選擇相機",
  "Switch": "切換",
  "Camera": "相機",
  "Loading": "加載中",
  "Scan the QR code on the machine.": "掃描機器上的二維碼。",
  "Switch Camera": "切換相機",
  "Off torch light": "關閉手電筒",
  "On torch light": "開啟手電筒",
  "switch camera if your camera is not clear": "如果您的相機不清晰，請切換相機",
  "Switch your camera if the display is not clear": "如果顯示不清晰請切換相機",
  "Please allow this webapp to access your camera": "請允許此網絡應用訪問您的相機",
  "DISCOUNT": "折扣",
  "Congratulation": "恭喜",
  "Expired Date": "過期日期",
  "Voucher": "優惠券",
  "Vouchers": "優惠券",
  "Something went wrong": "出了些問題",
  "Stamping Collection": "印章收集",
  "Total e-Token": "總電子代幣",
  "Total Wash": "洗衣機次數",
  "Total Dry": "烘乾機次數",
  "Reload": "充值",
  "Washer": "洗衣機",
  "Dryer": "烘乾機",
  "Congratulations!": "恭喜！",
  "You have completed your Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "您已完成印章收集。<br />優惠券已給出和印章收集已刷新",
  "You have completed Washer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "您已完成洗衣機印章收集。<br />優惠券已給出和印章收集已刷新",
  "You have completed Dryer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "您已完成烘乾機印章收集。<br />優惠券已給出和印章收集已刷新",
  "Latest News": "最新消息",
  "Transaction History": "交易記錄",
  "Stamping": "印章",
  "Transaction": "交易",
  "News": "消息",
  "Confirmation": "確認",
  "Logout Session?": "登出？",
  "NO": "否",
  "OK": "確定",
  "Account": "賬戶",
  "FAQs": "常見問題",
  "Feedback": "反饋",
  "LOGOUT": "登出",
  "Logout": "登出",
  "Are you sure you want to submit your feedback?": "您確定要提交反饋嗎？",
  "No": "否",
  "Yes": "是",
  "Success": "成功",
  "Failed": "失敗",
  "Pending": "待定",
  "Your feedback is submitted successfully": "您的反饋已成功提交",
  "Please fill in all the required fields before submit.": "請在提交前填寫所有必填內容。",
  "Give us your feedback!": "您好，請對我們的服務提出寶貴建議，謝謝！",
  "Type your name here (optional)": "在此處輸入您的姓名（選擇性）",
  "required": "必填",
  "Type your number here": "在此處輸入您的電話號碼",
  "Outlet": "店鋪",
  "Select an outlet": "選擇店鋪",
  "Outlet Cleanliness": "店鋪清潔度",
  "Washer Machine Performance": "洗衣機性能",
  "Dryer Machine Performance": "烘乾機性能",
  "Customer Service": "客戶服務",
  "Comment": "評論",
  "Type your comment here (optional)": "在此處輸入您的評論（選擇性）",
  "SUBMIT": "提交",
  "Join as a member now!": "立即加入成為會員！",
  "Join as a loyalty member now to get more benefits such as vouchers and free machine usage!<br /><br /><strong>Register as loyalty member?</strong>": "現在加入會員，即可免費獲得優惠券和免費機器使用等福利！<br /><br /><strong>註冊成為會員？</strong>",
  "Maybe Next Time": "下一次吧",
  "Yes, Register Now": "是的，立即註冊",
  "Washer Payment": "洗衣機支付",
  "Dryer Payment": "烘乾機支付",
  "Vending Machine Payment": "自動販賣機支付",
  "Online": "在線",
  "Offline": "離線",
  "Running": "運行",
  "Vacant": "空置",
  "Vending Machine": "自動販賣機",
  "Discount": "折扣",
  "No Vouchers Available": "沒有可用的優惠券",
  "Payment Method": "付款方法",
  "Would you like to pay with?": "您願意使用哪種方式付款?",
  "e-Token": "電子代幣",
  "E-TOKEN": "電子代幣",
  "E-Wallet": "電子錢包",
  "E-Wallet & Online Banking": "電子錢包和網上銀行",
  "Duitnow QR code": "Duitnow二維碼",
  "PromptPay QR Code": "PromptPay二維碼",
  "The Duitnow QR code will be downloaded and you need to open your banking app to make the payment. Pay {{ currency }}{{ totalPaymentAmount }} to {{ machineName }}?": "Duitnow 二維碼會將下載，您需要打開銀行應用程式進行付款。向 {{ machineName }} 支付 {{ currency }}{{ totalPaymentAmount }} 嗎？",
  "Pay": "付",
  "to": "給",
  "You may under utilized the voucher.": "您尚未充分利用您的優惠券。",
  "Proceed to pay": "繼續支付",
  "Processing ...": "支付中 ...",
  "You can't pay with e-token if voucher is in used, please remove your voucher to pay with e-token.": "您不能同時使用優惠劵和電子代幣付款，請移除您的優惠卷以使用電子代幣付款。",
  "Insufficient e-Tokens": "電子代幣不足",
  "Reload your e-token now?": "現在充值您的電子代幣？",
  "Reload now!": "現在充值！",
  "You have": "您有",
  "e-Tokens": "電子代幣",
  "Tokens to": "代幣給",
  "This machine is currently offline, please try again later.": "本機器當前離線，請稍後重試。",
  "MACHINE": "機器",
  "Machine": "機器",
  "TYPE": "類型",
  "CAPACITY": "容量",
  "DURATION": "時長",
  "Select Duration": "選擇時長",
  "AMOUNT TO PAY": "支付總額",
  "PRICE": "價格",
  "VOUCHER": "優惠券",
  "Select Voucher >": "選擇優惠券 >",
  "TOTAL": "總額",
  "PAY": "付款",
  "Remove Voucher": "移除優惠券",
  "Select Your Voucher": "選擇您的優惠券",
  "min": "分鐘",
  "MIN": "分鐘",
  "Select Payment Amount": "選擇支付總額",
  "Select Water Temperature": "選擇水溫",
  "Select temperature": "選擇水溫",
  "Select Temperature": "選擇水溫",
  "Cold": "冷",
  "Warm": "溫",
  "Hot": "熱",
  "e-Tokens to": "電子代幣給",
  "No Purchase History": "無購買記錄",
  "e-tokens": "電子代幣",
  "No Promotions": "沒有促銷",
  "New Password": "新密碼",
  "Back": "返回",
  "Buy this package?": "買這個配套？",
  "Purchase": "購買",
  "e-Tokens for": "電子代幣以",
  "Reload Tokens": "充值電子代幣",
  "Are you sure you want to purchase {{ tokenAmount }} e-Token for {{ currency }}{{ paymentAmount }}?": "您確定要以 {{ currency }}{{ paymentAmount }} 購買 {{ tokenAmount }} 電子代幣嗎？",
  "Current e-Token": "當前電子代幣",
  "Current point": "當前積分",
  "History": "歷史記錄",
  "Your profile picture has been updated!": "您的頭像已更新！",
  "Please only use png, jpg or jpeg file extension type": "請僅使用 png、jpg 或 jpeg 類型文件",
  "Please only use image type file": "請僅使用圖像類型文件",
  "User name has updated successfully!": "用戶名更新成功！",
  "Email Address updated successfully": "電子郵件更新成功",
  "Phone number updated successfully": "電話號碼更新成功",
  "Password must be at least 6 characters": "密碼必須至少6個字符",
  "Password updated successfully": "密碼更新成功",
  "User Settings": "用戶設置",
  "Profile Picture": "個人頭像",
  "Change Password": "更改密碼",
  "Do you want to submit your feedback?": "您想提交您的反饋嗎？",
  "Thank You!": "謝謝你！",
  "Thank you for using our services.": "感謝您使用我們的服務。",
  "BACK TO HOMEPAGE": "返回主頁",
  "How to pay?": "如何付款？",
  "Step 1": "步驟 1",
  "After scan the QR code on the machine, select either register new account, login your account or skip to payment.": "掃描機器上的二維碼後，選擇註冊新帳戶、登錄您的帳戶或直接付款。",
  "Step 2-1": "步驟 2-1",
  "For Dryer – Select your desired duration. Different duration will have different prices.": "對於烘乾機 - 選擇所需的時長。不同的時間會有不同的價格。",
  "Step 2-2": "步驟 2-2",
  "For Washer – Select your desired water temperature. Different water temperature will have different prices.": "對於洗衣機 - 選擇您想要的水溫。不同的水溫會有不同的價格。",
  "Step 3": "步驟 3",
  "For login user, Click on ‘Select Voucher’ to select your voucher.": "對於所有登錄用戶，點擊“選擇優惠劵”以選擇您的優惠劵。",
  "Step 4": "步驟 4",
  "Click on ‘PAY’ button to pay. For login user, select your payment method to pay.": "點擊“付款”按鈕進行支付。對於登錄用戶，選擇您的支付方式進行支付。",
  "Step 5": "步驟 5",
  "After confirm the price and machine details, click on ‘OK’ button to pay.": "確認價格和機器詳情后，點擊“確定”按鈕進行支付。",
  "How to reload your e-Token?": "如何充值您的電子代幣？",
  'Click on the "Reload" button.': '點擊“充值”按鈕。',
  "Select the package that you wish to purchase.": "選擇您要購買的配套。",
  'Click on "Purchase" as confirmation before payment page.': '在前往付款頁面之前點擊“購買”作為確認。',
  "Is e-token can be refund/transfer back to e-wallet?": "電子代幣可以退款/轉回電子錢包嗎？",
  "Why can't I applied my voucher?": "為何不能使用我的優惠券？",
  "When there is a Happy Hour Promotion is on going, you are unable to apply your voucher temporarily.": "每當特別促銷正在進行時，您暫時無法使用您的優惠劵。",
  "How to apply my voucher?": "如何使用我的優惠券？",
  'Click on the "Select Voucher" button.': '點擊“選擇優惠券”按鈕。',
  "Select the voucher that you wish to apply.": "選擇您要使用的優惠券。",
  'Click on "Pay" once you have verified the voucher is successfully applied.': '確認優惠劵已成功使用後，請點擊“付款”。',
  "Step 2": "步驟 2",
  "Language has updated successfully!": "語言更新成功！",
  "Change Language": "更改語言",
  "Language": "語言",
  "Select language": "選擇語言",
  "Referral Code": "邀請碼",
  "Copied!": "已復制!",
  "Inviting friends to get more benefits!": "邀請好友以獲取更多福利！",
  "Would you like to share your referral code to your friends & family?": "您要分享您的邀請碼給朋友&家人嗎？",
  "Refer a friend and get": "推薦朋友並獲得",
  "Share the love to your friends & family?": "將愛分享給您的朋友和家人？",
  "voucher": "優惠劵",
  "token": "電子代幣",
  "stamp": "印章",
  "washer stamp": "洗衣機印章",
  "dryer stamp": "烘乾機印章",
  "Learn More": "了解更多",
  "Welcome Gift": "歡迎禮物",
  "Share Your Referral Code Now": "立即分享您的邀請碼",
  "Birthday Gift for You": "給您的生日禮物",
  "Let's Pay with E-Token": "使用電子代幣支付",
  "Collect 10 Stamps and Get Voucher": "收集 10 個印章並獲得優惠劵",
  "The voucher will be given if you registered your account successfully.": "如果您成功註冊了您的帳戶，您將獲得優惠券。",
  "There is no expiration date for this voucher.": "此優惠券沒有過期日期。",
  "The voucher can be used for dryer machine only.": "優惠券僅可用於烘乾機。",
  "The voucher can be used for washer machine only.": "優惠券僅可用於洗衣機。",
  "The voucher can be used for Drop n Go transaction only.": "優惠券僅可用於 Drop n Go 交易。",
  "The voucher can be used for vending transaction only.": "此優惠券僅可用於自動販賣機交易。",
  "The voucher can be used for detergent vending transaction only.": "此優惠券僅可用於洗衣精自動販賣機交易。",
  "The voucher can be used for car wash transaction only.": "此優惠券僅可用於洗車交易。",
  "The voucher can be used for washer machine or Drop n Go transaction.": "優惠券僅可用於洗衣機或 Drop n Go 交易。",
  "The voucher can be used for dryer machine or Drop n Go transaction.": "優惠券僅可用於烘乾機或 Drop n Go 交易。",
  "The voucher can be used for dryer or washer machine.": "優惠券可用於烘乾機或洗衣機。",
  "The voucher can be used for washer machine, dryer machine or Drop n Go transaction.": "優惠券可用於洗衣機、烘乾機或 Drop n Go 交易。",
  "The voucher can be used for washer machine or vending machine transaction.": "此優惠券可用於洗衣機或自動販賣機交易。",
  "The voucher can be used for washer machine or detergent vending machine transaction.": "此優惠券可用於洗衣機或洗衣精自動販賣機交易。",
  "The voucher can be used for washer machine or car wash transaction.": "此優惠券可用於洗衣機或洗車交易。",
  "The voucher can be used for dryer machine or vending machine transaction.": "此優惠券可用於烘乾機或自動販賣機交易。",
  "The voucher can be used for dryer machine or detergent vending machine transaction.": "此優惠券可用於烘乾機或洗衣精自動販賣機交易。",
  "The voucher can be used for dryer machine or car wash transaction.": "此優惠券可用於烘乾機或洗車交易。",
  "The voucher can be used for vending machine or Drop n Go transaction.": "此優惠券可用於自動販賣機或Drop n Go交易。",
  "The voucher can be used for detergent vending machine or Drop n Go transaction.": "此優惠券可用於洗衣精自動販賣機或Drop n Go交易。",
  "The voucher can be used for car wash or Drop n Go transaction.": "此優惠券可用於洗車或Drop n Go交易。",
  "The voucher can be used for vending machine or detergent vending machine transaction.": "此優惠券可用於自動販賣機或洗衣精自動販賣機交易。",
  "The voucher can be used for vending machine or car wash transaction.": "此優惠券可用於自動販賣機或洗車交易。",
  "The voucher can be used for detergent vending machine or car wash transaction.": "此優惠券可用於洗衣精自動販賣機或洗車交易。",
  "The voucher can be used for washer machine, dryer machine or vending machine transaction.": "此優惠券可用於洗衣機、烘乾機或自動販賣機交易。",
  "The voucher can be used for washer machine, dryer machine or detergent vending machine transaction.": "此優惠券可用於洗衣機、烘乾機或洗衣精自動販賣機交易。",
  "The voucher can be used for washer machine, dryer machine or car wash transaction.": "此優惠券可用於洗衣機、烘乾機或洗車交易。",
  "The voucher can be used for washer machine, vending machine or Drop n Go transaction.": "此優惠券可用於洗衣機、自動販賣機或Drop n Go交易。",
  "The voucher can be used for washer machine, detergent vending machine or Drop n Go transaction.": "此優惠券可用於洗衣機、洗衣精自動販賣機或Drop n Go交易。",
  "The voucher can be used for washer machine, car wash or Drop n Go transaction.": "此優惠券可用於洗衣機、洗車或Drop n Go交易。",
  "The voucher can be used for washer machine, vending machine or detergent vending transaction.": "此優惠券可用於洗衣機、自動販賣機或洗衣精自動販賣機交易。",
  "The voucher can be used for washer machine, vending machine or car wash transaction.": "此優惠券可用於洗衣機、自動販賣機或洗車交易。",
  "The voucher can be used for washer machine, detergent vending machine or car wash transaction.": "此優惠券可用於洗衣機、洗衣精自動販賣機或洗車交易。",
  "The voucher can be used for dryer machine, vending machine or Drop n Go transaction.": "此優惠券可用於烘乾機、自動販賣機或Drop n Go交易。",
  "The voucher can be used for dryer machine, detergent vending machine or Drop n Go transaction.": "此優惠券可用於烘乾機、洗衣精自動販賣機或Drop n Go交易。",
  "The voucher can be used for dryer machine, car wash or Drop n Go transaction.": "此優惠券可用於烘乾機、洗車或Drop n Go交易。",
  "The voucher can be used for dryer machine, vending machine or detergent vending machine transaction.": "此優惠券可用於烘乾機、自動販賣機或洗衣精自動販賣機交易。",
  "The voucher can be used for dryer machine, vending machine or car wash transaction.": "此優惠券可用於烘乾機、自動販賣機或洗車交易。",
  "The voucher can be used for dryer machine, detergent vending machine or car wash transaction.": "此優惠券可用於烘乾機、洗衣精自動販賣機或洗車交易。",
  "The voucher can be used for vending machine, detergent vending machine or Drop n Go transaction.": "此優惠券可用於自動販賣機、洗衣精自動販賣機或Drop n Go交易。",
  "The voucher can be used for vending machine, car wash or Drop n Go transaction.": "此優惠券可用於自動販賣機、洗車或Drop n Go交易。",
  "The voucher can be used for detergent vending machine, car wash or Drop n Go transaction.": "此優惠券可用於洗衣精自動販賣機、洗車或Drop n Go交易。",
  "The voucher can be used for vending machine, detergent vending machine or car wash transaction.": "此優惠券可用於自動販賣機、洗衣精自動販賣機或洗車交易。",
  "The voucher can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "此優惠券可用於洗衣機、烘乾機、自動販賣機或Drop n Go交易。",
  "The voucher can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction.": "此優惠券可用於洗衣機、烘乾機、自動販賣機或洗衣精自動販賣機交易。",
  "The voucher can be used for washer machine, dryer machine, vending machine or car wash transaction.": "此優惠券可用於洗衣機、烘乾機、自動販賣機或洗車交易。",
  "The voucher can be used for washer machine, dryer machine, detergent vending machine or car wash transaction.": "此優惠券可用於洗衣機、烘乾機、洗衣精自動販賣機或洗車交易。",
  "The voucher can be used for washer machine, vending macihne, detergent vending machine, car wash or Drop n Go transaction.": "此優惠券可用於洗衣機、自動販賣機、洗衣精自動販賣機、洗車或Drop n Go交易。",
  "The voucher can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "此優惠券可用於烘乾機、自動販賣機、洗衣精自動販賣機、洗車或Drop n Go交易。",
  "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "此優惠券可用於洗衣機、烘乾機、自動販賣機、洗衣精自動販賣機、洗車或Drop n Go交易。",
  "When you applied the voucher during payment, it will give you": "當您在付款期間使用您的優惠券時，它會給您",
  "discount.": "折扣。",
  "When promotion is on going, the voucher is not applicable.": "促銷期間，優惠券不可使用。",
  "The voucher cannot be used if your payment method is E-Token.": "如果您的付款方式是電子代幣，則不能使用該優惠券。",
  "Your referral code can be found in user settings page.": "您的邀請碼可以在用戶設置頁面中找到。",
  "You can get": "你可以得到",
  "stamp for the reward.": "印章作為獎勵。",
  "e-token for the reward.": "電子代幣作為獎勵。",
  "e-token based on transaction payment amount for the reward.": "電子代幣根據交易的支付金額作為獎勵。",
  "for the reward.": "以作為獎勵。",
  "based on transaction payment amount for the reward.": "根據交易支付金額獲得獎勵。",
  "You can get a voucher for the reward": "您可以獲得優惠券作為獎勵",
  "which have": "此優惠劵將有",
  "it can be used for dryer machine only.": "它只能用於烘乾機。",
  "it can be used for washer machine only.": "它只能用於洗衣機。",
  "it can be used for Drop n Go transaction only.": "它只能用於Drop n Go交易。",
  "it can be used for vending machine only.": "僅可用於自動販賣機。",
  "it can be used for car wash transaction only.": "僅可用於洗車交易。",
  "it can be used for detergent vending machine only.": "僅可用於洗衣精自動販賣機。",
  "it can be used for dryer or washer machine.": "它可用於烘乾機或洗衣機。",
  "it can be used for dryer machine or Drop n Go transaction.": "它可用於烘乾機或Drop n Go交易。",
  "it can be used for washer machine or Drop n Go transaction.": "它可用於洗衣機或Drop n Go 交易。",
  "it can be used for washer machine, dryer machine or Drop n Go transaction.": "它可用於洗衣機、烘乾機或Drop n Go 交易。",
  "it can be used for washer machine, dryer machine or vending machine transaction.": "可用於洗衣機、烘乾機或自動販賣機交易。",
  "it can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "可用於洗衣機、烘乾機、自動販賣機或Drop n Go交易。",
  "washer stamp for the reward.": "洗衣機印章作為獎勵。",
  "dryer stamp for the reward.": "烘乾機印章作為獎勵。",
  "washer stamp and": "洗衣機印章和",
  "cleanproBirthdayShortDesc": "使用 Cleanpro Plus 在您的特殊日子兌換 {{ birthdayVoucherAmount }} 貨幣的生日禮券。點擊以了解更多信息。",
  'When you click on "PAY" button on the payment page, you can choose either using E-wallet or E-token to pay.': '當您在支付頁麵點擊"付款"按鈕時，您可以選擇使用電子錢包或電子代幣進行支付。',
  "When you using your voucher during payment, you will be unable to pay with E-token.": "當您在付款期間使用您的優惠券時，您將無法使用電子代幣付款。",
  "You can reload your E-token by clicking the reload button in the stamping page and select the package to purchase.": "您可以通過點擊印章頁面中的充值按鈕並選擇要購買的配套來充值您的電子代幣。",
  "You can reload your E-token by clicking the reload button in the home page and select the package to purchase.": "您可以通過點擊主頁中的充值按鈕並選擇要購買的配套來充值您的電子代幣。",
  "You can view your E-token reload history and E-token transaction history in transaction page.": "您可以在交易頁面查看您電子代幣的儲值記錄和交易記錄。",
  "You can view your E-token transaction history in transaction page.": "您可以在交易頁面查看您電子代幣的交易記錄。",
  "Using either dryer machine or washer machine with the minimum spending of": "使用烘乾機或洗衣機，最低消費",
  "to collect one stamp.": "即可收集一個印章。",
  "The voucher will be given if you have collected 10 stamps.": "如果您收集了 10 個印章，將獲得優惠券。",
  "Using dryer machine with the minimum spending of": "使用烘乾機最低消費",
  "Using washer machine with the minimum spending of": "使用洗衣機最低消費",
  "to collect one dryer stamp.": "即可獲得一個烘乾機印章。",
  "to collect one washer stamp.": "即可獲得一個洗衣機印章。",
  "The voucher will be given if you have collected 10 dryer stamps or 10 washer stamps.": "如果您收集了 10 個烘乾機印章或 10 個洗衣機印章，將獲得優惠券。",
  "For the voucher given by the dryer stamps,": "對於烘乾機印章給出的優惠劵，",
  "For the voucher given by the washer stamps,": "對於洗衣機印章給出的優惠劵，",
  "When promotion is on going, all the vouchers is not applicable.": "促銷期間，所有優惠券均不可使用。",
  "All the vouchers cannot be used if your payment method is E-Token.": "如果您的付款方式是電子代幣，則所有優惠券都不能使用。",
  "Description": "簡介",
  "Refer Friends": "推薦給朋友",
  "View our guideline": "查看我們的指南",
  "When a friend / family register using your referral code, and completed a transaction with a minimum spending of": "當朋友/家人使用您的邀請碼註冊並完成最低消費",
  ", you will be rewarded automatically.": "的交易時，您將自動獲得獎勵。",
  "One user only allow to have": "一個用戶只允許擁有",
  "referrals.": "邀請者。",
  "Confirmation Password": "確認密碼",
  "Password and confirmation password should be same.": "密碼和確認密碼必須相同。",
  "You haven't applied your voucher": "您還沒使用優惠券",
  "Would you like to continue your payment without using your voucher?": "您想在不使用優惠券的情況下繼續付款嗎？",
  "Continue": "繼續",
  "Apply voucher": "使用優惠券",
  "Transfer": "轉賬",
  "Transfer Tokens": "轉賬電子代幣",
  "Please fill in the phone number": "請填寫電話號碼",
  "Please fill in the email": "請填寫電子郵件",
  "Please enter the phone number / email that you want to transfer to": "請輸入您要轉賬的電話號碼/電子郵件",
  "Please fill in the transfer amount": "請填寫轉賬總額",
  "Transfer amount should be more than 0 and less than your current e-Token": "轉賬總額需大於0且小於您當前的電子代幣",
  "Please enter your password": "請輸入您的密碼",
  "Member ID": "會員ID",
  "E-Token Transfer Amount": "電子代幣轉賬總額",
  "Please confirm the details before proceeding": "請在繼續之前確認詳細信息",
  "Transfer From": "轉賬從",
  "Transfer To": "轉賬至",
  "Transfer Amount": "轉賬總額",
  "Transfer Successfully!": "轉賬成功！",
  "Transfer Time": "轉賬時間",
  "Token": "電子代幣",
  "Done": "完成",
  "Next": "繼續",
  "Enter Password": "輸入密碼",
  "Transfer E-Token Amount": "電子代幣轉賬金額",
  "User not found": "找不到用戶",
  "Password is incorrect": "密碼不正確",
  "Please go to your account setting and reset your password": "請前往您的用戶設置並重置您的密碼",
  "Only up to last 3 months transaction history": "僅最近3個月的交易記錄",
  "Reload History": "充值記錄",
  "Transfer History": "轉賬記錄",
  "{{ point }} History": "{{ point }}記錄",
  "Only up to last 3 months reload history": "僅最近3個月的充值記錄",
  "Only up to last 3 months transfer history": "僅最近3個月的轉賬記錄",
  "Only up to last 3 months {{ point }} history": "僅最近3個月的{{ point }}記錄",
  "Only up to last 3 months laundry pass history": "僅最近3個月的洗衣通行證明紀錄",
  "If require urgent response, please contact us through whatapp": "如果需要緊急回應，請通過whatsapp與我們聯繫",
  "Please scan the QR code again": "請再次掃描二維碼",
  "Home": "主頁",
  "Quick": "快速",
  "Super": "超級",
  "Premium": "高級",
  "All users will have infinite referrals.": "所有用戶都將獲得無限邀請者。",
  "Collect 10 stamps to get 1 Voucher": "收集10個印章獲得1張優惠劵",
  "The voucher is only for customer use only, not for sale.": "優惠券僅供客戶使用，不用於銷售。",
  "Outlet is currently offline, please try again later": "店鋪目前處於離線狀態，請稍後再試",
  "The voucher will be given if you completed a transaction with a minimum spending of": "您將獲得優惠劵如果您完成交易以最低消費",
  "The birthday voucher will be given on the first day of your birthday month.": "生日券將在您生日月份的第一天發放。",
  "The voucher only will be given if you have exceed spending amount of": "優惠劵只會發放當您的消費超過",
  "Pay with KiplePay": "使用 KiplePay 付款",
  "Pay with Scan2Pay": "使用 Scan2Pay 付款",
  "Pay with Razer": "使用 Razer 付款",
  "Pay with HitPay": "使用 HitPay 付款",
  "Pay with Duitnow QR": "使用 Duitnow QR 付款",
  "Pay with PagBank": "使用 PagBank 付款",
  "Pay with PromptPay QR": "使用 PromptPay QR 付款",
  "Pay with Card": "使用卡付款",
  "Pay with PayWay": "使用 PayWay 付款",
  "DISCOUNT CODE": "優惠碼",
  "Enter code >": "輸入優惠碼 >",
  "Enter Discount Code": "輸入優惠碼",
  "Remove Code": "移除優惠碼",
  "Discount Code": "優惠碼",
  "Close": "關閉",
  "Please fill in your email address": "請填寫您的電子郵件地址",
  "Notification": "通知",
  "Do you want to receive notification when wash cycle done?": "您想在洗滌週期完成時收到通知嗎？",
  "pay extra": "額外付費",
  "Email Address": "電子郵件地址",
  "Please fill in your phone number": "請填寫您的電話號碼",
  "Invalid Phone Number": "無效的電話號碼",
  "Washing Complete": "洗滌完成",
  "Drying Complete": "烘乾完成",
  "The voucher will be given if you registered your account successfully, but it only can be used when your total transaction spending reach": "成功註冊賬戶即可獲贈禮券，但僅能使用當交易總額達",
  "and above.": "或以上。",
  "This voucher is not applicable": "此優惠券不適用",
  "Finish in": "完成於",
  "Need to refresh to update": "需要刷新才能更新",
  "It's indicative and may change based on washer load": "這是指示性的，可能會根據洗衣機負載而變化",
  "We'll let you know when it's ready to pick up": "當準備好取衣物時，我們會通知您",
  "FREE": "免費",
  "Enter voucher code (if got any)": "輸入優惠券兌換碼（如果有）",
  "Please fill in the voucher code": "請輸入優惠券兌換碼",
  "Available On": "可用於",
  "Apply": "使用",
  "Enter a code": "輸入兌換碼",
  "Input Promo Code": "輸入促銷代碼",
  "Voucher is redeemed successfully!": "優惠券兌換成功！",
  "Not available": "無法使用",
  "Unable to register": "無法註冊",
  "Drop n Go Service": "Drop n Go 服務",
  "Select Mode": "選擇模式",
  "Quantity": "數量",
  "Pack": "包裹",
  "Add more": "添加更多",
  "Select Size": "選擇尺寸",
  "Select Services": "選擇服務",
  "Are you sure to delete the item?": "您確定要刪除該配套嗎？",
  "Delete": "刪除",
  "Your Duitnow QR code": "您的 Duitnow 二維碼",
  "Your PromptPay QR code": "您的 PromptPay 二維碼",
  "How to pay using Duitnow QR code?": "如何使用 Duitnow 二維碼付款？",
  "How to pay using PromptPay QR code?": "如何使用 PromptPay 二維碼付款？",
  "Launch": "運行",
  "Launch your preferred Mobile Banking or eWallet app.": "啟動您喜歡的手機銀行或電子錢包應用程式。",
  "Scan QR code from Gallery": "從圖庫掃描二維碼",
  "Choose DuitNow QR from your gallery.": "從您的圖庫中選擇 DuitNow 二維碼。",
  "Confirm payment details and pay.": "確認付款細節並付款。",
  "Receive payment confirmation.": "收到付款確認。",
  "expiring on": "過期於",
  "Expired on": "過期於",
  "based on transaction payment amount": "根據交易支付金額",
  "Join as our": "立即加入我們的",
  "Loyalty Member": "忠誠會員",
  "now to get more reward": "以獲得更多獎勵",
  "Payment amount should be greater than 0": "付款金額必須大於0",
  // admin portal
  "Dashboard": "概括",
  "Report": "報告",
  "Store Performance": "商店表現",
  "User Performance": "用戶表現",
  "Voucher Redemption": "優惠券兌換",
  "Token Report": "電子代幣報告",
  "SMS Report": "簡訊報告",
  "Discount Code Report": "優惠碼報告",
  "User Details": "用戶詳細資訊",
  "User Compensation": "用戶補償",
  "Voucher Settings": "優惠券設定",
  "Token Settings": "代幣設定",
  "Referral Settings": "邀請碼設定",
  "Voucher Code": "優惠券兌換碼",
  "Customize Color": "更換主題顏色",
  "User Migration": "用戶遷移",
  "Back To": "返回",
  "Eligibility": "資格",
  "If ticked, the voucher will have expired date": "若勾選，優惠券將有過期日期",
  "Expiry": "期限",
  "If ticked, the voucher can apply to washer machine transaction": "若勾選，優惠劵可用於洗衣機交易",
  "Washer Use": "應用於洗衣機",
  "If ticked, the voucher can apply to dryer machine transaction": "若勾選，優惠劵可用於烘乾機交易",
  "Dryer Use": "應用於烘乾機",
  "If ticked, the voucher can apply to Drop n Go transaction": "若勾選，優惠劵可用於Drop n Go交易",
  "Package Use": "應用於配套",
  "If ticked, the voucher can apply to vending machine transaction": "若勾選，優惠券可用於自動販賣機交易",
  "Vending Use": "應用於自動販賣機",
  "If ticked, the voucher can apply to detergent vending machine transaction": "若勾選，優惠券可用於洗衣精販賣機交易",
  "Detergent Use": "應用於洗衣精販賣機",
  "If ticked, the voucher can apply to car wash transaction": "若勾選，優惠券可用於洗車交易",
  "Car Wash Use": "應用於洗車",
  "Voucher Lifespan": "優惠券有效期限",
  "days": "天",
  "Discount Type": "折扣類型",
  "Select a discount type": "選擇折扣類型",
  "Flat": "扁平",
  "Rate": "率",
  "Voucher Title": "優惠券標題",
  "Voucher Description": "優惠券說明",
  "Voucher Amount": "優惠券金額",
  "CONFIRM": "確認",
  "If ticked, the system will give voucher to user who completed washer stamp collection": "如果勾選，系統將向完成洗衣機印章收集的用戶發放優惠劵",
  "If ticked, the system will give voucher to user who completed dryer stamp collection": "如果勾選，系統將向完成烘乾機印章收集的用戶發放優惠劵",
  "If ticked, the user only can get/use the voucher after make a transaction": "如果勾選，用戶只有在進行交易後才能取得/使用優惠券",
  "Pay And Get Voucher": "付款後取得優惠券",
  "Pay And Use Code": "消費後才能使用優惠碼",
  "If ticked, the system will only give the voucher to user after the user make a transaction": "如果勾選，只有在用戶進行交易後，系統才會將優惠券發放給用戶",
  "If ticked, the system will give voucher to user who completed registration process": "如果勾選，系統將會向完成註冊的用戶贈送優惠劵",
  "If ticked, the system will give voucher to user on their birthday month": "如果勾選，系統將在用戶生日當月向用戶贈送優惠券",
  "If ticked, the system will give voucher to user who completed stamp collection": "如果勾選，系統將贈送優惠劵給完成印章收集的用戶",
  "Minimum Payment Amount To Get/Use Register Voucher": "取得/使用註冊優惠券的最低付款金額",
  "Voucher Method": "優惠券贈送方式",
  "Select a voucher method": "選擇優惠券贈送方式",
  "The user directly get the voucher after register but only can use it after make transaction": "用戶註冊後直接獲得優惠券，但需進行交易後才能使用",
  "The user only can get voucher after make a transaction": "用戶只有在進行交易後才能獲得優惠券",
  "Minimum Payment Amount To Get Birthday Voucher": "獲得生日優惠劵的最低付款金額",
  "Minimum Payment Amount To Use Discount Code": "使用優惠碼的最低交易金額",
  "Outlets": "商店",
  "E-Payment Sales": "電子支付銷售",
  "Number of stamps granted to users": "贈送用戶的印章數量",
  "Total number of stamps granted": "贈送印章總數",
  "Registered Users": "註冊用戶",
  "Stamps": "印章",
  "Referral": "邀請碼",
  "Register": "註冊",
  "Top Outlets": "熱門商店",
  "Users": "用戶",
  "Sort by": "排序方式",
  "Top Users": "熱門用戶",
  "User name": "用戶名",
  "Number": "電話號碼",
  "Spending": "花費",
  "Number of registered users": "註冊用戶數",
  "Number of voucher given to users": "給予用戶的優惠券數量",
  "Total number of voucher given": "給予的優惠券總數",
  "Voucher Type": "優惠券類型",
  "Voucher Value": "優惠券的價值",
  "Date": "日期",
  "Discount Code Type": "優惠碼類型",
  "Discount Code Amount": "優惠碼金額",
  "Number of Redemption": "兌換次數",
  "Total Discount Amount": "總折扣金額",
  "Select Outlet": "選擇商店",
  "Select Date": "選擇日期",
  "Select Transaction Date": "選擇交易日期",
  "Reset": "重置",
  "Download Report": "下載報告",
  "Please fill in the remark": "請填寫備註",
  "Transaction Date": "交易日期",
  "Machine Type": "機器類型",
  "Machine Capacity": "機器容量",
  "Total Amount": "總金額",
  "Payment Amount": "支付金額",
  "Discount From": "折扣從",
  "Discount Amount": "折扣金額",
  "Action": "行動",
  "Remark": "備註",
  "Refund Date": "退款日期",
  "Refund": "退款",
  "Purchase Date": "購買日期",
  "e-Token Purchased (Tokens)": "購買的電子代幣（電子代幣）",
  "Bought e-Token using": "購買的電子代幣",
  "Transaction ID": "交易ID",
  "Method": "方式",
  "Requery": "重新查詢",
  "Reward Date": "獎勵日期",
  "Reward Type": "獎勵類型",
  "Notification Method": "通知方式",
  "Email Preview": "电子邮件预览",
  "Message for User": "給用戶的留言",
  "SMS will send to user, please enter the message less than 130 characters": "簡訊將發送給用戶，請輸入少於130個字元的簡訊",
  "Enter the message to be sent to the user": "輸入要傳送給用戶的留言",
  "Email Address to show on Email Template": "電子郵件範本上顯示的電子郵件地址",
  "Input Company Email Address": "輸入公司電子郵件地址",
  "Company Name to show on Email Template": "電子郵件範本上顯示的公司名稱",
  "Input Company Name": "輸入公司名稱",
  "Company Phone No. to show on Email Template": "電子郵件範本上顯示的公司電話號碼",
  "Input Company Phone No.": "輸入公司電話號碼",
  "Voucher ID": "優惠券ID",
  "Washer Stamp": "洗衣機印章",
  "Dryer Stamp": "烘乾機印章",
  "e-Token Amount": "電子代幣金額",
  "Transfer Date": "轉帳日期",
  "Transfer Amount (Token)": "轉帳金額（電子代幣）",
  "Number (Transfer From)": "電話號碼（轉自）",
  "Name (Transfer From)": "姓名（轉自）",
  "Member ID (Transfer From)": "會員ID（轉自）",
  "Number (Transfer To)": "電話號碼（轉給）",
  "Name (Transfer To)": "姓名（轉給）",
  "Member ID (Transfer To)": "會員ID（轉給）",
  "Grant Date": "給予日期",
  "Claim Date": "使用日期",
  "Member Details Report": "會員詳情報告",
  "Transaction Status": "交易狀態",
  "Token Reload": "儲值電子代幣",
  "Token Transfer": "電子代幣轉賬",
  "Voucher History": "優惠券歷史記錄",
  "TOKEN": "電子代幣",
  "Message Sent": "發送的訊息",
  "Date Sent": "發送日期",
  "Remaining SMS Credit": "簡訊餘額",
  "Store": "商店",
  "Total Registered Users": "註冊用戶總數",
  "User registered but no transaction record": "用戶已註冊但無交易紀錄",
  "Registered": "已註冊",
  "User spending is less than": "用戶花費小於",
  "Active": "活躍",
  "User spending is from": "用戶花費從",
  "until": "至",
  "Tier 1": "1 級",
  "User spending is": "用戶花費",
  "and above": "或以上",
  "Tier 2": "2 級",
  "Average spending in each transaction": "每筆交易的平均花費",
  "Average Spending": "平均花費",
  "Total number of transactions": "交易總數",
  "Total Transactions": "總交易量",
  "Number of vouchers used in all the transactions": "所有交易中使用的優惠劵數量",
  "Voucher Claimed": "使用優惠券數",
  "Total number of washer machine transactions": "洗衣機交易總數",
  "Washer Usage": "洗衣機使用次數",
  "Total number of dryer machine transactions": "烘乾機交易總數",
  "Dryer Usage": "烘乾機使用次數",
  "User Name": "用戶名",
  "e-Token Spent": "花費的電子代幣",
  "e-Token Detailed Report": "電子代幣詳細報告",
  "e-Token Purchase History": "電子代幣購買歷史記錄",
  "Select Purchase Date": "選擇購買日期",
  "Outlet Name": "店家名稱",
  "Total number of e-token used in all the transactions": "所有交易中使用的電子代幣總數",
  "Total e-Token Collected": "收集到的電子代幣總額",
  "Total number of e-token used in washer machine transactions": "所有洗衣機交易中使用的電子代幣總數",
  "Washer e-Token Collected": "收集到的洗衣機電子代幣總額",
  "Total number of e-token used in dryer machine transactions": "所有烘乾機交易中使用的電子代幣總數",
  "Dryer e-Token Collected": "收集到的烘乾機電子代幣總額",
  "Vending Machine e-Token Collected": "收集到的自動販賣機電子代幣總額",
  "Purchase History": "購買記錄",
  "All": "全部",
  "Most Bought e-Token Package": "最受歡迎的電子代幣配套",
  "for": "對於",
  "Tokens": "電子代幣",
  "Total Earned from users buying e-Tokens": "用戶購買電子代幣的總收入",
  "Total e-Tokens Bought from you": "從您購買的電子代幣總數",
  "Join Date": "加入日期",
  "Channel": "頻道",
  "Tier": "等級",
  "Referrer": "邀請者",
  "Referrals": "邀請人数",
  "Number of transactions for last 7 days": "近7天的交易數",
  "Number of Usage (in week)": "使用次數（週）",
  "Number of transactions for last 1 month": "近1個月的交易數",
  "Number of Usage (in month)": "使用次數（月）",
  "Total amount spent in all the transactions": "所有交易花費的總金額",
  "Total Spent": "總花費",
  "Last Transaction Date": "最後交易日期",
  "Number of vouchers collected": "領取優惠券數量",
  "Voucher Collected": "優惠劵領取數",
  "Number of vouchers used": "使用優惠券數量",
  "Voucher Spent": "優惠券使用數",
  "Washer Used": "洗衣機使用次數",
  "Dryer Used": "烘乾機使用次數",
  "Total number of e-Token spent in all the transactions": "所有交易中花費的電子代幣總數",
  "Total number of stamps collected": "收集的印章總數",
  "Total Stamps": "印章總數",
  "Select Join Date": "選擇加入日期",
  "Select Grant Date": "選擇給予日期",
  "Amount": "價值",
  "The image size is over 2MB": "圖片大小超過2MB",
  "Duplicate language selected": "您選擇了重複的語言",
  "Are you sure you want to add FAQ?": "您確定要新增常見問題嗎？",
  "FAQ added successfully": "常見問題添加成功",
  "FAQ Group added successfully": "常見問題組添加成功",
  "Please provide the faq with the default language": "請提供預設語言的常見問題",
  "Add FAQ": "新增常見問題",
  "Default Language": "預設語言",
  "Select Default Language": "選擇預設語言",
  "Image (Optional)": "圖片（可選）",
  "max": "最大",
  "Question": "問題",
  "Select Language": "選擇語言",
  "Remove": "移除",
  "Answer": "回答",
  "Add Translation": "新增翻譯",
  "Are you sure you want to add FAQ Group?": "您確定要新增常見問題組嗎？",
  "Please provide the faq group with the default language": "請為常見問題組提供預設語言",
  "Add FAQ Group": "新增常見問題組",
  "Title": "標題",
  "Title Language": "標題語言",
  "Please fill in the title": "請填寫標題",
  "Please fill in the description": "請填寫描述",
  "Please fill in the short description": "請填寫簡短的描述",
  "Please select the end date for your news": "請選擇消息的結束日期",
  "Please provide the news with the default language": "請提供預設語言的消息",
  "Please provide the banner image": "請提供橫幅圖片",
  "Please provide the news image": "請提供消息圖片",
  "Are you sure you want to add news?": "您確定要新增消息嗎？",
  "News added successfully": "消息添加成功",
  "Please fill in all the required fields before submit": "請在提交前填寫所有必填選項",
  "Add News": "新增消息",
  "Banner Image": "橫幅圖片",
  "News Image": "消息圖片",
  "Banner": "橫幅",
  "aspect ratio": "縱橫比",
  "Image": "圖片",
  "Display in": "顯示於",
  "Inbox Page": "收件箱頁面",
  "Promotion Banner": "促銷橫幅",
  "Select Period: (optional)": "選擇期間：（可選）",
  "Short Description": "簡短的介紹",
  "Your theme has been updated successfully": "您的主題已成功更新",
  "Default Theme": "預設主題",
  "Change Logo": "更改標誌",
  "REMOVE LOGO": "移除標誌",
  "Sms credit used up": "簡訊額度已用完",
  "Please top up your sms credit": "請儲值您的簡訊餘額",
  "Please": "請",
  "Again": "多一次",
  "Welcome": "歡迎",
  "Ranking": "排行榜",
  "Select Year": "選擇年份",
  "Missing Field": "選項未填",
  "Please select can be used for which type of transaction": "請選擇可用於哪種類型的交易",
  "Please fill in the start date and end date": "請填寫開始日期和結束日期",
  "Discount amount should be more than 0": "折扣金額應大於0",
  "Redeem per user should be more than 0": "每個用戶兌換次數應大於0",
  "Redeem per day should be more than 0": "每日兌換次數必須大於0",
  "Your discount code have edited successfully": "您的優惠碼已編輯成功",
  "Your discount code have added successfully": "您的優惠碼已添加成功",
  "Delete this entry?": "刪除此條目？",
  "Your discount code have deleted successfully": "您的優惠碼已刪除成功",
  "Created Date": "創建日期",
  "Discount code": "優惠碼",
  "General Discount Code": "通用優惠碼",
  "Unique Discount Code": "獨特優惠碼",
  "Start Date": "開始日期",
  "End Date": "結束日期",
  "Redeem Per User": "每個用戶兌換次數",
  "Redeem Per Day": "每日兌換次數",
  "Add Discount Code": "新增優惠碼",
  "Generate Discount Code": "生成优惠码",
  "No Discount Code": "没有優惠碼",
  "Edit Discount Code": "編輯優惠碼",
  "Select Period": "選擇期間",
  "Redeem per user": "每個用戶兌換次數",
  "How many times the discount code can be used for each user": "每個使用者可以使用優惠碼的次數",
  "Redeem per day": "每日兌換次數",
  "How many times the discount code can be used in one day": "優惠碼一天內可以使用幾次",
  "If ticked, the discount code can apply to washer machine transaction": "如果勾選，優惠碼可應用於洗衣機交易",
  "If ticked, the discount code can apply to dryer machine transaction": "如果勾選，優惠碼可應用於烘乾機交易",
  "If ticked, the discount code can apply to Drop n Go transaction": "如果勾選，優惠碼可應用於Drop n Go交易",
  "If ticked, the discount code can apply to vending machine transaction": "若勾選，折扣碼可用於自動販賣機交易",
  "If ticked, the discount code can apply to detergent vending machine transaction": "若勾選，折扣碼可用於洗衣精販賣機交易",
  "If ticked, the discount code can apply to car wash transaction": "若勾選，折扣碼可用於洗車交易",
  "The user enter the discount code": "用戶輸入優惠碼",
  "in the payment page will get": "在支付頁面會得到",
  "discount": "折扣",
  "The discount code only can be used start from {{ start_date }} until {{ end_date }}": "優惠碼只能在 {{ start_date }} 至 {{ end_date }} 期間使用",
  "Every user only can use the discount code {{ redeem_per_user }} times": "每個用戶只能使用優惠碼 {{ redeem_per_user }} 次",
  "Every user only can use {{ redeem_per_user }} discount code from this batch of code": "每個使用者只能使用這批優惠碼中的 {{ redeem_per_user }} 個優惠碼",
  "Only {{ redeem_per_day }} transactions can use the discount code in one day": "一天內只有 {{ redeem_per_day }} 筆交易可以使用優惠碼",
  "The discount code only can be used for washer machine": "優惠碼僅適用於洗衣機",
  "The discount code only can be used for dryer machine": "優惠碼僅適用於烘乾機",
  "The discount code only can be used for Drop n Go transaction": "優惠碼僅適用於Drop n Go交易",
  "The discount code only can be used for vending machine transaction": "折扣碼僅可用於自動販賣機交易",
  "The discount code only can be used for detergent vending machine transaction": "折扣碼僅可用於洗衣精販賣機交易",
  "The discount code only can be used for car wash transaction": "折扣碼僅可用於洗車交易",
  "The discount code can be used for washer machine or Drop n Go transaction": "優惠碼可用於洗衣機或 Drop n Go 交易",
  "The discount code can be used for dryer machine or Drop n Go transaction": "優惠碼可用於烘乾機或 Drop n Go 交易",
  "The discount code can be used for washer machine, dryer machine or Drop n Go transaction": "優惠碼可用於洗衣機、烘乾機或 Drop n Go 交易",
  "The discount code can be used for washer or dryer machine": "優惠碼可用於洗衣機或烘乾機",
  "The discount code can be used for washer machine or vending machine transaction": "折扣碼可用於洗衣機或自動販賣機交易",
  "The discount code can be used for washer machine or detergent vending machine transaction": "折扣碼可用於洗衣機或洗衣精販賣機交易",
  "The discount code can be used for washer machine or car wash transaction": "折扣碼可用於洗衣機或洗車交易",
  "The discount code can be used for dryer machine or vending machine transaction": "折扣碼可用於烘乾機或自動販賣機交易",
  "The discount code can be used for dryer machine or detergent vending machine transaction": "折扣碼可用於烘乾機或洗衣精販賣機交易",
  "The discount code can be used for dryer machine or car wash transaction": "折扣碼可用於烘乾機或洗車交易",
  "The discount code can be used for vending machine or Drop n Go transaction": "折扣碼可用於自動販賣機或Drop n Go交易",
  "The discount code can be used for detergent vending machine or Drop n Go transaction": "折扣碼可用於洗衣精販賣機或Drop n Go交易",
  "The discount code can be used for car wash or Drop n Go transaction": "折扣碼可用於洗車或Drop n Go交易",
  "The discount code can be used for vending machine or detergent vending machine transaction": "折扣碼可用於自動販賣機或洗衣精販賣機交易",
  "The discount code can be used for vending machine or car wash transaction": "折扣碼可用於自動販賣機或洗車交易",
  "The discount code can be used for detergent vending machine or car wash transaction": "折扣碼可用於洗衣精販賣機或洗車交易",
  "The discount code can be used for washer machine, dryer machine or vending machine transaction": "折扣碼可用於洗衣機、烘乾機或自動販賣機交易",
  "The discount code can be used for washer machine, dryer machine or detergent vending machine transaction": "折扣碼可用於洗衣機、烘乾機或洗衣精販賣機交易",
  "The discount code can be used for washer machine, dryer machine or car wash transaction": "折扣碼可用於洗衣機、烘乾機或洗車交易",
  "The discount code can be used for washer machine, vending machine or Drop n Go transaction": "折扣碼可用於洗衣機、自動販賣機或Drop n Go交易",
  "The discount code can be used for washer machine, detergent vending machine or Drop n Go transaction": "折扣碼可用於洗衣機、洗衣精販賣機或Drop n Go交易",
  "The discount code can be used for washer machine, car wash or Drop n Go transaction": "折扣碼可用於洗衣機、洗車或Drop n Go交易",
  "The discount code can be used for washer machine, vending machine or detergent vending machine transaction": "折扣碼可用於洗衣機、自動販賣機或洗衣精販賣機交易",
  "The discount code can be used for washer machine, vending machine or car wash transaction": "折扣碼可用於洗衣機、自動販賣機或洗車交易",
  "The discount code can be used for washer machine, detergent vending machine or car wash transaction": "折扣碼可用於洗衣機、洗衣精販賣機或洗車交易",
  "The discount code can be used for dryer machine, vending machine or Drop n Go transaction": "折扣碼可用於烘乾機、自動販賣機或Drop n Go交易",
  "The discount code can be used for dryer machine, detergent vending machine or Drop n Go transaction": "折扣碼可用於烘乾機、洗衣精販賣機或Drop n Go交易",
  "The discount code can be used for dryer machine, car wash or Drop n Go transaction": "折扣碼可用於烘乾機、洗車或Drop n Go交易",
  "The discount code can be used for dryer machine, vending machine or detergent vending machine transaction": "折扣碼可用於烘乾機、自動販賣機或洗衣精販賣機交易",
  "The discount code can be used for dryer machine, vending machine or car wash transaction": "折扣碼可用於烘乾機、自動販賣機或洗車交易",
  "The discount code can be used for dryer machine, detergent vending machine or car wash transaction": "折扣碼可用於烘乾機、洗衣精販賣機或洗車交易",
  "The discount code can be used for vending machine, detergent vending machine or Drop n Go transaction": "折扣碼可用於自動販賣機、洗衣精販賣機或Drop n Go交易",
  "The discount code can be used for vending machine, car wash or Drop n Go transaction": "折扣碼可用於自動販賣機、洗車或Drop n Go交易",
  "The discount code can be used for detergent vending machine, car wash or Drop n Go transaction": "折扣碼可用於洗衣精販賣機、洗車或Drop n Go交易",
  "The discount code can be used for vending machine, detergent vending machine or car wash transaction": "折扣碼可用於自動販賣機、洗衣精販賣機或洗車交易",
  "The discount code can be used for washer machine, dryer machine, vending machine or Drop n Go transaction": "折扣碼可用於洗衣機、烘乾機、自動販賣機或Drop n Go交易",
  "The discount code can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction": "折扣碼可用於洗衣機、烘乾機、自動販賣機或洗衣精販賣機交易",
  "The discount code can be used for washer machine, dryer machine, vending machine or car wash transaction": "折扣碼可用於洗衣機、烘乾機、自動販賣機或洗車交易",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine or car wash transaction": "折扣碼可用於洗衣機、烘乾機、洗衣精販賣機或洗車交易",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or Drop n Go transaction": "折扣碼可用於洗衣機、自動販賣機、洗衣精販賣機或Drop n Go交易",
  "The discount code can be used for washer machine, vending machine, car wash or Drop n Go transaction": "折扣碼可用於洗衣機、自動販賣機、洗車或Drop n Go交易",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or car wash transaction": "折扣碼可用於洗衣機、自動販賣機、洗衣精販賣機或洗車交易",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "折扣碼可用於烘乾機、自動販賣機、洗衣精販賣機或Drop n Go交易",
  "The discount code can be used for dryer machine, vending machine, car wash or Drop n Go transaction": "折扣碼可用於烘乾機、自動販賣機、洗車或Drop n Go交易",
  "The discount code can be used for dryer machine, detergent vending machine, car wash machine or Drop n Go transaction": "折扣碼可用於烘乾機、洗衣精販賣機、洗車機或Drop n Go交易",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or car wash transaction": "折扣碼可用於烘乾機、自動販賣機、洗衣精販賣機或洗車交易",
  "The discount code can be used for vending machine, detergent vending machine, car wash or Drop n Go transaction": "折扣碼可用於自動販賣機、洗衣精販賣機、洗車或Drop n Go交易",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "折扣碼可用於洗衣機、烘乾機、自動販賣機、洗衣精販賣機或Drop n Go交易",
  "The discount code can be used for washer machine, dryer machine, vending machine, car wash or Drop n Go transaction": "折扣碼可用於洗衣機、烘乾機、自動販賣機、洗車或Drop n Go交易",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine, car wash or Drop n Go transaction": "折扣碼可用於洗衣機、烘乾機、洗衣精販賣機、洗車或Drop n Go交易",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or car wash transaction": "折扣碼可用於洗衣機、烘乾機、自動販賣機、洗衣精販賣機或洗車交易",
  "The discount code can be used for washer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "折扣碼可用於洗衣機、自動販賣機、洗衣精販賣機、洗車或Drop n Go交易",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "折扣碼可用於烘乾機、自動販賣機、洗衣精販賣機、洗車或Drop n Go交易",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "折扣碼可用於洗衣機、烘乾機、自動販賣機、洗衣精販賣機、洗車或Drop n Go交易",
  "The discount code only can be used after user spending {{ currency }} {{ pay_and_use_amount }}": "優惠碼必須在消費滿{{ currency }} {{ pay_and_use_amount }}後才能使用",
  "Are you sure you want to edit FAQ?": "您確定要編輯常見問題嗎？",
  "FAQ updated successfully": "常見問題更新成功",
  "Edit FAQ": "編輯常見問題",
  "Are you sure you want to edit FAQ Group?": "您確定要編輯常見問題組嗎？",
  "FAQ Group updated successfully": "常見問題組更新成功",
  "Edit FAQ Group": "編輯常見問題組",
  "Are you sure you want to edit news?": "您確定要編輯消息嗎？",
  "News edit successfully": "消息編輯成功",
  "Edit News": "編輯消息",
  "All the FAQ under this group will be deleted. Are you sure you want to delete FAQ Group?": "該組下的所有常見問題將被刪除。您確定要刪除常見問題組嗎？",
  "FAQ Group deleted successfully": "常見問題組刪除成功",
  "FAQ List": "常見問題列表",
  "NO FAQ GROUP": "沒有常見問題組",
  "FAQ Group": "常見問題組",
  "Are you sure you want to delete FAQ?": "您確定要刪除常見問題嗎？",
  "FAQ deleted successfully": "常見問題刪除成功",
  "NO FAQs": "沒有常見問題",
  "FAQ": "常見問題",
  "Easy": "便利",
  "Fast Laundromate": "快速洗衣店",
  "Smart Laundry Management System": "智慧洗衣管理系統",
  "Enter your username and password to login": "請輸入登入用戶名和密碼",
  "Username": "用戶名",
  "Are you sure you want to delete news?": "您確定要刪除消息嗎？",
  "News deleted successfully": "消息刪除成功",
  "NO NEWS": "沒有消息",
  "The referral setting has been updated successfully!": "邀請碼設定已更新成功！",
  "Number of Stamp": "印章數量",
  "Number of Washer Stamp": "洗衣機印章數量",
  "Number of Dryer Stamp": "烘乾機印章數量",
  "Enable Referral Feature?": "開啟邀請碼功能嗎？",
  "Are you sure you want to delete the tier setting?": "您確實要刪除此等級設定嗎？",
  "Minimum referee transaction amount for referrer to get referral rewards": "邀請者獲得邀請獎勵的最低交易金額",
  "Maximum number of reward within this tier": "此等級內的最大獎勵數量",
  "Maximum number of reward can get from same user": "從同一用戶可獲得的最大獎勵數量",
  "Point Grant Type": "積分授予類型",
  "Select Point Grant Type": "選擇積分授予類型",
  "Token Grant Type": "電子代幣授予類型",
  "Select Token Grant Type": "選擇電子代幣授予類型",
  "Add Tier": "添加等級",
  "Stamp": "印章",
  "If ticked, the system will give stamp to user": "如果勾選，系統將會給用戶印章",
  "If ticked, the system will give e-Token to user": "如果勾選，系統將給用戶電子代幣",
  "If ticked, the system will give voucher to user": "如果勾選，系統將給用戶優惠券",
  "Number of E-Token": "電子代幣數量",
  "Reward Giveaway": "獎勵贈品",
  "Which type of reward you want to give to customer?": "您想給予客戶哪種類型的獎勵？",
  "For machine uses (required)": "用於機器用途（必選）",
  "leave blank if no expiry date": "如果沒有到期日則留空",
  "Remarks": "備註",
  "Reward": "獎勵",
  "Please fill in all the required field. (Title, description, and amount must be more than 0)": "請填寫所有必填選項。 （標題、描述、金額必須大於0）",
  "Checkbox required": "需要勾選複選框",
  "Must select voucher can be used for washer, dryer or package": "必須選擇優惠券可用於洗衣機，烘乾機或配套",
  "How many e-token?": "多少個電子代幣？",
  "Number of e-Token": "電子代幣數量",
  "Token value must be more than 0": "電子代幣金額必須大於0",
  "STAMP": "印章",
  "Please fill in at least one of the required field": "請填寫至少一個必填選項",
  "The value must be more than 0": "該值必須大於 0",
  "How many times rewarded to user": "給用戶多少次獎勵",
  "Rewarded Times": "獎勵次數",
  "How many times rewarded voucher to user": "給用戶多少次優惠券",
  "Voucher Rewarded (times)": "優惠券獎勵（次）",
  "How many times rewarded stamp to user": "給用戶多少次印章",
  "Stamps Rewarded (times)": "印章獎勵（次）",
  "Total number of washer stamps rewarded to user": "獎勵給用戶的洗衣機印章總數",
  "Washer Stamps Granted (stamp)": "給予的洗衣機印章（印章）",
  "Total number of dryer stamps rewarded to user": "獎勵給用戶的烘乾機印章總數",
  "Dryer Stamps Granted (stamp)": "給予的烘乾機印章（印章）",
  "How many times rewarded e-Token to user": "給用戶多少次電子代幣",
  "e-Token Rewarded (times)": "電子代幣獎勵（次）",
  "Total number of e-Token rewarded to user": "獎勵給用戶的電子代幣總數",
  "Total e-Token Granted (token)": "給予的電子代幣總數（電子代幣）",
  "Point Rewarded (times)": "積分獎勵（次）",
  "How many times rewarded point to user": "給用戶獎勵積分幾次",
  "Total Point Granted (point)": "總積分獎勵（積分）",
  "Total number of point rewarded to user": "獎勵給用戶的積分總數",
  "Point Amount": "積分數量",
  "Reward History": "獎勵歷史",
  "Are you sure you want to change how the stamping mechanics works?": "您確定要更改印章機制的運作方式嗎？",
  "The stamping mechanics setting has updated successfully!": "印章機制設定已更新成功！",
  "The voucher setting has been updated successfully!": "優惠券設定已更新成功！",
  "Mechanics Settings": "印章機制設置",
  "Minimum transaction amount for getting stamp": "獲得印章的最低交易金額",
  "Select User Stamping Mechanic": "選擇使用者的印章機制",
  "Separated Stamping": "分開印章",
  "Combined Stamping": "綜合印章",
  "Stamp for?": "印章方式？",
  "Both": "兩者",
  "Washer Only": "僅洗衣機",
  "Dryer Only": "僅烘乾機",
  "Separated Stamping = Different washer and dryer stamp collection. (example: Using Washer will gain 1 washer's stamp, and Dryer will gain 1 dryer stamp)": "分開印章 = 不同的洗衣機和烘乾機印章收集。 （例如：使用洗衣機將獲得1個洗衣機印章，使用烘乾機將獲得1個烘乾機印章）",
  "Combined Stamping = Washer and dryer has the same collection. (example: Using Washer or Dryer will gain 1 stamp)": "綜合印章 = 洗衣機和烘乾機有相同的印章收集。 （例如：使用洗衣機或烘乾機將可獲得1個印章）",
  "Stamp for": "印章方式",
  "User will be able to collect both washer stamp and dryer stamp": "用戶將能夠收集洗衣機印章和烘乾機印章",
  "User will only able to collect Washer stamp": "用戶只能收集洗衣機印章",
  "User will only able to collect Dryer stamp": "用戶只能收集烘乾機印章",
  "Registration": "註冊",
  "Birthday": "生日",
  "Please choose at least one payment method": "請至少選擇一種付款方式",
  "Please choose at least one member or non-member payment": "請至少選擇一位會員或非會員付款",
  "Are you sure you want to change the payment setting?": "您確定要更改付款設定嗎？",
  "The payment setting has updated successfully!": "付款設定已更新成功！",
  "Invalid input": "不正確輸入",
  "The price and token must be more than 0": "價格和電子代幣必須大於0",
  "Maximum number of purchase must be more than 0": "最多購買的次數必須大於0",
  "Point amount must be more than 1": "積分數量必須大於 1",
  "Added a new Token Bundle Package": "新增了新的電子代幣配套",
  "Bundle deleted successfully!": "配套刪除成功！",
  "Reload voucher setting have edited successfully!": "儲值優惠劵設定已編輯成功！",
  "Added on": "添加於",
  "remove": "移除",
  "edit": "編輯",
  "NO PACKAGES ON SALES": "沒有銷售配套",
  "Point Settings": "積分設定",
  "Enable Loyalty Point": "啟用積分",
  "Point Name": "積分名稱",
  "Number Of Point Equals To": "積分數量同等於",
  "If ticked, the point will have expired date": "如果勾選，積分將過期",
  "Point Lifespan": "積分壽命",
  "months": "月",
  "Minimum Transaction Amount To Get Point": "取得積分的最低交易金額",
  "Point Grant Amount": "積分贈予數量",
  "Point Grant Period": "積分贈予期間",
  "Optional": "自選的",
  "Drop n Go Eligibility": "Drop n Go 資格",
  "If ticked, Drop n Go transaction will get the point": "如果勾選，Drop n Go 交易將獲得積分",
  "Washer Eligibility": "洗衣機資格",
  "If ticked, washer transaction will get the point": "如果勾選，洗衣機交易將獲得積分",
  "Dryer Eligibility": "烘乾機資格",
  "If ticked, dryer transaction will get the point": "如果勾選，烘乾機交易將獲得積分",
  "Point settings updated successfully!": "積分設定更新成功！",
  "Point Eligibility": "積分資格",
  "If ticked, the system will give point to user when user reload token successfully": "如果勾選，當用戶成功儲值電子代幣時系統會給用戶積分",
  "{{ point_amount }} point will be given after user reload token successfully": "用戶成功充值電子代幣後將獲得 {{ point_amount }} 積分",
  "Payment Settings": "付款設定",
  "Select Payment Method": "選擇付款方式",
  "Enable E-Payment?": "啟用電子支付嗎？",
  "Enable Token Currency?": "啟用電子代幣嗎？",
  "Enable Cash Payment?": "啟用現金支付嗎？",
  "Enable QR Payment?": "啟用QR支付嗎？",
  "Member and Non-Member Settings": "會員和非會員設置",
  "Enable Member Payment?": "啟用會員支付？",
  "Enable Non-Member Payment?": "啟用非會員支付？",
  "Promotion Settings": "促銷設定",
  "Enable Non Member Promotion?": "啟用非會員促銷嗎？",
  "Enable Notification When Cycle Done?": "循環完成後啟用通知嗎？",
  "SMS charges": "簡訊收費",
  "SMS Settings": "簡訊設定",
  "Enable Free Sms For Members": "启用会员免费短信",
  "If enable notification, user can choose either receive email or sms when complete washing or drying": "如果啟用通知，用戶可以選擇在完成洗滌或烘乾時接收電子郵件或簡訊",
  "If user choose sms, non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "如果用戶選擇短信，非會員必須支付額外的{{ currency }}{{ sms_notification_amount }}短信費用",
  "If user choose sms, member and non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "如果用戶選擇短信，會員和非會員必須支付額外的{{ currency }}{{ sms_notification_amount }}短信費用",
  "Add Package": "添加配套",
  "Edit e-Token Package": "編輯電子代幣配套",
  "Add e-Token Package": "添加電子代幣配套",
  "Please only input numberic value to prevent any bugs.": "請僅輸入數字值，以防止任何錯誤。",
  "Price": "價格",
  "If ticked, the system will limit the number of purchase": "如果勾選，系統會限制購買次數",
  "Limit Number of Purchase": "限制購買次數",
  "Number of maximum purchase": "最多的購買次數",
  "Reload Voucher": "儲值優惠券",
  "If ticked, the system will give voucher to user when user reload token successfully": "如果勾選，當用戶儲值成功後，系統將會贈送使用者優惠券",
  "If ticked, the system will give voucher repeatly": "如果勾選，系統會重複贈送優惠券",
  "Recurring": "反覆",
  "Total number of voucher given to user": "給予用戶的優惠券總數",
  "Period for giving next voucher": "發放下一張優惠券的期限",
  "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens": "{{ currency }}{{ price }} 的電子代幣配對將獲得 {{ numberOfToken }} 個電子代幣",
  "Each user only can purchase {{ max_purchase }} times for the token package": "每個用戶只能購買{{ max_purchase }}次此電子代幣配套",
  "Voucher will be given after user reload token successfully": "用戶儲值成功後將獲得優惠券",
  "Voucher will not given after user reload tokens successfully": "用戶儲值成功後將不會獲得優惠券",
  "The voucher will be expired after {{ voucher_duration }} days": "優惠券將於 {{ voucher_duration }} 天後過期",
  "The voucher will not expired": "優惠券不會過期",
  "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount": "總共 {{ recurring_number }} 張優惠券將贈送給用戶，每張優惠券將有折扣",
  "Edit Package": "編輯配套",
  "Age": "年齡",
  "Total number of vouchers collected": "已領取優惠券總數",
  "Vouchers Acquired": "已獲得優惠券",
  "Total amount spent in washer machine transactions": "洗衣機交易總金額",
  "Total Washer Payment": "洗衣機總花費",
  "Total amount spent in dryer machine transactions": "烘乾機交易總金額",
  "Total Dryer Payment": "烘乾機總花費",
  "Total amount spent in all transactions": "所有交易花費的總金額",
  "Total Payment": "付款總額",
  "report": "報告",
  "Total amount spent for buying e-Token": "購買電子代幣的總金額",
  "Total number of e-Token purchased": "購買的電子代幣總數",
  "Total e-Token Purchased (Tokens)": "購買的電子代幣總數（電子代幣）",
  "Total number of e-Token used in washer machine transactions": "洗衣機交易中使用的電子代幣總數",
  "Washer Payment (Tokens)": "洗衣機付款金額（電子代幣）",
  "Total number of e-Token used in dryer machine transactions": "烘乾機交易中使用的電子代幣總數",
  "Dryer Payment (Tokens)": "烘乾機付款金額（電子代幣）",
  "Total number of e-Token used in all the transactions": "所有交易中使用的電子代幣總數",
  "Total Payment (Tokens)": "付款總金額（電子代幣）",
  "Number of washer stamp collected currently": "目前收集的洗衣機印章數量",
  "Number of dryer stamp collected currently": "目前收集的烘乾機印章數量",
  "User Phone Number / Member ID / Email": "用戶電話號碼/會員ID/電子郵件",
  "Example: 0123456789,A123456": "例如: 0123456789,A123456",
  "SEARCH": "搜尋",
  "Total Users Registered": "註冊用戶總數",
  "Total Active Outlets": "店家總數",
  "Total Vouchers Given": "給予的優惠券總數",
  "Total Transaction Counts": "總交易量",
  "Total User Stamps Collected": "用戶收集的印章總數",
  "Distributor Login": "經銷商登入",
  "Client Login": "客戶登入",
  "Kiosk Login": "自助服務終端登入",
  "Promotion": "促銷",
  "Please select operator": "請選擇營運商",
  "Please select distributor": "請選擇經銷商",
  "Select Operator": "選擇營運商",
  "Select Distributor": "選擇經銷商",
  "User can login or skip to payment without login to make the payment": "用戶可以登入或無需登入即可跳轉至付款頁面進行支付",
  "User have to login only can make the payment": "用戶必須登入才可以付款",
  "User only can skip to payment without login to make the payment": "用戶只能直接跳至付款頁面進行付款（無登入功能）",
  "Only CSV file is accepted": "僅接受 CSV 文件",
  "The user and the balance have updated": "用戶和餘額已更新",
  "Register Time": "註冊時間",
  "Upload User CSV file": "上傳用戶 CSV 文件",
  "Sample CSV file": "範例 CSV 文件",
  "Please follow the CSV file format": "請遵循 CSV 檔案格式",
  "User CSV file": "用戶 CSV 檔案",
  "Only CSV file (comma delimited) is support now": "現在僅支援 CSV 檔案（逗號分隔）",
  "Confirm uploaded data": "確認上傳的數據",
  "Operator": "營運商",
  "Distributor": "經銷商",
  "Refund By": "退款者",
  "Reward By": "獎勵者",
  "Number Of Voucher Code": "優惠券兌換碼數量",
  "Number Of Discount Code": "折扣碼數量",
  "New User Only": "僅限新用戶",
  "Minimum Transaction Amount To Redeem": "兌換最低交易金額",
  "Download": "下載",
  "Generate Voucher Code": "產生優惠券兌換碼",
  "Your voucher code is generating": "您的優惠券兌換碼正在生成",
  "Your discount code is generating": "您的折扣碼正在生成",
  "Voucher Code Settings": "優惠券兌換碼設定",
  "If ticked, the voucher code only can redeem in register page": "如果勾選，兌換碼只能在註冊頁面兌換",
  "If ticked, the user only can use the voucher after make a transaction": "如果勾選，用戶只能在交易後使用該優惠券",
  "If ticked, the user only can use the discount code after make a transaction": "如果勾選，用戶只能在交易後使用該優惠碼",
  "Expired Date Of Voucher Code": "優惠券兌換碼的失效日期",
  "Minimum Transaction Amount To Use Voucher": "使用優惠券的最低交易金額",
  "Minimum Transaction Amount To Use Code": "使用優惠碼的最低交易金額",
  "Max redemption per user in this batch voucher code": "此批次優惠券兌換碼中每位用戶的最大兌換次數",
  "Max redemption per user in this batch discount code": "此批次優惠碼中每位用戶的最大兌換次數",
  "Add Voucher": "增加優惠券",
  "Completed": "完成",
  "Voucher Code Report": "優惠券兌換碼報告",
  "Floating Token Report": "浮動電子代幣報告",
  "Floating Point Report": "浮動積分報告",
  "E-Payment Report": "電子支付報告",
  "Referral Reward History Report": "邀請碼獎勵歷史報告",
  "Redemption Date": "兌換日期",
  "Redemption Code": "兌換碼",
  "Select Redemption Date": "選擇兌換日期",
  "Select Voucher Type": "選擇優惠券類型",
  "Giveaway": "補償",
  "Select Name": "選擇名稱",
  "Amount must be more than 1": "金額必須大於1",
  "Payment method setting have updated successfully!": "付款方式設定已成功更新！",
  "Edit Payment Method": "編輯付款方式",
  "Minimum payment amount to include all the payment methods": "包含所有付款方式的最低付款金額",
  "Exclude Payment Method in Revenue Monster": "在 Revenue Monster 中排除的付款方式",
  "Welcome to": "歡迎來到",
  "Instruction": "操作說明",
  "Please select the machine": "請選擇機器",
  "Login your account": "登入您的帳戶",
  "Select the setting and make the payment": "選擇設定並付款",
  "Phone Number / Email": "電話號碼/電子郵件",
  "Reload & Transfer In": "儲值及轉入",
  "Usage & Transfer Out": "使用及轉出",
  "Usage": "使用",
  "Remaining": "剩余",
  "Gain": "獲得",
  "Type": "類型",
  "Order Date": "日期",
  "Pack Number": "包裹號碼",
  "Pack Details": "包裹詳情",
  "Size": "尺寸",
  "Mode": "模式",
  "Machine Payment": "機器支付總額",
  "DNG History": "DNG歷史",
  "Token History": "電子代幣歷史記錄",
  "Stamp History": "印章歷史記錄",
  "Staff Login": "員工登入",
  "Drop And Go Portal": "Drop And Go Portal",
  "Available Task": "可執行任務",
  "Completed Task": "已完成任務",
  "Task ID": "任務ID",
  "Task": "任務",
  "Start Task": "開始任務",
  "Select Machine": "選擇機器",
  "Start Machine": "啟動機器",
  "Reward To": "獎勵給",
  "Reward From": "獎勵來自",
  "Transaction Account": "交易帳戶",
  "Point": "積分",
  "POINT": "積分",
  "Number of Point": "積分數量",
  "Point History": "積分歷史",
  "Customer Name": "客戶姓名",
  "Number of Washer Transactions": "洗衣交易數量",
  "Number of Dryer Transactions": "烘乾交易數量",
  "Vouchers Redeemed": "兌換的優惠券",
  "Discount Code Redemption": "折扣碼兌換",
  "Total Spend": "總支出",
  "Select Outlet(s)": "選擇店鋪",
  "User Usage Report": "用戶使用報告",
  // cleanpro plus zh
  "Wash": "洗滌",
  "Dry": "烘乾",
  "Fold": "折疊",
  "Scan QR": "掃描二維碼",
  "Capacity": "容量",
  "Duration": "時長",
  "Custom duration": "自定義持續時間",
  "Choose duration": "選擇持續時間",
  "Select the correct amount on the machine after payment.": "付款後在機器上選擇正確的金額。",
  "Offers": "優惠",
  "Voucher Offers": "優惠券優惠",
  "Discount Code Offers": "折扣碼優惠",
  "An easier way to pay": "更簡單的支付方式",
  "Create account": "創建賬戶",
  "Login": "登錄",
  "By signing up, you agree to": "註冊即表示您同意",
  "Amount to Pay": "支付總額",
  "1 voucher selected": "已選擇 1 張優惠券",
  "No voucher selected": "未選擇優惠券",
  "credit": "點數",
  "Credits": "點數",
  "credits": "點數",
  "Credit balance": "點數餘額",
  "Please ensure that the machine door is shut & your laundry is inside.": "請確保機器門已關閉並且您的衣物在裡面。",
  "Insufficient balance": "餘額不足",
  "Topup now": "立即充值",
  "Copyright © {{ year }} Cleanpro Laundry Holdings Sdn Bhd (821842-P) All rights reserved.": "版權所有 © {{ year }} Cleanpro Laundry Holdings Sdn Bhd (821842-P) 保留所有權利。",
  "Good Evening!": "午安!",
  "Hello": "你好",
  "Wallet Balance": "錢包餘額",
  "Topup": "充值",
  "More details": "更多細節",
  "Collect 10 e-stamps to earn x1 FREE wash or dry voucher": "集齊 10 個電子印章即可獲得 x1 免費洗或乾優惠券",
  "For every wash or dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "您在我們這裡完成的每一次洗滌或烘乾循環，都將獲得一個電子印章。集齊 10 個，您就可以兌換一次免費的洗滌或烘乾週期。這是我們感謝您選擇 Cleanpro 的方式！",
  "For every wash cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "您在我們這裡完成的每一次洗滌循環，都將獲得一個電子印章。集齊 10 個，您就可以兌換一次免費的洗滌或烘乾週期。這是我們感謝您選擇 Cleanpro 的方式！",
  "For every dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "您在我們這裡完成的每一次烘乾循環，都將獲得一個電子印章。集齊 10 個，您就可以兌換一次免費的洗滌或烘乾週期。這是我們感謝您選擇 Cleanpro 的方式！",
  "Credits OFF": "點數折扣",
  "% OFF": "％ 折扣",
  "Valid Till": "有效期至",
  "Used On": "用於",
  "Expired On": "過期日期",
  "Available": "可用的",
  "Expired": "已過期",
  "Used": "已使用",
  "Promotions": "促銷活動",
  "Rewards": "獎勵",
  "Inbox": "收件箱",
  "Activities": "活動",
  "Support": "支持",
  "Active Rewards": "活躍獎勵",
  "Past Rewards": "過往獎勵",
  "Get rewarded for your loyalty with Cleanpro Plus Rewards!": "通過 Cleanpro Plus 獎勵獲得忠誠獎勵！",
  "Earn vouchers and redeem them for discounts, freebies and more. The more you use our services the more you save!": "賺取優惠券並將其兌換為折扣、免費贈品等。您使用我們的服務越多，您節省的越多！",
  "Up to 3 months history": "最近3個月的歷史記錄",
  "Filter": "篩選",
  "All Transactions": "所有交易",
  "Transactions": "交易",
  "Select amount to topup": "選擇充值金額",
  "Balance": "餘額",
  "You've just paid": "你剛剛付款",
  "Need help?": "需要幫忙？",
  "24-Hour Careline Number": "24 小時服務熱線號碼",
  "Email Us": "給我們發電子郵件",
  "Call Now": "現在打電話",
  "Email Now": "立即發送電子郵件",
  "Update name": "更新名稱",
  "Update email address": "更新電子郵件地址",
  "Update phone number": "更新電話號碼",
  "Change password": "更改密碼",
  "Change language": "改變語言",
  "User ID": "用戶號",
  "Let us know your feedback": "讓我們知道您的反饋",
  "Poor": "糟糕",
  "Good": "好的",
  "Leave addtional feedback here (optional)": "在此處留下其他反饋（可選)",
  "Submit feedback": "提交反饋",
  "Pay as guest": "以訪客身份付款",
  "Pay now": "現在付款",
  "Select voucher to use": "選擇要使用的優惠券",
  "Use voucher": "使用優惠券",
  "Total": "總共",
  "Transaction Type": "交易類型",
  "E-Token Topup": "電子代幣充值",
  "Credit Topup": "點數充值",
  "Credit topup": "點數充值",
  "Credit Transfer": "點數轉賬",
  "E-Token Transfer": "電子代幣轉賬",
  "Date/Time": "日期/時間",
  "Reference ID": "參考編號",
  "Status": "狀態",
  "Share Your Referral Code": "分享您的邀請碼",
  "cleanproReferralShortDesc": "將您的邀請碼分享給親朋好友，當完成交易後可免費獲得 {{ voucherAmount }} 積分。點擊以了解更多信息。",
  "Use": "使用",
  "dryer or washer": "烘乾機或洗衣機",
  "washer": "洗衣機",
  "dryer": "烘乾機",
  "dryer and washer": "烘乾機和洗衣機",
  "machine with the minimum spending of": "以最低消費",
  // "Welcome to Cleanpro Plus": "歡迎來到 Cleanpro Plus",
  // "Only scan, set & pay! An easier, more convenient way to pay with Cleanpro Plus! No need to download an app. Enjoy more rewards when you use Cleanpro Plus today! Tap to learn more.": "只需掃描、設置和支付！使用 Cleanpro Plus 支付更簡單、更方便的方式！無需下載應用程序。立即使用 Cleanpro Plus，享受更多獎勵！點擊以了解更多信息。",
  // "Cleanpro Pay Migration Notice": "Cleanpro Pay 遷移通知",
  // "Dear valued Cleanpro customers, please be informed that as of 22 June 2023, the Cleanpro Pay app will be upgraded and and no longer available for use. Tap to learn more.": "尊敬的 Cleanpro 客戶，請注意，自 2023 年 6 月 22 日起，Cleanpro Pay 應用程序將升級並不再可用。點擊以了解更多信息。",
  // "Answer simple questions and win credits for your next wash or dry! This contest is only available for selected outlets only. Tap to learn more.": "回答簡單的問題並為您的下一次洗滌或烘乾贏得點數！此競賽僅適用於指定的商店。點擊以了解更多信息。",
  // "The all-new Cleanpro Plus is a new payment method that includes loyalty features built into the app. The more you use our services and pay using Cleanpro Plus, the more you can save. With every transaction, you can earn rewards that will help you save on your next laundry expenses.": "全新的 Cleanpro Plus 是一種新的支付方式，包括內置於應用程序中的忠誠度功能。您使用我們的服務和使用 Cleanpro Plus 支付的次數越多，您節省的費用就越多。每筆交易，您都可以獲得獎勵，幫助您節省下一次洗衣費用。",
  // "To use Cleanpro Plus, simply scan the QR code on the machines and pay using your preferred credit/debit card or e-wallet. We hope that Cleanpro Plus will help simplify your laundry routine and give you more time for the things that matter.": "要使用 Cleanpro Plus，只需掃描機器上的二維碼並使用您首選的信用卡/借記卡或電子錢包付款。我們希望 Cleanpro Plus 能夠幫助簡化您的洗衣程序，讓您有更多時間處理重要的事情。",
  // "If you have any questions about Cleanpro Plus, please read our FAQ in the menu or contact our careline at +603 2770 0100 or email us at info@cleanprolaundry.com. Thank you for choosing Cleanpro.": "如果您對 Cleanpro Plus 有任何疑問，請閱讀菜單中的常見問題解答或致電 +603 2770 0100 聯繫我們的客服熱線或發送電子郵件至 info@cleanprolaundry.com。感謝您選擇 Cleanpro。",
  // "Dear valued Cleanpro customers, please be informed that as of 22 June 2023, the existing Cleanpro Pay mobile app will be upgraded and no longer available for use.": "尊敬的 Cleanpro 客戶，請注意，自 2023 年 6 月 22 日起，現有的 Cleanpro Pay 移動應用程序將升級並不再可用。",
  // "We are migrating to the all-new Cleanpro Plus. It is a new cashless payment method, without the need to download apps.": "我們正在遷移到全新的 Cleanpro Plus。這將是一種新的無現金支付方式，無需下載應用程序。",
  // "If you are the existing user of Cleanpro Pay, any of your remaining balance in the app will be transferred to your Cleanpro Plus account. You are required to use the same mobile number to sign up for Cleanpro Plus for balance transfer.": "如果您是 Cleanpro Pay 的現有用戶，您在應用程序中的任何餘額都將轉移到您的 Cleanpro Plus 帳戶。您需要使用相同的手機號碼註冊 Cleanpro Plus 進行餘額轉移。",
  // "If you need help on Cleanpro Plus, please feel free to call our careline at +603 2770 0100 or email us at info@cleanprolaundry.com": "如果您需要有關 Cleanpro Plus 的幫助，請隨時撥打我們的服務熱線 +603 2770 0100 或發送電子郵件至 info@cleanprolaundry.com",
  // "Answer simple questions and win credits for your next wash or dry!": "回答簡單的問題並為您的下一次洗滌或烘乾贏得點數！",
  // "Step 1 : Scan the Jawab & Gerenti Menang QR code in the participated outlets.": "第 1 步：在指定的商店裡掃描Jawab & Gerenti Menang 二維碼。",
  // "Step 2 : Answer 3 simple questions.": "第 2 步：回答 3 個簡單問題。",
  // "Step 3 : Submit and stand a chance to win prizes.": "第 3 步：提交並有機會贏取獎品。",
  // "Grand Prize :": "大獎：",
  // "x10 per outlet - 100 credits worth of vouchers in Cleanpro Plus": "每個分店 x10 - Cleanpro Plus 中的 RM100 點數優惠劵",
  // "Consolation Prize :": "安慰獎：",
  // "X25 per outlet - 50 credits worth of vouchers in Cleanpro Plus": "每個分店 X25 - Cleanpro Plus 中的 RM50 點數優惠劵",
  // "Participation prize:": "參與獎：",
  // "Every participants are eligible to receive a FREE 3 credits voucher (worth RM3) in Cleanpro Plus.": "每位參與者都有資格在 Cleanpro Plus 中免費獲得 3 個點數優惠券（價值 RM3）。",
  // "If you have any questions please don't hesitate to contact our careline at +603 2770 0100 or email us at info@cleanprolaundry.com. Thank you for choosing Cleanpro.": "如果您有任何疑問，請隨時撥打我們的服務熱線 +603 2770 0100 或發送電子郵件至 info@cleanprolaundry.com。感謝您選擇 Cleanpro。",
  "Payment Confirmation": "付款確認",
  "This campaign is only eligible for users who use the all-new Cleanpro Plus web application.": "此活動僅適用於使用全新 Cleanpro Plus 網絡應用程序的用戶。",
  "ONE e-stamp will be rewarded for each wash or dry cycle.": "每次洗滌或乾燥循環將獎勵一個電子印章。",
  "ONE e-stamp will be rewarded for each wash cycle.": "每個洗滌循環將獎勵一個電子印章。",
  "ONE e-stamp will be rewarded for each dry cycle.": "每個乾燥循環將獎勵一個電子印章。",
  "Regardless of the washer or dryer settings, the number of e-stamps being collected is the same.": "無論洗衣機或烘乾機設置如何，收集的電子印章數量都是相同的。",
  "The type of e-stamp collected is based on the services that you have used.": "您所收集的電子印章種類取決於你所使用的服務而定。",
  "Washing service will reward washer e-stamp and drying service will reward dryer e-stamp.": "洗滌服務將獎勵洗衣機電子印章，烘乾服務將獎勵烘乾機電子印章。",
  "Washing service will reward washer e-stamp.": "洗滌服務將獎勵洗衣機電子印章。",
  "Drying service will reward dryer e-stamp.": "烘乾服務將獎勵烘乾機電子印章。",
  "E-stamps will automatically be added to your account once the condition has been fulfilled.": "滿足條件後，電子印章將自動添加到您的帳戶中。",
  "There is no limit on how many e-stamps can be gathered in a single day. So long as you meet the requirements to collect the e-stamps.": "只要您符合收集電子印章的條件，您將獲得電子印章，一天內無收集電子印章數量限制",
  "The type of e-stamps that have been collected is final and cannot be changed.": "已收集的電子印章類型是最終的，不能更改。",
  "There is no expiration for the e-stamps; only till the discontinuation of the campaign.": "電子印章不會過期；直到活動停止為止。",
  "E-stamps do not have any currency value, and they cannot be converted to cash or credits.": "電子印章沒有任何貨幣價值，也不能兌換成現金或點數。",
  "This campaign is not applicable with any other ongoing promotions, offers, vouchers, and/or discounts provided by the participating outlets.": "此活動不適用於參與商店提供的任何其他正在進行的促銷、優惠、優惠券和/或折扣。",
  "These terms and conditions are subject to change at any time without prior notice.": "這些條款和條件可能隨時更改，恕不另行通知。",
  "Press START on the machine to begin washing.": "按機器上的START開始洗滌。",
  "Press START on the machine to begin drying.": "按機器上的START開始烘乾。",
  "Reminder": "提醒",
  "Remember to select the same settings you have paid for on the corresponding machine.": "請記住在相應的機器上選擇您已支付的相同設置。",
  "Please ensure that your laundry is inside the machine and door is properly shut.": "請確保您的衣物在機器內並且門已正確關閉。",
  "voucherCreditsOff": "折扣 {{currentVoucherAmount}} 點數",
  "voucherPercentageOff": "折扣 {{currentVoucherAmount}}%",
  "cleanproReferralFlatVoucher": "將您的 Cleanpro Plus 邀請碼分享給您的朋友和家人，即可獲得免費優惠劵！對於每個完成第一筆交易的成功推薦，您將獲得一張價值折扣 {{ referralVoucherAmount }} 貨幣的優惠劵。",
  "cleanproReferralRateVoucher": "將您的 Cleanpro Plus 邀請碼分享給您的朋友和家人，即可獲得免費優惠劵！對於每個完成第一筆交易的成功推薦，您將獲得一張價值 {{ referralVoucherAmount }}% 折扣的優惠劵。",
  "cleanproReferralTokenReward": "將您的 Cleanpro Plus 邀請碼分享給您的朋友和家人，即可獲得免費貨幣！對於每個完成第一筆交易的成功推薦，您將獲得免費的 {{ referralToken }} 貨幣。",
  "How to get & use code:": "如何獲取和使用邀請碼：",
  'Go to menu = icon and click “Refer friends”': '在菜單 = 圖標，然後單擊“推薦給朋友”',
  "Share with everyone who will likely to use Cleanpro Plus.": "與所有可能使用 Cleanpro Plus 的人分享。",
  "Referral Terms & Conditions:": "推薦條款和條件：",
  "When your friend or family register using your referral code, and completed a transaction (a minimum spending of {{ currency }}{{ referralTransactionAmount }}) , you will be rewarded automatically.": "當您的朋友或家人使用您的邀請碼註冊並完成交易（最低消費 {{ currency }}{{ referralTransactionAmount }}）時，您將自動獲得獎勵。",
  "cleanproNumberOfReferralReward": "您可以與任意數量的人分享，但每個用戶只能獲得 {{ numberOfReferral }} 次推薦獎勵。",
  "cleanproNumberOfReferral": "您可以與任意數量的人分享，但每個用戶只能收到 {{ numberOfReferral }} 張推薦優惠券。",
  "The voucher is valid for {{ duration }} days from the day voucher be given.": "優惠券自發放之日起 {{ duration }} 天內有效。",
  "The voucher is for customer use only and not for sale.": "優惠券僅供客戶使用，不得出售。",
  "We believe that your special day deserves a little extra sparkle! That's why we're thrilled to introduce our exclusive birthday rewards program just for you! Starting this year, and every year thereafter, we're giving away {{ currency }}{{ voucherAmount }} credit vouchers to you on your birthday.": "我們相信您的特殊日子值得額外閃耀！這就是為什麼我們很高興為您推出獨家生日獎勵計劃！從今年開始，之後的每一年，我們都會在您生日月份第一天贈送 {{ currency }}{{ voucherAmount }} 優惠券。",
  "cleanproBirthdayRateAmount": "我們相信您的特殊日子值得額外閃耀！這就是為什麼我們很高興為您推出獨家生日獎勵計劃！從今年開始，之後的每一年，我們都會在您生日月份第一天贈送 {{ voucherAmount }}% 優惠券。",
  "Make sure your account details include your birthdate. This way, we'll know exactly when to send you your special birthday surprise.": "請確保您的賬戶已填寫詳細信息包括您的生日。這樣，我們就能準確知道何時向您發送特別的生日驚喜。",
  "Birthday Voucher Terms & Conditions:": "生日禮券條款和條件：",
  "The voucher will be given on the first day of your birthday month.": "優惠券將在您生日月份的第一天發放。",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount.": "當您在付款時使用優惠劵，它會給您 {{ voucherAmount }} 貨幣（{{ currency }}{{ voucherAmount }}）折扣。",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }}% discount.": "當您在付款時使用優惠劵，它會給您 {{ voucherAmount }} %折扣。",
  "All vouchers is not valid with other ongoing promotions, discounts and offers.": "所有優惠券均不適用於當正在進行的促銷、折扣和優惠。",
  "Claim a complimentary wash and dry for every 10 e-stamps collected! We value your loyalty and want to reward you for choosing Cleanpro Plus. Tap to learn more.": "每收集 10 張電子印章，即可獲得免費清洗和烘乾服務！我們重視您的忠誠度，並希望獎勵您選擇 Cleanpro Plus。點擊以了解更多信息。",
  "cleanproStampFlat": "每收集 10 個電子印章，您就可以使用 Cleanpro Plus 申請高達 {{ voucherAmount }} 的免費洗或烘乾貨幣。讓您的洗衣程序不僅輕鬆無憂，而且收穫頗豐。",
  "cleanproStampRate": "每收集 10 個電子印章，您就可以使用 Cleanpro Plus 申請高達 {{ voucherAmount }}% 的折扣。讓您的洗衣程序不僅輕鬆無憂，而且收穫頗豐。",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "當您收集到 10 個洗滌印章時，優惠券將立即添加到您的獎勵頁面。您的電子印章計價器將在下次收集時歸零。下次洗衣時，在掃描二維碼頁面領取優惠券。",
  "A voucher will be instantly added to your Rewards page when you reach 10 drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "當您收集到 10 個烘乾印章時，優惠券將立即添加到您的獎勵頁面。您的電子印章計價器將在下次收集時歸零。下次洗衣時，在掃描二維碼頁面領取優惠券。",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes or drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "當您收集到 10 個洗滌或10個烘乾印章時，優惠券將立即添加到您的獎勵頁面。您的電子印章計價器將在下次收集時歸零。下次洗衣時，在掃描二維碼頁面領取優惠券。",
  "Terms & Conditions:": "條款和條件：",
  "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session.": "要賺取一個電子印章，您必須在每次會話中花費至少 {{ stampTransactionAmount }} 貨幣（{{ currency }}{{ stampTransactionAmount }}）。",
  "You will be automatically issued a voucher if you have collected 10 washer stamps.": "如果您收集了 10 張洗衣機印章，您將自動獲得一張優惠券。",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps.": "如果您收集了 10 張烘乾機印章，您將自動獲得一張優惠券。",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps or 10 washer stamps.": "如果您收集了 10 張洗衣機或10 張烘乾機印章，您將自動獲得一張優惠券。",
  "You will be automatically issued a voucher if you have collected 10 stamps.": "如果您收集了 10 張印章，您將自動獲得一張優惠券。",
  "The voucher is non-refundable and cannot be exchanged for cash; in part or in full.": "此禮券不可退款，亦不可兌換現金；部分或全部。",
  "This voucher is valid for single transaction only.": "此優惠劵僅適用於單次交易。",
  "General questions": "常見問題",
  "E-stamps collection": "電子印章",
  "Coin exchange machines": "硬幣兌換機",
  "Washer machines": "洗衣機",
  "Dryer machines": "烘乾機",
  "Paywave issues": "Paywave問題",
  "Cleanpro franchise": "Cleanpro特許經營權",
  "How can I wash my laundry using Cleanpro Plus?": "如何使用 Cleanpro Plus 洗滌衣物？",
  "Here are the steps to wash your laundry using Cleanpro Plus:": "以下是使用 Cleanpro Plus 洗滌衣物的步驟：",
  "Find an unoccupied washing machine in the store, and insert your laundry in the washer.": "在商店裡找一台無人使用的洗衣機，然後將要洗的衣服放入洗衣機。",
  "Select the desired temperature that you would like to use for your laundry.": "選擇您想用於洗衣的所需溫度。",
  "Using the scanner in the app, scan the QR code provided on the washing machine. Then select the same settings that you have pressed on the machine.": "使用應用程序中的掃描儀，掃描洗衣機上提供的二維碼。然後選擇您在機器上按下的相同設置。",
  'Tap on “Pay with credits” to pay the amount shown on the app.': '點擊“使用點數支付”以支付應用程序上顯示的金額。',
  "Once the payment has been accepted, press the START button on the washer machine.": "付款被接受後，按下洗衣機上的開始按鈕。",
  "After the washing cycle ends, you can just remove your laundry from the machine.": "洗滌週期結束後，您只需將衣物從機器中取出即可。",
  "How can I dry my laundry using Cleanpro Plus?": "如何使用 Cleanpro Plus 烘乾衣物？",
  "Here are the steps to dry your laundry using Cleanpro Plus:": "以下是使用 Cleanpro Plus 烘乾衣物的步驟：",
  "Find an unoccupied drying machine in the store, and insert your laundry in the dryer.": "在商店裡找一台無人使用的干衣機，然後將要烘乾的衣服放入乾衣機中。",
  "Select the desired temperature and duration that you would like to use for your laundry.": "選擇您想用於洗衣的所需溫度和持續時間。",
  "Using the scanner in the app, scan the QR code provided on the drying machine. Then select the same settings that you have pressed on the machine.": "使用應用程序中的掃描儀，掃描乾衣機上提供的二維碼。然後選擇您在機器上按下的相同設置。",
  "Once the payment has been accepted, press the START button on the dryer machine.": "付款被接受後，按下乾衣機上的開始按鈕。",
  "After the drying cycle ends, you can just remove your laundry from the machine.": "烘乾週期結束後，您只需將衣物從機器中取出即可。",
  "Why does the QR code I scanned take me to a different machine?": "為什麼我掃描的二維碼會將我帶到另一台機器上？",
  "Here are the steps to solve it:": "以下是解決它的步驟：",
  "Make sure that the number on the QR code (e.g. W1, W2, etc) is the same as the machine that you would like to use.": "確保二維碼上的數字（例如 W1、W2 等）與您要使用的機器相同。",
  "If the QR code number does not match the machine you want, use the other machine. Please contact our customer service line at 03-27700100 to report this issue.": "如果 QR 代碼編號與您想要的機器不匹配，請使用其他機器。請聯繫我們的客戶服務熱線03-27700100報告此問題。",
  "How can I add more time to the washer that I am currently using?": "如何為當前使用的洗衣機增加更多使用時間？",
  "The washing time for our washer is fixed and cannot add any additional time.": "我們洗衣機的洗滌時間是固定的，不能增加任何額外的時間。",
  "How can I add more time to the dryer that I am currently using?": "如何為當前使用的干衣機增加更多使用時間？",
  "Here are the steps to add more time to the dryer machine:": "以下是為烘乾機增加更多時間的步驟：",
  "By using the scanner in the app, scan the QR code provided at the dryer machine.": "使用應用程序中的掃描儀，掃描乾衣機上提供的二維碼。",
  "Select the amount of time that you would like to add to the machine.": "選擇您要增加的時間到機器上。",
  "After the drying cycle ends, you can just remove the clothes from the machine.": "烘乾週期結束後，您可以將衣物從機器中取出。",
  "REMINDER - It is recommended to add drying time 5 minutes before the cycle ends. And you cannot add tokens for extra times when the machine finishes the drying cycle.": "提醒 - 建議在循環結束前 5 分鐘增加干燥時間。當機器完成乾燥週期時，您不能增加額外時間。",
  "Will the timer keep running when I have stopped the drying machine?": "當我停止烘乾機時，定時器會繼續運行嗎？",
  "Yes. Even after you stop the machine, the timer will continue to run. If you want to extend the drying time, add drying time 5 minutes before the cycle ends. This prevents the cycle from ending before your clothes are completely dried.": "是的。即使在您停止機器後，計時器仍會繼續運行。如果您想延長干燥時間，請在循環結束前 5 分鐘增加干燥時間。這可以防止您的衣服完全乾燥之前結束烘乾。",
  "How do I reload my credits for Cleanpro Plus?": "我如何為 Cleanpro Plus 充值？",
  "Here are the steps to reload your credits:": "以下是充值點數的步驟：",
  'Select the "Top Up Credit" button on the homepage.': '選擇主頁上的“充值”按鈕。',
  "Choose the amount you want to reload and the payment method you want to use.": "選擇您要充值的金額和您要使用的付款方式。",
  "You will be taken to the payment page. The screen will return to Cleanpro Plus once the transaction is completed.": "您將被帶到付款頁面。交易完成後，屏幕將返回 Cleanpro Plus。",
  "How many credits can I reload in one transaction?": "我可以在一次交易中充值多少點數？",
  "Reloading credits requires a minimum of RM 10 and a maximum of RM 50.": "充值點數需要最低 RM 10 和最高 RM 50。",
  "Can I pay using credits in the Cleanpro Plus app along with tokens or coins in a single transaction?": "我可以在單筆交易中使用 Cleanpro Plus 應用程序中的點數以及代幣或硬幣進行支付嗎？",
  "No. Only a single payment method may be chosen when performing any transactions.": "不能。進行任何交易時只能選擇一種付款方式。",
  "The amount I have reloaded in my account was not reflected in the app.": "我在我的賬戶中充值的金額沒有反映在應用程序中。",
  "Please close and restart the application and check if the new balance has been updated.": "請關閉並重新啟動應用程序並檢查新余額是否已更新。",
  "If the amount is still not updated, please contact our customer service line at 03-27700110 to receive further assistance.": "如果金額仍未更新，請聯繫我們的客戶服務熱線03-27700110以獲得進一步的幫助。",
  "Can I cash out the credits I reloaded in my account for this app?": "我可以兌現我為這個應用程序中充值的點數嗎？",
  "No. The credits that you have reloaded will remain in your Cleanpro Plus account.": "不能。您充值的點數將保留在您的 Cleanpro Plus 賬戶中。",
  "I have requested a refund, but I still have not received it.": "我已申請退款，但仍未收到。",
  "Please contact our customer service line at 03-27700100 to receive further assistance.": "請聯繫我們的客戶服務熱線03-27700100以獲得進一步的幫助。",
  "I have made the payment, and the app double or triple charged me.": "我已經付款，但應用程序向我收取了兩倍或三倍的費用。",
  "The washing machine cannot start even after I have paid using the app.": "使用應用程序付款後洗衣機無法啟動。",
  "Ensure that the temperature settings you have selected and paid for on the application are the same as what you have pressed on the washing machine. If not, select the correct temperature settings on the washing machine and try again.": "確保您在應用程序上選擇和支付的溫度設置與您在洗衣機上按下的溫度設置相同。如果不是，請在洗衣機上選擇正確的溫度設置並重試。",
  "If the machine is still not able to be started, please contact our customer service line at 03-27700100 to receive further assistance.": "若機器仍無法啟動，請聯絡我們的客服熱線03-27700100以獲得進一步協助。",
  "Can I use multiple vouchers together in the same washing or drying cycle?": "我可以在同一個洗滌或烘乾程序中同時使用多張優惠券嗎？",
  "No. Only a single voucher can be used for each washing and drying cycle.": "不能。每個洗滌和烘乾週期只能使用一張優惠券。",
  "Why can't I use my free wash voucher that I received after signing up?": "為什麼我不能使用註冊後收到的免費洗滌券？",
  "To redeem or use the voucher, you must complete at least one washing or drying cycle.": "要兌換或使用優惠券，您必須至少完成一次洗滌或烘乾程序。",
  "Can I change my phone number even after registering my account?": "我可以在註冊賬戶後更改我的電話號碼嗎？",
  "No. Once registered to an account, the phone number is locked into the account.": "不能。一旦註冊到帳戶，電話號碼就會被鎖定到該賬戶中。",
  "I have problems in the store, and who can I refer to for help?": "我在店裡遇到問題，我可以向誰尋求幫助？",
  "Do not worry, as you can contact our customer service line at 03-27700100 to receive assistance at any time.": "別擔心，您可以隨時撥打我們的客服熱線03-27700100尋求幫助。",
  "Should I add my own laundry detergent and softeners to the washing machine?": "我應該在洗衣機中添加自己的洗衣液和柔順劑嗎？",
  "There is no need for that, as all you have to do is bring your dirty clothes and put them in the washer. The detergent and softeners will be provided by us, and you can rest assured that the laundry detergents we used are certified industrial grade.": "沒有必要，因為您只需帶上髒衣服並將它們放入洗衣機即可。洗滌劑和柔順劑由我們提供，您可以放心，我們使用的洗衣液都是經過認證的工業級洗滌劑。",
  "I would like to add my own laundry detergent and softener to the washing machine.": "我想在洗衣機中添加自己的洗衣液和柔順劑。",
  "We do not recommend our customers add their own detergent, as the mixture of different detergents may affect the wash quality. And you can rest assured that the laundry detergent we used is certified industrial grade.": "我們不建議客戶自行添加洗滌劑，因為不同洗滌劑的混合可能會影響洗滌質量。您可以放心，我們使用的洗衣液是經過認證的工業級洗滌劑。",
  "What time does the store close?": "商店幾點關門？",
  "Our self-service laundry operation is open 24 hours a day, which means you can always be sure to go back home with a fresh set of laundry.": "我們的自助洗衣店全天 24 小時開放，這意味著您回家時一定可以洗乾淨一整套新衣服。",
  "Are you open on weekends?": "你們週末營業嗎？",
  "Yes. Cleanpro is also open on weekends and even on public holidays.": "是的。 Cleanpro 在周末甚至公共假期也營業。",
  "How many clothes can I fit in the washing or drying machine?": "我可以在洗衣機或烘乾機中放入多少件衣服？",
  "To ensure that your laundry is properly washed or dried, keep the amount of laundry inside the machine lower than the line of guide sticker on the machine.": "為確保您的衣物得到正確洗滌或烘乾，請使機器內的衣物量低於機器上的引導標籤線。",
  "How many e-stamps can I collect in a single day?": "我一天可以收集多少個電子印章？",
  "There is no limit to the amount of stamps that can be collected in a single day; ONE stamp will be awarded with every wash or dry.": "一天內可以收集的印章數量沒有限制；每次洗滌或烘乾都會獲得一枚印章。",
  "When I use the washing service, can I change the collected stamp to a dryer stamp, and vice versa?": "當我使用洗滌服務時，我可以將收集的印章換成烘乾機印章，反之亦然嗎？",
  "No, the type of stamp collected is only applied to the service that you have used.": "不能，所收集的印章類型只適用於您使用過的服務。",
  "What temperatures can I choose when I claim the free washing e-stamp reward?": "領取免費洗印章獎勵時，我可以選擇什麼溫度？",
  "Any washing temperature is available for the e-stamp reward.": "任何洗滌溫度均可獲得電子印章獎勵。",
  "What temperatures can I choose when I claim the free drying e-stamp reward? And how long can I set the time?": "領取免費烘乾印章獎勵時，我可以選擇什麼溫度？我可以設置多長時間？",
  "Any drying temperature and duration can be selected for the e-stamp reward.": "可以選擇任何干燥溫度和持續時間作為電子印章獎勵。",
  "I'm unable to change the coin.": "我無法兌換硬幣。",
  "What colour is the light shown on the machine, red or green? If it is a red light, please contact our customer service line at 03-27700100 to receive further assistance.": "機器上顯示的燈是什麼顏色，紅色還是綠色？如果是紅燈，請聯繫我們的客戶服務熱線03-27700100以獲得進一步的幫助。",
  "Green Light": "綠燈",
  "Red Light": "紅燈",
  "Machine functions as normal. Please try again.": "機器功能正常。請再試一次。",
  "(flashing 2x) - There are no coins/tokens in the machine.": "（閃爍 2 次）- 機器中沒有硬幣/代幣。",
  "OR": "或者",
  "Note is jammed, please proceed to contact customer service": "紙幣卡紙，請聯繫客服",
  "(flashing 3x) - Note is jammed, please proceed to contact customer service": "（閃爍 3 次）- 紙幣卡住，請繼續聯繫客戶服務",
  "My notes are stuck in the machine.": "我的紙幣卡在機器裡了。",
  "My detergent is not dispensing in the vending machine.": "我的洗滌劑沒有在自動售貨機中分配。",
  "The water is leaking out of the washing machine.": "水從洗衣機中漏出。",
  "Please check the washer machine to see whether there are any clothes that are stuck at the door side.": "請檢查洗衣機是否有衣服卡在門邊。",
  "If yes, here are the steps to solve it:": "如果是，這裡是解決它的步驟：",
  "Press the emergency stop button (RED Button) for 3 seconds.": "按下緊急停止按鈕（紅色按鈕）3 秒鐘。",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at 03-27700100 to receive further assistance)": "等聲音停止，才打開門。 (若30分鐘後聲音仍未停止，請聯絡我們的客服熱線03-27700100以獲得進一步協助)",
  "Ensure the door is closed tightly, and press the START button.": "確保門緊閉，然後按下啟動按鈕。",
  "REMINDER - The emergency stop button can only be used once.": "提醒 - 緊急停止按鈕只能使用一次。",
  "There is no detergent dispensing in the washing machine.": "洗衣機中沒有洗滌劑配給。",
  "Ensure that the machine is in operation and that the START button was pressed.": "確保機器正在運行並且按下了啟動按鈕。",
  "If the detergent is still not dispensing, please contact our customer service department at 03-27700100 for further assistance.": "如果洗滌劑仍未配出，請致電03-27700100與我們的客戶服務部聯繫以獲得進一步的幫助。",
  "The price displayed on the machine's screen did not change after inserting the token.": "插入硬幣後，機器屏幕上顯示的價格沒有變化。",
  "Press the small button (in the centre) to reject the tokens that have been inserted. Press a few times till the coins come out.": "按小按鈕（在中心）拒絕已插入的硬幣。按幾次直到硬幣出來。",
  "If the coins still cannot come out or the button is not functioning, please contact our customer service line at 03-27700110 to receive further assistance.": "若仍無法出幣或按鈕無法使用，請聯絡我們的客服熱線03-27700110以獲得進一步協助。",
  "The machine is not starting, and it displays an error code.": "機器未啟動，並顯示錯誤代碼。",
  "We would like to apologise for any inconvenience caused. Please contact our customer service line at 03-27700100 to receive further assistance.": "對於由此造成的任何不便，我們深表歉意。請聯繫我們的客戶服務熱線03-27700100以獲得進一步的幫助。",
  "I want to wash the clothes again, but why couldn't the machine start even after I added tokens to the machine?": "我又想洗衣服，為什麼我給機器加了硬幣後機器還是啟動不了？",
  "Try opening and closing the door again before starting the machine.": "在啟動機器之前再次嘗試打開和關閉門。",
  "Can I change the water temperature of the machine?": "我可以改變機器的水溫嗎？",
  "Yes, but the washer temperature can only be changed from hot to cold after the machine has been started, and not from cold to hot.": "是的，但洗衣機溫度只能在機器啟動後由熱變冷，而不能由冷變熱。",
  "Can I stop the machine?": "我可以停止機器嗎？",
  "Here are the steps to stop the machine:": "以下是停止機器的步驟：",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at to receive further assistance)": "等聲音停止，才打開門。 （若30分鐘後聲音仍未停止，請聯繫我們的客服熱線獲取進一步幫助）",
  "There is no water supply on the machine used.": "使用的機器上沒有供水。",
  "Why is the washing temperature cold even when I have selected HOT.": "為什麼我選擇了熱，洗滌溫度還是很冷。",
  "The water temperature is HOT or WARM only during washing. The water will turn COLD during rinsing.": "水溫僅在洗滌期間為熱或溫。沖洗時水會變冷。",
  "The machine has already finished washing, but it does not spin well, and there is water left on the load.": "機器已經完成洗滌，但旋轉不暢，衣物上還有水。",
  "Can I put wet laundry into the dryer to dry?": "我可以將濕衣物放入烘乾機中烘乾嗎？",
  "No, as the dripping wet laundry might cause the dryer to short circuit.": "不能，因為滴水的濕衣物可能會導致乾衣機短路。",
  "REMINDER - Refer to the labels on your clothes to know what kind of temperature is best for the kind of fabric that it uses. Then select the temperature on the machine accordingly.": "提醒 - 請參閱衣服上的標籤，了解哪種溫度最適合所使用的面料。然後相應地選擇機器上的溫度。",
  "My clothes are still wet even after drying.": "我的衣服烘乾後還是濕的。",
  "How can I stop the dryer when the machine is still running?": "機器仍在運行時如何停止烘乾機？",
  "Just open the door and the machine will automatically stop.": "只要打開門，機器就會自動停止。",
  "I added extra tokens for extra times, but the machine did not update the time.": "我為額外的時間添加了額外的貨幣，但機器沒有更新時間。",
  "For the time to be reflected accurately, it is recommended for you to add tokens 5 minutes before the services end.": "為了準確反映時間，建議您在服務結束前5分鐘添加貨幣。",
  "REMINDER - You cannot add tokens for extra times when the machine finishes the drying cycle.": "提醒 - 當機器完成烘乾循環時，您不能為額外時間添加貨幣。",
  "Why is the machine making noise?": "為什麼機器會發出噪音？",
  "Please check the drum to see if there are any coins or other small things inside.": "請檢查滾筒，看看裡面是否有任何硬幣或其他小東西。",
  "I have pressed the START button on the dryer, but it is still not working.": "我已經按下烘乾機上的啟動按鈕，但它仍然無法正常工作。",
  "Please try to open the door and close it again. Next, press the START button again to start drying.": "請嘗試打開並再次關閉門。接下來，再次按下開始按鈕開始乾燥。",
  "If the dryer is still not functioning, please contact our customer service line at 03-27700100 to receive further assistance.": "如果乾衣機仍然無法正常工作，請聯繫我們的客戶服務熱線 03-27700100 以獲得進一步的幫助。",
  "Paywave has deducted an amount from the card but the machine did not reflect the transaction.": "Paywave 已從卡中扣除一筆金額，但機器未反映這筆交易。",
  "The Paywave transaction has failed but the amount has still been deducted from my card.": "Paywave 交易失敗，但金額仍從我的卡中扣除。",
  "Paywave has double/triple charge but the machine cannot start.": "Paywave 有雙倍/三倍收費但機器無法啟動。",
  "Paywave after double/triple charge machines can't start.": "雙倍/三倍收費後的 Paywave 機器無法啟動。",
  "Paywave is offline": "Paywave 已離線",
  "Do Cleanpro Express offer franchise business/selling machines/laundry products?": "Cleanpro Express 是否提供特許經營/銷售機器/洗衣產品？",
  "For further inquiries, please email to info@cleanproexpress.com": "如需進一步查詢，請發送電子郵件至 info@cleanproexpress.com",
  "Step 6": "步驟 6",
  "User Existed": "用戶已存在",
  "This email is registered": "該郵箱已註冊",
  "This phone number is registered": "該電話號碼已註冊",
  "Invalid Email Address": "無效的郵件地址",
  "Let's get started!": "讓我們開始吧！",
  "Enter your e-mail/mobile number": "輸入您的電子郵件/手機號碼",
  "Enter your e-mail": "輸入你的電子郵件",
  "Enter your mobile number": "輸入你的手機號碼",
  "Enter your e-mail address": "輸入你的電子郵件地址",
  "Proceed": "繼續",
  "Enter OTP number": "輸入一次性密碼",
  "You will receive a six-digit OTP via SMS sent to": "您將收到一個六位數的一次性密碼短信在",
  "You will receive a six-digit OTP via e-mail sent to": "您將收到一個六位數的一次性密碼郵件在",
  "Verify": "驗證",
  "Resend OTP": "重新發送一次性密碼",
  "Welcome onboard!": "歡迎！",
  "Please fill in the info below": "請填寫以下資料",
  "Enter your name*": "輸入你的名字*",
  "Enter your email address*": "輸入你的電子郵箱地址*",
  "Please enter either phone number or email address": "請輸入電話號碼或電子郵件地址",
  "Create a password*": "創建密碼*",
  "Enter referral code (if got any)": "輸入推薦碼（如果有）",
  "Get started": "開始",
  "Birthday updated successfully": "生日更新成功",
  "Date of birth": "出生日期",
  "Enter your date of birth": "輸入你的出生日期",
  "Select your birth date": "選擇您的出生日期",
  "Update date of birth": "更新出生日期",
  "Update birth date": "更新出生日期",
  "Already have an account?": "已經有賬戶？",
  "Login now": "立即登錄",
  "Sign in": "登入",
  "Sign up now": "立即註冊",
  "COMPLETED": "完成",
  "WASHING NOW": "洗滌中",
  "DRYING NOW": "烘乾中",
  "It's done!": "完成了！",
  "Please collect your fresh, clean laundry in order to leave the machine available for the next person to use!": "請收集您清新、乾淨的衣物，以便讓機器可供下一個人使用！",
  "Leave a feedback": "留下反饋",
  "Time left": "剩餘時間",
  "Add drying time": "增加烘乾時間",
  "Hi": "你好",
  "customer": "顧客",
  "Thank you for your payment. Don't forget to select the <b>correct temperature</b> and press <b>START</b> when you're ready.": "謝謝您的付款。不要忘記選擇<b>正確的溫度</b>，並在準備就緒後按<b>開始</b>。",
  "Select how you want to receive a notification when your laundry is finished": "選擇洗衣完成後您希望如何接收通知",
  "Sign up": "註冊",
  "Continue to pay": "繼續付款",
  "Register as a member to enjoy more benefits!": "註冊成為會員，享受更多優惠！",
  "Get FREE {{ voucherAmount }} credits per new user": "每個新用戶免費獲得 {{ voucherAmount }} 個貨幣",
  "Get FREE {{ voucherAmount }}% per new user": "每個新用戶免費獲得 {{ voucherAmount }}%",
  "Enjoy exclusive promotions": "享受獨家促銷",
  "FREE voucher on your birthday": "生日當天可獲贈免費優惠券",
  "and more": "和更多",
  "Denied camera access": "拒絕攝像頭訪問",
  'Permission to access the camera has been denied. Please try again and click "Allow" to scan the QR code.': '訪問攝像頭的權限已被拒絕。請重試並點擊“允許”掃描二維碼。',
  "Okay": "好的",
  "Oops. You don't have enough balance to make the payment": "您沒有足夠的餘額來付款",
  "Please confirm": "請確認",
  "Do you want to proceed with this feedback?": "您想繼續處理此反饋嗎？",
  "Are you sure to purchase": "您確定購買",
  "credits for": "貨幣以",
  "Topup credit": "充值貨幣",
  "Extended duration will be instantly reflected on machine after payment": "付款後，延長的時間將立即反映在機器上",
  "Machine is currently busy": "機器當前正忙",
  "Do you want to extend drying time?": "您想延長烘乾時間嗎？",
  // "Cuci Hari-Hari Bersama Cleanpro!": "Cuci Hari-Hari Bersama Cleanpro!",
  // "Ready for a challenge?": "準備好迎接挑戰了嗎？",
  // "Here's one for you - all you need to do is wash your laundry 10 times in 20 days at participating Cleanpro outlets. Stand a chance to win a Limited Edition Cleanpro Designer Laundry Bag worth up to RM40!": "挑戰如下 - 你只需在20天內於任何一家Cleanpro門店裡洗衣10次，即可贏得一款價值高達RM40的限量版Cleanpro設計師系列洗衣袋。",
  // "Here's how to participate:": "參與方式：",
  // "Step 1: Scan the QR Code on the washer to launch Cleanpro Plus": "步驟1：掃描QR Code來啟動Cleanpro Plus應用並註冊賬戶。",
  // "Step 2: Pay for your wash with Cleanpro Plus": "步驟2：選擇您需要充值的額度並支付。",
  // "Step 3: Complete x10 washes within 20 days to win": "步驟3：在20天內完成10次洗衣。",
  // "Challenge Period: 01 July - 31 August 2023": "挑戰期：2023年7月1日 - 8月31日",
  // "Drop by your nearest Cleanpro outlet to wash your laundry with us for 20 days straight! Good luck!": "前往最近的Cleanpro門店，與我們一起“天天喜衣”！祝您好運！",
  // "TERMS & CONDITIONS": "條款及細則",
  // "PARTICIPATION CRITERIA": "參與條件",
  // "1) Participant needs to register an account in Cleanpro Plus web app.": "1）參與者需要在Cleanpro Plus應用上註冊一個賬戶。",
  // "2) Participant can use any washer of any capacity in any participating outlets to qualify for entries.": "2）參與者在任何一間指定門店使用任何容量的洗衣機即符合資格。",
  // "3) Payment needs to be made with Cleanpro Plus web app.": "3）款項需通過Cleanpro Plus進行支付。",
  // "4) Washes must be completed and paid (with no dispute whatsoever) within campaign period.": "4）清洗及結賬必須在活動期間內完成（絕無爭議）。",
  // "5) Campaign period starts from 1st July 2023 at 00:00 and ends at 31st August 2023 at 23:59.": "5）活動將從2023年7月1日00:00開始，至2023年8月31日23:59結束。",
  // "WINNERS & PRIZES": "獲獎者及獎品",
  // "1) Cleanpro will notify the winners of the campaign via registered WhatsApp number or email address provided, within 4 weeks after the campaign ends.": "1）Cleanpro將在活動結束後的4週內，通過註冊的WhatsApp號碼或所提供的電子郵件箱通知獲獎者。",
  // "2) Any unclaimed prizes after 2 weeks from notification date will not be entertained thereafter.": "2）從通知日期起直至2週後仍未前來領取的獎品將不予理會。",
  // "3) Upon completing the ten (10) washes within twenty (20) days campaign, participants will be a winner and be eligible to win ONE (1) Cleanpro Designer Laundry Bag.": "3）參與者若在20天的活動期間內完成十（10）次洗衣次數後，將贏得一（1）款Cleanpro設計師系列洗衣袋。",
  // "4) Winners are eligible to win more than ONE (1) Cleanpro Designer Laundry Bag in this campaign.": "4）獲獎者有資格在此活動中贏得多於一（1）個Cleanpro設計師系列洗衣袋。",
  // "5) Winners will be given the choice of his/her preferred laundry bag size; but only ONE (1) can be selected for each qualified win.": "5）獲獎者將可選擇自己喜歡的洗衣袋尺寸；但每次完成挑戰只能在獎品中選擇一（1）個。",
  // "A) XL Size - Blue bag with up to 20KG in capacity": "A）XL尺寸 - 藍色洗衣袋，容量高達20公斤",
  // "B) L Size - White bag with up to 12KG in capacity": "B）L尺寸 - 白色洗衣袋，容量高達12公斤",
  // "6) Time and location for collection of prize will be informed via Whatsapp number and/or email address provided.": "6）獎品領取的時間和地點將通過參與者所提供的WhatsApp號碼和/或電子郵件箱通知。",
  "OTHER": "其他",
  // "1) Changes to the terms and conditions will be at Cleanpro's discretion; without prior notice.": "1）Cleanpro有權不經通知修改本條款和細則。",
  // "2) Completed wash is defined by washes performed with Cleanpro's washer and payments within Cleanpro Plus web app are made with no disputes.": "2）完整的洗衣過程意指使用Cleanpro的洗衣機進行洗滌，並在Cleanpro Plus網頁應用程序內進行付款 (絕無爭議)。",
  // "3) By participating in this campaign automatically indicates that the Participant has agreed to all the campaign's Terms and Conditions as stipulated.": "3）參與此活動即表示參與者已同意所有活動條款及細則。",
  "Welcome Voucher": "“歡迎”禮券",
  "Welcome to the Cleanpro Plus family! This first gift is just the beginning. Stay tuned for a series of exciting promotions and campaigns, exclusively for Cleanpro Plus users.": "歡迎加入 Cleanpro Plus的大家庭！這份見面禮只是一個開始。請繼續關注 Cleanpro Plus以獲得我們獨家提供給用戶的一系列激動人心的促銷和活動。",
  "Terms & Conditions": "條款及細則",
  "TERMS AND CONDITIONS": "條款及細則",
  "Welcome Voucher is valid for one-time use only.": "“歡迎”禮券僅供一次性使用。",
  "There is no minimum spend required for the voucher to be used.": "使用禮券時，沒有最低消費要求。",
  "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only.": "“歡迎”禮券在 Cleanpro Plus 註冊時將會自動存入用戶的帳戶，有效期僅為 {{ duration }} 天。",
  "Users are eligible to use their Welcome Voucher AFTER the completion of their first wash or dry cycle using the same Cleanpro Plus account.": "用戶需使用同一個 Cleanpro Plus 帳戶完成第一次洗滌或烘乾後，才能使用“歡迎”禮券。",
  "Welcome Voucher cannot be used together with any ongoing promotions or any other promotional vouchers.": "“歡迎”禮券不能與任何正在進行的促銷活動或任何其他促銷禮券一起使用。",
  "The voucher is final and cannot be refunded in form of cash or credit to the user.": "該禮券不能以現金或點數形式退還給用戶。",
  "Cleanpro reserves the right to change the terms and conditions without prior notice.": "Cleanpro 保留更改條款和條件的權利，恕不另行通知。",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})": "收集 10 個電子郵票即可免費獲得 {{ voucherAmount }} 點數禮券（價值 {{ currency }}{{ voucherAmount }}）",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }}% voucher (worth {{ voucherAmount }}%)": "收集 10 個電子郵票即可免費獲得 {{ voucherAmount }}% 禮券（價值 {{ voucherAmount }}%）",
  "Collect 10 e-Stamp to earn FREE Voucher": "收集 10 個電子郵票即可免費獲得禮券",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding.": "每收集 10 個電子印章，您將獲得一張免費 {{ voucherAmount }} 點數禮券（價值 {{ currency }}{{ voucherAmount }}）。讓您的洗衣程序不僅輕鬆無憂，而且收穫頗豐。",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }}% credits voucher (worth {{ voucherAmount }}%). Make your laundry routine not just hassle-free, but also rewarding.": "每收集 10 個電子印章，您將獲得一張免費 {{ voucherAmount }}% 禮券（價值 {{ voucherAmount }}%）。讓您的洗衣程序不僅輕鬆無憂，而且收穫頗豐。",
  // "How to participate:": "參與方式：",
  // "Prizes to be won:": "將贏得的獎品：",
  "RM10 OFF Welcome Voucher": "RM10 折扣歡迎禮券",
  "Welcome to the Cleanpro family, here is an appreciation voucher from us. Thank you for attending the COPE Investors Conference.": "歡迎加入 Cleanpro 大家庭，這是我們的感謝券。感謝您參加 COPE 投資者大會。",
  "Welcome Voucher | COPE Investors Conference": "歡迎券 | COPE投資者大會",
  "Payment methods": "付款方式",
  "Tap to proceed with your preferred mode of payment": "選擇您喜歡的付款方式",
  "Cleanpro Plus credits": "Cleanpro Plus 點數",
  "E-wallet or credit/debit cards": "電子錢包或信用卡",
  "Go to homepage": "前往主頁",
  // backend response or error
  "Admin is unauthorized to login": "管理員沒有權限登入",
  "Internal Error": "內部錯誤",
  "Please enter the correct credentials": "請輸入正確的密碼",
  "Operator not found": "未找到營運商",
  "Admin not found": "未找到管理員",
  "Distributor not found": "未找到經銷商",
  "Client not found": "未找到客戶",
  "Outlet not found": "未找到店鋪",
  "Token Package not found": "未找到電子代幣配套",
  "Top up history not found": "未找到儲值記錄",
  "Voucher not found": "未找到優惠券",
  "Faq not found": "未找到常見問題",
  "Faq Group not found": "未找到常見問題組",
  "News not found": "未找到新聞",
  "Transaction not found": "未找到交易",
  "Please Login Again": "請重新登入",
  "Decoding Error": "解碼錯誤",
  "Some error occured, please contact the dev team if this error continues.": "發生了一些錯誤，如果此錯誤仍然存在，請聯絡開發團隊。",
  "Please fill in all the required fields": "請填寫所有必填選項",
  "Only success transaction can be refund": "只有成功的交易才能退款",
  "Only token payment method can be refund": "只有電子代幣支付方式才能退款",
  "The discount code has been used, please change to other code": "該優惠碼已被使用，請更換其他優惠碼",
  "Cannot use ewallet in sandbox": "無法在沙盒中使用電子錢包",
  "Please close the door to proceed your payment": "請關上門以繼續付款",
  "Under Maintenance": "正在維修",
  "This machine is being fixed. Please use another machine.": "此機器正在維修中，請使用其他機器。",
  "Machine is currently running, please try again later": "機器目前正在運行，請稍後重試",
  "Machine is currently offline, please try again later": "機器目前離線，請稍後重試",
  "Outlet not participating in Loyalty program": "商店未參與忠誠度計劃",
  "Please log in to make the payment": "請登入後進行支付",
  "Package not found, please refresh and try again": "找不到配套，請刷新重試",
  "You have reached the maximum number of purchase": "您已達到最大購買數量",
  "Store not found, please try again later": "找不到商店，請稍後重試",
  "Incorrect Password": "密碼錯誤",
  "Token already top up": "電子代幣已充值",
  "Payment failed": "支付失敗",
  "Transaction Failure": "交易失敗",
  "Transaction Refunded": "交易已退款",
  "Transaction Pending": "交易待處理",
  "Please enter your mobile number": "請輸入您的手機號碼",
  "User is unauthorized to register": "用戶無權註冊",
  "Please proceed to sign up": "請繼續註冊",
  "OTP expired, please request a new OTP": "OTP 已過期，請申請新的 OTP",
  "Incorrect verification code": "驗證碼不正確",
  "This referrer ID is not valid": "該推薦人 ID 無效",
  "This referrer ID is different operator": "此推薦人 ID 是不同的營運商",
  "This referrer ID is exceed the limit": "該推薦人 ID 超出限制",
  "User is unauthorized to login": "用戶無權登入",
  "Click here to register": "點此註冊",
  "User is unauthorized to login. Please contact the admin": "用戶無權登入。請聯絡管理員",
  "User is unauthorized": "用戶未經授權",
  "This outlet does not participate in the Loyalty Program": "該商店不參與忠誠度計劃",
  "This outlet is not belongs to the operator": "該店舖不屬於此營運商",
  "Processing request": "處理請求",
  "This user is not verified": "該用戶未驗證",
  "Insufficient token to make payment": "電子代幣不足，無法付款",
  "Insufficient token to transfer": "電子代幣不足，無法轉帳",
  "Insufficient point to make payment": "積分不足，無法付款",
  "This voucher is not available for use": "此優惠券不可用",
  "This voucher is belongs to other user": "此優惠券屬於其他用戶",
  "Invalid Discount Code": "優惠碼無效",
  "This discount code cannot use in this outlet": "該優惠碼不能在該分店使用",
  "This discount code was expired": "該優惠碼已過期",
  "This discount code cannot use in washer machine transaction": "此優惠碼不能用於洗衣機交易",
  "This discount code cannot use in dryer machine transaction": "此優惠碼不能用於烘乾機交易",
  "This discount code was fully redeemed today, try again tomorrow": "該優惠碼今天已完全兌換，明天再試",
  "You have fully redeemed this discount code": "您已完全兌換此優惠碼",
  "This discount code have been redeemed": "此優惠碼已兌換",
  "This discount code is not applicable": "此優惠碼不適用",
  "Insufficient stamp": "印章不足",
  "Please provide at least one voucher setting": "請提供至少一項優惠券設置",
  "Previous batch are still generating, please try again later": "上一批仍在生成中，請稍後重試",
  "Number of voucher code should be more than 0": "兌換碼數量必須大於0",
  "Number of voucher code should be less than 50000": "兌換碼數量必須小於50000",
  "Number of discount code should be more than 0": "優惠碼數量必須大於0",
  "Number of discount code should be less than 50000": "優惠碼數量必須小於50000",
  "No Item": "沒有配套",
  "Please add item": "請添加配套",
  "Staff not found": "未找到工作人員",
  "This task already completed": "此任務已經完成",
  "Please complete the wash task first": "請先完成洗滌任務",
  "Please complete the dry task first": "請先完成烘乾任務",
  "Please select at least one outlet": "請至少選擇一個店鋪",
  "Touch to Start": "點擊開始",
  "New Users": "新用戶",
  "Get {{ voucher_amount }} FREE Credits!": "獲得免費 {{ voucher_amount }} 積分！",
  "Get {{ voucher_amount }}% FREE!": "獲得 {{ voucher_amount }}% 折扣！",
  "Load your clothes into the washing machine & note the machine number": "將投入衣服洗衣機並記下機器編號",
  "T&C Apply": "適用條款與條件",
  "Mobile Number": "手機號碼",
  "Member": "會員",
  "Please enter your mobile phone number / e-mail": "請輸入您的手機號碼/電子郵件信箱",
  "Please verify your number": "請確保您的電話號碼正確",
  "Please verify your e-mail": "請確保您的電子郵件正確",
  "Please enter the correct phone number format. Example: 01xxxxxxxx": "請輸入正確的電話號碼格式。範例：01xxxxxxxx",
  "Please enter the correct phone number format. Example: 09xxxxxxxx": "請輸入正確的電話號碼格式。範例：09xxxxxxxx",
  "Scan QR to Complete your signup & access more benefits!": "掃描二維碼完成註冊並享受更多福利！",
  "Please choose your service": "請選擇您的服務",
  "WASHER": "洗衣機",
  "DRYER": "烘乾機",
  "VENDING MACHINE": "自動販賣機",
  "Please tap your card on the reader": "請將您的卡輕觸在讀卡機上",
  "Payment Option": "付款方式",
  "Thank you for payment!": "感謝您的付款！",
  "Please select your items at the vending machine": "請在自動販賣機上選擇您的商品",
  "Please choose the temperature on the machine and press": "請選擇機器上的溫度並按",
  "START": "開始",
  "Need Help?": "需要幫助嗎？",
  "Please choose the temperature": "請選擇溫度",
  "Confirm Payment": "確認付款",
  "Select the time for": "選擇時間",
  "Do you want to add drying time?": "您是否想增加烘乾時間？",
  "minutes": "分鐘",
  "Your machine is": "您的機器是",
  "Please Collect your item from the vending machine": "請從自動販賣機領取您的物品",
  "You've earned 1 e-stamp for your wash!": "您已獲得 1 個洗滌電子印章！",
  "You've earned 1 e-stamp for your dry!": "您已獲得 1 個烘乾電子印章！",
  "You've missed 1 e-stamp for your wash!": "您錯過了 1 個洗滌電子印章！",
  "You've missed 1 e-stamp for your dry!": "您錯過了 1 個烘乾電子印章！",
  "Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "收集 10 個洗滌電子印章，即可免費獲得 {{ amount }} 點數優惠券。",
  "Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "收集 10 個洗滌電子印章即可賺取 {{ amount }}% 優惠券。",
  "Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "收集 10 個烘乾電子印章，即可免費獲得 {{ amount }} 點數優惠券。",
  "Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "收集 10 個烘乾電子印章即可獲得 {{ amount }}% 優惠券。",
  "Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "收集 10 個洗滌和烘乾電子印章即可免費獲得 {{ amount }} 點數優惠券。",
  "Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "收集 10 個洗滌和烘乾電子印章即可獲得 {{ amount }}% 優惠券。",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "註冊並收集 10 個洗滌和烘乾電子印章即可免費獲得 {{ amount }} 點數優惠券。",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "註冊並收集 10 個洗滌和烘乾電子印章即可賺取 {{ amount }}% 優惠券。",
  "Sign Up & Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "註冊並收集 10 個洗滌電子印章，即可免費獲得 {{ amount }} 點數優惠券。",
  "Sign Up & Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "註冊並收集 10 個洗滌電子印章即可賺取 {{ amount }}% 優惠券。",
  "Sign Up & Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "註冊並收集 10 個烘乾電子印章，即可免費獲得 {{ amount }} 點數優惠券。",
  "Sign Up & Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "註冊並收集 10 個烘乾電子印章即可賺取 {{ amount }}% 優惠券。",
  'For iOS users, press and hold the image, then choose "Add to Photos" or "Save in Photos" from the menu.': '對於 iOS 用戶，長按圖像，然後從選單中選擇 "Add to Photos" 或者 "Save in Photos"。',
  "Scan the QR code to pay": "掃描二維碼支付",
  "QR Code expires in {{ countdown }} seconds": "二維碼將在 {{ countdown }} 秒後過期",
  "Transfer In": "轉入",
  "Migrate": "遷移",
  "Update": "更新",
  "Transfer Out": "轉出",
  "Total In": "總收入",
  "Total Out": "總支出",
  "Laundry Pass": "洗衣通行證",
  "Number of wash": "洗滌次數",
  "Number of Wash": "洗滌次數",
  "Number of dry": "烘乾次數",
  "Number of Dry": "烘乾次數",
  "Laundry Pass Purchase": "購買洗衣通行證",
  "Laundry Pass Purchase Report": "洗衣通行證購買報告",
  "Please select distributor or operator": "請選擇經銷商或營運商",
  "Price should be more than 0": "價格應該大於0",
  "Number of wash or dry should be more than 0": "洗滌或烘乾次數應大於0",
  "Number of wash should be more than 0": "洗滌次數應大於0",
  "Number of dry should be more than 0": "烘乾次數應大於0",
  "Duration must be more than 0": "持續時間必須大於 0",
  "Please fill in the name": "請填寫姓名",
  "Purchase Start Date": "購買開始日期",
  "Purchase End Date": "購買結束日期",
  "Number of Maximum Purchase": "最大購買數量",
  "Create Laundry Pass": "創建洗衣通行證",
  "Select Purchase Period": "選擇購買期間",
  "If ticked, the Laundry Pass will have expired date": "若勾選，洗衣通行證將有過期日期",
  "Laundry Pass Lifespan": "洗衣通行證的使用壽命",
  "Edit Laundry Pass": "編輯洗衣通行證",
  "Washer Used Date": "洗滌使用日期",
  "Dryer Used Date": "烘乾使用日期",
  "Laundry Pass Purchase History": "洗衣通行證購買歷史記錄",
  "Laundry Pass Usage Report": "洗衣通行證使用報告",
  "Please Note! (Stacked Dryer)": "請注意！ (堆疊式乾燥機)",
  "Ensure machine is vacant and select correct machine after payment press START": "確保機器是空的，並在付款後選擇正確的機器，然後按“開始”",
  "Start date": "開始日期",
  "End date": "結束日期",
  "Today": "今天",
  "Yesterday": "昨天",
  "Last 7 Days": "過去 7 天",
  "Last 30 Days": "過去 30 天",
  "This Month": "本月",
  "Last Month": "上個月",
  "Use Per Day": "每日最大使用次數",
  "Maximum use per day must be more than 0": "每日最大使用次數必須大於 0",
  "Only applicable to selected outlet": "只適用於指定分店",
  "Applicable to all the outlets except selected outlet": "適用於除指定分店外的所有分店",
  "If applicable to all the outlet, leave it blank": "如果適用於所有分店，請留空",
  "Only applicable to selected weight": "僅適用於指定重量",
  "Applicable to all the weight except selected weight": "適用於指定重量以外的所有重量",
  "Weight": "重量",
  "If applicable to all the weight, leave it blank": "如果適用於所有重量，請留空",
  "Add Weight": "添加重量",
  "Only applicable to selected mode": "僅適用於選定模式",
  "Applicable to all the modes except selected mode": "適用於指定模式以外的所有模式",
  "If applicable to all the mode, leave it blank": "如果適用於所有模式，請留空",
  "Add Mode": "新增模式",
  "Laundry Pass not applicable in this outlet": "洗衣通行證不適用於此分店",
  "Discounted price should be more than 0": "折扣價應大於0",
  "Discounted Price": "折扣價",
  "Logo (Optional)": "標誌（可選）",
  "Save": "節省",
  "Cleanpro Laundry Pass": "Cleanpro Laundry Pass",
  "Save more with the Laundry Pass — ": "購買Laundry Pass",
  "wash and dry more clothes at a lower price while enjoying extra rewards from Cleanpro Plus!": "不僅能讓您以更實惠的價格洗滌和烘乾更多衣物，還能享受Cleanpro Plus帶來的額外獎勵，幫助您節省更多！",
  "How to Purchase Laundry Pass": "如何購買 Laundry Pass",
  "Step 1: Register as a Cleanpro Plus user.": "步驟 1：註冊成為 Cleanpro Plus 用戶。",
  "Step 2: Choose the Laundry Pass package you wish to purchase.": "步驟 2：選擇您要購買的 Laundry Pass配套。",
  "Step 3: Make the payment through Cleanpro Plus.": "步驟 3：透過 Cleanpro Plus 進行全額付款。",
  "Step 4: Enjoy washing and drying services at any Cleanpro outlet in Malaysia with exclusive discounted prices!": "步驟 4：在馬來西亞的任何 Cleanpro 分店以獨家折扣價享受洗滌和烘乾服務！",
  "By purchasing and/or using the Cleanpro Laundry Pass, you agree to be bound by the following terms and conditions:": "購買和/或使用Cleanpro Laundry Pass，您同意遵守以下條款和條件：",
  "Definitions": "定義",
  '"Laundry Pass" refers to the package(s) for specific laundry services offered by Cleanpro.': '「Laundry Pass」指Cleanpro提供的特定洗滌和烘乾服務配套。',
  '"Subscriber" refers to the individual(s) purchasing and/or using the Laundry Pass.': '「購買者」指購買和/或使用Laundry Pass的人。',
  "Pass Description": "配套描述",
  "The Laundry Pass is a promotional package that offers laundry services at any Cleanpro outlet in Malaysia.": "Laundry Pass是一個促銷配套，僅在馬來西亞的任何Cleanpro門市有效，提供洗滌和烘乾服務。",
  'The Laundry Pass is valid for both Malaysians and non-Malaysians; and is exclusively available to Cleanpro Plus members.': 'Laundry Pass適用於馬來西亞公民和非馬來西亞公民，僅限Cleanpro Plus會員使用。',
  "The campaign of Laundry Pass is valid from": "Laundry Pass的活動有效期限為",
  "1 March 2025 to 31 May 2025.": "2025年3月1日至2025年5月31日。",
  'Each Laundry Pass subscription is': '從購買 Laundry Pass日期起，每個Laundry Pass',
  'valid for 30 days from the start date,': '可使用有效期為30天，',
  'allowing subscribers to use the package': '購買者可',
  'up to 4 times per day.': '每天使用配套最多4次。',
  'During the promotional period, subscribers can repurchase the package unlimited times, but only after fully utilizing your current subscription.': '在促銷期間，您可以無限次重新購買配套，但必須先完全使用當前的配套。',
  "The Laundry Pass is": "Laundry Pass ",
  "valid only for cold wash and drying of machines under 25kg.": "僅適用於冷水洗滌和25kg以下的机器。",
  "Additional charges will apply for warm and hot wash services, based on the temperature selected.": "溫水洗滌和熱水洗滌服務將額外收費。",
  'Unused wash or dry session(s) from the Laundry Pass cannot be carried forward to the next purchase, and are non-refundable, non-exchangeable for cash, and non-transferable.': '未使用的洗滌或烘乾次數不可轉移至下次購買的配套裡，且不可退款、不可兌換現金、不可轉讓。',
  'The Laundry Pass is valid for washing and/or drying standard laundry items only (e.g., clothing, linens), excluding large items (e.g., rugs), heavily soiled items (e.g., pet bedding), or specialty items requiring special treatment.': 'Laundry Pass僅適用於洗滌和/或烘乾標準的衣物品，例如衣物、床單等，不包括大件物品（如地毯）、重污物品（如寵物床墊）或需要特別處理的特殊物品。',
  'The Laundry Pass can be cancelled within the first 7 days of subscription for a full refund, provided the subscriber has not used the Laundry Pass during this period. No refunds or transfers will be issued after the first 7 days.': '在購買配套後的前7天內，購買者可以取消Laundry Pass並獲得全額退款，前提是購買者在此期間完全沒有使用過Laundry Pass。超過7天后，購買的配套將不提供退款或轉讓。',
  "Refund process may take up to 21 working days.": "退款過程可能需要最多 21 個工作天。",
  'Subscribers are encouraged to regularly check Cleanpro Plus for reminders regarding the expiry date of their laundry pass.': '購買者可定期查看 Cleanpro Plus，以取得 Laundry Pass到期日期的提醒。',
  "This promotion is not valid in conjunction with the '10 Free 1 e-Stamp Campaign'.": "此促銷配套不可與「10次免費1次電子印花活動」同時使用。",
  "Any misuse of the Laundry Pass will result in the immediate termination of the subscription without prior notice. Payments for the Laundry Pass are non-refundable, non-exchangeable for cash, and non-transferable.": "任何濫用Laundry Pass的行為將導致其 Laundry Pass立即被終止，且不事先通知。 Laundry Pass的付款不可退款、不可兌換現金、不可轉讓。",
  "Payment must be made in full at the time of subscription via Cleanpro Plus.": "購買者必須透過Cleanpro Plus一次性支付全額以購買或使用 Laundry Pass。",
  "For any questions or assistance regarding the Laundry Pass, please email Cleanpro Customer Service at enquiry@cleanpro.asia.": "如有任何疑問，請透過電子郵件聯絡Cleanpro客服： enquiry@cleanpro.asia。",
  "Cleanpro reserves the right to change the terms and conditions at any time without prior notice.": "Cleanpro保留在任何時間更改條款和條件的權利，恕不另行通知。",
  "Search": "搜尋",
  "Scan to register as a member": "掃描註冊成為會員",
  "Select Product / Key in Amount": "選擇產品/輸入金額",
  "Discount code is not available in this payment type": "此交易類型不適用折扣碼",
  "This voucher is not available use in washer payment": "此優惠券不可用於支付洗衣機交易",
  "This voucher is not available use in dryer payment": "此優惠券不可用於烘乾機交易",
  "This voucher is not available use in Drop n Go payment": "此優惠券不適用於 Drop n Go 交易",
  "Voucher is not available in this payment type": "此交易類型不適用優惠券",
  "Select the price for": "選擇價格",
  "Enable Stamping": "啟用郵票",
  "Please select your preferred outlet": "請選擇您喜愛的店鋪",
  "Select your preferred outlet": "選擇您喜愛的店鋪",
  "State": "州",
  "Select State": "選擇州",
  "Payment Successful!": "付款成功！",
  "Thank you for purchasing Laundry Pass!": "感謝您購買洗衣通行證！",
  "Your Laundry Pass expired on": "您的洗衣通行證已過期於",
  "You have used all your Laundry Pass": "您已使用完所有洗衣通行證",
  "Purchase Again": "再次購買",
  "Save Big!": "省大錢！",
  "You've saved": "您已節省",
  "on your package!": "在您的配套上",
  "Please select distributor, operator or outlet": "請選擇經銷商、經營者或店鋪",
  "Please enter your mobile phone number or e-mail": "請輸入您的手機號碼或電子郵件",
  "We’ll send you an SMS when your laundry’s ready": "當您的洗衣完成時，我們會發送簡訊通知您",
  "Skip": "跳過",
  "Notice": "注意",
  "User exists but not verified. Please verify your account by scanning the QR Code at Thank You Page.": "用戶存在但未驗證。請掃描感謝頁面的二維碼來驗證您的帳戶。",
  "User registered successfully. Please complete verification by scanning the QR Code at Thank You Page.": "用戶註冊成功。請掃描感謝頁面的二維碼完成驗證。",
  "Please enter email address to register": "請輸入電子郵件地址註冊",
  "Please enter phone number to register": "請輸入手機號碼註冊",
  "Camera permission is denied": "相機權限被拒絕",
  "No camera device found": "未找到攝影機設備",
  "Camera is already in use by another app": "相機已被其他應用程序使用",
  "Preferred Outlet": "首選店鋪",
  "Purchase Now": "趕快搶購",
  "Cancel Date": "取消日期",
  "Cancel Laundry Pass": "取消洗衣通行證",
  "Download or takes a screenshot of the QR code.": "下載或截圖二維碼。",
  "Launch and login banking app.": "啟動並登入銀行應用程式。",
  "Choose QR code from your gallery.": "從您的圖庫中選擇二維碼。",
  "1 March 2025 - 30 April 2025": "2025年3月1日 - 2025年4月30日",
  "Payment Method to get point": "獲取積分的支付方式",
  "Payment Method to get voucher": "取得優惠券的付款方式",
  "If applicable to all the payment method, leave it blank": "如果適用於所有付款方式，請留空",
  "Add {{ currency }} {{ amount }} for {{ mode }} Wash": "添加 {{ currency }} {{ amount }} 用於 {{ mode }} 洗滌",
  "Add {{ currency }} {{ amount }} for an extra {{ runtime }} minutes!": "添加 {{ currency }} {{ amount }} 即可額外獲得 {{ runtime }} 分鐘！",
  "via": "通過",
  "Cash": "現金",
  "Are you sure you have collected your laundry?": "確定您已經領取您的衣物了嗎？",
  "Collected All": "全部已領取",
  "Collected": "已領取",
  "Are you sure the customer have collected the laundry?": "您確定顧客已經領取了他們的衣物了嗎？",
  "Pending Payment (Cash)": "待付款（現金）",
  "You have received the cash payment": "您已收到現金付款",
  "Print Receipt": "打印收據",
  "Are you sure you want to print receipt?": "您確定要打印收據嗎？",
  "Are you sure you want to print sticker?": "您確定要打印貼紙嗎？",
  "Copy": "複製",
  "low": "低",
  "medium": "中等",
  "high": "高",
  "About Us": "關於我們",
  "ABOUT US": "關於我們",
  "Only can request einvoice for Malaysia Outlet": "僅限馬來西亞分店可申請電子發票",
  "E-Invoice requested successfully": "電子發票申請成功",
  "Select machine": "選擇機器",
  "Select transaction date": "選擇交易日期",
  "Transaction Time": "交易時間",
  "Select transaction time": "選擇交易時間",
  "Transaction Amount": "交易金額",
  "Enter Transaction Amount, Example: 1.50": "輸入交易金額，例如：1.50",
  "Select payment method": "選擇付款方式",
  "Cashless (e-Wallet / DuitNow QR)": "非現金（電子錢包/DuitNow QR）",
  "Paywave (Tap with Debit/Credit Card)": "Paywave（使用借記卡/信用卡付款）",
  "Request as": "請求為",
  "Individual": "個人",
  "Company": "公司",
  "ID Type": "身分證類型",
  "Select ID Type": "選擇身分證件類型",
  "Company Name": "公司名稱",
  "Phone": "電話",
  "Address": "地址",
  "City": "城市",
  "Postcode": "郵政編碼",
  "Request E-Invoice": "申請電子發票",
  "Request e-Invoice": "申請電子發票",
  "e-Invoice Validation Link": "電子發票驗證鏈接",
  "Credit Card": "信用卡",
  "Credit Card Number": "信用卡號碼",
  "Credit Card Expiry Month": "信用卡到期月份",
  "Credit Card Expiry Year": "信用卡到期年份",
  "Credit Card Securtiy Code": "信用卡安全碼",
  "Credit Card Holder Name": "信用卡持有人姓名",
  "Settlement Amount": "結算金額",
  "Paid": "已付款",
  "Enable E-Wallet Payment?": "啟用電子錢包支付嗎？",
  "Enable DuitNow Payment?": "啟用 DuitNow 支付？",
  "Enable Credit Card Terminal Payment?": "啟用信用卡終端支付？",
  "Transaction date is more than 3 days": "交易日期超過3天",
  "Select Recurrence Type": "選擇重複類型",
  "Multiple Voucher": "多重優惠券",
  "Period for giving next voucher (days)": "發送下一張優惠券的週期（天）",
  "General Voucher Code Report": "通用優惠券代碼報告",
  "Unique Voucher Code Report": "獨特優惠券代碼報告",
  "Select Code": "選擇代碼",
  "Minimum transaction amount to use code cannot be negative": "使用代碼的最低交易金額不能為負數",
  "Redeem per user must at least 1": "每用戶兌換次數至少為1",
  "Start date must before end date": "開始日期必須早於結束日期",
  "Please select the start date and end date": "請選擇開始日期和結束日期",
  "Please enter the voucher code": "請輸入優惠券代碼",
  "Successfully create the voucher code": "成功創建優惠券代碼",
  "General Voucher Code": "通用優惠券代碼",
  "Unique Voucher Code": "獨特優惠券代碼",
  "Add Voucher Code": "添加優惠券代碼",
  "How many times the voucher code can be used for each user": "每個用戶可以使用優惠券代碼多少次",
  "Update Version": "更新版本",
  "User profile updated successfully": "用戶資料更新成功",
  "Salutation": "稱呼",
  "Nationality": "國籍",
  "Race": "種族",
  "Gender": "性別",
  "Update salutation": "更新稱呼",
  "Update ID Type": "更新身分證類型",
  "Update Address": "更新地址",
  "Update nationality": "更新國籍",
  "Male": "男性",
  "Female": "女性",
  "Update gender": "更新性別",
  "Number of Point cannot be 0": "積分數量不能為0",
  "Token value cannot be 0": "代幣價值不能為0",
  "Activate": "啟用",
  "Deactivate": "停用",
  "Activate User": "啟用用戶",
  "Deactivate User": "停用用戶",
  "Are you sure you want to activate the user account?": "您確定要啟用用戶帳戶嗎？",
  "Are you sure you want to deactivate the user account?": "您確定要停用用戶帳戶嗎？",
  "Your point redemption is successful": "您的積分兌換成功",
  "Point Redemption": "積分兌換",
  "This redemption has already been completed": "此兌換已完成",
  "Transaction Details": "交易詳情",
  "Please login to redeem point": "請登錄以兌換積分",
  "Login as {{name}}": "以{{name}}身份登錄",
  "Payment Amount Settings": "付款金額設定",
  "Allow washer pay less than cheapest mode price?": "允許洗衣機支付低於最便宜模式的價格？",
  "Allow dryer pay less than minimum price?": "允許烘乾機支付低於最低價格？",
  "Drop n Go Settings": "自助投遞設定",
  "Allow user pay for specific service only?": "僅允許用戶為特定服務付款？",
  "Display pricing for each service?": "顯示每項服務的價格？",
  "Delete Voucher": "刪除優惠券",
  "Are you sure you want to delete this voucher?": "您確定要刪除此優惠券嗎？",
  "Display in Promotion Page": "在促銷頁面顯示",
  "Add Promotion": "添加促銷",
  "Select Transaction Status": "选择交易状态",
  "Give Stamp for Drop n Go Transaction?": "是否为 Drop n Go 交易提供印章？",
  "Display machine capacity?": "顯示機器容量？",
  "External Voucher Code": "外部優惠券代碼",
  "Import Voucher Code": "導入優惠券代碼",
  "Voucher Code Stamp Settings": "優惠券代碼印章設置",
  "Upload Date": "上傳日期",
  "Import External Voucher Code": "導入外部優惠券代碼",
  "Import": "導入",
  "Please select a valid CSV file": "請選擇有效的 CSV 文件",
  "Redeemed": "已兌換",
  "Sales": "銷售額",
  "Drop N Go Dashboard": "自助投遞儀表板",
  "Total Drop N Go Sales by Month": "總自助投遞銷售額按月統計",
  "Total Drop N Go Sales by Day": "總自助投遞銷售額按日統計",
}

const translationTh = {
  "LOGIN": "เข้าสู่ระบบ",
  "REGISTER": "ลงทะเบียน",
  "SKIP TO PAYMENT": "ข้ามไปยังการชำระเงิน",
  "Continue as guest": "ดำเนินการต่อในฐานะแขก",
  "WELCOME": "ยินดีต้อนรับ",
  "Error": "ข้อผิดพลาด",
  "Please enter the correct phone number format. <br /><br /> <small>Example: 0129465628</small>": "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง <br /><br /> <small>ตัวอย่าง: 0129465628</small>",
  "Info": "ข้อมูล",
  "Please scan QRCode to Login": "กรุณาสแกน QR Code เพื่อเข้าสู่ระบบ",
  "Forgot Password": "ลืมรหัสผ่าน",
  "Seems like you have forgotten your password<br />Create a temporary password?": "ดูเหมือนว่าคุณลืมรหัสผ่าน<br />ต้องการสร้างรหัสผ่านชั่วคราวหรือไม่?",
  "Cancel": "ยกเลิก",
  "Confirm": "ยืนยัน",
  "Reset Your Password": "รีเซ็ตรหัสผ่านของคุณ",
  "Enter Your Phone Number / Email Address": "กรอกหมายเลขโทรศัพท์ / ที่อยู่อีเมลของคุณ",
  "Enter Your Email Address": "กรอกที่อยู่อีเมลของคุณ",
  "Please enter phone number / email address": "กรุณากรอกหมายเลขโทรศัพท์ / ที่อยู่อีเมล",
  "Please enter email address": "กรุณากรอกที่อยู่อีเมล",
  "Submit": "ส่ง",
  "Please enter a valid phone number": "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
  "Please enter a valid email address": "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
  "Success!": "สำเร็จ!",
  "You may login using your one time password now.": "คุณสามารถเข้าสู่ระบบโดยใช้รหัสผ่านครั้งเดียวของคุณได้แล้ว",
  "Phone Number": "หมายเลขโทรศัพท์",
  "Password": "รหัสผ่าน",
  "Don't have an account?": "ยังไม่มีบัญชี?",
  "Forgot password?": "ลืมรหัสผ่าน?",
  "Unable to register without a QRCode": "ไม่สามารถลงทะเบียนได้โดยไม่มี QR Code",
  "Please read and agree to the privacy policies, terms and conditions": "กรุณาอ่านและยอมรับนโยบายความเป็นส่วนตัว ข้อกำหนดและเงื่อนไข",
  "Password length must be at least 6 characters": "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร",
  "Please enter the confirmation code that was sent to your phone": "กรุณากรอกรหัสยืนยันที่ถูกส่งไปยังเบอร์โทรศัพท์ของคุณ",
  "Example: 012xxxxxxx": "ตัวอย่าง: 012xxxxxxx",
  "Example: 09xxxxxxxx": "ตัวอย่าง: 09xxxxxxxx",
  "Verification Method": "วิธีการยืนยัน",
  "Name": "ชื่อ",
  "Email": "อีเมล",
  "optional": "ไม่บังคับ",
  "Birth Year": "ปีเกิด",
  "Year": "ปี",
  "Birth Month": "เดือนเกิด",
  "Month": "เดือน",
  "Jan": "ม.ค.",
  "Feb": "ก.พ.",
  "Mar": "มี.ค.",
  "April": "เม.ย.",
  "May": "พ.ค.",
  "June": "มิ.ย.",
  "July": "ก.ค.",
  "Aug": "ส.ค.",
  "Sept": "ก.ย.",
  "Oct": "ต.ค.",
  "Nov": "พ.ย.",
  "Dec": "ธ.ค.",
  "Birth Day": "วันเกิด",
  "Day": "วัน",
  "OTP": "รหัส OTP",
  "OTP Confirmation": "ยืนยันรหัส OTP",
  "I agree to the": "ฉันยอมรับ",
  "Privacy Policy": "นโยบายความเป็นส่วนตัว",
  "PRIVACY POLICY": "นโยบายความเป็นส่วนตัว",
  "and": "และ",
  "Terms": "ข้อกำหนด",
  "Conditions": "เงื่อนไข",
  "SEND CODE": "ส่งรหัส",
  "Our One-Time Password (OTP) emails might end up in your spam or junk folder. We kindly ask you to take a moment to check your spam mailbox.": "อีเมลรหัสผ่านแบบใช้ครั้งเดียว (OTP) ของเราอาจจะอยู่ในโฟลเดอร์สแปมหรือขยะของคุณ เราขอความกรุณาให้คุณใช้เวลาสักครู่เพื่อตรวจสอบกล่องจดหมายขยะ",
  "Already have an account? Login": "มีบัญชีอยู่แล้ว? เข้าสู่ระบบ",
  "Didn't receive a code?": "ไม่ได้รับรหัส?",
  "Resend Code": "ส่งรหัสอีกครั้ง",
  "collected": "เก็บสะสม",
  "Collect": "เก็บ",
  "stamps": "แสตมป์",
  "get 1 voucher": "รับ 1 คูปอง",
  "Minimum": "ขั้นต่ำ",
  "spending to collect each washer stamp": "การใช้จ่ายเพื่อรับแสตมป์เครื่องซักผ้าแต่ละอัน",
  "spending to collect each dryer stamp": "การใช้จ่ายเพื่อรับแสตมป์เครื่องอบผ้าแต่ละอัน",
  "spending to collect each stamp": "การใช้จ่ายเพื่อรับแสตมป์สะสมแต่ละดวง",
  "Device don't have a camera": "อุปกรณ์ไม่มีกล้อง",
  "This is not a valid QRCode": "นี่ไม่ใช่ QR Code ที่ถูกต้อง",
  "Select Camera": "เลือกกล้อง",
  "Switch": "สลับ",
  "Camera": "กล้อง",
  "Loading": "กำลังโหลด",
  "Scan the QR code on the machine.": "สแกน QR Code บนเครื่อง",
  "Switch Camera": "สลับกล้อง",
  "Off torch light": "ปิดไฟฉาย",
  "On torch light": "เปิดไฟฉาย",
  "switch camera if your camera is not clear": "สลับกล้องถ้ากล้องของคุณไม่ชัด",
  "Switch your camera if the display is not clear": "สลับกล้องของคุณถ้าการแสดงผลไม่ชัดเจน",
  "Please allow this webapp to access your camera": "กรุณาอนุญาตให้เว็บแอปนี้เข้าถึงกล้องของคุณ",
  "DISCOUNT": "ส่วนลด",
  "Congratulation": "ยินดีด้วย!",
  "Expired Date": "วันหมดอายุ",
  "Voucher": "คูปอง",
  "Vouchers": "คูปอง",
  "Something went wrong": "เกิดข้อผิดพลาดบางอย่าง",
  "Stamping Collection": "การสะสมแสตมป์",
  "Total e-Token": "e-Token ทั้งหมด",
  "Total Wash": "ซักทั้งหมด",
  "Total Dry": "อบทั้งหมด",
  "Reload": "เติมเงิน",
  "Washer": "เครื่องซัก",
  "Dryer": "เครื่องอบ",
  "Congratulations!": "ยินดีด้วย!",
  "You have completed your Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "คุณได้สะสมแสตมป์ครบแล้ว<br />คุณได้รับคูปองและการสะสมแสตมป์จะได้รับการรีเฟรช",
  "You have completed Washer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "คุณได้สะสมแสตมป์เครื่องซักครบแล้ว<br />คุณได้รับคูปองและการสะสมแสตมป์จะได้รับการรีเฟรช",
  "You have completed Dryer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "คุณได้สะสมแสตมป์เครื่องอบครบแล้ว<br />คุณได้รับคูปองและการสะสมแสตมป์จะได้รับการรีเฟรช",
  "Latest News": "ข่าวล่าสุด",
  "Transaction History": "ประวัติการทำธุรกรรม",
  "Stamping": "การสะสมแสตมป์",
  "Transaction": "ธุรกรรม",
  "News": "ข่าว",
  "Confirmation": "การยืนยัน",
  "Logout Session?": "ออกจากระบบ?",
  "NO": "ไม่",
  "OK": "ตกลง",
  "Account": "บัญชี",
  "FAQs": "คำถามที่พบบ่อย",
  "Feedback": "ความคิดเห็น",
  "LOGOUT": "ออกจากระบบ",
  "Logout": "ออกจากระบบ",
  "Are you sure you want to submit your feedback?": "คุณแน่ใจหรือไม่ว่าต้องการส่งความคิดเห็นของคุณ?",
  "No": "ไม่",
  "Yes": "ใช่",
  "Success": "สำเร็จ",
  "Failed": "ล้มเหลว",
  "Pending": "รอดำเนินการ",
  "Your feedback is submitted successfully": "ส่งความคิดเห็นของคุณสำเร็จแล้ว",
  "Please fill in all the required fields before submit.": "กรุณากรอกข้อมูลในช่องที่จำเป็นทั้งหมดก่อนส่ง",
  "Give us your feedback!": "ให้ความคิดเห็นกับเรา!",
  "Type your name here (optional)": "พิมพ์ชื่อของคุณที่นี่ (ไม่บังคับ)",
  "required": "จำเป็น",
  "Type your number here": "พิมพ์หมายเลขของคุณที่นี่",
  "Outlet": "สาขา",
  "Select an outlet": "เลือกสาขา",
  "Outlet Cleanliness": "ความสะอาดของสาขา",
  "Washer Machine Performance": "ประสิทธิภาพของเครื่องซัก",
  "Dryer Machine Performance": "ประสิทธิภาพของเครื่องอบ",
  "Customer Service": "บริการลูกค้า",
  "Comment": "ความคิดเห็น",
  "Type your comment here (optional)": "พิมพ์ความคิดเห็นของคุณที่นี่ (ไม่บังคับ)",
  "SUBMIT": "ส่ง",
  "Join as a member now!": "สมัครเป็นสมาชิกเดี๋ยวนี้!",
  "Join as a loyalty member now to get more benefits such as vouchers and free machine usage!<br /><br /><strong>Register as loyalty member?</strong>": "สมัครเป็นสมาชิกระดับสมาชิกตอนนี้ เพื่อรับสิทธิประโยชน์มากขึ้น เช่น คูปองและการใช้เครื่องฟรี!<br /><br /><strong>ลงทะเบียนเป็นสมาชิกระดับสมาชิก ใช่ไหม?</strong>",
  "Maybe Next Time": "อาจจะครั้งหน้า",
  "Yes, Register Now": "ใช่ ลงทะเบียนเลย",
  "Washer Payment": "การชำระเงินเครื่องซัก",
  "Dryer Payment": "การชำระเงินเครื่องอบ",
  "Vending Machine Payment": "การชำระเงินตู้จำหน่ายสินค้าอัตโนมัติ",
  "Online": "ออนไลน์",
  "Offline": "ออฟไลน์",
  "Running": "กำลังทำงาน",
  "Vacant": "ว่าง",
  "Vending Machine": "ตู้จำหน่ายสินค้าอัตโนมัติ",
  "Discount": "ส่วนลด",
  "No Vouchers Available": "ไม่มีคูปองที่ใช้ได้",
  "Payment Method": "วิธีการชำระเงิน",
  "Would you like to pay with?": "คุณต้องการชำระเงินด้วยวิธีใด?",
  "e-Token": "e-Token",
  "E-TOKEN": "E-TOKEN",
  "E-Wallet": "กระเป๋าเงินอิเล็กทรอนิกส์",
  "E-Wallet & Online Banking": "กระเป๋าเงินอิเล็กทรอนิกส์และธนาคารออนไลน์",
  "Duitnow QR code": "รหัส QR Duitnow",
  "PromptPay QR Code": "รหัส QR PromptPay",
  "The Duitnow QR code will be downloaded and you need to open your banking app to make the payment. Pay {{ currency }}{{ totalPaymentAmount }} to {{ machineName }}?": "รหัส QR Duitnow จะถูกดาวน์โหลดและคุณต้องเปิดแอปธนาคารของคุณเพื่อทำการชำระเงิน ชำระเงิน {{ currency }}{{ totalPaymentAmount }} ให้กับ {{ machineName }}?",
  "Pay": "ชำระเงิน",
  "to": "ถึง",
  "You may under utilized the voucher.": "คุณอาจใช้คูปองไม่เต็มประสิทธิภาพ",
  "Proceed to pay": "ดำเนินการชำระเงิน",
  "Processing ...": "กำลังดำเนินการ ...",
  "You can't pay with e-token if voucher is in used, please remove your voucher to pay with e-token.": "คุณไม่สามารถชำระเงินด้วย e-token ถ้ามีการใช้คูปอง กรุณาลบคูปองของคุณเพื่อชำระเงินด้วย e-token",
  "Insufficient e-Tokens": "e-Tokens ไม่เพียงพอ",
  "Reload your e-token now?": "เติม e-token ของคุณตอนนี้?",
  "Reload now!": "เติมเงินตอนนี้!",
  "You have": "คุณมี",
  "e-Tokens": "e-Tokens",
  "Tokens to": "Tokens ถึง",
  "This machine is currently offline, please try again later.": "เครื่องนี้กำลังปิด กรุณาลองใหม่อีกครั้งในภายหลัง",
  "MACHINE": "เครื่อง",
  "Machine": "เครื่อง",
  "TYPE": "ประเภท",
  "CAPACITY": "ความจุ",
  "DURATION": "ระยะเวลา",
  "Select Duration": "เลือกระยะเวลา",
  "AMOUNT TO PAY": "จำนวนเงินที่ต้องชำระ",
  "PRICE": "ราคา",
  "VOUCHER": "คูปอง",
  "Select Voucher >": "เลือกคูปอง >",
  "TOTAL": "รวม",
  "PAY": "ชำระเงิน",
  "Remove Voucher": "ลบคูปอง",
  "Select Your Voucher": "เลือกคูปองของคุณ",
  "min": "นาที",
  "MIN": "นาที",
  "Select Payment Amount": "เลือกจำนวนเงินที่ต้องชำระ",
  "Select Water Temperature": "เลือกอุณหภูมิน้ำ",
  "Select temperature": "เลือกอุณหภูมิ",
  "Select Temperature": "เลือกอุณหภูมิ",
  "Cold": "เย็น",
  "Warm": "อุ่น",
  "Hot": "ร้อน",
  "e-Tokens to": "e-Tokens ถึง",
  "No Purchase History": "ไม่มีประวัติการซื้อ",
  "e-tokens": "e-tokens",
  "No Promotions": "ไม่มีโปรโมชั่น",
  "New Password": "รหัสผ่านใหม่",
  "Back": "กลับ",
  "Buy this package?": "ซื้อแพ็คเกจนี้?",
  "Purchase": "ซื้อ",
  "e-Tokens for": "e-Tokens สำหรับ",
  "Reload Tokens": "เติม Tokens",
  "Are you sure you want to purchase {{ tokenAmount }} e-Token for {{ currency }}{{ paymentAmount }}?": "Are you sure you want to purchase {{ tokenAmount }} e-Token for {{ currency }}{{ paymentAmount }}?", // new translation
  "Current e-Token": "e-Token ปัจจุบัน",
  "Current point": "point ปัจจุบัน",
  "History": "ประวัติ",
  "Your profile picture has been updated!": "รูปโปรไฟล์ของคุณได้รับการอัปเดตแล้ว!",
  "Please only use png, jpg or jpeg file extension type": "กรุณาใช้เฉพาะไฟล์นามสกุล png, jpg หรือ jpeg",
  "Please only use image type file": "กรุณาใช้เฉพาะไฟล์ประเภทรูปภาพ",
  "User name has updated successfully!": "อัปเดตชื่อผู้ใช้สำเร็จแล้ว!",
  "Email Address updated successfully": "อัปเดตที่อยู่อีเมลสำเร็จแล้ว",
  "Phone number updated successfully": "อัปเดตหมายเลขโทรศัพท์สำเร็จแล้ว",
  "Password must be at least 6 characters": "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร",
  "Password updated successfully": "อัปเดตรหัสผ่านสำเร็จแล้ว",
  "User Settings": "การตั้งค่าผู้ใช้",
  "Profile Picture": "รูปโปรไฟล์",
  "Change Password": "เปลี่ยนรหัสผ่าน",
  "Do you want to submit your feedback?": "คุณต้องการส่งความคิดเห็นของคุณหรือไม่?",
  "Thank You!": "ขอบคุณ!",
  "Thank you for using our services.": "ขอบคุณที่ใช้บริการของเรา",
  "BACK TO HOMEPAGE": "กลับไปหน้าแรก",
  "How to pay?": "วิธีการชำระเงิน?",
  "Step 1": "ขั้นตอนที่ 1",
  "After scan the QR code on the machine, select either register new account, login your account or skip to payment.": "หลังจากสแกน QR code บนเครื่อง เลือกลงทะเบียนบัญชีใหม่ เข้าสู่ระบบบัญชีของคุณ หรือข้ามไปยังการชำระเงิน",
  "Step 2-1": "ขั้นตอนที่ 2-1",
  "For Dryer – Select your desired duration. Different duration will have different prices.": "สำหรับเครื่องอบ – เลือกระยะเวลาที่คุณต้องการ ระยะเวลาที่แตกต่างกันจะมีราคาที่แตกต่างกัน",
  "Step 2-2": "ขั้นตอนที่ 2-2",
  "For Washer – Select your desired water temperature. Different water temperature will have different prices.": "สำหรับเครื่องซัก – เลือกอุณหภูมิน้ำที่คุณต้องการ อุณหภูมิน้ำที่แตกต่างกันจะมีราคาที่แตกต่างกัน",
  "Step 3": "ขั้นตอนที่ 3",
  "For login user, Click on ‘Select Voucher’ to select your voucher.": "สำหรับผู้ใช้ที่เข้าสู่ระบบ คลิกที่ 'เลือกคูปอง' เพื่อเลือกคูปองของคุณ",
  "Step 4": "ขั้นตอนที่ 4",
  "Click on ‘PAY’ button to pay. For login user, select your payment method to pay.": "คลิกที่ปุ่ม 'ชำระเงิน' เพื่อชำระเงิน สำหรับผู้ใช้ที่เข้าสู่ระบบ เลือกวิธีการชำระเงินของคุณเพื่อชำระเงิน",
  "Step 5": "ขั้นตอนที่ 5",
  "After confirm the price and machine details, click on ‘OK’ button to pay.": "หลังจากยืนยันราคาและรายละเอียดเครื่อง คลิกที่ปุ่ม 'ตกลง' เพื่อชำระเงิน",
  "How to reload your e-Token?": "วิธีการเติม e-Token ของคุณ?",
  "Click on the \"Reload\" button.": "คลิกที่ปุ่ม \"เติมเงิน\"",
  "Select the package that you wish to purchase.": "เลือกแพ็คเกจที่คุณต้องการซื้อ",
  "Click on \"Purchase\" as confirmation before payment page.": "คลิกที่ \"ซื้อ\" เพื่อเป็นการยืนยันก่อนไปยังหน้าการชำระเงิน",
  "Is e-token can be refund/transfer back to e-wallet?": "e-token สามารถขอคืนเงิน/โอนกลับไปยังกระเป๋าเงินอิเล็กทรอนิกส์ได้หรือไม่?",
  "Why can't I applied my voucher?": "ทำไมฉันไม่สามารถใช้คูปองของฉันได้?",
  "When there is a Happy Hour Promotion is on going, you are unable to apply your voucher temporarily.": "เมื่อมีโปรโมชั่น Happy Hour กำลังดำเนินอยู่ คุณไม่สามารถใช้คูปองของคุณได้ชั่วคราว",
  "How to apply my voucher?": "วิธีการใช้คูปองของฉัน?",
  "Click on the \"Select Voucher\" button.": "คลิกที่ปุ่ม \"เลือกคูปอง\"",
  "Select the voucher that you wish to apply.": "เลือกคูปองที่คุณต้องการใช้",
  "Click on \"Pay\" once you have verified the voucher is successfully applied.": "คลิกที่ \"ชำระเงิน\" เมื่อคุณได้ตรวจสอบว่าคูปองถูกใช้สำเร็จแล้ว",
  "Step 2": "ขั้นตอนที่ 2",
  "Language has updated successfully!": "อัปเดตภาษาสำเร็จแล้ว!",
  "Change Language": "เปลี่ยนภาษา",
  "Language": "ภาษา",
  "Select language": "เลือกภาษา",
  "Referral Code": "รหัสแนะนำ",
  "Copied!": "คัดลอกแล้ว!",
  "Inviting friends to get more benefits!": "เชิญเพื่อนเพื่อรับสิทธิประโยชน์มากขึ้น!",
  "Would you like to share your referral code to your friends & family?": "คุณต้องการแชร์รหัสแนะนำของคุณให้กับเพื่อนและครอบครัวหรือไม่?",
  "Refer a friend and get": "แนะนำเพื่อนและรับ",
  "Share the love to your friends & family?": "แบ่งปันความรักให้กับเพื่อนและครอบครัวของคุณหรือไม่?",
  "voucher": "คูปอง",
  "token": "โทเคน",
  "stamp": "แสตมป์",
  "washer stamp": "แสตมป์เครื่องซัก",
  "dryer stamp": "แสตมป์เครื่องอบ",
  "Learn More": "เรียนรู้เพิ่มเติม",
  "Welcome Gift": "ของขวัญต้อนรับ",
  "Share Your Referral Code Now": "แชร์รหัสแนะนำของคุณตอนนี้",
  "Birthday Gift for You": "ของขวัญวันเกิดสำหรับคุณ",
  "Let's Pay with E-Token": "มาชำระเงินด้วย E-Token กัน",
  "Collect 10 Stamps and Get Voucher": "สะสมแสตมป์ 10 ดวงและรับคูปอง",
  "The voucher will be given if you registered your account successfully.": "คุณจะได้รับคูปองถ้าคุณลงทะเบียนบัญชีสำเร็จ",
  "There is no expiration date for this voucher.": "คูปองนี้ไม่มีวันหมดอายุ",
  "The voucher can be used for dryer machine only.": "คูปองนี้สามารถใช้ได้กับเครื่องอบเท่านั้น",
  "The voucher can be used for washer machine only.": "คูปองนี้สามารถใช้ได้กับเครื่องซักเท่านั้น",
  "The voucher can be used for Drop n Go transaction only.": "คูปองนี้สามารถใช้ได้กับธุรกรรม Drop n Go เท่านั้น",
  "The voucher can be used for vending transaction only.": "คูปองนี้ใช้ได้กับธุรกรรมตู้จำหน่ายสินค้าอัตโนมัติเท่านั้น",
  "The voucher can be used for detergent vending transaction only.": "คูปองนี้ใช้ได้กับธุรกรรมตู้จำหน่ายผงซักฟอกเท่านั้น",
  "The voucher can be used for car wash transaction only.": "คูปองนี้ใช้ได้กับธุรกรรมล้างรถเท่านั้น",
  "The voucher can be used for washer machine or Drop n Go transaction.": "คูปองนี้สามารถใช้ได้กับเครื่องซักหรือธุรกรรม Drop n Go",
  "The voucher can be used for dryer machine or Drop n Go transaction.": "คูปองนี้สามารถใช้ได้กับเครื่องอบหรือธุรกรรม Drop n Go",
  "The voucher can be used for dryer or washer machine.": "คูปองนี้สามารถใช้ได้กับเครื่องอบหรือเครื่องซัก",
  "The voucher can be used for washer machine, dryer machine or Drop n Go transaction.": "คูปองนี้สามารถใช้ได้กับเครื่องซัก เครื่องอบ หรือธุรกรรม Drop n Go",
  "The voucher can be used for washer machine or vending machine transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้าหรือตู้จำหน่ายสินค้าอัตโนมัติ",
  "The voucher can be used for washer machine or detergent vending machine transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้าหรือตู้จำหน่ายผงซักฟอก",
  "The voucher can be used for washer machine or car wash transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้าหรือล้างรถ",
  "The voucher can be used for dryer machine or vending machine transaction.": "คูปองนี้ใช้ได้กับเครื่องอบผ้าหรือตู้จำหน่ายสินค้าอัตโนมัติ",
  "The voucher can be used for dryer machine or detergent vending machine transaction.": "คูปองนี้ใช้ได้กับเครื่องอบผ้าหรือตู้จำหน่ายผงซักฟอก",
  "The voucher can be used for dryer machine or car wash transaction.": "คูปองนี้ใช้ได้กับเครื่องอบผ้าหรือล้างรถ",
  "The voucher can be used for vending machine or Drop n Go transaction.": "คูปองนี้ใช้ได้กับตู้จำหน่ายสินค้าอัตโนมัติหรือ Drop n Go",
  "The voucher can be used for detergent vending machine or Drop n Go transaction.": "คูปองนี้ใช้ได้กับตู้จำหน่ายผงซักฟอกหรือ Drop n Go",
  "The voucher can be used for car wash or Drop n Go transaction.": "คูปองนี้ใช้ได้กับล้างรถหรือ Drop n Go",
  "The voucher can be used for vending machine or detergent vending machine transaction.": "คูปองนี้ใช้ได้กับตู้จำหน่ายสินค้าอัตโนมัติหรือตู้จำหน่ายผงซักฟอก",
  "The voucher can be used for vending machine or car wash transaction.": "คูปองนี้ใช้ได้กับตู้จำหน่ายสินค้าอัตโนมัติหรือล้างรถ",
  "The voucher can be used for detergent vending machine or car wash transaction.": "คูปองนี้ใช้ได้กับตู้จำหน่ายผงซักฟอกหรือล้างรถ",
  "The voucher can be used for washer machine, dryer machine or vending machine transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า เครื่องอบผ้าหรือตู้จำหน่ายสินค้าอัตโนมัติ",
  "The voucher can be used for washer machine, dryer machine or detergent vending machine transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า เครื่องอบผ้าหรือตู้จำหน่ายผงซักฟอก",
  "The voucher can be used for washer machine, dryer machine or car wash transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า เครื่องอบผ้าหรือล้างรถ",
  "The voucher can be used for washer machine, vending machine or Drop n Go transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายสินค้าอัตโนมัติหรือ Drop n Go",
  "The voucher can be used for washer machine, detergent vending machine or Drop n Go transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายผงซักฟอกหรือ Drop n Go",
  "The voucher can be used for washer machine, car wash or Drop n Go transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า ล้างรถหรือ Drop n Go",
  "The voucher can be used for washer machine, vending machine or detergent vending transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายสินค้าอัตโนมัติหรือตู้จำหน่ายผงซักฟอก",
  "The voucher can be used for washer machine, vending machine or car wash transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายสินค้าอัตโนมัติหรือล้างรถ",
  "The voucher can be used for washer machine, detergent vending machine or car wash transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายผงซักฟอกหรือล้างรถ",
  "The voucher can be used for dryer machine, vending machine or Drop n Go transaction.": "คูปองนี้ใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายสินค้าอัตโนมัติหรือ Drop n Go",
  "The voucher can be used for dryer machine, detergent vending machine or Drop n Go transaction.": "คูปองนี้ใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายผงซักฟอกหรือ Drop n Go",
  "The voucher can be used for dryer machine, car wash or Drop n Go transaction.": "คูปองนี้ใช้ได้กับเครื่องอบผ้า ล้างรถหรือ Drop n Go",
  "The voucher can be used for dryer machine, vending machine or detergent vending machine transaction.": "คูปองนี้ใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายสินค้าอัตโนมัติหรือตู้จำหน่ายผงซักฟอก",
  "The voucher can be used for dryer machine, vending machine or car wash transaction.": "คูปองนี้ใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายสินค้าอัตโนมัติหรือล้างรถ",
  "The voucher can be used for dryer machine, detergent vending machine or car wash transaction.": "คูปองนี้ใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายผงซักฟอกหรือล้างรถ",
  "The voucher can be used for vending machine, detergent vending machine or Drop n Go transaction.": "คูปองนี้ใช้ได้กับตู้จำหน่ายสินค้าอัตโนมัติ ตู้จำหน่ายผงซักฟอกหรือ Drop n Go",
  "The voucher can be used for vending machine, car wash or Drop n Go transaction.": "คูปองนี้ใช้ได้กับตู้จำหน่ายสินค้าอัตโนมัติ ล้างรถหรือ Drop n Go",
  "The voucher can be used for detergent vending machine, car wash or Drop n Go transaction.": "คูปองนี้ใช้ได้กับตู้จำหน่ายผงซักฟอก ล้างรถหรือ Drop n Go",
  "The voucher can be used for vending machine, detergent vending machine or car wash transaction.": "คูปองนี้ใช้ได้กับตู้จำหน่ายสินค้าอัตโนมัติ ตู้จำหน่ายผงซักฟอกหรือล้างรถ",
  "The voucher can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายสินค้าอัตโนมัติหรือ Drop n Go",
  "The voucher can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายสินค้าอัตโนมัติหรือตู้จำหน่ายผงซักฟอก",
  "The voucher can be used for washer machine, dryer machine, vending machine or car wash transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายสินค้าอัตโนมัติหรือล้างรถ",
  "The voucher can be used for washer machine, dryer machine, detergent vending machine or car wash transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายผงซักฟอกหรือล้างรถ",
  "The voucher can be used for washer machine, vending macihne, detergent vending machine, car wash or Drop n Go transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายสินค้าอัตโนมัติ ตู้จำหน่ายผงซักฟอก ล้างรถหรือ Drop n Go",
  "The voucher can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "คูปองนี้ใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายสินค้าอัตโนมัติ ตู้จำหน่ายผงซักฟอก ล้างรถหรือ Drop n Go",
  "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "คูปองนี้ใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายสินค้าอัตโนมัติ ตู้จำหน่ายผงซักฟอก ล้างรถหรือ Drop n Go",
  "When you applied the voucher during payment, it will give you": "เมื่อคุณใช้คูปองระหว่างการชำระเงิน คุณจะได้รับ",
  "discount.": "ส่วนลด",
  "When promotion is on going, the voucher is not applicable.": "เมื่อมีโปรโมชั่นกำลังดำเนินอยู่ ไม่สามารถใช้คูปองได้",
  "The voucher cannot be used if your payment method is E-Token.": "ไม่สามารถใช้คูปองได้ถ้าวิธีการชำระเงินของคุณเป็น E-Token",
  "Your referral code can be found in user settings page.": "คุณสามารถพบรหัสแนะนำของคุณได้ในหน้าการตั้งค่าผู้ใช้",
  "You can get": "คุณสามารถรับ",
  "stamp for the reward.": "แสตมป์สำหรับรางวัล",
  "e-token for the reward.": "e-token สำหรับรางวัล",
  "e-token based on transaction payment amount for the reward.": "e-token ตามจำนวนเงินที่ชำระสำหรับรางวัล",
  "for the reward.": "สำหรับรางวัล",
  "based on transaction payment amount for the reward.": "ตามจำนวนเงินที่ชำระสำหรับรางวัล",
  "You can get a voucher for the reward": "คุณสามารถรับคูปองเป็นรางวัล",
  "which have": "ซึ่งมี",
  "it can be used for dryer machine only.": "สามารถใช้ได้กับเครื่องอบเท่านั้น",
  "it can be used for washer machine only.": "สามารถใช้ได้กับเครื่องซักเท่านั้น",
  "it can be used for Drop n Go transaction only.": "สามารถใช้ได้กับธุรกรรม Drop n Go เท่านั้น",
  "it can be used for vending machine only.": "ใช้ได้กับตู้จำหน่ายสินค้าอัตโนมัติเท่านั้น",
  "it can be used for car wash transaction only.": "ใช้ได้กับล้างรถเท่านั้น",
  "it can be used for detergent vending machine only.": "ใช้ได้กับตู้จำหน่ายผงซักฟอกเท่านั้น",
  "it can be used for dryer or washer machine.": "สามารถใช้ได้กับเครื่องอบหรือเครื่องซัก",
  "it can be used for dryer machine or Drop n Go transaction.": "สามารถใช้ได้กับเครื่องอบหรือธุรกรรม Drop n Go",
  "it can be used for washer machine or Drop n Go transaction.": "สามารถใช้ได้กับเครื่องซักหรือธุรกรรม Drop n Go",
  "it can be used for washer machine, dryer machine or Drop n Go transaction.": "สามารถใช้ได้กับเครื่องซัก เครื่องอบ หรือธุรกรรม Drop n Go",
  "it can be used for washer machine, dryer machine or vending machine transaction.": "ใช้ได้กับเครื่องซักผ้า เครื่องอบผ้าหรือตู้จำหน่ายสินค้าอัตโนมัติ",
  "it can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "ใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายสินค้าอัตโนมัติหรือ Drop n Go",
  "washer stamp for the reward.": "แสตมป์เครื่องซักสำหรับรางวัล",
  "dryer stamp for the reward.": "แสตมป์เครื่องอบสำหรับรางวัล",
  "washer stamp and": "แสตมป์เครื่องซักและ",
  "cleanproBirthdayShortDesc_one": "แลกรับคูปองวันเกิดมูลค่า {{ birthdayVoucherAmount }} เครดิตในวันพิเศษของคุณกับ Cleanpro Plus แตะเพื่อเรียนรู้เพิ่มเติม",
  "cleanproBirthdayShortDesc_other": "แลกรับคูปองวันเกิดมูลค่า {{ birthdayVoucherAmount }} เครดิตในวันพิเศษของคุณกับ Cleanpro Plus แตะเพื่อเรียนรู้เพิ่มเติม",
  "When you click on \"PAY\" button on the payment page, you can choose either using E-wallet or E-token to pay.": "เมื่อคุณคลิกที่ปุ่ม \"ชำระเงิน\" บนหน้าการชำระเงิน คุณสามารถเลือกใช้ E-wallet หรือ E-token เพื่อชำระเงินได้",
  "When you using your voucher during payment, you will be unable to pay with E-token.": "เมื่อคุณใช้คูปองของคุณระหว่างการชำระเงิน คุณจะไม่สามารถชำระเงินด้วย E-token ได้",
  "You can reload your E-token by clicking the reload button in the stamping page and select the package to purchase.": "คุณสามารถเติม E-token ของคุณได้โดยคลิกที่ปุ่มเติมเงินในหน้าสะสมแสตมป์และเลือกแพ็คเกจที่ต้องการซื้อ",
  "You can reload your E-token by clicking the reload button in the home page and select the package to purchase.": "คุณสามารถเติม E-token ของคุณได้โดยคลิกที่ปุ่มเติมเงินในหน้าหลักและเลือกแพ็คเกจที่ต้องการซื้อ",
  "You can view your E-token reload history and E-token transaction history in transaction page.": "คุณสามารถดูประวัติการเติม E-token และประวัติธุรกรรม E-token ได้ในหน้าธุรกรรม",
  "You can view your E-token transaction history in transaction page.": "คุณสามารถดูประวัติธุรกรรม E-token ได้ในหน้าธุรกรรม",
  "Using either dryer machine or washer machine with the minimum spending of": "ใช้เครื่องอบหรือเครื่องซักโดยมีการใช้จ่ายขั้นต่ำ",
  "to collect one stamp.": "เพื่อรับหนึ่งแสตมป์",
  "The voucher will be given if you have collected 10 stamps.": "คุณจะได้รับคูปองถ้าคุณสะสมแสตมป์ครบ 10 ดวง",
  "Using dryer machine with the minimum spending of": "ใช้เครื่องอบโดยมีการใช้จ่ายขั้นต่ำ",
  "Using washer machine with the minimum spending of": "ใช้เครื่องซักโดยมีการใช้จ่ายขั้นต่ำ",
  "to collect one dryer stamp.": "เพื่อรับหนึ่งแสตมป์เครื่องอบ",
  "to collect one washer stamp.": "เพื่อรับหนึ่งแสตมป์เครื่องซัก",
  "The voucher will be given if you have collected 10 dryer stamps or 10 washer stamps.": "คุณจะได้รับคูปองถ้าคุณสะสมแสตมป์เครื่องอบครบ 10 ดวงหรือแสตมป์เครื่องซักครบ 10 ดวง",
  "For the voucher given by the dryer stamps,": "สำหรับคูปองที่ได้รับจากแสตมป์เครื่องอบ",
  "For the voucher given by the washer stamps,": "สำหรับคูปองที่ได้รับจากแสตมป์เครื่องซัก",
  "When promotion is on going, all the vouchers is not applicable.": "เมื่อมีโปรโมชั่นกำลังดำเนินอยู่ ไม่สามารถใช้คูปองทั้งหมดได้",
  "All the vouchers cannot be used if your payment method is E-Token.": "ไม่สามารถใช้คูปองทั้งหมดได้ถ้าวิธีการชำระเงินของคุณเป็น E-Token",
  "Description": "คำอธิบาย",
  "Refer Friends": "แนะนำเพื่อน",
  "View our guideline": "ดูแนวทางของเรา",
  "When a friend / family register using your referral code, and completed a transaction with a minimum spending of": "เมื่อเพื่อน / ครอบครัวลงทะเบียนโดยใช้รหัสแนะนำของคุณ และทำธุรกรรมเสร็จสมบูรณ์โดยมีการใช้จ่ายขั้นต่ำ",
  ", you will be rewarded automatically.": " คุณจะได้รับรางวัลโดยอัตโนมัติ",
  "One user only allow to have": "ผู้ใช้หนึ่งคนสามารถมีได้เพียง",
  "referrals.": "การแนะนำ",
  "Confirmation Password": "ยืนยันรหัสผ่าน",
  "Password and confirmation password should be same.": "รหัสผ่านและการยืนยันรหัสผ่านควรเหมือนกัน",
  "You haven't applied your voucher": "คุณยังไม่ได้ใช้คูปองของคุณ",
  "Would you like to continue your payment without using your voucher?": "คุณต้องการดำเนินการชำระเงินต่อโดยไม่ใช้คูปองของคุณหรือไม่?",
  "Continue": "ดำเนินการต่อ",
  "Apply voucher": "ใช้คูปอง",
  "Transfer": "โอน",
  "Transfer Tokens": "โอนโทเคน",
  "Please fill in the phone number": "กรุณากรอกหมายเลขโทรศัพท์",
  "Please fill in the email": "กรุณากรอกอีเมล",
  "Please enter the phone number / email that you want to transfer to": "กรุณากรอกหมายเลขโทรศัพท์ / อีเมลที่คุณต้องการโอนไป",
  "Please fill in the transfer amount": "กรุณากรอกจำนวนเงินที่ต้องการโอน",
  "Transfer amount should be more than 0 and less than your current e-Token": "จำนวนเงินที่โอนควรมากกว่า 0 และน้อยกว่า e-Token ปัจจุบันของคุณ",
  "Please enter your password": "กรุณากรอกรหัสผ่านของคุณ",
  "Member ID": "รหัสสมาชิก",
  "E-Token Transfer Amount": "จำนวน E-Token ที่โอน",
  "Please confirm the details before proceeding": "กรุณายืนยันรายละเอียดก่อนดำเนินการต่อ",
  "Transfer From": "โอนจาก",
  "Transfer To": "โอนไปยัง",
  "Transfer Amount": "จำนวนเงินที่โอน",
  "Transfer Successfully!": "โอนสำเร็จ!",
  "Transfer Time": "เวลาที่โอน",
  "Token": "โทเคน",
  "Done": "เสร็จสิ้น",
  "Next": "ถัดไป",
  "Enter Password": "กรอกรหัสผ่าน",
  "Transfer E-Token Amount": "จำนวน E-Token ที่โอน",
  "User not found": "ไม่พบผู้ใช้",
  "Password is incorrect": "รหัสผ่านไม่ถูกต้อง",
  "Please go to your account setting and reset your password": "กรุณาไปที่การตั้งค่าบัญชีของคุณและรีเซ็ตรหัสผ่าน",
  "Only up to last 3 months transaction history": "ประวัติธุรกรรมย้อนหลังได้เพียง 3 เดือนเท่านั้น",
  "Reload History": "ประวัติการเติมเงิน",
  "Transfer History": "ประวัติการโอน",
  "{{ point }} History": "ประวัติ {{ point }}",
  "Only up to last 3 months reload history": "ประวัติการเติมเงินย้อนหลังได้เพียง 3 เดือนเท่านั้น",
  "Only up to last 3 months transfer history": "ประวัติการโอนย้อนหลังได้เพียง 3 เดือนเท่านั้น",
  "Only up to last 3 months {{ point }} history": "ประวัติ {{ point }}  3 เดือนล่าสุดเท่านั้น",
  "Only up to last 3 months laundry pass history": "Only up to last 3 months laundry pass history",
  "If require urgent response, please contact us through whatapp": "หากต้องการการตอบสนองด่วน กรุณาติดต่อเราผ่านทาง WhatsApp",
  "Please scan the QR code again": "กรุณาสแกน QR code อีกครั้ง",
  "Home": "หน้าหลัก",
  "Quick": "ด่วน",
  "Super": "ซุปเปอร์",
  "Premium": "พรีเมียม",
  "All users will have infinite referrals.": "ผู้ใช้ทุกคนจะมีการแนะนำไม่จำกัด",
  "Collect 10 stamps to get 1 Voucher": "สะสม 10 แสตมป์เพื่อรับ 1 คูปอง",
  "The voucher is only for customer use only, not for sale.": "คูปองนี้สำหรับลูกค้าใช้เท่านั้น ไม่สามารถขายได้",
  "Outlet is currently offline, please try again later": "สาขากำลังออฟไลน์ กรุณาลองใหม่อีกครั้งในภายหลัง",
  "The voucher will be given if you completed a transaction with a minimum spending of": "คุณจะได้รับคูปองถ้าคุณทำธุรกรรมเสร็จสมบูรณ์โดยมีการใช้จ่ายขั้นต่ำ",
  "The birthday voucher will be given on the first day of your birthday month.": "คูปองวันเกิดจะมอบให้ในวันแรกของเดือนเกิดของคุณ",
  "The voucher only will be given if you have exceed spending amount of": "คุณจะได้รับคูปองเฉพาะเมื่อคุณมีการใช้จ่ายเกินกว่า",
  "Pay with KiplePay": "ชำระเงินด้วย KiplePay",
  "Pay with Scan2Pay": "ชำระเงินด้วย Scan2Pay",
  "Pay with Razer": "ชำระเงินด้วย Razer",
  "Pay with HitPay": "ชำระเงินด้วย HitPay",
  "Pay with Duitnow QR": "ชำระเงินด้วย Duitnow QR",
  "Pay with PagBank": "ชำระเงินด้วย PagBank",
  "Pay with PromptPay QR": "ชำระเงินด้วย PromptPay QR",
  "Pay with Card": "ชำระเงินด้วยบัตร",
  "Pay with PayWay": "ชำระเงินด้วย PayWay",
  "DISCOUNT CODE": "รหัสส่วนลด",
  "Enter code >": "ป้อนรหัส >",
  "Enter Discount Code": "ป้อนรหัสส่วนลด",
  "Remove Code": "ลบรหัส",
  "Discount Code": "รหัสส่วนลด",
  "Close": "ปิด",
  "Please fill in your email address": "กรุณากรอกที่อยู่อีเมลของคุณ",
  "Notification": "การแจ้งเตือน",
  "Do you want to receive notification when wash cycle done?": "คุณต้องการรับการแจ้งเตือนเมื่อรอบการซักเสร็จสิ้นหรือไม่?",
  "pay extra": "จ่ายเพิ่ม",
  "Email Address": "ที่อยู่อีเมล",
  "Please fill in your phone number": "กรุณากรอกหมายเลขโทรศัพท์ของคุณ",
  "Invalid Phone Number": "หมายเลขโทรศัพท์ไม่ถูกต้อง",
  "Washing Complete": "ซักเสร็จสิ้น",
  "Drying Complete": "อบแห้งเสร็จสิ้น",
  "The voucher will be given if you registered your account successfully, but it only can be used when your total transaction spending reach": "คุณจะได้รับคูปองถ้าคุณลงทะเบียนบัญชีสำเร็จ แต่สามารถใช้ได้เมื่อการใช้จ่ายธุรกรรมรวมของคุณถึง",
  "and above.": "และมากกว่า",
  "This voucher is not applicable": "คูปองนี้ไม่สามารถใช้ได้",
  "Finish in": "เสร็จใน",
  "Need to refresh to update": "ต้องรีเฟรชเพื่ออัปเดต",
  "It's indicative and may change based on washer load": "เป็นเพียงตัวบ่งชี้และอาจเปลี่ยนแปลงตามโหลดของเครื่องซักผ้า",
  "We'll let you know when it's ready to pick up": "เราจะแจ้งให้คุณทราบเมื่อสินค้าพร้อมให้รับ",
  "FREE": "ฟรี",
  "Enter voucher code (if got any)": "ป้อนรหัสคูปอง (ถ้ามี)",
  "Please fill in the voucher code": "กรุณากรอกรหัสคูปอง",
  "Available On": "ใช้ได้เมื่อ",
  "Apply": "ใช้",
  "Enter a code": "ป้อนรหัส",
  "Input Promo Code": "ป้อนรหัสโปรโมชั่น",
  "Voucher is redeemed successfully!": "แลกคูปองสำเร็จ!",
  "Not available": "ไม่พร้อมใช้งาน",
  "Unable to register": "ไม่สามารถลงทะเบียนได้",
  "Drop n Go Service": "บริการ Drop n Go",
  "Select Mode": "เลือกโหมด",
  "Quantity": "จำนวน",
  "Pack": "แพ็ค",
  "Add more": "เพิ่มเติม",
  "Select Size": "เลือกขนาด",
  "Select Services": "เลือกบริการ",
  "Are you sure to delete the item?": "คุณแน่ใจหรือไม่ที่จะลบรายการนี้?",
  "Delete": "ลบ",
  "Your Duitnow QR code": "รหัส QR Duitnow ของคุณ",
  "Your PromptPay QR code": "รหัส QR PromptPay ของคุณ",
  "How to pay using Duitnow QR code?": "วิธีการชำระเงินโดยใช้รหัส QR Duitnow?",
  "How to pay using PromptPay QR code?": "วิธีการชำระเงินโดยใช้รหัส QR PromptPay?",
  "Launch": "เปิด",
  "Launch your preferred Mobile Banking or eWallet app.": "เปิดแอปธนาคารบนมือถือหรือกระเป๋าเงินอิเล็กทรอนิกส์ที่คุณต้องการ",
  "Scan QR code from Gallery": "สแกนรหัส QR จากแกลเลอรี่",
  "Choose DuitNow QR from your gallery.": "เลือก DuitNow QR จากแกลเลอรี่ของคุณ",
  "Confirm payment details and pay.": "ยืนยันรายละเอียดการชำระเงินและชำระเงิน",
  "Receive payment confirmation.": "รับการยืนยันการชำระเงิน",
  "expiring on": "หมดอายุวันที่",
  "Expired on": "หมดอายุวันที่",
  "based on transaction payment amount": "ตามจำนวนเงินที่ชำระ",
  "Join as our": "เข้าร่วมเป็น",
  "Loyalty Member": "สมาชิก",
  "now to get more reward": "ตอนนี้เพื่อรับรางวัลเพิ่มเติม",
  "Payment amount should be greater than 0": "จำนวนเงินที่ชำระต้องมากกว่า 0",
  // admin portal
  "Dashboard": "แดชบอร์ด",
  "Report": "รายงาน",
  "Store Performance": "ประสิทธิภาพของร้าน",
  "User Performance": "ประสิทธิภาพของผู้ใช้",
  "Voucher Redemption": "การแลกคูปอง",
  "Token Report": "รายงานโทเคน",
  "SMS Report": "รายงาน SMS",
  "Discount Code Report": "รายงานรหัสส่วนลด",
  "User Details": "รายละเอียดผู้ใช้",
  "User Compensation": "การชดเชยผู้ใช้",
  "Voucher Settings": "การตั้งค่าคูปอง",
  "Token Settings": "การตั้งค่าโทเคน",
  "Referral Settings": "การตั้งค่าการแนะนำ",
  "Voucher Code": "รหัสคูปอง",
  "Customize Color": "ปรับแต่งสี",
  "User Migration": "การย้ายผู้ใช้",
  "Back To": "กลับไปยัง",
  "Eligibility": "คุณสมบัติ",
  "If ticked, the voucher will have expired date": "ถ้าติ๊ก คูปองจะมีวันหมดอายุ",
  "Expiry": "วันหมดอายุ",
  "If ticked, the voucher can apply to washer machine transaction": "ถ้าติ๊ก คูปองสามารถใช้กับธุรกรรมเครื่องซักได้",
  "Washer Use": "ใช้กับเครื่องซัก",
  "If ticked, the voucher can apply to dryer machine transaction": "ถ้าติ๊ก คูปองสามารถใช้กับธุรกรรมเครื่องอบได้",
  "Dryer Use": "ใช้กับเครื่องอบ",
  "If ticked, the voucher can apply to Drop n Go transaction": "ถ้าติ๊ก คูปองสามารถใช้กับธุรกรรม Drop n Go ได้",
  "Package Use": "ใช้กับแพ็คเกจ",
  "If ticked, the voucher can apply to vending machine transaction": "หากเลือก คูปองสามารถใช้กับธุรกรรมตู้จำหน่ายสินค้าอัตโนมัติได้",
  "Vending Use": "ใช้กับตู้จำหน่ายสินค้า",
  "If ticked, the voucher can apply to detergent vending machine transaction": "หากเลือก คูปองสามารถใช้กับธุรกรรมตู้จำหน่ายผงซักฟอกได้",
  "Detergent Use": "ใช้กับตู้จำหน่ายผงซักฟอก",
  "If ticked, the voucher can apply to car wash transaction": "หากเลือก คูปองสามารถใช้กับธุรกรรมล้างรถได้",
  "Car Wash Use": "ใช้กับล้างรถ",
  "Voucher Lifespan": "อายุการใช้งานของคูปอง",
  "days": "วัน",
  "Discount Type": "ประเภทส่วนลด",
  "Select a discount type": "เลือกประเภทส่วนลด",
  "Flat": "คงที่",
  "Rate": "อัตรา",
  "Voucher Title": "ชื่อคูปอง",
  "Voucher Description": "คำอธิบายคูปอง",
  "Voucher Amount": "จำนวนคูปอง",
  "CONFIRM": "ยืนยัน",
  "If ticked, the system will give voucher to user who completed washer stamp collection": "ถ้าติ๊ก ระบบจะให้คูปองกับผู้ใช้ที่สะสมแสตมป์เครื่องซักครบ",
  "If ticked, the system will give voucher to user who completed dryer stamp collection": "ถ้าติ๊ก ระบบจะให้คูปองกับผู้ใช้ที่สะสมแสตมป์เครื่องอบครบ",
  "If ticked, the user only can get/use the voucher after make a transaction": "ถ้าติ๊ก ผู้ใช้จะสามารถรับ/ใช้คูปองได้หลังจากทำธุรกรรมเท่านั้น",
  "Pay And Get Voucher": "ชำระเงินและรับคูปอง",
  "Pay And Use Code": "ชำระเงินและใช้รหัส",
  "If ticked, the system will only give the voucher to user after the user make a transaction": "ถ้าติ๊ก ระบบจะให้คูปองกับผู้ใช้หลังจากผู้ใช้ทำธุรกรรมเท่านั้น",
  "If ticked, the system will give voucher to user who completed registration process": "ถ้าติ๊ก ระบบจะให้คูปองกับผู้ใช้ที่ลงทะเบียนเสร็จสมบูรณ์",
  "If ticked, the system will give voucher to user on their birthday month": "ถ้าติ๊ก ระบบจะให้คูปองกับผู้ใช้ในเดือนเกิดของพวกเขา",
  "If ticked, the system will give voucher to user who completed stamp collection": "ถ้าติ๊ก ระบบจะให้คูปองกับผู้ใช้ที่สะสมแสตมป์ครบ",
  "Minimum Payment Amount To Get/Use Register Voucher": "จำนวนเงินขั้นต่ำในการชำระเงินเพื่อรับ/ใช้คูปองลงทะเบียน",
  "Voucher Method": "วิธีการคูปอง",
  "Select a voucher method": "เลือกวิธีการคูปอง",
  "The user directly get the voucher after register but only can use it after make transaction": "ผู้ใช้จะได้รับคูปองทันทีหลังจากลงทะเบียน แต่สามารถใช้ได้หลังจากทำธุรกรรมเท่านั้น",
  "The user only can get voucher after make a transaction": "ผู้ใช้จะสามารถรับคูปองได้หลังจากทำธุรกรรมเท่านั้น",
  "Minimum Payment Amount To Get Birthday Voucher": "จำนวนเงินขั้นต่ำในการชำระเงินเพื่อรับคูปองวันเกิด",
  "Minimum Payment Amount To Use Discount Code": "จำนวนเงินขั้นต่ำในการชำระเงินเพื่อใช้รหัสส่วนลด",
  "Outlets": "สาขา",
  "E-Payment Sales": "ยอดขายการชำระเงินอิเล็กทรอนิกส์",
  "Number of stamps granted to users": "จำนวนแสตมป์ที่มอบให้ผู้ใช้",
  "Total number of stamps granted": "จำนวนแสตมป์ทั้งหมดที่มอบให้",
  "Registered Users": "ผู้ใช้ที่ลงทะเบียน",
  "Stamps": "แสตมป์",
  "Referral": "การแนะนำ",
  "Register": "ลงทะเบียน",
  "Top Outlets": "สาขายอดนิยม",
  "Users": "ผู้ใช้",
  "Sort by": "เรียงตาม",
  "Top Users": "ผู้ใช้ยอดนิยม",
  "User name": "ชื่อผู้ใช้",
  "Number": "หมายเลข",
  "Spending": "การใช้จ่าย",
  "Number of registered users": "จำนวนผู้ใช้ที่ลงทะเบียน",
  "Number of voucher given to users": "จำนวนคูปองที่มอบให้ผู้ใช้",
  "Total number of voucher given": "จำนวนคูปองทั้งหมดที่มอบให้",
  "Voucher Type": "ประเภทคูปอง",
  "Voucher Value": "มูลค่าคูปอง",
  "Date": "วันที่",
  "Discount Code Type": "ประเภทรหัสส่วนลด",
  "Discount Code Amount": "จำนวนรหัสส่วนลด",
  "Number of Redemption": "จำนวนการแลก",
  "Total Discount Amount": "จำนวนส่วนลดทั้งหมด",
  "Select Outlet": "เลือกสาขา",
  "Select Date": "เลือกวันที่",
  "Select Transaction Date": "เลือกวันที่ทำธุรกรรม",
  "Reset": "รีเซ็ต",
  "Download Report": "ดาวน์โหลดรายงาน",
  "Please fill in the remark": "กรุณากรอกหมายเหตุ",
  "Transaction Date": "วันที่ทำธุรกรรม",
  "Machine Type": "ประเภทเครื่อง",
  "Machine Capacity": "ความจุของเครื่อง",
  "Total Amount": "จำนวนเงินทั้งหมด",
  "Payment Amount": "จำนวนเงินที่ชำระ",
  "Discount From": "ส่วนลดจาก",
  "Discount Amount": "จำนวนส่วนลด",
  "Action": "การดำเนินการ",
  "Remark": "หมายเหตุ",
  "Refund Date": "วันที่คืนเงิน",
  "Refund": "คืนเงิน",
  "Purchase Date": "วันที่ซื้อ",
  "e-Token Purchased (Tokens)": "e-Token ที่ซื้อ (โทเคน)",
  "Bought e-Token using": "ซื้อ e-Token โดยใช้",
  "Transaction ID": "รหัสธุรกรรม",
  "Method": "วิธีการ",
  "Requery": "สอบถามซ้ำ",
  "Reward Date": "วันที่ให้รางวัล",
  "Reward Type": "ประเภทรางวัล",
  "Notification Method": "วิธีการแจ้งเตือน",
  "Email Preview": "ตัวอย่างอีเมล",
  "Message for User": "ข้อความสำหรับผู้ใช้",
  "SMS will send to user, please enter the message less than 130 characters": "SMS will send to user, please enter the message less than 130 characters", // new translation
  "Enter the message to be sent to the user": "ป้อนข้อความที่จะส่งถึงผู้ใช้",
  "Email Address to show on Email Template": "ที่อยู่อีเมลที่จะแสดงบนเทมเพลตอีเมล",
  "Input Company Email Address": "ป้อนที่อยู่อีเมลของบริษัท",
  "Company Name to show on Email Template": "ชื่อบริษัทที่จะแสดงบนเทมเพลตอีเมล",
  "Input Company Name": "ป้อนชื่อบริษัท",
  "Company Phone No. to show on Email Template": "หมายเลขโทรศัพท์ของบริษัทที่จะแสดงบนเทมเพลตอีเมล",
  "Input Company Phone No.": "ป้อนหมายเลขโทรศัพท์ของบริษัท",
  "Voucher ID": "รหัสคูปอง",
  "Washer Stamp": "แสตมป์เครื่องซัก",
  "Dryer Stamp": "แสตมป์เครื่องอบ",
  "e-Token Amount": "จำนวน e-Token",
  "Transfer Date": "วันที่โอน",
  "Transfer Amount (Token)": "จำนวนที่โอน (โทเคน)",
  "Number (Transfer From)": "หมายเลข (โอนจาก)",
  "Name (Transfer From)": "ชื่อ (โอนจาก)",
  "Member ID (Transfer From)": "รหัสสมาชิก (โอนจาก)",
  "Number (Transfer To)": "หมายเลข (โอนไปยัง)",
  "Name (Transfer To)": "ชื่อ (โอนไปยัง)",
  "Member ID (Transfer To)": "รหัสสมาชิก (โอนไปยัง)",
  "Grant Date": "วันที่มอบให้",
  "Claim Date": "วันที่เรียกร้อง",
  "Member Details Report": "รายงานรายละเอียดสมาชิก",
  "Transaction Status": "สถานะธุรกรรม",
  "Token Reload": "เติมโทเคน",
  "Token Transfer": "โอนโทเคน",
  "Voucher History": "ประวัติคูปอง",
  "TOKEN": "โทเคน",
  "Message Sent": "ข้อความที่ส่ง",
  "Date Sent": "วันที่ส่ง",
  "Remaining SMS Credit": "เครดิต SMS ที่เหลือ",
  "Store": "ร้าน",
  "Total Registered Users": "จำนวนผู้ใช้ที่ลงทะเบียนทั้งหมด",
  "User registered but no transaction record": "ผู้ใช้ลงทะเบียนแต่ไม่มีประวัติธุรกรรม",
  "Registered": "ลงทะเบียนแล้ว",
  "User spending is less than": "การใช้จ่ายของผู้ใช้น้อยกว่า",
  "Active": "ใช้งาน",
  "User spending is from": "การใช้จ่ายของผู้ใช้ตั้งแต่",
  "until": "จนถึง",
  "Tier 1": "ระดับ 1",
  "User spending is": "การใช้จ่ายของผู้ใช้คือ",
  "and above": "และสูงกว่า",
  "Tier 2": "ระดับ 2",
  "Average spending in each transaction": "การใช้จ่ายเฉลี่ยในแต่ละธุรกรรม",
  "Average Spending": "การใช้จ่ายเฉลี่ย",
  "Total number of transactions": "จำนวนธุรกรรมทั้งหมด",
  "Total Transactions": "ธุรกรรมทั้งหมด",
  "Number of vouchers used in all the transactions": "จำนวนคูปองที่ใช้ในธุรกรรมทั้งหมด",
  "Voucher Claimed": "คูปองที่เรียกร้อง",
  "Total number of washer machine transactions": "จำนวนธุรกรรมเครื่องซักทั้งหมด",
  "Washer Usage": "การใช้งานเครื่องซัก",
  "Total number of dryer machine transactions": "จำนวนธุรกรรมเครื่องอบทั้งหมด",
  "Dryer Usage": "การใช้งานเครื่องอบ",
  "User Name": "ชื่อผู้ใช้",
  "e-Token Spent": "e-Token ที่ใช้ไป",
  "e-Token Detailed Report": "รายงานรายละเอียด e-Token",
  "e-Token Purchase History": "ประวัติการซื้อ e-Token",
  "Select Purchase Date": "เลือกวันที่ซื้อ",
  "Outlet Name": "ชื่อสาขา",
  "Total number of e-token used in all the transactions": "จำนวน e-token ทั้งหมดที่ใช้ในธุรกรรมทั้งหมด",
  "Total e-Token Collected": "e-Token ทั้งหมดที่เก็บได้",
  "Total number of e-token used in washer machine transactions": "จำนวน e-token ทั้งหมดที่ใช้ในธุรกรรมเครื่องซัก",
  "Washer e-Token Collected": "e-Token เครื่องซักที่เก็บได้",
  "Total number of e-token used in dryer machine transactions": "จำนวน e-token ทั้งหมดที่ใช้ในธุรกรรมเครื่องอบ",
  "Dryer e-Token Collected": "e-Token เครื่องอบที่เก็บได้",
  "Vending Machine e-Token Collected": "รวบรวม e-Token จากเครื่องจำหน่ายสินค้าอัตโนมัติ",
  "Purchase History": "ประวัติการซื้อ",
  "All": "ทั้งหมด",
  "Most Bought e-Token Package": "แพ็คเกจ e-Token ที่ซื้อมากที่สุด",
  "for": "สำหรับ",
  "Tokens": "โทเคน",
  "Total Earned from users buying e-Tokens": "รายได้รวมจากผู้ใช้ที่ซื้อ e-Tokens",
  "Total e-Tokens Bought from you": "e-Tokens ทั้งหมดที่ซื้อจากคุณ",
  "Join Date": "วันที่เข้าร่วม",
  "Channel": "ช่องทาง",
  "Tier": "ระดับ",
  "Referrer": "ผู้แนะนำ",
  "Referrals": "การแนะนำ",
  "Number of transactions for last 7 days": "จำนวนธุรกรรมใน 7 วันที่ผ่านมา",
  "Number of Usage (in week)": "จำนวนการใช้งาน (ในสัปดาห์)",
  "Number of transactions for last 1 month": "จำนวนธุรกรรมใน 1 เดือนที่ผ่านมา",
  "Number of Usage (in month)": "จำนวนการใช้งาน (ในเดือน)",
  "Total amount spent in all the transactions": "จำนวนเงินรวมที่ใช้ในธุรกรรมทั้งหมด",
  "Total Spent": "การใช้จ่ายรวม",
  "Last Transaction Date": "วันที่ทำธุรกรรมล่าสุด",
  "Number of vouchers collected": "จำนวนคูปองที่เก็บได้",
  "Voucher Collected": "คูปองที่เก็บได้",
  "Number of vouchers used": "จำนวนคูปองที่ใช้",
  "Voucher Spent": "คูปองที่ใช้ไป",
  "Washer Used": "เครื่องซักที่ใช้",
  "Dryer Used": "เครื่องอบที่ใช้",
  "Total number of e-Token spent in all the transactions": "จำนวน e-Token ทั้งหมดที่ใช้ในธุรกรรมทั้งหมด",
  "Total number of stamps collected": "จำนวนแสตมป์ทั้งหมดที่เก็บได้",
  "Total Stamps": "แสตมป์ทั้งหมด",
  "Select Join Date": "เลือกวันที่เข้าร่วม",
  "Select Grant Date": "เลือกวันที่มอบให้",
  "Amount": "จำนวน",
  "The image size is over 2MB": "ขนาดรูปภาพเกิน 2MB",
  "Duplicate language selected": "เลือกภาษาซ้ำ",
  "Are you sure you want to add FAQ?": "คุณแน่ใจหรือไม่ที่จะเพิ่มคำถามที่พบบ่อย?",
  "FAQ added successfully": "เพิ่มคำถามที่พบบ่อยสำเร็จ",
  "FAQ Group added successfully": "เพิ่มกลุ่มคำถามที่พบบ่อยสำเร็จ",
  "Please provide the faq with the default language": "กรุณาระบุคำถามที่พบบ่อยพร้อมภาษาเริ่มต้น",
  "Add FAQ": "เพิ่มคำถามที่พบบ่อย",
  "Default Language": "ภาษาเริ่มต้น",
  "Select Default Language": "เลือกภาษาเริ่มต้น",
  "Image (Optional)": "รูปภาพ (ไม่บังคับ)",
  "max": "สูงสุด",
  "Question": "คำถาม",
  "Select Language": "เลือกภาษา",
  "Remove": "ลบ",
  "Answer": "คำตอบ",
  "Add Translation": "เพิ่มการแปล",
  "Are you sure you want to add FAQ Group?": "คุณแน่ใจหรือไม่ที่จะเพิ่มกลุ่มคำถามที่พบบ่อย?",
  "Please provide the faq group with the default language": "กรุณาระบุกลุ่มคำถามที่พบบ่อยด้วยภาษาเริ่มต้น",
  "Add FAQ Group": "เพิ่มกลุ่มคำถามที่พบบ่อย",
  "Title": "หัวข้อ",
  "Title Language": "ภาษาของหัวข้อ",
  "Please fill in the title": "กรุณากรอกหัวข้อ",
  "Please fill in the description": "กรุณากรอกคำอธิบาย",
  "Please fill in the short description": "กรุณากรอกคำอธิบายสั้นๆ",
  "Please select the end date for your news": "กรุณาเลือกวันที่สิ้นสุดสำหรับข่าวสารของคุณ",
  "Please provide the news with the default language": "กรุณาระบุข่าวสารด้วยภาษาเริ่มต้น",
  "Please provide the banner image": "กรุณาระบุรูปภาพแบนเนอร์",
  "Please provide the news image": "กรุณาระบุรูปภาพข่าวสาร",
  "Are you sure you want to add news?": "คุณแน่ใจหรือไม่ที่จะเพิ่มข่าวสาร?",
  "News added successfully": "เพิ่มข่าวสารสำเร็จ",
  "Please fill in all the required fields before submit": "กรุณากรอกข้อมูลในช่องที่จำเป็นทั้งหมดก่อนส่ง",
  "Add News": "เพิ่มข่าว",
  "Banner Image": "รูปภาพแบนเนอร์",
  "News Image": "รูปภาพข่าวสาร",
  "Banner": "แบนเนอร์",
  "aspect ratio": "อัตราส่วนภาพ",
  "Image": "รูปภาพ",
  "Display in": "แสดงใน",
  "Inbox Page": "หน้ากล่องข้อความ",
  "Promotion Banner": "แบนเนอร์โปรโมชั่น",
  "Select Period: (optional)": "เลือกช่วงเวลา: (ไม่บังคับ)",
  "Short Description": "คำอธิบายสั้น",
  "Your theme has been updated successfully": "อัปเดตธีมของคุณสำเร็จแล้ว",
  "Default Theme": "ธีมเริ่มต้น",
  "Change Logo": "เปลี่ยนโลโก้",
  "REMOVE LOGO": "ลบโลโก้",
  "Sms credit used up": "เครดิต SMS หมดแล้ว",
  "Please top up your sms credit": "กรุณาเติมเครดิต SMS ของคุณ",
  "Please": "กรุณา",
  "Again": "อีกครั้ง",
  "Welcome": "ยินดีต้อนรับ",
  "Ranking": "อันดับ",
  "Select Year": "เลือกปี",
  "Missing Field": "ช่องที่ขาดหายไป",
  "Please select can be used for which type of transaction": "กรุณาเลือกว่าสามารถใช้กับธุรกรรมประเภทใด",
  "Please fill in the start date and end date": "กรุณากรอกวันที่เริ่มต้นและวันที่สิ้นสุด",
  "Discount amount should be more than 0": "จำนวนส่วนลดควรมากกว่า 0",
  "Redeem per user should be more than 0": "การแลกต่อผู้ใช้ควรมากกว่า 0",
  "Redeem per day should be more than 0": "การแลกต่อวันควรมากกว่า 0",
  "Your discount code have edited successfully": "แก้ไขรหัสส่วนลดของคุณสำเร็จแล้ว",
  "Your discount code have added successfully": "เพิ่มรหัสส่วนลดของคุณสำเร็จแล้ว",
  "Delete this entry?": "ลบรายการนี้?",
  "Your discount code have deleted successfully": "ลบรหัสส่วนลดของคุณสำเร็จแล้ว",
  "Created Date": "วันที่สร้าง",
  "Discount code": "รหัสส่วนลด",
  "General Discount Code": "รหัสส่วนลดทั่วไป",
  "Unique Discount Code": "รหัสส่วนลดเฉพาะ",
  "Start Date": "วันที่เริ่มต้น",
  "End Date": "วันที่สิ้นสุด",
  "Redeem Per User": "แลกรับต่อผู้ใช้",
  "Redeem Per Day": "แลกรับต่อวัน",
  "Add Discount Code": "เพิ่มรหัสส่วนลด",
  "Generate Discount Code": "สร้างรหัสส่วนลด",
  "No Discount Code": "ไม่มีรหัสส่วนลด",
  "Edit Discount Code": "แก้ไขรหัสส่วนลด",
  "Select Period": "เลือกช่วงเวลา",
  "Redeem per user": "แลกรับต่อผู้ใช้",
  "How many times the discount code can be used for each user": "รหัสส่วนลดสามารถใช้ได้กี่ครั้งสำหรับผู้ใช้แต่ละคน",
  "Redeem per day": "แลกต่อวัน",
  "How many times the discount code can be used in one day": "รหัสส่วนลดสามารถใช้ได้กี่ครั้งในหนึ่งวัน",
  "If ticked, the discount code can apply to washer machine transaction": "ถ้าติ๊ก รหัสส่วนลดสามารถใช้กับธุรกรรมเครื่องซักได้",
  "If ticked, the discount code can apply to dryer machine transaction": "ถ้าติ๊ก รหัสส่วนลดสามารถใช้กับธุรกรรมเครื่องอบได้",
  "If ticked, the discount code can apply to Drop n Go transaction": "ถ้าติ๊ก รหัสส่วนลดสามารถใช้กับธุรกรรม Drop n Go ได้",
  "If ticked, the discount code can apply to vending machine transaction": "หากเลือก โค้ดส่วนลดสามารถใช้กับธุรกรรมตู้จำหน่ายสินค้าอัตโนมัติได้",
  "If ticked, the discount code can apply to detergent vending machine transaction": "หากเลือก โค้ดส่วนลดสามารถใช้กับธุรกรรมตู้จำหน่ายผงซักฟอกได้",
  "If ticked, the discount code can apply to car wash transaction": "หากเลือก โค้ดส่วนลดสามารถใช้กับธุรกรรมล้างรถได้",
  "The user enter the discount code": "ผู้ใช้ป้อนรหัสส่วนลด",
  "in the payment page will get": "ในหน้าชำระเงินจะได้รับ",
  "discount": "ส่วนลด",
  "The discount code only can be used start from {{ start_date }} until {{ end_date }}": "รหัสส่วนลดสามารถใช้ได้ตั้งแต่ {{ start_date }} จนถึง {{ end_date }}",
  "Every user only can use the discount code {{ redeem_per_user }} times": "ผู้ใช้แต่ละคนสามารถใช้รหัสส่วนลดได้ {{ redeem_per_user }} ครั้ง",
  "Every user only can use {{ redeem_per_user }} discount code from this batch of code": "ผู้ใช้แต่ละคนสามารถใช้รหัสส่วนลดจากชุดรหัสนี้ได้ {{ redeem_per_user }} ครั้ง",
  "Only {{ redeem_per_day }} transactions can use the discount code in one day_one": "มีเพียง {{ redeem_per_day }} ธุรกรรมที่สามารถใช้รหัสส่วนลดได้ในหนึ่งวัน",
  "Only {{ redeem_per_day }} transactions can use the discount code in one day_other": "มีเพียง {{ redeem_per_day }} ธุรกรรมที่สามารถใช้รหัสส่วนลดได้ในหนึ่งวัน",
  "The discount code only can be used for washer machine": "รหัสส่วนลดสามารถใช้ได้กับเครื่องซักเท่านั้น",
  "The discount code only can be used for dryer machine": "รหัสส่วนลดสามารถใช้ได้กับเครื่องอบเท่านั้น",
  "The discount code only can be used for Drop n Go transaction": "รหัสส่วนลดสามารถใช้ได้กับธุรกรรม Drop n Go เท่านั้น",
  "The discount code only can be used for vending machine transaction": "โค้ดส่วนลดใช้ได้เฉพาะธุรกรรมตู้จำหน่ายสินค้าอัตโนมัติ",
  "The discount code only can be used for detergent vending machine transaction": "โค้ดส่วนลดใช้ได้เฉพาะธุรกรรมตู้จำหน่ายผงซักฟอก",
  "The discount code only can be used for car wash transaction": "โค้ดส่วนลดใช้ได้เฉพาะธุรกรรมล้างรถ",
  "The discount code can be used for washer machine or Drop n Go transaction": "รหัสส่วนลดสามารถใช้ได้กับเครื่องซักหรือธุรกรรม Drop n Go",
  "The discount code can be used for dryer machine or Drop n Go transaction": "รหัสส่วนลดสามารถใช้ได้กับเครื่องอบหรือธุรกรรม Drop n Go",
  "The discount code can be used for washer machine, dryer machine or Drop n Go transaction": "รหัสส่วนลดสามารถใช้ได้กับเครื่องซัก เครื่องอบ หรือธุรกรรม Drop n Go",
  "The discount code can be used for washer or dryer machine": "รหัสส่วนลดสามารถใช้ได้กับเครื่องซักหรือเครื่องอบ",
  "The discount code can be used for washer machine or vending machine transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้าหรือตู้จำหน่ายสินค้าอัตโนมัติ",
  "The discount code can be used for washer machine or detergent vending machine transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้าหรือตู้จำหน่ายผงซักฟอก",
  "The discount code can be used for washer machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้าหรือล้างรถ",
  "The discount code can be used for dryer machine or vending machine transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้าหรือตู้จำหน่ายสินค้าอัตโนมัติ",
  "The discount code can be used for dryer machine or detergent vending machine transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้าหรือตู้จำหน่ายผงซักฟอก",
  "The discount code can be used for dryer machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้าหรือล้างรถ",
  "The discount code can be used for vending machine or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับตู้จำหน่ายสินค้าหรือ Drop n Go",
  "The discount code can be used for detergent vending machine or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับตู้จำหน่ายผงซักฟอกหรือ Drop n Go",
  "The discount code can be used for car wash or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับล้างรถหรือ Drop n Go",
  "The discount code can be used for vending machine or detergent vending machine transaction": "โค้ดส่วนลดใช้ได้กับตู้จำหน่ายสินค้าหรือตู้จำหน่ายผงซักฟอก",
  "The discount code can be used for vending machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับตู้จำหน่ายสินค้าหรือล้างรถ",
  "The discount code can be used for detergent vending machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับตู้จำหน่ายผงซักฟอกหรือล้างรถ",
  "The discount code can be used for washer machine, dryer machine or vending machine transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า เครื่องอบผ้าหรือตู้จำหน่ายสินค้าอัตโนมัติ",
  "The discount code can be used for washer machine, dryer machine or detergent vending machine transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า เครื่องอบผ้าหรือตู้จำหน่ายผงซักฟอก",
  "The discount code can be used for washer machine, dryer machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า เครื่องอบผ้าหรือล้างรถ",
  "The discount code can be used for washer machine, vending machine or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายสินค้าหรือ Drop n Go",
  "The discount code can be used for washer machine, detergent vending machine or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายผงซักฟอกหรือ Drop n Go",
  "The discount code can be used for washer machine, car wash or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า ล้างรถหรือ Drop n Go",
  "The discount code can be used for washer machine, vending machine or detergent vending machine transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายสินค้าหรือตู้จำหน่ายผงซักฟอก",
  "The discount code can be used for washer machine, vending machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายสินค้าหรือล้างรถ",
  "The discount code can be used for washer machine, detergent vending machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายผงซักฟอกหรือล้างรถ",
  "The discount code can be used for dryer machine, vending machine or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายสินค้าหรือ Drop n Go",
  "The discount code can be used for dryer machine, detergent vending machine or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายผงซักฟอกหรือ Drop n Go",
  "The discount code can be used for dryer machine, car wash or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้า ล้างรถหรือ Drop n Go",
  "The discount code can be used for dryer machine, vending machine or detergent vending machine transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายสินค้าหรือตู้จำหน่ายผงซักฟอก",
  "The discount code can be used for dryer machine, vending machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายสินค้าหรือล้างรถ",
  "The discount code can be used for dryer machine, detergent vending machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายผงซักฟอกหรือล้างรถ",
  "The discount code can be used for vending machine, detergent vending machine or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับตู้จำหน่ายสินค้า ตู้จำหน่ายผงซักฟอกหรือ Drop n Go",
  "The discount code can be used for vending machine, car wash or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับตู้จำหน่ายสินค้า ล้างรถหรือ Drop n Go",
  "The discount code can be used for detergent vending machine, car wash or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับตู้จำหน่ายผงซักฟอก ล้างรถหรือ Drop n Go",
  "The discount code can be used for vending machine, detergent vending machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับตู้จำหน่ายสินค้า ตู้จำหน่ายผงซักฟอกหรือล้างรถ",
  "The discount code can be used for washer machine, dryer machine, vending machine or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายสินค้าหรือ Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายสินค้าหรือตู้จำหน่ายผงซักฟอก",
  "The discount code can be used for washer machine, dryer machine, vending machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายสินค้าหรือล้างรถ",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายผงซักฟอกหรือล้างรถ",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายสินค้า ตู้จำหน่ายผงซักฟอกหรือ Drop n Go",
  "The discount code can be used for washer machine, vending machine, car wash or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายสินค้า ล้างรถหรือ Drop n Go",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายสินค้า ตู้จำหน่ายผงซักฟอกหรือล้างรถ",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายสินค้า ตู้จำหน่ายผงซักฟอกหรือ Drop n Go",
  "The discount code can be used for dryer machine, vending machine, car wash or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายสินค้า ล้างรถหรือ Drop n Go",
  "The discount code can be used for dryer machine, detergent vending machine, car wash machine or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายผงซักฟอก เครื่องล้างรถหรือ Drop n Go",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายสินค้า ตู้จำหน่ายผงซักฟอกหรือล้างรถ",
  "The discount code can be used for vending machine, detergent vending machine, car wash or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับตู้จำหน่ายสินค้า ตู้จำหน่ายผงซักฟอก ล้างรถหรือ Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายสินค้า ตู้จำหน่ายผงซักฟอกหรือ Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine, car wash or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายสินค้า ล้างรถหรือ Drop n Go",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine, car wash or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายผงซักฟอก ล้างรถหรือ Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or car wash transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายสินค้า ตู้จำหน่ายผงซักฟอกหรือล้างรถ",
  "The discount code can be used for washer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า ตู้จำหน่ายสินค้า ตู้จำหน่ายผงซักฟอก ล้างรถหรือ Drop n Go",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องอบผ้า ตู้จำหน่ายสินค้า ตู้จำหน่ายผงซักฟอก ล้างรถหรือ Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "โค้ดส่วนลดใช้ได้กับเครื่องซักผ้า เครื่องอบผ้า ตู้จำหน่ายสินค้า ตู้จำหน่ายผงซักฟอก ล้างรถหรือ Drop n Go",
  "The discount code only can be used after user spending {{ currency }} {{ pay_and_use_amount }}": "รหัสส่วนลดสามารถใช้ได้หลังจากผู้ใช้ใช้จ่าย {{ currency }} {{ pay_and_use_amount }}",
  "Are you sure you want to edit FAQ?": "คุณแน่ใจหรือไม่ที่จะแก้ไขคำถามที่พบบ่อย?",
  "FAQ updated successfully": "อัปเดตคำถามที่พบบ่อยสำเร็จแล้ว",
  "Edit FAQ": "แก้ไขคำถามที่พบบ่อย",
  "Are you sure you want to edit FAQ Group?": "คุณแน่ใจหรือไม่ที่จะแก้ไขกลุ่มคำถามที่พบบ่อย?",
  "FAQ Group updated successfully": "อัปเดตกลุ่มคำถามที่พบบ่อยสำเร็จแล้ว",
  "Edit FAQ Group": "แก้ไขกลุ่มคำถามที่พบบ่อย",
  "Are you sure you want to edit news?": "คุณแน่ใจหรือไม่ที่จะแก้ไขข่าวสาร?",
  "News edit successfully": "แก้ไขข่าวสารสำเร็จแล้ว",
  "Edit News": "แก้ไขข่าวสาร",
  "All the FAQ under this group will be deleted. Are you sure you want to delete FAQ Group?": "คำถามที่พบบ่อยทั้งหมดในกลุ่มนี้จะถูกลบ คุณแน่ใจหรือไม่ที่จะลบกลุ่มคำถามที่พบบ่อยนี้?",
  "FAQ Group deleted successfully": "ลบกลุ่มคำถามที่พบบ่อยสำเร็จแล้ว",
  "FAQ List": "รายการคำถามที่พบบ่อย",
  "NO FAQ GROUP": "ไม่มีกลุ่มคำถามที่พบบ่อย",
  "FAQ Group": "กลุ่มคำถามที่พบบ่อย",
  "Are you sure you want to delete FAQ?": "คุณแน่ใจหรือไม่ที่จะลบคำถามที่พบบ่อย?",
  "FAQ deleted successfully": "ลบคำถามที่พบบ่อยสำเร็จแล้ว",
  "NO FAQs": "ไม่มีคำถามที่พบบ่อย",
  "FAQ": "คำถามที่พบบ่อย",
  "Easy": "ง่าย",
  "Fast Laundromate": "ซักรีดด่วน",
  "Smart Laundry Management System": "ระบบจัดการซักรีดอัจฉริยะ",
  "Enter your username and password to login": "ป้อนชื่อผู้ใช้และรหัสผ่านของคุณเพื่อเข้าสู่ระบบ",
  "Username": "ชื่อผู้ใช้",
  "Are you sure you want to delete news?": "คุณแน่ใจหรือไม่ที่จะลบข่าวสาร?",
  "News deleted successfully": "ลบข่าวสารสำเร็จแล้ว",
  "NO NEWS": "ไม่มีข่าวสาร",
  "The referral setting has been updated successfully!": "อัปเดตการตั้งค่าการแนะนำสำเร็จแล้ว!",
  "Number of Stamp": "จำนวนแสตมป์",
  "Number of Washer Stamp": "จำนวนแสตมป์เครื่องซัก",
  "Number of Dryer Stamp": "จำนวนแสตมป์เครื่องอบ",
  "Enable Referral Feature?": "เปิดใช้งานคุณสมบัติการแนะนำ?",
  "Are you sure you want to delete the tier setting?": "คุณแน่ใจหรือไม่ว่าต้องการลบการตั้งค่าระดับ?",
  "Minimum referee transaction amount for referrer to get referral rewards": "จำนวนเงินขั้นต่ำของผู้ถูกแนะนำสำหรับผู้แนะนำเพื่อรับรางวัลการแนะนำ",
  "Maximum number of reward within this tier": "จำนวนรางวัลสูงสุดภายในระดับนี้",
  "Maximum number of reward can get from same user": "จำนวนรางวัลสูงสุดที่สามารถรับได้จากผู้ใช้รายเดียวกัน",
  "Point Grant Type": "ประเภทการให้คะแนน",
  "Select Point Grant Type": "เลือกประเภทการให้คะแนน",
  "Token Grant Type": "ประเภทการให้โทเค็น",
  "Select Token Grant Type": "เลือกประเภทการให้โทเค็น",
  "Add Tier": "เพิ่มระดับ",
  // "Maximum number of referrals for each user": "จำนวนการแนะนำสูงสุดสำหรับผู้ใช้แต่ละคน",
  // "Minimum amount of transaction": "จำนวนเงินขั้นต่ำของธุรกรรม",
  "Stamp": "แสตมป์",
  "If ticked, the system will give stamp to user": "ถ้าติ๊ก ระบบจะให้แสตมป์แก่ผู้ใช้",
  "If ticked, the system will give e-Token to user": "ถ้าติ๊ก ระบบจะให้ e-Token แก่ผู้ใช้",
  "If ticked, the system will give voucher to user": "ถ้าติ๊ก ระบบจะให้คูปองแก่ผู้ใช้",
  "Number of E-Token": "จำนวน E-Token",
  "Reward Giveaway": "การแจกรางวัล",
  "Which type of reward you want to give to customer?": "คุณต้องการให้รางวัลประเภทใดแก่ลูกค้า?",
  "For machine uses (required)": "สำหรับการใช้เครื่อง (จำเป็น)",
  "leave blank if no expiry date": "เว้นว่างไว้ถ้าไม่มีวันหมดอายุ",
  "Remarks": "หมายเหตุ",
  "Reward": "รางวัล",
  "Please fill in all the required field. (Title, description, and amount must be more than 0)": "กรุณากรอกข้อมูลในช่องที่จำเป็นทั้งหมด (หัวข้อ, คำอธิบาย และจำนวนต้องมากกว่า 0)",
  "Checkbox required": "กรุณาใส่เครื่องหมายช่อง",
  "Must select voucher can be used for washer, dryer or package": "ต้องเลือกว่าคูปองสามารถใช้กับเครื่องซัก เครื่องอบ หรือแพ็คเกจ",
  "How many e-token?": "จำนวน e-token เท่าไร?",
  "Number of e-Token": "จำนวน e-Token",
  "Token value must be more than 0": "มูลค่าโทเคนต้องมากกว่า 0",
  "STAMP": "แสตมป์",
  "Please fill in at least one of the required field": "กรุณากรอกข้อมูลในช่องที่จำเป็นอย่างน้อยหนึ่งช่อง",
  "The value must be more than 0": "ค่าต้องมากกว่า 0",
  "How many times rewarded to user": "ให้รางวัลแก่ผู้ใช้กี่ครั้ง",
  "Rewarded Times": "จำนวนครั้งที่ให้รางวัล",
  "How many times rewarded voucher to user": "ให้คูปองเป็นรางวัลแก่ผู้ใช้กี่ครั้ง",
  "Voucher Rewarded (times)": "บัตรกำนัลรับรางวัล (ครั้ง)",
  "How many times rewarded stamp to user": "ให้แสตมป์เป็นรางวัลแก่ผู้ใช้กี่ครั้ง",
  "Stamps Rewarded (times)": "แสตมป์รับรางวัล (ครั้ง)",
  "Total number of washer stamps rewarded to user": "จำนวนแสตมป์เครื่องซักทั้งหมดที่ให้เป็นรางวัลแก่ผู้ใช้",
  "Washer Stamps Granted (stamp)": "แสตมป์เครื่องซักที่มอบให้ (แสตมป์)",
  "Total number of dryer stamps rewarded to user": "จำนวนแสตมป์เครื่องอบทั้งหมดที่ให้เป็นรางวัลแก่ผู้ใช้",
  "Dryer Stamps Granted (stamp)": "แสตมป์เครื่องอบที่มอบให้ (แสตมป์)",
  "How many times rewarded e-Token to user": "ให้ e-Token เป็นรางวัลแก่ผู้ใช้กี่ครั้ง",
  "e-Token Rewarded (times)": "e-Token ที่รับรางวัล (ครั้ง)",
  "Total number of e-Token rewarded to user": "จำนวน e-Token ทั้งหมดที่รับรางวัลแก่ผู้ใช้",
  "Total e-Token Granted (token)": "e-Token ทั้งหมดที่มอบให้ (โทเคน)",
  "Point Rewarded (times)": "คะแนนที่ได้รับรางวัล (ครั้ง)",
  "How many times rewarded point to user": "ให้รางวัลคะแนนแก่ผู้ใช้กี่ครั้ง",
  "Total Point Granted (point)": "คะแนนรวมที่ให้ (คะแนน)",
  "Total number of point rewarded to user": "จำนวนคะแนนรวมที่ให้รางวัลแก่ผู้ใช้",
  "Point Amount": "จำนวนคะแนน",
  "Reward History": "ประวัติการให้รางวัล",
  "Are you sure you want to change how the stamping mechanics works?": "คุณแน่ใจหรือไม่ที่จะเปลี่ยนวิธีการทำงานของกลไกการสะสมแสตมป์?",
  "The stamping mechanics setting has updated successfully!": "อัปเดตการตั้งค่าการสะสมแสตมป์สำเร็จแล้ว!",
  "The voucher setting has been updated successfully!": "อัปเดตการตั้งค่าคูปองสำเร็จแล้ว!",
  "Mechanics Settings": "การตั้งค่ากลไก",
  "Minimum transaction amount for getting stamp": "จำนวนเงินขั้นต่ำของธุรกรรมเพื่อรับแสตมป์",
  "Select User Stamping Mechanic": "เลือกกลไกการสะสมแสตมป์ของผู้ใช้",
  "Separated Stamping": "การสะสมแสตมป์แยกกัน",
  "Combined Stamping": "การสะสมแสตมป์รวมกัน",
  "Stamp for?": "แสตมป์สำหรับ?",
  "Both": "ทั้งสอง",
  "Washer Only": "เครื่องซักเท่านั้น",
  "Dryer Only": "เครื่องอบเท่านั้น",
  "Separated Stamping = Different washer and dryer stamp collection. (example: Using Washer will gain 1 washer's stamp, and Dryer will gain 1 dryer stamp)": "การสะสมแสตมป์แยกกัน = การสะสมแสตมป์เครื่องซักและเครื่องอบแยกกัน (ตัวอย่าง: การใช้เครื่องซักจะได้รับ 1 แสตมป์เครื่องซัก และเครื่องอบจะได้รับ 1 แสตมป์เครื่องอบ)",
  "Combined Stamping = Washer and dryer has the same collection. (example: Using Washer or Dryer will gain 1 stamp)": "การสะสมแสตมป์รวมกัน = เครื่องซักและเครื่องอบมีการสะสมเดียวกัน (ตัวอย่าง: การใช้เครื่องซักหรือเครื่องอบจะได้รับ 1 แสตมป์)",
  "Stamp for": "แสตมป์สำหรับ",
  "User will be able to collect both washer stamp and dryer stamp": "ผู้ใช้จะสามารถสะสมทั้งแสตมป์เครื่องซักและแสตมป์เครื่องอบได้",
  "User will only able to collect Washer stamp": "ผู้ใช้จะสามารถสะสมแสตมป์เครื่องซักได้เท่านั้น",
  "User will only able to collect Dryer stamp": "ผู้ใช้จะสามารถสะสมแสตมป์เครื่องอบได้เท่านั้น",
  "Registration": "การลงทะเบียน",
  "Birthday": "วันเกิด",
  "Please choose at least one payment method": "กรุณาเลือกวิธีการชำระเงินอย่างน้อยหนึ่งวิธี",
  "Please choose at least one member or non-member payment": "โปรดเลือกการชำระเงินสำหรับสมาชิกหรือผู้ที่ไม่ใช่สมาชิกอย่างน้อยหนึ่งรายการ",
  "Are you sure you want to change the payment setting?": "คุณแน่ใจหรือไม่ที่จะเปลี่ยนการตั้งค่าการชำระเงิน?",
  "The payment setting has updated successfully!": "อัปเดตการตั้งค่าการชำระเงินสำเร็จแล้ว!",
  "Invalid input": "ข้อมูลไม่ถูกต้อง",
  "The price and token must be more than 0": "ราคาและโทเคนต้องมากกว่า 0",
  "Maximum number of purchase must be more than 0": "จำนวนการซื้อสูงสุดต้องมากกว่า 0",
  "Point amount must be more than 1": "จำนวนคะแนนต้องมากกว่า 1",
  "Added a new Token Bundle Package": "เพิ่มแพ็คเกจชุดโทเคนใหม่แล้ว",
  "Bundle deleted successfully!": "ลบชุดสำเร็จแล้ว!",
  "Reload voucher setting have edited successfully!": "แก้ไขการตั้งค่าคูปองเติมเงินสำเร็จแล้ว!",
  "Added on": "เพิ่มเมื่อ",
  "remove": "ลบ",
  "edit": "แก้ไข",
  "NO PACKAGES ON SALES": "ไม่มีแพ็คเกจที่กำลังขาย",
  "Point Settings": "การตั้งค่าคะแนน",
  "Enable Loyalty Point": "เปิดใช้งานคะแนนสะสม",
  "Point Name": "ชื่อคะแนน",
  "Number Of Point Equals To": "จำนวนคะแนนเท่ากับ",
  "If ticked, the point will have expired date": "หากเลือก คะแนนจะมีวันหมดอายุ",
  "Point Lifespan": "อายุของคะแนน",
  "months": "เดือน",
  "Minimum Transaction Amount To Get Point": "จำนวนเงินขั้นต่ำในการทำธุรกรรมเพื่อรับคะแนน",
  "Point Grant Amount": "จำนวนคะแนนที่ให้",
  "Point Grant Period": "Point Grant Period", // new translation
  "Optional": "Optional",
  "Drop n Go Eligibility": "Drop n Go Eligibility",
  "If ticked, Drop n Go transaction will get the point": "If ticked, Drop n Go transaction will get the point",
  "Washer Eligibility": "Washer Eligibility",
  "If ticked, washer transaction will get the point": "If ticked, washer transaction will get the point",
  "Dryer Eligibility": "Dryer Eligibility",
  "If ticked, dryer transaction will get the point": "If ticked, dryer transaction will get the point",
  "Point settings updated successfully!": "อัปเดตการตั้งค่าคะแนนเรียบร้อยแล้ว!",
  "Point Eligibility": "สิทธิ์รับคะแนน",
  "If ticked, the system will give point to user when user reload token successfully": "หากเลือก ระบบจะให้คะแนนแก่ผู้ใช้เมื่อผู้ใช้เติมเงินโทเค็นสำเร็จ",
  "{{ point_amount }} point will be given after user reload token successfully": "จะได้รับ {{ point_amount }} คะแนนหลังจากผู้ใช้เติมเงินโทเค็นสำเร็จ",
  "Payment Settings": "การตั้งค่าการชำระเงิน",
  "Select Payment Method": "เลือกวิธีการชำระเงิน",
  "Enable E-Payment?": "เปิดใช้งานการชำระเงินอิเล็กทรอนิกส์?",
  "Enable Token Currency?": "เปิดใช้งานสกุลเงินโทเคน?",
  "Enable Cash Payment?": "เปิดใช้งานการชำระด้วยเงินสดหรือไม่?",
  "Enable QR Payment?": "เปิดใช้งานการชำระเงินด้วย QR หรือไม่?",
  // "E-payment for?": "การชำระเงินอิเล็กทรอนิกส์สำหรับ?",
  // "Member & Non-Member Payment": "การชำระเงินสำหรับสมาชิกและไม่ใช่สมาชิก",
  // "Only Member Payment": "การชำระเงินสำหรับสมาชิกเท่านั้น",
  "Member and Non-Member Settings": "การตั้งค่าสมาชิกและผู้ที่ไม่ใช่สมาชิก",
  "Enable Member Payment?": "เปิดใช้งานการชำระเงินสำหรับสมาชิก?",
  "Enable Non-Member Payment?": "เปิดใช้งานการชำระเงินสำหรับผู้ที่ไม่ใช่สมาชิก?",
  "Promotion Settings": "การตั้งค่าโปรโมชั่น",
  "Enable Non Member Promotion?": "เปิดใช้งานโปรโมชั่นสำหรับไม่ใช่สมาชิก?",
  "Enable Notification When Cycle Done?": "เปิดใช้งานการแจ้งเตือนเมื่อรอบการทำงานเสร็จสิ้น?",
  "SMS charges": "ค่าบริการ SMS",
  "SMS Settings": "การตั้งค่า SMS",
  "Enable Free Sms For Members": "เปิดใช้งาน SMS ฟรีสำหรับสมาชิก",
  "If enable notification, user can choose either receive email or sms when complete washing or drying": "ถ้าเปิดใช้งานการแจ้งเตือน ผู้ใช้สามารถเลือกรับอีเมลหรือ SMS เมื่อซักหรืออบเสร็จสิ้น",
  // "If user choose sms, user have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "ถ้าผู้ใช้เลือก SMS ผู้ใช้ต้องจ่ายเพิ่ม {{ สกุลเงิน }}{{ จำนวนเงินแจ้งเตือน sms}} สำหรับ SMS",
  "If user choose sms, non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "หากผู้ใช้เลือก sms ผู้ที่ไม่ใช่สมาชิกต้องชำระเงินเพิ่ม {{ currency }}{{ sms_notification_amount }} สำหรับ sms",
  "If user choose sms, member and non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "หากผู้ใช้เลือก sms สมาชิกและผู้ที่ไม่ใช่สมาชิกต้องชำระเงินเพิ่ม {{ currency }}{{ sms_notification_amount }} สำหรับ sms",
  "Add Package": "เพิ่มแพ็คเกจ",
  "Edit e-Token Package": "แก้ไขแพ็คเกจ e-Token",
  "Add e-Token Package": "เพิ่มแพ็คเกจ e-Token",
  "Please only input numberic value to prevent any bugs.": "กรุณาป้อนค่าตัวเลขเท่านั้นเพื่อป้องกันข้อผิดพลาด",
  "Price": "ราคา",
  "If ticked, the system will limit the number of purchase": "ถ้าติ๊ก ระบบจะจำกัดจำนวนการซื้อ",
  "Limit Number of Purchase": "จำกัดจำนวนการซื้อ",
  "Number of maximum purchase": "จำนวนการซื้อสูงสุด",
  "Reload Voucher": "คูปองเติมเงิน",
  "If ticked, the system will give voucher to user when user reload token successfully": "ถ้าติ๊ก ระบบจะให้คูปองแก่ผู้ใช้เมื่อผู้ใช้เติมโทเคนสำเร็จ",
  "If ticked, the system will give voucher repeatly": "ถ้าติ๊ก ระบบจะให้คูปองซ้ำๆ",
  "Recurring": "ทำซ้ำ",
  "Total number of voucher given to user": "จำนวนคูปองทั้งหมดที่ให้แก่ผู้ใช้",
  "Period for giving next voucher": "ระยะเวลาสำหรับการให้คูปองถัดไป",
  "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens_one": "แพ็คเกจโทเคน {{ currency  }}{{ price }} สำหรับ {{numberOfToken }} โทเคน",
  "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens_other": "แพ็คเกจโทเคน {{ currency  }}{{ price }} สำหรับ {{ numberOfToken }} โทเคน",
  "Each user only can purchase {{ max_purchase }} times for the token package": "ผู้ใช้แต่ละคนสามารถซื้อแพ็คเกจโทเคนได้เพียง {{ max_purchase}} ครั้งสำหรับแพ็คเกจโทเค็น",
  "Voucher will be given after user reload token successfully": "จะให้คูปองหลังจากผู้ใช้เติมโทเคนสำเร็จ",
  "Voucher will not given after user reload tokens successfully": "จะไม่ให้คูปองหลังจากผู้ใช้เติมโทเคนสำเร็จ",
  "The voucher will be expired after {{ voucher_duration }} days_one": "คูปองจะหมดอายุหลังจาก {{ voucher_duration }} วัน",
  "The voucher will be expired after {{ voucher_duration }} days_other": "คูปองจะหมดอายุหลังจาก {{ voucher_duration }} วัน",
  "The voucher will not expired": "คูปองจะไม่หมดอายุ",
  "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount_one": "จะให้คูปองทั้งหมด {{ recurring_number }} ใบแก่ผู้ใช้และแต่ละคูปองจะลดราคา",
  "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount_other": "จะให้คูปองทั้งหมด {{ recurring_number }} ใบแก่ผู้ใช้และแต่ละคูปองจะลดราคา",
  "Edit Package": "แก้ไขแพ็คเกจ",
  "Age": "อายุ",
  "Total number of vouchers collected": "จำนวนคูปองทั้งหมดที่สะสมได้",
  "Vouchers Acquired": "คูปองที่ได้รับ",
  "Total amount spent in washer machine transactions": "จำนวนเงินทั้งหมดที่ใช้ในธุรกรรมเครื่องซัก",
  "Total Washer Payment": "การชำระเงินเครื่องซักทั้งหมด",
  "Total amount spent in dryer machine transactions": "จำนวนเงินทั้งหมดที่ใช้ในธุรกรรมเครื่องอบ",
  "Total Dryer Payment": "การชำระเงินเครื่องอบทั้งหมด",
  "Total amount spent in all transactions": "จำนวนเงินทั้งหมดที่ใช้ในธุรกรรมทั้งหมด",
  "Total Payment": "การชำระเงินทั้งหมด",
  "report": "รายงาน",
  "Total amount spent for buying e-Token": "จำนวนเงินทั้งหมดที่ใช้ในการซื้อ e-Token",
  "Total number of e-Token purchased": "จำนวน e-Token ทั้งหมดที่ซื้อ",
  "Total e-Token Purchased (Tokens)": "e-Token ทั้งหมดที่ซื้อ (โทเคน)",
  "Total number of e-Token used in washer machine transactions": "จำนวน e-Token ทั้งหมดที่ใช้ในธุรกรรมเครื่องซัก",
  "Washer Payment (Tokens)": "การชำระเงินเครื่องซัก (โทเคน)",
  "Total number of e-Token used in dryer machine transactions": "จำนวน e-Token ทั้งหมดที่ใช้ในธุรกรรมเครื่องอบ",
  "Dryer Payment (Tokens)": "การชำระเงินเครื่องอบ (โทเคน)",
  "Total number of e-Token used in all the transactions": "จำนวน e-Token ทั้งหมดที่ใช้ในธุรกรรมทั้งหมด",
  "Total Payment (Tokens)": "การชำระเงินทั้งหมด (โทเคน)",
  "Number of washer stamp collected currently": "จำนวนแสตมป์เครื่องซักที่สะสมได้ในปัจจุบัน",
  "Number of dryer stamp collected currently": "จำนวนแสตมป์เครื่องอบที่สะสมได้ในปัจจุบัน",
  "User Phone Number / Member ID / Email": "หมายเลขโทรศัพท์ผู้ใช้ / รหัสสมาชิก / อีเมล",
  "Example: 0123456789,A123456": "ตัวอย่าง: 0123456789,A123456",
  "SEARCH": "ค้นหา",
  "Total Users Registered": "จำนวนผู้ใช้ที่ลงทะเบียนทั้งหมด",
  "Total Active Outlets": "จำนวนสาขาที่ใช้งานทั้งหมด",
  "Total Vouchers Given": "จำนวนคูปองที่ให้ทั้งหมด",
  "Total Transaction Counts": "จำนวนธุรกรรมทั้งหมด",
  "Total User Stamps Collected": "จำนวนแสตมป์ที่ผู้ใช้สะสมได้ทั้งหมด",
  "Distributor Login": "เข้าสู่ระบบผู้จัดจำหน่าย",
  "Client Login": "เข้าสู่ระบบลูกค้า",
  "Kiosk Login": "เข้าสู่ระบบคีออสก์",
  "Promotion": "โปรโมชั่น",
  "Please select operator": "กรุณาเลือกผู้ให้บริการ",
  "Please select distributor": "กรุณาเลือกผู้จัดจำหน่าย",
  "Select Operator": "เลือกผู้ให้บริการ",
  "Select Distributor": "เลือกผู้จัดจำหน่าย",
  "User can login or skip to payment without login to make the payment": "ผู้ใช้สามารถเข้าสู่ระบบหรือข้ามไปยังการชำระเงินโดยไม่ต้องเข้าสู่ระบบเพื่อชำระเงิน",
  "User only can skip to payment without login to make the payment": "ผู้ใช้สามารถข้ามไปยังการชำระเงินโดยไม่ต้องเข้าสู่ระบบเพื่อทำการชำระเงิน",
  "User have to login only can make the payment": "ผู้ใช้ต้องเข้าสู่ระบบเท่านั้นจึงจะสามารถทำการชำระเงินได้",
  "Only CSV file is accepted": "ยอมรับเฉพาะไฟล์ CSV เท่านั้น",
  "The user and the balance have updated": "ผู้ใช้และยอดคงเหลือได้รับการอัปเดตแล้ว",
  "Register Time": "เวลาลงทะเบียน",
  "Upload User CSV file": "อัปโหลดไฟล์ CSV ผู้ใช้",
  "Sample CSV file": "ไฟล์ CSV ตัวอย่าง",
  "Please follow the CSV file format": "กรุณาทำตามรูปแบบไฟล์ CSV",
  "User CSV file": "ไฟล์ CSV ผู้ใช้",
  "Only CSV file (comma delimited) is support now": "รองรับเฉพาะไฟล์ CSV (คั่นด้วยเครื่องหมายจุลภาค) เท่านั้นในขณะนี้",
  "Confirm uploaded data": "ยืนยันข้อมูลที่อัปโหลด",
  "Operator": "ผู้ให้บริการ",
  "Distributor": "ผู้จัดจำหน่าย",
  "Refund By": "คืนเงินโดย",
  "Reward By": "ให้รางวัลโดย",
  "Number Of Voucher Code": "จำนวนรหัสคูปอง",
  "Number Of Discount Code": "จำนวนรหัสส่วนลด",
  "New User Only": "เฉพาะผู้ใช้ใหม่เท่านั้น",
  "Minimum Transaction Amount To Redeem": "จำนวนเงินขั้นต่ำของธุรกรรมเพื่อแลก",
  "Download": "ดาวน์โหลด",
  "Generate Voucher Code": "สร้างรหัสคูปอง",
  "Your voucher code is generating": "กำลังสร้างรหัสคูปองของคุณ",
  "Your discount code is generating": "กำลังสร้างรหัสส่วนลดของคุณ",
  "Voucher Code Settings": "การตั้งค่ารหัสคูปอง",
  "If ticked, the voucher code only can redeem in register page": "ถ้าติ๊ก รหัสคูปองจะสามารถแลกได้ในหน้าลงทะเบียนเท่านั้น",
  "If ticked, the user only can use the voucher after make a transaction": "ถ้าติ๊ก ผู้ใช้จะสามารถใช้คูปองได้หลังจากทำธุรกรรมเท่านั้น",
  "If ticked, the user only can use the discount code after make a transaction": "ถ้าติ๊ก ผู้ใช้จะสามารถใช้รหัสส่วนลดได้หลังจากทำธุรกรรมเท่านั้น",
  "Expired Date Of Voucher Code": "วันหมดอายุของรหัสคูปอง",
  "Minimum Transaction Amount To Use Voucher": "จำนวนเงินขั้นต่ำของธุรกรรมเพื่อใช้คูปอง",
  "Minimum Transaction Amount To Use Code": "จำนวนเงินขั้นต่ำของธุรกรรมเพื่อใช้รหัส",
  "Max redemption per user in this batch voucher code": "การแลกสูงสุดต่อผู้ใช้ในชุดรหัสคูปองนี้",
  "Max redemption per user in this batch discount code": "การแลกสูงสุดต่อผู้ใช้ในชุดรหัสส่วนลดนี้",
  "Add Voucher": "เพิ่มคูปอง",
  "Completed": "เสร็จสิ้น",
  "Voucher Code Report": "รายงานรหัสคูปอง",
  "Floating Token Report": "รายงานโทเค็นลอย",
  "Floating Point Report": "รายงานคะแนนลอย",
  // "User Floating Token Report": "รายงานโทเคนลอยของผู้ใช้",
  "E-Payment Report": "รายงานการชำระเงินอิเล็กทรอนิกส์",
  "Referral Reward History Report": "รายงานประวัติรางวัลการแนะนำ",
  "Redemption Date": "วันที่แลก",
  "Redemption Code": "รหัสการแลก",
  "Select Redemption Date": "เลือกวันที่แลก",
  "Select Voucher Type": "เลือกประเภทคูปอง",
  "Giveaway": "แจกฟรี",
  "Select Name": "เลือกชื่อ",
  "Amount must be more than 1": "จำนวนต้องมากกว่า 1",
  "Payment method setting have updated successfully!": "อัปเดตการตั้งค่าวิธีการชำระเงินสำเร็จแล้ว!",
  "Edit Payment Method": "แก้ไขวิธีการชำระเงิน",
  "Minimum payment amount to include all the payment methods": "จำนวนเงินขั้นต่ำในการชำระเงินเพื่อรวมวิธีการชำระเงินทั้งหมด",
  "Exclude Payment Method in Revenue Monster": "ยกเว้นวิธีการชำระเงินใน Revenue Monster",
  "Welcome to": "ยินดีต้อนรับสู่",
  "Instruction": "คำแนะนำ",
  "Please select the machine": "กรุณาเลือกเครื่อง",
  "Login your account": "เข้าสู่ระบบบัญชีของคุณ",
  "Select the setting and make the payment": "เลือกการตั้งค่าและทำการชำระเงิน",
  "Phone Number / Email": "หมายเลขโทรศัพท์ / อีเมล",
  "Reload & Transfer In": "เติมเงิน & โอนเข้า",
  "Usage & Transfer Out": "การใช้งาน & โอนออก",
  "Usage": "การใช้งาน",
  "Remaining": "คงเหลือ",
  "Gain": "ได้รับ",
  "Type": "ประเภท",
  "Order Date": "วันที่สั่งซื้อ",
  "Pack Number": "หมายเลขแพ็ค",
  "Pack Details": "รายละเอียดแพ็ค",
  "Size": "ขนาด",
  "Mode": "โหมด",
  "Machine Payment": "การชำระเงินเครื่อง",
  "DNG History": "ประวัติ DNG",
  "Token History": "ประวัติโทเคน",
  "Stamp History": "ประวัติแสตมป์",
  "Staff Login": "เข้าสู่ระบบพนักงาน",
  "Drop And Go Portal": "พอร์ทัล Drop And Go",
  "Available Task": "งานที่มีอยู่",
  "Completed Task": "งานที่เสร็จสิ้น",
  "Task ID": "รหัสงาน",
  "Task": "Task", // new translation
  "Start Task": "เริ่มงาน",
  "Select Machine": "เลือกเครื่อง",
  "Start Machine": "เริ่มเครื่อง",
  "Reward To": "ให้รางวัลแก่",
  "Reward From": "รับรางวัลจาก",
  "Transaction Account": "บัญชีธุรกรรม",
  "Point": "คะแนน",
  "POINT": "คะแนน",
  "Number of Point": "จำนวนคะแนน",
  "Point History": "ประวัติคะแนน",
  "Customer Name": "ชื่อลูกค้า",
  "Number of Washer Transactions": "จำนวนธุรกรรมเครื่องซักผ้า",
  "Number of Dryer Transactions": "จำนวนธุรกรรมเครื่องอบผ้า",
  "Vouchers Redeemed": "บัตรกำนัลที่แลกแล้ว",
  "Discount Code Redemption": "การแลกรหัสส่วนลด",
  "Total Spend": "ยอดใช้จ่ายทั้งหมด",
  "Select Outlet(s)": "เลือกสาขา",
  "User Usage Report": "รายงานการใช้งานของผู้ใช้",
  // cleanpro plus th
  "Wash": "ซัก",
  "Dry": "อบ",
  "Fold": "พับ",
  "Scan QR": "สแกน QR",
  "Capacity": "ความจุ",
  "Duration": "ระยะเวลา",
  "Custom duration": "ระยะเวลาที่กำหนดเอง",
  "Choose duration": "เลือกระยะเวลา",
  "Select the correct amount on the machine after payment.": "เลือกจำนวนที่ถูกต้องบนเครื่องหลังจากชำระเงิน",
  "Offers": "ข้อเสนอ",
  "Voucher Offers": "ข้อเสนอบัตรกำนัล",
  "Discount Code Offers": "ข้อเสนอรหัสส่วนลด",
  "An easier way to pay": "วิธีการชำระเงินที่ง่ายขึ้น",
  "Create account": "สร้างบัญชี",
  "Login": "เข้าสู่ระบบ",
  "By signing up, you agree to": "โดยการลงทะเบียน คุณยอมรับ",
  "Amount to Pay": "จำนวนเงินที่ต้องชำระ",
  // "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount_one": "จะให้คูปองทั้งหมด {{ recurring_number }} ใบแก่ผู้ใช้และแต่ละคูปองจะลด",
  // "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount_other": "จะให้คูปองทั้งหมด {{ recurring_number }} ใบแก่ผู้ใช้และแต่ละคูปองจะลด",
  // "Edit Package": "แก้ไขแพ็คเกจ",
  // "Age": "อายุ",
  // "Total number of vouchers collected": "จำนวนคูปองทั้งหมดที่สะสมได้",
  // "Vouchers Acquired": "คูปองที่ได้รับ",
  // "Total amount spent in washer machine transactions": "จำนวนเงินทั้งหมดที่ใช้จ่ายในธุรกรรมเครื่องซัก",
  // "Total Washer Payment": "การชำระเงินเครื่องซักทั้งหมด",
  // "Total amount spent in dryer machine transactions": "จำนวนเงินทั้งหมดที่ใช้จ่ายในธุรกรรมเครื่องอบ",
  // "Total Dryer Payment": "การชำระเงินเครื่องอบทั้งหมด",
  // "Total amount spent in all transactions": "จำนวนเงินทั้งหมดที่จ่ายใช้ในธุรกรรมทั้งหมด",
  // "Total Payment": "การชำระเงินทั้งหมด",
  // "report": "รายงาน",
  // "Total amount spent for buying e-Token": "จำนวนเงินทั้งหมดที่ใช้ในการซื้อ e-Token",
  // "Total number of e-Token purchased": "จำนวน e-Token ทั้งหมดที่ซื้อ",
  // "Total e-Token Purchased (Tokens)": "e-Token ทั้งหมดที่ซื้อ (โทเคน)",
  // "Total number of e-Token used in washer machine transactions": "จำนวน e-Token ทั้งหมดที่ใช้ในธุรกรรมเครื่องซัก",
  // "Washer Payment (Tokens)": "การชำระเงินเครื่องซัก (โทเคน)",
  // "Total number of e-Token used in dryer machine transactions": "จำนวน e-Token ทั้งหมดที่ใช้ในธุรกรรมเครื่องอบ",
  // "Dryer Payment (Tokens)": "การชำระเงินเครื่องอบ (โทเคน)",
  // "Total number of e-Token used in all the transactions": "จำนวน e-Token ทั้งหมดที่ใช้ในธุรกรรมทั้งหมด",
  // "Total Payment (Tokens)": "การชำระเงินทั้งหมด (โทเคน)",
  // "Number of washer stamp collected currently": "จำนวนแสตมป์เครื่องซักที่สะสมได้ในปัจจุบัน",
  // "Number of dryer stamp collected currently": "จำนวนแสตมป์เครื่องอบที่สะสมได้ในปัจจุบัน",
  // "User Phone Number / Member ID / Email": "หมายเลขโทรศัพท์ผู้ใช้ / รหัสสมาชิก / อีเมล",
  // "Example: 0123456789,A123456": "ตัวอย่าง: 0123456789,A123456",
  // "SEARCH": "ค้นหา",
  // "Total Users Registered": "จำนวนผู้ใช้ที่ลงทะเบียนทั้งหมด",
  // "Total Active Outlets": "จำนวนสาขาที่ใช้งานทั้งหมด",
  // "Total Vouchers Given": "จำนวนคูปองที่ให้ทั้งหมด",
  // "Total Transaction Counts": "จำนวนธุรกรรมรวมทั้งหมด",
  // "Total User Stamps Collected": "จำนวนแสตมป์ที่ผู้ใช้สะสมได้ทั้งหมด",
  // "Distributor Login": "เข้าสู่ระบบผู้จัดจำหน่าย",
  // "Client Login": "เข้าสู่ระบบลูกค้า",
  // "Kiosk Login": "เข้าสู่ระบบคีออสก์",
  // "Promotion": "โปรโมชั่น",
  // "Please select operator": "กรุณาเลือกผู้ให้บริการ",
  // "Please select distributor": "กรุณาเลือกผู้จัดจำหน่าย",
  // "Select Operator": "เลือกผู้ให้บริการ",
  // "Select Distributor": "เลือกผู้จัดจำหน่าย",
  // "User can skip to payment without login to make the payment": "ผู้ใช้สามารถข้ามไปยังการชำระเงินโดยไม่ต้องเข้าสู่ระบบเพื่อทำการชำระเงิน",
  // "User have to login only can make the payment": "ผู้ใช้ต้องเข้าสู่ระบบเท่านั้นจึงจะสามารถทำการชำระเงินได้",
  // "Only CSV file is accepted": "ยอมรับเฉพาะไฟล์ CSV เท่านั้น",
  // "The user and the balance have updated": "ผู้ใช้และยอดคงเหลือได้รับการอัปเดตแล้ว",
  // "Register Time": "เวลาลงทะเบียน",
  // "Upload User CSV file": "อัปโหลดไฟล์ CSV ผู้ใช้",
  // "Sample CSV file": "ไฟล์ CSV ตัวอย่าง",
  // "Please follow the CSV file format": "กรุณาทำตามรูปแบบไฟล์ CSV",
  // "User CSV file": "ไฟล์ CSV ผู้ใช้",
  // "Only CSV file (comma delimited) is support now": "รองรับเฉพาะไฟล์ CSV (คั่นด้วยเครื่องหมายจุลภาค) เท่านั้นในขณะนี้",
  // "Confirm uploaded data": "ยืนยันข้อมูลที่อัปโหลด",
  // "Operator": "ผู้ให้บริการ",
  // "Distributor": "ผู้จัดจำหน่าย",
  // "Refund By": "คืนเงินโดย",
  // "Reward By": "ให้รางวัลโดย",
  // "Number Of Voucher Code": "จำนวนรหัสคูปอง",
  // "Number Of Discount Code": "จำนวนรหัสส่วนลด",
  // "New User Only": "เฉพาะผู้ใช้ใหม่เท่านั้น",
  // "Minimum Transaction Amount To Redeem": "จำนวนเงินขั้นต่ำของธุรกรรมเพื่อแลก",
  // "Download": "ดาวน์โหลด",
  // "Generate Voucher Code": "สร้างรหัสคูปอง",
  // "Your voucher code is generating": "กำลังสร้างรหัสคูปองของคุณ",
  // "Your discount code is generating": "กำลังสร้างรหัสส่วนลดของคุณ",
  // "Voucher Code Settings": "การตั้งค่ารหัสคูปอง",
  // "If ticked, the voucher code only can redeem in register page": "ถ้าติ๊ก รหัสคูปองจะสามารถแลกได้ในหน้าลงทะเบียนเท่านั้น",
  // "If ticked, the user only can use the voucher after make a transaction": "ถ้าติ๊ก ผู้ใช้จะสามารถใช้คูปองได้หลังจากทำธุรกรรมเท่านั้น",
  // "If ticked, the user only can use the discount code after make a transaction": "ถ้าติ๊ก ผู้ใช้จะสามารถใช้รหัสส่วนลดได้หลังจากทำธุรกรรมเท่านั้น",
  // "Expired Date Of Voucher Code": "วันหมดอายุของรหัสคูปอง",
  // "Minimum Transaction Amount To Use Voucher": "จำนวนเงินขั้นต่ำของธุรกรรมเพื่อใช้คูปอง",
  // "Minimum Transaction Amount To Use Code": "จำนวนเงินขั้นต่ำของธุรกรรมเพื่อใช้รหัส",
  // "Max redemption per user in this batch voucher code": "การแลกสูงสุดต่อผู้ใช้ในชุดรหัสคูปองนี้",
  // "Max redemption per user in this batch discount code": "การแลกสูงสุดต่อผู้ใช้ในชุดรหัสส่วนลดนี้",
  // "Add Voucher": "เพิ่มคูปอง",
  // "Completed": "เสร็จสิ้น",
  // "Voucher Code Report": "รายงานรหัสคูปอง",
  // "User Floating Token Report": "รายงานโทเคนลอยของผู้ใช้",
  // "E-Payment Report": "รายงานการชำระเงินอิเล็กทรอนิกส์",
  // "Redemption Date": "วันที่แลก",
  // "Redemption Code": "รหัสการแลก",
  // "Select Redemption Date": "เลือกวันที่แลก",
  // "Select Voucher Type": "เลือกประเภทคูปอง",
  // "Giveaway": "แจกฟรี",
  // "Select Name": "เลือกชื่อ",
  // "Amount must be more than 1": "จำนวนต้องมากกว่า 1",
  // "Payment method setting have updated successfully!": "อัปเดตการตั้งค่าวิธีการชำระเงินสำเร็จแล้ว!",
  // "Edit Payment Method": "แก้ไขวิธีการชำระเงิน",
  // "Minimum payment amount to include all the payment methods": "จำนวนเงินขั้นต่ำในการชำระเงินเพื่อรวมวิธีการชำระเงินทั้งหมด",
  // "Exclude Payment Method in Revenue Monster": "ยกเว้นวิธีการชำระเงินใน Revenue Monster",
  // "Welcome to": "ยินดีต้อนรับสู่",
  // "Instruction": "คำแนะนำ",
  // "Please select the machine": "กรุณาเลือกเครื่อง",
  // "Login your account": "เข้าสู่ระบบบัญชีของคุณ",
  // "Select the setting and make the payment": "เลือกการตั้งค่าและทำการชำระเงิน",
  // "Phone Number / Email": "หมายเลขโทรศัพท์ / อีเมล",
  // "Usage": "การใช้งาน",
  // "Remaining": "คงเหลือ",
  // "Type": "ประเภท",
  // "Order Date": "วันที่สั่งซื้อ",
  // "Pack Number": "หมายเลขแพ็ค",
  // "Pack Details": "รายละเอียดแพ็ค",
  // "Size": "ขนาด",
  // "Mode": "โหมด",
  // "Machine Payment": "การชำระเงินเครื่อง",
  // "DNG History": "ประวัติ DNG",
  // "Token History": "ประวัติโทเคน",
  // "Stamp History": "ประวัติแสตมป์",
  // "Staff Login": "เข้าสู่ระบบพนักงาน",
  // "Drop And Go Portal": "พอร์ทัล Drop And Go",
  // "Available Task": "งานที่มีอยู่",
  // "Completed Task": "งานที่เสร็จสิ้น",
  // "Task ID": "รหัสงาน",
  // "Start Task": "เริ่มงาน",
  // "Select Machine": "เลือกเครื่อง",
  // "Start Machine": "เริ่มเครื่อง",
  // "Wash": "ซัก",
  // "Dry": "อบ",
  // "Fold": "พับ",
  // "Scan QR": "สแกน QR",
  // "Capacity": "ความจุ",
  // "Duration": "ระยะเวลา",
  // "Custom duration": "ระยะเวลาที่กำหนดเอง",
  // "Choose duration": "เลือกระยะเวลา",
  // "Select the correct amount on the machine after payment.": "เลือกจำนวนที่ถูกต้องบนเครื่องหลังจากชำระเงิน",
  // "Offers": "ข้อเสนอ",
  // "An easier way to pay": "วิธีการชำระเงินที่ง่ายขึ้น",
  // "Create account": "สร้างบัญชี",
  // "Login": "เข้าสู่ระบบ",
  // "By signing up, you agree to": "โดยการลงทะเบียน คุณยอมรับ",
  // "Amount to Pay": "จำนวนเงินที่ต้องชำระ",
  "1 voucher selected": "เลือก 1 คูปอง",
  "No voucher selected": "ไม่ได้เลือกคูปอง",
  "Credits": "เครดิต",
  "credits": "เครดิต",
  "credit": "เครดิต",
  "Credit balance": "ยอดเครดิตคงเหลือ",
  "Please ensure that the machine door is shut & your laundry is inside.": "กรุณาตรวจสอบให้แน่ใจว่าประตูเครื่องปิดสนิทและผ้าของคุณอยู่ด้านใน",
  "Insufficient balance": "ยอดเงินไม่เพียงพอ",
  "Topup now": "เติมเงินตอนนี้",
  "Copyright © {{ year }} Cleanpro Laundry Holdings Sdn Bhd (821842-P) All rights reserved.": "ลิขสิทธิ์ © {{ year }} Cleanpro Laundry Holdings Sdn Bhd (821842-P) สงวนลิขสิทธิ์ทั้งหมด",
  "Good Evening!": "สวัสดีตอนเย็น!",
  "Hello": "สวัสดี",
  "Wallet Balance": "ยอดเงินในกระเป๋าเงิน",
  "Topup": "เติมเงิน",
  "More details": "รายละเอียดเพิ่มเติม",
  "Collect 10 e-stamps to earn x1 FREE wash or dry voucher": "สะสม 10 e-stamps เพื่อรับคูปองซักหรืออบฟรี 1 ครั้ง",
  "For every wash or dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "สำหรับทุกรอบการซักหรืออบที่คุณใช้บริการกับเรา คุณจะได้รับหนึ่ง e-stamp สะสม 10 ดวงและคุณจะสามารถแลกรับรอบการซักหรืออบฟรีได้ นี่คือวิธีที่เราขอบคุณที่คุณเลือก Cleanpro!",
  "For every wash cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "สำหรับทุกรอบการซักที่คุณใช้บริการกับเรา คุณจะได้รับหนึ่ง e-stamp สะสม 10 ดวงและคุณจะสามารถแลกรับรอบการซักหรืออบฟรีได้ นี่คือวิธีที่เราขอบคุณที่คุณเลือก Cleanpro!",
  "For every dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "สำหรับทุกรอบการอบที่คุณใช้บริการกับเรา คุณจะได้รับหนึ่ง e-stamp สะสม 10 ดวงและคุณจะสามารถแลกรับรอบการซักหรืออบฟรีได้ นี่คือวิธีที่เราขอบคุณที่คุณเลือก Cleanpro!",
  "Credits OFF": "ส่วนลดเครดิต",
  "% OFF": "% ส่วนลด",
  "Valid Till": "ใช้ได้ถึง",
  "Used On": "ใช้เมื่อ",
  "Expired On": "หมดอายุเมื่อ",
  "Available": "พร้อมใช้งาน",
  "Expired": "หมดอายุ",
  "Used": "ใช้แล้ว",
  "Promotions": "โปรโมชั่น",
  "Rewards": "รางวัล",
  "Inbox": "กล่องข้อความ",
  "Activities": "กิจกรรม",
  "Support": "การสนับสนุน",
  "Active Rewards": "รางวัลที่ใช้งานได้",
  "Past Rewards": "รางวัลที่ผ่านมา",
  "Get rewarded for your loyalty with Cleanpro Plus Rewards!": "รับรางวัลสำหรับความภักดีของคุณกับ Cleanpro Plus Rewards!",
  "Earn vouchers and redeem them for discounts, freebies and more. The more you use our services the more you save!": "รับคูปองและแลกรับส่วนลด ของแถม และอื่นๆ ยิ่งคุณใช้บริการของเรามากเท่าไหร่ คุณก็ยิ่งประหยัดมากขึ้นเท่านั้น!",
  "Up to 3 months history": "ประวัติย้อนหลังสูงสุด 3 เดือน",
  "Filter": "กรอง",
  "All Transactions": "ธุรกรรมทั้งหมด",
  "Transactions": "ธุรกรรม",
  "Select amount to topup": "เลือกจำนวนเงินที่จะเติม",
  "Balance": "ยอดคงเหลือ",
  "You've just paid": "คุณเพิ่งชำระเงิน",
  "Need help?": "ต้องการความช่วยเหลือ?",
  "24-Hour Careline Number": "หมายเลขสายด่วน 24 ชั่วโมง",
  "Email Us": "ส่งอีเมลถึงเรา",
  "Call Now": "โทรตอนนี้",
  "Email Now": "ส่งอีเมลตอนนี้",
  "Update name": "อัปเดตชื่อ",
  "Update email address": "อัปเดตที่อยู่อีเมล",
  "Update phone number": "อัปเดตหมายเลขโทรศัพท์",
  "Change password": "เปลี่ยนรหัสผ่าน",
  "Change language": "เปลี่ยนภาษา",
  "User ID": "รหัสผู้ใช้",
  "Let us know your feedback": "แจ้งความคิดเห็นของคุณให้เราทราบ",
  "Poor": "แย่",
  "Good": "ดี",
  "Leave addtional feedback here (optional)": "แสดงความคิดเห็นเพิ่มเติมที่นี่ (ไม่บังคับ)",
  "Submit feedback": "ส่งความคิดเห็น",
  "Pay as guest": "ชำระเงินในฐานะผู้ใช้ทั่วไป",
  "Pay now": "ชำระเงินตอนนี้",
  "Select voucher to use": "เลือกคูปองที่จะใช้",
  "Use voucher": "ใช้คูปอง",
  "Total": "รวม",
  "Transaction Type": "ประเภทธุรกรรม",
  "E-Token Topup": "E-Token Topup", // new translation
  "Credit Topup": "เติมเครดิต",
  "Credit topup": "เติมเครดิต",
  "Credit Transfer": "โอนเครดิต",
  "E-Token Transfer": "E-Token Transfer", // new translation
  "Date/Time": "วันที่/เวลา",
  "Reference ID": "รหัสอ้างอิง",
  "Status": "สถานะ",
  "Share Your Referral Code": "แชร์รหัสแนะนำของคุณ",
  "cleanproReferralShortDesc_one": "รับเครดิตฟรี {{ voucherAmount }} เครดิตเมื่อคุณแชร์รหัสแนะนำของคุณให้กับเพื่อนและครอบครัวหลังจากทำธุรกรรมสำเร็จ แตะเพื่อเรียนรู้เพิ่มเติม",
  "cleanproReferralShortDesc_other": "รับเครดิตฟรี {{ voucherAmount }} เครดิตเมื่อคุณแชร์รหัสแนะนำของคุณให้กับเพื่อนและครอบครัวหลังจากทำธุรกรรมสำเร็จ แตะเพื่อเรียนรู้เพิ่มเติม",
  "Use": "ใช้",
  "dryer or washer": "เครื่องอบหรือเครื่องซัก",
  "washer": "เครื่องซัก",
  "dryer": "เครื่องอบ",
  "dryer and washer": "เครื่องอบและเครื่องซัก",
  "machine with the minimum spending of": "เครื่องที่มีการใช้จ่ายขั้นต่ำ",
  // "Welcome to Cleanpro Plus": "ยินดีต้อนรับสู่ Cleanpro Plus",
  // "Only scan, set & pay! An easier, more convenient way to pay with Cleanpro Plus! No need to download an app. Enjoy more rewards when you use Cleanpro Plus today! Tap to learn more.": "เพียงสแกน ตั้งค่า และชำระเงิน! วิธีการชำระเงินที่ง่ายและสะดวกกว่าด้วย Cleanpro Plus! ไม่จำเป็นต้องดาวน์โหลดแอพ รับรางวัลมากขึ้นเมื่อคุณใช้ Cleanpro Plus วันนี้! แตะเพื่อเรียนรู้เพิ่มเติม",
  // "Cleanpro Pay Migration Notice": "ประกาศการย้ายไปใช้ Cleanpro Pay",
  // "Dear valued Cleanpro customers, please be informed that as of 22 June 2023, the Cleanpro Pay app will be upgraded and and no longer available for use. Tap to learn more.": "เรียนลูกค้า Cleanpro ที่มีค่า โปรดทราบว่าตั้งแต่วันที่ 22 มิถุนายน 2566 แอพ Cleanpro Pay จะได้รับการอัพเกรดและไม่สามารถใช้งานได้อีกต่อไป แตะเพื่อเรียนรู้เพิ่มเติม",
  // "Answer simple questions and win credits for your next wash or dry! This contest is only available for selected outlets only. Tap to learn more.": "ตอบคำถามง่ายๆ และรับเครดิตสำหรับการซักหรืออบครั้งต่อไปของคุณ! การแข่งขันนี้มีให้เฉพาะสาขาที่เลือกเท่านั้น แตะเพื่อเรียนรู้เพิ่มเติม",
  // "The all-new Cleanpro Plus is a new payment method that includes loyalty features built into the app. The more you use our services and pay using Cleanpro Plus, the more you can save. With every transaction, you can earn rewards that will help you save on your next laundry expenses.": "Cleanpro Plus ใหม่ล่าสุดเป็นวิธีการชำระเงินใหม่ที่รวมคุณสมบัติความภักดีเข้าไว้ในแอพ ยิ่งคุณใช้บริการของเราและชำระเงินด้วย Cleanpro Plus มากเท่าไหร่ คุณก็ยิ่งประหยัดได้มากขึ้นเท่านั้น ในทุกๆ ธุรกรรม คุณสามารถรับรางวัลที่จะช่วยให้คุณประหยัดค่าใช้จ่ายในการซักรีดครั้งต่อไปของคุณ",
  // "To use Cleanpro Plus, simply scan the QR code on the machines and pay using your preferred credit/debit card or e-wallet. We hope that Cleanpro Plus will help simplify your laundry routine and give you more time for the things that matter.": "ในการใช้ Cleanpro Plus เพียงสแกนรหัส QR บนเครื่องและชำระเงินโดยใช้บัตรเครดิต/เดบิตหรือกระเป๋าเงินอิเล็กทรอนิกส์ที่คุณต้องการ เราหวังว่า Cleanpro Plus จะช่วยทำให้การซักรีดของคุณง่ายขึ้นและให้เวลากับคุณมากขึ้นสำหรับสิ่งที่สำคัญ",
  // "If you have any questions about Cleanpro Plus, please read our FAQ in the menu or contact our careline at +603 2770 0100 or email us at info@cleanprolaundry.com. Thank you for choosing Cleanpro.": "หากคุณมีคำถามใดๆ เกี่ยวกับ Cleanpro Plus โปรดอ่าน FAQ ในเมนูหรือติดต่อสายด่วนของเราที่ +603 2770 0100 หรือส่งอีเมลถึงเราที่ info@cleanprolaundry.com ขอบคุณที่เลือก Cleanpro",
  // "Dear valued Cleanpro customers, please be informed that as of 22 June 2023, the existing Cleanpro Pay mobile app will be upgraded and no longer available for use.": "เรียนลูกค้า Cleanpro ที่มีค่า โปรดทราบว่าตั้งแต่วันที่ 22 มิถุนายน 2566 แอพมือถือ Cleanpro Pay ที่มีอยู่จะได้รับการอัพเกรดและไม่สามารถใช้งานได้อีกต่อไป",
  // "We are migrating to the all-new Cleanpro Plus. It is a new cashless payment method, without the need to download apps.": "เรากำลังย้ายไปใช้ Cleanpro Plus เวอร์ชันใหม่ ซึ่งเป็นวิธีการชำระเงินแบบไม่ใช้เงินสด โดยไม่จำเป็นต้องดาวน์โหลดแอพ",
  // "If you are the existing user of Cleanpro Pay, any of your remaining balance in the app will be transferred to your Cleanpro Plus account. You are required to use the same mobile number to sign up for Cleanpro Plus for balance transfer.": "หากคุณเป็นผู้ใช้ Cleanpro Pay ที่มีอยู่ ยอดเงินคงเหลือของคุณในแอพจะถูกโอนไปยังบัญชี Cleanpro Plus ของคุณ คุณจำเป็นต้องใช้หมายเลขโทรศัพท์มือถือเดิมในการลงทะเบียน Cleanpro Plus เพื่อโอนยอดเงิน",
  // "If you need help on Cleanpro Plus, please feel free to call our careline at +603 2770 0100 or email us at info@cleanprolaundry.com": "หากคุณต้องการความช่วยเหลือเกี่ยวกับ Cleanpro Plus โปรดติดต่อสายด่วนของเราที่ +603 2770 0100 หรือส่งอีเมลถึงเราที่ info@cleanprolaundry.com",
  // "Answer simple questions and win credits for your next wash or dry!": "ตอบคำถามง่ายๆ และรับเครดิตสำหรับการซักหรืออบครั้งต่อไปของคุณ!",
  // "Step 1 : Scan the Jawab & Gerenti Menang QR code in the participated outlets.": "ขั้นตอนที่ 1 : สแกนรหัส QR Jawab & Gerenti Menang ในสาขาที่เข้าร่วม",
  // "Step 2 : Answer 3 simple questions.": "ขั้นตอนที่ 2 : ตอบคำถามง่ายๆ 3 ข้อ",
  // "Step 3 : Submit and stand a chance to win prizes.": "ขั้นตอนที่ 3 : ส่งคำตอบและลุ้นรับรางวัล",
  // "Grand Prize :": "รางวัลใหญ่ :",
  // "x10 per outlet - 100 credits worth of vouchers in Cleanpro Plus": "10 รางวัลต่อสาขา - คูปองมูลค่า 100 เครดิตใน Cleanpro Plus",
  // "Consolation Prize :": "รางวัลปลอบใจ :",
  // "X25 per outlet - 50 credits worth of vouchers in Cleanpro Plus": "25 รางวัลต่อสาขา - คูปองมูลค่า 50 เครดิตใน Cleanpro Plus",
  // "Participation prize:": "รางวัลการเข้าร่วม:",
  // "Every participants are eligible to receive a FREE 3 credits voucher (worth RM3) in Cleanpro Plus.": "ผู้เข้าร่วมทุกคนมีสิทธิ์รับคูปอง 3 เครดิตฟรี (มูลค่า 3 ริงกิต) ใน Cleanpro Plus",
  // "If you have any questions please don't hesitate to contact our careline at +603 2770 0100 or email us at info@cleanprolaundry.com. Thank you for choosing Cleanpro.": "หากคุณมีคำถามใดๆ โปรดอย่าลังเลที่จะติดต่อสายด่วนของเราที่ +603 2770 0100 หรือส่งอีเมลถึงเราที่ info@cleanprolaundry.com ขอบคุณที่เลือก Cleanpro",
  "Payment Confirmation": "ยืนยันการชำระเงิน",
  "This campaign is only eligible for users who use the all-new Cleanpro Plus web application.": "แคมเปญนี้มีสิทธิ์เฉพาะผู้ใช้ที่ใช้แอปพลิเคชันเว็บ Cleanpro Plus ใหม่ล่าสุดเท่านั้น",
  "ONE e-stamp will be rewarded for each wash or dry cycle.": "จะได้รับ ONE e-stamp สำหรับแต่ละรอบการซักหรืออบ",
  "ONE e-stamp will be rewarded for each wash cycle.": "จะได้รับ ONE e-stamp สำหรับแต่ละรอบการซัก",
  "ONE e-stamp will be rewarded for each dry cycle.": "จะได้รับ ONE e-stamp สำหรับแต่ละรอบการอบ",
  "Regardless of the washer or dryer settings, the number of e-stamps being collected is the same.": "ไม่ว่าจะเป็นการตั้งค่าเครื่องซักหรือเครื่องอบ จำนวน e-stamps ที่สะสมได้จะเท่ากัน",
  "The type of e-stamp collected is based on the services that you have used.": "ประเภทของ e-stamp ที่สะสมได้ขึ้นอยู่กับบริการที่คุณใช้",
  "Washing service will reward washer e-stamp and drying service will reward dryer e-stamp.": "บริการซักจะให้รางวัลเป็น e-stamp เครื่องซัก และบริการอบจะให้รางวัลเป็น e-stamp เครื่องอบ",
  "Washing service will reward washer e-stamp.": "บริการซักจะให้รางวัลเป็น e-stamp เครื่องซัก",
  "Drying service will reward dryer e-stamp.": "บริการอบจะให้รางวัลเป็น e-stamp เครื่องอบ",
  "E-stamps will automatically be added to your account once the condition has been fulfilled.": "E-stamps จะถูกเพิ่มเข้าบัญชีของคุณโดยอัตโนมัติเมื่อเงื่อนไขครบถ้วน",
  "There is no limit on how many e-stamps can be gathered in a single day. So long as you meet the requirements to collect the e-stamps.": "ไม่มีข้อจำกัดว่าสามารถสะสม e-stamps ได้กี่ดวงในหนึ่งวัน ตราบใดที่คุณตรงตามข้อกำหนดในการสะสม e-stamps",
  "The type of e-stamps that have been collected is final and cannot be changed.": "ประเภทของ e-stamps ที่สะสมได้เป็นขั้นสุดท้ายและไม่สามารถเปลี่ยนแปลงได้",
  "There is no expiration for the e-stamps; only till the discontinuation of the campaign.": "ไม่มีวันหมดอายุสำหรับ e-stamps เว้นแต่จะมีการยกเลิกแคมเปญ",
  "E-stamps do not have any currency value, and they cannot be converted to cash or credits.": "E-stamps ไม่มีมูลค่าเป็นเงินตรา และไม่สามารถแลกเป็นเงินสดหรือเครดิตได้",
  "This campaign is not applicable with any other ongoing promotions, offers, vouchers, and/or discounts provided by the participating outlets.": "แคมเปญนี้ไม่สามารถใช้ร่วมกับโปรโมชั่น ข้อเสนอ คูปอง และ/หรือส่วนลดอื่นๆ ที่กำลังดำเนินอยู่ซึ่งจัดโดยสาขาที่เข้าร่วม",
  "These terms and conditions are subject to change at any time without prior notice.": "ข้อกำหนดและเงื่อนไขเหล่านี้อาจมีการเปลี่ยนแปลงได้ตลอดเวลาโดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
  "Press START on the machine to begin washing.": "กดปุ่ม START บนเครื่องเพื่อเริ่มการซัก",
  "Press START on the machine to begin drying.": "กดปุ่ม START บนเครื่องเพื่อเริ่มการอบ",
  "Reminder": "การแจ้งเตือน",
  "Remember to select the same settings you have paid for on the corresponding machine.": "อย่าลืมเลือกการตั้งค่าเดียวกันกับที่คุณได้ชำระเงินไว้บนเครื่องที่เกี่ยวข้อง",
  "Please ensure that your laundry is inside the machine and door is properly shut.": "กรุณาตรวจสอบให้แน่ใจว่าผ้าของคุณอยู่ในเครื่องและประตูปิดสนิทแล้ว",
  "voucherCreditsOff_one": "ส่วนลด {{currentVoucherAmount}} เครดิต",
  "voucherCreditsOff_other": "ส่วนลด {{currentVoucherAmount}} เครดิต",
  "voucherPercentageOff": "ส่วนลด {{currentVoucherAmount}}%",
  "cleanproReferralFlatVoucher_one": "รับเครดิตฟรีเมื่อคุณแชร์รหัสแนะนำ Cleanpro Plus ของคุณให้กับเพื่อนและครอบครัว! สำหรับการแนะนำที่สำเร็จแต่ละครั้งที่ทำธุรกรรมแรก คุณจะได้รับคูปองเครดิตฟรี {{ referralVoucherAmount }} เครดิต",
  "cleanproReferralFlatVoucher_other": "รับเครดิตฟรีเมื่อคุณแชร์รหัสแนะนำ Cleanpro Plus ของคุณให้กับเพื่อนและครอบครัว! สำหรับการแนะนำที่สำเร็จแต่ละครั้งที่ทำธุรกรรมแรก คุณจะได้รับคูปองเครดิตฟรี {{ referralVoucherAmount }} เครดิต",
  "cleanproReferralRateVoucher": "รับเครดิตฟรีเมื่อคุณแชร์รหัสแนะนำ Cleanpro Plus ของคุณให้กับเพื่อนและครอบครัว! สำหรับการแนะนำที่สำเร็จแต่ละครั้งที่ทำธุรกรรมแรก คุณจะได้รับคูปองส่วนลด {{ referralVoucherAmount }}% ฟรี",
  "cleanproReferralTokenReward_one": "รับเครดิตฟรีเมื่อคุณแชร์รหัสแนะนำ Cleanpro Plus ของคุณให้กับเพื่อนและครอบครัว! สำหรับการแนะนำที่สำเร็จแต่ละครั้งที่ทำธุรกรรมแรก คุณจะได้รับ {{ referralToken }} เครดิตฟรี",
  "cleanproReferralTokenReward_other": "รับเครดิตฟรีเมื่อคุณแชร์รหัสแนะนำ Cleanpro Plus ของคุณให้กับเพื่อนและครอบครัว! สำหรับการแนะนำที่สำเร็จแต่ละครั้งที่ทำธุรกรรมแรก คุณจะได้รับ {{ referralToken }} เครดิตฟรี",
  "How to get & use code:": "วิธีรับและใช้รหัส:",
  "Go to menu = icon and click “Refer friends”": "ไปที่เมนู = ไอคอนและคลิก “แนะนำเพื่อน”",
  "Share with everyone who will likely to use Cleanpro Plus.": "แชร์กับทุกคนที่มีแนวโน้มจะใช้ Cleanpro Plus",
  "Referral Terms & Conditions:": "ข้อกำหนดและเงื่อนไขการแนะนำ:",
  "When your friend or family register using your referral code, and completed a transaction (a minimum spending of {{ currency }}{{ referralTransactionAmount }}) , you will be rewarded automatically.": "เมื่อเพื่อนหรือครอบครัวของคุณลงทะเบียนโดยใช้รหัสแนะนำของคุณ และทำธุรกรรมเสร็จสมบูรณ์ (มีการใช้จ่ายขั้นต่ำ {{ currency }}{{ referralTransactionAmount }}) คุณจะได้รับรางวัลโดยอัตโนมัติ",
  "cleanproNumberOfReferralReward": "คุณสามารถแชร์ได้กับคนจำนวนมากเท่าที่คุณต้องการ แต่ผู้ใช้แต่ละคนสามารถรับรางวัลการแนะนำได้เพียง {{ numberOfReferral }} ครั้งเท่านั้น",
  "cleanproNumberOfReferral_one": "คุณสามารถแชร์ได้กับคนจำนวนมากเท่าที่คุณต้องการ แต่ผู้ใช้แต่ละคนสามารถรับคูปองการแนะนำได้เพียง {{ numberOfReferral }} ใบเท่านั้น",
  "cleanproNumberOfReferral_other": "คุณสามารถแชร์ได้กับคนจำนวนมากเท่าที่คุณต้องการ แต่ผู้ใช้แต่ละคนสามารถรับคูปองการแนะนำได้เพียง {{ numberOfReferral }} ใบเท่านั้น",
  "The voucher is valid for {{ duration }} days from the day voucher be given._one": "คูปองมีอายุ {{ duration }} วันนับจากวันที่ได้รับคูปอง",
  "The voucher is valid for {{ duration }} days from the day voucher be given._other": "คูปองมีอายุ {{ duration }} วันนับจากวันที่ได้รับคูปอง",
  "The voucher is for customer use only and not for sale.": "คูปองนี้สำหรับลูกค้าใช้เท่านั้น ไม่สามารถขายต่อได้",
  "We believe that your special day deserves a little extra sparkle! That's why we're thrilled to introduce our exclusive birthday rewards program just for you! Starting this year, and every year thereafter, we're giving away {{ currency }}{{ voucherAmount }} credit vouchers to you on your birthday.": "เราเชื่อว่าวันพิเศษของคุณสมควรได้รับความพิเศษเพิ่มเติม! นั่นคือเหตุผลที่เรารู้สึกตื่นเต้นที่จะแนะนำโปรแกรมรางวัลวันเกิดพิเศษสำหรับคุณโดยเฉพาะ! เริ่มตั้งแต่ปีนี้และทุกๆ ปีหลังจากนี้ เราจะมอบคูปองเครดิตมูลค่า {{ currency }}{{ voucherAmount }} ให้คุณในวันเกิดของคุณ",
  "cleanproBirthdayRateAmount": "เราเชื่อว่าวันพิเศษของคุณสมควรได้รับความพิเศษเพิ่มเติม! นั่นคือเหตุผลที่เรารู้สึกตื่นเต้นที่จะแนะนำโปรแกรมรางวัลวันเกิดพิเศษสำหรับคุณโดยเฉพาะ! เริ่มตั้งแต่ปีนี้และทุกๆ ปีหลังจากนี้ เราจะมอบคูปองส่วนลด {{ voucherAmount }}% ให้คุณในวันเกิดของคุณ",
  "Make sure your account details include your birthdate. This way, we'll know exactly when to send you your special birthday surprise.": "ตรวจสอบให้แน่ใจว่ารายละเอียดบัญชีของคุณมีวันเกิดของคุณ เพื่อให้เราทราบได้ชัดเจนว่าควรส่งเซอร์ไพรส์ของขวัญวันเกิดพิเศษให้คุณเมื่อใด",
  "Birthday Voucher Terms & Conditions:": "ข้อกำหนดและเงื่อนไขคูปองวันเกิด:",
  "The voucher will be given on the first day of your birthday month.": "คูปองจะมอบให้ในวันแรกของเดือนเกิดของคุณ",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount._one": "เมื่อคุณใช้คูปองระหว่างการชำระเงิน คุณจะได้รับส่วนลด {{ voucherAmount }} เครดิต ({{ currency }}{{ voucherAmount }})",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount._other": "เมื่อคุณใช้คูปองระหว่างการชำระเงิน คุณจะได้รับส่วนลด {{ voucherAmount }} เครดิต ({{ currency }}{{ voucherAmount }})",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }}% discount.": "เมื่อคุณใช้คูปองระหว่างการชำระเงิน คุณจะได้รับส่วนลด {{ voucherAmount }}%",
  "All vouchers is not valid with other ongoing promotions, discounts and offers.": "คูปองทั้งหมดไม่สามารถใช้ร่วมกับโปรโมชั่น ส่วนลด และข้อเสนออื่นๆ ที่กำลังดำเนินอยู่",
  "Claim a complimentary wash and dry for every 10 e-stamps collected! We value your loyalty and want to reward you for choosing Cleanpro Plus. Tap to learn more.": "รับสิทธิ์การซักและอบฟรีทุกๆ 10 e-stamps ที่สะสมได้! เราให้คุณค่ากับความภักดีของคุณและต้องการตอบแทนคุณที่เลือก Cleanpro Plus แตะเพื่อเรียนรู้เพิ่มเติม",
  "cleanproStampFlat_one": "ด้วยทุกๆ 10 e-stamps ที่คุณสะสมได้ คุณสามารถแลกรับการซักหรืออบฟรีสูงสุด {{ voucherAmount }} เครดิตกับ Cleanpro Plus ทำให้การซักรีดของคุณไม่เพียงแต่สะดวกสบาย แต่ยังคุ้มค่าอีกด้วย",
  "cleanproStampFlat_other": "ด้วยทุกๆ 10 e-stamps ที่คุณสะสมได้ คุณสามารถแลกรับการซักหรืออบฟรีสูงสุด {{ voucherAmount }} เครดิตกับ Cleanpro Plus ทำให้การซักรีดของคุณไม่เพียงแต่สะดวกสบาย แต่ยังคุ้มค่าอีกด้วย",
  "cleanproStampRate": "ด้วยทุกๆ 10 e-stamps ที่คุณสะสมได้ คุณสามารถแลกรับส่วนลดสูงสุด {{ voucherAmount }}% สำหรับการซักหรืออบกับ Cleanpro Plus ทำให้การซักรีดของคุณไม่เพียงแต่สะดวกสบาย แต่ยังคุ้มค่าอีกด้วย",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "คูปองจะถูกเพิ่มลงในหน้ารางวัลของคุณทันทีเมื่อคุณซักครบ 10 ครั้ง มิเตอร์ e-stamp ของคุณจะถูกรีเซ็ตเป็นศูนย์สำหรับการสะสมครั้งต่อไป แลกคูปองในหน้าสแกน QR เมื่อคุณซักผ้าครั้งต่อไป",
  "A voucher will be instantly added to your Rewards page when you reach 10 drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "คูปองจะถูกเพิ่มลงในหน้ารางวัลของคุณทันทีเมื่อคุณอบครบ 10 ครั้ง มิเตอร์ e-stamp ของคุณจะถูกรีเซ็ตเป็นศูนย์สำหรับการสะสมครั้งต่อไป แลกคูปองในหน้าสแกน QR เมื่อคุณซักผ้าครั้งต่อไป",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes or drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "คูปองจะถูกเพิ่มลงในหน้ารางวัลของคุณทันทีเมื่อคุณซักหรืออบครบ 10 ครั้ง มิเตอร์ e-stamp ของคุณจะถูกรีเซ็ตเป็นศูนย์สำหรับการสะสมครั้งต่อไป แลกคูปองในหน้าสแกน QR เมื่อคุณซักผ้าครั้งต่อไป",
  "Terms & Conditions:": "ข้อกำหนดและเงื่อนไข:",
  "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session._one": "เพื่อรับ ONE e-stamp คุณต้องใช้จ่ายอย่างน้อย {{ stampTransactionAmount }} เครดิต ({{ currency }}{{ stampTransactionAmount }}) ต่อครั้ง",
  "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session._other": "เพื่อรับ ONE e-stamp คุณต้องใช้จ่ายอย่างน้อย {{ stampTransactionAmount }} เครดิต ({{ currency }}{{ stampTransactionAmount }}) ต่อครั้ง",
  "You will be automatically issued a voucher if you have collected 10 washer stamps.": "คุณจะได้รับคูปองโดยอัตโนมัติหากคุณสะสมแสตมป์เครื่องซักครบ 10 ดวง",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps.": "คุณจะได้รับคูปองโดยอัตโนมัติหากคุณสะสมแสตมป์เครื่องอบครบ 10 ดวง",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps or 10 washer stamps.": "คุณจะได้รับคูปองโดยอัตโนมัติหากคุณสะสมแสตมป์เครื่องอบครบ 10 ดวงหรือแสตมป์เครื่องซักครบ 10 ดวง",
  "You will be automatically issued a voucher if you have collected 10 stamps.": "คุณจะได้รับคูปองโดยอัตโนมัติหากคุณสะสมแสตมป์ครบ 10 ดวง",
  "The voucher is non-refundable and cannot be exchanged for cash; in part or in full.": "คูปองไม่สามารถคืนเงินได้และไม่สามารถแลกเป็นเงินสดได้ ไม่ว่าจะบางส่วนหรือทั้งหมด",
  "This voucher is valid for single transaction only.": "คูปองนี้ใช้ได้สำหรับการทำธุรกรรมครั้งเดียวเท่านั้น",
  "General questions": "คำถามทั่วไป",
  "E-stamps collection": "การสะสม E-stamps",
  "Coin exchange machines": "เครื่องแลกเหรียญ",
  "Washer machines": "เครื่องซักผ้า",
  "Dryer machines": "เครื่องอบผ้า",
  "Paywave issues": "ปัญหาเกี่ยวกับ Paywave",
  "Cleanpro franchise": "แฟรนไชส์ Cleanpro",
  "How can I wash my laundry using Cleanpro Plus?": "ฉันจะซักผ้าโดยใช้ Cleanpro Plus ได้อย่างไร?",
  "Here are the steps to wash your laundry using Cleanpro Plus:": "นี่คือขั้นตอนการซักผ้าโดยใช้ Cleanpro Plus:",
  "Find an unoccupied washing machine in the store, and insert your laundry in the washer.": "หาเครื่องซักผ้าที่ว่างในร้าน และใส่ผ้าของคุณลงในเครื่องซัก",
  "Select the desired temperature that you would like to use for your laundry.": "เลือกอุณหภูมิที่คุณต้องการใช้สำหรับการซักผ้าของคุณ",
  "Using the scanner in the app, scan the QR code provided on the washing machine. Then select the same settings that you have pressed on the machine.": "ใช้เครื่องสแกนในแอพ สแกนรหัส QR ที่อยู่บนเครื่องซักผ้า จากนั้นเลือกการตั้งค่าเดียวกันกับที่คุณได้กดบนเครื่อง",
  'Tap on “Pay with credits” to pay the amount shown on the app.': 'แตะที่ "ชำระด้วยเครดิต" เพื่อชำระเงินตามจำนวนที่แสดงในแอพ',
  "Once the payment has been accepted, press the START button on the washer machine.": "เมื่อการชำระเงินได้รับการยอมรับแล้ว ให้กดปุ่ม START บนเครื่องซักผ้า",
  "After the washing cycle ends, you can just remove your laundry from the machine.": "หลังจากรอบการซักสิ้นสุดลง คุณสามารถนำผ้าของคุณออกจากเครื่องได้",
  "How can I dry my laundry using Cleanpro Plus?": "ฉันจะอบผ้าโดยใช้ Cleanpro Plus ได้อย่างไร?",
  "Here are the steps to dry your laundry using Cleanpro Plus:": "นี่คือขั้นตอนการอบผ้าโดยใช้ Cleanpro Plus:",
  "Find an unoccupied drying machine in the store, and insert your laundry in the dryer.": "หาเครื่องอบผ้าที่ว่างในร้าน และใส่ผ้าของคุณลงในเครื่องอบ",
  "Select the desired temperature and duration that you would like to use for your laundry.": "เลือกอุณหภูมิและระยะเวลาที่คุณต้องการใช้สำหรับการอบผ้าของคุณ",
  "Using the scanner in the app, scan the QR code provided on the drying machine. Then select the same settings that you have pressed on the machine.": "ใช้เครื่องสแกนในแอพ สแกนรหัส QR ที่อยู่บนเครื่องอบผ้า จากนั้นเลือกการตั้งค่าเดียวกันกับที่คุณได้กดบนเครื่อง",
  "Once the payment has been accepted, press the START button on the dryer machine.": "เมื่อการชำระเงินได้รับการยอมรับแล้ว ให้กดปุ่ม START บนเครื่องอบผ้า",
  "After the drying cycle ends, you can just remove your laundry from the machine.": "หลังจากรอบการอบสิ้นสุดลง คุณสามารถนำผ้าของคุณออกจากเครื่องได้",
  "Why does the QR code I scanned take me to a different machine?": "ทำไมรหัส QR ที่ฉันสแกนจึงพาฉันไปยังเครื่องอื่น?",
  "Here are the steps to solve it:": "นี่คือขั้นตอนในการแก้ไขปัญหา:",
  "Make sure that the number on the QR code (e.g. W1, W2, etc) is the same as the machine that you would like to use.": "ตรวจสอบให้แน่ใจว่าหมายเลขบนรหัส QR (เช่น W1, W2 เป็นต้น) ตรงกับเครื่องที่คุณต้องการใช้",
  "If the QR code number does not match the machine you want, use the other machine. Please contact our customer service line at 03-27700100 to report this issue.": "หากหมายเลขรหัส QR ไม่ตรงกับเครื่องที่คุณต้องการ ให้ใช้เครื่องอื่น กรุณาติดต่อสายบริการลูกค้าของเราที่ 03-27700100 เพื่อรายงานปัญหานี้",
  "How can I add more time to the washer that I am currently using?": "ฉันจะเพิ่มเวลาให้กับเครื่องซักผ้าที่ฉันกำลังใช้งานอยู่ได้อย่างไร?",
  "The washing time for our washer is fixed and cannot add any additional time.": "เวลาในการซักสำหรับเครื่องซักผ้าของเราถูกกำหนดไว้แน่นอนและไม่สามารถเพิ่มเวลาเพิ่มเติมได้",
  "How can I add more time to the dryer that I am currently using?": "ฉันจะเพิ่มเวลาให้กับเครื่องอบผ้าที่ฉันกำลังใช้งานอยู่ได้อย่างไร?",
  "Here are the steps to add more time to the dryer machine:": "นี่คือขั้นตอนในการเพิ่มเวลาให้กับเครื่องอบผ้า:",
  "By using the scanner in the app, scan the QR code provided at the dryer machine.": "โดยใช้เครื่องสแกนในแอพ สแกนรหัส QR ที่อยู่บนเครื่องอบผ้า",
  "Select the amount of time that you would like to add to the machine.": "เลือกจำนวนเวลาที่คุณต้องการเพิ่มให้กับเครื่อง",
  "After the drying cycle ends, you can just remove the clothes from the machine.": "หลังจากรอบการอบสิ้นสุดลง คุณสามารถนำเสื้อผ้าออกจากเครื่องได้",
  "REMINDER - It is recommended to add drying time 5 minutes before the cycle ends. And you cannot add tokens for extra times when the machine finishes the drying cycle.": "การเตือน - แนะนำให้เพิ่มเวลาอบ 5 นาทีก่อนรอบการอบจะสิ้นสุด และคุณไม่สามารถเพิ่มโทเคนสำหรับเวลาเพิ่มเติมเมื่อเครื่องเสร็จสิ้นรอบการอบแล้ว",
  "Will the timer keep running when I have stopped the drying machine?": "ตัวจับเวลาจะยังคงทำงานต่อไปหรือไม่เมื่อฉันหยุดเครื่องอบผ้า?",
  "Yes. Even after you stop the machine, the timer will continue to run. If you want to extend the drying time, add drying time 5 minutes before the cycle ends. This prevents the cycle from ending before your clothes are completely dried.": "ใช่ แม้หลังจากคุณหยุดเครื่อง ตัวจับเวลาจะยังคงทำงานต่อไป หากคุณต้องการขยายเวลาอบ ให้เพิ่มเวลาอบ 5 นาทีก่อนรอบการอบจะสิ้นสุด วิธีนี้จะช่วยป้องกันไม่ให้รอบการอบสิ้นสุดลงก่อนที่เสื้อผ้าของคุณจะแห้งสนิท",
  "How do I reload my credits for Cleanpro Plus?": "ฉันจะเติมเครดิตสำหรับ Cleanpro Plus ได้อย่างไร?",
  "Here are the steps to reload your credits:": "นี่คือขั้นตอนในการเติมเครดิตของคุณ:",
  "Select the \"Top Up Credit\" button on the homepage.": "เลือกปุ่ม \"เติมเครดิต\" บนหน้าแรก",
  "Choose the amount you want to reload and the payment method you want to use.": "เลือกจำนวนเงินที่คุณต้องการเติมและวิธีการชำระเงินที่คุณต้องการใช้",
  "You will be taken to the payment page. The screen will return to Cleanpro Plus once the transaction is completed.": "คุณจะถูกนำไปยังหน้าการชำระเงิน หน้าจอจะกลับไปยัง Cleanpro Plus เมื่อการทำธุรกรรมเสร็จสมบูรณ์",
  "How many credits can I reload in one transaction?": "ฉันสามารถเติมเครดิตได้กี่เครดิตในหนึ่งธุรกรรม?",
  "Reloading credits requires a minimum of RM 10 and a maximum of RM 50.": "การเติมเครดิตต้องมีขั้นต่ำ 10 ริงกิตและสูงสุด 50 ริงกิต",
  "Can I pay using credits in the Cleanpro Plus app along with tokens or coins in a single transaction?": "ฉันสามารถชำระเงินโดยใช้เครดิตในแอพ Cleanpro Plus พร้อมกับโทเคนหรือเหรียญในธุรกรรมเดียวได้หรือไม่?",
  "No. Only a single payment method may be chosen when performing any transactions.": "ไม่ได้ สามารถเลือกวิธีการชำระเงินได้เพียงวิธีเดียวเท่านั้นเมื่อทำธุรกรรมใดๆ",
  "The amount I have reloaded in my account was not reflected in the app.": "จำนวนเงินที่ฉันได้เติมในบัญชีของฉันไม่ปรากฏในแอพ",
  "Please close and restart the application and check if the new balance has been updated.": "กรุณาปิดและเปิดแอพลิเคชันใหม่ และตรวจสอบว่ายอดเงินใหม่ได้รับการอัปเดตแล้วหรือไม่",
  "If the amount is still not updated, please contact our customer service line at 03-27700110 to receive further assistance.": "หากยอดเงินยังไม่ได้รับการอัปเดต กรุณาติดต่อสายบริการลูกค้าของเราที่ 03-27700110 เพื่อรับความช่วยเหลือเพิ่มเติม",
  "Can I cash out the credits I reloaded in my account for this app?": "ฉันสามารถถอนเงินสดจากเครดิตที่ฉันเติมในบัญชีของฉันสำหรับแอพนี้ได้หรือไม่?",
  "No. The credits that you have reloaded will remain in your Cleanpro Plus account.": "ไม่ได้ เครดิตที่คุณได้เติมจะยังคงอยู่ในบัญชี Cleanpro Plus ของคุณ",
  "I have requested a refund, but I still have not received it.": "ฉันได้ขอคืนเงินแล้ว แต่ยังไม่ได้รับเงินคืน",
  "Please contact our customer service line at 03-27700100 to receive further assistance.": "กรุณาติดต่อสายบริการลูกค้าของเราที่ 03-27700100 เพื่อรับความช่วยเหลือเพิ่มเติม",
  "I have made the payment, and the app double or triple charged me.": "ฉันได้ชำระเงินแล้ว และแอพเรียกเก็บเงินจากฉันสองหรือสามเท่า",
  "The washing machine cannot start even after I have paid using the app.": "เครื่องซักผ้าไม่สามารถเริ่มทำงานได้แม้ว่าฉันจะชำระเงินผ่านแอพแล้ว",
  "Ensure that the temperature settings you have selected and paid for on the application are the same as what you have pressed on the washing machine. If not, select the correct temperature settings on the washing machine and try again.": "ตรวจสอบให้แน่ใจว่าการตั้งค่าอุณหภูมิที่คุณเลือกและชำระเงินในแอปพลิเคชันเหมือนกับที่คุณกดบนเครื่องซักผ้า หากไม่ใช่ โปรดเลือกการตั้งค่าอุณหภูมิที่ถูกต้องบนเครื่องซักผ้าแล้วลองอีกครั้ง",
  "If the machine is still not able to be started, please contact our customer service line at 03-27700100 to receive further assistance.": "หากเครื่องยังไม่สามารถเริ่มทำงานได้ กรุณาติดต่อสายบริการลูกค้าของเราที่ 03-27700100 เพื่อรับความช่วยเหลือเพิ่มเติม",
  "Can I use multiple vouchers together in the same washing or drying cycle?": "ฉันสามารถใช้หลายคูปองพร้อมกันในรอบการซักหรืออบเดียวกันได้หรือไม่?",
  "No. Only a single voucher can be used for each washing and drying cycle.": "ไม่ได้ สามารถใช้ได้เพียงหนึ่งคูปองเท่านั้นสำหรับแต่ละรอบการซักและอบ",
  "Why can't I use my free wash voucher that I received after signing up?": "ทำไมฉันจึงไม่สามารถใช้คูปองซักฟรีที่ฉันได้รับหลังจากลงทะเบียนได้?",
  "To redeem or use the voucher, you must complete at least one washing or drying cycle.": "เพื่อแลกหรือใช้คูปอง คุณต้องทำการซักหรืออบให้เสร็จสิ้นอย่างน้อยหนึ่งรอบ",
  "Can I change my phone number even after registering my account?": "ฉันสามารถเปลี่ยนหมายเลขโทรศัพท์ของฉันได้หรือไม่ แม้จะลงทะเบียนบัญชีแล้ว?",
  "No. Once registered to an account, the phone number is locked into the account.": "ไม่ได้ เมื่อลงทะเบียนกับบัญชีแล้ว หมายเลขโทรศัพท์จะถูกล็อคเข้ากับบัญชีนั้น",
  "I have problems in the store, and who can I refer to for help?": "ฉันมีปัญหาในร้าน และฉันสามารถขอความช่วยเหลือจากใครได้บ้าง?",
  "Do not worry, as you can contact our customer service line at 03-27700100 to receive assistance at any time.": "ไม่ต้องกังวล คุณสามารถติดต่อสายบริการลูกค้าของเราที่ 03-27700100 เพื่อรับความช่วยเหลือได้ตลอดเวลา",
  "Should I add my own laundry detergent and softeners to the washing machine?": "ฉันควรเพิ่มผงซักฟอกและน้ำยาปรับผ้านุ่มของตัวเองลงในเครื่องซักผ้าหรือไม่?",
  "There is no need for that, as all you have to do is bring your dirty clothes and put them in the washer. The detergent and softeners will be provided by us, and you can rest assured that the laundry detergents we used are certified industrial grade.": "ไม่จำเป็น เพราะสิ่งที่คุณต้องทำคือนำเสื้อผ้าที่สกปรกมาใส่ในเครื่องซักผ้าเท่านั้น ผงซักฟอกและน้ำยาปรับผ้านุ่มจะถูกจัดเตรียมโดยเรา และคุณสามารถมั่นใจได้ว่าผงซักฟอกที่เราใช้เป็นเกรดอุตสาหกรรมที่ได้รับการรับรอง",
  "I would like to add my own laundry detergent and softener to the washing machine.": "ฉันต้องการเพิ่มผงซักฟอกและน้ำยาปรับผ้านุ่มของตัวเองลงในเครื่องซักผ้า",
  "We do not recommend our customers add their own detergent, as the mixture of different detergents may affect the wash quality. And you can rest assured that the laundry detergent we used is certified industrial grade.": "เราไม่แนะนำให้ลูกค้าของเราเพิ่มผงซักฟอกของตัวเอง เนื่องจากการผสมผงซักฟอกที่แตกต่างกันอาจส่งผลต่อคุณภาพการซัก และคุณสามารถมั่นใจได้ว่าผงซักฟอกที่เราใช้เป็นเกรดอุตสาหกรรมที่ได้รับการรับรอง",
  "What time does the store close?": "ร้านปิดเวลาไหน?",
  "Our self-service laundry operation is open 24 hours a day, which means you can always be sure to go back home with a fresh set of laundry.": "บริการซักรีดแบบบริการตนเองของเราเปิดให้บริการ 24 ชั่วโมงต่อวัน ซึ่งหมายความว่าคุณสามารถมั่นใจได้เสมอว่าจะได้กลับบ้านพร้อมกับชุดเสื้อผ้าที่สะอาดสดชื่น",
  "Are you open on weekends?": "คุณเปิดให้บริการในวันหยุดสุดสัปดาห์หรือไม่?",
  "Yes. Cleanpro is also open on weekends and even on public holidays.": "ใช่ Cleanpro เปิดให้บริการในวันหยุดสุดสัปดาห์และแม้แต่ในวันหยุดนักขัตฤกษ์",
  "How many clothes can I fit in the washing or drying machine?": "ฉันสามารถใส่เสื้อผ้าได้กี่ชิ้นในเครื่องซักหรือเครื่องอบ?",
  "To ensure that your laundry is properly washed or dried, keep the amount of laundry inside the machine lower than the line of guide sticker on the machine.": "เพื่อให้แน่ใจว่าเสื้อผ้าของคุณจะถูกซักหรืออบอย่างเหมาะสม ให้ใส่เสื้อผ้าในเครื่องให้ต่ำกว่าเส้นสติกเกอร์แนะนำบนเครื่อง",
  "How many e-stamps can I collect in a single day?": "ฉันสามารถสะสม e-stamps ได้กี่ดวงในหนึ่งวัน?",
  "There is no limit to the amount of stamps that can be collected in a single day; ONE stamp will be awarded with every wash or dry.": "ไม่มีข้อจำกัดในจำนวนแสตมป์ที่สามารถสะสมได้ในหนึ่งวัน จะได้รับหนึ่งแสตมป์สำหรับทุกการซักหรืออบ",
  "When I use the washing service, can I change the collected stamp to a dryer stamp, and vice versa?": "เมื่อฉันใช้บริการซัก ฉันสามารถเปลี่ยนแสตมป์ที่สะสมได้เป็นแสตมป์เครื่องอบได้หรือไม่ และในทางกลับกัน?",
  "No, the type of stamp collected is only applied to the service that you have used.": "ไม่ได้ ประเภทของแสตมป์ที่สะสมได้จะใช้ได้เฉพาะกับบริการที่คุณได้ใช้เท่านั้น",
  "What temperatures can I choose when I claim the free washing e-stamp reward?": "ฉันสามารถเลือกอุณหภูมิใดได้บ้างเมื่อฉันแลกรางวัล e-stamp ซักฟรี?",
  "Any washing temperature is available for the e-stamp reward.": "สามารถเลือกอุณหภูมิการซักใดก็ได้สำหรับรางวัล e-stamp",
  "What temperatures can I choose when I claim the free drying e-stamp reward? And how long can I set the time?": "ฉันสามารถเลือกอุณหภูมิใดได้บ้างเมื่อฉันแลกรางวัล e-stamp อบฟรี? และฉันสามารถตั้งเวลาได้นานเท่าไร?",
  "Any drying temperature and duration can be selected for the e-stamp reward.": "สามารถเลือกอุณหภูมิและระยะเวลาการอบใดก็ได้สำหรับรางวัล e-stamp",
  "I'm unable to change the coin.": "ฉันไม่สามารถแลกเหรียญได้",
  "What colour is the light shown on the machine, red or green? If it is a red light, please contact our customer service line at 03-27700100 to receive further assistance.": "สีของไฟที่แสดงบนเครื่องเป็นสีแดงหรือสีเขียว? ถ้าเป็นไฟสีแดง กรุณาติดต่อสายบริการลูกค้าของเราที่ 03-27700100 เพื่อรับความช่วยเหลือเพิ่มเติม",
  "Green Light": "ไฟสีเขียว",
  "Red Light": "ไฟสีแดง",
  "Machine functions as normal. Please try again.": "เครื่องทำงานเป็นปกติ กรุณาลองอีกครั้ง",
  "(flashing 2x) - There are no coins/tokens in the machine.": "(กะพริบ 2 ครั้ง) - ไม่มีเหรียญ/โทเคนในเครื่อง",
  "OR": "หรือ",
  "Note is jammed, please proceed to contact customer service": "ธนบัตรติด กรุณาติดต่อฝ่ายบริการลูกค้า",
  "(flashing 3x) - Note is jammed, please proceed to contact customer service": "(กะพริบ 3 ครั้ง) - ธนบัตรติด กรุณาติดต่อฝ่ายบริการลูกค้า",
  "My notes are stuck in the machine.": "ธนบัตรของฉันติดอยู่ในเครื่อง",
  "My detergent is not dispensing in the vending machine.": "ผงซักฟอกของฉันไม่ถูกจ่ายออกมาในเครื่องจำหน่ายสินค้าอัตโนมัติ",
  "The water is leaking out of the washing machine.": "น้ำรั่วออกมาจากเครื่องซักผ้า",
  "Please check the washer machine to see whether there are any clothes that are stuck at the door side.": "กรุณาตรวจสอบเครื่องซักผ้าว่ามีเสื้อผ้าติดอยู่ที่ด้านประตูหรือไม่",
  "If yes, here are the steps to solve it:": "ถ้าใช่ นี่คือขั้นตอนในการแก้ไข:",
  "Press the emergency stop button (RED Button) for 3 seconds.": "กดปุ่มหยุดฉุกเฉิน (ปุ่มสีแดง) เป็นเวลา 3 วินาที",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at 03-27700100 to receive further assistance)": "รอให้เสียงหยุด จากนั้นจึงเปิดประตู (หากหลังจาก 30 นาทีเสียงยังไม่หยุด กรุณาติดต่อสายบริการลูกค้าของเราที่ 03-27700100 เพื่อรับความช่วยเหลือเพิ่มเติม)",
  "Ensure the door is closed tightly, and press the START button.": "ตรวจสอบให้แน่ใจว่าประตูปิดสนิท และกดปุ่ม START",
  "REMINDER - The emergency stop button can only be used once.": "การเตือน - ปุ่มหยุดฉุกเฉินสามารถใช้ได้เพียงครั้งเดียวเท่านั้น",
  "There is no detergent dispensing in the washing machine.": "ไม่มีการจ่ายผงซักฟอกในเครื่องซักผ้า",
  "Ensure that the machine is in operation and that the START button was pressed.": "ตรวจสอบให้แน่ใจว่าเครื่องกำลังทำงานอยู่และได้กดปุ่ม START แล้ว",
  "If the detergent is still not dispensing, please contact our customer service department at 03-27700100 for further assistance.": "หากผงซักฟอกยังไม่ถูกจ่ายออกมา กรุณาติดต่อฝ่ายบริการลูกค้าของเราที่ 03-27700100 เพื่อรับความช่วยเหลือเพิ่มเติม",
  "The price displayed on the machine's screen did not change after inserting the token.": "ราคาที่แสดงบนหน้าจอของเครื่องไม่เปลี่ยนแปลงหลังจากใส่โทเคน",
  "Press the small button (in the centre) to reject the tokens that have been inserted. Press a few times till the coins come out.": "กดปุ่มเล็ก (ตรงกลาง) เพื่อคืนโทเคนที่ได้ใส่ไป กดหลายๆ ครั้งจนกว่าเหรียญจะออกมา",
  "If the coins still cannot come out or the button is not functioning, please contact our customer service line at 03-27700110 to receive further assistance.": "หากเหรียญยังไม่ออกมาหรือปุ่มไม่ทำงาน กรุณาติดต่อสายบริการลูกค้าของเราที่ 03-27700110 เพื่อรับความช่วยเหลือเพิ่มเติม",
  "The machine is not starting, and it displays an error code.": "เครื่องไม่เริ่มทำงานและแสดงรหัสข้อผิดพลาด",
  "We would like to apologise for any inconvenience caused. Please contact our customer service line at 03-27700100 to receive further assistance.": "เราขออภัยในความไม่สะดวกที่เกิดขึ้น กรุณาติดต่อสายบริการลูกค้าของเราที่ 03-27700100 เพื่อรับความช่วยเหลือเพิ่มเติม",
  "I want to wash the clothes again, but why couldn't the machine start even after I added tokens to the machine?": "ฉันต้องการซักผ้าอีกครั้ง แต่ทำไมเครื่องถึงไม่เริ่มทำงานแม้ว่าฉันจะเพิ่มโทเคนลงในเครื่องแล้ว?",
  "Try opening and closing the door again before starting the machine.": "ลองเปิดและปิดประตูอีกครั้งก่อนเริ่มเครื่อง",
  "Can I change the water temperature of the machine?": "ฉันสามารถเปลี่ยนอุณหภูมิน้ำของเครื่องได้หรือไม่?",
  "Yes, but the washer temperature can only be changed from hot to cold after the machine has been started, and not from cold to hot.": "ได้ แต่อุณหภูมิของเครื่องซักผ้าสามารถเปลี่ยนได้เฉพาะจากร้อนเป็นเย็นหลังจากเครื่องเริ่มทำงานแล้วเท่านั้น และไม่สามารถเปลี่ยนจากเย็นเป็นร้อนได้",
  "Can I stop the machine?": "ฉันสามารถหยุดเครื่องได้หรือไม่?",
  "Here are the steps to stop the machine:": "นี่คือขั้นตอนในการหยุดเครื่อง:",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at to receive further assistance)": "รอให้เสียงหยุด จากนั้นจึงเปิดประตู (หากหลังจาก 30 นาทีเสียงยังไม่หยุด กรุณาติดต่อสายบริการลูกค้าของเราเพื่อรับความช่วยเหลือเพิ่มเติม)",
  "There is no water supply on the machine used.": "ไม่มีน้ำเข้าเครื่องที่ใช้งาน",
  "Why is the washing temperature cold even when I have selected HOT.": "ทำไมอุณหภูมิการซักถึงเย็นแม้ว่าฉันจะเลือก HOT",
  "The water temperature is HOT or WARM only during washing. The water will turn COLD during rinsing.": "อุณหภูมิของน้ำจะร้อนหรืออุ่นเฉพาะในระหว่างการซักเท่านั้น น้ำจะเปลี่ยนเป็นเย็นในระหว่างการล้าง",
  "The machine has already finished washing, but it does not spin well, and there is water left on the load.": "เครื่องซักผ้าเสร็จสิ้นการซักแล้ว แต่ไม่ปั่นแห้งดี และยังมีน้ำเหลืออยู่ในผ้า",
  "Can I put wet laundry into the dryer to dry?": "ฉันสามารถใส่ผ้าเปียกลงในเครื่องอบผ้าเพื่ออบแห้งได้หรือไม่?",
  "No, as the dripping wet laundry might cause the dryer to short circuit.": "ไม่ได้ เนื่องจากผ้าที่เปียกชุ่มอาจทำให้เครื่องอบผ้าเกิดไฟฟ้าลัดวงจรได้",
  "REMINDER - Refer to the labels on your clothes to know what kind of temperature is best for the kind of fabric that it uses. Then select the temperature on the machine accordingly.": "การเตือน - อ้างอิงป้ายกำกับบนเสื้อผ้าของคุณเพื่อทราบว่าอุณหภูมิแบบใดเหมาะสมที่สุดสำหรับประเภทของผ้าที่ใช้ จากนั้นเลือกอุณหภูมิบนเครื่องตามนั้น",
  "My clothes are still wet even after drying.": "เสื้อผ้าของฉันยังเปียกอยู่แม้จะอบแล้ว",
  "How can I stop the dryer when the machine is still running?": "ฉันจะหยุดเครื่องอบผ้าได้อย่างไรเมื่อเครื่องยังทำงานอยู่?",
  "Just open the door and the machine will automatically stop.": "เพียงแค่เปิดประตู เครื่องจะหยุดโดยอัตโนมัติ",
  "I added extra tokens for extra times, but the machine did not update the time.": "ฉันเพิ่มโทเคนพิเศษสำหรับเวลาเพิ่มเติม แต่เครื่องไม่อัปเดตเวลา",
  "For the time to be reflected accurately, it is recommended for you to add tokens 5 minutes before the services end.": "เพื่อให้เวลาถูกแสดงอย่างถูกต้อง แนะนำให้คุณเพิ่มโทเคน 5 นาทีก่อนบริการจะสิ้นสุด",
  "REMINDER - You cannot add tokens for extra times when the machine finishes the drying cycle.": "การเตือน - คุณไม่สามารถเพิ่มโทเคนสำหรับเวลาเพิ่มเติมเมื่อเครื่องเสร็จสิ้นรอบการอบ",
  "Why is the machine making noise?": "ทำไมเครื่องถึงมีเสียงดัง?",
  "Please check the drum to see if there are any coins or other small things inside.": "กรุณาตรวจสอบถังซักว่ามีเหรียญหรือสิ่งของเล็กๆ อื่นๆ อยู่ข้างในหรือไม่",
  "I have pressed the START button on the dryer, but it is still not working.": "ฉันได้กดปุ่ม START บนเครื่องอบผ้าแล้ว แต่มันยังไม่ทำงาน",
  "Please try to open the door and close it again. Next, press the START button again to start drying.": "กรุณาลองเปิดประตูและปิดอีกครั้ง จากนั้นกดปุ่ม START อีกครั้งเพื่อเริ่มการอบ",
  "If the dryer is still not functioning, please contact our customer service line at 03-27700100 to receive further assistance.": "หากเครื่องอบผ้ายังไม่ทำงาน กรุณาติดต่อสายบริการลูกค้าของเราที่ 03-27700100 เพื่อรับความช่วยเหลือเพิ่มเติม",
  "Paywave has deducted an amount from the card but the machine did not reflect the transaction.": "Paywave ได้หักเงินจากบัตรแล้ว แต่เครื่องไม่แสดงการทำรายการ",
  "The Paywave transaction has failed but the amount has still been deducted from my card.": "การทำรายการ Paywave ล้มเหลว แต่ยอดเงินยังถูกหักจากบัตรของฉัน",
  "Paywave has double/triple charge but the machine cannot start.": "Paywave เรียกเก็บเงินสองเท่า/สามเท่า แต่เครื่องไม่สามารถเริ่มทำงานได้",
  "Paywave after double/triple charge machines can't start.": "Paywave หลังจากเรียกเก็บเงินสองเท่า/สามเท่า เครื่องไม่สามารถเริ่มทำงานได้",
  "Paywave is offline": "Paywave ออฟไลน์",
  "Do Cleanpro Express offer franchise business/selling machines/laundry products?": "Cleanpro Express เสนอธุรกิจแฟรนไชส์/ขายเครื่อง/ผลิตภัณฑ์ซักรีดหรือไม่?",
  "For further inquiries, please email to info@cleanproexpress.com": "สำหรับการสอบถามเพิ่มเติม กรุณาส่งอีเมลไปที่ info@cleanproexpress.com",
  "Step 6": "ขั้นตอนที่ 6",
  "User Existed": "มีผู้ใช้อยู่แล้ว",
  "This email is registered": "อีเมลนี้ลงทะเบียนแล้ว",
  "This phone number is registered": "หมายเลขโทรศัพท์นี้ลงทะเบียนแล้ว",
  "Invalid Email Address": "ที่อยู่อีเมลไม่ถูกต้อง",
  "Let's get started!": "มาเริ่มกันเลย!",
  "Enter your e-mail/mobile number": "ป้อนอีเมล/หมายเลขโทรศัพท์มือถือของคุณ",
  "Enter your e-mail": "ป้อนอีเมลของคุณ",
  "Enter your mobile number": "ป้อนหมายเลขโทรศัพท์มือถือของคุณ",
  "Enter your e-mail address": "ป้อนที่อยู่อีเมลของคุณ",
  "Proceed": "ดำเนินการต่อ",
  "Enter OTP number": "ป้อนหมายเลข OTP",
  "You will receive a six-digit OTP via SMS sent to": "คุณจะได้รับรหัส OTP 6 หลักทาง SMS ที่ส่งไปยัง",
  "You will receive a six-digit OTP via e-mail sent to": "คุณจะได้รับรหัส OTP 6 หลักทางอีเมลที่ส่งไปยัง",
  "Verify": "ยืนยัน",
  "Resend OTP": "ส่ง OTP อีกครั้ง",
  "Welcome onboard!": "ยินดีต้อนรับ!",
  "Please fill in the info below": "กรุณากรอกข้อมูลด้านล่าง",
  "Enter your name*": "ป้อนชื่อของคุณ*",
  "Enter your email address*": "ป้อนที่อยู่อีเมลของคุณ*",
  "Please enter either phone number or email address": "กรุณาป้อนหมายเลขโทรศัพท์หรือที่อยู่อีเมล",
  "Create a password*": "สร้างรหัสผ่าน*",
  "Enter referral code (if got any)": "ป้อนรหัสแนะนำ (ถ้ามี)",
  "Get started": "เริ่มต้นใช้งาน",
  "Birthday updated successfully": "อัปเดตวันเกิดสำเร็จ",
  "Date of birth": "วันเกิด",
  "Enter your date of birth": "ป้อนวันเกิดของคุณ",
  "Select your birth date": "เลือกวันเกิดของคุณ",
  "Update date of birth": "อัปเดตวันเกิด",
  "Update birth date": "อัปเดตวันเกิด",
  "Already have an account?": "มีบัญชีอยู่แล้ว?",
  "Login now": "เข้าสู่ระบบตอนนี้",
  "Sign in": "เข้าสู่ระบบ",
  "Sign up now": "ลงทะเบียนตอนนี้",
  "COMPLETED": "เสร็จสิ้น",
  "WASHING NOW": "กำลังซักอยู่",
  "DRYING NOW": "กำลังอบอยู่",
  "It's done!": "เสร็จแล้ว!",
  "Please collect your fresh, clean laundry in order to leave the machine available for the next person to use!": "กรุณารับผ้าที่สะอาดสดชื่นของคุณเพื่อให้เครื่องว่างสำหรับคนต่อไปที่จะใช้!",
  "Leave a feedback": "ให้ข้อเสนอแนะ",
  "Time left": "เวลาที่เหลือ",
  "Add drying time": "เพิ่มเวลาอบ",
  "Hi": "สวัสดี",
  "customer": "ลูกค้า",
  "Thank you for your payment. Don't forget to select the <b>correct temperature</b> and press <b>START</b> when you're ready.": "ขอบคุณสำหรับการชำระเงินของคุณ อย่าลืมเลือก<b>อุณหภูมิที่ถูกต้อง</b>และกด<b>START</b>เมื่อคุณพร้อม",
  "Select how you want to receive a notification when your laundry is finished": "เลือกวิธีที่คุณต้องการรับการแจ้งเตือนเมื่อการซักผ้าของคุณเสร็จสิ้น",
  "Sign up": "ลงทะเบียน",
  "Continue to pay": "ดำเนินการชำระเงินต่อ",
  "Register as a member to enjoy more benefits!": "ลงทะเบียนเป็นสมาชิกเพื่อรับสิทธิประโยชน์มากขึ้น!",
  "Get FREE {{ voucherAmount }} credits per new user_one": "รับ {{ voucherAmount }} เครดิตฟรีต่อผู้ใช้ใหม่",
  "Get FREE {{ voucherAmount }} credits per new user_other": "รับ {{ voucherAmount }} เครดิตฟรีต่อผู้ใช้ใหม่",
  "Get FREE {{ voucherAmount }}% per new user": "รับส่วนลด {{ voucherAmount }}% ฟรีต่อผู้ใช้ใหม่",
  "Enjoy exclusive promotions": "เพลิดเพลินกับโปรโมชั่นพิเศษ",
  "FREE voucher on your birthday": "คูปองฟรีในวันเกิดของคุณ",
  "and more": "และอื่นๆ อีกมากมาย",
  "Denied camera access": "ปฏิเสธการเข้าถึงกล้อง",
  "Permission to access the camera has been denied. Please try again and click \"Allow\" to scan the QR code.": "การอนุญาตให้เข้าถึงกล้องถูกปฏิเสธ กรุณาลองอีกครั้งและคลิก \"อนุญาต\" เพื่อสแกนรหัส QR",
  "Okay": "ตกลง",
  "Oops. You don't have enough balance to make the payment": "อุ๊ปส์ คุณมียอดเงินไม่เพียงพอที่จะชำระเงิน",
  "Please confirm": "กรุณายืนยัน",
  "Do you want to proceed with this feedback?": "คุณต้องการดำเนินการกับข้อเสนอแนะนี้หรือไม่?",
  "Are you sure to purchase": "คุณแน่ใจหรือไม่ที่จะซื้อ",
  "credits for": "เครดิตสำหรับ",
  "Topup credit": "เติมเครดิต",
  "Extended duration will be instantly reflected on machine after payment": "ระยะเวลาที่ขยายจะถูกแสดงทันทีบนเครื่องหลังจากชำระเงิน",
  "Machine is currently busy": "เครื่องกำลังทำงานอยู่",
  "Do you want to extend drying time?": "คุณต้องการขยายเวลาอบหรือไม่?",
  // "Cuci Hari-Hari Bersama Cleanpro!": "ซักทุกวันกับ Cleanpro!",
  // "Ready for a challenge?": "พร้อมรับความท้าทายหรือไม่?",
  // "Here's one for you - all you need to do is wash your laundry 10 times in 20 days at participating Cleanpro outlets. Stand a chance to win a Limited Edition Cleanpro Designer Laundry Bag worth up to RM40!": "นี่คือความท้าทายสำหรับคุณ - สิ่งที่คุณต้องทำคือซักผ้า 10 ครั้งภายใน 20 วันที่สาขา Cleanpro ที่ร่วมรายการ มีโอกาสชนะถุงซักผ้าดีไซเนอร์ Limited Edition ของ Cleanpro มูลค่าสูงถึง 40 ริงกิต!",
  // "Here's how to participate:": "นี่คือวิธีการเข้าร่วม:",
  // "Step 1: Scan the QR Code on the washer to launch Cleanpro Plus": "ขั้นตอนที่ 1: สแกนรหัส QR บนเครื่องซักผ้าเพื่อเปิด Cleanpro Plus",
  // "Step 2: Pay for your wash with Cleanpro Plus": "ขั้นตอนที่ 2: ชำระค่าซักผ้าด้วย Cleanpro Plus",
  // "Step 3: Complete x10 washes within 20 days to win": "ขั้นตอนที่ 3: ซักผ้าให้ครบ 10 ครั้งภายใน 20 วันเพื่อชนะ",
  // "Challenge Period: 01 July - 31 August 2023": "ระยะเวลาของความท้าทาย: 1 กรกฎาคม - 31 สิงหาคม 2566",
  // "Drop by your nearest Cleanpro outlet to wash your laundry with us for 20 days straight! Good luck!": "แวะมาที่สาขา Cleanpro ที่ใกล้ที่สุดเพื่อซักผ้ากับเราเป็นเวลา 20 วันติดต่อกัน! ขอให้โชคดี!",
  // "TERMS & CONDITIONS": "ข้อกำหนดและเงื่อนไข",
  // "PARTICIPATION CRITERIA": "เกณฑ์การเข้าร่วม",
  // "1) Participant needs to register an account in Cleanpro Plus web app.": "1) ผู้เข้าร่วมต้องลงทะเบียนบัญชีในแอพเว็บ Cleanpro Plus",
  // "2) Participant can use any washer of any capacity in any participating outlets to qualify for entries.": "2) ผู้เข้าร่วมสามารถใช้เครื่องซักผ้าใดก็ได้ที่มีความจุเท่าใดก็ได้ในสาขาที่เข้าร่วมรายการเพื่อมีสิทธิ์เข้าร่วม",
  // "3) Payment needs to be made with Cleanpro Plus web app.": "3) ต้องชำระเงินด้วยแอพเว็บ Cleanpro Plus",
  // "4) Washes must be completed and paid (with no dispute whatsoever) within campaign period.": "4) ต้องซักผ้าให้เสร็จสิ้นและชำระเงิน (โดยไม่มีข้อโต้แย้งใดๆ) ภายในระยะเวลาของแคมเปญ",
  // "5) Campaign period starts from 1st July 2023 at 00:00 and ends at 31st August 2023 at 23:59.": "5) ระยะเวลาของแคมเปญเริ่มตั้งแต่วันที่ 1 กรกฎาคม 2566 เวลา 00:00 น. และสิ้นสุดวันที่ 31 สิงหาคม 2566 เวลา 23:59 น.",
  // "WINNERS & PRIZES": "ผู้ชนะและรางวัล",
  // "1) Cleanpro will notify the winners of the campaign via registered WhatsApp number or email address provided, within 4 weeks after the campaign ends.": "1) Cleanpro จะแจ้งผู้ชนะของแคมเปญผ่านทางหมายเลข WhatsApp หรือที่อยู่อีเมลที่ลงทะเบียนไว้ ภายใน 4 สัปดาห์หลังจากแคมเปญสิ้นสุด",
  // "2) Any unclaimed prizes after 2 weeks from notification date will not be entertained thereafter.": "2) รางวัลที่ไม่มีการเรียกร้องหลังจาก 2 สัปดาห์นับจากวันที่แจ้งจะไม่ได้รับการพิจารณาหลังจากนั้น",
  // "3) Upon completing the ten (10) washes within twenty (20) days campaign, participants will be a winner and be eligible to win ONE (1) Cleanpro Designer Laundry Bag.": "3) เมื่อซักผ้าครบสิบ (10) ครั้งภายในยี่สิบ (20) วันของแคมเปญ ผู้เข้าร่วมจะเป็นผู้ชนะและมีสิทธิ์ได้รับถุงซักผ้าดีไซเนอร์ Cleanpro หนึ่ง (1) ใบ",
  // "4) Winners are eligible to win more than ONE (1) Cleanpro Designer Laundry Bag in this campaign.": "4) ผู้ชนะมีสิทธิ์ได้รับถุงซักผ้าดีไซเนอร์ Cleanpro มากกว่าหนึ่ง (1) ใบในแคมเปญนี้",
  // "5) Winners will be given the choice of his/her preferred laundry bag size; but only ONE (1) can be selected for each qualified win.": "5) ผู้ชนะจะได้รับสิทธิ์เลือกขนาดถุงซักผ้าที่ต้องการ แต่สามารถเลือกได้เพียงหนึ่ง (1) ใบสำหรับแต่ละการชนะที่มีคุณสมบัติครบ",
  // "A) XL Size - Blue bag with up to 20KG in capacity": "A) ขนาด XL - ถุงสีน้ำเงินที่มีความจุสูงสุด 20 กิโลกรัม",
  // "B) L Size - White bag with up to 12KG in capacity": "B) ขนาด L - ถุงสีขาวที่มีความจุสูงสุด 12 กิโลกรัม",
  // "6) Time and location for collection of prize will be informed via Whatsapp number and/or email address provided.": "6) เวลาและสถานที่สำหรับการรับรางวัลจะแจ้งให้ทราบผ่านทางหมายเลข Whatsapp และ/หรือที่อยู่อีเมลที่ให้ไว้",
  "OTHER": "อื่นๆ",
  // "1) Changes to the terms and conditions will be at Cleanpro's discretion; without prior notice.": "1) การเปลี่ยนแปลงข้อกำหนดและเงื่อนไขจะขึ้นอยู่กับดุลยพินิจของ Cleanpro โดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
  // "2) Completed wash is defined by washes performed with Cleanpro's washer and payments within Cleanpro Plus web app are made with no disputes.": "2) การซักที่เสร็จสมบูรณ์หมายถึงการซักที่ดำเนินการด้วยเครื่องซักผ้าของ Cleanpro และการชำระเงินภายในแอพเว็บ Cleanpro Plus โดยไม่มีข้อโต้แย้ง",
  // "3) By participating in this campaign automatically indicates that the Participant has agreed to all the campaign's Terms and Conditions as stipulated.": "3) การเข้าร่วมในแคมเปญนี้โดยอัตโนมัติแสดงว่าผู้เข้าร่วมได้ยอมรับข้อกำหนดและเงื่อนไขทั้งหมดของแคมเปญตามที่ระบุไว้",
  "Welcome Voucher": "คูปองต้อนรับ",
  "Welcome to the Cleanpro Plus family! This first gift is just the beginning. Stay tuned for a series of exciting promotions and campaigns, exclusively for Cleanpro Plus users.": "ยินดีต้อนรับสู่ครอบครัว Cleanpro Plus! ของขวัญชิ้นแรกนี้เป็นเพียงจุดเริ่มต้น โปรดติดตามโปรโมชั่นและแคมเปญที่น่าตื่นเต้นมากมาย ซึ่งมีไว้เฉพาะสำหรับผู้ใช้ Cleanpro Plus เท่านั้น",
  "Terms & Conditions": "ข้อกำหนดและเงื่อนไข",
  "TERMS AND CONDITIONS": "ข้อกำหนดและเงื่อนไข",
  "Welcome Voucher is valid for one-time use only.": "คูปองต้อนรับใช้ได้เพียงครั้งเดียวเท่านั้น",
  "There is no minimum spend required for the voucher to be used.": "ไม่มีการกำหนดยอดใช้จ่ายขั้นต่ำสำหรับการใช้คูปอง",
  "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only._one": "คูปองต้อนรับจะถูกเครดิตเข้าบัญชีผู้ใช้โดยอัตโนมัติ ณ จุดที่ลงทะเบียนบน Cleanpro Plus และมีอายุการใช้งานเพียง {{ duration }} วันเท่านั้น",
  "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only._other": "คูปองต้อนรับจะถูกเครดิตเข้าบัญชีผู้ใช้โดยอัตโนมัติ ณ จุดที่ลงทะเบียนบน Cleanpro Plus และมีอายุการใช้งานเพียง {{ duration }} วันเท่านั้น",
  "Users are eligible to use their Welcome Voucher AFTER the completion of their first wash or dry cycle using the same Cleanpro Plus account.": "ผู้ใช้มีสิทธิ์ใช้คูปองต้อนรับหลังจากเสร็จสิ้นการซักหรืออบรอบแรกโดยใช้บัญชี Cleanpro Plus เดียวกัน",
  "Welcome Voucher cannot be used together with any ongoing promotions or any other promotional vouchers.": "คูปองต้อนรับไม่สามารถใช้ร่วมกับโปรโมชั่นที่กำลังดำเนินอยู่หรือคูปองโปรโมชั่นอื่นๆ ได้",
  "The voucher is final and cannot be refunded in form of cash or credit to the user.": "คูปองเป็นสิ่งสุดท้ายและไม่สามารถคืนเงินในรูปแบบเงินสดหรือเครดิตให้กับผู้ใช้ได้",
  "Cleanpro reserves the right to change the terms and conditions without prior notice.": "Cleanpro ขอสงวนสิทธิ์ในการเปลี่ยนแปลงข้อกำหนดและเงื่อนไขโดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})_one": "สะสม 10 e-stamps เพื่อรับคูปองเครดิตฟรี {{ voucherAmount }} เครดิต (มูลค่า {{ currency }}{{ voucherAmount }})",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})_other": "สะสม 10 e-stamps เพื่อรับคูปองเครดิตฟรี {{ voucherAmount }} เครดิต (มูลค่า {{ currency }}{{ voucherAmount }})",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }}% voucher (worth {{ voucherAmount }}%)": "สะสม 10 e-stamps เพื่อรับคูปองส่วนลด {{ voucherAmount }}% ฟรี (มูลค่า {{ voucherAmount }}%)",
  "Collect 10 e-Stamp to earn FREE Voucher": "สะสม e-Stamp 10 ดวงเพื่อรับบัตรกำนัลฟรี",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding._one": "ทุกๆ 10 e-stamps ที่คุณสะสม คุณจะได้รับคูปองเครดิตฟรี {{ voucherAmount }} เครดิต (มูลค่า {{ currency }}{{ voucherAmount }}) ทำให้การซักรีดของคุณไม่เพียงแต่ไร้ความยุ่งยาก แต่ยังให้รางวัลด้วย",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding._other": "ทุกๆ 10 e-stamps ที่คุณสะสม คุณจะได้รับคูปองเครดิตฟรี {{ voucherAmount }} เครดิต (มูลค่า {{ currency }}{{ voucherAmount }}) ทำให้การซักรีดของคุณไม่เพียงแต่ไร้ความยุ่งยาก แต่ยังให้รางวัลด้วย",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }}% credits voucher (worth {{ voucherAmount }}%). Make your laundry routine not just hassle-free, but also rewarding.": "ทุกๆ 10 e-stamps ที่คุณสะสม คุณจะได้รับคูปองส่วนลด {{ voucherAmount }}% ฟรี (มูลค่า {{ voucherAmount }}%) ทำให้การซักรีดของคุณไม่เพียงแต่ไร้ความยุ่งยาก แต่ยังให้รางวัลด้วย",
  // "How to participate:": "วิธีการเข้าร่วม:",
  // "Prizes to be won:": "รางวัลที่จะได้รับ:",
  "RM10 OFF Welcome Voucher": "คูปองต้อนรับส่วนลด 10 ริงกิต",
  "Welcome to the Cleanpro family, here is an appreciation voucher from us. Thank you for attending the COPE Investors Conference.": "ยินดีต้อนรับสู่ครอบครัว Cleanpro นี่คือคูปองแสดงความขอบคุณจากเรา ขอบคุณที่เข้าร่วมการประชุมนักลงทุน COPE",
  "Welcome Voucher | COPE Investors Conference": "คูปองต้อนรับ | การประชุมนักลงทุน COPE",
  "Payment methods": "วิธีการชำระเงิน",
  "Tap to proceed with your preferred mode of payment": "แตะเพื่อดำเนินการด้วยวิธีการชำระเงินที่คุณต้องการ",
  "Cleanpro Plus credits": "เครดิต Cleanpro Plus",
  "E-wallet or credit/debit cards": "กระเป๋าเงินอิเล็กทรอนิกส์หรือบัตรเครดิต/เดบิต",
  "Go to homepage": "ไปที่หน้าหลัก",
  // backend response or error
  "Admin is unauthorized to login": "ผู้ดูแลระบบไม่ได้รับอนุญาตให้เข้าสู่ระบบ",
  "Internal Error": "ข้อผิดพลาดภายใน",
  "Please enter the correct credentials": "กรุณาป้อนข้อมูลประจำตัวที่ถูกต้อง",
  "Operator not found": "ไม่พบผู้ให้บริการ",
  "Admin not found": "ไม่พบผู้ดูแลระบบ",
  "Distributor not found": "ไม่พบผู้จัดจำหน่าย",
  "Client not found": "ไม่พบลูกค้า",
  "Outlet not found": "ไม่พบสาขา",
  "Token Package not found": "ไม่พบแพ็คเกจโทเคน",
  "Top up history not found": "ไม่พบประวัติการเติมเงิน",
  "Voucher not found": "ไม่พบคูปอง",
  "Faq not found": "ไม่พบคำถามที่พบบ่อย",
  "Faq Group not found": "ไม่พบกลุ่มคำถามที่พบบ่อย",
  "News not found": "ไม่พบข่าว",
  "Transaction not found": "ไม่พบธุรกรรม",
  "Please Login Again": "กรุณาเข้าสู่ระบบอีกครั้ง",
  "Decoding Error": "ข้อผิดพลาดในการถอดรหัส",
  "Some error occured, please contact the dev team if this error continues.": "เกิดข้อผิดพลาดบางอย่าง กรุณาติดต่อทีมนักพัฒนาหากข้อผิดพลาดนี้ยังคงเกิดขึ้น",
  "Please fill in all the required fields": "กรุณากรอกข้อมูลในช่องที่จำเป็นทั้งหมด",
  "Only success transaction can be refund": "เฉพาะธุรกรรมที่สำเร็จเท่านั้นที่สามารถขอคืนเงินได้",
  "Only token payment method can be refund": "เฉพาะวิธีการชำระเงินด้วยโทเคนเท่านั้นที่สามารถขอคืนเงินได้",
  "The discount code has been used, please change to other code": "รหัสส่วนลดนี้ถูกใช้ไปแล้ว กรุณาเปลี่ยนเป็นรหัสอื่น",
  "Cannot use ewallet in sandbox": "ไม่สามารถใช้กระเป๋าเงินอิเล็กทรอนิกส์ในโหมดทดลองได้",
  "Please close the door to proceed your payment": "กรุณาปิดประตูเพื่อดำเนินการชำระเงินของคุณ",
  "Under Maintenance": "กำลังอยู่ในระหว่างการบำรุงรักษา",
  "This machine is being fixed. Please use another machine.": "เครื่องนี้กำลังถูกซ่อมแซม กรุณาใช้เครื่องอื่น",
  "Machine is currently running, please try again later": "เครื่องกำลังทำงานอยู่ กรุณาลองอีกครั้งในภายหลัง",
  "Machine is currently offline, please try again later": "เครื่องกำลังออฟไลน์อยู่ กรุณาลองอีกครั้งในภายหลัง",
  "Outlet not participating in Loyalty program": "สาขาไม่ได้เข้าร่วมโปรแกรมสมาชิก",
  "Please log in to make the payment": "กรุณาเข้าสู่ระบบเพื่อทำการชำระเงิน",
  "Package not found, please refresh and try again": "ไม่พบแพ็คเกจ กรุณารีเฟรชและลองอีกครั้ง",
  "You have reached the maximum number of purchase": "คุณได้ถึงจำนวนการซื้อสูงสุดแล้ว",
  "Store not found, please try again later": "ไม่พบร้าน กรุณาลองอีกครั้งในภายหลัง",
  "Incorrect Password": "รหัสผ่านไม่ถูกต้อง",
  "Token already top up": "เติมโทเคนแล้ว",
  "Payment failed": "การชำระเงินล้มเหลว",
  "Transaction Failure": "ธุรกรรมล้มเหลว",
  "Transaction Refunded": "คืนเงินธุรกรรมแล้ว",
  "Transaction Pending": "ธุรกรรมกำลังดำเนินการ",
  "Please enter your mobile number": "กรุณาป้อนหมายเลขโทรศัพท์มือถือของคุณ",
  "User is unauthorized to register": "ผู้ใช้ไม่ได้รับอนุญาตให้ลงทะเบียน",
  "Please proceed to sign up": "กรุณาดำเนินการลงทะเบียน",
  "OTP expired, please request a new OTP": "OTP หมดอายุ กรุณาขอ OTP ใหม่",
  "Incorrect verification code": "รหัสยืนยันไม่ถูกต้อง",
  "This referrer ID is not valid": "รหัสผู้แนะนำนี้ไม่ถูกต้อง",
  "This referrer ID is different operator": "รหัสผู้แนะนำนี้เป็นผู้ให้บริการที่แตกต่างกัน",
  "This referrer ID is exceed the limit": "รหัสผู้แนะนำนี้เกินขีดจำกัด",
  "User is unauthorized to login": "ผู้ใช้ไม่ได้รับอนุญาตให้เข้าสู่ระบบ",
  "Click here to register": "คลิกที่นี่เพื่อลงทะเบียน",
  "User is unauthorized to login. Please contact the admin": "ผู้ใช้ไม่ได้รับอนุญาตให้เข้าสู่ระบบ กรุณาติดต่อผู้ดูแลระบบ",
  "User is unauthorized": "ผู้ใช้ไม่ได้รับอนุญาต",
  "This outlet does not participate in the Loyalty Program": "สาขานี้ไม่ได้เข้าร่วมโปรแกรมสมาชิก",
  "This outlet is not belongs to the operator": "สาขานี้ไม่ได้เป็นของผู้ให้บริการ",
  "Processing request": "กำลังประมวลผลคำขอ",
  "This user is not verified": "ผู้ใช้นี้ยังไม่ได้รับการยืนยัน",
  "Insufficient token to make payment": "โทเคนไม่เพียงพอที่จะทำการชำระเงิน",
  "Insufficient token to transfer": "Insufficient token to transfer", // new translation
  "Insufficient point to make payment": "Insufficient point to make payment",
  "This voucher is not available for use": "คูปองนี้ไม่สามารถใช้งานได้",
  "This voucher is belongs to other user": "คูปองนี้เป็นของผู้ใช้อื่น",
  "Invalid Discount Code": "รหัสส่วนลดไม่ถูกต้อง",
  "This discount code cannot use in this outlet": "ไม่สามารถใช้รหัสส่วนลดนี้ในสาขานี้ได้",
  "This discount code was expired": "รหัสส่วนลดนี้หมดอายุแล้ว",
  "This discount code cannot use in washer machine transaction": "ไม่สามารถใช้รหัสส่วนลดนี้ในธุรกรรมเครื่องซักผ้าได้",
  "This discount code cannot use in dryer machine transaction": "ไม่สามารถใช้รหัสส่วนลดนี้ในธุรกรรมเครื่องอบผ้าได้",
  "This discount code was fully redeemed today, try again tomorrow": "รหัสส่วนลดนี้ถูกใช้หมดแล้วในวันนี้ ลองอีกครั้งในวันพรุ่งนี้",
  "You have fully redeemed this discount code": "คุณได้ใช้รหัสส่วนลดนี้เต็มจำนวนแล้ว",
  "This discount code have been redeemed": "รหัสส่วนลดนี้ถูกใช้ไปแล้ว",
  "This discount code is not applicable": "รหัสส่วนลดนี้ไม่สามารถใช้ได้",
  "Insufficient stamp": "แสตมป์ไม่เพียงพอ",
  "Please provide at least one voucher setting": "กรุณาระบุการตั้งค่าคูปองอย่างน้อยหนึ่งรายการ",
  "Previous batch are still generating, please try again later": "ชุดก่อนหน้ายังอยู่ในระหว่างการสร้าง กรุณาลองอีกครั้งในภายหลัง",
  "Number of voucher code should be more than 0": "จำนวนรหัสคูปองควรมากกว่า 0",
  "Number of voucher code should be less than 50000": "จำนวนรหัสคูปองควรน้อยกว่า 50000",
  "Number of discount code should be more than 0": "จำนวนรหัสส่วนลดควรมากกว่า 0",
  "Number of discount code should be less than 50000": "จำนวนรหัสส่วนลดควรน้อยกว่า 50000",
  "No Item": "ไม่มีรายการ",
  "Please add item": "กรุณาเพิ่มรายการ",
  "Staff not found": "ไม่พบพนักงาน",
  "This task already completed": "งานนี้เสร็จสมบูรณ์แล้ว",
  "Please complete the wash task first": "กรุณาทำงานซักให้เสร็จก่อน",
  "Please complete the dry task first": "กรุณาทำงานอบให้เสร็จก่อน",
  "Please select at least one outlet": "กรุณาเลือกสาขาอย่างน้อยหนึ่งสาขา",
  "Touch to Start": "Touch to Start", // new translation
  "New Users": "New Users",
  "Get {{ voucher_amount }} FREE Credits!": "Get {{ voucher_amount }} FREE Credits!",
  "Get {{ voucher_amount }}% FREE!": "Get {{ voucher_amount }}% FREE!",
  "Load your clothes into the washing machine & note the machine number": "Load your clothes into the washing machine & note the machine number",
  "T&C Apply": "T&C Apply",
  "Mobile Number": "Mobile Number",
  "Member": "Member",
  "Please enter your mobile phone number / e-mail": "Please enter your mobile phone number / e-mail",
  "Please verify your number": "Please verify your number",
  "Please verify your e-mail": "Please verify your e-mail",
  "Please enter the correct phone number format. Example: 01xxxxxxxx": "Please enter the correct phone number format. Example: 01xxxxxxxx",
  "Please enter the correct phone number format. Example: 09xxxxxxxx": "Please enter the correct phone number format. Example: 09xxxxxxxx",
  "Scan QR to Complete your signup & access more benefits!": "Scan QR to Complete your signup & access more benefits!",
  "Please choose your service": "Please choose your service",
  "WASHER": "WASHER",
  "DRYER": "DRYER",
  "VENDING MACHINE": "VENDING MACHINE",
  "Please tap your card on the reader": "Please tap your card on the reader",
  "Payment Option": "Payment Option",
  "Thank you for payment!": "Thank you for payment!",
  "Please select your items at the vending machine": "Please select your items at the vending machine",
  "Please choose the temperature on the machine and press": "Please choose the temperature on the machine and press",
  "START": "START",
  "Need Help?": "Need Help?",
  "Please choose the temperature": "Please choose the temperature",
  "Confirm Payment": "Confirm Payment",
  "Select the time for": "Select the time for",
  "Do you want to add drying time?": "Do you want to add drying time?",
  "Your machine is": "Your machine is",
  "Please Collect your item from the vending machine": "Please Collect your item from the vending machine",
  "You've earned 1 e-stamp for your wash!": "You've earned 1 e-stamp for your wash!",
  "You've earned 1 e-stamp for your dry!": "You've earned 1 e-stamp for your dry!",
  "You've missed 1 e-stamp for your wash!": "You've missed 1 e-stamp for your wash!",
  "You've missed 1 e-stamp for your dry!": "You've missed 1 e-stamp for your dry!",
  "Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.",
  "Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.",
  "Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.",
  "Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.",
  "Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.",
  "Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "Sign Up & Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "Sign Up & Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.",
  "Sign Up & Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "Sign Up & Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.",
  "Sign Up & Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "Sign Up & Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.",
  "Sign Up & Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "Sign Up & Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.",
  "Sign Up & Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "Sign Up & Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.",
  'For iOS users, press and hold the image, then choose "Add to Photos" or "Save in Photos" from the menu.': 'For iOS users, press and hold the image, then choose "Add to Photos" or "Save in Photos" from the menu.',
  "Scan the QR code to pay": "Scan the QR code to pay",
  "QR Code expires in {{ countdown }} seconds": "QR Code expires in {{ countdown }} seconds",
  "Transfer In": "โอนเข้า",
  "Migrate": "ย้ายถิ่น",
  "Update": "อัปเดต",
  "Transfer Out": "โอนออก",
  "Total In": "รวมเข้า",
  "Total Out": "รวมออก",
  "Laundry Pass": "Laundry Pass",
  "Number of wash": "Number of wash",
  "Number of Wash": "Number of Wash",
  "Number of dry": "Number of dry",
  "Number of Dry": "Number of Dry",
  "Laundry Pass Purchase": "Laundry Pass Purchase",
  "Laundry Pass Purchase Report": "Laundry Pass Purchase Report",
  "Please select distributor or operator": "Please select distributor or operator",
  "Price should be more than 0": "Price should be more than 0",
  "Number of wash or dry should be more than 0": "Number of wash or dry should be more than 0",
  "Number of wash should be more than 0": "Number of wash should be more than 0",
  "Number of dry should be more than 0": "Number of dry should be more than 0",
  "Duration must be more than 0": "Duration must be more than 0",
  "Please fill in the name": "Please fill in the name",
  "Purchase Start Date": "Purchase Start Date",
  "Purchase End Date": "Purchase End Date",
  "Number of Maximum Purchase": "Number of Maximum Purchase",
  "Create Laundry Pass": "Create Laundry Pass",
  "Select Purchase Period": "Select Purchase Period",
  "If ticked, the Laundry Pass will have expired date": "If ticked, the Laundry Pass will have expired date",
  "Laundry Pass Lifespan": "Laundry Pass Lifespan",
  "Edit Laundry Pass": "Edit Laundry Pass",
  "Washer Used Date": "Washer Used Date",
  "Dryer Used Date": "Dryer Used Date",
  "Laundry Pass Purchase History": "Laundry Pass Purchase History",
  "Laundry Pass Usage Report": "Laundry Pass Usage Report",
  "Please Note! (Stacked Dryer)": "Please Note! (Stacked Dryer)",
  "Ensure machine is vacant and select correct machine after payment press START": "Ensure machine is vacant and select correct machine after payment press START",
  "Start date": "Start date",
  "End date": "End date",
  "Today": "Today",
  "Yesterday": "Yesterday",
  "Last 7 Days": "Last 7 Days",
  "Last 30 Days": "Last 30 Days",
  "This Month": "This Month",
  "Last Month": "Last Month",
  "Use Per Day": "Use Per Day",
  "Maximum use per day must be more than 0": "Maximum use per day must be more than 0",
  "Only applicable to selected outlet": "Only applicable to selected outlet",
  "Applicable to all the outlets except selected outlet": "Applicable to all the outlets except selected outlet",
  "If applicable to all the outlet, leave it blank": "If applicable to all the outlet, leave it blank",
  "Only applicable to selected weight": "Only applicable to selected weight",
  "Applicable to all the weight except selected weight": "Applicable to all the weight except selected weight",
  "Weight": "Weight",
  "If applicable to all the weight, leave it blank": "If applicable to all the weight, leave it blank",
  "Add Weight": "Add Weight",
  "Only applicable to selected mode": "Only applicable to selected mode",
  "Applicable to all the modes except selected mode": "Applicable to all the modes except selected mode",
  "If applicable to all the mode, leave it blank": "If applicable to all the mode, leave it blank",
  "Add Mode": "Add Mode",
  "Laundry Pass not applicable in this outlet": "Laundry Pass not applicable in this outlet",
  "Discounted price should be more than 0": "Discounted price should be more than 0",
  "Discounted Price": "Discounted Price",
  "Logo (Optional)": "Logo (Optional)",
  "Save": "Save",
  "Cleanpro Laundry Pass": "บัตรผ่าน Cleanpro Laundry",
  "Save more with the Laundry Pass — ": "การซื้อ Laundry Pass",
  "wash and dry more clothes at a lower price while enjoying extra rewards from Cleanpro Plus!": "ไม่เพียงแต่ช่วยให้คุณซักและอบผ้าได้มากขึ้นในราคาที่ประหยัดกว่า แต่ยังสามารถรับรางวัลพิเศษจาก Cleanpro Plus เพื่อช่วยให้คุณประหยัดได้มากยิ่งขึ้น!",
  "How to Purchase Laundry Pass": "วิธีการซื้อ Laundry Pass",
  "Step 1: Register as a Cleanpro Plus user.": "ขั้นตอนที่ 1: ลงทะเบียนเป็นสมาชิก Cleanpro Plus",
  "Step 2: Choose the Laundry Pass package you wish to purchase.": "ขั้นตอนที่ 2: เลือกแพ็กเกจ Laundry Pass ที่คุณต้องการซื้อ",
  "Step 3: Make the payment through Cleanpro Plus.": "ขั้นตอนที่ 3: ชำระเงินผ่าน Cleanpro Plus",
  "Step 4: Enjoy washing and drying services at any Cleanpro outlet in Malaysia with exclusive discounted prices!": "ขั้นตอนที่ 4: เพลิดเพลินกับบริการซักและอบผ้าที่สาขา Cleanpro ทั่วมาเลเซียในราคาส่วนลดสุดพิเศษ!",
  "By purchasing and/or using the Cleanpro Laundry Pass, you agree to be bound by the following terms and conditions:": "คุณตกลงที่จะผูกพันตามข้อกำหนดและเงื่อนไขต่อไปนี้:",
  "Definitions": "คำจำกัดความ",
  '"Laundry Pass" refers to the package(s) for specific laundry services offered by Cleanpro.': '"Laundry Pass" หมายถึงแพ็คเกจสำหรับบริการซักรีดที่กำหนดโดย Cleanpro',
  '"Subscriber" refers to the individual(s) purchasing and/or using the Laundry Pass.': '"ผู้สมัคร" หมายถึงบุคคลที่ทำการซื้อและ/หรือใช้ Laundry Pass',
  "Pass Description": "คำอธิบายของ Pass",
  "The Laundry Pass is a promotional package that offers laundry services at any Cleanpro outlet in Malaysia.": "Laundry Pass เป็นแพ็คเกจโปรโมชั่นที่ให้บริการซักรีดที่จุดให้บริการ Cleanpro ทุกแห่งในมาเลเซีย",
  'The Laundry Pass is valid for both Malaysians and non-Malaysians; and is exclusively available to Cleanpro Plus members.': 'Laundry Pass ใช้ได้ทั้งสำหรับชาวมาเลเซียและชาวต่างชาติ และมีให้เฉพาะสมาชิก Cleanpro Plus เท่านั้น',
  "The campaign of Laundry Pass is valid from": "แคมเปญ Laundry Pass ใช้ได้ตั้งแต่วันที่",
  "1 March 2025 to 31 May 2025.": "1 มีนาคม 2568 ถึง 31 พฤษภาคม 2568",
  'Each Laundry Pass subscription is': 'การสมัครสมาชิก Laundry Pass การสมัครสมาชิก Laundry Pass มีอายุ',
  'valid for 30 days from the start date,': '30',
  'allowing subscribers to use the package': 'วันนับจากวันที่เริ่มต้น ซึ่งผู้สมัครสามารถใช้บริการได้สูงสุด ',
  'up to 4 times per day.': '4 ครั้งต่อวัน ',
  'During the promotional period, subscribers can repurchase the package unlimited times, but only after fully utilizing your current subscription.': 'นช่วงระยะเวลาโปรโมชั่น ผู้สมัครสามารถซื้อแพ็คเกจใหม่ได้ไม่จำกัดจำนวนครั้ง แต่จะต้องใช้บริการจากการสมัครสมาชิกปัจจุบันให้หมดก่อน',
  "The Laundry Pass is": "Laundry Pass",
  "valid only for cold wash and drying of machines under 25kg.": "ช้ได้สำหรับการซักน้ำเย็นและการอบแห้งของเครื่องที่มีน้ำหนักไม่เกิน 25 กิโลกรัม",
  "Additional charges will apply for warm and hot wash services, based on the temperature selected.": "โดยจะมีค่าใช้จ่ายเพิ่มเติมสำหรับบริการซักน้ำอุ่นและน้ำร้อน ตามอุณหภูมิที่เลือก",
  'Unused wash or dry session(s) from the Laundry Pass cannot be carried forward to the next purchase, and are non-refundable, non-exchangeable for cash, and non-transferable.': 'การใช้บริการที่ยังไม่ถูกใช้จาก Laundry Pass จะไม่สามารถนำไปใช้ในการซื้อครั้งถัดไปได้ และไม่สามารถขอเงินคืน, แลกเป็นเงินสด, หรือโอนให้บุคคลอื่นได้',
  'The Laundry Pass is valid for washing and/or drying standard laundry items only (e.g., clothing, linens), excluding large items (e.g., rugs), heavily soiled items (e.g., pet bedding), or specialty items requiring special treatment.': 'Laundry Pass ใช้ได้สำหรับการซักและ/หรืออบแห้งเฉพาะของใช้ซักรีดมาตรฐานเท่านั้น (เช่น เสื้อผ้า ผ้าปูที่นอน) ไม่รวมถึงของใหญ่ (เช่น พรม) หรือของที่สกปรกมาก (เช่น ที่นอนสัตว์เลี้ยง) หรือของพิเศษที่ต้องการการดูแลเป็นพิเศษ',
  'The Laundry Pass can be cancelled within the first 7 days of subscription for a full refund, provided the subscriber has not used the Laundry Pass during this period. No refunds or transfers will be issued after the first 7 days.': 'Laundry Pass สามารถยกเลิกได้ภายใน 7 วันแรกของการสมัคร เพื่อขอเงินคืนเต็มจำนวน หากผู้สมัครไม่ได้ใช้ Laundry Pass ในช่วงเวลาดังกล่าว การขอเงินคืนหรือการโอนจะไม่ได้รับการพิจารณาหลังจาก 7 วันแรก',
  "Refund process may take up to 21 working days.": "กระบวนการขอคืนเงินอาจใช้เวลานานสูงสุดถึง 21 วันทำการ.",
  'Subscribers are encouraged to regularly check Cleanpro Plus for reminders regarding the expiry date of their laundry pass.': 'ผู้สมัครได้รับการแนะนำให้ตรวจสอบ Cleanpro Plus อย่างสม่ำเสมอเพื่อรับการแจ้งเตือนเกี่ยวกับวันหมดอายุของ Laundry Pass',
  "This promotion is not valid in conjunction with the '10 Free 1 e-Stamp Campaign'.": "โปรโมชั่นนี้ไม่สามารถใช้ร่วมกับแคมเปญ '10 Free 1 e-Stamp Campaign' ได้",
  "Any misuse of the Laundry Pass will result in the immediate termination of the subscription without prior notice. Payments for the Laundry Pass are non-refundable, non-exchangeable for cash, and non-transferable.": "การใช้ Laundry Pass อย่างไม่ถูกต้องจะทำให้การสมัครสมาชิกถูกยกเลิกทันทีโดยไม่ต้องแจ้งให้ทราบล่วงหน้า การชำระเงินสำหรับ Laundry Pass ไม่สามารถขอเงินคืน, แลกเป็นเงินสด, หรือโอนให้บุคคลอื่นได้",
  "Payment must be made in full at the time of subscription via Cleanpro Plus.": "การชำระเงินต้องทำทั้งหมดในขณะสมัครสมาชิกผ่าน Cleanpro Plus",
  "For any questions or assistance regarding the Laundry Pass, please email Cleanpro Customer Service at enquiry@cleanpro.asia.": "สำหรับคำถามหรือความช่วยเหลือเกี่ยวกับ Laundry Pass กรุณาติดต่อบริการลูกค้าของ Cleanpro ทางอีเมล enquiry@cleanpro.asia",
  "Cleanpro reserves the right to change the terms and conditions at any time without prior notice.": "Cleanpro ขอสงวนสิทธิ์ในการเปลี่ยนแปลงข้อกำหนดและเงื่อนไขได้ตลอดเวลาโดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
  "Search": "Search",
  "Scan to register as a member": "Scan to register as a member",
  "Select Product / Key in Amount": "Select Product / Key in Amount",
  "Discount code is not available in this payment type": "Discount code is not available in this payment type",
  "This voucher is not available use in washer payment": "This voucher is not available use in washer payment",
  "This voucher is not available use in dryer payment": "This voucher is not available use in dryer payment",
  "This voucher is not available use in Drop n Go payment": "This voucher is not available use in Drop n Go payment",
  "Voucher is not available in this payment type": "Voucher is not available in this payment type",
  "Select the price for": "เลือก ราคา สำหรับ",
  "Enable Stamping": "Enable Stamping",
  "Please select your preferred outlet": "Please select your preferred outlet",
  "Select your preferred outlet": "Select your preferred outlet",
  "State": "State",
  "Select State": "Select State",
  "Payment Successful!": "Payment Successful!",
  "Thank you for purchasing Laundry Pass!": "Thank you for purchasing Laundry Pass!",
  "Your Laundry Pass expired on": "Your Laundry Pass expired on",
  "You have used all your Laundry Pass": "You have used all your Laundry Pass",
  "Purchase Again": "Purchase Again",
  "Save Big!": "Save Big!",
  "You've saved": "You've saved",
  "on your package!": "on your package!",
  "Please select distributor, operator or outlet": "Please select distributor, operator or outlet",
  "Please enter your mobile phone number or e-mail": "กรุณากรอกหมายเลขโทรศัพท์มือถือหรืออีเมลของคุณ",
  "We’ll send you an SMS when your laundry’s ready": "เราจะส่ง SMS ให้คุณเมื่อผ้าของคุณพร้อมแล้ว",
  "Skip": "Skip",
  "Notice": "Notice",
  "User exists but not verified. Please verify your account by scanning the QR Code at Thank You Page.": "User exists but not verified. Please verify your account by scanning the QR Code at Thank You Page.",
  "User registered successfully. Please complete verification by scanning the QR Code at Thank You Page.": "User registered successfully. Please complete verification by scanning the QR Code at Thank You Page.",
  "Please enter email address to register": "Please enter email address to register",
  "Please enter phone number to register": "Please enter phone number to register",
  "Camera permission is denied": "Camera permission is denied",
  "No camera device found": "No camera device found",
  "Camera is already in use by another app": "Camera is already in use by another app",
  "Preferred Outlet": "Preferred Outlet",
  "Purchase Now": "รีบซื้อ",
  "Cancel Date": "Cancel Date",
  "Cancel Laundry Pass": "Cancel Laundry Pass",
  "Download or takes a screenshot of the QR code.": "ดาวน์โหลดหรือถ่ายภาพหน้าจอของคิวอาร์โค้ด",
  "Launch and login banking app.": "เปิดและเข้าสู่ระบบแอปธนาคาร",
  "Choose QR code from your gallery.": "เลือกคิวอาร์โค้ดจากแกลเลอรีของคุณ",
  "1 March 2025 - 30 April 2025": "1 มีนาคม 2025 - 30 เมษายน 2025",
  "Payment Method to get point": "Payment Method to get point",
  "Payment Method to get voucher": "Payment Method to get voucher",
  "If applicable to all the payment method, leave it blank": "If applicable to all the payment method, leave it blank",
  "Add {{ currency }} {{ amount }} for {{ mode }} Wash": "Add {{ currency }} {{ amount }} for {{ mode }} Wash",
  "Add {{ currency }} {{ amount }} for an extra {{ runtime }} minutes!": "Add {{ currency }} {{ amount }} for an extra {{ runtime }} minutes!",
  "via": "ผ่านทาง",
  "Cash": "เงินสด",
  "Are you sure you have collected your laundry?": "Are you sure you have collected your laundry?",
  "Collected All": "Collected All",
  "Collected": "Collected",
  "Are you sure the customer have collected the laundry?": "Are you sure the customer have collected the laundry?",
  "Pending Payment (Cash)": "Pending Payment (Cash)",
  "You have received the cash payment": "You have received the cash payment",
  "Print Receipt": "Print Receipt",
  "Are you sure you want to print receipt?": "Are you sure you want to print receipt?",
  "Are you sure you want to print sticker?": "Are you sure you want to print sticker?",
  "Copy": "สำเนา",
  "low": "low",
  "medium": "medium",
  "high": "high",
  "About Us": "About Us",
  "ABOUT US": "ABOUT US",
  "Only can request einvoice for Malaysia Outlet": "Only can request einvoice for Malaysia Outlet",
  "E-Invoice requested successfully": "E-Invoice requested successfully",
  "Select machine": "Select machine",
  "Select transaction date": "Select transaction date",
  "Transaction Time": "Transaction Time",
  "Select transaction time": "Select transaction time",
  "Transaction Amount": "Transaction Amount",
  "Enter Transaction Amount, Example: 1.50": "Enter Transaction Amount, Example: 1.50",
  "Select payment method": "Select payment method",
  "Cashless (e-Wallet / DuitNow QR)": "Cashless (e-Wallet / DuitNow QR)",
  "Paywave (Tap with Debit/Credit Card)": "Paywave (Tap with Debit/Credit Card)",
  "Request as": "Request as",
  "Individual": "Individual",
  "Company": "Company",
  "ID Type": "ID Type",
  "Select ID Type": "Select ID Type",
  "Company Name": "Company Name",
  "Phone": "Phone",
  "Address": "Address",
  "City": "City",
  "Postcode": "Postcode",
  "Request E-Invoice": "Request E-Invoice",
  "Request e-Invoice": "Request e-Invoice",
  "e-Invoice Validation Link": "e-Invoice Validation Link",
  "Credit Card": "Credit Card",
  "Credit Card Number": "Credit Card Number",
  "Credit Card Expiry Month": "Credit Card Expiry Month",
  "Credit Card Expiry Year": "Credit Card Expiry Year",
  "Credit Card Securtiy Code": "Credit Card Securtiy Code",
  "Credit Card Holder Name": "Credit Card Holder Name",
  "Settlement Amount": "Settlement Amount",
  "Paid": "Paid",
  "Enable E-Wallet Payment?": "เปิดใช้งานการชำระเงิน e-Wallet หรือไม่?",
  "Enable DuitNow Payment?": "เปิดใช้งานการชำระเงิน DuitNow หรือไม่?",
  "Enable Credit Card Terminal Payment?": "เปิดใช้งานการชำระเงินด้วยเครื่องรูดบัตรเครดิตหรือไม่?",
  "Transaction date is more than 3 days": "Transaction date is more than 3 days",
  "Select Recurrence Type": "เลือกประเภทการเกิดซ้ำ",
  "Multiple Voucher": "คูปองหลายใบ",
  "Period for giving next voucher (days)": "ระยะเวลาในการให้คูปองถัดไป (วัน)",
  "General Voucher Code Report": "รายงานรหัสคูปองทั่วไป",
  "Unique Voucher Code Report": "รายงานรหัสคูปองเฉพาะ",
  "Select Code": "เลือกรหัส",
  "Minimum transaction amount to use code cannot be negative": "จำนวนเงินขั้นต่ำในการใช้รหัสไม่สามารถเป็นลบได้",
  "Redeem per user must at least 1": "การแลกต่อผู้ใช้ต้องอย่างน้อย 1",
  "Start date must before end date": "วันที่เริ่มต้นต้องมาก่อนวันที่สิ้นสุด",
  "Please select the start date and end date": "กรุณาเลือกวันที่เริ่มต้นและวันที่สิ้นสุด",
  "Please enter the voucher code": "กรุณาป้อนรหัสคูปอง",
  "Successfully create the voucher code": "สร้างรหัสคูปองสำเร็จแล้ว",
  "General Voucher Code": "รหัสคูปองทั่วไป",
  "Unique Voucher Code": "รหัสคูปองเฉพาะ",
  "Add Voucher Code": "เพิ่มรหัสคูปอง",
  "How many times the voucher code can be used for each user": "รหัสคูปองสามารถใช้ได้กี่ครั้งสำหรับผู้ใช้แต่ละคน",
  "Update Version": "อัปเดตเวอร์ชัน",
  "User profile updated successfully": "อัปเดตโปรไฟล์ผู้ใช้สำเร็จแล้ว",
  "Salutation": "คำนำหน้า",
  "Nationality": "สัญชาติ",
  "Race": "เชื้อชาติ",
  "Gender": "เพศ",
  "Update salutation": "อัปเดตคำนำหน้า",
  "Update ID Type": "อัปเดตประเภทบัตรประชาชน",
  "Update Address": "อัปเดตที่อยู่",
  "Update nationality": "อัปเดตสัญชาติ",
  "Male": "ชาย",
  "Female": "หญิง",
  "Update gender": "อัปเดตเพศ",
  "Number of Point cannot be 0": "จำนวนคะแนนไม่สามารถเป็น 0 ได้",
  "Token value cannot be 0": "ค่าโทเค็นไม่สามารถเป็น 0 ได้",
  "Activate": "เปิดใช้งาน",
  "Deactivate": "ปิดใช้งาน",
  "Activate User": "เปิดใช้งานผู้ใช้",
  "Deactivate User": "ปิดใช้งานผู้ใช้",
  "Are you sure you want to activate the user account?": "คุณแน่ใจหรือไม่ว่าต้องการเปิดใช้งานบัญชีผู้ใช้?",
  "Are you sure you want to deactivate the user account?": "คุณแน่ใจหรือไม่ว่าต้องการปิดใช้งานบัญชีผู้ใช้?",
  "Your point redemption is successful": "การแลกแต้มของคุณสำเร็จแล้ว",
  "Point Redemption": "การแลกแต้ม",
  "This redemption has already been completed": "การแลกแต้มนี้เสร็จสิ้นแล้ว",
  "Transaction Details": "รายละเอียดการทำรายการ",
  "Please login to redeem point": "กรุณาเข้าสู่ระบบเพื่อแลกแต้ม",
  "Login as {{name}}": "เข้าสู่ระบบในนาม {{name}}",
  "Payment Amount Settings": "การตั้งค่าจำนวนเงินชำระเงิน",
  "Allow washer pay less than cheapest mode price?": "อนุญาตให้เครื่องซักผ้าจ่ายน้อยกว่าราคาต่ำสุดได้หรือไม่?",
  "Allow dryer pay less than minimum price?": "อนุญาตให้เครื่องอบผ้าจ่ายน้อยกว่าราคาขั้นต่ำได้หรือไม่?",
  "Drop n Go Settings": "การตั้งค่า Drop n Go",
  "Allow user pay for specific service only?": "อนุญาตให้ผู้ใช้ชำระเงินสำหรับบริการเฉพาะเท่านั้นหรือไม่?",
  "Display pricing for each service?": "แสดงราคาสำหรับแต่ละบริการหรือไม่?",
  "Delete Voucher": "ลบบัตรกำนัล",
  "Are you sure you want to delete this voucher?": "คุณแน่ใจหรือว่าต้องการลบบัตรกำนัลนี้?",
  "Display in Promotion Page": "แสดงในหน้าโปรโมชั่น",
  "Add Promotion": "เพิ่มโปรโมชั่น",
  "Select Transaction Status": "เลือกสถานะการทำรายการ",
  "Give Stamp for Drop n Go Transaction?": "ให้แสตมป์สำหรับธุรกรรม Drop n Go หรือไม่?",
  "Display machine capacity?": "แสดงความจุของเครื่องหรือไม่?",
  "External Voucher Code": "รหัสคูปองภายนอก",
  "Import Voucher Code": "นำเข้ารหัสคูปอง",
  "Voucher Code Stamp Settings": "การตั้งค่าแสตมป์รหัสคูปอง",
  "Upload Date": "วันที่อัปโหลด",
  "Import External Voucher Code": "นำเข้ารหัสคูปองภายนอก",
  "Import": "นำเข้า",
  "Please select a valid CSV file": "กรุณาเลือกไฟล์ CSV ที่ถูกต้อง",
  "Redeemed": "แลกแล้ว",
  "Sales": "ยอดขาย",
  "Drop N Go Dashboard": "แดชบอร์ด Drop N Go",
  "Total Drop N Go Sales by Month": "ยอดขาย Drop N Go รวมรายเดือน",
  "Total Drop N Go Sales by Day": "ยอดขาย Drop N Go รวมรายวัน",
}

const translationPt = {
  "LOGIN": "ENTRAR",
  "REGISTER": "CADASTRAR",
  "SKIP TO PAYMENT": "IR PARA PAGAMENTO",
  "Continue as guest": "Continuar como convidado",
  "WELCOME": "BEM-VINDO",
  "Error": "Erro",
  "Please enter the correct phone number format. <br /><br /> <small>Example: 0129465628</small>": "Por favor, insira o formato correto do número de telefone. <br /><br /> <small>Exemplo: 0129465628</small>",
  "Info": "Informação",
  "Please scan QRCode to Login": "Por favor, escaneie o QRCode para Entrar",
  "Forgot Password": "Esqueceu a Senha",
  "Seems like you have forgotten your password<br />Create a temporary password?": "Parece que você esqueceu sua senha<br />Criar uma senha temporária?",
  "Cancel": "Cancelar",
  "Confirm": "Confirmar",
  "Reset Your Password": "Redefinir Sua Senha",
  "Enter Your Phone Number / Email Address": "Digite Seu Número de Telefone / Endereço de Email",
  "Enter Your Email Address": "Digite Seu Endereço de Email",
  "Please enter phone number / email address": "Por favor, digite o número de telefone / endereço de email",
  "Please enter email address": "Por favor, digite o endereço de email",
  "Submit": "Enviar",
  "Please enter a valid phone number": "Por favor, digite um número de telefone válido",
  "Please enter a valid email address": "Por favor, digite um endereço de email válido",
  "Success!": "Sucesso!",
  "You may login using your one time password now.": "Agora você pode entrar usando sua senha de uso único.",
  "Phone Number": "Número de Telefone",
  "Password": "Senha",
  "Don't have an account?": "Não tem uma conta?",
  "Forgot password?": "Esqueceu a senha?",
  "Unable to register without a QRCode": "Não é possível cadastrar sem um QRCode",
  "Please read and agree to the privacy policies, terms and conditions": "Por favor, leia e concorde com as políticas de privacidade, termos e condições",
  "Password length must be at least 6 characters": "A senha deve ter pelo menos 6 caracteres",
  "Please enter the confirmation code that was sent to your phone": "Por favor, digite o código de confirmação que foi enviado para seu telefone",
  "Example: 012xxxxxxx": "Exemplo: 012xxxxxxx",
  "Example: 09xxxxxxxx": "Exemplo: 09xxxxxxxx",
  "Verification Method": "Método de Verificação",
  "Name": "Nome",
  "Email": "Email",
  "optional": "opcional",
  "Birth Year": "Ano de Nascimento",
  "Year": "Ano",
  "Birth Month": "Mês de Nascimento",
  "Month": "Mês",
  "Jan": "Jan",
  "Feb": "Fev",
  "Mar": "Mar",
  "April": "Abril",
  "May": "Maio",
  "June": "Junho",
  "July": "Julho",
  "Aug": "Ago",
  "Sept": "Set",
  "Oct": "Out",
  "Nov": "Nov",
  "Dec": "Dez",
  "Birth Day": "Dia de Nascimento",
  "Day": "Dia",
  "OTP": "OTP",
  "OTP Confirmation": "Confirmação de OTP",
  "I agree to the": "Eu concordo com a",
  "Privacy Policy": "Política de Privacidade",
  "PRIVACY POLICY": "POLÍTICA DE PRIVACIDADE",
  "and": "e",
  "Terms": "Termos",
  "Conditions": "Condições",
  "SEND CODE": "ENVIAR CÓDIGO",
  "Our One-Time Password (OTP) emails might end up in your spam or junk folder. We kindly ask you to take a moment to check your spam mailbox.": "Nossos emails de Senha de Uso Único (OTP) podem acabar na sua pasta de spam ou lixo. Pedimos gentilmente que você verifique sua caixa de spam.",
  "Already have an account? Login": "Já tem uma conta? Entrar",
  "Didn't receive a code?": "Não recebeu um código?",
  "Resend Code": "Reenviar Código",
  "collected": "coletado",
  "Collect": "Coletar",
  "stamps": "selos",
  "get 1 voucher": "ganhe 1 voucher",
  "Minimum": "Mínimo",
  "spending to collect each washer stamp": "gasto para coletar cada selo de lavadora",
  "spending to collect each dryer stamp": "gasto para coletar cada selo de secadora",
  "spending to collect each stamp": "gasto para coletar cada selo",
  "Device don't have a camera": "O dispositivo não tem câmera",
  "This is not a valid QRCode": "Este não é um QRCode válido",
  "Select Camera": "Selecionar Câmera",
  "Switch": "Alternar",
  "Camera": "Câmera",
  "Loading": "Carregando",
  "Scan the QR code on the machine.": "Escaneie o código QR na máquina.",
  "Switch Camera": "Alternar Câmera",
  "Off torch light": "Desligar lanterna",
  "On torch light": "Ligar lanterna",
  "switch camera if your camera is not clear": "alternar câmera se sua câmera não estiver clara",
  "Switch your camera if the display is not clear": "Alterne sua câmera se a exibição não estiver clara",
  "Please allow this webapp to access your camera": "Por favor, permita que este aplicativo acesse sua câmera",
  "DISCOUNT": "DESCONTO",
  "Congratulation": "Parabéns",
  "Expired Date": "Data de Validade",
  "Voucher": "Voucher",
  "Vouchers": "Vouchers",
  "Something went wrong": "Algo deu errado",
  "Stamping Collection": "Coleção de Selos",
  "Total e-Token": "Total de e-Tokens",
  "Total Wash": "Total de Lavagens",
  "Total Dry": "Total de Secagens",
  "Reload": "Recarregar",
  "Washer": "Lavadora",
  "Dryer": "Secadora",
  "Congratulations!": "Parabéns!",
  "You have completed your Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "Você completou sua coleção de Selos.<br />Concedido um voucher e a coleção de selos foi reiniciada",
  "You have completed Washer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "Você completou a coleção de Selos de Lavadora.<br />Concedido um voucher e a coleção de selos foi reiniciada",
  "You have completed Dryer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "Você completou a coleção de Selos de Secadora.<br />Concedido um voucher e a coleção de selos foi reiniciada",
  "Latest News": "Últimas Notícias",
  "Transaction History": "Histórico de Transações",
  "Stamping": "Carimbando",
  "Transaction": "Transação",
  "News": "Notícias",
  "Confirmation": "Confirmação",
  "Logout Session?": "Encerrar Sessão?",
  "NO": "NÃO",
  "OK": "OK",
  "Account": "Conta",
  "FAQs": "Perguntas Frequentes",
  "Feedback": "Feedback",
  "LOGOUT": "SAIR",
  "Logout": "Sair",
  "Are you sure you want to submit your feedback?": "Tem certeza de que deseja enviar seu feedback?",
  "No": "Não",
  "Yes": "Sim",
  "Success": "Sucesso",
  "Failed": "Falha",
  "Pending": "Pendente",
  "Your feedback is submitted successfully": "Seu feedback foi enviado com sucesso",
  "Please fill in all the required fields before submit.": "Por favor, preencha todos os campos obrigatórios antes de enviar.",
  "Give us your feedback!": "Dê-nos o seu feedback!",
  "Type your name here (optional)": "Digite seu nome aqui (opcional)",
  "required": "obrigatório",
  "Type your number here": "Digite seu número aqui",
  "Outlet": "Loja",
  "Select an outlet": "Selecione uma loja",
  "Outlet Cleanliness": "Limpeza da Loja",
  "Washer Machine Performance": "Desempenho da Máquina de Lavar",
  "Dryer Machine Performance": "Desempenho da Máquina de Secar",
  "Customer Service": "Atendimento ao Cliente",
  "Comment": "Comentário",
  "Type your comment here (optional)": "Digite seu comentário aqui (opcional)",
  "SUBMIT": "ENVIAR",
  "Join as a member now!": "Torne-se um membro agora!",
  "Join as a loyalty member now to get more benefits such as vouchers and free machine usage!<br /><br /><strong>Register as loyalty member?</strong>": "Torne-se um membro de fidelidade agora para obter mais benefícios como vouchers e uso gratuito de máquinas!<br /><br /><strong>Cadastrar-se como membro de fidelidade?</strong>",
  "Maybe Next Time": "Talvez na Próxima",
  "Yes, Register Now": "Sim, Cadastrar Agora",
  "Washer Payment": "Pagamento de Lavadora",
  "Dryer Payment": "Pagamento de Secadora",
  "Vending Machine Payment": "Pagamento de Máquina de Venda",
  "Online": "Online",
  "Offline": "Offline",
  "Running": "Em Funcionamento",
  "Vacant": "Vaga",
  "Vending Machine": "Máquina de Venda",
  "Discount": "Desconto",
  "No Vouchers Available": "Nenhum Voucher Disponível",
  "Payment Method": "Método de Pagamento",
  "Would you like to pay with?": "Gostaria de pagar com?",
  "e-Token": "e-Token",
  "E-TOKEN": "E-TOKEN",
  "E-Wallet": "Carteira Eletrônica",
  "E-Wallet & Online Banking": "Carteira Eletrônica & Banco Online",
  "Duitnow QR code": "Código QR Duitnow",
  "PromptPay QR Code": "Código QR PromptPay",
  "The Duitnow QR code will be downloaded and you need to open your banking app to make the payment. Pay {{ currency }}{{ totalPaymentAmount }} to {{ machineName }}?": "O código QR Duitnow será baixado e você precisará abrir seu aplicativo bancário para fazer o pagamento. Pagar {{ currency }}{{ totalPaymentAmount }} para {{ machineName }}?",
  "Pay": "Pagar",
  "to": "para",
  "You may under utilized the voucher.": "Você pode subutilizar o voucher.",
  "Proceed to pay": "Prosseguir para pagamento",
  "Processing ...": "Processando ...",
  "You can't pay with e-token if voucher is in used, please remove your voucher to pay with e-token.": "Você não pode pagar com e-token se o voucher estiver em uso, por favor, remova seu voucher para pagar com e-token.",
  "Insufficient e-Tokens": "e-Tokens Insuficientes",
  "Reload your e-token now?": "Recarregar seu e-token agora?",
  "Reload now!": "Recarregar agora!",
  "You have": "Você tem",
  "e-Tokens": "e-Tokens",
  "Tokens to": "Tokens para",
  "This machine is currently offline, please try again later.": "Esta máquina está atualmente offline, por favor, tente novamente mais tarde.",
  "MACHINE": "MÁQUINA",
  "Machine": "Máquina",
  "TYPE": "TIPO",
  "CAPACITY": "CAPACIDADE",
  "DURATION": "DURAÇÃO",
  "Select Duration": "Selecionar Duração",
  "AMOUNT TO PAY": "VALOR A PAGAR",
  "PRICE": "PREÇO",
  "VOUCHER": "VOUCHER",
  "Select Voucher >": "Selecionar Voucher >",
  "TOTAL": "TOTAL",
  "PAY": "PAGAR",
  "Remove Voucher": "Remover Voucher",
  "Select Your Voucher": "Selecione Seu Voucher",
  "min": "min",
  "MIN": "MIN",
  "Select Payment Amount": "Selecionar Valor de Pagamento",
  "Select Water Temperature": "Selecionar Temperatura da Água",
  "Select temperature": "Selecionar temperatura",
  "Select Temperature": "Selecionar temperatura",
  "Cold": "Fria",
  "Warm": "Morna",
  "Hot": "Quente",
  "e-Tokens to": "e-Tokens para",
  "No Purchase History": "Sem Histórico de Compras",
  "e-tokens": "e-tokens",
  "No Promotions": "Sem Promoções",
  "New Password": "Nova Senha",
  "Back": "Voltar",
  "Buy this package?": "Comprar este pacote?",
  "Purchase": "Comprar",
  "e-Tokens for": "e-Tokens por",
  "Reload Tokens": "Recarregar Tokens",
  "Are you sure you want to purchase {{ tokenAmount }} e-Token for {{ currency }}{{ paymentAmount }}?": "Tem certeza de que deseja comprar {{ tokenAmount }} e-Token por {{ currency }}{{ paymentAmount }}?",
  "Current e-Token": "e-Token Atual",
  "Current point": "Pontos atuais",
  "History": "Histórico",
  "Your profile picture has been updated!": "Sua foto de perfil foi atualizada!",
  "Please only use png, jpg or jpeg file extension type": "Por favor, use apenas arquivos com extensão png, jpg ou jpeg",
  "Please only use image type file": "Por favor, use apenas arquivos do tipo imagem",
  "User name has updated successfully!": "Nome de usuário atualizado com sucesso!",
  "Email Address updated successfully": "Endereço de email atualizado com sucesso",
  "Phone number updated successfully": "Número de telefone atualizado com sucesso",
  "Password must be at least 6 characters": "A senha deve ter pelo menos 6 caracteres",
  "Password updated successfully": "Senha atualizada com sucesso",
  "User Settings": "Configurações do Usuário",
  "Profile Picture": "Foto de Perfil",
  "Change Password": "Alterar Senha",
  "Do you want to submit your feedback?": "Deseja enviar seu feedback?",
  "Thank You!": "Obrigado!",
  "Thank you for using our services.": "Obrigado por usar nossos serviços.",
  "BACK TO HOMEPAGE": "VOLTAR À PÁGINA INICIAL",
  "How to pay?": "Como pagar?",
  "Step 1": "Passo 1",
  "After scan the QR code on the machine, select either register new account, login your account or skip to payment.": "Após escanear o código QR na máquina, selecione entre cadastrar nova conta, entrar na sua conta ou ir direto para o pagamento.",
  "Step 2-1": "Passo 2-1",
  "For Dryer – Select your desired duration. Different duration will have different prices.": "Para Secadora – Selecione a duração desejada. Durações diferentes terão preços diferentes.",
  "Step 2-2": "Passo 2-2",
  "For Washer – Select your desired water temperature. Different water temperature will have different prices.": "Para Lavadora – Selecione a temperatura da água desejada. Temperaturas diferentes terão preços diferentes.",
  "Step 3": "Passo 3",
  "For login user, Click on 'Select Voucher' to select your voucher.": "Para usuários logados, Clique em 'Selecionar Voucher' para escolher seu voucher.",
  "Step 4": "Passo 4",
  "Click on 'PAY' button to pay. For login user, select your payment method to pay.": "Clique no botão 'PAGAR' para pagar. Para usuários logados, selecione seu método de pagamento.",
  "Step 5": "Passo 5",
  "After confirm the price and machine details, click on 'OK' button to pay.": "Após confirmar o preço e os detalhes da máquina, clique no botão 'OK' para pagar.",
  "How to reload your e-Token?": "Como recarregar seu e-Token?",
  'Click on the "Reload" button.': 'Clique no botão "Recarregar".',
  "Select the package that you wish to purchase.": "Selecione o pacote que deseja comprar.",
  'Click on "Purchase" as confirmation before payment page.': 'Clique em "Comprar" como confirmação antes da página de pagamento.',
  "Is e-token can be refund/transfer back to e-wallet?": "O e-token pode ser reembolsado/transferido de volta para a carteira eletrônica?",
  "Why can't I applied my voucher?": "Por que não consigo aplicar meu voucher?",
  "When there is a Happy Hour Promotion is on going, you are unable to apply your voucher temporarily.": "Quando há uma Promoção de Happy Hour em andamento, você não pode aplicar seu voucher temporariamente.",
  "How to apply my voucher?": "Como aplicar meu voucher?",
  'Click on the "Select Voucher" button.': 'Clique no botão "Selecionar Voucher".',
  "Select the voucher that you wish to apply.": "Selecione o voucher que deseja aplicar.",
  'Click on "Pay" once you have verified the voucher is successfully applied.': 'Clique em "Pagar" depois de verificar que o voucher foi aplicado com sucesso.',
  "Step 2": "Passo 2",
  "Language has updated successfully!": "Idioma atualizado com sucesso!",
  "Change Language": "Alterar Idioma",
  "Language": "Idioma",
  "Select language": "Selecionar idioma",
  "Referral Code": "Código de Indicação",
  "Copied!": "Copiado!",
  "Inviting friends to get more benefits!": "Convide amigos para obter mais benefícios!",
  "Would you like to share your referral code to your friends & family?": "Gostaria de compartilhar seu código de indicação com amigos e familiares?",
  "Refer a friend and get": "Indique um amigo e ganhe",
  "Share the love to your friends & family?": "Compartilhar o amor com seus amigos e familiares?",
  "voucher": "voucher",
  "token": "token",
  "stamp": "selo",
  "washer stamp": "selo de lavadora",
  "dryer stamp": "selo de secadora",
  "Learn More": "Saiba Mais",
  "Welcome Gift": "Presente de Boas-vindas",
  "Share Your Referral Code Now": "Compartilhe Seu Código de Indicação Agora",
  "Birthday Gift for You": "Presente de Aniversário para Você",
  "Let's Pay with E-Token": "Vamos Pagar com E-Token",
  "Collect 10 Stamps and Get Voucher": "Colete 10 Selos e Ganhe um Voucher",
  "The voucher will be given if you registered your account successfully.": "O voucher será concedido se você cadastrar sua conta com sucesso.",
  "There is no expiration date for this voucher.": "Não há data de validade para este voucher.",
  "The voucher can be used for dryer machine only.": "O voucher pode ser usado apenas para máquinas de secar.",
  "The voucher can be used for washer machine only.": "O voucher pode ser usado apenas para máquinas de lavar.",
  "The voucher can be used for Drop n Go transaction only.": "O voucher pode ser usado apenas para transações Drop n Go.",
  "The voucher can be used for vending transaction only.": "O voucher só pode ser usado para transação em máquina de venda automática.",
  "The voucher can be used for detergent vending transaction only.": "O voucher só pode ser usado para transação em máquina de venda de detergente.",
  "The voucher can be used for car wash transaction only.": "O voucher só pode ser usado para transação de lavagem de carro.",
  "The voucher can be used for washer machine or Drop n Go transaction.": "O voucher pode ser usado para máquinas de lavar ou transações Drop n Go.",
  "The voucher can be used for dryer machine or Drop n Go transaction.": "O voucher pode ser usado para máquinas de secar ou transações Drop n Go.",
  "The voucher can be used for dryer or washer machine.": "O voucher pode ser usado para máquinas de secar ou de lavar.",
  "The voucher can be used for washer machine, dryer machine or Drop n Go transaction.": "O voucher pode ser usado para máquinas de lavar, máquinas de secar ou transações Drop n Go.",
  "The voucher can be used for washer machine or vending machine transaction.": "O voucher pode ser usado para máquina de lavar ou máquina de venda automática.",
  "The voucher can be used for washer machine or detergent vending machine transaction.": "O voucher pode ser usado para máquina de lavar ou máquina de venda de detergente.",
  "The voucher can be used for washer machine or car wash transaction.": "O voucher pode ser usado para máquina de lavar ou lavagem de carro.",
  "The voucher can be used for dryer machine or vending machine transaction.": "O voucher pode ser usado para máquina de secar ou máquina de venda automática.",
  "The voucher can be used for dryer machine or detergent vending machine transaction.": "O voucher pode ser usado para máquina de secar ou máquina de venda de detergente.",
  "The voucher can be used for dryer machine or car wash transaction.": "O voucher pode ser usado para máquina de secar ou lavagem de carro.",
  "The voucher can be used for vending machine or Drop n Go transaction.": "O voucher pode ser usado para máquina de venda automática ou Drop n Go.",
  "The voucher can be used for detergent vending machine or Drop n Go transaction.": "O voucher pode ser usado para máquina de venda de detergente ou Drop n Go.",
  "The voucher can be used for car wash or Drop n Go transaction.": "O voucher pode ser usado para lavagem de carro ou Drop n Go.",
  "The voucher can be used for vending machine or detergent vending machine transaction.": "O voucher pode ser usado para máquina de venda automática ou máquina de venda de detergente.",
  "The voucher can be used for vending machine or car wash transaction.": "O voucher pode ser usado para máquina de venda automática ou lavagem de carro.",
  "The voucher can be used for detergent vending machine or car wash transaction.": "O voucher pode ser usado para máquina de venda de detergente ou lavagem de carro.",
  "The voucher can be used for washer machine, dryer machine or vending machine transaction.": "O voucher pode ser usado para máquina de lavar, máquina de secar ou máquina de venda automática.",
  "The voucher can be used for washer machine, dryer machine or detergent vending machine transaction.": "O voucher pode ser usado para máquina de lavar, máquina de secar ou máquina de venda de detergente.",
  "The voucher can be used for washer machine, dryer machine or car wash transaction.": "O voucher pode ser usado para máquina de lavar, máquina de secar ou lavagem de carro.",
  "The voucher can be used for washer machine, vending machine or Drop n Go transaction.": "O voucher pode ser usado para máquina de lavar, máquina de venda automática ou Drop n Go.",
  "The voucher can be used for washer machine, detergent vending machine or Drop n Go transaction.": "O voucher pode ser usado para máquina de lavar, máquina de venda de detergente ou Drop n Go.",
  "The voucher can be used for washer machine, car wash or Drop n Go transaction.": "O voucher pode ser usado para máquina de lavar, lavagem de carro ou Drop n Go.",
  "The voucher can be used for washer machine, vending machine or detergent vending transaction.": "O voucher pode ser usado para máquina de lavar, máquina de venda automática ou máquina de venda de detergente.",
  "The voucher can be used for washer machine, vending machine or car wash transaction.": "O voucher pode ser usado para máquina de lavar, máquina de venda automática ou lavagem de carro.",
  "The voucher can be used for washer machine, detergent vending machine or car wash transaction.": "O voucher pode ser usado para máquina de lavar, máquina de venda de detergente ou lavagem de carro.",
  "The voucher can be used for dryer machine, vending machine or Drop n Go transaction.": "O voucher pode ser usado para máquina de secar, máquina de venda automática ou Drop n Go.",
  "The voucher can be used for dryer machine, detergent vending machine or Drop n Go transaction.": "O voucher pode ser usado para máquina de secar, máquina de venda de detergente ou Drop n Go.",
  "The voucher can be used for dryer machine, car wash or Drop n Go transaction.": "O voucher pode ser usado para máquina de secar, lavagem de carro ou Drop n Go.",
  "The voucher can be used for dryer machine, vending machine or detergent vending machine transaction.": "O voucher pode ser usado para máquina de secar, máquina de venda automática ou máquina de venda de detergente.",
  "The voucher can be used for dryer machine, vending machine or car wash transaction.": "O voucher pode ser usado para máquina de secar, máquina de venda automática ou lavagem de carro.",
  "The voucher can be used for dryer machine, detergent vending machine or car wash transaction.": "O voucher pode ser usado para máquina de secar, máquina de venda de detergente ou lavagem de carro.",
  "The voucher can be used for vending machine, detergent vending machine or Drop n Go transaction.": "O voucher pode ser usado para máquina de venda automática, máquina de venda de detergente ou Drop n Go.",
  "The voucher can be used for vending machine, car wash or Drop n Go transaction.": "O voucher pode ser usado para máquina de venda automática, lavagem de carro ou Drop n Go.",
  "The voucher can be used for detergent vending machine, car wash or Drop n Go transaction.": "O voucher pode ser usado para máquina de venda de detergente, lavagem de carro ou Drop n Go.",
  "The voucher can be used for vending machine, detergent vending machine or car wash transaction.": "O voucher pode ser usado para máquina de venda automática, máquina de venda de detergente ou lavagem de carro.",
  "The voucher can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "O voucher pode ser usado para máquina de lavar, máquina de secar, máquina de venda automática ou Drop n Go.",
  "The voucher can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction.": "O voucher pode ser usado para máquina de lavar, máquina de secar, máquina de venda automática ou máquina de venda de detergente.",
  "The voucher can be used for washer machine, dryer machine, vending machine or car wash transaction.": "O voucher pode ser usado para máquina de lavar, máquina de secar, máquina de venda automática ou lavagem de carro.",
  "The voucher can be used for washer machine, dryer machine, detergent vending machine or car wash transaction.": "O voucher pode ser usado para máquina de lavar, máquina de secar, máquina de venda de detergente ou lavagem de carro.",
  "The voucher can be used for washer machine, vending macihne, detergent vending machine, car wash or Drop n Go transaction.": "O voucher pode ser usado para máquina de lavar, máquina de venda automática, máquina de venda de detergente, lavagem de carro ou Drop n Go.",
  "The voucher can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "O voucher pode ser usado para máquina de secar, máquina de venda automática, máquina de venda de detergente, lavagem de carro ou Drop n Go.",
  "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "O voucher pode ser usado para máquina de lavar, máquina de secar, máquina de venda automática, máquina de venda de detergente, lavagem de carro ou Drop n Go.",
  "When you applied the voucher during payment, it will give you": "Quando você aplicar o voucher durante o pagamento, ele lhe dará",
  "discount.": "de desconto.",
  "When promotion is on going, the voucher is not applicable.": "Quando uma promoção está em andamento, o voucher não é aplicável.",
  "The voucher cannot be used if your payment method is E-Token.": "O voucher não pode ser usado se seu método de pagamento for E-Token.",
  "Your referral code can be found in user settings page.": "Seu código de indicação pode ser encontrado na página de configurações do usuário.",
  "You can get": "Você pode ganhar",
  "stamp for the reward.": "selo para a recompensa.",
  "e-token for the reward.": "e-token para a recompensa.",
  "e-token based on transaction payment amount for the reward.": "e-token baseado no valor do pagamento da transação para a recompensa.",
  "for the reward.": "para a recompensa.",
  "based on transaction payment amount for the reward.": "baseado no valor do pagamento da transação para a recompensa.",
  "You can get a voucher for the reward": "Você pode ganhar um voucher como recompensa",
  "which have": "que tem",
  "it can be used for dryer machine only.": "pode ser usado apenas para máquinas de secar.",
  "it can be used for washer machine only.": "pode ser usado apenas para máquinas de lavar.",
  "it can be used for Drop n Go transaction only.": "pode ser usado apenas para transações Drop n Go.",
  "it can be used for vending machine only.": "Só pode ser usado para máquina de venda automática.",
  "it can be used for car wash transaction only.": "Só pode ser usado para lavagem de carro.",
  "it can be used for detergent vending machine only.": "Só pode ser usado para máquina de venda de detergente.",
  "it can be used for dryer or washer machine.": "pode ser usado para máquinas de secar ou de lavar.",
  "it can be used for dryer machine or Drop n Go transaction.": "pode ser usado para máquinas de secar ou transações Drop n Go.",
  "it can be used for washer machine or Drop n Go transaction.": "pode ser usado para máquinas de lavar ou transações Drop n Go.",
  "it can be used for washer machine, dryer machine or Drop n Go transaction.": "pode ser usado para máquinas de lavar, máquinas de secar ou transações Drop n Go.",
  "it can be used for washer machine, dryer machine or vending machine transaction.": "Pode ser usado para máquina de lavar, máquina de secar ou máquina de venda automática.",
  "it can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "Pode ser usado para máquina de lavar, máquina de secar, máquina de venda automática ou Drop n Go.",
  "washer stamp for the reward.": "selo de lavadora para a recompensa.",
  "dryer stamp for the reward.": "selo de secadora para a recompensa.",
  "washer stamp and": "selo de lavadora e",
  "cleanproBirthdayShortDesc_one": "Resgate um voucher de aniversário de {{ birthdayVoucherAmount }} crédito no seu dia especial com o Cleanpro Plus. Toque para saber mais.",
  "cleanproBirthdayShortDesc_other": "Resgate um voucher de aniversário de {{ birthdayVoucherAmount }} créditos no seu dia especial com o Cleanpro Plus. Toque para saber mais.",
  'When you click on "PAY" button on the payment page, you can choose either using E-wallet or E-token to pay.': 'Quando você clicar no botão "PAGAR" na página de pagamento, pode escolher pagar usando Carteira Eletrônica ou E-token.',
  "When you using your voucher during payment, you will be unable to pay with E-token.": "Quando você usar seu voucher durante o pagamento, não poderá pagar com E-token.",
  "You can reload your E-token by clicking the reload button in the stamping page and select the package to purchase.": "Você pode recarregar seu E-token clicando no botão recarregar na página de carimbos e selecionando o pacote para comprar.",
  "You can reload your E-token by clicking the reload button in the home page and select the package to purchase.": "Você pode recarregar seu E-token clicando no botão recarregar na página inicial e selecionando o pacote para comprar.",
  "You can view your E-token reload history and E-token transaction history in transaction page.": "Você pode ver seu histórico de recarga de E-token e histórico de transações de E-token na página de transações.",
  "You can view your E-token transaction history in transaction page.": "Você pode ver seu histórico de transações de E-token na página de transações.",
  "Using either dryer machine or washer machine with the minimum spending of": "Usando máquina de secar ou máquina de lavar com o gasto mínimo de",
  "to collect one stamp.": "para coletar um selo.",
  "The voucher will be given if you have collected 10 stamps.": "O voucher será concedido se você tiver coletado 10 selos.",
  "Using dryer machine with the minimum spending of": "Usando máquina de secar com o gasto mínimo de",
  "Using washer machine with the minimum spending of": "Usando máquina de lavar com o gasto mínimo de",
  "to collect one dryer stamp.": "para coletar um selo de secadora.",
  "to collect one washer stamp.": "para coletar um selo de lavadora.",
  "The voucher will be given if you have collected 10 dryer stamps or 10 washer stamps.": "O voucher será concedido se você tiver coletado 10 selos de secadora ou 10 selos de lavadora.",
  "For the voucher given by the dryer stamps,": "Para o voucher concedido pelos selos de secadora,",
  "For the voucher given by the washer stamps,": "Para o voucher concedido pelos selos de lavadora,",
  "When promotion is on going, all the vouchers is not applicable.": "Quando uma promoção está em andamento, todos os vouchers não são aplicáveis.",
  "All the vouchers cannot be used if your payment method is E-Token.": "Todos os vouchers não podem ser usados se seu método de pagamento for E-Token.",
  "Description": "Descrição",
  "Refer Friends": "Indicar Amigos",
  "View our guideline": "Ver nossas diretrizes",
  "When a friend / family register using your referral code, and completed a transaction with a minimum spending of": "Quando um amigo/familiar se cadastrar usando seu código de indicação e completar uma transação com um gasto mínimo de",
  ", you will be rewarded automatically.": ", você será recompensado automaticamente.",
  "One user only allow to have": "Um usuário só pode ter",
  "referrals.": "indicações.",
  "Confirmation Password": "Confirmar Senha",
  "Password and confirmation password should be same.": "A senha e a confirmação da senha devem ser iguais.",
  "You haven't applied your voucher": "Você não aplicou seu voucher",
  "Would you like to continue your payment without using your voucher?": "Gostaria de continuar seu pagamento sem usar seu voucher?",
  "Continue": "Continuar",
  "Apply voucher": "Aplicar voucher",
  "Transfer": "Transferir",
  "Transfer Tokens": "Transferir Tokens",
  "Please fill in the phone number": "Por favor, preencha o número de telefone",
  "Please fill in the email": "Por favor, preencha o email",
  "Please enter the phone number / email that you want to transfer to": "Por favor, digite o número de telefone / email para o qual deseja transferir",
  "Please fill in the transfer amount": "Por favor, preencha o valor da transferência",
  "Transfer amount should be more than 0 and less than your current e-Token": "O valor da transferência deve ser maior que 0 e menor que seu e-Token atual",
  "Please enter your password": "Por favor, digite sua senha",
  "Member ID": "ID de Membro",
  "E-Token Transfer Amount": "Valor de Transferência de E-Token",
  "Please confirm the details before proceeding": "Por favor, confirme os detalhes antes de prosseguir",
  "Transfer From": "Transferir De",
  "Transfer To": "Transferir Para",
  "Transfer Amount": "Valor da Transferência",
  "Transfer Successfully!": "Transferência Bem-sucedida!",
  "Transfer Time": "Hora da Transferência",
  "Token": "Token",
  "Done": "Concluído",
  "Next": "Próximo",
  "Enter Password": "Digite a Senha",
  "Transfer E-Token Amount": "Valor de Transferência de E-Token",
  "User not found": "Usuário não encontrado",
  "Password is incorrect": "Senha incorreta",
  "Please go to your account setting and reset your password": "Por favor, vá para as configurações da sua conta e redefina sua senha",
  "Only up to last 3 months transaction history": "Apenas até os últimos 3 meses de histórico de transações",
  "Reload History": "Histórico de Recarga",
  "Transfer History": "Histórico de Transferência",
  "{{ point }} History": "Histórico de {{ point }}",
  "Only up to last 3 months reload history": "Apenas até os últimos 3 meses de histórico de recarga",
  "Only up to last 3 months transfer history": "Apenas até os últimos 3 meses de histórico de transferência",
  "Only up to last 3 months {{ point }} history": "Apenas até os últimos 3 meses de histórico de {{ point }}",
  "Only up to last 3 months laundry pass history": "Apenas até os últimos 3 meses de histórico de passe de lavanderia",
  "If require urgent response, please contact us through whatapp": "Se precisar de resposta urgente, entre em contato conosco pelo WhatsApp",
  "Please scan the QR code again": "Por favor, escaneie o código QR novamente",
  "Home": "Início",
  "Quick": "Rápido",
  "Super": "Super",
  "Premium": "Premium",
  "All users will have infinite referrals.": "Todos os usuários terão indicações infinitas.",
  "Collect 10 stamps to get 1 Voucher": "Colete 10 selos para ganhar 1 Voucher",
  "The voucher is only for customer use only, not for sale.": "O voucher é apenas para uso do cliente, não para venda.",
  "Outlet is currently offline, please try again later": "A loja está atualmente offline, por favor, tente novamente mais tarde",
  "The voucher will be given if you completed a transaction with a minimum spending of": "O voucher será concedido se você completar uma transação com um gasto mínimo de",
  "The birthday voucher will be given on the first day of your birthday month.": "O voucher de aniversário será concedido no primeiro dia do mês do seu aniversário.",
  "The voucher only will be given if you have exceed spending amount of": "O voucher só será concedido se você exceder o valor de gasto de",
  "Pay with KiplePay": "Pagar com KiplePay",
  "Pay with Scan2Pay": "Pagar com Scan2Pay",
  "Pay with Razer": "Pagar com Razer",
  "Pay with HitPay": "Pagar com HitPay",
  "Pay with Duitnow QR": "Pagar com Duitnow QR",
  "Pay with PagBank": "Pagar com PagBank",
  "Pay with PromptPay QR": "Pagar com PromptPay QR",
  "Pay with Card": "Pagar com Cartão",
  "Pay with PayWay": "Pagar com PayWay",
  "DISCOUNT CODE": "CÓDIGO DE DESCONTO",
  "Enter code >": "Digite o código >",
  "Enter Discount Code": "Digite o Código de Desconto",
  "Remove Code": "Remover Código",
  "Discount Code": "Código de Desconto",
  "Close": "Fechar",
  "Please fill in your email address": "Por favor, preencha seu endereço de email",
  "Notification": "Notificação",
  "Do you want to receive notification when wash cycle done?": "Deseja receber notificação quando o ciclo de lavagem terminar?",
  "pay extra": "pagar extra",
  "Email Address": "Endereço de Email",
  "Please fill in your phone number": "Por favor, preencha seu número de telefone",
  "Invalid Phone Number": "Número de Telefone Inválido",
  "Washing Complete": "Lavagem Completa",
  "Drying Complete": "Secagem Completa",
  "The voucher will be given if you registered your account successfully, but it only can be used when your total transaction spending reach": "O voucher será concedido se você cadastrar sua conta com sucesso, mas só poderá ser usado quando seu gasto total em transações atingir",
  "and above.": "e acima.",
  "This voucher is not applicable": "Este voucher não é aplicável",
  "Finish in": "Termina em",
  "Need to refresh to update": "Precisa atualizar para atualizar",
  "It's indicative and may change based on washer load": "É indicativo e pode mudar com base na carga da lavadora",
  "We'll let you know when it's ready to pick up": "Avisaremos quando estiver pronto para retirada",
  "FREE": "GRÁTIS",
  "Enter voucher code (if got any)": "Digite o código do voucher (se tiver algum)",
  "Please fill in the voucher code": "Por favor, preencha o código do voucher",
  "Available On": "Disponível Em",
  "Apply": "Aplicar",
  "Enter a code": "Digite um código",
  "Input Promo Code": "Digite o Código Promocional",
  "Voucher is redeemed successfully!": "Voucher resgatado com sucesso!",
  "Not available": "Não disponível",
  "Unable to register": "Não é possível cadastrar",
  "Drop n Go Service": "Serviço Drop n Go",
  "Select Mode": "Selecionar Modo",
  "Quantity": "Quantidade",
  "Pack": "Pacote",
  "Add more": "Adicionar mais",
  "Select Size": "Selecionar Tamanho",
  "Select Services": "Selecionar Serviços",
  "Are you sure to delete the item?": "Tem certeza de que deseja excluir o item?",
  "Delete": "Excluir",
  "Your Duitnow QR code": "Seu código QR Duitnow",
  "Your PromptPay QR code": "Seu código QR PromptPay",
  "How to pay using Duitnow QR code?": "Como pagar usando o código QR Duitnow?",
  "How to pay using PromptPay QR code?": "Como pagar usando o código QR PromptPay?",
  "Launch": "Iniciar",
  "Launch your preferred Mobile Banking or eWallet app.": "Inicie seu aplicativo preferido de Mobile Banking ou Carteira Eletrônica.",
  "Scan QR code from Gallery": "Escanear código QR da Galeria",
  "Choose DuitNow QR from your gallery.": "Escolha o QR DuitNow da sua galeria.",
  "Confirm payment details and pay.": "Confirme os detalhes do pagamento e pague.",
  "Receive payment confirmation.": "Receba a confirmação do pagamento.",
  "expiring on": "expira em",
  "Expired on": "Expirado em",
  "based on transaction payment amount": "baseado no valor do pagamento da transação",
  "Join as our": "Junte-se como nosso",
  "Loyalty Member": "Membro de Fidelidade",
  "now to get more reward": "agora para obter mais recompensas",
  "Payment amount should be greater than 0": "O valor do pagamento deve ser maior que 0",
  // admin portal
  "Dashboard": "Painel",
  "Report": "Relatório",
  "Store Performance": "Desempenho da Loja",
  "User Performance": "Desempenho do Usuário",
  "Voucher Redemption": "Resgate de Voucher",
  "Token Report": "Relatório de Tokens",
  "SMS Report": "Relatório de SMS",
  "Discount Code Report": "Relatório de Código de Desconto",
  "User Details": "Detalhes do Usuário",
  "User Compensation": "Compensação do Usuário",
  "Voucher Settings": "Configurações de Voucher",
  "Token Settings": "Configurações de Token",
  "Referral Settings": "Configurações de Indicação",
  "Voucher Code": "Código do Voucher",
  "Customize Color": "Personalizar Cor",
  "User Migration": "Migração de Usuário",
  "Back To": "Voltar Para",
  "Eligibility": "Elegibilidade",
  "If ticked, the voucher will have expired date": "Se marcado, o voucher terá data de validade",
  "Expiry": "Validade",
  "If ticked, the voucher can apply to washer machine transaction": "Se marcado, o voucher pode ser aplicado a transações de máquina de lavar",
  "Washer Use": "Uso de Lavadora",
  "If ticked, the voucher can apply to dryer machine transaction": "Se marcado, o voucher pode ser aplicado a transações de máquina de secar",
  "Dryer Use": "Uso de Secadora",
  "If ticked, the voucher can apply to Drop n Go transaction": "Se marcado, o voucher pode ser aplicado a transações Drop n Go",
  "Package Use": "Uso de Pacote",
  "If ticked, the voucher can apply to vending machine transaction": "Se marcado, o voucher pode ser usado em transações de máquina de venda automática",
  "Vending Use": "Uso em Máquina de Venda",
  "If ticked, the voucher can apply to detergent vending machine transaction": "Se marcado, o voucher pode ser usado em transações de máquina de venda de detergente",
  "Detergent Use": "Uso em Máquina de Detergente",
  "If ticked, the voucher can apply to car wash transaction": "Se marcado, o voucher pode ser usado em transações de lavagem de carros",
  "Car Wash Use": "Uso em Lavagem de Carros",
  "Voucher Lifespan": "Duração do Voucher",
  "days": "dias",
  "Discount Type": "Tipo de Desconto",
  "Select a discount type": "Selecione um tipo de desconto",
  "Flat": "Fixo",
  "Rate": "Taxa",
  "Voucher Title": "Título do Voucher",
  "Voucher Description": "Descrição do Voucher",
  "Voucher Amount": "Valor do Voucher",
  "CONFIRM": "CONFIRMAR",
  "If ticked, the system will give voucher to user who completed washer stamp collection": "Se marcado, o sistema dará voucher ao usuário que completar a coleção de selos de lavadora",
  "If ticked, the system will give voucher to user who completed dryer stamp collection": "Se marcado, o sistema dará voucher ao usuário que completar a coleção de selos de secadora",
  "If ticked, the user only can get/use the voucher after make a transaction": "Se marcado, o usuário só poderá obter/usar o voucher após fazer uma transação",
  "Pay And Get Voucher": "Pagar E Ganhar Voucher",
  "Pay And Use Code": "Pagar E Usar Código",
  "If ticked, the system will only give the voucher to user after the user make a transaction": "Se marcado, o sistema só dará o voucher ao usuário após o usuário fazer uma transação",
  "If ticked, the system will give voucher to user who completed registration process": "Se marcado, o sistema dará voucher ao usuário que completar o processo de cadastro",
  "If ticked, the system will give voucher to user on their birthday month": "Se marcado, o sistema dará voucher ao usuário no mês do seu aniversário",
  "If ticked, the system will give voucher to user who completed stamp collection": "Se marcado, o sistema dará voucher ao usuário que completar a coleção de selos",
  "Minimum Payment Amount To Get/Use Register Voucher": "Valor Mínimo de Pagamento Para Obter/Usar Voucher de Cadastro",
  "Voucher Method": "Método de Voucher",
  "Select a voucher method": "Selecione um método de voucher",
  "The user directly get the voucher after register but only can use it after make transaction": "O usuário recebe diretamente o voucher após o cadastro, mas só pode usá-lo após fazer uma transação",
  "The user only can get voucher after make a transaction": "O usuário só pode obter voucher após fazer uma transação",
  "Minimum Payment Amount To Get Birthday Voucher": "Valor Mínimo de Pagamento Para Obter Voucher de Aniversário",
  "Minimum Payment Amount To Use Discount Code": "Valor Mínimo de Pagamento Para Usar Código de Desconto",
  "Outlets": "Lojas",
  "E-Payment Sales": "Vendas por Pagamento Eletrônico",
  "Number of stamps granted to users": "Número de selos concedidos aos usuários",
  "Total number of stamps granted": "Número total de selos concedidos",
  "Registered Users": "Usuários Cadastrados",
  "Stamps": "Selos",
  "Referral": "Indicação",
  "Register": "Cadastrar",
  "Top Outlets": "Principais Lojas",
  "Users": "Usuários",
  "Sort by": "Ordenar por",
  "Top Users": "Principais Usuários",
  "User name": "Nome do usuário",
  "Number": "Número",
  "Spending": "Gastos",
  "Number of registered users": "Número de usuários cadastrados",
  "Number of voucher given to users": "Número de vouchers concedidos aos usuários",
  "Total number of voucher given": "Número total de vouchers concedidos",
  "Voucher Type": "Tipo de Voucher",
  "Voucher Value": "Valor do Voucher",
  "Date": "Data",
  "Discount Code Type": "Tipo de Código de Desconto",
  "Discount Code Amount": "Valor do Código de Desconto",
  "Number of Redemption": "Número de Resgates",
  "Total Discount Amount": "Valor Total de Desconto",
  "Select Outlet": "Selecionar Loja",
  "Select Date": "Selecionar Data",
  "Select Transaction Date": "Selecionar Data da Transação",
  "Reset": "Redefinir",
  "Download Report": "Baixar Relatório",
  "Please fill in the remark": "Por favor, preencha a observação",
  "Transaction Date": "Data da Transação",
  "Machine Type": "Tipo de Máquina",
  "Machine Capacity": "Capacidade da Máquina",
  "Total Amount": "Valor Total",
  "Payment Amount": "Valor do Pagamento",
  "Discount From": "Desconto De",
  "Discount Amount": "Valor do Desconto",
  "Action": "Ação",
  "Remark": "Observação",
  "Refund Date": "Data do Reembolso",
  "Refund": "Reembolso",
  "Purchase Date": "Data da Compra",
  "e-Token Purchased (Tokens)": "e-Token Comprado (Tokens)",
  "Bought e-Token using": "Comprou e-Token usando",
  "Transaction ID": "ID da Transação",
  "Method": "Método",
  "Requery": "Consultar Novamente",
  "Reward Date": "Data da Recompensa",
  "Reward Type": "Tipo de Recompensa",
  "Notification Method": "Método de Notificação",
  "Email Preview": "Visualização de Email",
  "Message for User": "Mensagem para o Usuário",
  "SMS will send to user, please enter the message less than 130 characters": "SMS será enviado ao usuário, por favor, digite a mensagem com menos de 130 caracteres",
  "Enter the message to be sent to the user": "Digite a mensagem a ser enviada ao usuário",
  "Email Address to show on Email Template": "Endereço de Email para mostrar no Modelo de Email",
  "Input Company Email Address": "Digite o Endereço de Email da Empresa",
  "Company Name to show on Email Template": "Nome da Empresa para mostrar no Modelo de Email",
  "Input Company Name": "Digite o Nome da Empresa",
  "Company Phone No. to show on Email Template": "Nº de Telefone da Empresa para mostrar no Modelo de Email",
  "Input Company Phone No.": "Digite o Nº de Telefone da Empresa",
  "Voucher ID": "ID do Voucher",
  "Washer Stamp": "Selo de Lavadora",
  "Dryer Stamp": "Selo de Secadora",
  "e-Token Amount": "Quantidade de e-Token",
  "Transfer Date": "Data da Transferência",
  "Transfer Amount (Token)": "Valor da Transferência (Token)",
  "Number (Transfer From)": "Número (Transferir De)",
  "Name (Transfer From)": "Nome (Transferir De)",
  "Member ID (Transfer From)": "ID de Membro (Transferir De)",
  "Number (Transfer To)": "Número (Transferir Para)",
  "Name (Transfer To)": "Nome (Transferir Para)",
  "Member ID (Transfer To)": "ID de Membro (Transferir Para)",
  "Grant Date": "Data de Concessão",
  "Claim Date": "Data de Reivindicação",
  "Member Details Report": "Relatório de Detalhes do Membro",
  "Transaction Status": "Status da Transação",
  "Token Reload": "Recarga de Token",
  "Token Transfer": "Transferência de Token",
  "Voucher History": "Histórico de Voucher",
  "TOKEN": "TOKEN",
  "Message Sent": "Mensagem Enviada",
  "Date Sent": "Data de Envio",
  "Remaining SMS Credit": "Crédito de SMS Restante",
  "Store": "Loja",
  "Total Registered Users": "Total de Usuários Cadastrados",
  "User registered but no transaction record": "Usuário cadastrado mas sem registro de transação",
  "Registered": "Cadastrado",
  "User spending is less than": "Gasto do usuário é menor que",
  "Active": "Ativo",
  "User spending is from": "Gasto do usuário é de",
  "until": "até",
  "Tier 1": "Nível 1",
  "User spending is": "Gasto do usuário é",
  "and above": "e acima",
  "Tier 2": "Nível 2",
  "Average spending in each transaction": "Gasto médio em cada transação",
  "Average Spending": "Gasto Médio",
  "Total number of transactions": "Número total de transações",
  "Total Transactions": "Total de Transações",
  "Number of vouchers used in all the transactions": "Número de vouchers usados em todas as transações",
  "Voucher Claimed": "Voucher Reivindicado",
  "Total number of washer machine transactions": "Número total de transações de máquina de lavar",
  "Washer Usage": "Uso de Lavadora",
  "Total number of dryer machine transactions": "Número total de transações de máquina de secar",
  "Dryer Usage": "Uso de Secadora",
  "User Name": "Nome do Usuário",
  "e-Token Spent": "e-Token Gasto",
  "e-Token Detailed Report": "Relatório Detalhado de e-Token",
  "e-Token Purchase History": "Histórico de Compra de e-Token",
  "Select Purchase Date": "Selecionar Data de Compra",
  "Outlet Name": "Nome da Loja",
  "Total number of e-token used in all the transactions": "Número total de e-tokens usados em todas as transações",
  "Total e-Token Collected": "Total de e-Token Coletado",
  "Total number of e-token used in washer machine transactions": "Número total de e-tokens usados em transações de máquina de lavar",
  "Washer e-Token Collected": "e-Token de Lavadora Coletado",
  "Total number of e-token used in dryer machine transactions": "Número total de e-tokens usados em transações de máquina de secar",
  "Dryer e-Token Collected": "e-Token de Secadora Coletado",
  "Vending Machine e-Token Collected": "Token eletrônico de máquina de venda automática coletado",
  "Purchase History": "Histórico de Compra",
  "All": "Todos",
  "Most Bought e-Token Package": "Pacote de e-Token Mais Comprado",
  "for": "por",
  "Tokens": "Tokens",
  "Total Earned from users buying e-Tokens": "Total Ganho com usuários comprando e-Tokens",
  "Total e-Tokens Bought from you": "Total de e-Tokens Comprados de você",
  "Join Date": "Data de Adesão",
  "Channel": "Canal",
  "Tier": "Nível",
  "Referrer": "Indicador",
  "Referrals": "Indicações",
  "Number of transactions for last 7 days": "Número de transações nos últimos 7 dias",
  "Number of Usage (in week)": "Número de Uso (na semana)",
  "Number of transactions for last 1 month": "Número de transações no último mês",
  "Number of Usage (in month)": "Número de Uso (no mês)",
  "Total amount spent in all the transactions": "Valor total gasto em todas as transações",
  "Total Spent": "Total Gasto",
  "Last Transaction Date": "Data da Última Transação",
  "Number of vouchers collected": "Número de vouchers coletados",
  "Voucher Collected": "Voucher Coletado",
  "Number of vouchers used": "Número de vouchers usados",
  "Voucher Spent": "Voucher Gasto",
  "Washer Used": "Lavadora Usada",
  "Dryer Used": "Secadora Usada",
  "Total number of e-Token spent in all the transactions": "Número total de e-Tokens gastos em todas as transações",
  "Total number of stamps collected": "Número total de selos coletados",
  "Total Stamps": "Total de Selos",
  "Select Join Date": "Selecionar Data de Adesão",
  "Select Grant Date": "Selecionar Data de Concessão",
  "Amount": "Valor",
  "The image size is over 2MB": "O tamanho da imagem é superior a 2MB",
  "Duplicate language selected": "Idioma duplicado selecionado",
  "Are you sure you want to add FAQ?": "Tem certeza de que deseja adicionar FAQ?",
  "FAQ added successfully": "FAQ adicionada com sucesso",
  "FAQ Group added successfully": "Grupo de FAQ adicionado com sucesso",
  "Please provide the faq with the default language": "Por favor, forneça a FAQ com o idioma padrão",
  "Add FAQ": "Adicionar FAQ",
  "Default Language": "Idioma Padrão",
  "Select Default Language": "Selecionar Idioma Padrão",
  "Image (Optional)": "Imagem (Opcional)",
  "max": "máx",
  "Question": "Pergunta",
  "Select Language": "Selecionar Idioma",
  "Remove": "Remover",
  "Answer": "Resposta",
  "Add Translation": "Adicionar Tradução",
  "Are you sure you want to add FAQ Group?": "Tem certeza de que deseja adicionar Grupo de FAQ?",
  "Please provide the faq group with the default language": "Por favor, forneça o grupo de FAQ com o idioma padrão",
  "Add FAQ Group": "Adicionar Grupo de FAQ",
  "Title": "Título",
  "Title Language": "Idioma do Título",
  "Please fill in the title": "Por favor, preencha o título",
  "Please fill in the description": "Por favor, preencha a descrição",
  "Please fill in the short description": "Por favor, preencha a descrição curta",
  "Please select the end date for your news": "Por favor, selecione a data final para suas notícias",
  "Please provide the news with the default language": "Por favor, forneça as notícias com o idioma padrão",
  "Please provide the banner image": "Por favor, forneça a imagem do banner",
  "Please provide the news image": "Por favor, forneça a imagem das notícias",
  "Are you sure you want to add news?": "Tem certeza de que deseja adicionar notícias?",
  "News added successfully": "Notícias adicionadas com sucesso",
  "Please fill in all the required fields before submit": "Por favor, preencha todos os campos obrigatórios antes de enviar",
  "Add News": "Adicionar Notícias",
  "Banner Image": "Imagem do Banner",
  "News Image": "Imagem das Notícias",
  "Banner": "Banner",
  "aspect ratio": "proporção",
  "Image": "Imagem",
  "Display in": "Exibir em",
  "Inbox Page": "Página de Entrada",
  "Promotion Banner": "Banner Promocional",
  "Select Period: (optional)": "Selecionar Período: (opcional)",
  "Short Description": "Descrição Curta",
  "Your theme has been updated successfully": "Seu tema foi atualizado com sucesso",
  "Default Theme": "Tema Padrão",
  "Change Logo": "Alterar Logo",
  "REMOVE LOGO": "REMOVER LOGO",
  "Sms credit used up": "Crédito de SMS esgotado",
  "Please top up your sms credit": "Por favor, recarregue seu crédito de SMS",
  "Please": "Por favor",
  "Again": "Novamente",
  "Welcome": "Bem-vindo",
  "Ranking": "Classificação",
  "Select Year": "Selecionar Ano",
  "Missing Field": "Campo Ausente",
  "Please select can be used for which type of transaction": "Por favor, selecione para qual tipo de transação pode ser usado",
  "Please fill in the start date and end date": "Por favor, preencha a data de início e data de término",
  "Discount amount should be more than 0": "O valor do desconto deve ser maior que 0",
  "Redeem per user should be more than 0": "Resgate por usuário deve ser maior que 0",
  "Redeem per day should be more than 0": "Resgate por dia deve ser maior que 0",
  "Your discount code have edited successfully": "Seu código de desconto foi editado com sucesso",
  "Your discount code have added successfully": "Seu código de desconto foi adicionado com sucesso",
  "Delete this entry?": "Excluir esta entrada?",
  "Your discount code have deleted successfully": "Seu código de desconto foi excluído com sucesso",
  "Created Date": "Data de Criação",
  "Discount code": "Código de desconto",
  "General Discount Code": "Código de Desconto Geral",
  "Unique Discount Code": "Código de Desconto Único",
  "Start Date": "Data de Início",
  "End Date": "Data de Término",
  "Redeem Per User": "Resgate Por Usuário",
  "Redeem Per Day": "Resgate Por Dia",
  "Add Discount Code": "Adicionar Código de Desconto",
  "Generate Discount Code": "Gerar Código de Desconto",
  "No Discount Code": "Nenhum Código de Desconto",
  "Edit Discount Code": "Editar Código de Desconto",
  "Select Period": "Selecionar Período",
  "Redeem per user": "Resgate por usuário",
  "How many times the discount code can be used for each user": "Quantas vezes o código de desconto pode ser usado para cada usuário",
  "Redeem per day": "Resgate por dia",
  "How many times the discount code can be used in one day": "Quantas vezes o código de desconto pode ser usado em um dia",
  "If ticked, the discount code can apply to washer machine transaction": "Se marcado, o código de desconto pode ser aplicado a transações de máquina de lavar",
  "If ticked, the discount code can apply to dryer machine transaction": "Se marcado, o código de desconto pode ser aplicado a transações de máquina de secar",
  "If ticked, the discount code can apply to Drop n Go transaction": "Se marcado, o código de desconto pode ser aplicado a transações Drop n Go",
  "If ticked, the discount code can apply to vending machine transaction": "Se marcado, o código de desconto pode ser usado em transações de máquina de venda automática",
  "If ticked, the discount code can apply to detergent vending machine transaction": "Se marcado, o código de desconto pode ser usado em transações de máquina de venda de detergente",
  "If ticked, the discount code can apply to car wash transaction": "Se marcado, o código de desconto pode ser usado em transações de lavagem de carros",
  "The user enter the discount code": "O usuário digita o código de desconto",
  "in the payment page will get": "na página de pagamento receberá",
  "discount": "de desconto",
  "The discount code only can be used start from {{ start_date }} until {{ end_date }}": "O código de desconto só pode ser usado a partir de {{ start_date }} até {{ end_date }}",
  "Every user only can use the discount code {{ redeem_per_user }} times": "Cada usuário só pode usar o código de desconto {{ redeem_per_user }} vezes",
  "Every user only can use {{ redeem_per_user }} discount code from this batch of code": "Cada usuário só pode usar {{ redeem_per_user }} código de desconto deste lote de códigos",
  "Only {{ redeem_per_day }} transactions can use the discount code in one day_one": "Apenas {{ redeem_per_day }} transação pode usar o código de desconto em um dia",
  "Only {{ redeem_per_day }} transactions can use the discount code in one day_other": "Apenas {{ redeem_per_day }} transações podem usar o código de desconto em um dia",
  "The discount code only can be used for washer machine": "O código de desconto só pode ser usado para máquina de lavar",
  "The discount code only can be used for dryer machine": "O código de desconto só pode ser usado para máquina de secar",
  "The discount code only can be used for Drop n Go transaction": "O código de desconto só pode ser usado para transação Drop n Go",
  "The discount code only can be used for vending machine transaction": "O código de desconto só pode ser usado em transações de máquina de venda automática",
  "The discount code only can be used for detergent vending machine transaction": "O código de desconto só pode ser usado em transações de máquina de venda de detergente",
  "The discount code only can be used for car wash transaction": "O código de desconto só pode ser usado em transações de lavagem de carros",
  "The discount code can be used for washer machine or Drop n Go transaction": "O código de desconto pode ser usado para máquina de lavar ou transação Drop n Go",
  "The discount code can be used for dryer machine or Drop n Go transaction": "O código de desconto pode ser usado para máquina de secar ou transação Drop n Go",
  "The discount code can be used for washer machine, dryer machine or Drop n Go transaction": "O código de desconto pode ser usado para máquina de lavar, máquina de secar ou transação Drop n Go",
  "The discount code can be used for washer or dryer machine": "O código de desconto pode ser usado para máquina de lavar ou de secar",
  "The discount code can be used for washer machine or vending machine transaction": "O código de desconto pode ser usado em máquina de lavar ou máquina de venda automática",
  "The discount code can be used for washer machine or detergent vending machine transaction": "O código de desconto pode ser usado em máquina de lavar ou máquina de venda de detergente",
  "The discount code can be used for washer machine or car wash transaction": "O código de desconto pode ser usado em máquina de lavar ou lavagem de carros",
  "The discount code can be used for dryer machine or vending machine transaction": "O código de desconto pode ser usado em máquina de secar ou máquina de venda automática",
  "The discount code can be used for dryer machine or detergent vending machine transaction": "O código de desconto pode ser usado em máquina de secar ou máquina de venda de detergente",
  "The discount code can be used for dryer machine or car wash transaction": "O código de desconto pode ser usado em máquina de secar ou lavagem de carros",
  "The discount code can be used for vending machine or Drop n Go transaction": "O código de desconto pode ser usado em máquina de venda automática ou Drop n Go",
  "The discount code can be used for detergent vending machine or Drop n Go transaction": "O código de desconto pode ser usado em máquina de venda de detergente ou Drop n Go",
  "The discount code can be used for car wash or Drop n Go transaction": "O código de desconto pode ser usado em lavagem de carros ou Drop n Go",
  "The discount code can be used for vending machine or detergent vending machine transaction": "O código de desconto pode ser usado em máquina de venda automática ou máquina de venda de detergente",
  "The discount code can be used for vending machine or car wash transaction": "O código de desconto pode ser usado em máquina de venda automática ou lavagem de carros",
  "The discount code can be used for detergent vending machine or car wash transaction": "O código de desconto pode ser usado em máquina de venda de detergente ou lavagem de carros",
  "The discount code can be used for washer machine, dryer machine or vending machine transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de secar ou máquina de venda automática",
  "The discount code can be used for washer machine, dryer machine or detergent vending machine transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de secar ou máquina de venda de detergente",
  "The discount code can be used for washer machine, dryer machine or car wash transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de secar ou lavagem de carros",
  "The discount code can be used for washer machine, vending machine or Drop n Go transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de venda automática ou Drop n Go",
  "The discount code can be used for washer machine, detergent vending machine or Drop n Go transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de venda de detergente ou Drop n Go",
  "The discount code can be used for washer machine, car wash or Drop n Go transaction": "O código de desconto pode ser usado em máquina de lavar, lavagem de carros ou Drop n Go",
  "The discount code can be used for washer machine, vending machine or detergent vending machine transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de venda automática ou máquina de venda de detergente",
  "The discount code can be used for washer machine, vending machine or car wash transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de venda automática ou lavagem de carros",
  "The discount code can be used for washer machine, detergent vending machine or car wash transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de venda de detergente ou lavagem de carros",
  "The discount code can be used for dryer machine, vending machine or Drop n Go transaction": "O código de desconto pode ser usado em máquina de secar, máquina de venda automática ou Drop n Go",
  "The discount code can be used for dryer machine, detergent vending machine or Drop n Go transaction": "O código de desconto pode ser usado em máquina de secar, máquina de venda de detergente ou Drop n Go",
  "The discount code can be used for dryer machine, car wash or Drop n Go transaction": "O código de desconto pode ser usado em máquina de secar, lavagem de carros ou Drop n Go",
  "The discount code can be used for dryer machine, vending machine or detergent vending machine transaction": "O código de desconto pode ser usado em máquina de secar, máquina de venda automática ou máquina de venda de detergente",
  "The discount code can be used for dryer machine, vending machine or car wash transaction": "O código de desconto pode ser usado em máquina de secar, máquina de venda automática ou lavagem de carros",
  "The discount code can be used for dryer machine, detergent vending machine or car wash transaction": "O código de desconto pode ser usado em máquina de secar, máquina de venda de detergente ou lavagem de carros",
  "The discount code can be used for vending machine, detergent vending machine or Drop n Go transaction": "O código de desconto pode ser usado em máquina de venda automática, máquina de venda de detergente ou Drop n Go",
  "The discount code can be used for vending machine, car wash or Drop n Go transaction": "O código de desconto pode ser usado em máquina de venda automática, lavagem de carros ou Drop n Go",
  "The discount code can be used for detergent vending machine, car wash or Drop n Go transaction": "O código de desconto pode ser usado em máquina de venda de detergente, lavagem de carros ou Drop n Go",
  "The discount code can be used for vending machine, detergent vending machine or car wash transaction": "O código de desconto pode ser usado em máquina de venda automática, máquina de venda de detergente ou lavagem de carros",
  "The discount code can be used for washer machine, dryer machine, vending machine or Drop n Go transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de secar, máquina de venda automática ou Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de secar, máquina de venda automática ou máquina de venda de detergente",
  "The discount code can be used for washer machine, dryer machine, vending machine or car wash transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de secar, máquina de venda automática ou lavagem de carros",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine or car wash transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de secar, máquina de venda de detergente ou lavagem de carros",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or Drop n Go transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de venda automática, máquina de venda de detergente ou Drop n Go",
  "The discount code can be used for washer machine, vending machine, car wash or Drop n Go transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de venda automática, lavagem de carros ou Drop n Go",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or car wash transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de venda automática, máquina de venda de detergente ou lavagem de carros",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "O código de desconto pode ser usado em máquina de secar, máquina de venda automática, máquina de venda de detergente ou Drop n Go",
  "The discount code can be used for dryer machine, vending machine, car wash or Drop n Go transaction": "O código de desconto pode ser usado em máquina de secar, máquina de venda automática, lavagem de carros ou Drop n Go",
  "The discount code can be used for dryer machine, detergent vending machine, car wash machine or Drop n Go transaction": "O código de desconto pode ser usado em máquina de secar, máquina de venda de detergente, máquina de lavagem de carros ou Drop n Go",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or car wash transaction": "O código de desconto pode ser usado em máquina de secar, máquina de venda automática, máquina de venda de detergente ou lavagem de carros",
  "The discount code can be used for vending machine, detergent vending machine, car wash or Drop n Go transaction": "O código de desconto pode ser usado em máquina de venda automática, máquina de venda de detergente, lavagem de carros ou Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de secar, máquina de venda automática, máquina de venda de detergente ou Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine, car wash or Drop n Go transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de secar, máquina de venda automática, lavagem de carros ou Drop n Go",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine, car wash or Drop n Go transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de secar, máquina de venda de detergente, lavagem de carros ou Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or car wash transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de secar, máquina de venda automática, máquina de venda de detergente ou lavagem de carros",
  "The discount code can be used for washer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de venda automática, máquina de venda de detergente, lavagem de carros ou Drop n Go",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "O código de desconto pode ser usado em máquina de secar, máquina de venda automática, máquina de venda de detergente, lavagem de carros ou Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "O código de desconto pode ser usado em máquina de lavar, máquina de secar, máquina de venda automática, máquina de venda de detergente, lavagem de carros ou Drop n Go",
  "The discount code only can be used after user spending {{ currency }} {{ pay_and_use_amount }}": "O código de desconto só pode ser usado após o usuário gastar {{ currency }} {{ pay_and_use_amount }}",
  "Are you sure you want to edit FAQ?": "Tem certeza de que deseja editar a FAQ?",
  "FAQ updated successfully": "FAQ atualizada com sucesso",
  "Edit FAQ": "Editar FAQ",
  "Are you sure you want to edit FAQ Group?": "Tem certeza de que deseja editar o Grupo de FAQ?",
  "FAQ Group updated successfully": "Grupo de FAQ atualizado com sucesso",
  "Edit FAQ Group": "Editar Grupo de FAQ",
  "Are you sure you want to edit news?": "Tem certeza de que deseja editar as notícias?",
  "News edit successfully": "Notícias editadas com sucesso",
  "Edit News": "Editar Notícias",
  "All the FAQ under this group will be deleted. Are you sure you want to delete FAQ Group?": "Todas as FAQs neste grupo serão excluídas. Tem certeza de que deseja excluir o Grupo de FAQ?",
  "FAQ Group deleted successfully": "Grupo de FAQ excluído com sucesso",
  "FAQ List": "Lista de FAQ",
  "NO FAQ GROUP": "SEM GRUPO DE FAQ",
  "FAQ Group": "Grupo de FAQ",
  "Are you sure you want to delete FAQ?": "Tem certeza de que deseja excluir a FAQ?",
  "FAQ deleted successfully": "FAQ excluída com sucesso",
  "NO FAQs": "SEM FAQs",
  "FAQ": "FAQ",
  "Easy": "Fácil",
  "Fast Laundromate": "Lavanderia Rápida",
  "Smart Laundry Management System": "Sistema Inteligente de Gestão de Lavanderia",
  "Enter your username and password to login": "Digite seu nome de usuário e senha para entrar",
  "Username": "Nome de Usuário",
  "Are you sure you want to delete news?": "Tem certeza de que deseja excluir as notícias?",
  "News deleted successfully": "Notícias excluídas com sucesso",
  "NO NEWS": "SEM NOTÍCIAS",
  "The referral setting has been updated successfully!": "A configuração de indicação foi atualizada com sucesso!",
  "Number of Stamp": "Número de Selo",
  "Number of Washer Stamp": "Número de Selo de Lavadora",
  "Number of Dryer Stamp": "Número de Selo de Secadora",
  "Enable Referral Feature?": "Ativar Recurso de Indicação?",
  "Are you sure you want to delete the tier setting?": "Tem certeza de que deseja excluir a configuração de nível?",
  "Minimum referee transaction amount for referrer to get referral rewards": "Valor mínimo de transação do indicado para o indicador receber recompensas",
  "Maximum number of reward within this tier": "Número máximo de recompensas dentro deste nível",
  "Maximum number of reward can get from same user": "Número máximo de recompensas que podem ser obtidas do mesmo usuário",
  "Point Grant Type": "Tipo de Concessão de Pontos",
  "Select Point Grant Type": "Selecionar Tipo de Concessão de Pontos",
  "Token Grant Type": "Tipo de Concessão de Tokens",
  "Select Token Grant Type": "Selecionar Tipo de Concessão de Tokens",
  "Add Tier": "Adicionar Nível",
  "Stamp": "Selo",
  "If ticked, the system will give stamp to user": "Se marcado, o sistema dará selo ao usuário",
  "If ticked, the system will give e-Token to user": "Se marcado, o sistema dará e-Token ao usuário",
  "If ticked, the system will give voucher to user": "Se marcado, o sistema dará voucher ao usuário",
  "Number of E-Token": "Número de E-Token",
  "Reward Giveaway": "Distribuição de Recompensas",
  "Which type of reward you want to give to customer?": "Que tipo de recompensa você deseja dar ao cliente?",
  "For machine uses (required)": "Para usos de máquina (obrigatório)",
  "leave blank if no expiry date": "deixe em branco se não houver data de validade",
  "Remarks": "Observações",
  "Reward": "Recompensa",
  "Please fill in all the required field. (Title, description, and amount must be more than 0)": "Por favor, preencha todos os campos obrigatórios. (Título, descrição e valor devem ser maiores que 0)",
  "Checkbox required": "Caixa de seleção obrigatória",
  "Must select voucher can be used for washer, dryer or package": "Deve selecionar se o voucher pode ser usado para lavadora, secadora ou pacote",
  "How many e-token?": "Quantos e-tokens?",
  "Number of e-Token": "Número de e-Token",
  "Token value must be more than 0": "O valor do token deve ser maior que 0",
  "STAMP": "SELO",
  "Please fill in at least one of the required field": "Por favor, preencha pelo menos um dos campos obrigatórios",
  "The value must be more than 0": "O valor deve ser maior que 0",
  "How many times rewarded to user": "Quantas vezes recompensado ao usuário",
  "Rewarded Times": "Vezes Recompensado",
  "How many times rewarded voucher to user": "Quantas vezes voucher recompensado ao usuário",
  "Voucher Rewarded (times)": "Voucher Recompensado (vezes)",
  "How many times rewarded stamp to user": "Quantas vezes selo recompensado ao usuário",
  "Stamps Rewarded (times)": "Selos Recompensados (vezes)",
  "Total number of washer stamps rewarded to user": "Número total de selos de lavadora recompensados ao usuário",
  "Washer Stamps Granted (stamp)": "Selos de Lavadora Concedidos (selo)",
  "Total number of dryer stamps rewarded to user": "Número total de selos de secadora recompensados ao usuário",
  "Dryer Stamps Granted (stamp)": "Selos de Secadora Concedidos (selo)",
  "How many times rewarded e-Token to user": "Quantas vezes e-Token recompensado ao usuário",
  "e-Token Rewarded (times)": "e-Token Recompensado (vezes)",
  "Total number of e-Token rewarded to user": "Número total de e-Token recompensado ao usuário",
  "Total e-Token Granted (token)": "Total de e-Token Concedido (token)",
  "Point Rewarded (times)": "Pontos Recompensados (vezes)",
  "How many times rewarded point to user": "Quantas vezes pontos recompensados ao usuário",
  "Total Point Granted (point)": "Total de Pontos Concedidos (ponto)",
  "Total number of point rewarded to user": "Número total de pontos recompensados ao usuário",
  "Point Amount": "Quantidade de Pontos",
  "Reward History": "Histórico de Recompensas",
  "Are you sure you want to change how the stamping mechanics works?": "Tem certeza de que deseja alterar como funciona a mecânica de carimbagem?",
  "The stamping mechanics setting has updated successfully!": "A configuração da mecânica de carimbagem foi atualizada com sucesso!",
  "The voucher setting has been updated successfully!": "A configuração do voucher foi atualizada com sucesso!",
  "Mechanics Settings": "Configurações de Mecânica",
  "Minimum transaction amount for getting stamp": "Valor mínimo de transação para obter selo",
  "Select User Stamping Mechanic": "Selecionar Mecânica de Carimbagem do Usuário",
  "Separated Stamping": "Carimbagem Separada",
  "Combined Stamping": "Carimbagem Combinada",
  "Stamp for?": "Selo para?",
  "Both": "Ambos",
  "Washer Only": "Apenas Lavadora",
  "Dryer Only": "Apenas Secadora",
  "Separated Stamping = Different washer and dryer stamp collection. (example: Using Washer will gain 1 washer's stamp, and Dryer will gain 1 dryer stamp)": "Carimbagem Separada = Coleção de selos de lavadora e secadora diferentes. (exemplo: Usar a Lavadora ganhará 1 selo de lavadora, e a Secadora ganhará 1 selo de secadora)",
  "Combined Stamping = Washer and dryer has the same collection. (example: Using Washer or Dryer will gain 1 stamp)": "Carimbagem Combinada = Lavadora e secadora têm a mesma coleção. (exemplo: Usar a Lavadora ou Secadora ganhará 1 selo)",
  "Stamp for": "Selo para",
  "User will be able to collect both washer stamp and dryer stamp": "O usuário poderá coletar tanto selo de lavadora quanto selo de secadora",
  "User will only able to collect Washer stamp": "O usuário só poderá coletar selo de Lavadora",
  "User will only able to collect Dryer stamp": "O usuário só poderá coletar selo de Secadora",
  "Registration": "Cadastro",
  "Birthday": "Aniversário",
  "Please choose at least one payment method": "Por favor, escolha pelo menos um método de pagamento",
  "Please choose at least one member or non-member payment": "Por favor, escolha pelo menos um pagamento de membro ou não-membro",
  "Are you sure you want to change the payment setting?": "Tem certeza de que deseja alterar a configuração de pagamento?",
  "The payment setting has updated successfully!": "A configuração de pagamento foi atualizada com sucesso!",
  "Invalid input": "Entrada inválida",
  "The price and token must be more than 0": "O preço e o token devem ser maiores que 0",
  "Maximum number of purchase must be more than 0": "O número máximo de compras deve ser maior que 0",
  "Point amount must be more than 1": "A quantidade de pontos deve ser maior que 1",
  "Added a new Token Bundle Package": "Adicionado um novo Pacote de Bundle de Token",
  "Bundle deleted successfully!": "Bundle excluído com sucesso!",
  "Reload voucher setting have edited successfully!": "Configuração de voucher de recarga editada com sucesso!",
  "Added on": "Adicionado em",
  "remove": "remover",
  "edit": "editar",
  "NO PACKAGES ON SALES": "SEM PACOTES EM PROMOÇÃO",
  "Point Settings": "Configurações de Pontos",
  "Enable Loyalty Point": "Ativar Ponto de Fidelidade",
  "Point Name": "Nome do Ponto",
  "Number Of Point Equals To": "Número De Pontos Igual A",
  "If ticked, the point will have expired date": "Se marcado, o ponto terá data de validade",
  "Point Lifespan": "Duração do Ponto",
  "months": "meses",
  "Minimum Transaction Amount To Get Point": "Valor Mínimo de Transação Para Obter Ponto",
  "Point Grant Amount": "Quantidade de Concessão de Pontos",
  "Point Grant Period": "Período de Concessão de Pontos",
  "Optional": "Opcional",
  "Drop n Go Eligibility": "Elegibilidade Drop n Go",
  "If ticked, Drop n Go transaction will get the point": "Se marcado, a transação Drop n Go receberá o ponto",
  "Washer Eligibility": "Washer Eligibility", // new translation
  "If ticked, washer transaction will get the point": "If ticked, washer transaction will get the point",
  "Dryer Eligibility": "Dryer Eligibility",
  "If ticked, dryer transaction will get the point": "If ticked, dryer transaction will get the point",
  "Point settings updated successfully!": "Configurações de pontos atualizadas com sucesso!",
  "Point Eligibility": "Elegibilidade de Pontos",
  "If ticked, the system will give point to user when user reload token successfully": "Se marcado, o sistema dará pontos ao usuário quando o usuário recarregar token com sucesso",
  "{{ point_amount }} point will be given after user reload token successfully": "{{ point_amount }} ponto será concedido após o usuário recarregar token com sucesso",
  "Payment Settings": "Configurações de Pagamento",
  "Select Payment Method": "Selecionar Método de Pagamento",
  "Enable E-Payment?": "Ativar Pagamento Eletrônico?",
  "Enable Token Currency?": "Ativar Moeda de Token?",
  "Enable Cash Payment?": "Ativar Pagamento em Dinheiro?",
  "Enable QR Payment?": "Ativar Pagamento por QR?",
  "Member and Non-Member Settings": "Configurações de Membro e Não-Membro",
  "Enable Member Payment?": "Ativar Pagamento de Membro?",
  "Enable Non-Member Payment?": "Ativar Pagamento de Não-Membro?",
  "Promotion Settings": "Configurações de Promoção",
  "Enable Non Member Promotion?": "Ativar Promoção de Não-Membro?",
  "Enable Notification When Cycle Done?": "Ativar Notificação Quando o Ciclo Terminar?",
  "SMS charges": "Cobranças de SMS",
  "SMS Settings": "Configurações de SMS",
  "Enable Free Sms For Members": "Ativar SMS Gratuito Para Membros",
  "If enable notification, user can choose either receive email or sms when complete washing or drying": "Se a notificação estiver ativada, o usuário pode escolher receber email ou SMS quando a lavagem ou secagem for concluída",
  "If user choose sms, non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "Se o usuário escolher SMS, não-membros terão que pagar extra {{ currency }}{{ sms_notification_amount }} pelo SMS",
  "If user choose sms, member and non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "Se o usuário escolher SMS, membros e não-membros terão que pagar extra {{ currency }}{{ sms_notification_amount }} pelo SMS",
  "Add Package": "Adicionar Pacote",
  "Edit e-Token Package": "Editar Pacote de e-Token",
  "Add e-Token Package": "Adicionar Pacote de e-Token",
  "Please only input numberic value to prevent any bugs.": "Por favor, digite apenas valores numéricos para evitar bugs.",
  "Price": "Preço",
  "If ticked, the system will limit the number of purchase": "Se marcado, o sistema limitará o número de compras",
  "Limit Number of Purchase": "Limitar Número de Compras",
  "Number of maximum purchase": "Número máximo de compras",
  "Reload Voucher": "Recarregar Voucher",
  "If ticked, the system will give voucher to user when user reload token successfully": "Se marcado, o sistema dará voucher ao usuário quando o usuário recarregar token com sucesso",
  "If ticked, the system will give voucher repeatly": "Se marcado, o sistema dará voucher repetidamente",
  "Recurring": "Recorrente",
  "Total number of voucher given to user": "Número total de vouchers dados ao usuário",
  "Period for giving next voucher": "Período para dar o próximo voucher",
  "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens_one": "Pacote de token {{ currency }}{{ price }} por {{ numberOfToken }} token",
  "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens_other": "Pacote de token {{ currency }}{{ price }} por {{ numberOfToken }} tokens",
  "Each user only can purchase {{ max_purchase }} times for the token package": "Cada usuário só pode comprar {{ max_purchase }} vezes o pacote de token",
  "Voucher will be given after user reload token successfully": "Voucher será dado após o usuário recarregar token com sucesso",
  "Voucher will not given after user reload tokens successfully": "Voucher não será dado após o usuário recarregar tokens com sucesso",
  "The voucher will be expired after {{ voucher_duration }} days_one": "O voucher expirará após {{ voucher_duration }} dia",
  "The voucher will be expired after {{ voucher_duration }} days_other": "O voucher expirará após {{ voucher_duration }} dias",
  "The voucher will not expired": "O voucher não expirará",
  "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount_one": "Total de {{ recurring_number }} voucher será dado ao usuário e cada voucher descontará",
  "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount_other": "Total de {{ recurring_number }} vouchers serão dados ao usuário e cada voucher descontará",
  "Edit Package": "Editar Pacote",
  "Age": "Idade",
  "Total number of vouchers collected": "Número total de vouchers coletados",
  "Vouchers Acquired": "Vouchers Adquiridos",
  "Total amount spent in washer machine transactions": "Valor total gasto em transações de máquina de lavar",
  "Total Washer Payment": "Pagamento Total de Lavadora",
  "Total amount spent in dryer machine transactions": "Valor total gasto em transações de máquina de secar",
  "Total Dryer Payment": "Pagamento Total de Secadora",
  "Total amount spent in all transactions": "Valor total gasto em todas as transações",
  "Total Payment": "Pagamento Total",
  "report": "relatório",
  "Total amount spent for buying e-Token": "Valor total gasto para comprar e-Token",
  "Total number of e-Token purchased": "Número total de e-Token comprado",
  "Total e-Token Purchased (Tokens)": "Total de e-Token Comprado (Tokens)",
  "Total number of e-Token used in washer machine transactions": "Número total de e-Token usado em transações de máquina de lavar",
  "Washer Payment (Tokens)": "Pagamento de Lavadora (Tokens)",
  "Total number of e-Token used in dryer machine transactions": "Número total de e-Token usado em transações de máquina de secar",
  "Dryer Payment (Tokens)": "Pagamento de Secadora (Tokens)",
  "Total number of e-Token used in all the transactions": "Número total de e-Token usado em todas as transações",
  "Total Payment (Tokens)": "Pagamento Total (Tokens)",
  "Number of washer stamp collected currently": "Número de selos de lavadora coletados atualmente",
  "Number of dryer stamp collected currently": "Número de selos de secadora coletados atualmente",
  "User Phone Number / Member ID / Email": "Número de Telefone do Usuário / ID de Membro / Email",
  "Example: 0123456789,A123456": "Exemplo: 0123456789,A123456",
  "SEARCH": "BUSCAR",
  "Total Users Registered": "Total de Usuários Cadastrados",
  "Total Active Outlets": "Total de Lojas Ativas",
  "Total Vouchers Given": "Total de Vouchers Concedidos",
  "Total Transaction Counts": "Total de Contagens de Transações",
  "Total User Stamps Collected": "Total de Selos de Usuário Coletados",
  "Distributor Login": "Login de Distribuidor",
  "Client Login": "Login de Cliente",
  "Kiosk Login": "Login de Quiosque",
  "Promotion": "Promoção",
  "Please select operator": "Por favor, selecione o operador",
  "Please select distributor": "Por favor, selecione o distribuidor",
  "Select Operator": "Selecionar Operador",
  "Select Distributor": "Selecionar Distribuidor",
  "User can login or skip to payment without login to make the payment": "O usuário pode entrar ou ir direto para o pagamento sem login para fazer o pagamento",
  "User have to login only can make the payment": "O usuário tem que entrar apenas para poder fazer o pagamento",
  "User only can skip to payment without login to make the payment": "O usuário só pode ir direto para o pagamento sem login para fazer o pagamento",
  "Only CSV file is accepted": "Apenas arquivo CSV é aceito",
  "The user and the balance have updated": "O usuário e o saldo foram atualizados",
  "Register Time": "Hora de Cadastro",
  "Upload User CSV file": "Carregar arquivo CSV de Usuário",
  "Sample CSV file": "Arquivo CSV de exemplo",
  "Please follow the CSV file format": "Por favor, siga o formato do arquivo CSV",
  "User CSV file": "Arquivo CSV de Usuário",
  "Only CSV file (comma delimited) is support now": "Apenas arquivo CSV (delimitado por vírgula) é suportado agora",
  "Confirm uploaded data": "Confirmar dados carregados",
  "Operator": "Operador",
  "Distributor": "Distribuidor",
  "Refund By": "Reembolso Por",
  "Reward By": "Recompensa Por",
  "Number Of Voucher Code": "Número De Código de Voucher",
  "Number Of Discount Code": "Número De Código de Desconto",
  "New User Only": "Apenas Novo Usuário",
  "Minimum Transaction Amount To Redeem": "Valor Mínimo de Transação Para Resgatar",
  "Download": "Baixar",
  "Generate Voucher Code": "Gerar Código de Voucher",
  "Your voucher code is generating": "Seu código de voucher está sendo gerado",
  "Your discount code is generating": "Seu código de desconto está sendo gerado",
  "Voucher Code Settings": "Configurações de Código de Voucher",
  "If ticked, the voucher code only can redeem in register page": "Se marcado, o código de voucher só pode ser resgatado na página de cadastro",
  "If ticked, the user only can use the voucher after make a transaction": "Se marcado, o usuário só pode usar o voucher após fazer uma transação",
  "If ticked, the user only can use the discount code after make a transaction": "Se marcado, o usuário só pode usar o código de desconto após fazer uma transação",
  "Expired Date Of Voucher Code": "Data de Validade Do Código de Voucher",
  "Minimum Transaction Amount To Use Voucher": "Valor Mínimo de Transação Para Usar Voucher",
  "Minimum Transaction Amount To Use Code": "Valor Mínimo de Transação Para Usar Código",
  "Max redemption per user in this batch voucher code": "Resgate máximo por usuário neste lote de código de voucher",
  "Max redemption per user in this batch discount code": "Resgate máximo por usuário neste lote de código de desconto",
  "Add Voucher": "Adicionar Voucher",
  "Completed": "Concluído",
  "Voucher Code Report": "Relatório de Código de Voucher",
  "Floating Token Report": "Relatório de Token Flutuante",
  "Floating Point Report": "Relatório de Ponto Flutuante",
  "E-Payment Report": "Relatório de Pagamento Eletrônico",
  "Referral Reward History Report": "Relatório de Histórico de Recompensa de Indicação",
  "Redemption Date": "Data de Resgate",
  "Redemption Code": "Código de Resgate",
  "Select Redemption Date": "Selecionar Data de Resgate",
  "Select Voucher Type": "Selecionar Tipo de Voucher",
  "Giveaway": "Brinde",
  "Select Name": "Selecionar Nome",
  "Amount must be more than 1": "O valor deve ser maior que 1",
  "Payment method setting have updated successfully!": "Configuração de método de pagamento atualizada com sucesso!",
  "Edit Payment Method": "Editar Método de Pagamento",
  "Minimum payment amount to include all the payment methods": "Valor mínimo de pagamento para incluir todos os métodos de pagamento",
  "Exclude Payment Method in Revenue Monster": "Excluir Método de Pagamento no Revenue Monster",
  "Welcome to": "Bem-vindo a",
  "Instruction": "Instrução",
  "Please select the machine": "Por favor, selecione a máquina",
  "Login your account": "Entre na sua conta",
  "Select the setting and make the payment": "Selecione a configuração e faça o pagamento",
  "Phone Number / Email": "Número de Telefone / Email",
  "Reload & Transfer In": "Recarregar & Transferência Recebida",
  "Usage & Transfer Out": "Uso & Transferência Enviada",
  "Usage": "Uso",
  "Remaining": "Restante",
  "Gain": "Ganho",
  "Type": "Tipo",
  "Order Date": "Data do Pedido",
  "Pack Number": "Número do Pacote",
  "Pack Details": "Detalhes do Pacote",
  "Size": "Tamanho",
  "Mode": "Modo",
  "Machine Payment": "Pagamento da Máquina",
  "DNG History": "Histórico DNG",
  "Token History": "Histórico de Token",
  "Stamp History": "Histórico de Selo",
  "Staff Login": "Login de Funcionário",
  "Drop And Go Portal": "Portal Drop And Go",
  "Available Task": "Tarefa Disponível",
  "Completed Task": "Tarefa Concluída",
  "Task ID": "ID da Tarefa",
  "Start Task": "Iniciar Tarefa",
  "Select Machine": "Selecionar Máquina",
  "Start Machine": "Iniciar Máquina",
  "Reward To": "Recompensar Para",
  "Reward From": "Recompensa De",
  "Transaction Account": "Conta de Transação",
  "Point": "Ponto",
  "POINT": "PONTO",
  "Number of Point": "Número de Pontos",
  "Point History": "Histórico de Pontos",
  "Customer Name": "Nome do Cliente",
  "Number of Washer Transactions": "Número de Transações de Lavadora",
  "Number of Dryer Transactions": "Número de Transações de Secadora",
  "Vouchers Redeemed": "Vouchers Resgatados",
  "Discount Code Redemption": "Resgate de Código de Desconto",
  "Total Spend": "Gasto Total",
  "Select Outlet(s)": "Selecionar Loja(s)",
  "User Usage Report": "Relatório de Uso do Usuário",
  // cleanpro plus en
  "Wash": "Lavar",
  "Dry": "Secar",
  "Fold": "Dobrar",
  "Scan QR": "Escanear QR",
  "Capacity": "Capacidade",
  "Duration": "Duração",
  "Custom duration": "Duração personalizada",
  "Choose duration": "Escolher duração",
  "Select the correct amount on the machine after payment.": "Selecione o valor correto na máquina após o pagamento.",
  "Offers": "Ofertas",
  "Voucher Offers": "Ofertas de Cupons",
  "Discount Code Offers": "Ofertas de Códigos de Desconto",
  "An easier way to pay": "Uma maneira mais fácil de pagar",
  "Create account": "Criar conta",
  "Login": "Entrar",
  "By signing up, you agree to": "Ao se cadastrar, você concorda com",
  "Amount to Pay": "Valor a Pagar",
  "1 voucher selected": "1 voucher selecionado",
  "No voucher selected": "Nenhum voucher selecionado",
  "Credits": "Créditos",
  "credits": "créditos",
  "credit": "crédito",
  "Credit balance": "Saldo de crédito",
  "Please ensure that the machine door is shut & your laundry is inside.": "Por favor, certifique-se de que a porta da máquina está fechada e sua roupa está dentro.",
  "Insufficient balance": "Saldo insuficiente",
  "Topup now": "Recarregar agora",
  "Copyright © {{ year }} Cleanpro Laundry Holdings Sdn Bhd (821842-P) All rights reserved.": "Copyright © {{ year }} Cleanpro Laundry Holdings Sdn Bhd (821842-P) Todos os direitos reservados.",
  "Good Evening!": "Boa Noite!",
  "Hello": "Olá",
  "Wallet Balance": "Saldo da Carteira",
  "Topup": "Recarregar",
  "More details": "Mais detalhes",
  "Collect 10 e-stamps to earn x1 FREE wash or dry voucher": "Colete 10 e-selos para ganhar x1 voucher GRÁTIS de lavagem ou secagem",
  "For every wash or dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "Para cada ciclo de lavagem ou secagem que você completar conosco, você ganhará um e-selo. Colete 10 e poderá resgatar um ciclo de lavagem ou secagem GRÁTIS. É nossa forma de agradecer por escolher a Cleanpro!",
  "For every wash cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "Para cada ciclo de lavagem que você completar conosco, você ganhará um e-selo. Colete 10 e poderá resgatar um ciclo de lavagem ou secagem GRÁTIS. É nossa forma de agradecer por escolher a Cleanpro!",
  "For every dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "Para cada ciclo de secagem que você completar conosco, você ganhará um e-selo. Colete 10 e poderá resgatar um ciclo de lavagem ou secagem GRÁTIS. É nossa forma de agradecer por escolher a Cleanpro!",
  "Credits OFF": "Créditos OFF",
  "% OFF": "% OFF",
  "Valid Till": "Válido Até",
  "Used On": "Usado Em",
  "Expired On": "Expirado Em",
  "Available": "Disponível",
  "Expired": "Expirado",
  "Used": "Usado",
  "Promotions": "Promoções",
  "Rewards": "Recompensas",
  "Inbox": "Caixa de Entrada",
  "Activities": "Atividades",
  "Support": "Suporte",
  "Active Rewards": "Recompensas Ativas",
  "Past Rewards": "Recompensas Passadas",
  "Get rewarded for your loyalty with Cleanpro Plus Rewards!": "Seja recompensado pela sua fidelidade com o Cleanpro Plus Rewards!",
  "Earn vouchers and redeem them for discounts, freebies and more. The more you use our services the more you save!": "Ganhe vouchers e resgate-os por descontos, brindes e mais. Quanto mais você usa nossos serviços, mais você economiza!",
  "Up to 3 months history": "Histórico de até 3 meses",
  "Filter": "Filtro",
  "All Transactions": "Todas as Transações",
  "Transactions": "Transações",
  "Select amount to topup": "Selecione o valor para recarregar",
  "Balance": "Saldo",
  "You've just paid": "Você acabou de pagar",
  "Need help?": "Precisa de ajuda?",
  "24-Hour Careline Number": "Número de Atendimento 24 Horas",
  "Email Us": "Envie-nos um Email",
  "Call Now": "Ligar Agora",
  "Email Now": "Enviar Email Agora",
  "Update name": "Atualizar nome",
  "Update email address": "Atualizar endereço de email",
  "Update phone number": "Atualizar número de telefone",
  "Change password": "Alterar senha",
  "Change language": "Alterar idioma",
  "User ID": "ID do Usuário",
  "Let us know your feedback": "Dê-nos seu feedback",
  "Poor": "Ruim",
  "Good": "Bom",
  "Leave addtional feedback here (optional)": "Deixe feedback adicional aqui (opcional)",
  "Submit feedback": "Enviar feedback",
  "Pay as guest": "Pagar como convidado",
  "Pay now": "Pagar agora",
  "Select voucher to use": "Selecionar voucher para usar",
  "Use voucher": "Usar voucher",
  "Total": "Total",
  "Transaction Type": "Tipo de Transação",
  "E-Token Topup": "Recarga de E-Token",
  "Credit Topup": "Recarga de Crédito",
  "Credit topup": "Recarga de crédito",
  "Credit Transfer": "Transferência de Crédito",
  "E-Token Transfer": "Transferência de E-Token",
  "Date/Time": "Data/Hora",
  "Reference ID": "ID de Referência",
  "Status": "Status",
  "Share Your Referral Code": "Compartilhe Seu Código de Indicação",
  "cleanproReferralShortDesc_one": "Ganhe {{ voucherAmount }} crédito grátis quando compartilhar seu código de indicação para amigos e familiares após uma transação bem-sucedida. Toque para saber mais.",
  "cleanproReferralShortDesc_other": "Ganhe {{ voucherAmount }} créditos grátis quando compartilhar seu código de indicação para amigos e familiares após uma transação bem-sucedida. Toque para saber mais.",
  "Use": "Usar",
  "dryer or washer": "secadora ou lavadora",
  "washer": "lavadora",
  "dryer": "secadora",
  "dryer and washer": "secadora e lavadora",
  "machine with the minimum spending of": "máquina com o gasto mínimo de",
  "Payment Confirmation": "Confirmação de Pagamento",
  "This campaign is only eligible for users who use the all-new Cleanpro Plus web application.": "Esta campanha é válida apenas para usuários que usam o novo aplicativo web Cleanpro Plus.",
  "ONE e-stamp will be rewarded for each wash or dry cycle.": "UM e-selo será recompensado para cada ciclo de lavagem ou secagem.",
  "ONE e-stamp will be rewarded for each wash cycle.": "UM e-selo será recompensado para cada ciclo de lavagem.",
  "ONE e-stamp will be rewarded for each dry cycle.": "UM e-selo será recompensado para cada ciclo de secagem.",
  "Regardless of the washer or dryer settings, the number of e-stamps being collected is the same.": "Independentemente das configurações da lavadora ou secadora, o número de e-selos sendo coletados é o mesmo.",
  "The type of e-stamp collected is based on the services that you have used.": "O tipo de e-selo coletado é baseado nos serviços que você usou.",
  "Washing service will reward washer e-stamp and drying service will reward dryer e-stamp.": "O serviço de lavagem recompensará com e-selo de lavadora e o serviço de secagem recompensará com e-selo de secadora.",
  "Washing service will reward washer e-stamp.": "O serviço de lavagem recompensará com e-selo de lavadora.",
  "Drying service will reward dryer e-stamp.": "O serviço de secagem recompensará com e-selo de secadora.",
  "E-stamps will automatically be added to your account once the condition has been fulfilled.": "E-selos serão automaticamente adicionados à sua conta uma vez que a condição tenha sido cumprida.",
  "There is no limit on how many e-stamps can be gathered in a single day. So long as you meet the requirements to collect the e-stamps.": "Não há limite para quantos e-selos podem ser coletados em um único dia. Desde que você atenda aos requisitos para coletar os e-selos.",
  "The type of e-stamps that have been collected is final and cannot be changed.": "O tipo de e-selos que foram coletados é final e não pode ser alterado.",
  "There is no expiration for the e-stamps; only till the discontinuation of the campaign.": "Não há expiração para os e-selos; apenas até a descontinuação da campanha.",
  "E-stamps do not have any currency value, and they cannot be converted to cash or credits.": "E-selos não têm nenhum valor monetário, e não podem ser convertidos em dinheiro ou créditos.",
  "This campaign is not applicable with any other ongoing promotions, offers, vouchers, and/or discounts provided by the participating outlets.": "Esta campanha não é aplicável com quaisquer outras promoções em andamento, ofertas, vouchers e/ou descontos fornecidos pelas lojas participantes.",
  "These terms and conditions are subject to change at any time without prior notice.": "Estes termos e condições estão sujeitos a alterações a qualquer momento sem aviso prévio.",
  "Press START on the machine to begin washing.": "Pressione INICIAR na máquina para começar a lavar.",
  "Press START on the machine to begin drying.": "Pressione INICIAR na máquina para começar a secar.",
  "Reminder": "Lembrete",
  "Remember to select the same settings you have paid for on the corresponding machine.": "Lembre-se de selecionar as mesmas configurações que você pagou na máquina correspondente.",
  "Please ensure that your laundry is inside the machine and door is properly shut.": "Por favor, certifique-se de que sua roupa está dentro da máquina e a porta está devidamente fechada.",
  "voucherCreditsOff_one": "{{currentVoucherAmount}} Crédito OFF",
  "voucherCreditsOff_other": "{{currentVoucherAmount}} Créditos OFF",
  "voucherPercentageOff": "{{currentVoucherAmount}}% OFF",
  "cleanproReferralFlatVoucher_one": "Ganhe créditos grátis quando compartilhar seu código de indicação Cleanpro Plus para seus amigos e familiares! Para cada indicação bem-sucedida que completar sua primeira transação, você receberá um voucher de {{ referralVoucherAmount }} crédito grátis.",
  "cleanproReferralFlatVoucher_other": "Ganhe créditos grátis quando compartilhar seu código de indicação Cleanpro Plus para seus amigos e familiares! Para cada indicação bem-sucedida que completar sua primeira transação, você receberá um voucher de {{ referralVoucherAmount }} créditos grátis.",
  "cleanproReferralRateVoucher": "Ganhe créditos grátis quando compartilhar seu código de indicação Cleanpro Plus para seus amigos e familiares! Para cada indicação bem-sucedida que completar sua primeira transação, você receberá um voucher de {{ referralVoucherAmount }}% Off grátis.",
  "cleanproReferralTokenReward_one": "Ganhe créditos grátis quando compartilhar seu código de indicação Cleanpro Plus para seus amigos e familiares! Para cada indicação bem-sucedida que completar sua primeira transação, você receberá {{ referralToken }} crédito grátis.",
  "cleanproReferralTokenReward_other": "Ganhe créditos grátis quando compartilhar seu código de indicação Cleanpro Plus para seus amigos e familiares! Para cada indicação bem-sucedida que completar sua primeira transação, você receberá {{ referralToken }} créditos grátis.",
  "How to get & use code:": "Como obter e usar o código:",
  'Go to menu = icon and click "Refer friends"': 'Vá ao menu = ícone e clique em "Indicar amigos"',
  "Share with everyone who will likely to use Cleanpro Plus.": "Compartilhe com todos que provavelmente usarão o Cleanpro Plus.",
  "Referral Terms & Conditions:": "Termos e Condições de Indicação:",
  "When your friend or family register using your referral code, and completed a transaction (a minimum spending of {{ currency }}{{ referralTransactionAmount }}) , you will be rewarded automatically.": "Quando seu amigo ou familiar se cadastrar usando seu código de indicação e completar uma transação (um gasto mínimo de {{ currency }}{{ referralTransactionAmount }}), você será recompensado automaticamente.",
  "cleanproNumberOfReferralReward": "Você pode compartilhar com quantas pessoas quiser, mas cada usuário só pode receber {{ numberOfReferral }} recompensa de indicação.",
  "cleanproNumberOfReferral_one": "Você pode compartilhar com quantas pessoas quiser, mas cada usuário só pode receber {{ numberOfReferral }} voucher de indicação.",
  "cleanproNumberOfReferral_other": "Você pode compartilhar com quantas pessoas quiser, mas cada usuário só pode receber {{ numberOfReferral }} vouchers de indicação.",
  "The voucher is valid for {{ duration }} days from the day voucher be given._one": "O voucher é válido por {{ duration }} dia a partir do dia em que o voucher for concedido.",
  "The voucher is valid for {{ duration }} days from the day voucher be given._other": "O voucher é válido por {{ duration }} dias a partir do dia em que o voucher for concedido.",
  "The voucher is for customer use only and not for sale.": "O voucher é apenas para uso do cliente e não para venda.",
  "We believe that your special day deserves a little extra sparkle! That's why we're thrilled to introduce our exclusive birthday rewards program just for you! Starting this year, and every year thereafter, we're giving away {{ currency }}{{ voucherAmount }} credit vouchers to you on your birthday.": "Acreditamos que seu dia especial merece um brilho extra! É por isso que estamos entusiasmados em apresentar nosso programa exclusivo de recompensas de aniversário só para você! A partir deste ano, e todos os anos subsequentes, estamos oferecendo vouchers de {{ currency }}{{ voucherAmount }} créditos para você no seu aniversário.",
  "cleanproBirthdayRateAmount": "Acreditamos que seu dia especial merece um brilho extra! É por isso que estamos entusiasmados em apresentar nosso programa exclusivo de recompensas de aniversário só para você! A partir deste ano, e todos os anos subsequentes, estamos oferecendo vouchers de {{ voucherAmount }}% para você no seu aniversário.",
  "Make sure your account details include your birthdate. This way, we'll know exactly when to send you your special birthday surprise.": "Certifique-se de que os detalhes da sua conta incluem sua data de nascimento. Desta forma, saberemos exatamente quando enviar sua surpresa especial de aniversário.",
  "Birthday Voucher Terms & Conditions:": "Termos e Condições do Voucher de Aniversário:",
  "The voucher will be given on the first day of your birthday month.": "O voucher será concedido no primeiro dia do mês do seu aniversário.",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount._one": "Quando você aplicar o voucher durante o pagamento, ele lhe dará {{ voucherAmount }} crédito ({{ currency }}{{ voucherAmount }}) de desconto.",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount._other": "Quando você aplicar o voucher durante o pagamento, ele lhe dará {{ voucherAmount }} créditos ({{ currency }}{{ voucherAmount }}) de desconto.",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }}% discount.": "Quando você aplicar o voucher durante o pagamento, ele lhe dará {{ voucherAmount }}% de desconto.",
  "All vouchers is not valid with other ongoing promotions, discounts and offers.": "Todos os vouchers não são válidos com outras promoções em andamento, descontos e ofertas.",
  "Claim a complimentary wash and dry for every 10 e-stamps collected! We value your loyalty and want to reward you for choosing Cleanpro Plus. Tap to learn more.": "Reivindique uma lavagem e secagem gratuitas a cada 10 e-selos coletados! Valorizamos sua fidelidade e queremos recompensá-lo por escolher o Cleanpro Plus. Toque para saber mais.",
  "cleanproStampFlat_one": "A cada 10 e-selos que você coletar, poderá reivindicar até {{ voucherAmount }} crédito de sessão de lavagem ou secagem gratuita com o Cleanpro Plus. Torne sua rotina de lavanderia não apenas descomplicada, mas também recompensadora.",
  "cleanproStampFlat_other": "A cada 10 e-selos que você coletar, poderá reivindicar até {{ voucherAmount }} créditos de sessão de lavagem ou secagem gratuita com o Cleanpro Plus. Torne sua rotina de lavanderia não apenas descomplicada, mas também recompensadora.",
  "cleanproStampRate": "A cada 10 e-selos que você coletar, poderá reivindicar até {{ voucherAmount }}% de sessão de lavagem ou secagem gratuita com o Cleanpro Plus. Torne sua rotina de lavanderia não apenas descomplicada, mas também recompensadora.",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "Um voucher será instantaneamente adicionado à sua página de Recompensas quando você atingir 10 lavagens. Seu medidor de e-selo será restaurado para zero para a próxima coleção. Reivindique o voucher na página Escanear QR quando fizer sua próxima lavanderia.",
  "A voucher will be instantly added to your Rewards page when you reach 10 drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "Um voucher será instantaneamente adicionado à sua página de Recompensas quando você atingir 10 secagens. Seu medidor de e-selo será restaurado para zero para a próxima coleção. Reivindique o voucher na página Escanear QR quando fizer sua próxima lavanderia.",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes or drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "Um voucher será instantaneamente adicionado à sua página de Recompensas quando você atingir 10 lavagens ou secagens. Seu medidor de e-selo será restaurado para zero para a próxima coleção. Reivindique o voucher na página Escanear QR quando fizer sua próxima lavanderia.",
  "Terms & Conditions:": "Termos e Condições:",
  "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session._one": "Para ganhar UM e-selo, você deve gastar pelo menos {{ stampTransactionAmount }} crédito ({{ currency }}{{ stampTransactionAmount }}) por sessão.",
  "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session._other": "Para ganhar UM e-selo, você deve gastar pelo menos {{ stampTransactionAmount }} créditos ({{ currency }}{{ stampTransactionAmount }}) por sessão.",
  "You will be automatically issued a voucher if you have collected 10 washer stamps.": "Você receberá automaticamente um voucher se tiver coletado 10 selos de lavadora.",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps.": "Você receberá automaticamente um voucher se tiver coletado 10 selos de secadora.",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps or 10 washer stamps.": "Você receberá automaticamente um voucher se tiver coletado 10 selos de secadora ou 10 selos de lavadora.",
  "You will be automatically issued a voucher if you have collected 10 stamps.": "Você receberá automaticamente um voucher se tiver coletado 10 selos.",
  "The voucher is non-refundable and cannot be exchanged for cash; in part or in full.": "O voucher é não reembolsável e não pode ser trocado por dinheiro; em parte ou totalmente.",
  "This voucher is valid for single transaction only.": "Este voucher é válido para uma única transação apenas.",
  "General questions": "Perguntas gerais",
  "E-stamps collection": "Coleção de e-selos",
  "Coin exchange machines": "Máquinas de troca de moedas",
  "Washer machines": "Máquinas de lavar",
  "Dryer machines": "Máquinas de secar",
  "Paywave issues": "Problemas com Paywave",
  "Cleanpro franchise": "Franquia Cleanpro",
  "How can I wash my laundry using Cleanpro Plus?": "Como posso lavar minhas roupas usando o Cleanpro Plus?",
  "Here are the steps to wash your laundry using Cleanpro Plus:": "Aqui estão os passos para lavar suas roupas usando o Cleanpro Plus:",
  "Find an unoccupied washing machine in the store, and insert your laundry in the washer.": "Encontre uma máquina de lavar desocupada na loja e insira suas roupas na lavadora.",
  "Select the desired temperature that you would like to use for your laundry.": "Selecione a temperatura desejada que você gostaria de usar para suas roupas.",
  "Using the scanner in the app, scan the QR code provided on the washing machine. Then select the same settings that you have pressed on the machine.": "Usando o scanner no aplicativo, escaneie o código QR fornecido na máquina de lavar. Em seguida, selecione as mesmas configurações que você pressionou na máquina.",
  'Tap on "Pay with credits" to pay the amount shown on the app.': 'Toque em "Pagar com créditos" para pagar o valor mostrado no aplicativo.',
  "Once the payment has been accepted, press the START button on the washer machine.": "Uma vez que o pagamento tenha sido aceito, pressione o botão INICIAR na máquina de lavar.",
  "After the washing cycle ends, you can just remove your laundry from the machine.": "Após o término do ciclo de lavagem, você pode simplesmente remover suas roupas da máquina.",
  "How can I dry my laundry using Cleanpro Plus?": "Como posso secar minhas roupas usando o Cleanpro Plus?",
  "Here are the steps to dry your laundry using Cleanpro Plus:": "Aqui estão os passos para secar suas roupas usando o Cleanpro Plus:",
  "Find an unoccupied drying machine in the store, and insert your laundry in the dryer.": "Encontre uma máquina de secar desocupada na loja e insira suas roupas na secadora.",
  "Select the desired temperature and duration that you would like to use for your laundry.": "Selecione a temperatura e duração desejadas que você gostaria de usar para suas roupas.",
  "Using the scanner in the app, scan the QR code provided on the drying machine. Then select the same settings that you have pressed on the machine.": "Usando o scanner no aplicativo, escaneie o código QR fornecido na máquina de secar. Em seguida, selecione as mesmas configurações que você pressionou na máquina.",
  "Once the payment has been accepted, press the START button on the dryer machine.": "Uma vez que o pagamento tenha sido aceito, pressione o botão INICIAR na máquina de secar.",
  "After the drying cycle ends, you can just remove your laundry from the machine.": "Após o término do ciclo de secagem, você pode simplesmente remover suas roupas da máquina.",
  "Why does the QR code I scanned take me to a different machine?": "Por que o código QR que escaneei me leva a uma máquina diferente?",
  "Here are the steps to solve it:": "Aqui estão as etapas para resolver isso:",
  "Make sure that the number on the QR code (e.g. W1, W2, etc) is the same as the machine that you would like to use.": "Certifique-se de que o número no código QR (ex: W1, W2, etc) é o mesmo da máquina que você gostaria de usar.",
  "If the QR code number does not match the machine you want, use the other machine. Please contact our customer service line at 03-27700100 to report this issue.": "Se o número do código QR não corresponder à máquina que você deseja, use a outra máquina. Por favor, entre em contato com nossa linha de atendimento ao cliente em 03-27700100 para relatar este problema.",
  "How can I add more time to the washer that I am currently using?": "Como posso adicionar mais tempo à lavadora que estou usando atualmente?",
  "The washing time for our washer is fixed and cannot add any additional time.": "O tempo de lavagem para nossa lavadora é fixo e não pode adicionar nenhum tempo adicional.",
  "How can I add more time to the dryer that I am currently using?": "Como posso adicionar mais tempo à secadora que estou usando atualmente?",
  "Here are the steps to add more time to the dryer machine:": "Aqui estão os passos para adicionar mais tempo à máquina de secar:",
  "By using the scanner in the app, scan the QR code provided at the dryer machine.": "Usando o scanner no aplicativo, escaneie o código QR fornecido na máquina de secar.",
  "Select the amount of time that you would like to add to the machine.": "Selecione a quantidade de tempo que você gostaria de adicionar à máquina.",
  "After the drying cycle ends, you can just remove the clothes from the machine.": "Após o término do ciclo de secagem, você pode simplesmente remover as roupas da máquina.",
  "REMINDER - It is recommended to add drying time 5 minutes before the cycle ends. And you cannot add tokens for extra times when the machine finishes the drying cycle.": "LEMBRETE - É recomendado adicionar tempo de secagem 5 minutos antes do término do ciclo. E você não pode adicionar tokens para tempos extras quando a máquina terminar o ciclo de secagem.",
  "Will the timer keep running when I have stopped the drying machine?": "O temporizador continuará funcionando quando eu parar a máquina de secar?",
  "Yes. Even after you stop the machine, the timer will continue to run. If you want to extend the drying time, add drying time 5 minutes before the cycle ends. This prevents the cycle from ending before your clothes are completely dried.": "Sim. Mesmo depois de parar a máquina, o temporizador continuará a funcionar. Se você quiser estender o tempo de secagem, adicione tempo de secagem 5 minutos antes do término do ciclo. Isso impede que o ciclo termine antes que suas roupas estejam completamente secas.",
  "How do I reload my credits for Cleanpro Plus?": "Como recarrego meus créditos para o Cleanpro Plus?",
  "Here are the steps to reload your credits:": "Aqui estão os passos para recarregar seus créditos:",
  'Select the "Top Up Credit" button on the homepage.': 'Selecione o botão "Recarregar Crédito" na página inicial.',
  "Choose the amount you want to reload and the payment method you want to use.": "Escolha o valor que deseja recarregar e o método de pagamento que deseja usar.",
  "You will be taken to the payment page. The screen will return to Cleanpro Plus once the transaction is completed.": "Você será levado à página de pagamento. A tela retornará ao Cleanpro Plus assim que a transação for concluída.",
  "How many credits can I reload in one transaction?": "Quantos créditos posso recarregar em uma transação?",
  "Reloading credits requires a minimum of RM 10 and a maximum of RM 50.": "Recarregar créditos requer um mínimo de RM 10 e um máximo de RM 50.",
  "Can I pay using credits in the Cleanpro Plus app along with tokens or coins in a single transaction?": "Posso pagar usando créditos no aplicativo Cleanpro Plus junto com tokens ou moedas em uma única transação?",
  "No. Only a single payment method may be chosen when performing any transactions.": "Não. Apenas um único método de pagamento pode ser escolhido ao realizar qualquer transação.",
  "The amount I have reloaded in my account was not reflected in the app.": "O valor que recarreguei na minha conta não foi refletido no aplicativo.",
  "Please close and restart the application and check if the new balance has been updated.": "Por favor, feche e reinicie o aplicativo e verifique se o novo saldo foi atualizado.",
  "If the amount is still not updated, please contact our customer service line at 03-27700110 to receive further assistance.": "Se o valor ainda não estiver atualizado, por favor, entre em contato com nossa linha de atendimento ao cliente em 03-27700110 para receber assistência adicional.",
  "Can I cash out the credits I reloaded in my account for this app?": "Posso sacar os créditos que recarreguei na minha conta para este aplicativo?",
  "No. The credits that you have reloaded will remain in your Cleanpro Plus account.": "Não. Os créditos que você recarregou permanecerão na sua conta Cleanpro Plus.",
  "I have requested a refund, but I still have not received it.": "Solicitei um reembolso, mas ainda não o recebi.",
  "Please contact our customer service line at 03-27700100 to receive further assistance.": "Por favor, entre em contato com nossa linha de atendimento ao cliente em 03-27700100 para receber assistência adicional.",
  "I have made the payment, and the app double or triple charged me.": "Fiz o pagamento, e o aplicativo me cobrou duas ou três vezes.",
  "The washing machine cannot start even after I have paid using the app.": "A máquina de lavar não pode iniciar mesmo depois de eu ter pago usando o aplicativo.",
  "Ensure that the temperature settings you have selected and paid for on the application are the same as what you have pressed on the washing machine. If not, select the correct temperature settings on the washing machine and try again.": "Certifique-se de que as configurações de temperatura que você selecionou e pagou no aplicativo são as mesmas que pressionou na máquina de lavar. Caso contrário, selecione as configurações de temperatura corretas na máquina de lavar e tente novamente.",
  "If the machine is still not able to be started, please contact our customer service line at 03-27700100 to receive further assistance.": "Se a máquina ainda não puder ser iniciada, por favor, entre em contato com nossa linha de atendimento ao cliente em 03-27700100 para receber assistência adicional.",
  "Can I use multiple vouchers together in the same washing or drying cycle?": "Posso usar vários vouchers juntos no mesmo ciclo de lavagem ou secagem?",
  "No. Only a single voucher can be used for each washing and drying cycle.": "Não. Apenas um único voucher pode ser usado para cada ciclo de lavagem e secagem.",
  "Why can't I use my free wash voucher that I received after signing up?": "Por que não posso usar meu voucher de lavagem gratuita que recebi após me cadastrar?",
  "To redeem or use the voucher, you must complete at least one washing or drying cycle.": "Para resgatar ou usar o voucher, você deve completar pelo menos um ciclo de lavagem ou secagem.",
  "Can I change my phone number even after registering my account?": "Posso alterar meu número de telefone mesmo após cadastrar minha conta?",
  "No. Once registered to an account, the phone number is locked into the account.": "Não. Uma vez registrado em uma conta, o número de telefone fica bloqueado na conta.",
  "I have problems in the store, and who can I refer to for help?": "Tenho problemas na loja, a quem posso recorrer para obter ajuda?",
  "Do not worry, as you can contact our customer service line at 03-27700100 to receive assistance at any time.": "Não se preocupe, pois pode contactar a nossa linha de apoio ao cliente através do 03-27700100 para receber assistência a qualquer momento.",
  "Should I add my own laundry detergent and softeners to the washing machine?": "Devo adicionar o meu próprio detergente e amaciador à máquina de lavar?",
  "There is no need for that, as all you have to do is bring your dirty clothes and put them in the washer. The detergent and softeners will be provided by us, and you can rest assured that the laundry detergents we used are certified industrial grade.": "Não há necessidade disso, pois tudo o que tem de fazer é trazer a sua roupa suja e colocá-la na máquina. O detergente e amaciadores serão fornecidos por nós, e pode ficar descansado que os detergentes que utilizamos são de qualidade industrial certificada.",
  "I would like to add my own laundry detergent and softener to the washing machine.": "Gostaria de adicionar o meu próprio detergente e amaciador à máquina de lavar.",
  "We do not recommend our customers add their own detergent, as the mixture of different detergents may affect the wash quality. And you can rest assured that the laundry detergent we used is certified industrial grade.": "Não recomendamos aos nossos clientes que adicionem o seu próprio detergente, pois a mistura de diferentes detergentes pode afetar a qualidade da lavagem. E pode ficar descansado que o detergente que utilizamos é de qualidade industrial certificada.",
  "What time does the store close?": "A que horas fecha a loja?",
  "Our self-service laundry operation is open 24 hours a day, which means you can always be sure to go back home with a fresh set of laundry.": "A nossa lavandaria self-service está aberta 24 horas por dia, o que significa que pode sempre ter a certeza de voltar para casa com um conjunto de roupa fresca.",
  "Are you open on weekends?": "Estão abertos aos fins de semana?",
  "Yes. Cleanpro is also open on weekends and even on public holidays.": "Sim. A Cleanpro também está aberta aos fins de semana e mesmo em feriados.",
  "How many clothes can I fit in the washing or drying machine?": "Quantas roupas posso colocar na máquina de lavar ou secar?",
  "To ensure that your laundry is properly washed or dried, keep the amount of laundry inside the machine lower than the line of guide sticker on the machine.": "Para garantir que a sua roupa é devidamente lavada ou seca, mantenha a quantidade de roupa dentro da máquina abaixo da linha do adesivo de orientação na máquina.",
  "How many e-stamps can I collect in a single day?": "Quantos e-selos posso colecionar num único dia?",
  "There is no limit to the amount of stamps that can be collected in a single day; ONE stamp will be awarded with every wash or dry.": "Não há limite para a quantidade de selos que podem ser colecionados num único dia; UM selo será atribuído a cada lavagem ou secagem.",
  "When I use the washing service, can I change the collected stamp to a dryer stamp, and vice versa?": "Quando utilizo o serviço de lavagem, posso mudar o selo colecionado para um selo de secagem, e vice-versa?",
  "No, the type of stamp collected is only applied to the service that you have used.": "Não, o tipo de selo colecionado só é aplicado ao serviço que utilizou.",
  "What temperatures can I choose when I claim the free washing e-stamp reward?": "Que temperaturas posso escolher quando reivindico a recompensa gratuita de e-selo de lavagem?",
  "Any washing temperature is available for the e-stamp reward.": "Qualquer temperatura de lavagem está disponível para a recompensa de e-selo.",
  "What temperatures can I choose when I claim the free drying e-stamp reward? And how long can I set the time?": "Que temperaturas posso escolher quando reivindico a recompensa gratuita de e-selo de secagem? E por quanto tempo posso definir o tempo?",
  "Any drying temperature and duration can be selected for the e-stamp reward.": "Qualquer temperatura e duração de secagem podem ser selecionadas para a recompensa de e-selo.",
  "I'm unable to change the coin.": "Não consigo trocar a moeda.",
  "What colour is the light shown on the machine, red or green? If it is a red light, please contact our customer service line at 03-27700100 to receive further assistance.": "Qual é a cor da luz mostrada na máquina, vermelha ou verde? Se for uma luz vermelha, por favor contacte a nossa linha de apoio ao cliente através do 03-27700100 para receber assistência adicional.",
  "Green Light": "Luz Verde",
  "Red Light": "Luz Vermelha",
  "Machine functions as normal. Please try again.": "A máquina funciona normalmente. Por favor, tente novamente.",
  "(flashing 2x) - There are no coins/tokens in the machine.": "(piscando 2x) - Não há moedas/fichas na máquina.",
  "OR": "OU",
  "Note is jammed, please proceed to contact customer service": "A nota está presa, por favor proceda ao contacto com o serviço de apoio ao cliente",
  "(flashing 3x) - Note is jammed, please proceed to contact customer service": "(piscando 3x) - A nota está presa, por favor proceda ao contacto com o serviço de apoio ao cliente",
  "My notes are stuck in the machine.": "As minhas notas estão presas na máquina.",
  "My detergent is not dispensing in the vending machine.": "O meu detergente não está a ser dispensado na máquina de venda automática.",
  "The water is leaking out of the washing machine.": "A água está a sair da máquina de lavar.",
  "Please check the washer machine to see whether there are any clothes that are stuck at the door side.": "Por favor, verifique a máquina de lavar para ver se existe alguma roupa presa na porta.",
  "If yes, here are the steps to solve it:": "Se sim, aqui estão os passos para resolver:",
  "Press the emergency stop button (RED Button) for 3 seconds.": "Prima o botão de paragem de emergência (Botão VERMELHO) durante 3 segundos.",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at 03-27700100 to receive further assistance)": "Aguarde que o som pare, e só depois abra a porta. (Se após 30 minutos o som ainda não parou, por favor contacte a nossa linha de apoio ao cliente através do 03-27700100 para receber assistência adicional)",
  "Ensure the door is closed tightly, and press the START button.": "Certifique-se de que a porta está bem fechada e prima o botão START.",
  "REMINDER - The emergency stop button can only be used once.": "LEMBRETE - O botão de paragem de emergência só pode ser utilizado uma vez.",
  "There is no detergent dispensing in the washing machine.": "Não há dispensador de detergente na máquina de lavar.",
  "Ensure that the machine is in operation and that the START button was pressed.": "Certifique-se de que a máquina está em funcionamento e que o botão START foi pressionado.",
  "If the detergent is still not dispensing, please contact our customer service department at 03-27700100 for further assistance.": "Se o detergente ainda não estiver a ser dispensado, por favor contacte o nosso departamento de apoio ao cliente através do 03-27700100 para obter assistência adicional.",
  "The price displayed on the machine's screen did not change after inserting the token.": "O preço exibido no ecrã da máquina não mudou após inserir a ficha.",
  "Press the small button (in the centre) to reject the tokens that have been inserted. Press a few times till the coins come out.": "Prima o pequeno botão (no centro) para rejeitar as fichas que foram inseridas. Prima algumas vezes até as moedas saírem.",
  "If the coins still cannot come out or the button is not functioning, please contact our customer service line at 03-27700110 to receive further assistance.": "Se as moedas ainda não conseguirem sair ou o botão não estiver a funcionar, por favor contacte a nossa linha de apoio ao cliente através do 03-27700110 para receber assistência adicional.",
  "The machine is not starting, and it displays an error code.": "A máquina não está a iniciar e exibe um código de erro.",
  "We would like to apologise for any inconvenience caused. Please contact our customer service line at 03-27700100 to receive further assistance.": "Gostaríamos de pedir desculpa por qualquer inconveniente causado. Por favor, contacte a nossa linha de apoio ao cliente através do 03-27700100 para receber assistência adicional.",
  "I want to wash the clothes again, but why couldn't the machine start even after I added tokens to the machine?": "Quero lavar a roupa novamente, mas por que razão a máquina não conseguiu iniciar mesmo depois de ter adicionado fichas à máquina?",
  "Try opening and closing the door again before starting the machine.": "Tente abrir e fechar a porta novamente antes de iniciar a máquina.",
  "Can I change the water temperature of the machine?": "Posso mudar a temperatura da água da máquina?",
  "Yes, but the washer temperature can only be changed from hot to cold after the machine has been started, and not from cold to hot.": "Sim, mas a temperatura da máquina de lavar só pode ser alterada de quente para fria depois de a máquina ter sido iniciada, e não de fria para quente.",
  "Can I stop the machine?": "Posso parar a máquina?",
  "Here are the steps to stop the machine:": "Aqui estão os passos para parar a máquina:",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at to receive further assistance)": "Aguarde que o som pare e só depois abra a porta. (Se após 30 minutos o som ainda não parou, por favor contacte a nossa linha de apoio ao cliente para receber assistência adicional)",
  "There is no water supply on the machine used.": "Não há fornecimento de água na máquina utilizada.",
  "Why is the washing temperature cold even when I have selected HOT.": "Por que razão a temperatura de lavagem está fria mesmo quando selecionei QUENTE.",
  "The water temperature is HOT or WARM only during washing. The water will turn COLD during rinsing.": "A temperatura da água é QUENTE ou MORNA apenas durante a lavagem. A água ficará FRIA durante o enxaguamento.",
  "The machine has already finished washing, but it does not spin well, and there is water left on the load.": "A máquina já terminou a lavagem, mas não centrifuga bem e há água restante na carga.",
  "Can I put wet laundry into the dryer to dry?": "Posso colocar roupa molhada na secadora para secar?",
  "No, as the dripping wet laundry might cause the dryer to short circuit.": "Não, pois a roupa a pingar pode causar um curto-circuito na secadora.",
  "REMINDER - Refer to the labels on your clothes to know what kind of temperature is best for the kind of fabric that it uses. Then select the temperature on the machine accordingly.": "LEMBRETE - Consulte as etiquetas nas suas roupas para saber que tipo de temperatura é melhor para o tipo de tecido que utiliza. Em seguida, selecione a temperatura na máquina de acordo.",
  "My clothes are still wet even after drying.": "A minha roupa ainda está molhada mesmo após a secagem.",
  "How can I stop the dryer when the machine is still running?": "Como posso parar a secadora quando a máquina ainda está a funcionar?",
  "Just open the door and the machine will automatically stop.": "Basta abrir a porta e a máquina parará automaticamente.",
  "I added extra tokens for extra times, but the machine did not update the time.": "Adicionei fichas extras para tempos extras, mas a máquina não atualizou o tempo.",
  "For the time to be reflected accurately, it is recommended for you to add tokens 5 minutes before the services end.": "Para que o tempo seja refletido com precisão, é recomendável adicionar fichas 5 minutos antes do término dos serviços.",
  "REMINDER - You cannot add tokens for extra times when the machine finishes the drying cycle.": "LEMBRETE - Não é possível adicionar fichas para tempos extras quando a máquina termina o ciclo de secagem.",
  "Why is the machine making noise?": "Por que razão a máquina está a fazer barulho?",
  "Please check the drum to see if there are any coins or other small things inside.": "Por favor, verifique o tambor para ver se há moedas ou outros pequenos objetos dentro.",
  "I have pressed the START button on the dryer, but it is still not working.": "Pressionei o botão START na secadora, mas ainda não está a funcionar.",
  "Please try to open the door and close it again. Next, press the START button again to start drying.": "Por favor, tente abrir a porta e fechá-la novamente. Em seguida, pressione o botão START novamente para iniciar a secagem.",
  "If the dryer is still not functioning, please contact our customer service line at 03-27700100 to receive further assistance.": "Se a secadora ainda não estiver funcionando, entre em contato com nossa linha de atendimento ao cliente pelo 03-27700100 para receber assistência adicional.",
  "Paywave has deducted an amount from the card but the machine did not reflect the transaction.": "O Paywave deduziu um valor do cartão, mas a máquina não refletiu a transação.",
  "The Paywave transaction has failed but the amount has still been deducted from my card.": "A transação do Paywave falhou, mas o valor ainda foi debitado do meu cartão.",
  "Paywave has double/triple charge but the machine cannot start.": "O Paywave fez cobrança dupla/tripla, mas a máquina não pode iniciar.",
  "Paywave after double/triple charge machines can't start.": "Paywave após cobrança dupla/tripla, as máquinas não podem iniciar.",
  "Paywave is offline": "Paywave está offline",
  "Do Cleanpro Express offer franchise business/selling machines/laundry products?": "A Cleanpro Express oferece negócios de franquia/venda de máquinas/produtos de lavanderia?",
  "For further inquiries, please email to info@cleanproexpress.com": "Para mais informações, por favor envie um e-mail para info@cleanproexpress.com",
  "Step 6": "Passo 6",
  "User Existed": "Usuário Existente",
  "This email is registered": "Este e-mail está registrado",
  "This phone number is registered": "Este número de telefone está registrado",
  "Invalid Email Address": "Endereço de E-mail Inválido",
  "Let's get started!": "Vamos começar!",
  "Enter your e-mail/mobile number": "Digite seu e-mail/número de celular",
  "Enter your e-mail": "Digite seu e-mail",
  "Enter your mobile number": "Digite seu número de celular",
  "Enter your e-mail address": "Digite seu endereço de e-mail",
  "Proceed": "Prosseguir",
  "Enter OTP number": "Digite o número OTP",
  "You will receive a six-digit OTP via SMS sent to": "Você receberá um OTP de seis dígitos via SMS enviado para",
  "You will receive a six-digit OTP via e-mail sent to": "Você receberá um OTP de seis dígitos via e-mail enviado para",
  "Verify": "Verificar",
  "Resend OTP": "Reenviar OTP",
  "Welcome onboard!": "Bem-vindo a bordo!",
  "Please fill in the info below": "Por favor, preencha as informações abaixo",
  "Enter your name*": "Digite seu nome*",
  "Enter your email address*": "Digite seu endereço de e-mail*",
  "Please enter either phone number or email address": "Por favor, digite o número de telefone ou endereço de e-mail",
  "Create a password*": "Crie uma senha*",
  "Enter referral code (if got any)": "Digite o código de indicação (se tiver algum)",
  "Get started": "Começar",
  "Birthday updated successfully": "Aniversário atualizado com sucesso",
  "Date of birth": "Data de nascimento",
  "Enter your date of birth": "Digite sua data de nascimento",
  "Select your birth date": "Selecione sua data de nascimento",
  "Update date of birth": "Atualizar data de nascimento",
  "Update birth date": "Atualizar data de nascimento",
  "Already have an account?": "Já tem uma conta?",
  "Login now": "Entrar agora",
  "Sign in": "Entrar",
  "Sign up now": "Inscreva-se agora",
  "COMPLETED": "CONCLUÍDO",
  "WASHING NOW": "LAVANDO AGORA",
  "DRYING NOW": "SECANDO AGORA",
  "It's done!": "Está pronto!",
  "Please collect your fresh, clean laundry in order to leave the machine available for the next person to use!": "Por favor, recolha sua roupa limpa e fresca para deixar a máquina disponível para a próxima pessoa usar!",
  "Leave a feedback": "Deixe um comentário",
  "Time left": "Tempo restante",
  "Add drying time": "Adicionar tempo de secagem",
  "Hi": "Olá",
  "customer": "cliente",
  "Thank you for your payment. Don't forget to select the <b>correct temperature</b> and press <b>START</b> when you're ready.": "Obrigado pelo seu pagamento. Não se esqueça de selecionar a <b>temperatura correta</b> e pressionar <b>INICIAR</b> quando estiver pronto.",
  "Select how you want to receive a notification when your laundry is finished": "Selecione como deseja receber uma notificação quando sua lavagem estiver concluída",
  "Sign up": "Inscrever-se",
  "Continue to pay": "Continuar para pagar",
  "Register as a member to enjoy more benefits!": "Registre-se como membro para desfrutar de mais benefícios!",
  "Get FREE {{ voucherAmount }} credits per new user_one": "Ganhe {{ voucherAmount }} crédito GRÁTIS por novo usuário",
  "Get FREE {{ voucherAmount }} credits per new user_other": "Ganhe {{ voucherAmount }} créditos GRÁTIS por novo usuário",
  "Get FREE {{ voucherAmount }}% per new user": "Ganhe {{ voucherAmount }}% GRÁTIS por novo usuário",
  "Enjoy exclusive promotions": "Desfrute de promoções exclusivas",
  "FREE voucher on your birthday": "Voucher GRÁTIS no seu aniversário",
  "and more": "e mais",
  "Denied camera access": "Acesso à câmera negado",
  'Permission to access the camera has been denied. Please try again and click "Allow" to scan the QR code.': 'A permissão para acessar a câmera foi negada. Por favor, tente novamente e clique em "Permitir" para escanear o código QR.',
  "Okay": "Ok",
  "Oops. You don't have enough balance to make the payment": "Ops. Você não tem saldo suficiente para fazer o pagamento",
  "Please confirm": "Por favor confirme",
  "Do you want to proceed with this feedback?": "Deseja prosseguir com este feedback?",
  "Are you sure to purchase": "Tem certeza que deseja comprar",
  "credits for": "créditos por",
  "Topup credit": "Recarga de crédito",
  "Extended duration will be instantly reflected on machine after payment": "A duração estendida será instantaneamente refletida na máquina após o pagamento",
  "Machine is currently busy": "A máquina está ocupada no momento",
  "Do you want to extend drying time?": "Deseja estender o tempo de secagem?",
  "OTHER": "OUTRO",
  "Welcome Voucher": "Voucher de Boas-vindas",
  "Welcome to the Cleanpro Plus family! This first gift is just the beginning. Stay tuned for a series of exciting promotions and campaigns, exclusively for Cleanpro Plus users.": "Bem-vindo à família Cleanpro Plus! Este primeiro presente é apenas o começo. Fique atento para uma série de promoções e campanhas empolgantes, exclusivamente para usuários do Cleanpro Plus.",
  "Terms & Conditions": "Termos e Condições",
  "TERMS AND CONDITIONS": "TERMOS E CONDIÇÕES",
  "Welcome Voucher is valid for one-time use only.": "O Voucher de Boas-vindas é válido para uso único.",
  "There is no minimum spend required for the voucher to be used.": "Não há gasto mínimo necessário para o uso do voucher.",
  "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only._one": "O Voucher de Boas-vindas é creditado automaticamente na conta do usuário no momento do registro no Cleanpro Plus e válido por apenas {{ duration }} dia.",
  "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only._other": "O Voucher de Boas-vindas é creditado automaticamente na conta do usuário no momento do registro no Cleanpro Plus e válido por apenas {{ duration }} dias.",
  "Users are eligible to use their Welcome Voucher AFTER the completion of their first wash or dry cycle using the same Cleanpro Plus account.": "Os usuários estão qualificados para usar seu Voucher de Boas-vindas APÓS a conclusão do primeiro ciclo de lavagem ou secagem usando a mesma conta Cleanpro Plus.",
  "Welcome Voucher cannot be used together with any ongoing promotions or any other promotional vouchers.": "O Voucher de Boas-vindas não pode ser usado juntamente com promoções em andamento ou quaisquer outros vouchers promocionais.",
  "The voucher is final and cannot be refunded in form of cash or credit to the user.": "O voucher é final e não pode ser reembolsado na forma de dinheiro ou crédito para o usuário.",
  "Cleanpro reserves the right to change the terms and conditions without prior notice.": "A Cleanpro reserva-se o direito de alterar os termos e condições sem aviso prévio.",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})_one": "Colete 10 e-selos para ganhar {{ voucherAmount }} crédito GRÁTIS (no valor de {{ currency }}{{ voucherAmount }})",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})_other": "Colete 10 e-selos para ganhar {{ voucherAmount }} créditos GRÁTIS (no valor de {{ currency }}{{ voucherAmount }})",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }}% voucher (worth {{ voucherAmount }}%)": "Colete 10 e-selos para ganhar voucher de {{ voucherAmount }}% GRÁTIS (no valor de {{ voucherAmount }}%)",
  "Collect 10 e-Stamp to earn FREE Voucher": "Colete 10 e-Selos para ganhar Voucher GRÁTIS",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding._one": "A cada 10 e-selos que você coletar, será recompensado com um voucher de {{ voucherAmount }} crédito GRÁTIS (no valor de {{ currency }}{{ voucherAmount }}). Torne sua rotina de lavanderia não apenas sem complicações, mas também gratificante.",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding._other": "A cada 10 e-selos que você coletar, será recompensado com um voucher de {{ voucherAmount }} créditos GRÁTIS (no valor de {{ currency }}{{ voucherAmount }}). Torne sua rotina de lavanderia não apenas sem complicações, mas também gratificante.",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }}% credits voucher (worth {{ voucherAmount }}%). Make your laundry routine not just hassle-free, but also rewarding.": "A cada 10 e-selos que você coletar, será recompensado com um voucher de {{ voucherAmount }}% de créditos GRÁTIS (no valor de {{ voucherAmount }}%). Torne sua rotina de lavanderia não apenas sem complicações, mas também gratificante.",
  "RM10 OFF Welcome Voucher": "Voucher de Boas-vindas com RM10 DE DESCONTO",
  "Welcome to the Cleanpro family, here is an appreciation voucher from us. Thank you for attending the COPE Investors Conference.": "Bem-vindo à família Cleanpro, aqui está um voucher de agradecimento da nossa parte. Obrigado por participar da Conferência de Investidores COPE.",
  "Welcome Voucher | COPE Investors Conference": "Voucher de Boas-vindas | Conferência de Investidores COPE",
  "Payment methods": "Métodos de pagamento",
  "Tap to proceed with your preferred mode of payment": "Toque para prosseguir com seu modo de pagamento preferido",
  "Cleanpro Plus credits": "Créditos Cleanpro Plus",
  "E-wallet or credit/debit cards": "E-wallet ou cartões de crédito/débito",
  "Go to homepage": "Ir para a página inicial",
  // backend response or error
  "Admin is unauthorized to login": "Administrador não está autorizado a fazer login",
  "Internal Error": "Erro Interno",
  "Please enter the correct credentials": "Por favor, insira as credenciais corretas",
  "Operator not found": "Operador não encontrado",
  "Admin not found": "Administrador não encontrado",
  "Distributor not found": "Distribuidor não encontrado",
  "Client not found": "Cliente não encontrado",
  "Outlet not found": "Filial não encontrada",
  "Token Package not found": "Pacote de tokens não encontrado",
  "Top up history not found": "Histórico de recarga não encontrado",
  "Voucher not found": "Voucher não encontrado",
  "Faq not found": "FAQ não encontrada",
  "Faq Group not found": "Grupo de FAQ não encontrado",
  "News not found": "Notícias não encontradas",
  "Transaction not found": "Transação não encontrada",
  "Please Login Again": "Por favor, faça login novamente",
  "Decoding Error": "Erro de decodificação",
  "Some error occured, please contact the dev team if this error continues.": "Ocorreu algum erro, entre em contato com a equipe de desenvolvimento se este erro continuar.",
  "Please fill in all the required fields": "Por favor, preencha todos os campos obrigatórios",
  "Only success transaction can be refund": "Apenas transações bem-sucedidas podem ser reembolsadas",
  "Only token payment method can be refund": "Apenas método de pagamento por token pode ser reembolsado",
  "The discount code has been used, please change to other code": "O código de desconto já foi usado, por favor, altere para outro código",
  "Cannot use ewallet in sandbox": "Não é possível usar e-wallet no sandbox",
  "Please close the door to proceed your payment": "Por favor, feche a porta para prosseguir com seu pagamento",
  "Under Maintenance": "Em manutenção",
  "This machine is being fixed. Please use another machine.": "Esta máquina está sendo consertada. Por favor, use outra máquina.",
  "Machine is currently running, please try again later": "A máquina está em funcionamento no momento, tente novamente mais tarde",
  "Machine is currently offline, please try again later": "A máquina está offline no momento, tente novamente mais tarde",
  "Outlet not participating in Loyalty program": "Filial não participante do programa de Fidelidade",
  "Please log in to make the payment": "Por favor, faça login para efetuar o pagamento",
  "Package not found, please refresh and try again": "Pacote não encontrado, por favor, atualize e tente novamente",
  "You have reached the maximum number of purchase": "Você atingiu o número máximo de compras",
  "Store not found, please try again later": "Loja não encontrada, por favor, tente novamente mais tarde",
  "Incorrect Password": "Senha incorreta",
  "Token already top up": "Token já recarregado",
  "Payment failed": "Pagamento falhou",
  "Transaction Failure": "Falha na transação",
  "Transaction Refunded": "Transação reembolsada",
  "Transaction Pending": "Transação pendente",
  "Please enter your mobile number": "Por favor, digite seu número de celular",
  "User is unauthorized to register": "Usuário não está autorizado a se registrar",
  "Please proceed to sign up": "Por favor, prossiga para se inscrever",
  "OTP expired, please request a new OTP": "OTP expirado, por favor solicite um novo OTP",
  "Incorrect verification code": "Código de verificação incorreto",
  "This referrer ID is not valid": "Este ID de referência não é válido",
  "This referrer ID is different operator": "Este ID de referência é de um operador diferente",
  "This referrer ID is exceed the limit": "Este ID de referência excedeu o limite",
  "User is unauthorized to login": "Usuário não está autorizado a fazer login",
  "Click here to register": "Clique aqui para se registrar",
  "User is unauthorized to login. Please contact the admin": "Usuário não está autorizado a fazer login. Por favor, entre em contato com o administrador",
  "User is unauthorized": "Usuário não autorizado",
  "This outlet does not participate in the Loyalty Program": "Esta filial não participa do Programa de Fidelidade",
  "This outlet is not belongs to the operator": "Esta filial não pertence ao operador",
  "Processing request": "Processando solicitação",
  "This user is not verified": "Este usuário não está verificado",
  "Insufficient token to make payment": "Token insuficiente para fazer pagamento",
  "Insufficient token to transfer": "Token insuficiente para transferir",
  "Insufficient point to make payment": "Pontos insuficientes para fazer pagamento",
  "This voucher is not available for use": "Este voucher não está disponível para uso",
  "This voucher is belongs to other user": "Este voucher pertence a outro usuário",
  "Invalid Discount Code": "Código de desconto inválido",
  "This discount code cannot use in this outlet": "Este código de desconto não pode ser usado nesta filial",
  "This discount code was expired": "Este código de desconto expirou",
  "This discount code cannot use in washer machine transaction": "Este código de desconto não pode ser usado em transações de máquina de lavar",
  "This discount code cannot use in dryer machine transaction": "Este código de desconto não pode ser usado em transações de máquina de secar",
  "This discount code was fully redeemed today, try again tomorrow": "Este código de desconto foi totalmente resgatado hoje, tente novamente amanhã",
  "You have fully redeemed this discount code": "Você resgatou completamente este código de desconto",
  "This discount code have been redeemed": "Este código de desconto foi resgatado",
  "This discount code is not applicable": "Este código de desconto não é aplicável",
  "Insufficient stamp": "Selo insuficiente",
  "Please provide at least one voucher setting": "Por favor, forneça pelo menos uma configuração de voucher",
  "Previous batch are still generating, please try again later": "O lote anterior ainda está em geração, por favor, tente novamente mais tarde",
  "Number of voucher code should be more than 0": "O número de códigos de voucher deve ser maior que 0",
  "Number of voucher code should be less than 50000": "O número de códigos de voucher deve ser menor que 50000",
  "Number of discount code should be more than 0": "O número de códigos de desconto deve ser maior que 0",
  "Number of discount code should be less than 50000": "O número de códigos de desconto deve ser menor que 50000",
  "No Item": "Sem itens",
  "Please add item": "Por favor, adicione um item",
  "Staff not found": "Funcionário não encontrado",
  "This task already completed": "Esta tarefa já foi concluída",
  "Please complete the wash task first": "Por favor, complete a tarefa de lavagem primeiro",
  "Please complete the dry task first": "Por favor, complete a tarefa de secagem primeiro",
  "Please select at least one outlet": "Por favor, selecione pelo menos uma filial",
  "Touch to Start": "Toque para iniciar",
  "New Users": "Novos Usuários",
  "Get {{ voucher_amount }} FREE Credits!": "Ganhe {{ voucher_amount }} Créditos GRÁTIS!",
  "Get {{ voucher_amount }}% FREE!": "Ganhe {{ voucher_amount }}% GRÁTIS!",
  "Load your clothes into the washing machine & note the machine number": "Carregue suas roupas na máquina de lavar e anote o número da máquina",
  "T&C Apply": "Aplicam-se T&C",
  "Mobile Number": "Número de Celular",
  "Member": "Membro",
  "Please enter your mobile phone number / e-mail": "Por favor, digite seu número de celular / e-mail",
  "Please verify your number": "Por favor, verifique seu número",
  "Please verify your e-mail": "Por favor, verifique seu e-mail",
  "Please enter the correct phone number format. Example: 01xxxxxxxx": "Por favor, insira o formato correto de número de telefone. Exemplo: 01xxxxxxxx",
  "Please enter the correct phone number format. Example: 09xxxxxxxx": "Por favor, insira o formato correto de número de telefone. Exemplo: 09xxxxxxxx",
  "Scan QR to Complete your signup & access more benefits!": "Escaneie o QR para completar seu cadastro e acessar mais benefícios!",
  "Please choose your service": "Por favor, escolha seu serviço",
  "WASHER": "LAVADORA",
  "DRYER": "SECADORA",
  "VENDING MACHINE": "MÁQUINA DE VENDA",
  "Please tap your card on the reader": "Por favor, toque seu cartão no leitor",
  "Payment Option": "Opção de Pagamento",
  "Thank you for payment!": "Obrigado pelo pagamento!",
  "Please select your items at the vending machine": "Por favor, selecione seus itens na máquina de venda",
  "Please choose the temperature on the machine and press": "Por favor, escolha a temperatura na máquina e pressione",
  "START": "INICIAR",
  "Need Help?": "Precisa de ajuda?",
  "Please choose the temperature": "Por favor, escolha a temperatura",
  "Confirm Payment": "Confirmar Pagamento",
  "Select the time for": "Selecione o tempo para",
  "Do you want to add drying time?": "Deseja adicionar tempo de secagem?",
  "minutes": "minutos",
  "Your machine is": "Sua máquina é",
  "Please Collect your item from the vending machine": "Por favor, colete seu item da máquina de venda",
  "You've earned 1 e-stamp for your wash!": "Você ganhou 1 e-selo pela sua lavagem!",
  "You've earned 1 e-stamp for your dry!": "Você ganhou 1 e-selo pela sua secagem!",
  "You've missed 1 e-stamp for your wash!": "Você perdeu 1 e-selo pela sua lavagem!",
  "You've missed 1 e-stamp for your dry!": "Você perdeu 1 e-selo pela sua secagem!",
  "Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "Colete 10 e-selos de Lavagem para ganhar voucher de {{ amount }} créditos GRÁTIS.",
  "Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "Colete 10 e-selos de Lavagem para ganhar um voucher de {{ amount }}%.",
  "Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "Colete 10 e-selos de Secagem para ganhar voucher de {{ amount }} créditos GRÁTIS.",
  "Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "Colete 10 e-selos de Secagem para ganhar um voucher de {{ amount }}%.",
  "Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "Colete 10 e-selos de Lavagem e Secagem para ganhar voucher de {{ amount }} créditos GRÁTIS.",
  "Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "Colete 10 e-selos de Lavagem e Secagem para ganhar um voucher de {{ amount }}%.",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "Inscreva-se e colete 10 e-selos de Lavagem e Secagem para ganhar voucher de {{ amount }} créditos GRÁTIS.",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "Inscreva-se e colete 10 e-selos de Lavagem e Secagem para ganhar um voucher de {{ amount }}%.",
  "Sign Up & Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "Inscreva-se e colete 10 e-selos de Lavagem para ganhar voucher de {{ amount }} créditos GRÁTIS.",
  "Sign Up & Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "Inscreva-se e colete 10 e-selos de Lavagem para ganhar um voucher de {{ amount }}%.",
  "Sign Up & Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "Inscreva-se e colete 10 e-selos de Secagem para ganhar voucher de {{ amount }} créditos GRÁTIS.",
  "Sign Up & Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "Inscreva-se e colete 10 e-selos de Secagem para ganhar um voucher de {{ amount }}%.",
  'For iOS users, press and hold the image, then choose "Add to Photos" or "Save in Photos" from the menu.': 'Para usuários de iOS, pressione e segure a imagem, depois escolha "Adicionar às Fotos" ou "Salvar nas Fotos" no menu.',
  "Scan the QR code to pay": "Escaneie o código QR para pagar",
  "QR Code expires in {{ countdown }} seconds": "Código QR expira em {{ countdown }} segundos",
  "Transfer In": "Transferência de Entrada",
  "Migrate": "Migrar",
  "Update": "Atualizar",
  "Transfer Out": "Transferência de Saída",
  "Total In": "Total de Entrada",
  "Total Out": "Total de Saída",
  "Laundry Pass": "Passe de Lavanderia",
  "Number of wash": "Número de lavagens",
  "Number of Wash": "Número de Lavagens",
  "Number of dry": "Número de secagens",
  "Number of Dry": "Número de Secagens",
  "Laundry Pass Purchase": "Compra de Passe de Lavanderia",
  "Laundry Pass Purchase Report": "Relatório de Compra de Passe de Lavanderia",
  "Please select distributor or operator": "Por favor, selecione distribuidor ou operador",
  "Price should be more than 0": "O preço deve ser maior que 0",
  "Number of wash or dry should be more than 0": "O número de lavagens ou secagens deve ser maior que 0",
  "Number of wash should be more than 0": "O número de lavagens deve ser maior que 0",
  "Number of dry should be more than 0": "O número de secagens deve ser maior que 0",
  "Duration must be more than 0": "A duração deve ser maior que 0",
  "Please fill in the name": "Por favor, preencha o nome",
  "Purchase Start Date": "Data de Início da Compra",
  "Purchase End Date": "Data de Término da Compra",
  "Number of Maximum Purchase": "Número Máximo de Compras",
  "Create Laundry Pass": "Criar Passe de Lavanderia",
  "Select Purchase Period": "Selecionar Período de Compra",
  "If ticked, the Laundry Pass will have expired date": "Se marcado, o Passe de Lavanderia terá data de validade",
  "Laundry Pass Lifespan": "Vida Útil do Passe de Lavanderia",
  "Edit Laundry Pass": "Editar Passe de Lavanderia",
  "Washer Used Date": "Data de Uso da Lavadora",
  "Dryer Used Date": "Data de Uso da Secadora",
  "Laundry Pass Purchase History": "Histórico de Compra de Passe de Lavanderia",
  "Laundry Pass Usage Report": "Relatório de Uso de Passe de Lavanderia",
  "Please Note! (Stacked Dryer)": "Atenção! (Secadora Empilhada)",
  "Ensure machine is vacant and select correct machine after payment press START": "Certifique-se de que a máquina esteja vaga e selecione a máquina correta após o pagamento, pressione INICIAR",
  "Start date": "Data de início",
  "End date": "Data de término",
  "Today": "Hoje",
  "Yesterday": "Ontem",
  "Last 7 Days": "Últimos 7 Dias",
  "Last 30 Days": "Últimos 30 Dias",
  "This Month": "Este Mês",
  "Last Month": "Mês Passado",
  "Use Per Day": "Uso Por Dia",
  "Maximum use per day must be more than 0": "O uso máximo por dia deve ser maior que 0",
  "Only applicable to selected outlet": "Aplicável apenas à filial selecionada",
  "Applicable to all the outlets except selected outlet": "Aplicável a todas as filiais, exceto a filial selecionada",
  "If applicable to all the outlet, leave it blank": "Se aplicável a todas as filiais, deixe em branco",
  "Only applicable to selected weight": "Aplicável apenas ao peso selecionado",
  "Applicable to all the weight except selected weight": "Aplicável a todos os pesos, exceto o peso selecionado",
  "Weight": "Peso",
  "If applicable to all the weight, leave it blank": "Se aplicável a todos os pesos, deixe em branco",
  "Add Weight": "Adicionar Peso",
  "Only applicable to selected mode": "Aplicável apenas ao modo selecionado",
  "Applicable to all the modes except selected mode": "Aplicável a todos os modos, exceto o modo selecionado",
  "If applicable to all the mode, leave it blank": "Se aplicável a todos os modos, deixe em branco",
  "Add Mode": "Adicionar Modo",
  "Laundry Pass not applicable in this outlet": "Passe de Lavanderia não aplicável nesta filial",
  "Discounted price should be more than 0": "O preço com desconto deve ser maior que 0",
  "Discounted Price": "Preço com Desconto",
  "Logo (Optional)": "Logo (Opcional)",
  "Save": "Salvar",
  "Cleanpro Laundry Pass": "Passe de Lavanderia Cleanpro",
  "Save more with the Laundry Pass — ": "Economize mais com o Passe de Lavanderia — ",
  "wash and dry more clothes at a lower price while enjoying extra rewards from Cleanpro Plus!": "lave e seque mais roupas a um preço menor enquanto desfruta de recompensas extras do Cleanpro Plus!",
  "How to Purchase Laundry Pass": "Como Comprar o Passe de Lavanderia",
  "Step 1: Register as a Cleanpro Plus user.": "Passo 1: Registre-se como usuário do Cleanpro Plus.",
  "Step 2: Choose the Laundry Pass package you wish to purchase.": "Passo 2: Escolha o pacote de Passe de Lavanderia que deseja comprar.",
  "Step 3: Make the payment through Cleanpro Plus.": "Passo 3: Faça o pagamento através do Cleanpro Plus.",
  "Step 4: Enjoy washing and drying services at any Cleanpro outlet in Malaysia with exclusive discounted prices!": "Passo 4: Desfrute de serviços de lavagem e secagem em qualquer filial da Cleanpro na Malásia com preços exclusivos com desconto!",
  "By purchasing and/or using the Cleanpro Laundry Pass, you agree to be bound by the following terms and conditions:": "Ao comprar e/ou usar o Passe de Lavanderia Cleanpro, você concorda em estar vinculado aos seguintes termos e condições:",
  "Definitions": "Definições",
  '"Laundry Pass" refers to the package(s) for specific laundry services offered by Cleanpro.': '"Passe de Lavanderia" refere-se ao(s) pacote(s) para serviços específicos de lavanderia oferecidos pela Cleanpro.',
  '"Subscriber" refers to the individual(s) purchasing and/or using the Laundry Pass.': '"Assinante" refere-se ao(s) indivíduo(s) que compra(m) e/ou usa(m) o Passe de Lavanderia.',
  "Pass Description": "Descrição do Passe",
  "The Laundry Pass is a promotional package that offers laundry services at any Cleanpro outlet in Malaysia.": "O Passe de Lavanderia é um pacote promocional que oferece serviços de lavanderia em qualquer filial da Cleanpro na Malásia.",
  'The Laundry Pass is valid for both Malaysians and non-Malaysians; and is exclusively available to Cleanpro Plus members.': 'O Passe de Lavanderia é válido tanto para malaios quanto para não-malaios; e está disponível exclusivamente para membros do Cleanpro Plus.',
  "The campaign of Laundry Pass is valid from": "A campanha do Passe de Lavanderia é válida de",
  "1 March 2025 to 31 May 2025.": "1 de março de 2025 a 31 de maio de 2025.",
  'Each Laundry Pass subscription is': 'Cada assinatura do Passe de Lavanderia é',
  'valid for 30 days from the start date,': 'válida por 30 dias a partir da data de início,',
  'allowing subscribers to use the package': 'permitindo aos assinantes usar o pacote',
  'up to 4 times per day.': 'até 4 vezes por dia.',
  'During the promotional period, subscribers can repurchase the package unlimited times, but only after fully utilizing your current subscription.': 'Durante o período promocional, os assinantes podem recomprar o pacote ilimitadamente, mas apenas após utilizar completamente sua assinatura atual.',
  "The Laundry Pass is": "O Passe de Lavanderia é",
  "valid only for cold wash and drying of machines under 25kg.": "válido apenas para lavagem fria e secagem de máquinas com menos de 25kg.",
  "Additional charges will apply for warm and hot wash services, based on the temperature selected.": "Cobranças adicionais serão aplicadas para serviços de lavagem morna e quente, com base na temperatura selecionada.",
  'Unused wash or dry session(s) from the Laundry Pass cannot be carried forward to the next purchase, and are non-refundable, non-exchangeable for cash, and non-transferable.': 'Sessão(ões) de lavagem ou secagem não utilizadas do Passe de Lavanderia não podem ser transferidas para a próxima compra, e não são reembolsáveis, não podem ser trocadas por dinheiro e não são transferíveis.',
  'The Laundry Pass is valid for washing and/or drying standard laundry items only (e.g., clothing, linens), excluding large items (e.g., rugs), heavily soiled items (e.g., pet bedding), or specialty items requiring special treatment.': 'O Passe de Lavanderia é válido apenas para lavagem e/ou secagem de itens padrão de lavanderia (por exemplo, roupas, lençóis), excluindo itens grandes (por exemplo, tapetes), itens muito sujos (por exemplo, roupas de cama de animais de estimação) ou itens especiais que requerem tratamento especial.',
  'The Laundry Pass can be cancelled within the first 7 days of subscription for a full refund, provided the subscriber has not used the Laundry Pass during this period. No refunds or transfers will be issued after the first 7 days.': 'O Passe de Lavanderia pode ser cancelado nos primeiros 7 dias de assinatura para um reembolso total, desde que o assinante não tenha usado o Passe de Lavanderia durante este período. Nenhum reembolso ou transferência será emitido após os primeiros 7 dias.',
  "Refund process may take up to 21 working days.": "O processo de reembolso pode levar até 21 dias úteis.",
  'Subscribers are encouraged to regularly check Cleanpro Plus for reminders regarding the expiry date of their laundry pass.': 'Os assinantes são encorajados a verificar regularmente o Cleanpro Plus para lembretes sobre a data de validade do seu passe de lavanderia.',
  "This promotion is not valid in conjunction with the '10 Free 1 e-Stamp Campaign'.": "Esta promoção não é válida em conjunto com a 'Campanha 10 Grátis 1 e-Selo'.",
  "Any misuse of the Laundry Pass will result in the immediate termination of the subscription without prior notice. Payments for the Laundry Pass are non-refundable, non-exchangeable for cash, and non-transferable.": "Qualquer uso indevido do Passe de Lavanderia resultará no término imediato da assinatura sem aviso prévio. Os pagamentos pelo Passe de Lavanderia não são reembolsáveis, não podem ser trocados por dinheiro e não são transferíveis.",
  "Payment must be made in full at the time of subscription via Cleanpro Plus.": "O pagamento deve ser feito integralmente no momento da assinatura via Cleanpro Plus.",
  "For any questions or assistance regarding the Laundry Pass, please email Cleanpro Customer Service at enquiry@cleanpro.asia.": "Para quaisquer perguntas ou assistência relacionadas ao Passe de Lavanderia, por favor, envie um e-mail para o Serviço de Atendimento ao Cliente da Cleanpro em enquiry@cleanpro.asia.",
  "Cleanpro reserves the right to change the terms and conditions at any time without prior notice.": "A Cleanpro reserva-se o direito de alterar os termos e condições a qualquer momento sem aviso prévio.",
  "Search": "Pesquisar",
  "Scan to register as a member": "Escaneie para se registrar como membro",
  "Select Product / Key in Amount": "Selecione o Produto / Digite o Valor",
  "Discount code is not available in this payment type": "Código de desconto não está disponível neste tipo de pagamento",
  "This voucher is not available use in washer payment": "Este voucher não está disponível para uso em pagamento de lavadora",
  "This voucher is not available use in dryer payment": "Este voucher não está disponível para uso em pagamento de secadora",
  "This voucher is not available use in Drop n Go payment": "Este voucher não está disponível para uso em pagamento Drop n Go",
  "Voucher is not available in this payment type": "Voucher não está disponível neste tipo de pagamento",
  "Select the price for": "Selecione o preço para",
  "Enable Stamping": "Habilitar Carimbo",
  "Please select your preferred outlet": "Por favor, selecione sua filial preferida",
  "Select your preferred outlet": "Selecione sua filial preferida",
  "State": "Estado",
  "Select State": "Selecionar Estado",
  "Payment Successful!": "Pagamento bem-sucedido!",
  "Thank you for purchasing Laundry Pass!": "Obrigado por comprar o Passe de Lavanderia!",
  "Your Laundry Pass expired on": "Seu Passe de Lavanderia expirou em",
  "You have used all your Laundry Pass": "Você usou todo o seu Passe de Lavanderia",
  "Purchase Again": "Comprar Novamente",
  "Save Big!": "Economize Muito!",
  "You've saved": "Você economizou",
  "on your package!": "no seu pacote!",
  "Please select distributor, operator or outlet": "Por favor, selecione distribuidor, operador ou filial",
  "Please enter your mobile phone number or e-mail": "Por favor, digite seu número de celular ou e-mail",
  "We'll send you an SMS when your laundry's ready": "Enviaremos um SMS quando sua lavagem estiver pronta",
  "Skip": "Pular",
  "Notice": "Aviso",
  "User exists but not verified. Please verify your account by scanning the QR Code at Thank You Page.": "Usuário existe, mas não está verificado. Por favor, verifique sua conta escaneando o Código QR na Página de Agradecimento.",
  "User registered successfully. Please complete verification by scanning the QR Code at Thank You Page.": "Usuário registrado com sucesso. Por favor, complete a verificação escaneando o Código QR na Página de Agradecimento.",
  "Please enter email address to register": "Por favor, digite o endereço de e-mail para registrar",
  "Please enter phone number to register": "Por favor, digite o número de telefone para registrar",
  "Camera permission is denied": "Permissão de câmera negada",
  "No camera device found": "Nenhum dispositivo de câmera encontrado",
  "Camera is already in use by another app": "Câmera já está em uso por outro aplicativo",
  "Preferred Outlet": "Filial Preferida",
  "Purchase Now": "Comprar Agora",
  "Cancel Date": "Data de Cancelamento",
  "Cancel Laundry Pass": "Cancelar Passe de Lavanderia",
  "Download or takes a screenshot of the QR code.": "Baixe ou tire uma captura de tela do código QR.",
  "Launch and login banking app.": "Inicie e faça login no aplicativo bancário.",
  "Choose QR code from your gallery.": "Escolha o código QR da sua galeria.",
  "1 March 2025 - 30 April 2025": "1 de março de 2025 - 30 de abril de 2025",
  "Payment Method to get point": "Método de Pagamento para obter pontos",
  "Payment Method to get voucher": "Método de Pagamento para obter voucher",
  "If applicable to all the payment method, leave it blank": "Se aplicável a todos os métodos de pagamento, deixe em branco",
  "Add {{ currency }} {{ amount }} for {{ mode }} Wash": "Adicione {{ currency }} {{ amount }} para Lavagem {{ mode }}",
  "Add {{ currency }} {{ amount }} for an extra {{ runtime }} minutes!": "Adicione {{ currency }} {{ amount }} por mais {{ runtime }} minutos!",
  "via": "via",
  "Copy": "Cópia",
  "low": "Frio",
  "medium": "Médio",
  "high": "Quente",
  "About Us": "Sobre nós",
  "ABOUT US": "SOBRE NÓS",
  "Only can request einvoice for Malaysia Outlet": "Only can request einvoice for Malaysia Outlet",
  "E-Invoice requested successfully": "E-Invoice requested successfully",
  "Select machine": "Select machine",
  "Select transaction date": "Select transaction date",
  "Transaction Time": "Transaction Time",
  "Select transaction time": "Select transaction time",
  "Transaction Amount": "Transaction Amount",
  "Enter Transaction Amount, Example: 1.50": "Enter Transaction Amount, Example: 1.50",
  "Select payment method": "Select payment method",
  "Cash": "Cash",
  "Cashless (e-Wallet / DuitNow QR)": "Cashless (e-Wallet / DuitNow QR)",
  "Paywave (Tap with Debit/Credit Card)": "Paywave (Tap with Debit/Credit Card)",
  "Request as": "Request as",
  "Individual": "Individual",
  "Company": "Company",
  "ID Type": "ID Type",
  "Select ID Type": "Select ID Type",
  "Company Name": "Company Name",
  "Phone": "Phone",
  "Address": "Address",
  "City": "City",
  "Postcode": "Postcode",
  "Request E-Invoice": "Request E-Invoice",
  "Request e-Invoice": "Request e-Invoice",
  "e-Invoice Validation Link": "e-Invoice Validation Link",
  "Credit Card": "Cartão de Crédito",
  "Credit Card Number": "Número do Cartão de Crédito",
  "Credit Card Expiry Month": "Mês de Validade do Cartão",
  "Credit Card Expiry Year": "Ano de Validade do Cartão",
  "Credit Card Securtiy Code": "Código de Segurança do Cartão",
  "Credit Card Holder Name": "Nome do Titular do Cartão",
  "Settlement Amount": "Valor da Liquidação",
  "Paid": "Pago",
  "Enable E-Wallet Payment?": "Ativar o pagamento E-Wallet?",
  "Enable DuitNow Payment?": "Ativar o pagamento DuitNow?",
  "Enable Credit Card Terminal Payment?": "Ativar o pagamento por terminal de cartão de crédito?",
  "Transaction date is more than 3 days": "Transaction date is more than 3 days",
  "Select Recurrence Type": "Selecionar Tipo de Recorrência",
  "Multiple Voucher": "Vouchers Múltiplos",
  "Period for giving next voucher (days)": "Período para entregar o próximo voucher (dias)",
  "General Voucher Code Report": "Relatório de Código de Voucher Geral",
  "Unique Voucher Code Report": "Relatório de Código de Voucher Único",
  "Select Code": "Selecionar Código",
  "Minimum transaction amount to use code cannot be negative": "O valor mínimo da transação para usar o código não pode ser negativo",
  "Redeem per user must at least 1": "Resgate por usuário deve ser pelo menos 1",
  "Start date must before end date": "A data de início deve ser anterior à data de fim",
  "Please select the start date and end date": "Por favor, selecione a data de início e a data de fim",
  "Please enter the voucher code": "Por favor, insira o código do voucher",
  "Successfully create the voucher code": "Código do voucher criado com sucesso",
  "General Voucher Code": "Código de Voucher Geral",
  "Unique Voucher Code": "Código de Voucher Único",
  "Add Voucher Code": "Adicionar Código de Voucher",
  "How many times the voucher code can be used for each user": "Quantas vezes o código do voucher pode ser usado por cada usuário",
  "Update Version": "Atualizar versão",
  "User profile updated successfully": "Perfil de utilizador atualizado com sucesso",
  "Salutation": "Saudação",
  "Nationality": "Nacionalidade",
  "Race": "Raça",
  "Gender": "Gênero",
  "Update salutation": "Atualizar saudação",
  "Update ID Type": "Atualizar tipo de ID",
  "Update Address": "Atualizar endereço",
  "Update nationality": "Atualizar nacionalidade",
  "Male": "Masculino",
  "Female": "Feminino",
  "Update gender": "Atualizar gênero",
  "Number of Point cannot be 0": "O número de pontos não pode ser 0",
  "Token value cannot be 0": "O valor do token não pode ser 0",
  "Activate": "Ativar",
  "Deactivate": "Desativar",
  "Activate User": "Ativar Usuário",
  "Deactivate User": "Desativar Usuário",
  "Are you sure you want to activate the user account?": "Tem certeza de que deseja ativar a conta do usuário?",
  "Are you sure you want to deactivate the user account?": "Tem certeza de que deseja desativar a conta do usuário?",
  "Your point redemption is successful": "Seu resgate de pontos foi bem-sucedido",
  "Point Redemption": "Resgate de Pontos",
  "This redemption has already been completed": "Este resgate já foi concluído",
  "Transaction Details": "Detalhes da Transação",
  "Please login to redeem point": "Por favor, faça login para resgatar pontos",
  "Login as {{name}}": "Entrar como {{name}}",
  "Payment Amount Settings": "Configurações de Valor de Pagamento",
  "Allow washer pay less than cheapest mode price?": "Permitir que a lavadora pague menos que o preço do modo mais barato?",
  "Allow dryer pay less than minimum price?": "Permitir que a secadora pague menos que o preço mínimo?",
  "Drop n Go Settings": "Configurações Drop n Go",
  "Allow user pay for specific service only?": "Permitir que o usuário pague apenas por serviço específico?",
  "Display pricing for each service?": "Exibir preços para cada serviço?",
  "Delete Voucher": "Excluir voucher",
  "Are you sure you want to delete this voucher?": "Tem certeza de que deseja excluir este voucher?",
  "Display in Promotion Page": "Exibir na Página de Promoção",
  "Add Promotion": "Adicionar Promoção",
  "Select Transaction Status": "Selecionar Status da Transação",
  "Give Stamp for Drop n Go Transaction?": "Dar Selo para Transação Drop n Go?",
  "Display machine capacity?": "Exibir capacidade da máquina?",
  "External Voucher Code": "Código de Voucher Externo",
  "Import Voucher Code": "Importar Código de Voucher",
  "Voucher Code Stamp Settings": "Configurações de Selo de Código de Voucher",
  "Upload Date": "Data de Upload",
  "Import External Voucher Code": "Importar Código de Voucher Externo",
  "Import": "Importar",
  "Please select a valid CSV file": "Por favor, selecione um arquivo CSV válido",
  "Redeemed": "Resgatado",
  "Sales": "Vendas",
  "Drop N Go Dashboard": "Painel do Drop N Go",
  "Total Drop N Go Sales by Month": "Total de vendas do Drop N Go por mês",
  "Total Drop N Go Sales by Day": "Total de vendas do Drop N Go por dia",
}

const translationAr = {
  "LOGIN": "تسجيل الدخول",
  "REGISTER": "التسجيل",
  "SKIP TO PAYMENT": "الانتقال للدفع",
  "Continue as guest": "المتابعة كضيف",
  "WELCOME": "أهلاً وسهلاً",
  "Error": "خطأ",
  "Please enter the correct phone number format. <br /><br /> <small>Example: 0129465628</small>": "يرجى إدخال رقم الهاتف بالصيغة الصحيحة. <br /><br /> <small>مثال: 0129465628</small>",
  "Info": "معلومات",
  "Please scan QRCode to Login": "يرجى مسح رمز QR لتسجيل الدخول",
  "Forgot Password": "نسيت كلمة المرور",
  "Seems like you have forgotten your password<br />Create a temporary password?": "يبدو أنك نسيت كلمة المرور<br />إنشاء كلمة مرور مؤقتة؟",
  "Cancel": "إلغاء",
  "Confirm": "تأكيد",
  "Reset Your Password": "إعادة تعيين كلمة المرور",
  "Enter Your Phone Number / Email Address": "أدخل رقم هاتفك / عنوان البريد الإلكتروني",
  "Enter Your Email Address": "أدخل عنوان بريدك الإلكتروني",
  "Please enter phone number / email address": "يرجى إدخال رقم الهاتف / عنوان البريد الإلكتروني",
  "Please enter email address": "يرجى إدخال عنوان البريد الإلكتروني",
  "Submit": "إرسال",
  "Please enter a valid phone number": "يرجى إدخال رقم هاتف صحيح",
  "Please enter a valid email address": "يرجى إدخال عنوان بريد إلكتروني صحيح",
  "Success!": "نجاح!",
  "You may login using your one time password now.": "يمكنك الآن تسجيل الدخول باستخدام كلمة المرور المؤقتة.",
  "Phone Number": "رقم الهاتف",
  "Password": "كلمة المرور",
  "Don't have an account?": "ليس لديك حساب؟",
  "Forgot password?": "نسيت كلمة المرور؟",
  "Unable to register without a QRCode": "لا يمكن التسجيل بدون رمز QR",
  "Please read and agree to the privacy policies, terms and conditions": "يرجى قراءة سياسات الخصوصية والشروط والأحكام والموافقة عليها",
  "Password length must be at least 6 characters": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
  "Please enter the confirmation code that was sent to your phone": "يرجى إدخال رمز التأكيد الذي تم إرساله إلى هاتفك",
  "Example: 012xxxxxxx": "مثال: 012xxxxxxx",
  "Example: 09xxxxxxxx": "مثال: 09xxxxxxxx",
  "Verification Method": "طريقة التحقق",
  "Name": "الاسم",
  "Email": "البريد الإلكتروني",
  "optional": "اختياري",
  "Birth Year": "سنة الميلاد",
  "Year": "السنة",
  "Birth Month": "شهر الميلاد",
  "Month": "الشهر",
  "Jan": "يناير",
  "Feb": "فبراير",
  "Mar": "مارس",
  "April": "أبريل",
  "May": "مايو",
  "June": "يونيو",
  "July": "يوليو",
  "Aug": "أغسطس",
  "Sept": "سبتمبر",
  "Oct": "أكتوبر",
  "Nov": "نوفمبر",
  "Dec": "ديسمبر",
  "Birth Day": "يوم الميلاد",
  "Day": "اليوم",
  "OTP": "رمز التحقق",
  "OTP Confirmation": "تأكيد رمز التحقق",
  "I agree to the": "أوافق على",
  "Privacy Policy": "سياسة الخصوصية",
  "PRIVACY POLICY": "سياسة الخصوصية",
  "and": "و",
  "Terms": "الشروط",
  "Conditions": "الأحكام",
  "SEND CODE": "إرسال الرمز",
  "Our One-Time Password (OTP) emails might end up in your spam or junk folder. We kindly ask you to take a moment to check your spam mailbox.": "قد تصل رسائل كلمة المرور المؤقتة إلى مجلد البريد العشوائي. نرجو منك التحقق من مجلد البريد العشوائي.",
  "Already have an account? Login": "لديك حساب بالفعل؟ تسجيل الدخول",
  "Didn't receive a code?": "لم تستلم الرمز؟",
  "Resend Code": "إعادة إرسال الرمز",
  "collected": "محصل",
  "Collect": "جمع",
  "stamps": "أختام",
  "get 1 voucher": "احصل على ١ قسيمة",
  "Minimum": "الحد الأدنى",
  "spending to collect each washer stamp": "للإنفاق لجمع ختم كل غسالة",
  "spending to collect each dryer stamp": "للإنفاق لجمع ختم كل مجفف",
  "spending to collect each stamp": "للإنفاق لجمع كل ختم",
  "Device don't have a camera": "الجهاز لا يحتوي على كاميرا",
  "This is not a valid QRCode": "هذا ليس رمز QR صالح",
  "Select Camera": "اختر الكاميرا",
  "Switch": "تبديل",
  "Camera": "الكاميرا",
  "Loading": "جاري التحميل",
  "Scan the QR code on the machine.": "امسح رمز QR على الجهاز.",
  "Switch Camera": "تبديل الكاميرا",
  "Off torch light": "إطفاء الضوء الكاشف",
  "On torch light": "تشغيل الضوء الكاشف",
  "switch camera if your camera is not clear": "قم بتبديل الكاميرا إذا لم تكن الصورة واضحة",
  "Switch your camera if the display is not clear": "قم بتبديل الكاميرا إذا لم تكن الشاشة واضحة",
  "Please allow this webapp to access your camera": "يرجى السماح للتطبيق بالوصول إلى الكاميرا",
  "DISCOUNT": "خصم",
  "Congratulation": "تهانينا",
  "Expired Date": "تاريخ الانتهاء",
  "Voucher": "قسيمة",
  "Vouchers": "القسائم",
  "Something went wrong": "حدث خطأ ما",
  "Stamping Collection": "مجموعة الأختام",
  "Total e-Token": "إجمالي الرموز الإلكترونية",
  "Total Wash": "إجمالي الغسيل",
  "Total Dry": "إجمالي التجفيف",
  "Reload": "إعادة الشحن",
  "Washer": "غسالة",
  "Dryer": "مجفف",
  "Congratulations!": "تهانينا!",
  "You have completed your Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "لقد أكملت مجموعة الأختام.<br />تم منحك قسيمة وتم تحديث مجموعة الأختام",
  "You have completed Washer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "لقد أكملت مجموعة أختام الغسالة.<br />تم منحك قسيمة وتم تحديث مجموعة الأختام",
  "You have completed Dryer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "لقد أكملت مجموعة أختام المجفف.<br />تم منحك قسيمة وتم تحديث مجموعة الأختام",
  "Latest News": "آخر الأخبار",
  "Transaction History": "سجل المعاملات",
  "Stamping": "الأختام",
  "Transaction": "المعاملة",
  "News": "الأخبار",
  "Confirmation": "التأكيد",
  "Logout Session?": "تسجيل الخروج؟",
  "NO": "لا",
  "OK": "موافق",
  "Account": "الحساب",
  "FAQs": "الأسئلة الشائعة",
  "Feedback": "التعليقات",
  "LOGOUT": "تسجيل الخروج",
  "Logout": "تسجيل الخروج",
  "Are you sure you want to submit your feedback?": "هل تريد بالتأكيد إرسال تعليقك؟",
  "No": "لا",
  "Yes": "نعم",
  "Success": "نجاح",
  "Failed": "فشل",
  "Pending": "قيد الانتظار",
  "Your feedback is submitted successfully": "تم إرسال تعليقك بنجاح",
  "Please fill in all the required fields before submit.": "يرجى ملء جميع الحقول المطلوبة قبل الإرسال.",
  "Give us your feedback!": "أعطنا رأيك!",
  "Type your name here (optional)": "اكتب اسمك هنا (اختياري)",
  "required": "مطلوب",
  "Type your number here": "اكتب رقمك هنا",
  "Outlet": "المحل",
  "Select an outlet": "اختر محلاً",
  "Outlet Cleanliness": "نظافة المحل",
  "Washer Machine Performance": "أداء جهاز الغسيل",
  "Dryer Machine Performance": "أداء جهاز التجفيف",
  "Customer Service": "خدمة العملاء",
  "Comment": "التعليق",
  "Type your comment here (optional)": "اكتب تعليقك هنا (اختياري)",
  "SUBMIT": "إرسال",
  "Join as a member now!": "انضم كعضو الآن!",
  "Join as a loyalty member now to get more benefits such as vouchers and free machine usage!<br /><br /><strong>Register as loyalty member?</strong>": "انضم كعضو في برنامج الولاء للحصول على المزيد من المزايا مثل القسائم واستخدام الأجهزة مجاناً!<br /><br /><strong>التسجيل كعضو في برنامج الولاء؟</strong>",
  "Maybe Next Time": "ربما في المرة القادمة",
  "Yes, Register Now": "نعم، سجل الآن",
  "Washer Payment": "دفع الغسالة",
  "Dryer Payment": "دفع المجفف",
  "Vending Machine Payment": "دفع آلة البيع",
  "Online": "متصل",
  "Offline": "غير متصل",
  "Running": "يعمل",
  "Vacant": "فارغ",
  "Vending Machine": "آلة البيع",
  "Discount": "خصم",
  "No Vouchers Available": "لا توجد قسائم متاحة",
  "Payment Method": "طريقة الدفع",
  "Would you like to pay with?": "كيف تود الدفع؟",
  "e-Token": "الرمز الإلكتروني",
  "E-TOKEN": "الرمز الإلكتروني",
  "E-Wallet": "المحفظة الإلكترونية",
  "E-Wallet & Online Banking": "المحفظة الإلكترونية والخدمات المصرفية عبر الإنترنت",
  "Duitnow QR code": "رمز Duitnow QR",
  "PromptPay QR Code": "رمز PromptPay QR",
  "The Duitnow QR code will be downloaded and you need to open your banking app to make the payment. Pay {{ currency }}{{ totalPaymentAmount }} to {{ machineName }}?": "سيتم تنزيل رمز Duitnow QR وتحتاج إلى فتح تطبيق البنك لإجراء الدفع. الدفع {{ currency }}{{ totalPaymentAmount }} إلى {{ machineName }}؟",
  "Pay": "دفع",
  "to": "إلى",
  "You may under utilized the voucher.": "قد تكون لم تستخدم القسيمة بشكل كامل.",
  "Proceed to pay": "المتابعة للدفع",
  "Processing ...": "جاري المعالجة ...",
  "You can't pay with e-token if voucher is in used, please remove your voucher to pay with e-token.": "لا يمكنك الدفع بالرمز الإلكتروني إذا كانت القسيمة مستخدمة، يرجى إزالة القسيمة للدفع بالرمز الإلكتروني.",
  "Insufficient e-Tokens": "الرموز الإلكترونية غير كافية",
  "Reload your e-token now?": "إعادة شحن رموزك الإلكترونية الآن؟",
  "Reload now!": "إعادة الشحن الآن!",
  "You have": "لديك",
  "e-Tokens": "رموز إلكترونية",
  "Tokens to": "رموز إلى",
  "This machine is currently offline, please try again later.": "هذا الجهاز غير متصل حالياً، يرجى المحاولة مرة أخرى لاحقاً.",
  "MACHINE": "الجهاز",
  "Machine": "الجهاز",
  "TYPE": "النوع",
  "CAPACITY": "السعة",
  "DURATION": "المدة",
  "Select Duration": "اختر المدة",
  "AMOUNT TO PAY": "المبلغ المستحق",
  "PRICE": "السعر",
  "VOUCHER": "القسيمة",
  "Select Voucher >": "اختر القسيمة >",
  "TOTAL": "الإجمالي",
  "PAY": "دفع",
  "Remove Voucher": "إزالة القسيمة",
  "Select Your Voucher": "اختر قسيمتك",
  "min": "دقيقة",
  "MIN": "دقيقة",
  "Select Payment Amount": "اختر قيمة الدفع",
  "Select Water Temperature": "اختر درجة حرارة الماء",
  "Select temperature": "اختر درجة الحرارة",
  "Select Temperature": "اختر درجة الحرارة",
  "Cold": "بارد",
  "Warm": "دافئ",
  "Hot": "ساخن",
  "e-Tokens to": "رموز إلكترونية إلى",
  "No Purchase History": "لا يوجد سجل شراء",
  "e-tokens": "رموز إلكترونية",
  "No Promotions": "لا توجد عروض ترويجية",
  "New Password": "كلمة المرور الجديدة",
  "Back": "رجوع",
  "Buy this package?": "شراء هذه الباقة؟",
  "Purchase": "شراء",
  "e-Tokens for": "رموز إلكترونية مقابل",
  "Reload Tokens": "إعادة شحن الرموز",
  "Are you sure you want to purchase {{ tokenAmount }} e-Token for {{ currency }}{{ paymentAmount }}?": "هل تريد بالتأكيد شراء {{ tokenAmount }} رمز إلكتروني مقابل {{ currency }}{{ paymentAmount }}؟",
  "Current e-Token": "الرمز الإلكتروني الحالي",
  "Current point": "النقاط الحالية",
  "History": "السجل",
  "Your profile picture has been updated!": "تم تحديث صورة الملف الشخصي!",
  "Please only use png, jpg or jpeg file extension type": "يرجى استخدام ملفات png أو jpg أو jpeg فقط",
  "Please only use image type file": "يرجى استخدام ملفات الصور فقط",
  "User name has updated successfully!": "تم تحديث اسم المستخدم بنجاح!",
  "Email Address updated successfully": "تم تحديث عنوان البريد الإلكتروني بنجاح",
  "Phone number updated successfully": "تم تحديث رقم الهاتف بنجاح",
  "Password must be at least 6 characters": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
  "Password updated successfully": "تم تحديث كلمة المرور بنجاح",
  "User Settings": "إعدادات المستخدم",
  "Profile Picture": "صورة الملف الشخصي",
  "Change Password": "تغيير كلمة المرور",
  "Do you want to submit your feedback?": "هل تريد إرسال تعليقك؟",
  "Thank You!": "شكراً لك!",
  "Thank you for using our services.": "شكراً لك لاستخدام خدماتنا.",
  "BACK TO HOMEPAGE": "العودة للصفحة الرئيسية",
  "How to pay?": "كيفية الدفع؟",
  "Step 1": "الخطوة 1",
  "After scan the QR code on the machine, select either register new account, login your account or skip to payment.": "بعد مسح رمز QR على الجهاز، اختر إما إنشاء حساب جديد أو تسجيل الدخول أو الانتقال للدفع.",
  "Step 2-1": "الخطوة 2-1",
  "For Dryer – Select your desired duration. Different duration will have different prices.": "للمجفف - اختر المدة المرغوب فيها. سيكون لكل مدة سعر مختلف.",
  "Step 2-2": "الخطوة 2-2",
  "For Washer – Select your desired water temperature. Different water temperature will have different prices.": "للغسالة - اختر درجة حرارة الماء المرغوب فيها. سيكون لكل درجة حرارة سعر مختلف.",
  "Step 3": "الخطوة 3",
  "For login user, Click on 'Select Voucher' to select your voucher.": "للمستخدم المسجل، انقر على 'اختر القسيمة' لاختيار قسيمتك.",
  "Step 4": "الخطوة 4",
  "Click on 'PAY' button to pay. For login user, select your payment method to pay.": "انقر على زر 'دفع' للدفع. للمستخدم المسجل، اختر طريقة الدفع.",
  "Step 5": "الخطوة 5",
  "After confirm the price and machine details, click on 'OK' button to pay.": "بعد التأكد من السعر وتفاصيل الجهاز، انقر على زر 'موافق' للدفع.",
  "How to reload your e-Token?": "كيفية إعادة شحن رموزك الإلكترونية؟",
  'Click on the "Reload" button.': 'انقر على زر "إعادة الشحن".',
  "Select the package that you wish to purchase.": "اختر الباقة التي تريد شراءها.",
  'Click on "Purchase" as confirmation before payment page.': 'انقر على "شراء" كتأكيد قبل صفحة الدفع.',
  "Is e-token can be refund/transfer back to e-wallet?": "هل يمكن إرجاع/تحويل الرمز الإلكتروني إلى المحفظة الإلكترونية؟",
  "Why can't I applied my voucher?": "لماذا لا أستطيع استخدام قسيمتي؟",
  "When there is a Happy Hour Promotion is on going, you are unable to apply your voucher temporarily.": "عندما يكون هناك عرض ترويجي للساعة السعيدة، لا يمكنك استخدام قسيمتك مؤقتاً.",
  "How to apply my voucher?": "كيفية استخدام قسيمتي؟",
  'Click on the "Select Voucher" button.': 'انقر على زر "اختر القسيمة".',
  "Select the voucher that you wish to apply.": "اختر القسيمة التي تريد استخدامها.",
  'Click on "Pay" once you have verified the voucher is successfully applied.': 'انقر على "دفع" بعد التأكد من تطبيق القسيمة بنجاح.',
  "Step 2": "الخطوة 2",
  "Language has updated successfully!": "تم تحديث اللغة بنجاح!",
  "Change Language": "تغيير اللغة",
  "Language": "اللغة",
  "Select language": "اختر اللغة",
  "Referral Code": "رمز الإحالة",
  "Copied!": "تم النسخ!",
  "Inviting friends to get more benefits!": "دعوة الأصدقاء للحصول على المزيد من المزايا!",
  "Would you like to share your referral code to your friends & family?": "هل تريد مشاركة رمز الإحالة مع أصدقائك وعائلتك؟",
  "Refer a friend and get": "أحل صديقاً واحصل على",
  "Share the love to your friends & family?": "شارك الحب مع أصدقائك وعائلتك؟",
  "voucher": "قسيمة",
  "token": "رمز",
  "stamp": "ختم",
  "washer stamp": "ختم غسالة",
  "dryer stamp": "ختم مجفف",
  "Learn More": "اعرف المزيد",
  "Welcome Gift": "هدية الترحيب",
  "Share Your Referral Code Now": "شارك رمز الإحالة الآن",
  "Birthday Gift for You": "هدية عيد ميلاد لك",
  "Let's Pay with E-Token": "لنقم بالدفع بالرمز الإلكتروني",
  "Collect 10 Stamps and Get Voucher": "اجمع 10 أختام واحصل على قسيمة",
  "The voucher will be given if you registered your account successfully.": "سيتم منح القسيمة عند تسجيل حسابك بنجاح.",
  "There is no expiration date for this voucher.": "لا يوجد تاريخ انتهاء لهذه القسيمة.",
  "The voucher can be used for dryer machine only.": "يمكن استخدام القسيمة لجهاز التجفيف فقط.",
  "The voucher can be used for washer machine only.": "يمكن استخدام القسيمة لجهاز الغسيل فقط.",
  "The voucher can be used for Drop n Go transaction only.": "يمكن استخدام القسيمة لمعاملات Drop n Go فقط.",
  "The voucher can be used for vending transaction only.": "يمكن استخدام القسيمة فقط لمعاملة آلة البيع.",
  "The voucher can be used for detergent vending transaction only.": "يمكن استخدام القسيمة فقط لمعاملة آلة بيع المنظفات.",
  "The voucher can be used for car wash transaction only.": "يمكن استخدام القسيمة فقط لمعاملة غسيل السيارات.",
  "The voucher can be used for washer machine or Drop n Go transaction.": "يمكن استخدام القسيمة لجهاز الغسيل أو معاملات Drop n Go.",
  "The voucher can be used for dryer machine or Drop n Go transaction.": "يمكن استخدام القسيمة لجهاز التجفيف أو معاملات Drop n Go.",
  "The voucher can be used for dryer or washer machine.": "يمكن استخدام القسيمة لجهاز التجفيف أو الغسيل.",
  "The voucher can be used for washer machine, dryer machine or Drop n Go transaction.": "يمكن استخدام القسيمة لجهاز الغسيل أو التجفيف أو معاملات Drop n Go.",
  "The voucher can be used for washer machine or vending machine transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة البيع.",
  "The voucher can be used for washer machine or detergent vending machine transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة بيع المنظفات.",
  "The voucher can be used for washer machine or car wash transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو غسيل السيارات.",
  "The voucher can be used for dryer machine or vending machine transaction.": "يمكن استخدام القسيمة لمعاملة آلة التجفيف أو آلة البيع.",
  "The voucher can be used for dryer machine or detergent vending machine transaction.": "يمكن استخدام القسيمة لمعاملة آلة التجفيف أو آلة بيع المنظفات.",
  "The voucher can be used for dryer machine or car wash transaction.": "يمكن استخدام القسيمة لمعاملة آلة التجفيف أو غسيل السيارات.",
  "The voucher can be used for vending machine or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة آلة البيع أو خدمة Drop n Go.",
  "The voucher can be used for detergent vending machine or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة آلة بيع المنظفات أو خدمة Drop n Go.",
  "The voucher can be used for car wash or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة غسيل السيارات أو خدمة Drop n Go.",
  "The voucher can be used for vending machine or detergent vending machine transaction.": "يمكن استخدام القسيمة لمعاملة آلة البيع أو آلة بيع المنظفات.",
  "The voucher can be used for vending machine or car wash transaction.": "يمكن استخدام القسيمة لمعاملة آلة البيع أو غسيل السيارات.",
  "The voucher can be used for detergent vending machine or car wash transaction.": "يمكن استخدام القسيمة لمعاملة آلة بيع المنظفات أو غسيل السيارات.",
  "The voucher can be used for washer machine, dryer machine or vending machine transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة التجفيف أو آلة البيع.",
  "The voucher can be used for washer machine, dryer machine or detergent vending machine transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة التجفيف أو آلة بيع المنظفات.",
  "The voucher can be used for washer machine, dryer machine or car wash transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة التجفيف أو غسيل السيارات.",
  "The voucher can be used for washer machine, vending machine or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة البيع أو خدمة Drop n Go.",
  "The voucher can be used for washer machine, detergent vending machine or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة بيع المنظفات أو خدمة Drop n Go.",
  "The voucher can be used for washer machine, car wash or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو غسيل السيارات أو خدمة Drop n Go.",
  "The voucher can be used for washer machine, vending machine or detergent vending transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة البيع أو آلة بيع المنظفات.",
  "The voucher can be used for washer machine, vending machine or car wash transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة البيع أو غسيل السيارات.",
  "The voucher can be used for washer machine, detergent vending machine or car wash transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة بيع المنظفات أو غسيل السيارات.",
  "The voucher can be used for dryer machine, vending machine or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة آلة التجفيف أو آلة البيع أو خدمة Drop n Go.",
  "The voucher can be used for dryer machine, detergent vending machine or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة آلة التجفيف أو آلة بيع المنظفات أو خدمة Drop n Go.",
  "The voucher can be used for dryer machine, car wash or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة آلة التجفيف أو غسيل السيارات أو خدمة Drop n Go.",
  "The voucher can be used for dryer machine, vending machine or detergent vending machine transaction.": "يمكن استخدام القسيمة لمعاملة آلة التجفيف أو آلة البيع أو آلة بيع المنظفات.",
  "The voucher can be used for dryer machine, vending machine or car wash transaction.": "يمكن استخدام القسيمة لمعاملة آلة التجفيف أو آلة البيع أو غسيل السيارات.",
  "The voucher can be used for dryer machine, detergent vending machine or car wash transaction.": "يمكن استخدام القسيمة لمعاملة آلة التجفيف أو آلة بيع المنظفات أو غسيل السيارات.",
  "The voucher can be used for vending machine, detergent vending machine or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة آلة البيع أو آلة بيع المنظفات أو خدمة Drop n Go.",
  "The voucher can be used for vending machine, car wash or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة آلة البيع أو غسيل السيارات أو خدمة Drop n Go.",
  "The voucher can be used for detergent vending machine, car wash or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة آلة بيع المنظفات أو غسيل السيارات أو خدمة Drop n Go.",
  "The voucher can be used for vending machine, detergent vending machine or car wash transaction.": "يمكن استخدام القسيمة لمعاملة آلة البيع أو آلة بيع المنظفات أو غسيل السيارات.",
  "The voucher can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة التجفيف أو آلة البيع أو خدمة Drop n Go.",
  "The voucher can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة التجفيف أو آلة البيع أو آلة بيع المنظفات.",
  "The voucher can be used for washer machine, dryer machine, vending machine or car wash transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة التجفيف أو آلة البيع أو غسيل السيارات.",
  "The voucher can be used for washer machine, dryer machine, detergent vending machine or car wash transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة التجفيف أو آلة بيع المنظفات أو غسيل السيارات.",
  "The voucher can be used for washer machine, vending macihne, detergent vending machine, car wash or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة البيع أو آلة بيع المنظفات أو غسيل السيارات أو خدمة Drop n Go.",
  "The voucher can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة آلة التجفيف أو آلة البيع أو آلة بيع المنظفات أو غسيل السيارات أو خدمة Drop n Go.",
  "The voucher can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction.": "يمكن استخدام القسيمة لمعاملة غسالة الملابس أو آلة التجفيف أو آلة البيع أو آلة بيع المنظفات أو غسيل السيارات أو خدمة Drop n Go.",
  "When you applied the voucher during payment, it will give you": "عند استخدام القسيمة أثناء الدفع، ستحصل على",
  "discount.": "خصم.",
  "When promotion is on going, the voucher is not applicable.": "عندما يكون هناك عرض ترويجي، لا يمكن استخدام القسيمة.",
  "The voucher cannot be used if your payment method is E-Token.": "لا يمكن استخدام القسيمة إذا كانت طريقة الدفع هي الرمز الإلكتروني.",
  "Your referral code can be found in user settings page.": "يمكن العثور على رمز الإحالة في صفحة إعدادات المستخدم.",
  "You can get": "يمكنك الحصول على",
  "stamp for the reward.": "ختم كمكافأة.",
  "e-token for the reward.": "رمز إلكتروني كمكافأة.",
  "e-token based on transaction payment amount for the reward.": "رمز إلكتروني بناءً على مبلغ الدفع كمكافأة.",
  "for the reward.": "كمكافأة.",
  "based on transaction payment amount for the reward.": "بناءً على مبلغ الدفع كمكافأة.",
  "You can get a voucher for the reward": "يمكنك الحصول على قسيمة كمكافأة",
  "which have": "التي لديها",
  "it can be used for dryer machine only.": "يمكن استخدامها لجهاز التجفيف فقط.",
  "it can be used for washer machine only.": "يمكن استخدامها لجهاز الغسيل فقط.",
  "it can be used for Drop n Go transaction only.": "يمكن استخدامها لمعاملات Drop n Go فقط.",
  "it can be used for vending machine only.": "يمكن استخدامه فقط لآلة البيع.",
  "it can be used for car wash transaction only.": "يمكن استخدامه فقط لغسيل السيارات.",
  "it can be used for detergent vending machine only.": "يمكن استخدامه فقط لآلة بيع المنظفات.",
  "it can be used for dryer or washer machine.": "يمكن استخدامها لجهاز التجفيف أو الغسيل.",
  "it can be used for dryer machine or Drop n Go transaction.": "يمكن استخدامها لجهاز التجفيف أو معاملات Drop n Go.",
  "it can be used for washer machine or Drop n Go transaction.": "يمكن استخدامها لجهاز الغسيل أو معاملات Drop n Go.",
  "it can be used for washer machine, dryer machine or Drop n Go transaction.": "يمكن استخدامها لجهاز الغسيل أو التجفيف أو معاملات Drop n Go.",
  "it can be used for washer machine, dryer machine or vending machine transaction.": "يمكن استخدامه لمعاملة غسالة الملابس أو آلة التجفيف أو آلة البيع.",
  "it can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "يمكن استخدامه لمعاملة غسالة الملابس أو آلة التجفيف أو آلة البيع أو خدمة Drop n Go.",
  "washer stamp for the reward.": "ختم غسالة كمكافأة.",
  "dryer stamp for the reward.": "ختم مجفف كمكافأة.",
  "washer stamp and": "ختم غسالة و",
  "cleanproBirthdayShortDesc_one": "استرد قسيمة {{ birthdayVoucherAmount }} رصيد في عيد ميلادك مع Cleanpro Plus. اضغط لمعرفة المزيد.",
  "cleanproBirthdayShortDesc_other": "استرد قسيمة {{ birthdayVoucherAmount }} أرصدة في عيد ميلادك مع Cleanpro Plus. اضغط لمعرفة المزيد.",
  'When you click on "PAY" button on the payment page, you can choose either using E-wallet or E-token to pay.': 'عندما تنقر على زر "دفع" في صفحة الدفع، يمكنك اختيار الدفع بالمحفظة الإلكترونية أو الرمز الإلكتروني.',
  "When you using your voucher during payment, you will be unable to pay with E-token.": "عند استخدام قسيمتك أثناء الدفع، لن تتمكن من الدفع بالرمز الإلكتروني.",
  "You can reload your E-token by clicking the reload button in the stamping page and select the package to purchase.": "يمكنك إعادة شحن رموزك الإلكترونية بالنقر على زر إعادة الشحن في صفحة الأختام واختيار الباقة للشراء.",
  "You can reload your E-token by clicking the reload button in the home page and select the package to purchase.": "يمكنك إعادة شحن رموزك الإلكترونية بالنقر على زر إعادة الشحن في الصفحة الرئيسية واختيار الباقة للشراء.",
  "You can view your E-token reload history and E-token transaction history in transaction page.": "يمكنك مشاهدة سجل إعادة شحن الرموز الإلكترونية وسجل معاملات الرموز الإلكترونية في صفحة المعاملات.",
  "You can view your E-token transaction history in transaction page.": "يمكنك مشاهدة سجل معاملات الرموز الإلكترونية في صفحة المعاملات.",
  "Using either dryer machine or washer machine with the minimum spending of": "استخدام جهاز التجفيف أو الغسيل مع الحد الأدنى للإنفاق",
  "to collect one stamp.": "لجمع ختم واحد.",
  "The voucher will be given if you have collected 10 stamps.": "سيتم منح القسيمة عند جمع 10 أختام.",
  "Using dryer machine with the minimum spending of": "استخدام جهاز التجفيف مع الحد الأدنى للإنفاق",
  "Using washer machine with the minimum spending of": "استخدام جهاز الغسيل مع الحد الأدنى للإنفاق",
  "to collect one dryer stamp.": "لجمع ختم مجفف واحد.",
  "to collect one washer stamp.": "لجمع ختم غسالة واحد.",
  "The voucher will be given if you have collected 10 dryer stamps or 10 washer stamps.": "سيتم منح القسيمة عند جمع 10 أختام مجفف أو 10 أختام غسالة.",
  "For the voucher given by the dryer stamps,": "للقسيمة الممنوحة بأختام المجفف،",
  "For the voucher given by the washer stamps,": "للقسيمة الممنوحة بأختام الغسالة،",
  "When promotion is on going, all the vouchers is not applicable.": "عندما يكون هناك عرض ترويجي، لا يمكن استخدام جميع القسائم.",
  "All the vouchers cannot be used if your payment method is E-Token.": "لا يمكن استخدام جميع القسائم إذا كانت طريقة الدفع هي الرمز الإلكتروني.",
  "Description": "الوصف",
  "Refer Friends": "إحالة الأصدقاء",
  "View our guideline": "عرض التوجيهات",
  "When a friend / family register using your referral code, and completed a transaction with a minimum spending of": "عندما يسجل صديق/أحد أفراد العائلة باستخدام رمز الإحالة الخاص بك، ويكمل معاملة بحد أدنى للإنفاق",
  ", you will be rewarded automatically.": "، ستحصل على مكافأة تلقائياً.",
  "One user only allow to have": "يُسمح للمستخدم الواحد بالحصول على",
  "referrals.": "إحالات.",
  "Confirmation Password": "تأكيد كلمة المرور",
  "Password and confirmation password should be same.": "يجب أن تكون كلمة المرور وتأكيد كلمة المرور متطابقتين.",
  "You haven't applied your voucher": "لم تستخدم قسيمتك",
  "Would you like to continue your payment without using your voucher?": "هل تريد المتابعة بالدفع دون استخدام قسيمتك؟",
  "Continue": "المتابعة",
  "Apply voucher": "استخدام القسيمة",
  "Transfer": "تحويل",
  "Transfer Tokens": "تحويل الرموز",
  "Please fill in the phone number": "يرجى إدخال رقم الهاتف",
  "Please fill in the email": "يرجى إدخال البريد الإلكتروني",
  "Please enter the phone number / email that you want to transfer to": "يرجى إدخال رقم الهاتف/البريد الإلكتروني الذي تريد التحويل إليه",
  "Please fill in the transfer amount": "يرجى إدخال مبلغ التحويل",
  "Transfer amount should be more than 0 and less than your current e-Token": "يجب أن يكون مبلغ التحويل أكثر من 0 وأقل من رموزك الإلكترونية الحالية",
  "Please enter your password": "يرجى إدخال كلمة المرور",
  "Member ID": "رقم العضوية",
  "E-Token Transfer Amount": "مبلغ تحويل الرمز الإلكتروني",
  "Please confirm the details before proceeding": "يرجى تأكيد التفاصيل قبل المتابعة",
  "Transfer From": "التحويل من",
  "Transfer To": "التحويل إلى",
  "Transfer Amount": "مبلغ التحويل",
  "Transfer Successfully!": "تم التحويل بنجاح!",
  "Transfer Time": "وقت التحويل",
  "Token": "رمز",
  "Done": "تم",
  "Next": "التالي",
  "Enter Password": "إدخال كلمة المرور",
  "Transfer E-Token Amount": "تحويل مبلغ الرمز الإلكتروني",
  "User not found": "المستخدم غير موجود",
  "Password is incorrect": "كلمة المرور غير صحيحة",
  "Please go to your account setting and reset your password": "يرجى الذهاب إلى إعدادات الحساب وإعادة تعيين كلمة المرور",
  "Only up to last 3 months transaction history": "سجل المعاملات لآخر 3 أشهر فقط",
  "Reload History": "سجل إعادة الشحن",
  "Transfer History": "سجل التحويلات",
  "{{ point }} History": "سجل {{ point }}",
  "Only up to last 3 months reload history": "سجل إعادة الشحن لآخر 3 أشهر فقط",
  "Only up to last 3 months transfer history": "سجل التحويلات لآخر 3 أشهر فقط",
  "Only up to last 3 months {{ point }} history": "سجل {{ point }} لآخر 3 أشهر فقط",
  "Only up to last 3 months laundry pass history": "سجل بطاقة الغسيل لآخر 3 أشهر فقط",
  "If require urgent response, please contact us through whatapp": "إذا كنت تحتاج إلى رد عاجل، يرجى الاتصال بنا عبر واتساب",
  "Please scan the QR code again": "يرجى مسح رمز QR مرة أخرى",
  "Home": "الرئيسية",
  "Quick": "سريع",
  "Super": "ممتاز",
  "Premium": "متميز",
  "All users will have infinite referrals.": "جميع المستخدمين لديهم إحالات غير محدودة.",
  "Collect 10 stamps to get 1 Voucher": "اجمع 10 أختام للحصول على قسيمة واحدة",
  "The voucher is only for customer use only, not for sale.": "القسيمة للاستخدام الشخصي للعميل فقط، وليست للبيع.",
  "Outlet is currently offline, please try again later": "المحل غير متصل حالياً، يرجى المحاولة مرة أخرى لاحقاً",
  "The voucher will be given if you completed a transaction with a minimum spending of": "سيتم منح القسيمة عند إكمال معاملة بحد أدنى للإنفاق",
  "The birthday voucher will be given on the first day of your birthday month.": "سيتم منح قسيمة عيد الميلاد في اليوم الأول من شهر عيد ميلادك.",
  "The voucher only will be given if you have exceed spending amount of": "سيتم منح القسيمة فقط إذا تجاوزت مبلغ الإنفاق",
  "Pay with KiplePay": "الدفع بـ KiplePay",
  "Pay with Scan2Pay": "الدفع بـ Scan2Pay",
  "Pay with Razer": "الدفع بـ Razer",
  "Pay with HitPay": "الدفع بـ HitPay",
  "Pay with Duitnow QR": "الدفع بـ Duitnow QR",
  "Pay with PagBank": "الدفع بـ PagBank",
  "Pay with PromptPay QR": "الدفع بـ PromptPay QR",
  "Pay with Card": "الدفع بالبطاقة",
  "Pay with PayWay": "الدفع بـ PayWay",
  "DISCOUNT CODE": "رمز الخصم",
  "Enter code >": "أدخل الرمز >",
  "Enter Discount Code": "أدخل رمز الخصم",
  "Remove Code": "إزالة الرمز",
  "Discount Code": "رمز الخصم",
  "Close": "إغلاق",
  "Please fill in your email address": "يرجى إدخال عنوان بريدك الإلكتروني",
  "Notification": "الإشعار",
  "Do you want to receive notification when wash cycle done?": "هل تريد تلقي إشعار عند انتهاء دورة الغسيل؟",
  "pay extra": "دفع إضافي",
  "Email Address": "عنوان البريد الإلكتروني",
  "Please fill in your phone number": "يرجى إدخال رقم هاتفك",
  "Invalid Phone Number": "رقم الهاتف غير صحيح",
  "Washing Complete": "اكتمل الغسيل",
  "Drying Complete": "اكتمل التجفيف",
  "The voucher will be given if you registered your account successfully, but it only can be used when your total transaction spending reach": "سيتم منح القسيمة عند تسجيل حسابك بنجاح، ولكن يمكن استخدامها فقط عندما يصل إجمالي إنفاقك في المعاملات إلى",
  "and above.": "وما فوق.",
  "This voucher is not applicable": "هذه القسيمة غير قابلة للتطبيق",
  "Finish in": "ينتهي في",
  "Need to refresh to update": "تحتاج إلى تحديث الصفحة للتحديث",
  "It's indicative and may change based on washer load": "هذا تقريبي وقد يتغير حسب حمولة الغسالة",
  "We'll let you know when it's ready to pick up": "سنعلمك عندما يكون جاهزاً للاستلام",
  "FREE": "مجاني",
  "Enter voucher code (if got any)": "أدخل رمز القسيمة (إن وجد)",
  "Please fill in the voucher code": "يرجى إدخال رمز القسيمة",
  "Available On": "متاح في",
  "Apply": "تطبيق",
  "Enter a code": "أدخل رمزاً",
  "Input Promo Code": "أدخل الرمز الترويجي",
  "Voucher is redeemed successfully!": "تم استخدام القسيمة بنجاح!",
  "Not available": "غير متاح",
  "Unable to register": "لا يمكن التسجيل",
  "Drop n Go Service": "خدمة Drop n Go",
  "Select Mode": "اختر النمط",
  "Quantity": "الكمية",
  "Pack": "باقة",
  "Add more": "إضافة المزيد",
  "Select Size": "اختر الحجم",
  "Select Services": "اختر الخدمات",
  "Are you sure to delete the item?": "هل تريد بالتأكيد حذف العنصر؟",
  "Delete": "حذف",
  "Your Duitnow QR code": "رمز Duitnow QR الخاص بك",
  "Your PromptPay QR code": "رمز PromptPay QR الخاص بك",
  "How to pay using Duitnow QR code?": "كيفية الدفع باستخدام رمز Duitnow QR؟",
  "How to pay using PromptPay QR code?": "كيفية الدفع باستخدام رمز PromptPay QR؟",
  "Launch": "تشغيل",
  "Launch your preferred Mobile Banking or eWallet app.": "شغل تطبيق البنك المحمول أو المحفظة الإلكترونية المفضل لديك.",
  "Scan QR code from Gallery": "مسح رمز QR من المعرض",
  "Choose DuitNow QR from your gallery.": "اختر DuitNow QR من معرضك.",
  "Confirm payment details and pay.": "تأكيد تفاصيل الدفع والدفع.",
  "Receive payment confirmation.": "تلقي تأكيد الدفع.",
  "expiring on": "ينتهي في",
  "Expired on": "انتهت في",
  "based on transaction payment amount": "بناءً على مبلغ الدفع",
  "Join as our": "انضم كـ",
  "Loyalty Member": "عضو في برنامج الولاء",
  "now to get more reward": "الآن للحصول على المزيد من المكافآت",
  "Payment amount should be greater than 0": "يجب أن يكون مبلغ الدفع أكبر من 0",
  // admin portal
  "Dashboard": "لوحة المعلومات",
  "Report": "التقرير",
  "Store Performance": "أداء المحل",
  "User Performance": "أداء المستخدم",
  "Voucher Redemption": "استرداد القسائم",
  "Token Report": "تقرير الرموز",
  "SMS Report": "تقرير الرسائل النصية",
  "Discount Code Report": "تقرير رموز الخصم",
  "User Details": "تفاصيل المستخدم",
  "User Compensation": "تعويض المستخدم",
  "Voucher Settings": "إعدادات القسائم",
  "Token Settings": "إعدادات الرموز",
  "Referral Settings": "إعدادات الإحالة",
  "Voucher Code": "رمز القسيمة",
  "Customize Color": "تخصيص اللون",
  "User Migration": "ترحيل المستخدم",
  "Back To": "العودة إلى",
  "Eligibility": "الأهلية",
  "If ticked, the voucher will have expired date": "إذا تم تحديده، سيكون للقسيمة تاريخ انتهاء",
  "Expiry": "الانتهاء",
  "If ticked, the voucher can apply to washer machine transaction": "إذا تم تحديده، يمكن تطبيق القسيمة على معاملات الغسالة",
  "Washer Use": "استخدام الغسالة",
  "If ticked, the voucher can apply to dryer machine transaction": "إذا تم تحديده، يمكن تطبيق القسيمة على معاملات المجفف",
  "Dryer Use": "استخدام المجفف",
  "If ticked, the voucher can apply to Drop n Go transaction": "إذا تم تحديده، يمكن تطبيق القسيمة على معاملات Drop n Go",
  "Package Use": "استخدام الباقة",
  "If ticked, the voucher can apply to vending machine transaction": "إذا تم التحديد، يمكن استخدام القسيمة في معاملات آلة البيع",
  "Vending Use": "استخدام آلة البيع",
  "If ticked, the voucher can apply to detergent vending machine transaction": "إذا تم التحديد، يمكن استخدام القسيمة في معاملات آلة بيع المنظفات",
  "Detergent Use": "استخدام آلة بيع المنظفات",
  "If ticked, the voucher can apply to car wash transaction": "إذا تم التحديد، يمكن استخدام القسيمة في معاملات غسيل السيارات",
  "Car Wash Use": "استخدام غسيل السيارات",
  "Voucher Lifespan": "مدة صلاحية القسيمة",
  "days": "أيام",
  "Discount Type": "نوع الخصم",
  "Select a discount type": "اختر نوع الخصم",
  "Flat": "مبلغ ثابت",
  "Rate": "نسبة",
  "Voucher Title": "عنوان القسيمة",
  "Voucher Description": "وصف القسيمة",
  "Voucher Amount": "قيمة القسيمة",
  "CONFIRM": "تأكيد",
  "If ticked, the system will give voucher to user who completed washer stamp collection": "إذا تم تحديده، سيمنح النظام قسيمة للمستخدم الذي أكمل جمع أختام الغسالة",
  "If ticked, the system will give voucher to user who completed dryer stamp collection": "إذا تم تحديده، سيمنح النظام قسيمة للمستخدم الذي أكمل جمع أختام المجفف",
  "If ticked, the user only can get/use the voucher after make a transaction": "إذا تم تحديده، يمكن للمستخدم الحصول على/استخدام القسيمة فقط بعد إجراء معاملة",
  "Pay And Get Voucher": "ادفع واحصل على قسيمة",
  "Pay And Use Code": "ادفع واستخدم الرمز",
  "If ticked, the system will only give the voucher to user after the user make a transaction": "إذا تم تحديده، سيمنح النظام القسيمة للمستخدم فقط بعد إجراء معاملة",
  "If ticked, the system will give voucher to user who completed registration process": "إذا تم تحديده، سيمنح النظام قسيمة للمستخدم الذي أكمل عملية التسجيل",
  "If ticked, the system will give voucher to user on their birthday month": "إذا تم تحديده، سيمنح النظام قسيمة للمستخدم في شهر عيد ميلاده",
  "If ticked, the system will give voucher to user who completed stamp collection": "إذا تم تحديده، سيمنح النظام قسيمة للمستخدم الذي أكمل جمع الأختام",
  "Minimum Payment Amount To Get/Use Register Voucher": "الحد الأدنى لمبلغ الدفع للحصول على/استخدام قسيمة التسجيل",
  "Voucher Method": "طريقة القسيمة",
  "Select a voucher method": "اختر طريقة القسيمة",
  "The user directly get the voucher after register but only can use it after make transaction": "يحصل المستخدم على القسيمة مباشرة بعد التسجيل ولكن يمكنه استخدامها فقط بعد إجراء معاملة",
  "The user only can get voucher after make a transaction": "يمكن للمستخدم الحصول على القسيمة فقط بعد إجراء معاملة",
  "Minimum Payment Amount To Get Birthday Voucher": "الحد الأدنى لمبلغ الدفع للحصول على قسيمة عيد الميلاد",
  "Minimum Payment Amount To Use Discount Code": "الحد الأدنى لمبلغ الدفع لاستخدام رمز الخصم",
  "Outlets": "المحلات",
  "E-Payment Sales": "مبيعات الدفع الإلكتروني",
  "Number of stamps granted to users": "عدد الأختام الممنوحة للمستخدمين",
  "Total number of stamps granted": "إجمالي عدد الأختام الممنوحة",
  "Registered Users": "المستخدمون المسجلون",
  "Stamps": "الأختام",
  "Referral": "الإحالة",
  "Register": "التسجيل",
  "Top Outlets": "أفضل المحلات",
  "Users": "المستخدمون",
  "Sort by": "ترتيب حسب",
  "Top Users": "أفضل المستخدمين",
  "User name": "اسم المستخدم",
  "Number": "الرقم",
  "Spending": "الإنفاق",
  "Number of registered users": "عدد المستخدمين المسجلين",
  "Number of voucher given to users": "عدد القسائم الممنوحة للمستخدمين",
  "Total number of voucher given": "إجمالي عدد القسائم الممنوحة",
  "Voucher Type": "نوع القسيمة",
  "Voucher Value": "قيمة القسيمة",
  "Date": "التاريخ",
  "Discount Code Type": "نوع رمز الخصم",
  "Discount Code Amount": "قيمة رمز الخصم",
  "Number of Redemption": "عدد مرات الاستخدام",
  "Total Discount Amount": "إجمالي مبلغ الخصم",
  "Select Outlet": "اختر المحل",
  "Select Date": "اختر التاريخ",
  "Select Transaction Date": "اختر تاريخ المعاملة",
  "Reset": "إعادة تعيين",
  "Download Report": "تنزيل التقرير",
  "Please fill in the remark": "يرجى إدخال الملاحظة",
  "Transaction Date": "تاريخ المعاملة",
  "Machine Type": "نوع الجهاز",
  "Machine Capacity": "سعة الجهاز",
  "Total Amount": "المبلغ الإجمالي",
  "Payment Amount": "مبلغ الدفع",
  "Discount From": "الخصم من",
  "Discount Amount": "مبلغ الخصم",
  "Action": "الإجراء",
  "Remark": "ملاحظة",
  "Refund Date": "تاريخ الاسترداد",
  "Refund": "استرداد",
  "Purchase Date": "تاريخ الشراء",
  "e-Token Purchased (Tokens)": "الرموز الإلكترونية المشتراة (رموز)",
  "Bought e-Token using": "شراء الرمز الإلكتروني باستخدام",
  "Transaction ID": "رقم المعاملة",
  "Method": "الطريقة",
  "Requery": "إعادة الاستعلام",
  "Reward Date": "تاريخ المكافأة",
  "Reward Type": "نوع المكافأة",
  "Notification Method": "طريقة الإشعار",
  "Email Preview": "معاينة البريد الإلكتروني",
  "Message for User": "رسالة للمستخدم",
  "SMS will send to user, please enter the message less than 130 characters": "ستُرسل الرسالة النصية للمستخدم، يرجى إدخال رسالة أقل من 130 حرفاً",
  "Enter the message to be sent to the user": "أدخل الرسالة التي سيتم إرسالها للمستخدم",
  "Email Address to show on Email Template": "عنوان البريد الإلكتروني لإظهاره في قالب البريد الإلكتروني",
  "Input Company Email Address": "أدخل عنوان بريد الشركة الإلكتروني",
  "Company Name to show on Email Template": "اسم الشركة لإظهاره في قالب البريد الإلكتروني",
  "Input Company Name": "أدخل اسم الشركة",
  "Company Phone No. to show on Email Template": "رقم هاتف الشركة لإظهاره في قالب البريد الإلكتروني",
  "Input Company Phone No.": "أدخل رقم هاتف الشركة",
  "Voucher ID": "رقم القسيمة",
  "Washer Stamp": "ختم الغسالة",
  "Dryer Stamp": "ختم المجفف",
  "e-Token Amount": "مبلغ الرمز الإلكتروني",
  "Transfer Date": "تاريخ التحويل",
  "Transfer Amount (Token)": "مبلغ التحويل (رمز)",
  "Number (Transfer From)": "الرقم (التحويل من)",
  "Name (Transfer From)": "الاسم (التحويل من)",
  "Member ID (Transfer From)": "رقم العضوية (التحويل من)",
  "Number (Transfer To)": "الرقم (التحويل إلى)",
  "Name (Transfer To)": "الاسم (التحويل إلى)",
  "Member ID (Transfer To)": "رقم العضوية (التحويل إلى)",
  "Grant Date": "تاريخ المنح",
  "Claim Date": "تاريخ الاستلام",
  "Member Details Report": "تقرير تفاصيل العضو",
  "Transaction Status": "حالة المعاملة",
  "Token Reload": "إعادة شحن الرموز",
  "Token Transfer": "تحويل الرموز",
  "Voucher History": "سجل القسائم",
  "TOKEN": "رمز",
  "Message Sent": "الرسالة المرسلة",
  "Date Sent": "تاريخ الإرسال",
  "Remaining SMS Credit": "رصيد الرسائل النصية المتبقي",
  "Store": "المحل",
  "Total Registered Users": "إجمالي المستخدمين المسجلين",
  "User registered but no transaction record": "مستخدم مسجل ولكن لا يوجد سجل معاملات",
  "Registered": "مسجل",
  "User spending is less than": "إنفاق المستخدم أقل من",
  "Active": "نشط",
  "User spending is from": "إنفاق المستخدم من",
  "until": "حتى",
  "Tier 1": "المستوى 1",
  "User spending is": "إنفاق المستخدم",
  "and above": "وما فوق",
  "Tier 2": "المستوى 2",
  "Average spending in each transaction": "متوسط الإنفاق في كل معاملة",
  "Average Spending": "متوسط الإنفاق",
  "Total number of transactions": "إجمالي عدد المعاملات",
  "Total Transactions": "إجمالي المعاملات",
  "Number of vouchers used in all the transactions": "عدد القسائم المستخدمة في جميع المعاملات",
  "Voucher Claimed": "القسائم المستخدمة",
  "Total number of washer machine transactions": "إجمالي عدد معاملات الغسالة",
  "Washer Usage": "استخدام الغسالة",
  "Total number of dryer machine transactions": "إجمالي عدد معاملات المجفف",
  "Dryer Usage": "استخدام المجفف",
  "User Name": "اسم المستخدم",
  "e-Token Spent": "الرموز الإلكترونية المنفقة",
  "e-Token Detailed Report": "تقرير تفصيلي للرموز الإلكترونية",
  "e-Token Purchase History": "سجل شراء الرموز الإلكترونية",
  "Select Purchase Date": "اختر تاريخ الشراء",
  "Outlet Name": "اسم المحل",
  "Total number of e-token used in all the transactions": "إجمالي عدد الرموز الإلكترونية المستخدمة في جميع المعاملات",
  "Total e-Token Collected": "إجمالي الرموز الإلكترونية المحصلة",
  "Total number of e-token used in washer machine transactions": "إجمالي عدد الرموز الإلكترونية المستخدمة في معاملات الغسالة",
  "Washer e-Token Collected": "الرموز الإلكترونية للغسالة المحصلة",
  "Total number of e-token used in dryer machine transactions": "إجمالي عدد الرموز الإلكترونية المستخدمة في معاملات المجفف",
  "Dryer e-Token Collected": "الرموز الإلكترونية للمجفف المحصلة",
  "Vending Machine e-Token Collected": "تم جمع الرمز الإلكتروني لآلة البيع",
  "Purchase History": "سجل الشراء",
  "All": "الكل",
  "Most Bought e-Token Package": "أكثر باقات الرموز الإلكترونية شراءً",
  "for": "لـ",
  "Tokens": "رموز",
  "Total Earned from users buying e-Tokens": "إجمالي الأرباح من شراء المستخدمين للرموز الإلكترونية",
  "Total e-Tokens Bought from you": "إجمالي الرموز الإلكترونية المشتراة منك",
  "Join Date": "تاريخ الانضمام",
  "Channel": "القناة",
  "Tier": "المستوى",
  "Referrer": "المُحيل",
  "Referrals": "الإحالات",
  "Number of transactions for last 7 days": "عدد المعاملات لآخر 7 أيام",
  "Number of Usage (in week)": "عدد مرات الاستخدام (في الأسبوع)",
  "Number of transactions for last 1 month": "عدد المعاملات لآخر شهر",
  "Number of Usage (in month)": "عدد مرات الاستخدام (في الشهر)",
  "Total amount spent in all the transactions": "إجمالي المبلغ المنفق في جميع المعاملات",
  "Total Spent": "إجمالي المنفق",
  "Last Transaction Date": "تاريخ آخر معاملة",
  "Number of vouchers collected": "عدد القسائم المحصلة",
  "Voucher Collected": "القسائم المحصلة",
  "Number of vouchers used": "عدد القسائم المستخدمة",
  "Voucher Spent": "القسائم المستخدمة",
  "Washer Used": "الغسالة المستخدمة",
  "Dryer Used": "المجفف المستخدم",
  "Total number of e-Token spent in all the transactions": "إجمالي عدد الرموز الإلكترونية المنفقة في جميع المعاملات",
  "Total number of stamps collected": "إجمالي عدد الأختام المحصلة",
  "Total Stamps": "إجمالي الأختام",
  "Select Join Date": "اختر تاريخ الانضمام",
  "Select Grant Date": "اختر تاريخ المنح",
  "Amount": "المبلغ",
  "The image size is over 2MB": "حجم الصورة أكبر من 2 ميجابايت",
  "Duplicate language selected": "تم اختيار لغة مكررة",
  "Are you sure you want to add FAQ?": "هل تريد بالتأكيد إضافة سؤال شائع؟",
  "FAQ added successfully": "تم إضافة السؤال الشائع بنجاح",
  "FAQ Group added successfully": "تم إضافة مجموعة الأسئلة الشائعة بنجاح",
  "Please provide the faq with the default language": "يرجى توفير السؤال الشائع باللغة الافتراضية",
  "Add FAQ": "إضافة سؤال شائع",
  "Default Language": "اللغة الافتراضية",
  "Select Default Language": "اختر اللغة الافتراضية",
  "Image (Optional)": "صورة (اختيارية)",
  "max": "الحد الأقصى",
  "Question": "السؤال",
  "Select Language": "اختر اللغة",
  "Remove": "إزالة",
  "Answer": "الإجابة",
  "Add Translation": "إضافة ترجمة",
  "Are you sure you want to add FAQ Group?": "هل تريد بالتأكيد إضافة مجموعة الأسئلة الشائعة؟",
  "Please provide the faq group with the default language": "يرجى توفير مجموعة الأسئلة الشائعة باللغة الافتراضية",
  "Add FAQ Group": "إضافة مجموعة الأسئلة الشائعة",
  "Title": "العنوان",
  "Title Language": "لغة العنوان",
  "Please fill in the title": "يرجى ملء العنوان",
  "Please fill in the description": "يرجى ملء الوصف",
  "Please fill in the short description": "يرجى ملء الوصف المختصر",
  "Please select the end date for your news": "يرجى اختيار تاريخ انتهاء الأخبار",
  "Please provide the news with the default language": "يرجى توفير الأخبار باللغة الافتراضية",
  "Please provide the banner image": "يرجى توفير صورة البانر",
  "Please provide the news image": "يرجى توفير صورة الأخبار",
  "Are you sure you want to add news?": "هل تريد بالتأكيد إضافة أخبار؟",
  "News added successfully": "تم إضافة الأخبار بنجاح",
  "Please fill in all the required fields before submit": "يرجى ملء جميع الحقول المطلوبة قبل الإرسال",
  "Add News": "إضافة أخبار",
  "Banner Image": "صورة البانر",
  "News Image": "صورة الأخبار",
  "Banner": "البانر",
  "aspect ratio": "نسبة العرض إلى الارتفاع",
  "Image": "الصورة",
  "Display in": "عرض في",
  "Inbox Page": "صفحة البريد الوارد",
  "Promotion Banner": "بانر العروض",
  "Select Period: (optional)": "اختر الفترة: (اختيارية)",
  "Short Description": "وصف مختصر",
  "Your theme has been updated successfully": "تم تحديث المظهر بنجاح",
  "Default Theme": "المظهر الافتراضي",
  "Change Logo": "تغيير الشعار",
  "REMOVE LOGO": "إزالة الشعار",
  "Sms credit used up": "نفد رصيد الرسائل النصية",
  "Please top up your sms credit": "يرجى شحن رصيد الرسائل النصية",
  "Please": "يرجى",
  "Again": "مرة أخرى",
  "Welcome": "مرحباً",
  "Ranking": "التصنيف",
  "Select Year": "اختر السنة",
  "Missing Field": "حقل مفقود",
  "Please select can be used for which type of transaction": "يرجى اختيار نوع المعاملة التي يمكن استخدامها",
  "Please fill in the start date and end date": "يرجى ملء تاريخ البداية وتاريخ النهاية",
  "Discount amount should be more than 0": "يجب أن يكون مبلغ الخصم أكثر من 0",
  "Redeem per user should be more than 0": "يجب أن يكون عدد مرات الاستخدام لكل مستخدم أكثر من 0",
  "Redeem per day should be more than 0": "يجب أن يكون عدد مرات الاستخدام يومياً أكثر من 0",
  "Your discount code have edited successfully": "تم تعديل رمز الخصم بنجاح",
  "Your discount code have added successfully": "تم إضافة رمز الخصم بنجاح",
  "Delete this entry?": "حذف هذا الإدخال؟",
  "Your discount code have deleted successfully": "تم حذف رمز الخصم بنجاح",
  "Created Date": "تاريخ الإنشاء",
  "Discount code": "رمز الخصم",
  "General Discount Code": "رمز خصم عام",
  "Unique Discount Code": "رمز خصم فريد",
  "Start Date": "تاريخ البداية",
  "End Date": "تاريخ النهاية",
  "Redeem Per User": "استخدام لكل مستخدم",
  "Redeem Per Day": "استخدام لكل يوم",
  "Add Discount Code": "إضافة رمز خصم",
  "Generate Discount Code": "إنشاء رمز خصم",
  "No Discount Code": "لا يوجد رمز خصم",
  "Edit Discount Code": "تعديل رمز الخصم",
  "Select Period": "اختر الفترة",
  "Redeem per user": "استخدام لكل مستخدم",
  "How many times the discount code can be used for each user": "كم مرة يمكن استخدام رمز الخصم لكل مستخدم",
  "Redeem per day": "استخدام لكل يوم",
  "How many times the discount code can be used in one day": "كم مرة يمكن استخدام رمز الخصم في يوم واحد",
  "If ticked, the discount code can apply to washer machine transaction": "إذا تم تحديده، يمكن تطبيق رمز الخصم على معاملات الغسالة",
  "If ticked, the discount code can apply to dryer machine transaction": "إذا تم تحديده، يمكن تطبيق رمز الخصم على معاملات المجفف",
  "If ticked, the discount code can apply to Drop n Go transaction": "إذا تم تحديده، يمكن تطبيق رمز الخصم على معاملات Drop n Go",
  "If ticked, the discount code can apply to vending machine transaction": "إذا تم التحديد، يمكن استخدام رمز الخصم في معاملات آلة البيع",
  "If ticked, the discount code can apply to detergent vending machine transaction": "إذا تم التحديد، يمكن استخدام رمز الخصم في معاملات آلة بيع المنظفات",
  "If ticked, the discount code can apply to car wash transaction": "إذا تم التحديد، يمكن استخدام رمز الخصم في معاملات غسيل السيارات",
  "The user enter the discount code": "المستخدم يدخل رمز الخصم",
  "in the payment page will get": "في صفحة الدفع سيحصل على",
  "discount": "خصم",
  "The discount code only can be used start from {{ start_date }} until {{ end_date }}": "يمكن استخدام رمز الخصم فقط من {{ start_date }} حتى {{ end_date }}",
  "Every user only can use the discount code {{ redeem_per_user }} times": "كل مستخدم يمكنه استخدام رمز الخصم {{ redeem_per_user }} مرات فقط",
  "Every user only can use {{ redeem_per_user }} discount code from this batch of code": "كل مستخدم يمكنه استخدام {{ redeem_per_user }} رمز خصم من هذه المجموعة فقط",
  "Only {{ redeem_per_day }} transactions can use the discount code in one day_one": "معاملة واحدة فقط يمكنها استخدام رمز الخصم في اليوم الواحد",
  "Only {{ redeem_per_day }} transactions can use the discount code in one day_other": "فقط {{ redeem_per_day }} معاملات يمكنها استخدام رمز الخصم في اليوم الواحد",
  "The discount code only can be used for washer machine": "يمكن استخدام رمز الخصم لجهاز الغسيل فقط",
  "The discount code only can be used for dryer machine": "يمكن استخدام رمز الخصم لجهاز التجفيف فقط",
  "The discount code only can be used for Drop n Go transaction": "يمكن استخدام رمز الخصم لمعاملات Drop n Go فقط",
  "The discount code only can be used for vending machine transaction": "يمكن استخدام رمز الخصم فقط في معاملات آلة البيع",
  "The discount code only can be used for detergent vending machine transaction": "يمكن استخدام رمز الخصم فقط في معاملات آلة بيع المنظفات",
  "The discount code only can be used for car wash transaction": "يمكن استخدام رمز الخصم فقط في معاملات غسيل السيارات",
  "The discount code can be used for washer machine or Drop n Go transaction": "يمكن استخدام رمز الخصم لجهاز الغسيل أو معاملات Drop n Go",
  "The discount code can be used for dryer machine or Drop n Go transaction": "يمكن استخدام رمز الخصم لجهاز التجفيف أو معاملات Drop n Go",
  "The discount code can be used for washer machine, dryer machine or Drop n Go transaction": "يمكن استخدام رمز الخصم لجهاز الغسيل أو التجفيف أو معاملات Drop n Go",
  "The discount code can be used for washer or dryer machine": "يمكن استخدام رمز الخصم لجهاز الغسيل أو التجفيف",
  "The discount code can be used for washer machine or vending machine transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس أو آلة البيع",
  "The discount code can be used for washer machine or detergent vending machine transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس أو آلة بيع المنظفات",
  "The discount code can be used for washer machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس أو غسيل السيارات",
  "The discount code can be used for dryer machine or vending machine transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس أو آلة البيع",
  "The discount code can be used for dryer machine or detergent vending machine transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس أو آلة بيع المنظفات",
  "The discount code can be used for dryer machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس أو غسيل السيارات",
  "The discount code can be used for vending machine or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات آلة البيع أو Drop n Go",
  "The discount code can be used for detergent vending machine or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات آلة بيع المنظفات أو Drop n Go",
  "The discount code can be used for car wash or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات غسيل السيارات أو Drop n Go",
  "The discount code can be used for vending machine or detergent vending machine transaction": "يمكن استخدام رمز الخصم في معاملات آلة البيع أو آلة بيع المنظفات",
  "The discount code can be used for vending machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات آلة البيع أو غسيل السيارات",
  "The discount code can be used for detergent vending machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات آلة بيع المنظفات أو غسيل السيارات",
  "The discount code can be used for washer machine, dryer machine or vending machine transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة تجفيف الملابس أو آلة البيع",
  "The discount code can be used for washer machine, dryer machine or detergent vending machine transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة تجفيف الملابس أو آلة بيع المنظفات",
  "The discount code can be used for washer machine, dryer machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة تجفيف الملابس أو غسيل السيارات",
  "The discount code can be used for washer machine, vending machine or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة البيع أو Drop n Go",
  "The discount code can be used for washer machine, detergent vending machine or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة بيع المنظفات أو Drop n Go",
  "The discount code can be used for washer machine, car wash or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، غسيل السيارات أو Drop n Go",
  "The discount code can be used for washer machine, vending machine or detergent vending machine transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة البيع أو آلة بيع المنظفات",
  "The discount code can be used for washer machine, vending machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة البيع أو غسيل السيارات",
  "The discount code can be used for washer machine, detergent vending machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة بيع المنظفات أو غسيل السيارات",
  "The discount code can be used for dryer machine, vending machine or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس، آلة البيع أو Drop n Go",
  "The discount code can be used for dryer machine, detergent vending machine or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس، آلة بيع المنظفات أو Drop n Go",
  "The discount code can be used for dryer machine, car wash or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس، غسيل السيارات أو Drop n Go",
  "The discount code can be used for dryer machine, vending machine or detergent vending machine transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس، آلة البيع أو آلة بيع المنظفات",
  "The discount code can be used for dryer machine, vending machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس، آلة البيع أو غسيل السيارات",
  "The discount code can be used for dryer machine, detergent vending machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس، آلة بيع المنظفات أو غسيل السيارات",
  "The discount code can be used for vending machine, detergent vending machine or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات آلة البيع، آلة بيع المنظفات أو Drop n Go",
  "The discount code can be used for vending machine, car wash or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات آلة البيع، غسيل السيارات أو Drop n Go",
  "The discount code can be used for detergent vending machine, car wash or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات آلة بيع المنظفات، غسيل السيارات أو Drop n Go",
  "The discount code can be used for vending machine, detergent vending machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات آلة البيع، آلة بيع المنظفات أو غسيل السيارات",
  "The discount code can be used for washer machine, dryer machine, vending machine or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة تجفيف الملابس، آلة البيع أو Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة تجفيف الملابس، آلة البيع أو آلة بيع المنظفات",
  "The discount code can be used for washer machine, dryer machine, vending machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة تجفيف الملابس، آلة البيع أو غسيل السيارات",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة تجفيف الملابس، آلة بيع المنظفات أو غسيل السيارات",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة البيع، آلة بيع المنظفات أو Drop n Go",
  "The discount code can be used for washer machine, vending machine, car wash or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة البيع، غسيل السيارات أو Drop n Go",
  "The discount code can be used for washer machine, vending machine, detergent vending machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة البيع، آلة بيع المنظفات أو غسيل السيارات",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس، آلة البيع، آلة بيع المنظفات أو Drop n Go",
  "The discount code can be used for dryer machine, vending machine, car wash or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس، آلة البيع، غسيل السيارات أو Drop n Go",
  "The discount code can be used for dryer machine, detergent vending machine, car wash machine or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس، آلة بيع المنظفات، آلة غسيل السيارات أو Drop n Go",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس، آلة البيع، آلة بيع المنظفات أو غسيل السيارات",
  "The discount code can be used for vending machine, detergent vending machine, car wash or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات آلة البيع، آلة بيع المنظفات، غسيل السيارات أو Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة تجفيف الملابس، آلة البيع، آلة بيع المنظفات أو Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine, car wash or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة تجفيف الملابس، آلة البيع، غسيل السيارات أو Drop n Go",
  "The discount code can be used for washer machine, dryer machine, detergent vending machine, car wash or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة تجفيف الملابس، آلة بيع المنظفات، غسيل السيارات أو Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or car wash transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة تجفيف الملابس، آلة البيع، آلة بيع المنظفات أو غسيل السيارات",
  "The discount code can be used for washer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة البيع، آلة بيع المنظفات، غسيل السيارات أو Drop n Go",
  "The discount code can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات آلة تجفيف الملابس، آلة البيع، آلة بيع المنظفات، غسيل السيارات أو Drop n Go",
  "The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction": "يمكن استخدام رمز الخصم في معاملات غسالة الملابس، آلة تجفيف الملابس، آلة البيع، آلة بيع المنظفات، غسيل السيارات أو Drop n Go",
  "The discount code only can be used after user spending {{ currency }} {{ pay_and_use_amount }}": "يمكن استخدام رمز الخصم فقط بعد إنفاق المستخدم {{ currency }} {{ pay_and_use_amount }}",
  "Are you sure you want to edit FAQ?": "هل تريد بالتأكيد تعديل السؤال الشائع؟",
  "FAQ updated successfully": "تم تحديث السؤال الشائع بنجاح",
  "Edit FAQ": "تعديل سؤال شائع",
  "Are you sure you want to edit FAQ Group?": "هل تريد بالتأكيد تعديل مجموعة الأسئلة الشائعة؟",
  "FAQ Group updated successfully": "تم تحديث مجموعة الأسئلة الشائعة بنجاح",
  "Edit FAQ Group": "تعديل مجموعة الأسئلة الشائعة",
  "Are you sure you want to edit news?": "هل تريد بالتأكيد تعديل الأخبار؟",
  "News edit successfully": "تم تعديل الأخبار بنجاح",
  "Edit News": "تعديل الأخبار",
  "All the FAQ under this group will be deleted. Are you sure you want to delete FAQ Group?": "سيتم حذف جميع الأسئلة الشائعة في هذه المجموعة. هل تريد بالتأكيد حذف مجموعة الأسئلة الشائعة؟",
  "FAQ Group deleted successfully": "تم حذف مجموعة الأسئلة الشائعة بنجاح",
  "FAQ List": "قائمة الأسئلة الشائعة",
  "NO FAQ GROUP": "لا توجد مجموعة أسئلة شائعة",
  "FAQ Group": "مجموعة الأسئلة الشائعة",
  "Are you sure you want to delete FAQ?": "هل تريد بالتأكيد حذف السؤال الشائع؟",
  "FAQ deleted successfully": "تم حذف السؤال الشائع بنجاح",
  "NO FAQs": "لا توجد أسئلة شائعة",
  "FAQ": "أسئلة شائعة",
  "Easy": "سهل",
  "Fast Laundromate": "مغسلة سريعة",
  "Smart Laundry Management System": "نظام إدارة الغسيل الذكي",
  "Enter your username and password to login": "أدخل اسم المستخدم وكلمة المرور لتسجيل الدخول",
  "Username": "اسم المستخدم",
  "Are you sure you want to delete news?": "هل تريد بالتأكيد حذف الأخبار؟",
  "News deleted successfully": "تم حذف الأخبار بنجاح",
  "NO NEWS": "لا توجد أخبار",
  "The referral setting has been updated successfully!": "تم تحديث إعدادات الإحالة بنجاح!",
  "Number of Stamp": "عدد الطوابع",
  "Number of Washer Stamp": "عدد طوابع الغسالة",
  "Number of Dryer Stamp": "عدد طوابع المجفف",
  "Enable Referral Feature?": "تفعيل ميزة الإحالة؟",
  "Are you sure you want to delete the tier setting?": "هل أنت متأكد أنك تريد حذف إعداد المستوى؟",
  "Minimum referee transaction amount for referrer to get referral rewards": "الحد الأدنى لمبلغ معاملة المحال لحصول المحيل على مكافآت الإحالة",
  "Maximum number of reward within this tier": "العدد الأقصى للمكافآت ضمن هذا المستوى",
  "Maximum number of reward can get from same user": "العدد الأقصى للمكافآت التي يمكن الحصول عليها من نفس المستخدم",
  "Point Grant Type": "نوع منح النقاط",
  "Select Point Grant Type": "اختر نوع منح النقاط",
  "Token Grant Type": "نوع منح الرمز المميز",
  "Select Token Grant Type": "اختر نوع منح الرمز المميز",
  "Add Tier": "إضافة مستوى",
  "Stamp": "طابع",
  "If ticked, the system will give stamp to user": "إذا تم تحديدها، سيمنح النظام طابعاً للمستخدم",
  "If ticked, the system will give e-Token to user": "إذا تم تحديدها، سيمنح النظام رمزاً إلكترونياً للمستخدم",
  "If ticked, the system will give voucher to user": "إذا تم تحديدها، سيمنح النظام قسيمة للمستخدم",
  "Number of E-Token": "عدد الرموز الإلكترونية",
  "Reward Giveaway": "توزيع المكافآت",
  "Which type of reward you want to give to customer?": "أي نوع من المكافآت تريد أن تمنحه للعميل؟",
  "For machine uses (required)": "لاستخدام الآلة (مطلوب)",
  "leave blank if no expiry date": "اتركه فارغاً إذا لم يكن هناك تاريخ انتهاء صلاحية",
  "Remarks": "ملاحظات",
  "Reward": "مكافأة",
  "Please fill in all the required field. (Title, description, and amount must be more than 0)": "يرجى ملء جميع الحقول المطلوبة. (العنوان والوصف والمبلغ يجب أن تكون أكثر من 0)",
  "Checkbox required": "مربع الاختيار مطلوب",
  "Must select voucher can be used for washer, dryer or package": "يجب اختيار ما إذا كانت القسيمة يمكن استخدامها للغسالة أو المجفف أو الحزمة",
  "How many e-token?": "كم عدد الرموز الإلكترونية؟",
  "Number of e-Token": "عدد الرموز الإلكترونية",
  "Token value must be more than 0": "قيمة الرمز يجب أن تكون أكثر من 0",
  "STAMP": "طابع",
  "Please fill in at least one of the required field": "يرجى ملء واحد على الأقل من الحقول المطلوبة",
  "The value must be more than 0": "القيمة يجب أن تكون أكثر من 0",
  "How many times rewarded to user": "كم مرة تم إعطاء المكافأة للمستخدم",
  "Rewarded Times": "مرات المكافأة",
  "How many times rewarded voucher to user": "كم مرة تم إعطاء القسيمة للمستخدم",
  "Voucher Rewarded (times)": "القسائم الممنوحة (مرات)",
  "How many times rewarded stamp to user": "كم مرة تم إعطاء الطابع للمستخدم",
  "Stamps Rewarded (times)": "الطوابع الممنوحة (مرات)",
  "Total number of washer stamps rewarded to user": "إجمالي عدد طوابع الغسالة الممنوحة للمستخدم",
  "Washer Stamps Granted (stamp)": "طوابع الغسالة الممنوحة (طابع)",
  "Total number of dryer stamps rewarded to user": "إجمالي عدد طوابع المجفف الممنوحة للمستخدم",
  "Dryer Stamps Granted (stamp)": "طوابع المجفف الممنوحة (طابع)",
  "How many times rewarded e-Token to user": "كم مرة تم إعطاء الرمز الإلكتروني للمستخدم",
  "e-Token Rewarded (times)": "الرموز الإلكترونية الممنوحة (مرات)",
  "Total number of e-Token rewarded to user": "إجمالي عدد الرموز الإلكترونية الممنوحة للمستخدم",
  "Total e-Token Granted (token)": "إجمالي الرموز الإلكترونية الممنوحة (رمز)",
  "Point Rewarded (times)": "النقاط الممنوحة (مرات)",
  "How many times rewarded point to user": "كم مرة تم إعطاء النقاط للمستخدم",
  "Total Point Granted (point)": "إجمالي النقاط الممنوحة (نقطة)",
  "Total number of point rewarded to user": "إجمالي عدد النقاط الممنوحة للمستخدم",
  "Point Amount": "مبلغ النقاط",
  "Reward History": "تاريخ المكافآت",
  "Are you sure you want to change how the stamping mechanics works?": "هل أنت متأكد أنك تريد تغيير كيفية عمل آلية الطوابع؟",
  "The stamping mechanics setting has updated successfully!": "تم تحديث إعدادات آلية الطوابع بنجاح!",
  "The voucher setting has been updated successfully!": "تم تحديث إعدادات القسيمة بنجاح!",
  "Mechanics Settings": "إعدادات الآلية",
  "Minimum transaction amount for getting stamp": "الحد الأدنى لمبلغ المعاملة للحصول على طابع",
  "Select User Stamping Mechanic": "اختر آلية طوابع المستخدم",
  "Separated Stamping": "طوابع منفصلة",
  "Combined Stamping": "طوابع مدمجة",
  "Stamp for?": "طابع لـ؟",
  "Both": "كلاهما",
  "Washer Only": "الغسالة فقط",
  "Dryer Only": "المجفف فقط",
  "Separated Stamping = Different washer and dryer stamp collection. (example: Using Washer will gain 1 washer's stamp, and Dryer will gain 1 dryer stamp)": "الطوابع المنفصلة = مجموعة طوابع مختلفة للغسالة والمجفف. (مثال: استخدام الغسالة سيكسب طابع غسالة واحد، والمجفف سيكسب طابع مجفف واحد)",
  "Combined Stamping = Washer and dryer has the same collection. (example: Using Washer or Dryer will gain 1 stamp)": "الطوابع المدمجة = الغسالة والمجفف لهما نفس المجموعة. (مثال: استخدام الغسالة أو المجفف سيكسب طابعاً واحداً)",
  "Stamp for": "طابع لـ",
  "User will be able to collect both washer stamp and dryer stamp": "سيتمكن المستخدم من جمع طوابع الغسالة وطوابع المجفف",
  "User will only able to collect Washer stamp": "سيتمكن المستخدم فقط من جمع طوابع الغسالة",
  "User will only able to collect Dryer stamp": "سيتمكن المستخدم فقط من جمع طوابع المجفف",
  "Registration": "التسجيل",
  "Birthday": "عيد الميلاد",
  "Please choose at least one payment method": "يرجى اختيار طريقة دفع واحدة على الأقل",
  "Please choose at least one member or non-member payment": "يرجى اختيار دفع عضو أو غير عضو واحد على الأقل",
  "Are you sure you want to change the payment setting?": "هل أنت متأكد أنك تريد تغيير إعدادات الدفع؟",
  "The payment setting has updated successfully!": "تم تحديث إعدادات الدفع بنجاح!",
  "Invalid input": "إدخال غير صحيح",
  "The price and token must be more than 0": "السعر والرمز يجب أن يكونا أكثر من 0",
  "Maximum number of purchase must be more than 0": "العدد الأقصى للشراء يجب أن يكون أكثر من 0",
  "Point amount must be more than 1": "مبلغ النقاط يجب أن يكون أكثر من 1",
  "Added a new Token Bundle Package": "تمت إضافة حزمة رموز جديدة",
  "Bundle deleted successfully!": "تم حذف الحزمة بنجاح!",
  "Reload voucher setting have edited successfully!": "تم تعديل إعدادات قسيمة إعادة التحميل بنجاح!",
  "Added on": "مُضاف في",
  "remove": "إزالة",
  "edit": "تعديل",
  "NO PACKAGES ON SALES": "لا توجد حزم في المبيعات",
  "Point Settings": "إعدادات النقاط",
  "Enable Loyalty Point": "تفعيل نقاط الولاء",
  "Point Name": "اسم النقطة",
  "Number Of Point Equals To": "عدد النقاط يساوي",
  "If ticked, the point will have expired date": "إذا تم تحديدها، ستكون للنقطة تاريخ انتهاء صلاحية",
  "Point Lifespan": "فترة صلاحية النقطة",
  "months": "أشهر",
  "Minimum Transaction Amount To Get Point": "الحد الأدنى لمبلغ المعاملة للحصول على نقطة",
  "Point Grant Amount": "مبلغ منح النقاط",
  "Point Grant Period": "فترة منح النقاط",
  "Optional": "اختياري",
  "Drop n Go Eligibility": "أهلية الإسقاط والذهاب",
  "If ticked, Drop n Go transaction will get the point": "إذا تم تحديدها، ستحصل معاملة الإسقاط والذهاب على النقطة",
  "Point settings updated successfully!": "تم تحديث إعدادات النقاط بنجاح!",
  "Point Eligibility": "أهلية النقطة",
  "If ticked, the system will give point to user when user reload token successfully": "إذا تم تحديدها، سيمنح النظام نقطة للمستخدم عند إعادة تحميل الرمز بنجاح",
  "{{ point_amount }} point will be given after user reload token successfully": "{{ point_amount }} نقطة ستُمنح بعد إعادة تحميل المستخدم للرمز بنجاح",
  "Payment Settings": "إعدادات الدفع",
  "Select Payment Method": "اختر طريقة الدفع",
  "Enable E-Payment?": "تفعيل الدفع الإلكتروني؟",
  "Enable Token Currency?": "تفعيل عملة الرمز؟",
  "Enable Cash Payment?": "تفعيل الدفع النقدي؟",
  "Enable QR Payment?": "تفعيل دفع رمز الاستجابة السريعة؟",
  "Member and Non-Member Settings": "إعدادات العضو وغير العضو",
  "Enable Member Payment?": "تفعيل دفع العضو؟",
  "Enable Non-Member Payment?": "تفعيل دفع غير العضو؟",
  "Promotion Settings": "إعدادات العروض الترويجية",
  "Enable Non Member Promotion?": "تفعيل عروض غير الأعضاء؟",
  "Enable Notification When Cycle Done?": "تفعيل الإشعار عند انتهاء الدورة؟",
  "SMS charges": "رسوم الرسائل النصية",
  "SMS Settings": "إعدادات الرسائل النصية",
  "Enable Free Sms For Members": "تفعيل الرسائل النصية المجانية للأعضاء",
  "If enable notification, user can choose either receive email or sms when complete washing or drying": "إذا تم تفعيل الإشعار، يمكن للمستخدم اختيار تلقي إيميل أو رسالة نصية عند إكمال الغسل أو التجفيف",
  "If user choose sms, non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "إذا اختار المستخدم الرسالة النصية، يجب على غير العضو دفع {{ currency }}{{ sms_notification_amount }} إضافية للرسالة النصية",
  "If user choose sms, member and non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "إذا اختار المستخدم الرسالة النصية، يجب على العضو وغير العضو دفع {{ currency }}{{ sms_notification_amount }} إضافية للرسالة النصية",
  "Add Package": "إضافة حزمة",
  "Edit e-Token Package": "تعديل حزمة الرمز الإلكتروني",
  "Add e-Token Package": "إضافة حزمة رمز إلكتروني",
  "Please only input numberic value to prevent any bugs.": "يرجى إدخال قيم رقمية فقط لمنع أي أخطاء.",
  "Price": "السعر",
  "If ticked, the system will limit the number of purchase": "إذا تم تحديدها، سيحدد النظام عدد مرات الشراء",
  "Limit Number of Purchase": "حد عدد مرات الشراء",
  "Number of maximum purchase": "العدد الأقصى للشراء",
  "Reload Voucher": "قسيمة إعادة التحميل",
  "If ticked, the system will give voucher to user when user reload token successfully": "إذا تم تحديدها، سيمنح النظام قسيمة للمستخدم عند إعادة تحميل الرمز بنجاح",
  "If ticked, the system will give voucher repeatly": "إذا تم تحديدها، سيمنح النظام القسيمة بشكل متكرر",
  "Recurring": "متكرر",
  "Total number of voucher given to user": "إجمالي عدد القسائم الممنوحة للمستخدم",
  "Period for giving next voucher": "فترة إعطاء القسيمة التالية",
  "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens_one": "حزمة رمز {{ currency }}{{ price }} لـ {{ numberOfToken }} رمز",
  "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens_other": "حزمة رمز {{ currency }}{{ price }} لـ {{ numberOfToken }} رمز",
  "Each user only can purchase {{ max_purchase }} times for the token package": "كل مستخدم يمكنه شراء حزمة الرمز {{ max_purchase }} مرات فقط",
  "Voucher will be given after user reload token successfully": "ستُمنح القسيمة بعد إعادة تحميل المستخدم للرمز بنجاح",
  "Voucher will not given after user reload tokens successfully": "لن تُمنح القسيمة بعد إعادة تحميل المستخدم للرموز بنجاح",
  "The voucher will be expired after {{ voucher_duration }} days_one": "ستنتهي صلاحية القسيمة بعد {{ voucher_duration }} يوم",
  "The voucher will be expired after {{ voucher_duration }} days_other": "ستنتهي صلاحية القسيمة بعد {{ voucher_duration }} يوم",
  "The voucher will not expired": "لن تنتهي صلاحية القسيمة",
  "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount_one": "إجمالي {{ recurring_number }} قسيمة ستُمنح للمستخدم وكل قسيمة ستحصل على خصم",
  "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount_other": "إجمالي {{ recurring_number }} قسيمة ستُمنح للمستخدم وكل قسيمة ستحصل على خصم",
  "Edit Package": "تعديل الحزمة",
  "Age": "العمر",
  "Total number of vouchers collected": "إجمالي عدد القسائم المجمعة",
  "Vouchers Acquired": "القسائم المكتسبة",
  "Total amount spent in washer machine transactions": "إجمالي المبلغ المنفق في معاملات الغسالة",
  "Total Washer Payment": "إجمالي دفع الغسالة",
  "Total amount spent in dryer machine transactions": "إجمالي المبلغ المنفق في معاملات المجفف",
  "Total Dryer Payment": "إجمالي دفع المجفف",
  "Total amount spent in all transactions": "إجمالي المبلغ المنفق في جميع المعاملات",
  "Total Payment": "إجمالي الدفع",
  "report": "تقرير",
  "Total amount spent for buying e-Token": "إجمالي المبلغ المنفق لشراء الرمز الإلكتروني",
  "Total number of e-Token purchased": "إجمالي عدد الرموز الإلكترونية المشتراة",
  "Total e-Token Purchased (Tokens)": "إجمالي الرموز الإلكترونية المشتراة (رموز)",
  "Total number of e-Token used in washer machine transactions": "إجمالي عدد الرموز الإلكترونية المستخدمة في معاملات الغسالة",
  "Washer Payment (Tokens)": "دفع الغسالة (رموز)",
  "Total number of e-Token used in dryer machine transactions": "إجمالي عدد الرموز الإلكترونية المستخدمة في معاملات المجفف",
  "Dryer Payment (Tokens)": "دفع المجفف (رموز)",
  "Total number of e-Token used in all the transactions": "إجمالي عدد الرموز الإلكترونية المستخدمة في جميع المعاملات",
  "Total Payment (Tokens)": "إجمالي الدفع (رموز)",
  "Number of washer stamp collected currently": "عدد طوابع الغسالة المجمعة حالياً",
  "Number of dryer stamp collected currently": "عدد طوابع المجفف المجمعة حالياً",
  "User Phone Number / Member ID / Email": "رقم هاتف المستخدم / معرف العضو / الإيميل",
  "Example: 0123456789,A123456": "مثال: 0123456789,A123456",
  "SEARCH": "بحث",
  "Total Users Registered": "إجمالي المستخدمين المسجلين",
  "Total Active Outlets": "إجمالي المنافذ النشطة",
  "Total Vouchers Given": "إجمالي القسائم الممنوحة",
  "Total Transaction Counts": "إجمالي عدد المعاملات",
  "Total User Stamps Collected": "إجمالي طوابع المستخدمين المجمعة",
  "Distributor Login": "تسجيل دخول الموزع",
  "Client Login": "تسجيل دخول العميل",
  "Kiosk Login": "تسجيل دخول الكشك",
  "Promotion": "عرض ترويجي",
  "Please select operator": "يرجى اختيار المشغل",
  "Please select distributor": "يرجى اختيار الموزع",
  "Select Operator": "اختر المشغل",
  "Select Distributor": "اختر الموزع",
  "User can login or skip to payment without login to make the payment": "يمكن للمستخدم تسجيل الدخول أو تخطي إلى الدفع بدون تسجيل دخول لإجراء الدفع",
  "User have to login only can make the payment": "يجب على المستخدم تسجيل الدخول فقط ليتمكن من إجراء الدفع",
  "User only can skip to payment without login to make the payment": "يمكن للمستخدم فقط تخطي إلى الدفع بدون تسجيل دخول لإجراء الدفع",
  "Only CSV file is accepted": "يتم قبول ملف CSV فقط",
  "The user and the balance have updated": "تم تحديث المستخدم والرصيد",
  "Register Time": "وقت التسجيل",
  "Upload User CSV file": "رفع ملف CSV للمستخدم",
  "Sample CSV file": "ملف CSV نموذجي",
  "Please follow the CSV file format": "يرجى اتباع تنسيق ملف CSV",
  "User CSV file": "ملف CSV للمستخدم",
  "Only CSV file (comma delimited) is support now": "يتم دعم ملف CSV (مفصول بفاصلة) فقط حالياً",
  "Confirm uploaded data": "تأكيد البيانات المرفوعة",
  "Operator": "المشغل",
  "Distributor": "الموزع",
  "Refund By": "مسترد بواسطة",
  "Reward By": "مكافأة بواسطة",
  "Number Of Voucher Code": "عدد رموز القسيمة",
  "Number Of Discount Code": "عدد رموز الخصم",
  "New User Only": "للمستخدمين الجدد فقط",
  "Minimum Transaction Amount To Redeem": "الحد الأدنى لمبلغ المعاملة للاستبدال",
  "Download": "تحميل",
  "Generate Voucher Code": "إنشاء رمز القسيمة",
  "Your voucher code is generating": "رمز القسيمة قيد الإنشاء",
  "Your discount code is generating": "رمز الخصم قيد الإنشاء",
  "Voucher Code Settings": "إعدادات رمز القسيمة",
  "If ticked, the voucher code only can redeem in register page": "إذا تم تحديدها، يمكن استبدال رمز القسيمة في صفحة التسجيل فقط",
  "If ticked, the user only can use the voucher after make a transaction": "إذا تم تحديدها، يمكن للمستخدم استخدام القسيمة فقط بعد إجراء معاملة",
  "If ticked, the user only can use the discount code after make a transaction": "إذا تم تحديدها، يمكن للمستخدم استخدام رمز الخصم فقط بعد إجراء معاملة",
  "Expired Date Of Voucher Code": "تاريخ انتهاء صلاحية رمز القسيمة",
  "Minimum Transaction Amount To Use Voucher": "الحد الأدنى لمبلغ المعاملة لاستخدام القسيمة",
  "Minimum Transaction Amount To Use Code": "الحد الأدنى لمبلغ المعاملة لاستخدام الرمز",
  "Max redemption per user in this batch voucher code": "الحد الأقصى للاستبدال لكل مستخدم في مجموعة رموز القسيمة هذه",
  "Max redemption per user in this batch discount code": "الحد الأقصى للاستبدال لكل مستخدم في مجموعة رموز الخصم هذه",
  "Add Voucher": "إضافة قسيمة",
  "Completed": "مكتمل",
  "Voucher Code Report": "تقرير رمز القسيمة",
  "Floating Token Report": "تقرير الرمز العائم",
  "Floating Point Report": "تقرير النقطة العائمة",
  "E-Payment Report": "تقرير الدفع الإلكتروني",
  "Referral Reward History Report": "تقرير تاريخ مكافآت الإحالة",
  "Redemption Date": "تاريخ الاستبدال",
  "Redemption Code": "رمز الاستبدال",
  "Select Redemption Date": "اختر تاريخ الاستبدال",
  "Select Voucher Type": "اختر نوع القسيمة",
  "Giveaway": "هدية مجانية",
  "Select Name": "اختر الاسم",
  "Amount must be more than 1": "المبلغ يجب أن يكون أكثر من 1",
  "Payment method setting have updated successfully!": "تم تحديث إعدادات طريقة الدفع بنجاح!",
  "Edit Payment Method": "تعديل طريقة الدفع",
  "Minimum payment amount to include all the payment methods": "الحد الأدنى لمبلغ الدفع لتشمل جميع طرق الدفع",
  "Exclude Payment Method in Revenue Monster": "استبعاد طريقة الدفع في Revenue Monster",
  "Welcome to": "مرحباً بك في",
  "Instruction": "التعليمات",
  "Please select the machine": "يرجى اختيار الآلة",
  "Login your account": "تسجيل الدخول إلى حسابك",
  "Select the setting and make the payment": "اختر الإعداد وقم بالدفع",
  "Phone Number / Email": "رقم الهاتف / الإيميل",
  "Reload & Transfer In": "إعادة التحميل والتحويل الداخلي",
  "Usage & Transfer Out": "الاستخدام والتحويل الخارجي",
  "Usage": "الاستخدام",
  "Remaining": "متبقي",
  "Gain": "كسب",
  "Type": "النوع",
  "Order Date": "تاريخ الطلب",
  "Pack Number": "رقم الحزمة",
  "Pack Details": "تفاصيل الحزمة",
  "Size": "الحجم",
  "Mode": "الوضع",
  "Machine Payment": "دفع الآلة",
  "DNG History": "تاريخ DNG",
  "Token History": "تاريخ الرمز",
  "Stamp History": "تاريخ الطوابع",
  "Staff Login": "تسجيل دخول الموظف",
  "Drop And Go Portal": "بوابة الإسقاط والذهاب",
  "Available Task": "المهام المتاحة",
  "Completed Task": "المهام المكتملة",
  "Task ID": "معرف المهمة",
  "Start Task": "بدء المهمة",
  "Select Machine": "اختر الآلة",
  "Start Machine": "تشغيل الآلة",
  "Reward To": "مكافأة إلى",
  "Reward From": "مكافأة من",
  "Transaction Account": "حساب المعاملة",
  "Point": "نقطة",
  "POINT": "نقطة",
  "Number of Point": "عدد النقاط",
  "Point History": "تاريخ النقاط",
  "Customer Name": "اسم العميل",
  "Number of Washer Transactions": "عدد معاملات الغسالة",
  "Number of Dryer Transactions": "عدد معاملات المجفف",
  "Vouchers Redeemed": "القسائم المستبدلة",
  "Discount Code Redemption": "استبدال رمز الخصم",
  "Total Spend": "إجمالي الإنفاق",
  "Select Outlet(s)": "اختر المنفذ (المنافذ)",
  "User Usage Report": "تقرير استخدام المستخدم",
  // cleanpro plus en
  "Wash": "غسل",
  "Dry": "تجفيف",
  "Fold": "طي",
  "Scan QR": "مسح رمز QR",
  "Capacity": "السعة",
  "Duration": "المدة",
  "Custom duration": "مدة مخصصة",
  "Choose duration": "اختر المدة",
  "Select the correct amount on the machine after payment.": "اختر المبلغ الصحيح على الآلة بعد الدفع.",
  "Offers": "العروض",
  "Voucher Offers": "عروض القسائم",
  "Discount Code Offers": "عروض كود الخصم",
  "An easier way to pay": "طريقة أسهل للدفع",
  "Create account": "إنشاء حساب",
  "Login": "تسجيل الدخول",
  "By signing up, you agree to": "بالتسجيل، أنت توافق على",
  "Amount to Pay": "المبلغ المطلوب دفعه",
  "1 voucher selected": "تم اختيار قسيمة واحدة",
  "No voucher selected": "لم يتم اختيار أي قسيمة",
  "Credits": "أرصدة",
  "credits": "أرصدة",
  "credit": "رصيد",
  "Credit balance": "رصيد الأرصدة",
  "Please ensure that the machine door is shut & your laundry is inside.": "يرجى التأكد من إغلاق باب الآلة ووجود غسيلك بداخلها.",
  "Insufficient balance": "رصيد غير كافي",
  "Topup now": "شحن الرصيد الآن",
  "Copyright © {{ year }} Cleanpro Laundry Holdings Sdn Bhd (821842-P) All rights reserved.": "حقوق الطبع والنشر © {{ year }} شركة Cleanpro Laundry Holdings Sdn Bhd (821842-P) جميع الحقوق محفوظة.",
  "Good Evening!": "مساء الخير!",
  "Hello": "مرحباً",
  "Wallet Balance": "رصيد المحفظة",
  "Topup": "شحن الرصيد",
  "More details": "المزيد من التفاصيل",
  "Collect 10 e-stamps to earn x1 FREE wash or dry voucher": "اجمع 10 طوابع إلكترونية لكسب قسيمة غسل أو تجفيف مجانية واحدة",
  "For every wash or dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "لكل دورة غسل أو تجفيف تكملها معنا، ستحصل على طابع إلكتروني واحد. اجمع 10 وستتمكن من استبدال دورة غسل أو تجفيف مجانية. هذه طريقتنا في شكرك لاختيارك Cleanpro!",
  "For every wash cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "لكل دورة غسل تكملها معنا، ستحصل على طابع إلكتروني واحد. اجمع 10 وستتمكن من استبدال دورة غسل أو تجفيف مجانية. هذه طريقتنا في شكرك لاختيارك Cleanpro!",
  "For every dry cycle you complete with us, you'll earn one e-stamp. Collect 10 and you'll be able to redeem a FREE wash or dry cycle. It's our way of saying thank you for choosing Cleanpro!": "لكل دورة تجفيف تكملها معنا، ستحصل على طابع إلكتروني واحد. اجمع 10 وستتمكن من استبدال دورة غسل أو تجفيف مجانية. هذه طريقتنا في شكرك لاختيارك Cleanpro!",
  "Credits OFF": "خصم على الأرصدة",
  "% OFF": "% خصم",
  "Valid Till": "صالح حتى",
  "Used On": "مستخدم في",
  "Expired On": "منتهي الصلاحية في",
  "Available": "متاح",
  "Expired": "منتهي الصلاحية",
  "Used": "مستخدم",
  "Promotions": "العروض الترويجية",
  "Rewards": "المكافآت",
  "Inbox": "صندوق الوارد",
  "Activities": "الأنشطة",
  "Support": "الدعم",
  "Active Rewards": "المكافآت النشطة",
  "Past Rewards": "المكافآت السابقة",
  "Get rewarded for your loyalty with Cleanpro Plus Rewards!": "احصل على مكافآت على ولائك مع مكافآت Cleanpro Plus!",
  "Earn vouchers and redeem them for discounts, freebies and more. The more you use our services the more you save!": "احصل على قسائم واستبدلها للحصول على خصومات وهدايا مجانية والمزيد. كلما استخدمت خدماتنا أكثر، كلما وفرت أكثر!",
  "Up to 3 months history": "تاريخ يصل إلى 3 أشهر",
  "Filter": "تصفية",
  "All Transactions": "جميع المعاملات",
  "Transactions": "المعاملات",
  "Select amount to topup": "اختر المبلغ لشحن الرصيد",
  "Balance": "الرصيد",
  "You've just paid": "لقد دفعت للتو",
  "Need help?": "تحتاج مساعدة؟",
  "24-Hour Careline Number": "رقم الخدمة على مدار 24 ساعة",
  "Email Us": "راسلنا بالإيميل",
  "Call Now": "اتصل الآن",
  "Email Now": "راسل بالإيميل الآن",
  "Update name": "تحديث الاسم",
  "Update email address": "تحديث عنوان الإيميل",
  "Update phone number": "تحديث رقم الهاتف",
  "Change password": "تغيير كلمة المرور",
  "Change language": "تغيير اللغة",
  "User ID": "معرف المستخدم",
  "Let us know your feedback": "أخبرنا برأيك",
  "Poor": "ضعيف",
  "Good": "جيد",
  "Leave addtional feedback here (optional)": "اترك تعليقاً إضافياً هنا (اختياري)",
  "Submit feedback": "إرسال التعليق",
  "Pay as guest": "الدفع كضيف",
  "Pay now": "ادفع الآن",
  "Select voucher to use": "اختر القسيمة للاستخدام",
  "Use voucher": "استخدم القسيمة",
  "Total": "المجموع",
  "Transaction Type": "نوع المعاملة",
  "E-Token Topup": "شحن الرمز الإلكتروني",
  "Credit Topup": "شحن الأرصدة",
  "Credit topup": "شحن الأرصدة",
  "Credit Transfer": "تحويل الأرصدة",
  "E-Token Transfer": "تحويل الرمز الإلكتروني",
  "Date/Time": "التاريخ/الوقت",
  "Reference ID": "معرف المرجع",
  "Status": "الحالة",
  "Share Your Referral Code": "شارك رمز الإحالة الخاص بك",
  "cleanproReferralShortDesc_one": "احصل على رصيد مجاني {{ voucherAmount }} عندما تشارك رمز الإحالة الخاص بك مع الأصدقاء والعائلة بعد معاملة ناجحة. اضغط لمعرفة المزيد.",
  "cleanproReferralShortDesc_other": "احصل على أرصدة مجانية {{ voucherAmount }} عندما تشارك رمز الإحالة الخاص بك مع الأصدقاء والعائلة بعد معاملة ناجحة. اضغط لمعرفة المزيد.",
  "Use": "استخدام",
  "dryer or washer": "مجفف أو غسالة",
  "washer": "غسالة",
  "dryer": "مجفف",
  "dryer and washer": "مجفف وغسالة",
  "machine with the minimum spending of": "آلة بحد أدنى للإنفاق",
  "Payment Confirmation": "تأكيد الدفع",
  "This campaign is only eligible for users who use the all-new Cleanpro Plus web application.": "هذه الحملة مخصصة فقط للمستخدمين الذين يستخدمون تطبيق Cleanpro Plus الجديد.",
  "ONE e-stamp will be rewarded for each wash or dry cycle.": "ستُمنح طابع إلكتروني واحد لكل دورة غسل أو تجفيف.",
  "ONE e-stamp will be rewarded for each wash cycle.": "ستُمنح طابع إلكتروني واحد لكل دورة غسل.",
  "ONE e-stamp will be rewarded for each dry cycle.": "ستُمنح طابع إلكتروني واحد لكل دورة تجفيف.",
  "Regardless of the washer or dryer settings, the number of e-stamps being collected is the same.": "بغض النظر عن إعدادات الغسالة أو المجفف، عدد الطوابع الإلكترونية المجمعة هو نفسه.",
  "The type of e-stamp collected is based on the services that you have used.": "نوع الطابع الإلكتروني المجمع يعتمد على الخدمات التي استخدمتها.",
  "Washing service will reward washer e-stamp and drying service will reward dryer e-stamp.": "خدمة الغسل ستكافئ بطابع غسالة إلكتروني وخدمة التجفيف ستكافئ بطابع مجفف إلكتروني.",
  "Washing service will reward washer e-stamp.": "خدمة الغسل ستكافئ بطابع غسالة إلكتروني.",
  "Drying service will reward dryer e-stamp.": "خدمة التجفيف ستكافئ بطابع مجفف إلكتروني.",
  "E-stamps will automatically be added to your account once the condition has been fulfilled.": "ستتم إضافة الطوابع الإلكترونية تلقائياً إلى حسابك عند استيفاء الشرط.",
  "There is no limit on how many e-stamps can be gathered in a single day. So long as you meet the requirements to collect the e-stamps.": "لا يوجد حد لعدد الطوابع الإلكترونية التي يمكن جمعها في يوم واحد. طالما تستوفي متطلبات جمع الطوابع الإلكترونية.",
  "The type of e-stamps that have been collected is final and cannot be changed.": "نوع الطوابع الإلكترونية التي تم جمعها نهائي ولا يمكن تغييرها.",
  "There is no expiration for the e-stamps; only till the discontinuation of the campaign.": "لا يوجد انتهاء صلاحية للطوابع الإلكترونية؛ فقط حتى إيقاف الحملة.",
  "E-stamps do not have any currency value, and they cannot be converted to cash or credits.": "الطوابع الإلكترونية ليس لها أي قيمة نقدية، ولا يمكن تحويلها إلى نقد أو أرصدة.",
  "This campaign is not applicable with any other ongoing promotions, offers, vouchers, and/or discounts provided by the participating outlets.": "هذه الحملة لا تنطبق مع أي عروض ترويجية أو عروض أو قسائم و/أو خصومات أخرى مستمرة مقدمة من المنافذ المشاركة.",
  "These terms and conditions are subject to change at any time without prior notice.": "هذه الشروط والأحكام عرضة للتغيير في أي وقت دون إشعار مسبق.",
  "Press START on the machine to begin washing.": "اضغط على زر START على الآلة لبدء الغسل.",
  "Press START on the machine to begin drying.": "اضغط على زر START على الآلة لبدء التجفيف.",
  "Reminder": "تذكير",
  "Remember to select the same settings you have paid for on the corresponding machine.": "تذكر اختيار نفس الإعدادات التي دفعت ثمنها على الآلة المقابلة.",
  "Please ensure that your laundry is inside the machine and door is properly shut.": "يرجى التأكد من أن غسيلك داخل الآلة وأن الباب مغلق بإحكام.",
  "voucherCreditsOff_one": "{{currentVoucherAmount}} رصيد خصم",
  "voucherCreditsOff_other": "{{currentVoucherAmount}} أرصدة خصم",
  "voucherPercentageOff": "{{currentVoucherAmount}}% خصم",
  "cleanproReferralFlatVoucher_one": "احصل على أرصدة مجانية عندما تشارك رمز إحالة Cleanpro Plus الخاص بك مع أصدقائك وعائلتك! لكل إحالة ناجحة تكمل أول معاملة لها، ستحصل على قسيمة أرصدة مجانية {{ referralVoucherAmount }}.",
  "cleanproReferralFlatVoucher_other": "احصل على أرصدة مجانية عندما تشارك رمز إحالة Cleanpro Plus الخاص بك مع أصدقائك وعائلتك! لكل إحالة ناجحة تكمل أول معاملة لها، ستحصل على قسيمة أرصدة مجانية {{ referralVoucherAmount }}.",
  "cleanproReferralRateVoucher": "احصل على أرصدة مجانية عندما تشارك رمز إحالة Cleanpro Plus الخاص بك مع أصدقائك وعائلتك! لكل إحالة ناجحة تكمل أول معاملة لها، ستحصل على قسيمة خصم {{ referralVoucherAmount }}%.",
  "cleanproReferralTokenReward_one": "احصل على أرصدة مجانية عندما تشارك رمز إحالة Cleanpro Plus الخاص بك مع أصدقائك وعائلتك! لكل إحالة ناجحة تكمل أول معاملة لها، ستحصل على {{ referralToken }} رصيد مجاني.",
  "cleanproReferralTokenReward_other": "احصل على أرصدة مجانية عندما تشارك رمز إحالة Cleanpro Plus الخاص بك مع أصدقائك وعائلتك! لكل إحالة ناجحة تكمل أول معاملة لها، ستحصل على {{ referralToken }} أرصدة مجانية.",
  "How to get & use code:": "كيفية الحصول على الرمز واستخدامه:",
  'Go to menu = icon and click "Refer friends"': 'اذهب إلى القائمة = الأيقونة واضغط على "إحالة الأصدقاء"',
  "Share with everyone who will likely to use Cleanpro Plus.": "شارك مع كل من يحتمل أن يستخدم Cleanpro Plus.",
  "Referral Terms & Conditions:": "شروط وأحكام الإحالة:",
  "When your friend or family register using your referral code, and completed a transaction (a minimum spending of {{ currency }}{{ referralTransactionAmount }}) , you will be rewarded automatically.": "عندما يسجل صديقك أو عائلتك باستخدام رمز الإحالة الخاص بك، ويكمل معاملة (بحد أدنى للإنفاق {{ currency }}{{ referralTransactionAmount }})، ستحصل على المكافأة تلقائياً.",
  "cleanproNumberOfReferralReward": "يمكنك المشاركة مع عدد كبير من الأشخاص كما تريد، لكن كل مستخدم يمكنه الحصول على {{ numberOfReferral }} مكافأة إحالة فقط.",
  "cleanproNumberOfReferral_one": "يمكنك المشاركة مع عدد كبير من الأشخاص كما تريد، لكن كل مستخدم يمكنه الحصول على {{ numberOfReferral }} قسيمة إحالة فقط.",
  "cleanproNumberOfReferral_other": "يمكنك المشاركة مع عدد كبير من الأشخاص كما تريد، لكن كل مستخدم يمكنه الحصول على {{ numberOfReferral }} قسائم إحالة فقط.",
  "The voucher is valid for {{ duration }} days from the day voucher be given._one": "القسيمة صالحة لمدة {{ duration }} يوم من يوم إعطاء القسيمة.",
  "The voucher is valid for {{ duration }} days from the day voucher be given._other": "القسيمة صالحة لمدة {{ duration }} يوماً من يوم إعطاء القسيمة.",
  "The voucher is for customer use only and not for sale.": "القسيمة لاستخدام العميل فقط وليست للبيع.",
  "We believe that your special day deserves a little extra sparkle! That's why we're thrilled to introduce our exclusive birthday rewards program just for you! Starting this year, and every year thereafter, we're giving away {{ currency }}{{ voucherAmount }} credit vouchers to you on your birthday.": "نعتقد أن يومك المميز يستحق لمسة إضافية من الإشراق! لهذا نحن متحمسون لتقديم برنامج مكافآت عيد الميلاد الحصري خصيصاً لك! ابتداء من هذا العام، وكل عام بعد ذلك، نقدم لك قسائم أرصدة {{ currency }}{{ voucherAmount }} في عيد ميلادك.",
  "cleanproBirthdayRateAmount": "نعتقد أن يومك المميز يستحق لمسة إضافية من الإشراق! لهذا نحن متحمسون لتقديم برنامج مكافآت عيد الميلاد الحصري خصيصاً لك! ابتداء من هذا العام، وكل عام بعد ذلك، نقدم لك قسائم {{ voucherAmount }}% في عيد ميلادك.",
  "Make sure your account details include your birthdate. This way, we'll know exactly when to send you your special birthday surprise.": "تأكد من أن تفاصيل حسابك تتضمن تاريخ ميلادك. بهذه الطريقة، سنعرف بالضبط متى نرسل لك مفاجأة عيد ميلادك الخاصة.",
  "Birthday Voucher Terms & Conditions:": "شروط وأحكام قسيمة عيد الميلاد:",
  "The voucher will be given on the first day of your birthday month.": "ستُمنح القسيمة في اليوم الأول من شهر عيد ميلادك.",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount._one": "عندما تطبق القسيمة أثناء الدفع، ستمنحك {{ voucherAmount }} رصيد ({{ currency }}{{ voucherAmount }}) خصم.",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount._other": "عندما تطبق القسيمة أثناء الدفع، ستمنحك {{ voucherAmount }} أرصدة ({{ currency }}{{ voucherAmount }}) خصم.",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }}% discount.": "عندما تطبق القسيمة أثناء الدفع، ستمنحك {{ voucherAmount }}% خصم.",
  "All vouchers is not valid with other ongoing promotions, discounts and offers.": "جميع القسائم غير صالحة مع العروض الترويجية والخصومات والعروض الأخرى الجارية.",
  "Claim a complimentary wash and dry for every 10 e-stamps collected! We value your loyalty and want to reward you for choosing Cleanpro Plus. Tap to learn more.": "احصل على غسل وتجفيف مجاني لكل 10 طوابع إلكترونية تجمعها! نحن نقدر ولاءك ونريد أن نكافئك لاختيارك Cleanpro Plus. اضغط لمعرفة المزيد.",
  "cleanproStampFlat_one": "مع كل 10 طوابع إلكترونية تجمعها، يمكنك الحصول على ما يصل إلى {{ voucherAmount }} رصيد من جلسة غسل أو تجفيف مجانية مع Cleanpro Plus. اجعل روتين الغسيل الخاص بك ليس فقط خالياً من المتاعب، ولكن أيضاً مجزياً.",
  "cleanproStampFlat_other": "مع كل 10 طوابع إلكترونية تجمعها، يمكنك الحصول على ما يصل إلى {{ voucherAmount }} أرصدة من جلسة غسل أو تجفيف مجانية مع Cleanpro Plus. اجعل روتين الغسيل الخاص بك ليس فقط خالياً من المتاعب، ولكن أيضاً مجزياً.",
  "cleanproStampRate": "مع كل 10 طوابع إلكترونية تجمعها، يمكنك الحصول على ما يصل إلى {{ voucherAmount }}% من جلسة غسل أو تجفيف مجانية مع Cleanpro Plus. اجعل روتين الغسيل الخاص بك ليس فقط خالياً من المتاعب، ولكن أيضاً مجزياً.",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "ستُضاف قسيمة فوراً إلى صفحة المكافآت الخاصة بك عندما تصل إلى 10 غسلات. سيُستعاد مقياس الطوابع الإلكترونية إلى الصفر للمجموعة التالية. استلم القسيمة في صفحة مسح رمز QR عندما تقوم بغسيلك التالي.",
  "A voucher will be instantly added to your Rewards page when you reach 10 drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "ستُضاف قسيمة فوراً إلى صفحة المكافآت الخاصة بك عندما تصل إلى 10 تجفيفات. سيُستعاد مقياس الطوابع الإلكترونية إلى الصفر للمجموعة التالية. استلم القسيمة في صفحة مسح رمز QR عندما تقوم بغسيلك التالي.",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes or drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "ستُضاف قسيمة فوراً إلى صفحة المكافآت الخاصة بك عندما تصل إلى 10 غسلات أو تجفيفات. سيُستعاد مقياس الطوابع الإلكترونية إلى الصفر للمجموعة التالية. استلم القسيمة في صفحة مسح رمز QR عندما تقوم بغسيلك التالي.",
  "Terms & Conditions:": "الشروط والأحكام:",
  "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session._one": "لكسب طابع إلكتروني واحد، يجب أن تنفق ما لا يقل عن {{ stampTransactionAmount }} رصيد ({{ currency }}{{ stampTransactionAmount }}) لكل جلسة.",
  "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session._other": "لكسب طابع إلكتروني واحد، يجب أن تنفق ما لا يقل عن {{ stampTransactionAmount }} أرصدة ({{ currency }}{{ stampTransactionAmount }}) لكل جلسة.",
  "You will be automatically issued a voucher if you have collected 10 washer stamps.": "ستحصل تلقائياً على قسيمة إذا جمعت 10 طوابع غسالة.",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps.": "ستحصل تلقائياً على قسيمة إذا جمعت 10 طوابع مجفف.",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps or 10 washer stamps.": "ستحصل تلقائياً على قسيمة إذا جمعت 10 طوابع مجفف أو 10 طوابع غسالة.",
  "You will be automatically issued a voucher if you have collected 10 stamps.": "ستحصل تلقائياً على قسيمة إذا جمعت 10 طوابع.",
  "The voucher is non-refundable and cannot be exchanged for cash; in part or in full.": "القسيمة غير قابلة للاسترداد ولا يمكن استبدالها بالنقد؛ جزئياً أو كلياً.",
  "This voucher is valid for single transaction only.": "هذه القسيمة صالحة لمعاملة واحدة فقط.",
  "General questions": "أسئلة عامة",
  "E-stamps collection": "جمع الطوابع الإلكترونية",
  "Coin exchange machines": "ماكينات صرف العملات",
  "Washer machines": "ماكينات الغسل",
  "Dryer machines": "ماكينات التجفيف",
  "Paywave issues": "مشاكل الدفع اللاسلكي",
  "Cleanpro franchise": "امتياز كلين برو",
  "How can I wash my laundry using Cleanpro Plus?": "كيف يمكنني غسل ملابسي باستخدام Cleanpro Plus؟",
  "Here are the steps to wash your laundry using Cleanpro Plus:": "إليك خطوات غسل ملابسك باستخدام Cleanpro Plus:",
  "Find an unoccupied washing machine in the store, and insert your laundry in the washer.": "ابحث عن غسالة غير مشغولة في المتجر، وضع غسيلك في الغسالة.",
  "Select the desired temperature that you would like to use for your laundry.": "اختر درجة الحرارة المرغوبة التي تريد استخدامها لغسيلك.",
  "Using the scanner in the app, scan the QR code provided on the washing machine. Then select the same settings that you have pressed on the machine.": "باستخدام الماسح الضوئي في التطبيق، امسح رمز QR المتوفر على الغسالة. ثم اختر نفس الإعدادات التي ضغطت عليها على الآلة.",
  'Tap on "Pay with credits" to pay the amount shown on the app.': 'اضغط على "ادفع بالأرصدة" لدفع المبلغ المعروض في التطبيق.',
  "Once the payment has been accepted, press the START button on the washer machine.": "بمجرد قبول الدفع، اضغط على زر START في الغسالة.",
  "After the washing cycle ends, you can just remove your laundry from the machine.": "بعد انتهاء دورة الغسل، يمكنك ببساطة إخراج غسيلك من الآلة.",
  "How can I dry my laundry using Cleanpro Plus?": "كيف يمكنني تجفيف ملابسي باستخدام Cleanpro Plus؟",
  "Here are the steps to dry your laundry using Cleanpro Plus:": "إليك خطوات تجفيف ملابسك باستخدام Cleanpro Plus:",
  "Find an unoccupied drying machine in the store, and insert your laundry in the dryer.": "ابحث عن مجفف غير مشغول في المتجر، وضع غسيلك في المجفف.",
  "Select the desired temperature and duration that you would like to use for your laundry.": "اختر درجة الحرارة والمدة المرغوبة التي تريد استخدامها لغسيلك.",
  "Using the scanner in the app, scan the QR code provided on the drying machine. Then select the same settings that you have pressed on the machine.": "باستخدام الماسح الضوئي في التطبيق، امسح رمز QR المتوفر على المجفف. ثم اختر نفس الإعدادات التي ضغطت عليها على الآلة.",
  "Once the payment has been accepted, press the START button on the dryer machine.": "بمجرد قبول الدفع، اضغط على زر START في المجفف.",
  "After the drying cycle ends, you can just remove your laundry from the machine.": "بعد انتهاء دورة التجفيف، يمكنك ببساطة إخراج غسيلك من الآلة.",
  "Why does the QR code I scanned take me to a different machine?": "لماذا يأخذني رمز QR الذي مسحته إلى آلة مختلفة؟",
  "Here are the steps to solve it:": "إليك خطوات حل المشكلة:",
  "Make sure that the number on the QR code (e.g. W1, W2, etc) is the same as the machine that you would like to use.": "تأكد من أن الرقم على رمز QR (مثل W1، W2، إلخ) هو نفس الآلة التي تريد استخدامها.",
  "If the QR code number does not match the machine you want, use the other machine. Please contact our customer service line at 03-27700100 to report this issue.": "إذا لم يتطابق رقم رمز QR مع الآلة التي تريدها، استخدم الآلة الأخرى. يرجى الاتصال بخط خدمة العملاء لدينا على 03-27700100 للإبلاغ عن هذه المشكلة.",
  "How can I add more time to the washer that I am currently using?": "كيف يمكنني إضافة المزيد من الوقت للغسالة التي أستخدمها حالياً؟",
  "The washing time for our washer is fixed and cannot add any additional time.": "وقت الغسل في غسالتنا ثابت ولا يمكن إضافة أي وقت إضافي.",
  "How can I add more time to the dryer that I am currently using?": "كيف يمكنني إضافة المزيد من الوقت للمجفف الذي أستخدمه حالياً؟",
  "Here are the steps to add more time to the dryer machine:": "إليك خطوات إضافة المزيد من الوقت لماكينة التجفيف:",
  "By using the scanner in the app, scan the QR code provided at the dryer machine.": "باستخدام الماسح الضوئي في التطبيق، امسح رمز QR المتوفر في المجفف.",
  "Select the amount of time that you would like to add to the machine.": "اختر مقدار الوقت الذي تريد إضافته للآلة.",
  "After the drying cycle ends, you can just remove the clothes from the machine.": "بعد انتهاء دورة التجفيف، يمكنك ببساطة إخراج الملابس من الآلة.",
  "REMINDER - It is recommended to add drying time 5 minutes before the cycle ends. And you cannot add tokens for extra times when the machine finishes the drying cycle.": "تذكير - يُنصح بإضافة وقت التجفيف قبل 5 دقائق من انتهاء الدورة. ولا يمكنك إضافة رموز لأوقات إضافية عندما تنتهي الآلة من دورة التجفيف.",
  "Will the timer keep running when I have stopped the drying machine?": "هل سيستمر المؤقت في العمل عندما أوقف ماكينة التجفيف؟",
  "Yes. Even after you stop the machine, the timer will continue to run. If you want to extend the drying time, add drying time 5 minutes before the cycle ends. This prevents the cycle from ending before your clothes are completely dried.": "نعم. حتى بعد إيقاف الآلة، سيستمر المؤقت في العمل. إذا كنت تريد تمديد وقت التجفيف، أضف وقت التجفيف قبل 5 دقائق من انتهاء الدورة. هذا يمنع انتهاء الدورة قبل أن تجف ملابسك تماماً.",
  "How do I reload my credits for Cleanpro Plus?": "كيف أعيد شحن أرصدتي لـ Cleanpro Plus؟",
  "Here are the steps to reload your credits:": "إليك خطوات إعادة شحن أرصدتك:",
  'Select the "Top Up Credit" button on the homepage.': 'اختر زر "شحن الأرصدة" في الصفحة الرئيسية.',
  "Choose the amount you want to reload and the payment method you want to use.": "اختر المبلغ الذي تريد إعادة شحنه وطريقة الدفع التي تريد استخدامها.",
  "You will be taken to the payment page. The screen will return to Cleanpro Plus once the transaction is completed.": "ستتم إحالتك إلى صفحة الدفع. ستعود الشاشة إلى Cleanpro Plus بمجرد اكتمال المعاملة.",
  "How many credits can I reload in one transaction?": "كم عدد الأرصدة التي يمكنني إعادة شحنها في معاملة واحدة؟",
  "Reloading credits requires a minimum of RM 10 and a maximum of RM 50.": "إعادة شحن الأرصدة تتطلب حداً أدنى 10 رينغت ماليزي وحداً أقصى 50 رينغت ماليزي.",
  "Can I pay using credits in the Cleanpro Plus app along with tokens or coins in a single transaction?": "هل يمكنني الدفع باستخدام الأرصدة في تطبيق Cleanpro Plus مع الرموز أو العملات المعدنية في معاملة واحدة؟",
  "No. Only a single payment method may be chosen when performing any transactions.": "لا. يمكن اختيار طريقة دفع واحدة فقط عند إجراء أي معاملات.",
  "The amount I have reloaded in my account was not reflected in the app.": "المبلغ الذي أعدت شحنه في حسابي لم ينعكس في التطبيق.",
  "Please close and restart the application and check if the new balance has been updated.": "يرجى إغلاق التطبيق وإعادة تشغيله والتحقق من تحديث الرصيد الجديد.",
  "If the amount is still not updated, please contact our customer service line at 03-27700110 to receive further assistance.": "إذا لم يتم تحديث المبلغ بعد، يرجى الاتصال بخط خدمة العملاء لدينا على 03-27700110 للحصول على مساعدة إضافية.",
  "Can I cash out the credits I reloaded in my account for this app?": "هل يمكنني سحب الأرصدة التي أعدت شحنها في حسابي لهذا التطبيق؟",
  "No. The credits that you have reloaded will remain in your Cleanpro Plus account.": "لا. الأرصدة التي أعدت شحنها ستبقى في حساب Cleanpro Plus الخاص بك.",
  "I have requested a refund, but I still have not received it.": "لقد طلبت استرداداً، لكنني لم أتلقه بعد.",
  "Please contact our customer service line at 03-27700100 to receive further assistance.": "يرجى الاتصال بخط خدمة العملاء لدينا على 03-27700100 للحصول على مساعدة إضافية.",
  "I have made the payment, and the app double or triple charged me.": "لقد دفعت، والتطبيق فرض عليّ رسوماً مضاعفة أو ثلاثية.",
  "The washing machine cannot start even after I have paid using the app.": "الغسالة لا يمكنها البدء حتى بعد أن دفعت باستخدام التطبيق.",
  "Ensure that the temperature settings you have selected and paid for on the application are the same as what you have pressed on the washing machine. If not, select the correct temperature settings on the washing machine and try again.": "تأكد من أن إعدادات درجة الحرارة التي اخترتها ودفعت مقابلها في التطبيق هي نفسها التي ضغطت عليها في الغسالة. إذا لم تكن كذلك، اختر إعدادات درجة الحرارة الصحيحة في الغسالة وحاول مرة أخرى.",
  "If the machine is still not able to be started, please contact our customer service line at 03-27700100 to receive further assistance.": "إذا كانت الآلة لا تزال غير قادرة على البدء، يرجى الاتصال بخط خدمة العملاء لدينا على 03-27700100 للحصول على مساعدة إضافية.",
  "Can I use multiple vouchers together in the same washing or drying cycle?": "هل يمكنني استخدام قسائم متعددة معاً في نفس دورة الغسل أو التجفيف؟",
  "No. Only a single voucher can be used for each washing and drying cycle.": "لا. يمكن استخدام قسيمة واحدة فقط لكل دورة غسل وتجفيف.",
  "Why can't I use my free wash voucher that I received after signing up?": "لماذا لا يمكنني استخدام قسيمة الغسل المجانية التي تلقيتها بعد التسجيل؟",
  "To redeem or use the voucher, you must complete at least one washing or drying cycle.": "لاستبدال أو استخدام القسيمة، يجب أن تكمل دورة غسل أو تجفيف واحدة على الأقل.",
  "Can I change my phone number even after registering my account?": "هل يمكنني تغيير رقم هاتفي حتى بعد تسجيل حسابي؟",
  "No. Once registered to an account, the phone number is locked into the account.": "لا. بمجرد التسجيل في حساب، يتم تأمين رقم الهاتف في الحساب.",
  "I have problems in the store, and who can I refer to for help?": "لدي مشاكل في المتجر، ومن يمكنني الرجوع إليه للمساعدة؟",
  "Do not worry, as you can contact our customer service line at 03-27700100 to receive assistance at any time.": "لا تقلق، يمكنك الاتصال بخط خدمة العملاء لدينا على 03-27700100 للحصول على المساعدة في أي وقت.",
  "Should I add my own laundry detergent and softeners to the washing machine?": "هل يجب أن أضيف منظف الغسيل والمنعمات الخاصة بي إلى الغسالة؟",
  "There is no need for that, as all you have to do is bring your dirty clothes and put them in the washer. The detergent and softeners will be provided by us, and you can rest assured that the laundry detergents we used are certified industrial grade.": "لا حاجة لذلك، فكل ما عليك فعله هو إحضار ملابسك المتسخة ووضعها في الغسالة. سنوفر نحن المنظف والمنعمات، ويمكنك أن تطمئن أن منظفات الغسيل التي نستخدمها معتمدة من النوع الصناعي.",
  "I would like to add my own laundry detergent and softener to the washing machine.": "أود إضافة منظف الغسيل والمنعم الخاصة بي إلى الغسالة.",
  "We do not recommend our customers add their own detergent, as the mixture of different detergents may affect the wash quality. And you can rest assured that the laundry detergent we used is certified industrial grade.": "لا ننصح عملاءنا بإضافة منظفهم الخاص، حيث أن مزج منظفات مختلفة قد يؤثر على جودة الغسل. ويمكنك أن تطمئن أن منظف الغسيل الذي نستخدمه معتمد من النوع الصناعي.",
  "What time does the store close?": "في أي وقت يغلق المتجر؟",
  "Our self-service laundry operation is open 24 hours a day, which means you can always be sure to go back home with a fresh set of laundry.": "خدمة الغسيل الذاتي مفتوحة 24 ساعة في اليوم، مما يعني أنه يمكنك دائماً أن تتأكد من العودة إلى المنزل بغسيل نظيف ومنعش.",
  "Are you open on weekends?": "هل أنتم مفتوحون في عطلات نهاية الأسبوع؟",
  "Yes. Cleanpro is also open on weekends and even on public holidays.": "نعم. Cleanpro مفتوح أيضاً في عطلات نهاية الأسبوع وحتى في الإجازات العامة.",
  "How many clothes can I fit in the washing or drying machine?": "كم عدد الملابس التي يمكنني وضعها في الغسالة أو المجفف؟",
  "To ensure that your laundry is properly washed or dried, keep the amount of laundry inside the machine lower than the line of guide sticker on the machine.": "لضمان غسل أو تجفيف ملابسك بشكل صحيح، حافظ على كمية الغسيل داخل الآلة أقل من خط الملصق الإرشادي على الآلة.",
  "How many e-stamps can I collect in a single day?": "كم عدد الطوابع الإلكترونية التي يمكنني جمعها في يوم واحد؟",
  "There is no limit to the amount of stamps that can be collected in a single day; ONE stamp will be awarded with every wash or dry.": "لا يوجد حد لعدد الطوابع التي يمكن جمعها في يوم واحد؛ ستُمنح طابع واحد مع كل غسل أو تجفيف.",
  "When I use the washing service, can I change the collected stamp to a dryer stamp, and vice versa?": "عندما أستخدم خدمة الغسل، هل يمكنني تغيير الطابع المجمع إلى طابع مجفف، والعكس؟",
  "No, the type of stamp collected is only applied to the service that you have used.": "لا، نوع الطابع المجمع ينطبق فقط على الخدمة التي استخدمتها.",
  "What temperatures can I choose when I claim the free washing e-stamp reward?": "ما هي درجات الحرارة التي يمكنني اختيارها عندما أستلم مكافأة طابع الغسل الإلكتروني المجاني؟",
  "Any washing temperature is available for the e-stamp reward.": "أي درجة حرارة للغسل متاحة لمكافأة الطابع الإلكتروني.",
  "What temperatures can I choose when I claim the free drying e-stamp reward? And how long can I set the time?": "ما هي درجات الحرارة التي يمكنني اختيارها عندما أستلم مكافأة طابع التجفيف الإلكتروني المجاني؟ وكم من الوقت يمكنني تحديده؟",
  "Any drying temperature and duration can be selected for the e-stamp reward.": "يمكن اختيار أي درجة حرارة ومدة للتجفيف لمكافأة الطابع الإلكتروني.",
  "I'm unable to change the coin.": "لا أستطيع صرف العملة المعدنية.",
  "What colour is the light shown on the machine, red or green? If it is a red light, please contact our customer service line at 03-27700100 to receive further assistance.": "ما لون الضوء المعروض على الآلة، أحمر أم أخضر؟ إذا كان ضوءاً أحمر، يرجى الاتصال بخط خدمة العملاء لدينا على 03-27700100 للحصول على مساعدة إضافية.",
  "Green Light": "ضوء أخضر",
  "Red Light": "ضوء أحمر",
  "Machine functions as normal. Please try again.": "الآلة تعمل بشكل طبيعي. يرجى المحاولة مرة أخرى.",
  "(flashing 2x) - There are no coins/tokens in the machine.": "(وميض مرتين) - لا توجد عملات معدنية/رموز في الآلة.",
  "OR": "أو",
  "Note is jammed, please proceed to contact customer service": "الورقة النقدية محشورة، يرجى الاتصال بخدمة العملاء",
  "(flashing 3x) - Note is jammed, please proceed to contact customer service": "(وميض 3 مرات) - الورقة النقدية محشورة، يرجى الاتصال بخدمة العملاء",
  "My notes are stuck in the machine.": "أوراقي النقدية عالقة في الآلة.",
  "My detergent is not dispensing in the vending machine.": "المنظف الخاص بي لا يخرج من آلة البيع.",
  "The water is leaking out of the washing machine.": "الماء يتسرب من الغسالة.",
  "Please check the washer machine to see whether there are any clothes that are stuck at the door side.": "يرجى فحص الغسالة لمعرفة ما إذا كانت هناك أي ملابس عالقة في جانب الباب.",
  "If yes, here are the steps to solve it:": "إذا كان الأمر كذلك، إليك خطوات حل المشكلة:",
  "Press the emergency stop button (RED Button) for 3 seconds.": "اضغط على زر التوقف الطارئ (الزر الأحمر) لمدة 3 ثوانٍ.",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at 03-27700100 to receive further assistance)": "انتظر حتى يتوقف الصوت، ثم افتح الباب فقط. (إذا لم يتوقف الصوت بعد 30 دقيقة، يرجى الاتصال بخط خدمة العملاء لدينا على 03-27700100 للحصول على مساعدة إضافية)",
  "Ensure the door is closed tightly, and press the START button.": "تأكد من إغلاق الباب بإحكام، واضغط على زر START.",
  "REMINDER - The emergency stop button can only be used once.": "تذكير - يمكن استخدام زر التوقف الطارئ مرة واحدة فقط.",
  "There is no detergent dispensing in the washing machine.": "لا يخرج منظف في الغسالة.",
  "Ensure that the machine is in operation and that the START button was pressed.": "تأكد من أن الآلة تعمل وأن زر START قد تم الضغط عليه.",
  "If the detergent is still not dispensing, please contact our customer service department at 03-27700100 for further assistance.": "إذا كان المنظف لا يزال لا يخرج، يرجى الاتصال بقسم خدمة العملاء لدينا على 03-27700100 للحصول على مساعدة إضافية.",
  "The price displayed on the machine's screen did not change after inserting the token.": "السعر المعروض على شاشة الآلة لم يتغير بعد إدخال الرمز.",
  "Press the small button (in the centre) to reject the tokens that have been inserted. Press a few times till the coins come out.": "اضغط على الزر الصغير (في الوسط) لرفض الرموز التي تم إدخالها. اضغط عدة مرات حتى تخرج العملات.",
  "If the coins still cannot come out or the button is not functioning, please contact our customer service line at 03-27700110 to receive further assistance.": "إذا كانت العملات لا تزال لا تستطيع الخروج أو أن الزر لا يعمل، يرجى الاتصال بخط خدمة العملاء لدينا على 03-27700110 للحصول على مساعدة إضافية.",
  "The machine is not starting, and it displays an error code.": "الآلة لا تبدأ، وتعرض رمز خطأ.",
  "We would like to apologise for any inconvenience caused. Please contact our customer service line at 03-27700100 to receive further assistance.": "نود أن نعتذر عن أي إزعاج قد يكون سُبب. يرجى الاتصال بخط خدمة العملاء لدينا على 03-27700100 للحصول على مساعدة إضافية.",
  "I want to wash the clothes again, but why couldn't the machine start even after I added tokens to the machine?": "أريد غسل الملابس مرة أخرى، لكن لماذا لم تستطع الآلة البدء حتى بعد أن أضفت رموزاً إلى الآلة؟",
  "Try opening and closing the door again before starting the machine.": "حاول فتح وإغلاق الباب مرة أخرى قبل تشغيل الآلة.",
  "Can I change the water temperature of the machine?": "هل يمكنني تغيير درجة حرارة الماء في الآلة؟",
  "Yes, but the washer temperature can only be changed from hot to cold after the machine has been started, and not from cold to hot.": "نعم، لكن يمكن تغيير درجة حرارة الغسالة من الساخن إلى البارد فقط بعد تشغيل الآلة، وليس من البارد إلى الساخن.",
  "Can I stop the machine?": "هل يمكنني إيقاف الآلة؟",
  "Here are the steps to stop the machine:": "إليك خطوات إيقاف الآلة:",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at to receive further assistance)": "انتظر حتى يتوقف الصوت، ثم افتح الباب فقط. (إذا لم يتوقف الصوت بعد 30 دقيقة، يرجى الاتصال بخط خدمة العملاء لدينا للحصول على مساعدة إضافية)",
  "There is no water supply on the machine used.": "لا يوجد إمداد مياه في الآلة المستخدمة.",
  "Why is the washing temperature cold even when I have selected HOT.": "لماذا تكون درجة حرارة الغسل باردة حتى عندما اخترت ساخن.",
  "The water temperature is HOT or WARM only during washing. The water will turn COLD during rinsing.": "درجة حرارة الماء ساخنة أو دافئة فقط أثناء الغسل. سيصبح الماء بارداً أثناء الشطف.",
  "The machine has already finished washing, but it does not spin well, and there is water left on the load.": "انتهت الآلة من الغسل بالفعل، لكنها لا تعصر جيداً، وما زال هناك ماء على الغسيل.",
  "Can I put wet laundry into the dryer to dry?": "هل يمكنني وضع الغسيل المبلل في المجفف للتجفيف؟",
  "No, as the dripping wet laundry might cause the dryer to short circuit.": "لا، حيث أن الغسيل المبلل المتساقط قد يسبب ماس كهربائي في المجفف.",
  "REMINDER - Refer to the labels on your clothes to know what kind of temperature is best for the kind of fabric that it uses. Then select the temperature on the machine accordingly.": "تذكير - راجع الملصقات على ملابسك لمعرفة أي درجة حرارة الأفضل لنوع القماش المستخدم. ثم اختر درجة الحرارة على الآلة وفقاً لذلك.",
  "My clothes are still wet even after drying.": "ملابسي لا تزال مبللة حتى بعد التجفيف.",
  "How can I stop the dryer when the machine is still running?": "كيف يمكنني إيقاف المجفف عندما تكون الآلة لا تزال تعمل؟",
  "Just open the door and the machine will automatically stop.": "فقط افتح الباب وستتوقف الآلة تلقائياً.",
  "I added extra tokens for extra times, but the machine did not update the time.": "أضفت رموزاً إضافية لأوقات إضافية، لكن الآلة لم تحدث الوقت.",
  "For the time to be reflected accurately, it is recommended for you to add tokens 5 minutes before the services end.": "لكي ينعكس الوقت بدقة، يُنصح بإضافة الرموز قبل 5 دقائق من انتهاء الخدمات.",
  "REMINDER - You cannot add tokens for extra times when the machine finishes the drying cycle.": "تذكير - لا يمكنك إضافة رموز لأوقات إضافية عندما تنتهي الآلة من دورة التجفيف.",
  "Why is the machine making noise?": "لماذا تصدر الآلة ضوضاء؟",
  "Please check the drum to see if there are any coins or other small things inside.": "يرجى فحص الحوض لمعرفة ما إذا كانت هناك أي عملات معدنية أو أشياء صغيرة أخرى بداخله.",
  "I have pressed the START button on the dryer, but it is still not working.": "لقد ضغطت على زر START في المجفف، لكنه لا يزال لا يعمل.",
  "Please try to open the door and close it again. Next, press the START button again to start drying.": "يرجى محاولة فتح الباب وإغلاقه مرة أخرى. بعد ذلك، اضغط على زر START مرة أخرى لبدء التجفيف.",
  "If the dryer is still not functioning, please contact our customer service line at 03-27700100 to receive further assistance.": "إذا كان المجفف لا يزال لا يعمل، يرجى الاتصال بخط خدمة العملاء لدينا على 03-27700100 للحصول على مساعدة إضافية.",
  "Paywave has deducted an amount from the card but the machine did not reflect the transaction.": "خصم الدفع اللاسلكي مبلغاً من البطاقة لكن الآلة لم تعكس المعاملة.",
  "The Paywave transaction has failed but the amount has still been deducted from my card.": "فشلت معاملة الدفع اللاسلكي لكن المبلغ لا يزال مخصوماً من بطاقتي.",
  "Paywave has double/triple charge but the machine cannot start.": "الدفع اللاسلكي فرض رسوماً مضاعفة/ثلاثية لكن الآلة لا تستطيع البدء.",
  "Paywave after double/triple charge machines can't start.": "الدفع اللاسلكي بعد الرسوم المضاعفة/الثلاثية، الآلات لا تستطيع البدء.",
  "Paywave is offline": "الدفع اللاسلكي غير متصل",
  "Do Cleanpro Express offer franchise business/selling machines/laundry products?": "هل تقدم Cleanpro Express أعمال الامتياز/بيع الآلات/منتجات الغسيل؟",
  "For further inquiries, please email to info@cleanproexpress.com": "للاستفسارات الإضافية، يرجى إرسال إيميل إلى info@cleanproexpress.com",
  "Step 6": "الخطوة 6",
  "User Existed": "المستخدم موجود",
  "This email is registered": "هذا الإيميل مسجل",
  "This phone number is registered": "رقم الهاتف هذا مسجل",
  "Invalid Email Address": "عنوان إيميل غير صحيح",
  "Let's get started!": "لنبدأ!",
  "Enter your e-mail/mobile number": "أدخل إيميلك/رقم هاتفك المحمول",
  "Enter your e-mail": "أدخل إيميلك",
  "Enter your mobile number": "أدخل رقم هاتفك المحمول",
  "Enter your e-mail address": "أدخل عنوان إيميلك",
  "Proceed": "المتابعة",
  "Enter OTP number": "أدخل رقم OTP",
  "You will receive a six-digit OTP via SMS sent to": "ستتلقى رمز OTP مكون من ستة أرقام عبر رسالة نصية ترسل إلى",
  "You will receive a six-digit OTP via e-mail sent to": "ستتلقى رمز OTP مكون من ستة أرقام عبر إيميل يرسل إلى",
  "Verify": "تحقق",
  "Resend OTP": "إعادة إرسال OTP",
  "Welcome onboard!": "مرحباً بك على متنا!",
  "Please fill in the info below": "يرجى ملء المعلومات أدناه",
  "Enter your name*": "أدخل اسمك*",
  "Enter your email address*": "أدخل عنوان إيميلك*",
  "Please enter either phone number or email address": "يرجى إدخال رقم الهاتف أو عنوان الإيميل",
  "Create a password*": "إنشاء كلمة مرور*",
  "Enter referral code (if got any)": "أدخل رمز الإحالة (إن وجد)",
  "Get started": "ابدأ",
  "Birthday updated successfully": "تم تحديث عيد الميلاد بنجاح",
  "Date of birth": "تاريخ الميلاد",
  "Enter your date of birth": "أدخل تاريخ ميلادك",
  "Select your birth date": "اختر تاريخ ميلادك",
  "Update date of birth": "تحديث تاريخ الميلاد",
  "Update birth date": "تحديث تاريخ الميلاد",
  "Already have an account?": "لديك حساب بالفعل؟",
  "Login now": "سجل الدخول الآن",
  "Sign in": "تسجيل الدخول",
  "Sign up now": "سجل الآن",
  "COMPLETED": "مكتمل",
  "WASHING NOW": "يغسل الآن",
  "DRYING NOW": "يجفف الآن",
  "It's done!": "انتهى!",
  "Please collect your fresh, clean laundry in order to leave the machine available for the next person to use!": "يرجى جمع غسيلك النظيف المنعش لتترك الآلة متاحة للشخص التالي للاستخدام!",
  "Leave a feedback": "اترك تعليق",
  "Time left": "الوقت المتبقي",
  "Add drying time": "إضافة وقت التجفيف",
  "Hi": "مرحباً",
  "customer": "عميل",
  "Thank you for your payment. Don't forget to select the <b>correct temperature</b> and press <b>START</b> when you're ready.": "شكراً لك على دفعتك. لا تنس اختيار <b>درجة الحرارة الصحيحة</b> والضغط على <b>START</b> عندما تكون جاهزاً.",
  "Select how you want to receive a notification when your laundry is finished": "اختر كيف تريد تلقي إشعار عندما ينتهي غسيلك",
  "Sign up": "التسجيل",
  "Continue to pay": "المتابعة للدفع",
  "Register as a member to enjoy more benefits!": "سجل كعضو للاستمتاع بمزيد من المزايا!",
  "Get FREE {{ voucherAmount }} credits per new user_one": "احصل على {{ voucherAmount }} رصيد مجاني لكل مستخدم جديد",
  "Get FREE {{ voucherAmount }} credits per new user_other": "احصل على {{ voucherAmount }} أرصدة مجانية لكل مستخدم جديد",
  "Get FREE {{ voucherAmount }}% per new user": "احصل على {{ voucherAmount }}% مجاني لكل مستخدم جديد",
  "Enjoy exclusive promotions": "استمتع بالعروض الترويجية الحصرية",
  "FREE voucher on your birthday": "قسيمة مجانية في عيد ميلادك",
  "and more": "والمزيد",
  "Denied camera access": "تم رفض الوصول للكاميرا",
  'Permission to access the camera has been denied. Please try again and click "Allow" to scan the QR code.': 'تم رفض الإذن للوصول إلى الكاميرا. يرجى المحاولة مرة أخرى والنقر على "السماح" لمسح رمز QR.',
  "Okay": "حسناً",
  "Oops. You don't have enough balance to make the payment": "عذراً. ليس لديك رصيد كافٍ لإجراء الدفع",
  "Please confirm": "يرجى التأكيد",
  "Do you want to proceed with this feedback?": "هل تريد المتابعة مع هذا التعليق؟",
  "Are you sure to purchase": "هل أنت متأكد من الشراء",
  "credits for": "أرصدة لـ",
  "Topup credit": "شحن الأرصدة",
  "Extended duration will be instantly reflected on machine after payment": "المدة الممددة ستنعكس فوراً على الآلة بعد الدفع",
  "Machine is currently busy": "الآلة مشغولة حالياً",
  "Do you want to extend drying time?": "هل تريد تمديد وقت التجفيف؟",
  "OTHER": "أخرى",
  "Welcome Voucher": "قسيمة الترحيب",
  "Welcome to the Cleanpro Plus family! This first gift is just the beginning. Stay tuned for a series of exciting promotions and campaigns, exclusively for Cleanpro Plus users.": "مرحباً بك في عائلة Cleanpro Plus! هذه الهدية الأولى هي مجرد البداية. ابق منتبهاً لسلسلة من العروض الترويجية والحملات المثيرة، حصرياً لمستخدمي Cleanpro Plus.",
  "Terms & Conditions": "الشروط والأحكام",
  "TERMS AND CONDITIONS": "الشروط والأحكام",
  "Welcome Voucher is valid for one-time use only.": "قسيمة الترحيب صالحة للاستخدام مرة واحدة فقط.",
  "There is no minimum spend required for the voucher to be used.": "لا يوجد حد أدنى للإنفاق مطلوب لاستخدام القسيمة.",
  "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only._one": "تُضاف قسيمة الترحيب تلقائياً إلى حساب المستخدم عند نقطة التسجيل في Cleanpro Plus وصالحة لمدة {{ duration }} يوم فقط.",
  "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only._other": "تُضاف قسيمة الترحيب تلقائياً إلى حساب المستخدم عند نقطة التسجيل في Cleanpro Plus وصالحة لمدة {{ duration }} يوماً فقط.",
  "Users are eligible to use their Welcome Voucher AFTER the completion of their first wash or dry cycle using the same Cleanpro Plus account.": "المستخدمون مؤهلون لاستخدام قسيمة الترحيب الخاصة بهم بعد إكمال أول دورة غسل أو تجفيف باستخدام نفس حساب Cleanpro Plus.",
  "Welcome Voucher cannot be used together with any ongoing promotions or any other promotional vouchers.": "لا يمكن استخدام قسيمة الترحيب مع أي عروض ترويجية جارية أو أي قسائم ترويجية أخرى.",
  "The voucher is final and cannot be refunded in form of cash or credit to the user.": "القسيمة نهائية ولا يمكن استردادها في شكل نقد أو رصيد للمستخدم.",
  "Cleanpro reserves the right to change the terms and conditions without prior notice.": "تحتفظ Cleanpro بالحق في تغيير الشروط والأحكام دون إشعار مسبق.",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})_one": "اجمع 10 طوابع إلكترونية لكسب قسيمة أرصدة مجانية {{ voucherAmount }} (بقيمة {{ currency }}{{ voucherAmount }})",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})_other": "اجمع 10 طوابع إلكترونية لكسب قسيمة أرصدة مجانية {{ voucherAmount }} (بقيمة {{ currency }}{{ voucherAmount }})",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }}% voucher (worth {{ voucherAmount }}%)": "اجمع 10 طوابع إلكترونية لكسب قسيمة {{ voucherAmount }}% مجانية (بقيمة {{ voucherAmount }}%)",
  "Collect 10 e-Stamp to earn FREE Voucher": "اجمع 10 طوابع إلكترونية لكسب قسيمة مجانية",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding._one": "مع كل 10 طوابع إلكترونية تجمعها، ستحصل على قسيمة أرصدة مجانية {{ voucherAmount }} (بقيمة {{ currency }}{{ voucherAmount }}). اجعل روتين الغسيل الخاص بك ليس فقط خالياً من المتاعب، ولكن أيضاً مجزياً.",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding._other": "مع كل 10 طوابع إلكترونية تجمعها، ستحصل على قسيمة أرصدة مجانية {{ voucherAmount }} (بقيمة {{ currency }}{{ voucherAmount }}). اجعل روتين الغسيل الخاص بك ليس فقط خالياً من المتاعب، ولكن أيضاً مجزياً.",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }}% credits voucher (worth {{ voucherAmount }}%). Make your laundry routine not just hassle-free, but also rewarding.": "مع كل 10 طوابع إلكترونية تجمعها، ستحصل على قسيمة أرصدة {{ voucherAmount }}% مجانية (بقيمة {{ voucherAmount }}%). اجعل روتين الغسيل الخاص بك ليس فقط خالياً من المتاعب، ولكن أيضاً مجزياً.",
  "RM10 OFF Welcome Voucher": "قسيمة ترحيب خصم 10 رينغت ماليزي",
  "Welcome to the Cleanpro family, here is an appreciation voucher from us. Thank you for attending the COPE Investors Conference.": "مرحباً بك في عائلة Cleanpro، إليك قسيمة تقدير منا. شكراً لك لحضور مؤتمر المستثمرين COPE.",
  "Welcome Voucher | COPE Investors Conference": "قسيمة الترحيب | مؤتمر المستثمرين COPE",
  "Payment methods": "طرق الدفع",
  "Tap to proceed with your preferred mode of payment": "اضغط للمتابعة بطريقة الدفع المفضلة لديك",
  "Cleanpro Plus credits": "أرصدة Cleanpro Plus",
  "E-wallet or credit/debit cards": "المحفظة الإلكترونية أو بطاقات الائتمان/الخصم",
  "Go to homepage": "اذهب إلى الصفحة الرئيسية",
  // backend response or error
  "Admin is unauthorized to login": "المدير غير مخول لتسجيل الدخول",
  "Internal Error": "خطأ داخلي",
  "Please enter the correct credentials": "يرجى إدخال بيانات الاعتماد الصحيحة",
  "Operator not found": "المشغل غير موجود",
  "Admin not found": "المدير غير موجود",
  "Distributor not found": "الموزع غير موجود",
  "Client not found": "العميل غير موجود",
  "Outlet not found": "المنفذ غير موجود",
  "Token Package not found": "حزمة الرمز غير موجودة",
  "Top up history not found": "تاريخ الشحن غير موجود",
  "Voucher not found": "القسيمة غير موجودة",
  "Faq not found": "الأسئلة الشائعة غير موجودة",
  "Faq Group not found": "مجموعة الأسئلة الشائعة غير موجودة",
  "News not found": "الأخبار غير موجودة",
  "Transaction not found": "المعاملة غير موجودة",
  "Please Login Again": "يرجى تسجيل الدخول مرة أخرى",
  "Decoding Error": "خطأ في فك التشفير",
  "Some error occured, please contact the dev team if this error continues.": "حدث خطأ ما، يرجى التواصل مع فريق التطوير إذا استمر هذا الخطأ.",
  "Please fill in all the required fields": "يرجى ملء جميع الحقول المطلوبة",
  "Only success transaction can be refund": "لا يمكن استرداد الأموال إلا للمعاملات الناجحة",
  "Only token payment method can be refund": "طريقة الدفع بالرموز المميزة فقط يمكن استردادها",
  "The discount code has been used, please change to other code": "تم استخدام رمز الخصم، يرجى تغييره إلى رمز آخر",
  "Cannot use ewallet in sandbox": "لا يمكن استخدام المحفظة الإلكترونية في بيئة الاختبار",
  "Please close the door to proceed your payment": "يرجى إغلاق الباب للمتابعة في عملية الدفع",
  "Under Maintenance": "تحت الصيانة",
  "This machine is being fixed. Please use another machine.": "هذه الآلة قيد الإصلاح. يرجى استخدام آلة أخرى.",
  "Machine is currently running, please try again later": "الآلة تعمل حالياً، يرجى المحاولة مرة أخرى لاحقاً",
  "Machine is currently offline, please try again later": "الآلة غير متصلة حالياً، يرجى المحاولة مرة أخرى لاحقاً",
  "Outlet not participating in Loyalty program": "المتجر لا يشارك في برنامج الولاء",
  "Please log in to make the payment": "يرجى تسجيل الدخول لإجراء الدفع",
  "Package not found, please refresh and try again": "الحزمة غير موجودة، يرجى التحديث والمحاولة مرة أخرى",
  "You have reached the maximum number of purchase": "لقد وصلت إلى الحد الأقصى لعدد المشتريات",
  "Store not found, please try again later": "المتجر غير موجود، يرجى المحاولة مرة أخرى لاحقاً",
  "Incorrect Password": "كلمة مرور خاطئة",
  "Token already top up": "تم شحن الرمز المميز مسبقاً",
  "Payment failed": "فشل في الدفع",
  "Transaction Failure": "فشل في المعاملة",
  "Transaction Refunded": "تم استرداد المعاملة",
  "Transaction Pending": "المعاملة معلقة",
  "Please enter your mobile number": "يرجى إدخال رقم هاتفك المحمول",
  "User is unauthorized to register": "المستخدم غير مخول للتسجيل",
  "Please proceed to sign up": "يرجى المتابعة للتسجيل",
  "OTP expired, please request a new OTP": "انتهت صلاحية رمز التحقق، يرجى طلب رمز جديد",
  "Incorrect verification code": "رمز التحقق غير صحيح",
  "This referrer ID is not valid": "معرف الإحالة غير صالح",
  "This referrer ID is different operator": "معرف الإحالة يتبع لمشغل مختلف",
  "This referrer ID is exceed the limit": "معرف الإحالة تجاوز الحد المسموح",
  "User is unauthorized to login": "المستخدم غير مخول لتسجيل الدخول",
  "Click here to register": "انقر هنا للتسجيل",
  "User is unauthorized to login. Please contact the admin": "المستخدم غير مخول لتسجيل الدخول. يرجى التواصل مع المدير",
  "User is unauthorized": "المستخدم غير مخول",
  "This outlet does not participate in the Loyalty Program": "هذا المتجر لا يشارك في برنامج الولاء",
  "This outlet is not belongs to the operator": "هذا المتجر لا ينتمي إلى المشغل",
  "Processing request": "معالجة الطلب",
  "This user is not verified": "هذا المستخدم غير موثق",
  "Insufficient token to make payment": "رموز غير كافية لإجراء الدفع",
  "Insufficient token to transfer": "رموز غير كافية للتحويل",
  "Insufficient point to make payment": "نقاط غير كافية لإجراء الدفع",
  "This voucher is not available for use": "هذا القسيمة غير متاحة للاستخدام",
  "This voucher is belongs to other user": "هذا القسيمة تنتمي إلى مستخدم آخر",
  "Invalid Discount Code": "رمز خصم غير صالح",
  "This discount code cannot use in this outlet": "لا يمكن استخدام رمز الخصم هذا في هذا المتجر",
  "This discount code was expired": "انتهت صلاحية رمز الخصم",
  "This discount code cannot use in washer machine transaction": "لا يمكن استخدام رمز الخصم هذا في معاملة آلة الغسيل",
  "This discount code cannot use in dryer machine transaction": "لا يمكن استخدام رمز الخصم هذا في معاملة آلة التجفيف",
  "This discount code was fully redeemed today, try again tomorrow": "تم استخدام رمز الخصم بالكامل اليوم، جرب مرة أخرى غداً",
  "You have fully redeemed this discount code": "لقد استخدمت رمز الخصم هذا بالكامل",
  "This discount code have been redeemed": "تم استخدام رمز الخصم",
  "This discount code is not applicable": "رمز الخصم هذا غير قابل للتطبيق",
  "Insufficient stamp": "طوابع غير كافية",
  "Please provide at least one voucher setting": "يرجى توفير إعداد قسيمة واحد على الأقل",
  "Previous batch are still generating, please try again later": "الدفعة السابقة ما زالت قيد الإنشاء، يرجى المحاولة مرة أخرى لاحقاً",
  "Number of voucher code should be more than 0": "عدد أكواد القسائم يجب أن يكون أكثر من 0",
  "Number of voucher code should be less than 50000": "عدد أكواد القسائم يجب أن يكون أقل من 50000",
  "Number of discount code should be more than 0": "عدد أكواد الخصم يجب أن يكون أكثر من 0",
  "Number of discount code should be less than 50000": "عدد أكواد الخصم يجب أن يكون أقل من 50000",
  "No Item": "لا يوجد عنصر",
  "Please add item": "يرجى إضافة عنصر",
  "Staff not found": "الموظف غير موجود",
  "This task already completed": "هذه المهمة مكتملة بالفعل",
  "Please complete the wash task first": "يرجى إكمال مهمة الغسيل أولاً",
  "Please complete the dry task first": "يرجى إكمال مهمة التجفيف أولاً",
  "Please select at least one outlet": "يرجى اختيار متجر واحد على الأقل",
  "Touch to Start": "اضغط للبدء",
  "New Users": "مستخدمون جدد",
  "Get {{ voucher_amount }} FREE Credits!": "احصل على {{ voucher_amount }} نقطة مجانية!",
  "Get {{ voucher_amount }}% FREE!": "احصل على {{ voucher_amount }}% مجاناً!",
  "Load your clothes into the washing machine & note the machine number": "ضع ملابسك في آلة الغسيل واكتب رقم الآلة",
  "T&C Apply": "تطبق الشروط والأحكام",
  "Mobile Number": "رقم المحمول",
  "Member": "عضو",
  "Please enter your mobile phone number / e-mail": "يرجى إدخال رقم هاتفك المحمول / البريد الإلكتروني",
  "Please verify your number": "يرجى التحقق من رقمك",
  "Please verify your e-mail": "يرجى التحقق من بريدك الإلكتروني",
  "Please enter the correct phone number format. Example: 01xxxxxxxx": "يرجى إدخال تنسيق رقم الهاتف الصحيح. مثال: 01xxxxxxxx",
  "Please enter the correct phone number format. Example: 09xxxxxxxx": "يرجى إدخال تنسيق رقم الهاتف الصحيح. مثال: 09xxxxxxxx",
  "Scan QR to Complete your signup & access more benefits!": "امسح رمز QR لإكمال تسجيلك والوصول إلى المزيد من المزايا!",
  "Please choose your service": "يرجى اختيار خدمتك",
  "WASHER": "الغسالة",
  "DRYER": "المجفف",
  "VENDING MACHINE": "آلة البيع",
  "Please tap your card on the reader": "يرجى وضع بطاقتك على القارئ",
  "Payment Option": "خيار الدفع",
  "Thank you for payment!": "شكراً لك على الدفع!",
  "Please select your items at the vending machine": "يرجى اختيار عناصرك من آلة البيع",
  "Please choose the temperature on the machine and press": "يرجى اختيار درجة الحرارة على الآلة واضغط",
  "START": "ابدأ",
  "Need Help?": "تحتاج مساعدة؟",
  "Please choose the temperature": "يرجى اختيار درجة الحرارة",
  "Confirm Payment": "تأكيد الدفع",
  "Select the time for": "اختر الوقت لـ",
  "Do you want to add drying time?": "هل تريد إضافة وقت التجفيف؟",
  "minutes": "دقائق",
  "Your machine is": "آلتك هي",
  "Please Collect your item from the vending machine": "يرجى جمع عنصرك من آلة البيع",
  "You've earned 1 e-stamp for your wash!": "لقد حصلت على طابع إلكتروني واحد للغسيل!",
  "You've earned 1 e-stamp for your dry!": "لقد حصلت على طابع إلكتروني واحد للتجفيف!",
  "You've missed 1 e-stamp for your wash!": "لقد فاتك طابع إلكتروني واحد للغسيل!",
  "You've missed 1 e-stamp for your dry!": "لقد فاتك طابع إلكتروني واحد للتجفيف!",
  "Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "اجمع 10 طوابع إلكترونية للغسيل لتحصل على قسيمة نقاط مجانية بقيمة {{ amount }}.",
  "Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "اجمع 10 طوابع إلكترونية للغسيل لتحصل على قسيمة خصم {{ amount }}%.",
  "Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "اجمع 10 طوابع إلكترونية للتجفيف لتحصل على قسيمة نقاط مجانية بقيمة {{ amount }}.",
  "Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "اجمع 10 طوابع إلكترونية للتجفيف لتحصل على قسيمة خصم {{ amount }}%.",
  "Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "اجمع 10 طوابع إلكترونية للغسيل والتجفيف لتحصل على قسيمة نقاط مجانية بقيمة {{ amount }}.",
  "Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "اجمع 10 طوابع إلكترونية للغسيل والتجفيف لتحصل على قسيمة خصم {{ amount }}%.",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "سجل واجمع 10 طوابع إلكترونية للغسيل والتجفيف لتحصل على قسيمة نقاط مجانية بقيمة {{ amount }}.",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "سجل واجمع 10 طوابع إلكترونية للغسيل والتجفيف لتحصل على قسيمة خصم {{ amount }}%.",
  "Sign Up & Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "سجل واجمع 10 طوابع إلكترونية للغسيل لتحصل على قسيمة نقاط مجانية بقيمة {{ amount }}.",
  "Sign Up & Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "سجل واجمع 10 طوابع إلكترونية للغسيل لتحصل على قسيمة خصم {{ amount }}%.",
  "Sign Up & Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "سجل واجمع 10 طوابع إلكترونية للتجفيف لتحصل على قسيمة نقاط مجانية بقيمة {{ amount }}.",
  "Sign Up & Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "سجل واجمع 10 طوابع إلكترونية للتجفيف لتحصل على قسيمة خصم {{ amount }}%.",
  'For iOS users, press and hold the image, then choose "Add to Photos" or "Save in Photos" from the menu.': 'لمستخدمي iOS، اضغط مع الاستمرار على الصورة، ثم اختر "إضافة إلى الصور" أو "حفظ في الصور" من القائمة.',
  "Scan the QR code to pay": "امسح رمز QR للدفع",
  "QR Code expires in {{ countdown }} seconds": "رمز QR ينتهي خلال {{ countdown }} ثانية",
  "Transfer In": "تحويل داخل",
  "Migrate": "ترحيل",
  "Update": "تحديث",
  "Transfer Out": "تحويل خارج",
  "Total In": "إجمالي الدخل",
  "Total Out": "إجمالي الخروج",
  "Laundry Pass": "بطاقة الغسيل",
  "Number of wash": "عدد الغسلات",
  "Number of Wash": "عدد الغسلات",
  "Number of dry": "عدد التجفيفات",
  "Number of Dry": "عدد التجفيفات",
  "Laundry Pass Purchase": "شراء بطاقة الغسيل",
  "Laundry Pass Purchase Report": "تقرير شراء بطاقة الغسيل",
  "Please select distributor or operator": "يرجى اختيار الموزع أو المشغل",
  "Price should be more than 0": "السعر يجب أن يكون أكثر من 0",
  "Number of wash or dry should be more than 0": "عدد الغسلات أو التجفيفات يجب أن يكون أكثر من 0",
  "Number of wash should be more than 0": "عدد الغسلات يجب أن يكون أكثر من 0",
  "Number of dry should be more than 0": "عدد التجفيفات يجب أن يكون أكثر من 0",
  "Duration must be more than 0": "المدة يجب أن تكون أكثر من 0",
  "Please fill in the name": "يرجى ملء الاسم",
  "Purchase Start Date": "تاريخ بداية الشراء",
  "Purchase End Date": "تاريخ نهاية الشراء",
  "Number of Maximum Purchase": "عدد المشتريات الأقصى",
  "Create Laundry Pass": "إنشاء بطاقة الغسيل",
  "Select Purchase Period": "اختر فترة الشراء",
  "If ticked, the Laundry Pass will have expired date": "إذا تم التأشير، ستكون لبطاقة الغسيل تاريخ انتهاء",
  "Laundry Pass Lifespan": "عمر بطاقة الغسيل",
  "Edit Laundry Pass": "تعديل بطاقة الغسيل",
  "Washer Used Date": "تاريخ استخدام الغسالة",
  "Dryer Used Date": "تاريخ استخدام المجفف",
  "Laundry Pass Purchase History": "تاريخ شراء بطاقة الغسيل",
  "Laundry Pass Usage Report": "تقرير استخدام بطاقة الغسيل",
  "Please Note! (Stacked Dryer)": "يرجى الملاحظة! (مجفف مكدس)",
  "Ensure machine is vacant and select correct machine after payment press START": "تأكد من أن الآلة فارغة واختر الآلة الصحيحة بعد الدفع اضغط ابدأ",
  "Start date": "تاريخ البداية",
  "End date": "تاريخ النهاية",
  "Today": "اليوم",
  "Yesterday": "أمس",
  "Last 7 Days": "آخر 7 أيام",
  "Last 30 Days": "آخر 30 يوماً",
  "This Month": "هذا الشهر",
  "Last Month": "الشهر الماضي",
  "Use Per Day": "الاستخدام في اليوم",
  "Maximum use per day must be more than 0": "الحد الأقصى للاستخدام في اليوم يجب أن يكون أكثر من 0",
  "Only applicable to selected outlet": "ينطبق فقط على المتجر المحدد",
  "Applicable to all the outlets except selected outlet": "ينطبق على جميع المتاجر عدا المتجر المحدد",
  "If applicable to all the outlet, leave it blank": "إذا كان ينطبق على جميع المتاجر، اتركه فارغاً",
  "Only applicable to selected weight": "ينطبق فقط على الوزن المحدد",
  "Applicable to all the weight except selected weight": "ينطبق على جميع الأوزان عدا الوزن المحدد",
  "Weight": "الوزن",
  "If applicable to all the weight, leave it blank": "إذا كان ينطبق على جميع الأوزان، اتركه فارغاً",
  "Add Weight": "إضافة وزن",
  "Only applicable to selected mode": "ينطبق فقط على النمط المحدد",
  "Applicable to all the modes except selected mode": "ينطبق على جميع الأنماط عدا النمط المحدد",
  "If applicable to all the mode, leave it blank": "إذا كان ينطبق على جميع الأنماط، اتركه فارغاً",
  "Add Mode": "إضافة نمط",
  "Laundry Pass not applicable in this outlet": "بطاقة الغسيل غير قابلة للتطبيق في هذا المتجر",
  "Discounted price should be more than 0": "السعر المخفض يجب أن يكون أكثر من 0",
  "Discounted Price": "السعر المخفض",
  "Logo (Optional)": "الشعار (اختياري)",
  "Save": "حفظ",
  "Cleanpro Laundry Pass": "بطاقة غسيل Cleanpro",
  "Save more with the Laundry Pass — ": "وفر أكثر مع بطاقة الغسيل — ",
  "wash and dry more clothes at a lower price while enjoying extra rewards from Cleanpro Plus!": "اغسل وجفف المزيد من الملابس بسعر أقل بينما تستمتع بمكافآت إضافية من Cleanpro Plus!",
  "How to Purchase Laundry Pass": "كيفية شراء بطاقة الغسيل",
  "Step 1: Register as a Cleanpro Plus user.": "الخطوة 1: سجل كمستخدم Cleanpro Plus.",
  "Step 2: Choose the Laundry Pass package you wish to purchase.": "الخطوة 2: اختر حزمة بطاقة الغسيل التي تريد شراءها.",
  "Step 3: Make the payment through Cleanpro Plus.": "الخطوة 3: قم بالدفع من خلال Cleanpro Plus.",
  "Step 4: Enjoy washing and drying services at any Cleanpro outlet in Malaysia with exclusive discounted prices!": "الخطوة 4: استمتع بخدمات الغسيل والتجفيف في أي متجر Cleanpro في ماليزيا بأسعار مخفضة حصرية!",
  "By purchasing and/or using the Cleanpro Laundry Pass, you agree to be bound by the following terms and conditions:": "بشراء و/أو استخدام بطاقة غسيل Cleanpro، فإنك توافق على الالتزام بالشروط والأحكام التالية:",
  "Definitions": "التعريفات",
  '"Laundry Pass" refers to the package(s) for specific laundry services offered by Cleanpro.': '"بطاقة الغسيل" تشير إلى الحزمة (الحزم) لخدمات الغسيل المحددة التي تقدمها Cleanpro.',
  '"Subscriber" refers to the individual(s) purchasing and/or using the Laundry Pass.': '"المشترك" يشير إلى الفرد (الأفراد) الذين يشترون و/أو يستخدمون بطاقة الغسيل.',
  "Pass Description": "وصف البطاقة",
  "The Laundry Pass is a promotional package that offers laundry services at any Cleanpro outlet in Malaysia.": "بطاقة الغسيل هي حزمة ترويجية تقدم خدمات الغسيل في أي متجر Cleanpro في ماليزيا.",
  'The Laundry Pass is valid for both Malaysians and non-Malaysians; and is exclusively available to Cleanpro Plus members.': 'بطاقة الغسيل صالحة للماليزيين وغير الماليزيين؛ وهي متاحة حصرياً لأعضاء Cleanpro Plus.',
  "The campaign of Laundry Pass is valid from": "حملة بطاقة الغسيل صالحة من",
  "1 March 2025 to 31 May 2025.": "1 مارس 2025 إلى 31 مايو 2025.",
  'Each Laundry Pass subscription is': 'كل اشتراك في بطاقة الغسيل',
  'valid for 30 days from the start date,': 'صالح لمدة 30 يوماً من تاريخ البداية،',
  'allowing subscribers to use the package': 'يسمح للمشتركين باستخدام الحزمة',
  'up to 4 times per day.': 'حتى 4 مرات في اليوم.',
  'During the promotional period, subscribers can repurchase the package unlimited times, but only after fully utilizing your current subscription.': 'خلال فترة الترويج، يمكن للمشتركين إعادة شراء الحزمة عدد مرات غير محدود، ولكن فقط بعد الاستفادة الكاملة من اشتراكهم الحالي.',
  "The Laundry Pass is": "بطاقة الغسيل",
  "valid only for cold wash and drying of machines under 25kg.": "صالحة فقط للغسيل البارد والتجفيف في الآلات التي تقل عن 25 كجم.",
  "Additional charges will apply for warm and hot wash services, based on the temperature selected.": "ستنطبق رسوم إضافية لخدمات الغسيل الدافئ والساخن، بناءً على درجة الحرارة المختارة.",
  'Unused wash or dry session(s) from the Laundry Pass cannot be carried forward to the next purchase, and are non-refundable, non-exchangeable for cash, and non-transferable.': 'جلسات الغسيل أو التجفيف غير المستخدمة من بطاقة الغسيل لا يمكن نقلها إلى الشراء التالي، وهي غير قابلة للاسترداد أو الاستبدال نقداً أو التحويل.',
  'The Laundry Pass is valid for washing and/or drying standard laundry items only (e.g., clothing, linens), excluding large items (e.g., rugs), heavily soiled items (e.g., pet bedding), or specialty items requiring special treatment.': 'بطاقة الغسيل صالحة لغسيل و/أو تجفيف عناصر الغسيل العادية فقط (مثل الملابس، البياضات)، باستثناء العناصر الكبيرة (مثل السجاد)، العناصر المتسخة بشدة (مثل فراش الحيوانات الأليفة)، أو العناصر المتخصصة التي تتطلب معاملة خاصة.',
  'The Laundry Pass can be cancelled within the first 7 days of subscription for a full refund, provided the subscriber has not used the Laundry Pass during this period. No refunds or transfers will be issued after the first 7 days.': 'يمكن إلغاء بطاقة الغسيل خلال أول 7 أيام من الاشتراك لاسترداد كامل، شرط ألا يكون المشترك قد استخدم بطاقة الغسيل خلال هذه الفترة. لن يتم إصدار أي استرداد أو تحويلات بعد أول 7 أيام.',
  "Refund process may take up to 21 working days.": "قد تستغرق عملية الاسترداد حتى 21 يوم عمل.",
  'Subscribers are encouraged to regularly check Cleanpro Plus for reminders regarding the expiry date of their laundry pass.': 'يُشجع المشتركون على التحقق بانتظام من Cleanpro Plus للحصول على تذكيرات بشأن تاريخ انتهاء صلاحية بطاقة الغسيل الخاصة بهم.',
  "This promotion is not valid in conjunction with the '10 Free 1 e-Stamp Campaign'.": "هذا العرض غير صالح بالاقتران مع 'حملة 10 طوابع إلكترونية مجانية'.",
  "Any misuse of the Laundry Pass will result in the immediate termination of the subscription without prior notice. Payments for the Laundry Pass are non-refundable, non-exchangeable for cash, and non-transferable.": "أي سوء استخدام لبطاقة الغسيل سيؤدي إلى الإنهاء الفوري للاشتراك دون إشعار مسبق. المدفوعات لبطاقة الغسيل غير قابلة للاسترداد أو الاستبدال نقداً أو التحويل.",
  "Payment must be made in full at the time of subscription via Cleanpro Plus.": "يجب دفع المبلغ بالكامل وقت الاشتراك عبر Cleanpro Plus.",
  "For any questions or assistance regarding the Laundry Pass, please email Cleanpro Customer Service at enquiry@cleanpro.asia.": "لأي أسئلة أو مساعدة بخصوص بطاقة الغسيل، يرجى إرسال بريد إلكتروني إلى خدمة عملاء Cleanpro على enquiry@cleanpro.asia.",
  "Cleanpro reserves the right to change the terms and conditions at any time without prior notice.": "تحتفظ Cleanpro بالحق في تغيير الشروط والأحكام في أي وقت دون إشعار مسبق.",
  "Search": "بحث",
  "Scan to register as a member": "امسح للتسجيل كعضو",
  "Select Product / Key in Amount": "اختر المنتج / أدخل المبلغ",
  "Discount code is not available in this payment type": "رمز الخصم غير متاح في نوع الدفع هذا",
  "This voucher is not available use in washer payment": "هذه القسيمة غير متاحة للاستخدام في دفع الغسالة",
  "This voucher is not available use in dryer payment": "هذه القسيمة غير متاحة للاستخدام في دفع المجفف",
  "This voucher is not available use in Drop n Go payment": "هذه القسيمة غير متاحة للاستخدام في دفع Drop n Go",
  "Voucher is not available in this payment type": "القسيمة غير متاحة في نوع الدفع هذا",
  "Select the price for": "اختر السعر لـ",
  "Enable Stamping": "تمكين الختم",
  "Please select your preferred outlet": "يرجى اختيار متجرك المفضل",
  "Select your preferred outlet": "اختر متجرك المفضل",
  "State": "الولاية",
  "Select State": "اختر الولاية",
  "Payment Successful!": "تم الدفع بنجاح!",
  "Thank you for purchasing Laundry Pass!": "شكراً لك على شراء بطاقة الغسيل!",
  "Your Laundry Pass expired on": "انتهت صلاحية بطاقة الغسيل الخاصة بك في",
  "You have used all your Laundry Pass": "لقد استخدمت كل بطاقة الغسيل الخاصة بك",
  "Purchase Again": "اشتري مرة أخرى",
  "Save Big!": "وفر كثيراً!",
  "You've saved": "لقد وفرت",
  "on your package!": "على حزمتك!",
  "Please select distributor, operator or outlet": "يرجى اختيار الموزع أو المشغل أو المتجر",
  "Please enter your mobile phone number or e-mail": "يرجى إدخال رقم هاتفك المحمول أو البريد الإلكتروني",
  "We'll send you an SMS when your laundry's ready": "سنرسل لك رسالة نصية عندما يصبح غسيلك جاهزاً",
  "Skip": "تخطي",
  "Notice": "إشعار",
  "User exists but not verified. Please verify your account by scanning the QR Code at Thank You Page.": "المستخدم موجود لكن غير موثق. يرجى التحقق من حسابك عن طريق مسح رمز QR في صفحة الشكر.",
  "User registered successfully. Please complete verification by scanning the QR Code at Thank You Page.": "تم تسجيل المستخدم بنجاح. يرجى إكمال التحقق عن طريق مسح رمز QR في صفحة الشكر.",
  "Please enter email address to register": "يرجى إدخال عنوان البريد الإلكتروني للتسجيل",
  "Please enter phone number to register": "يرجى إدخال رقم الهاتف للتسجيل",
  "Camera permission is denied": "تم رفض إذن الكاميرا",
  "No camera device found": "لم يتم العثور على جهاز كاميرا",
  "Camera is already in use by another app": "الكاميرا قيد الاستخدام من قبل تطبيق آخر",
  "Preferred Outlet": "المتجر المفضل",
  "Purchase Now": "اشتر الآن",
  "Cancel Date": "تاريخ الإلغاء",
  "Cancel Laundry Pass": "إلغاء بطاقة الغسيل",
  "Download or takes a screenshot of the QR code.": "قم بتنزيل أو التقاط لقطة شاشة لرمز QR.",
  "Launch and login banking app.": "افتح وسجل دخول تطبيق البنك.",
  "Choose QR code from your gallery.": "اختر رمز QR من معرض الصور.",
  "1 March 2025 - 30 April 2025": "1 مارس 2025 - 30 أبريل 2025",
  "Payment Method to get point": "طريقة الدفع للحصول على نقاط",
  "Payment Method to get voucher": "طريقة الدفع للحصول على قسيمة",
  "If applicable to all the payment method, leave it blank": "إذا كان ينطبق على جميع طرق الدفع، اتركه فارغاً",
  "Add {{ currency }} {{ amount }} for {{ mode }} Wash": "أضف {{ currency }} {{ amount }} لغسيل {{ mode }}",
  "Add {{ currency }} {{ amount }} for an extra {{ runtime }} minutes!": "أضف {{ currency }} {{ amount }} لدقائق إضافية {{ runtime }}!",
  "via": "عبر",
  "Cash": "Cash",
  "Are you sure you have collected your laundry?": "Are you sure you have collected your laundry?",
  "Collected All": "Collected All",
  "Collected": "Collected",
  "Are you sure the customer have collected the laundry?": "Are you sure the customer have collected the laundry?",
  "Pending Payment (Cash)": "Pending Payment (Cash)",
  "You have received the cash payment": "You have received the cash payment",
  "Print Receipt": "Print Receipt",
  "Are you sure you want to print receipt?": "Are you sure you want to print receipt?",
  "Are you sure you want to print sticker?": "Are you sure you want to print sticker?",
  "Copy": "ينسخ",
  "low": "منخفض",
  "medium": "متوسط",
  "high": "مرتفع",
  "About Us": "معلومات عنا",
  "ABOUT US": "معلومات عنا",
  "Only can request einvoice for Malaysia Outlet": "Only can request einvoice for Malaysia Outlet",
  "E-Invoice requested successfully": "E-Invoice requested successfully",
  "Select machine": "Select machine",
  "Select transaction date": "Select transaction date",
  "Transaction Time": "Transaction Time",
  "Select transaction time": "Select transaction time",
  "Transaction Amount": "Transaction Amount",
  "Enter Transaction Amount, Example: 1.50": "Enter Transaction Amount, Example: 1.50",
  "Select payment method": "Select payment method",
  "Cashless (e-Wallet / DuitNow QR)": "Cashless (e-Wallet / DuitNow QR)",
  "Paywave (Tap with Debit/Credit Card)": "Paywave (Tap with Debit/Credit Card)",
  "Request as": "Request as",
  "Individual": "Individual",
  "Company": "Company",
  "ID Type": "ID Type",
  "Select ID Type": "Select ID Type",
  "Company Name": "Company Name",
  "Phone": "Phone",
  "Address": "Address",
  "City": "City",
  "Postcode": "Postcode",
  "Request E-Invoice": "Request E-Invoice",
  "Request e-Invoice": "Request e-Invoice",
  "e-Invoice Validation Link": "e-Invoice Validation Link",
  "Credit Card": "Credit Card",
  "Credit Card Number": "Credit Card Number",
  "Credit Card Expiry Month": "Credit Card Expiry Month",
  "Credit Card Expiry Year": "Credit Card Expiry Year",
  "Credit Card Securtiy Code": "Credit Card Securtiy Code",
  "Credit Card Holder Name": "Credit Card Holder Name",
  "Settlement Amount": "Settlement Amount",
  "Paid": "Paid",
  "Enable E-Wallet Payment?": "تمكين الدفع من E-Wallet؟",
  "Enable DuitNow Payment?": "تمكين الدفع من DuitNow؟",
  "Enable Credit Card Terminal Payment?": "تمكين الدفع من خلال جهاز بطاقة الائتمان؟",
  "Transaction date is more than 3 days": "Transaction date is more than 3 days",
  "Select Recurrence Type": "اختر نوع التكرار",
  "Multiple Voucher": "قسائم متعددة",
  "Period for giving next voucher (days)": "الفترة الزمنية لتقديم القسيمة التالية (بالأيام)",
  "General Voucher Code Report": "تقرير رمز القسيمة العام",
  "Unique Voucher Code Report": "تقرير رمز القسيمة الفريد",
  "Select Code": "اختر الرمز",
  "Minimum transaction amount to use code cannot be negative": "الحد الأدنى لمبلغ المعاملة لاستخدام الرمز لا يمكن أن يكون سالباً",
  "Redeem per user must at least 1": "الاستبدال لكل مستخدم يجب أن يكون على الأقل 1",
  "Start date must before end date": "تاريخ البداية يجب أن يكون قبل تاريخ النهاية",
  "Please select the start date and end date": "يرجى اختيار تاريخ البداية وتاريخ النهاية",
  "Please enter the voucher code": "يرجى إدخال رمز القسيمة",
  "Successfully create the voucher code": "تم إنشاء رمز القسيمة بنجاح",
  "General Voucher Code": "رمز القسيمة العام",
  "Unique Voucher Code": "رمز القسيمة الفريد",
  "Add Voucher Code": "إضافة رمز القسيمة",
  "How many times the voucher code can be used for each user": "كم مرة يمكن استخدام رمز القسيمة لكل مستخدم",
  "Update Version": "تحديث الإصدار",
  "User profile updated successfully": "تم تحديث ملف تعريف المستخدم بنجاح",
  "Salutation": "التحية",
  "Nationality": "الجنسية",
  "Race": "العرق",
  "Gender": "الجنس",
  "Update salutation": "تحديث التحية",
  "Update ID Type": "تحديث نوع الهوية",
  "Update Address": "تحديث العنوان",
  "Update nationality": "تحديث الجنسية",
  "Male": "ذكر",
  "Female": "أنثى",
  "Update gender": "تحديث الجنس",
  "Number of Point cannot be 0": "عدد النقاط لا يمكن أن يكون 0",
  "Token value cannot be 0": "قيمة الرمز المميز لا يمكن أن تكون 0",
  "Activate": "تفعيل",
  "Deactivate": "إلغاء التفعيل",
  "Activate User": "تفعيل المستخدم",
  "Deactivate User": "إلغاء تفعيل المستخدم",
  "Are you sure you want to activate the user account?": "هل أنت متأكد من أنك تريد تفعيل حساب المستخدم؟",
  "Are you sure you want to deactivate the user account?": "هل أنت متأكد من أنك تريد إلغاء تفعيل حساب المستخدم؟",
  "Your point redemption is successful": "تم استرداد النقاط بنجاح",
  "Point Redemption": "استرداد النقاط",
  "This redemption has already been completed": "تم إنجاز هذا الاسترداد بالفعل",
  "Transaction Details": "تفاصيل المعاملة",
  "Please login to redeem point": "يرجى تسجيل الدخول لاسترداد النقاط",
  "Login as {{name}}": "تسجيل الدخول باسم {{name}}",
  "Payment Amount Settings": "إعدادات مبلغ الدفع",
  "Allow washer pay less than cheapest mode price?": "هل يسمح للغسالة بالدفع أقل من أرخص سعر للوضع؟",
  "Allow dryer pay less than minimum price?": "هل يسمح للمجفف بالدفع أقل من الحد الأدنى للسعر؟",
  "Drop n Go Settings": "إعدادات دروب آند جو",
  "Allow user pay for specific service only?": "هل يسمح للمستخدم بالدفع مقابل خدمة محددة فقط؟",
  "Display pricing for each service?": "عرض التسعير لكل خدمة؟",
  "Delete Voucher": "حذف القسيمة",
  "Are you sure you want to delete this voucher?": "هل أنت متأكد أنك تريد حذف هذه القسيمة؟",
  "Display in Promotion Page": "عرض في صفحة الترويج",
  "Add Promotion": "إضافة ترويج",
  "Select Transaction Status": "اختر حالة المعاملة",
  "Give Stamp for Drop n Go Transaction?": "هل تعطي طابعًا مقابل معاملة دروب آند جو؟",
  "Display machine capacity?": "عرض سعة الآلة؟",
  "External Voucher Code": "رمز القسيمة الخارجي",
  "Import Voucher Code": "استيراد رمز القسيمة",
  "Voucher Code Stamp Settings": "إعدادات ختم رمز القسيمة",
  "Upload Date": "تاريخ التحميل",
  "Import External Voucher Code": "استيراد رمز القسيمة الخارجي",
  "Import": "استيراد",
  "Please select a valid CSV file": "يرجى اختيار ملف CSV صالح",
  "Redeemed": "تم الاسترداد",
  "Sales": "المبيعات",
  "Drop N Go Dashboard": "لوحة تحكم Drop N Go",
  "Total Drop N Go Sales by Month": "إجمالي مبيعات Drop N Go حسب الشهر",
  "Total Drop N Go Sales by Day": "إجمالي مبيعات Drop N Go حسب اليوم",
}

const translationKm = {
  "LOGIN": "ចូល",
  "REGISTER": "ចុះឈ្មោះ",
  "SKIP TO PAYMENT": "រំលងទៅការទូទាត់",
  "Continue as guest": "បន្តជាអ្នកទេសចរ",
  "WELCOME": "សូមស្វាគមន៍",
  "Error": "កំហុស",
  "Please enter the correct phone number format. <br /><br /> <small>Example: 0129465628</small>": "សូមបញ្ចូលទ្រង់ទ្រាយលេខទូរស័ព្ទដែលត្រឹមត្រូវ។ <br /><br /> <small>ឧទាហរណ៍៖ 0129465628</small>",
  "Info": "ព័ត៌មាន",
  "Please scan QRCode to Login": "សូមស្កេន QRCode ដើម្បីចូល",
  "Forgot Password": "ភ្លេចពាក្យសម្ងាត់",
  "Seems like you have forgotten your password<br />Create a temporary password?": "ហាក់ដូចជាអ្នកបានភ្លេចពាក្យសម្ងាត់របស់អ្នក<br />បង្កើតពាក្យសម្ងាត់បណ្តោះអាសន្ន?",
  "Cancel": "បោះបង់",
  "Confirm": "បញ្ជាក់",
  "Reset Your Password": "កំណត់ពាក្យសម្ងាត់របស់អ្នកឡើងវិញ",
  "Enter Your Phone Number / Email Address": "បញ្ចូលលេខទូរស័ព្ទ / អាសយដ្ឋានអ៊ីមែលរបស់អ្នក",
  "Enter Your Email Address": "បញ្ចូលអាសយដ្ឋានអ៊ីមែលของคุณ",
  "Please enter phone number / email address": "សូមป้อนหมายเลขโทรศัพท์ / ที่อยู่อีเมล",
  "Please enter email address": "សូមបញ្ចូលអាសយដ្ឋានអ៊ីមែល",
  "Submit": "ដាក់ស្នើ",
  "Please enter a valid phone number": "សូមបញ្ចូលលេខទូរស័ព្ទដែលត្រឹមត្រូវ",
  "Please enter a valid email address": "សូមបញ្ចូលអាសយដ្ឋានអ៊ីមែលដែលត្រឹមត្រូវ",
  "Success!": "ជោគជ័យ!",
  "You may login using your one time password now.": "អ្នកអាចចូលប្រើដោយប្រើពាក្យសម្ងាត់ម្តងតែមួយឥឡូវនេះ",
  "Phone Number": "លេខទូរស័ព្ទ",
  "Password": "ពាក្យសម្ងាត់",
  "Don't have an account?": "មិនទាន់មានគណនីមែនទេ?",
  "Forgot password?": "ភ្លេចពាក្យសម្ងាត់?",
  "Unable to register without a QRCode": "មិនអាចចុះឈ្មោះដោយគ្មាន QRCode បានទេ",
  "Please read and agree to the privacy policies, terms and conditions": "សូមអាន និងយល់ព្រមលើគោលការណ៍ឯកជនភាព លក្ខខណ្ឌ និងកិច្ចព្រមព្រៀង",
  "Password length must be at least 6 characters": "ប្រវែងពាក្យសម្ងាត់ត្រូវមានយ៉ាងហោចណាស់ 6 តួអក្សរ",
  "Please enter the confirmation code that was sent to your phone": "សូមបញ្ចូលកូដបញ្ជាក់ដែលបានផ្ញើទៅទូរស័ព្ទរបស់អ្នក",
  "Example: 012xxxxxxx": "ឧទាហរណ៍៖ 012xxxxxxx",
  "Example: 09xxxxxxxx": "ឧទាហរណ៍៖ 09xxxxxxxx",
  "Verification Method": "វិធីសាស្ត្រផ្ទៀងផ្ទាត់",
  "Name": "ឈ្មោះ",
  "Email": "អ៊ីមែល",
  "optional": "ស្រេចចិត្ត",
  "Birth Year": "ឆ្នាំកំណើត",
  "Year": "ឆ្នាំ",
  "Birth Month": "ខែកំណើត",
  "Month": "ខែ",
  "Jan": "មករា",
  "Feb": "កុម្ភៈ",
  "Mar": "មីនា",
  "April": "មេសា",
  "May": "ឧសភា",
  "June": "មិថុនា",
  "July": "កក្កដា",
  "Aug": "សីហា",
  "Sept": "កញ្ញា",
  "Oct": "តុលា",
  "Nov": "វិច្ឆិកា",
  "Dec": "ធ្នូ",
  "Birth Day": "ថ្ងៃកំណើត",
  "Day": "ថ្ងៃ",
  "OTP": "OTP",
  "OTP Confirmation": "ការបញ្ជាក់ OTP",
  "I agree to the": "ខ្ញុំយល់ព្រមទៅនឹង",
  "Privacy Policy": "គោលការណ៍ឯកជនភាព",
  "PRIVACY POLICY": "គោលការណ៍ឯកជនភាព",
  "and": "និង",
  "Terms": "លក្ខខណ្ឌ",
  "Conditions": "លក្ខខណ្ឌ",
  "SEND CODE": "ផ្ញើកូដ",
  "Our One-Time Password (OTP) emails might end up in your spam or junk folder. We kindly ask you to take a moment to check your spam mailbox.": "អ៊ីមែល OTP របស់យើងអាចទៅដល់ប្រអប់សារឥតបានការ (Spam/Junk) របស់អ្នក។ សូមចំណាយពេលបន្តិចដើម្បីពិនិត្យមើលប្រអប់សារ Spam របស់អ្នក។",
  "Already have an account? Login": "មានគណនីរួចហើយមែនទេ? ចូលប្រើ",
  "Didn't receive a code?": "មិនទទួលបានកូដមែនទេ?",
  "Resend Code": "ផ្ញើកូដម្តងទៀត",
  "collected": "បានប្រមូល",
  "Collect": "ប្រមូល",
  "stamps": "ស្តាំ",
  "get 1 voucher": "ទទួលបានប័ណ្ណបញ្ចុះតម្លៃ ១",
  "Minimum": "អប្បបរមា",
  "spending to collect each washer stamp": "ចំណាយដើម្បីប្រមូលស្តាំម៉ាស៊ីនបោកគក់មួយ",
  "spending to collect each dryer stamp": "ចំណាយដើម្បីប្រមូលស្តាំម៉ាស៊ីនសម្ងួតមួយ",
  "spending to collect each stamp": "ចំណាយដើម្បីប្រមូលស្តាំមួយ",
  "Device don't have a camera": "ឧបករណ៍មិនមានកាមេរ៉ា",
  "This is not a valid QRCode": "នេះមិនមែនជា QRCode ត្រឹមត្រូវទេ",
  "Select Camera": "ជ្រើសរើសកាមេរ៉ា",
  "Switch": "ប្ដូរ",
  "Camera": "កាមេរ៉ា",
  "Loading": "កំពុងផ្ទុក",
  "Scan the QR code on the machine.": "ស្កេន QR code នៅលើម៉ាស៊ីន",
  "Switch Camera": "ប្ដូរកាមេរ៉ា",
  "Off torch light": "បិទភ្លើង",
  "On torch light": "បើកភ្លើង",
  "switch camera if your camera is not clear": "ប្ដូរកាមេរ៉ាប្រសិនបើមិនច្បាស់",
  "Switch your camera if the display is not clear": "ប្ដូរកាមេរ៉ារបស់អ្នក ប្រសិនបើការបង្ហាញមិនច្បាស់",
  "Please allow this webapp to access your camera": "សូមអនុញ្ញាតឲ្យ webapp នេះចូលប្រើកាមេរ៉ារបស់អ្នក",
  "DISCOUNT": "បញ្ចុះតម្លៃ",
  "Congratulation": "អបអរសាទរ",
  "Expired Date": "កាលបរិច្ឆេទផុតកំណត់",
  "Voucher": "ប័ណ្ណបញ្ចុះតម្លៃ",
  "Vouchers": "ប័ណ្ណបញ្ចុះតម្លៃ",
  "Something went wrong": "មានអ្វីមួយខុសប្រក្រតី",
  "Stamping Collection": "ការប្រមូលស្តាំ",
  "Total e-Token": "សរុប e-Token",
  "Total Wash": "សរុបការបោក",
  "Total Dry": "សរុបការសម្ងួត",
  "Reload": "បញ្ចូលទឹកប្រាក់ឡើងវិញ",
  "Washer": "ម៉ាស៊ីនបោកគក់",
  "Dryer": "ម៉ាស៊ីនសម្ងួត",
  "Congratulations!": "អបអរសាទរ!",
  "You have completed your Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "អ្នកបានបញ្ចប់ការប្រមូលស្តាំរបស់អ្នក។<br />បានផ្តល់ប័ណ្ណបញ្ចុះតម្លៃ ហើយការប្រមូលស្តាំត្រូវបានកំណត់ឡើងវិញ",
  "You have completed Washer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "អ្នកបានបញ្ចប់ការប្រមូលស្តាំម៉ាស៊ីនបោកគក់។<br />បានផ្តល់ប័ណ្ណបញ្ចុះតម្លៃ ហើយការប្រមូលស្តាំត្រូវបានកំណត់ឡើងវិញ",
  "You have completed Dryer Stamp collection.<br />Granted a voucher and stamp collection is refreshed": "អ្នកបានបញ្ចប់ការប្រមូលស្តាំម៉ាស៊ីនសម្ងួត។<br />បានផ្តល់ប័ណ្ណបញ្ចុះតម្លៃ ហើយការប្រមូលស្តាំត្រូវបានកំណត់ឡើងវិញ",
  "Latest News": "ព័ត៌មានថ្មីៗ",
  "Transaction History": "ប្រវត្តិប្រតិបត្តិការ",
  "Stamping": "ស្តាំ",
  "Transaction": "ប្រតិបត្តិការ",
  "News": "ព័ត៌មាន",
  "Confirmation": "ការបញ្ជាក់",
  "Logout Session?": "ចាកចេញពីសម័យប្រើប្រាស់?",
  "NO": "ទេ",
  "OK": "យល់ព្រម",
  "Account": "គណនី",
  "FAQs": "សំណួរញឹកញាប់",
  "Feedback": "មតិយោបល់",
  "LOGOUT": "ចាកចេញ",
  "Logout": "ចាកចេញ",
  "Are you sure you want to submit your feedback?": "តើអ្នកប្រាកដថាចង់ផ្ញើមតិយោបល់របស់អ្នកមែនទេ?",
  "No": "ទេ",
  "Yes": "បាទ/ចាស",
  "Success": "ជោគជ័យ",
  "Failed": "បរាជ័យ",
  "Pending": "កំពុងរង់ចាំ",
  "Your feedback is submitted successfully": "មតិយោបល់របស់អ្នកត្រូវបានផ្ញើយ៉ាងជោគជ័យ",
  "Please fill in all the required fields before submit.": "សូមបំពេញវាលចាំបាច់ទាំងអស់មុនពេលផ្ញើ",
  "Give us your feedback!": "សូមផ្តល់មតិយោបល់របស់អ្នក!",
  "Type your name here (optional)": "វាយបញ្ចូលឈ្មោះរបស់អ្នកនៅទីនេះ (ស្រេចចិត្ត)",
  "required": "ចាំបាច់",
  "Type your number here": "វាយបញ្ចូលលេខរបស់អ្នកនៅទីនេះ",
  "Outlet": "សាខា",
  "Select an outlet": "ជ្រើសរើសសាខា",
  "Outlet Cleanliness": "ភាពស្អាតស្អំសាខា",
  "Washer Machine Performance": "ប្រសិទ្ធភាពម៉ាស៊ីនបោកគក់",
  "Dryer Machine Performance": "ប្រសិទ្ធភាពម៉ាស៊ីនសម្ងួត",
  "Customer Service": "សេវាកម្មអតិថិជន",
  "Comment": "មតិយោបល់",
  "Type your comment here (optional)": "វាយបញ្ចូលមតិយោបល់របស់អ្នកនៅទីនេះ (ស្រេចចិត្ត)",
  "SUBMIT": "ផ្ញើ",
  "Join as a member now!": "ចូលរួមជាសមាជិកឥឡូវនេះ!",
  "Join as a loyalty member now to get more benefits such as vouchers and free machine usage!<br /><br /><strong>Register as loyalty member?</strong>": "ចូលរួមជាសមាជិកភាពស្មោះត្រង់ឥឡូវនេះ ដើម្បីទទួលបានអត្ថប្រយោជន៍បន្ថែម ដូចជា ប័ណ្ណបញ្ចុះតម្លៃ និងការប្រើម៉ាស៊ីនឥតគិតថ្លៃ!<br /><br /><strong>ចុះឈ្មោះជាសមាជិកភាពស្មោះត្រង់?</strong>",
  "Maybe Next Time": "ប្រហែលពេលក្រោយ",
  "Yes, Register Now": "បាទ/ចាស ចុះឈ្មោះឥឡូវនេះ",
  "Washer Payment": "ការទូទាត់ម៉ាស៊ីនបោកគក់",
  "Dryer Payment": "ការទូទាត់ម៉ាស៊ីនសម្ងួត",
  "Vending Machine Payment": "ការទូទាត់ម៉ាស៊ីនលក់ស្វ័យប្រវត្តិ",
  "Online": "អនឡាញ",
  "Offline": "ក្រៅបណ្តាញ",
  "Running": "កំពុងដំណើរការ",
  "Vacant": "ទំនេរ",
  "Vending Machine": "ម៉ាស៊ីនលក់ស្វ័យប្រវត្តិ",
  "Discount": "បញ្ចុះតម្លៃ",
  "No Vouchers Available": "មិនមានប័ណ្ណបញ្ចុះតម្លៃទេ",
  "Payment Method": "វិធីសាស្ត្រទូទាត់",
  "Would you like to pay with?": "តើអ្នកចង់ទូទាត់ដោយអ្វី?",
  "e-Token": "e-Token",
  "E-TOKEN": "E-TOKEN",
  "E-Wallet": "កាបូបអេឡិចត្រូនិក",
  "E-Wallet & Online Banking": "កាបូបអេឡិចត្រូនិក និងធនាគារអនឡាញ",
  "Duitnow QR code": "កូដ QR DuitNow",
  "PromptPay QR Code": "កូដ QR PromptPay",
  "The Duitnow QR code will be downloaded and you need to open your banking app to make the payment. Pay {{ currency }}{{ totalPaymentAmount }} to {{ machineName }}?": "កូដ QR DuitNow នឹងត្រូវបានទាញយក ហើយអ្នកត្រូវបើកកម្មវិធីធនាគាររបស់អ្នកដើម្បីធ្វើការទូទាត់។ តើបង់ប្រាក់ {{ currency }}{{ totalPaymentAmount }} ទៅកាន់ {{ machineName }} មែនទេ?",
  "Pay": "បង់ប្រាក់",
  "to": "ទៅកាន់",
  "You may under utilized the voucher.": "អ្នកអាចប្រើប្រាស់ប័ណ្ណបញ្ចុះតម្លៃមិនពេញលេញ",
  "Proceed to pay": "បន្តទៅទូទាត់",
  "Processing ...": "កំពុងដំណើរការ...",
  "You can't pay with e-token if voucher is in used, please remove your voucher to pay with e-token.": "អ្នកមិនអាចបង់ប្រាក់ដោយ e-token បានទេ ប្រសិនបើកំពុងប្រើប័ណ្ណបញ្ចុះតម្លៃ សូមដកប័ណ្ណចេញសិនដើម្បីបង់ដោយ e-token",
  "Insufficient e-Tokens": "e-Token មិនគ្រប់គ្រាន់",
  "Reload your e-token now?": "បញ្ចូល e-token ឥឡូវនេះ?",
  "Reload now!": "បញ្ចូលឥឡូវនេះ!",
  "You have": "អ្នកមាន",
  "e-Tokens": "e-Token",
  "Tokens to": "Token ទៅ",
  "This machine is currently offline, please try again later.": "ម៉ាស៊ីននេះកំពុងក្រៅបណ្តាញ សូមព្យាយាមម្តងទៀតពេលក្រោយ",
  "MACHINE": "ម៉ាស៊ីន",
  "Machine": "ម៉ាស៊ីន",
  "TYPE": "ប្រភេទ",
  "CAPACITY": "សមត្ថភាព",
  "DURATION": "រយៈពេល",
  "Select Duration": "ជ្រើសរើសរយៈពេល",
  "AMOUNT TO PAY": "ចំនួនត្រូវបង់",
  "PRICE": "តម្លៃ",
  "VOUCHER": "ប័ណ្ណបញ្ចុះតម្លៃ",
  "Select Voucher >": "ជ្រើសរើសប័ណ្ណ >",
  "TOTAL": "សរុប",
  "PAY": "បង់ប្រាក់",
  "Remove Voucher": "ដកប័ណ្ណបញ្ចុះតម្លៃចេញ",
  "Select Your Voucher": "ជ្រើសរើសប័ណ្ណរបស់អ្នក",
  "min": "នាទី",
  "MIN": "នាទី",
  "Select Payment Amount": "ជ្រើសរើសចំនួនទូទាត់",
  "Select Water Temperature": "ជ្រើសរើសសីតុណ្ហភាពទឹក",
  "Select temperature": "ជ្រើសរើសសីតុណ្ហភាព",
  "Select Temperature": "ជ្រើសរើសសីតុណ្ហភាព",
  "Cold": "ត្រជាក់",
  "Warm": "ក្តៅបន្តិច",
  "Hot": "ក្តៅ",
  "e-Tokens to": "e-Token ទៅ",
  "No Purchase History": "មិនមានប្រវត្តិការទិញ",
  "e-tokens": "e-token",
  "No Promotions": "មិនមានប្រូម៉ូសិន",
  "New Password": "ពាក្យសម្ងាត់ថ្មី",
  "Back": "ត្រឡប់ក្រោយ",
  "Buy this package?": "ទិញកញ្ចប់នេះមែនទេ?",
  "Purchase": "ទិញ",
  "e-Tokens for": "e-Token សម្រាប់",
  "Reload Tokens": "បញ្ចូល Token",
  "Are you sure you want to purchase {{ tokenAmount }} e-Token for {{ currency }}{{ paymentAmount }}?": "តើអ្នកប្រាកដថាចង់ទិញ {{ tokenAmount }} e-Token ក្នុងតម្លៃ {{ currency }}{{ paymentAmount }} មែនទេ?",
  "Current e-Token": "e-Token បច្ចុប្បន្ន",
  "Current point": "ពិន្ទុបច្ចុប្បន្ន",
  "History": "ប្រវត្តិ",
  "Your profile picture has been updated!": "រូបភាពប្រវត្តិរបស់អ្នកត្រូវបានអាប់ដេតហើយ!",
  "Please only use png, jpg or jpeg file extension type": "សូមប្រើតែឯកសារប្រភេទ png, jpg ឬ jpeg ប៉ុណ្ណោះ",
  "Please only use image type file": "សូមប្រើតែឯកសារប្រភេទរូបភាពប៉ុណ្ណោះ",
  "User name has updated successfully!": "ឈ្មោះអ្នកប្រើត្រូវបានអាប់ដេតដោយជោគជ័យ!",
  "Email Address updated successfully": "អាសយដ្ឋានអ៊ីមែលត្រូវបានអាប់ដេតដោយជោគជ័យ",
  "Phone number updated successfully": "លេខទូរស័ព្ទត្រូវបានអាប់ដេតដោយជោគជ័យ",
  "Password must be at least 6 characters": "ពាក្យសម្ងាត់ត្រូវមានយ៉ាងហោចណាស់ 6 តួអក្សរ",
  "Password updated successfully": "ពាក្យសម្ងាត់ត្រូវបានអាប់ដេតដោយជោគជ័យ",
  "User Settings": "ការកំណត់អ្នកប្រើ",
  "Profile Picture": "រូបភាពប្រវត្តិ",
  "Change Password": "ប្តូរពាក្យសម្ងាត់",
  "Do you want to submit your feedback?": "តើអ្នកចង់ផ្ញើមតិយោបល់របស់អ្នកមែនទេ?",
  "Thank You!": "អរគុណ!",
  "Thank you for using our services.": "អរគុណសម្រាប់ការប្រើប្រាស់សេវាកម្មរបស់យើង",
  "BACK TO HOMEPAGE": "ត្រឡប់ទៅទំព័រដើម",
  "How to pay?": "តើបង់ប្រាក់យ៉ាងដូចម្តេច?",
  "Step 1": "ជំហានទី 1",
  "After scan the QR code on the machine, select either register new account, login your account or skip to payment.": "បន្ទាប់ពីស្កេន QR code នៅលើម៉ាស៊ីន សូមជ្រើសរើស ចុះឈ្មោះគណនីថ្មី ចូលគណនី ឬរំលងទៅការទូទាត់",
  "Step 2-1": "ជំហានទី 2-1",
  "For Dryer – Select your desired duration. Different duration will have different prices.": "សម្រាប់ម៉ាស៊ីនសម្ងួត – ជ្រើសរើសរយៈពេលដែលអ្នកចង់បាន។ រយៈពេលខុសគ្នា មានតម្លៃខុសគ្នា",
  "Step 2-2": "ជំហានទី 2-2",
  "For Washer – Select your desired water temperature. Different water temperature will have different prices.": "សម្រាប់ម៉ាស៊ីនបោកគក់ – ជ្រើសរើសសីតុណ្ហភាពទឹកដែលអ្នកចង់បាន។ សីតុណ្ហភាពខុសគ្នា មានតម្លៃខុសគ្នា",
  "Step 3": "ជំហានទី 3",
  "For login user, Click on ‘Select Voucher’ to select your voucher.": "សម្រាប់អ្នកបានចូលគណនី ចុចលើ “ជ្រើសរើសប័ណ្ណ” ដើម្បីជ្រើសរើសប័ណ្ណរបស់អ្នក",
  "Step 4": "ជំហានទី 4",
  "Click on ‘PAY’ button to pay. For login user, select your payment method to pay.": "ចុចប៊ូតុង “បង់ប្រាក់” ដើម្បីទូទាត់។ សម្រាប់អ្នកបានចូលគណនី សូមជ្រើសរើសវិធីសាស្ត្រទូទាត់",
  "Step 5": "ជំហានទី 5",
  "After confirm the price and machine details, click on ‘OK’ button to pay.": "បន្ទាប់ពីបញ្ជាក់តម្លៃ និងព័ត៌មានម៉ាស៊ីន សូមចុច “យល់ព្រម” ដើម្បីទូទាត់",
  "How to reload your e-Token?": "តើបញ្ចូល e-Token យ៉ាងដូចម្តេច?",
  "Click on the \"Reload\" button.": "ចុចលើប៊ូតុង \"បញ្ចូល\"",
  "Select the package that you wish to purchase.": "ជ្រើសរើសកញ្ចប់ដែលអ្នកចង់ទិញ",
  "Click on \"Purchase\" as confirmation before payment page.": "ចុច \"ទិញ\" ដើម្បីបញ្ជាក់ មុនទៅទំព័រទូទាត់",
  "Is e-token can be refund/transfer back to e-wallet?": "តើ e-Token អាចសងវិញ ឬផ្ទេរត្រឡប់ទៅកាបូបអេឡិចត្រូនិកបានទេ?",
  "Why can't I applied my voucher?": "ហេតុអ្វីខ្ញុំមិនអាចប្រើប័ណ្ណបាន?",
  "When there is a Happy Hour Promotion is on going, you are unable to apply your voucher temporarily.": "នៅពេលមានប្រូម៉ូសិន Happy Hour អ្នកមិនអាចប្រើប័ណ្ណបានជាបណ្តោះអាសន្ន",
  "How to apply my voucher?": "តើប្រើប័ណ្ណយ៉ាងដូចម្តេច?",
  "Click on the \"Select Voucher\" button.": "ចុចលើប៊ូតុង \"ជ្រើសរើសប័ណ្ណ\"",
  "Select the voucher that you wish to apply.": "ជ្រើសរើសប័ណ្ណដែលអ្នកចង់ប្រើ",
  "Click on \"Pay\" once you have verified the voucher is successfully applied.": "ចុច \"បង់ប្រាក់\" បន្ទាប់ពីបញ្ជាក់ថាប័ណ្ណបានអនុវត្តដោយជោគជ័យ",
  "Step 2": "ជំហានទី 2",
  "Language has updated successfully!": "ភាសាត្រូវបានអាប់ដេតដោយជោគជ័យ!",
  "Change Language": "ប្តូរភាសា",
  "Language": "ភាសា",
  "Select language": "ជ្រើសរើសភាសា",
  "Referral Code": "កូដណែនាំ",
  "Copied!": "បានចម្លង!",
  "Inviting friends to get more benefits!": "អញ្ជើញមិត្តភក្តិដើម្បីទទួលបានអត្ថប្រយោជន៍បន្ថែម!",
  "Would you like to share your referral code to your friends & family?": "តើអ្នកចង់ចែករំលែកកូដណែនាំទៅមិត្តភក្តិ និងគ្រួសាររបស់អ្នកមែនទេ?",
  "Refer a friend and get": "ណែនាំមិត្តភក្តិ ហើយទទួលបាន",
  "Share the love to your friends & family?": "ចែករំលែកទៅមិត្តភក្តិ និងគ្រួសាររបស់អ្នកមែនទេ?",
  "voucher": "ប័ណ្ណបញ្ចុះតម្លៃ",
  "token": "token",
  "stamp": "ស្តាំ",
  "washer stamp": "ស្តាំម៉ាស៊ីនបោកគក់",
  "dryer stamp": "ស្តាំម៉ាស៊ីនសម្ងួត",
  "Learn More": "ស្វែងយល់បន្ថែម",
  "Welcome Gift": "អំណោយស្វាគមន៍",
  "Share Your Referral Code Now": "ចែករំលែកកូដណែនាំឥឡូវនេះ",
  "Birthday Gift for You": "អំណោយថ្ងៃកំណើតសម្រាប់អ្នក",
  "Let's Pay with E-Token": "បង់ប្រាក់ដោយ e-Token",
  "Collect 10 Stamps and Get Voucher": "ប្រមូល 10 ស្តាំ និងទទួលបានប័ណ្ណ",
  "The voucher will be given if you registered your account successfully.": "ប័ណ្ណនឹងត្រូវផ្តល់ជូន ប្រសិនបើអ្នកចុះឈ្មោះគណនីបានជោគជ័យ",
  "There is no expiration date for this voucher.": "ប័ណ្ណនេះមិនមានកាលបរិច្ឆេទផុតកំណត់ទេ",
  "When you applied the voucher during payment, it will give you": "នៅពេលអ្នកប្រើប័ណ្ណក្នុងការទូទាត់ វានឹងផ្តល់ឲ្យអ្នក",
  "discount.": "ការបញ្ចុះតម្លៃ។",
  "When promotion is on going, the voucher is not applicable.": "នៅពេលមានប្រូម៉ូសិន កំពុងដំណើរការ ប័ណ្ណមិនអាចប្រើបានទេ",
  "The voucher cannot be used if your payment method is E-Token.": "ប័ណ្ណមិនអាចប្រើបានទេ ប្រសិនបើអ្នកជ្រើសរើសបង់ដោយ E-Token",
  "Your referral code can be found in user settings page.": "អ្នកអាចរកឃើញកូដណែនាំរបស់អ្នកនៅក្នុងទំព័រការកំណត់អ្នកប្រើ",
  "You can get": "អ្នកអាចទទួលបាន",
  "stamp for the reward.": "ស្តាំជារង្វាន់",
  "e-token for the reward.": "e-Token ជារង្វាន់",
  "e-token based on transaction payment amount for the reward.": "e-Token ផ្អែកលើចំនួនទឹកប្រាក់ទូទាត់ជារង្វាន់",
  "for the reward.": "ជារង្វាន់",
  "based on transaction payment amount for the reward.": "ផ្អែកលើចំនួនទឹកប្រាក់ទូទាត់ជារង្វាន់",
  "You can get a voucher for the reward": "អ្នកអាចទទួលបានប័ណ្ណជារង្វាន់",
  "which have": "ដែលមាន",
  "it can be used for dryer machine only.": "អាចប្រើបានសម្រាប់ម៉ាស៊ីនសម្ងួតតែប៉ុណ្ណោះ",
  "it can be used for washer machine only.": "អាចប្រើបានសម្រាប់ម៉ាស៊ីនបោកគក់តែប៉ុណ្ណោះ",
  "it can be used for Drop n Go transaction only.": "អាចប្រើបានសម្រាប់ប្រតិបត្តិការ Drop n Go តែប៉ុណ្ណោះ",
  "it can be used for vending machine only.": "អាចប្រើបានសម្រាប់ម៉ាស៊ីនលក់ស្វ័យប្រវត្តិ តែប៉ុណ្ណោះ",
  "it can be used for car wash transaction only.": "អាចប្រើបានសម្រាប់សេវាលាងឡាន តែប៉ុណ្ណោះ",
  "it can be used for detergent vending machine only.": "អាចប្រើបានសម្រាប់ម៉ាស៊ីនលក់សាប៊ូបោក តែប៉ុណ្ណោះ",
  "it can be used for dryer or washer machine.": "អាចប្រើបានសម្រាប់ម៉ាស៊ីនសម្ងួត ឬម៉ាស៊ីនបោកគក់",
  "it can be used for dryer machine or Drop n Go transaction.": "អាចប្រើបានសម្រាប់ម៉ាស៊ីនសម្ងួត ឬប្រតិបត្តិការ Drop n Go",
  "it can be used for washer machine or Drop n Go transaction.": "អាចប្រើបានសម្រាប់ម៉ាស៊ីនបោកគក់ ឬប្រតិបត្តិការ Drop n Go",
  "it can be used for washer machine, dryer machine or Drop n Go transaction.": "អាចប្រើបានសម្រាប់ម៉ាស៊ីនបោកគក់ ម៉ាស៊ីនសម្ងួត ឬប្រតិបត្តិការ Drop n Go",
  "it can be used for washer machine, dryer machine or vending machine transaction.": "អាចប្រើបានសម្រាប់ម៉ាស៊ីនបោកគក់ ម៉ាស៊ីនសម្ងួត ឬម៉ាស៊ីនលក់ស្វ័យប្រវត្តិ",
  "it can be used for washer machine, dryer machine, vending machine or Drop n Go transaction.": "អាចប្រើបានសម្រាប់ម៉ាស៊ីនបោកគក់ ម៉ាស៊ីនសម្ងួត ម៉ាស៊ីនលក់ស្វ័យប្រវត្តិ ឬប្រតិបត្តិការ Drop n Go",
  "washer stamp for the reward.": "ស្តាំម៉ាស៊ីនបោកគក់ជារង្វាន់",
  "dryer stamp for the reward.": "ស្តាំម៉ាស៊ីនសម្ងួតជារង្វាន់",
  "washer stamp and": "ស្តាំម៉ាស៊ីនបោកគក់ និង",
  "cleanproBirthdayShortDesc_one": "ប្តូរយកប័ណ្ណថ្ងៃកំណើត {{ birthdayVoucherAmount }} ក្រេឌីត នៅថ្ងៃពិសេសរបស់អ្នកជាមួយ Cleanpro Plus។ ចុចដើម្បីស្វែងយល់បន្ថែម",
  "cleanproBirthdayShortDesc_other": "ប្តូរយកប័ណ្ណថ្ងៃកំណើត {{ birthdayVoucherAmount }} ក្រេឌីត នៅថ្ងៃពិសេសរបស់អ្នកជាមួយ Cleanpro Plus។ ចុចដើម្បីស្វែងយល់បន្ថែម",
  "When you click on \"PAY\" button on the payment page, you can choose either using E-wallet or E-token to pay.": "នៅពេលអ្នកចុចប៊ូតុង \"បង់ប្រាក់\" នៅទំព័រទូទាត់ អ្នកអាចជ្រើសរើសបង់ដោយ E-Wallet ឬ E-Token",
  "When you using your voucher during payment, you will be unable to pay with E-token.": "នៅពេលអ្នកប្រើប័ណ្ណក្នុងការទូទាត់ អ្នកមិនអាចបង់ដោយ E-Token បានទេ",
  "You can reload your E-token by clicking the reload button in the stamping page and select the package to purchase.": "អ្នកអាចបញ្ចូល E-Token ដោយចុចប៊ូតុងបញ្ចូល នៅទំព័រស្តាំ ហើយជ្រើសរើសកញ្ចប់ដែលចង់ទិញ",
  "You can reload your E-token by clicking the reload button in the home page and select the package to purchase.": "អ្នកអាចបញ្ចូល E-Token ដោយចុចប៊ូតុងបញ្ចូល នៅទំព័រដើម ហើយជ្រើសរើសកញ្ចប់ដែលចង់ទិញ",
  "You can view your E-token reload history and E-token transaction history in transaction page.": "អ្នកអាចមើលប្រវត្តិបញ្ចូល និងប្រវត្តិប្រតិបត្តិការ E-Token នៅទំព័រប្រតិបត្តិការ",
  "You can view your E-token transaction history in transaction page.": "អ្នកអាចមើលប្រវត្តិប្រតិបត្តិការ E-Token នៅទំព័រប្រតិបត្តិការ",
  "Using either dryer machine or washer machine with the minimum spending of": "ប្រើម៉ាស៊ីនសម្ងួត ឬម៉ាស៊ីនបោកគក់ ជាមួយការចំណាយអប្បបរមា",
  "to collect one stamp.": "ដើម្បីប្រមូលស្តាំ ១",
  "The voucher will be given if you have collected 10 stamps.": "ប័ណ្ណនឹងត្រូវផ្តល់ជូន ប្រសិនបើអ្នកបានប្រមូល 10 ស្តាំ",
  "Using dryer machine with the minimum spending of": "ប្រើម៉ាស៊ីនសម្ងួត ជាមួយការចំណាយអប្បបរមា",
  "Using washer machine with the minimum spending of": "ប្រើម៉ាស៊ីនបោកគក់ ជាមួយការចំណាយអប្បបរមា",
  "to collect one dryer stamp.": "ដើម្បីប្រមូលស្តាំម៉ាស៊ីនសម្ងួត ១",
  "to collect one washer stamp.": "ដើម្បីប្រមូលស្តាំម៉ាស៊ីនបោកគក់ ១",
  "The voucher will be given if you have collected 10 dryer stamps or 10 washer stamps.": "ប័ណ្ណនឹងត្រូវផ្តល់ជូន ប្រសិនបើអ្នកបានប្រមូល 10 ស្តាំម៉ាស៊ីនសម្ងួត ឬ 10 ស្តាំម៉ាស៊ីនបោកគក់",
  "For the voucher given by the dryer stamps,": "សម្រាប់ប័ណ្ណដែលទទួលបានពីស្តាំម៉ាស៊ីនសម្ងួត",
  "For the voucher given by the washer stamps,": "សម្រាប់ប័ណ្ណដែលទទួលបានពីស្តាំម៉ាស៊ីនបោកគក់",
  "When promotion is on going, all the vouchers is not applicable.": "នៅពេលមានប្រូម៉ូសិន កំពុងដំណើរការ ប័ណ្ណទាំងអស់មិនអាចប្រើបានទេ",
  "All the vouchers cannot be used if your payment method is E-Token.": "ប័ណ្ណទាំងអស់មិនអាចប្រើបានទេ ប្រសិនបើបង់ដោយ E-Token",
  "Description": "ពិពណ៌នា",
  "Refer Friends": "ណែនាំមិត្តភក្តិ",
  "View our guideline": "មើលសេចក្តីណែនាំរបស់យើង",
  "When a friend / family register using your referral code, and completed a transaction with a minimum spending of": "នៅពេលមិត្តភក្តិ ឬគ្រួសាររបស់អ្នក ចុះឈ្មោះដោយប្រើកូដណែនាំ ហើយបញ្ចប់ប្រតិបត្តិការ ជាមួយការចំណាយអប្បបរមា",
  ", you will be rewarded automatically.": " អ្នកនឹងទទួលបានរង្វាន់ដោយស្វ័យប្រវត្តិ",
  "One user only allow to have": "អ្នកប្រើម្នាក់ អាចមានបានតែ",
  "referrals.": "ការណែនាំ",
  "Confirmation Password": "បញ្ជាក់ពាក្យសម្ងាត់",
  "Password and confirmation password should be same.": "ពាក្យសម្ងាត់ និងការបញ្ជាក់ពាក្យសម្ងាត់ ត្រូវតែដូចគ្នា",
  "You haven't applied your voucher": "អ្នកមិនទាន់ប្រើប័ណ្ណរបស់អ្នកទេ",
  "Would you like to continue your payment without using your voucher?": "តើអ្នកចង់បន្តការទូទាត់ ដោយមិនប្រើប័ណ្ណមែនទេ?",
  "Continue": "បន្ត",
  "Apply voucher": "ប្រើប័ណ្ណ",
  "Transfer": "ផ្ទេរ",
  "Transfer Tokens": "ផ្ទេរ Token",
  "Please fill in the phone number": "សូមបំពេញលេខទូរស័ព្ទ",
  "Please fill in the email": "សូមបំពេញអ៊ីមែល",
  "Please enter the phone number / email that you want to transfer to": "សូមបញ្ចូលលេខទូរស័ព្ទ ឬ អ៊ីមែល ដែលអ្នកចង់ផ្ទេរទៅ",
  "Please fill in the transfer amount": "សូមបំពេញចំនួនទឹកប្រាក់ផ្ទេរ",
  "Transfer amount should be more than 0 and less than your current e-Token": "ចំនួនផ្ទេរត្រូវតែធំជាង 0 និងតិចជាង e-Token បច្ចុប្បន្នរបស់អ្នក",
  "Please enter your password": "សូមបញ្ចូលពាក្យសម្ងាត់របស់អ្នក",
  "Member ID": "លេខសម្គាល់សមាជិក",
  "E-Token Transfer Amount": "ចំនួន e-Token ផ្ទេរ",
  "Please confirm the details before proceeding": "សូមបញ្ជាក់ព័ត៌មានមុនបន្ត",
  "Transfer From": "ផ្ទេរពី",
  "Transfer To": "ផ្ទេរទៅ",
  "Transfer Amount": "ចំនួនផ្ទេរ",
  "Transfer Successfully!": "ផ្ទេរជោគជ័យ!",
  "Transfer Time": "ពេលវេលាផ្ទេរ",
  "Token": "Token",
  "Done": "រួចរាល់",
  "Next": "បន្ទាប់",
  "Enter Password": "បញ្ចូលពាក្យសម្ងាត់",
  "Transfer E-Token Amount": "ផ្ទេរចំនួន e-Token",
  "User not found": "រកមិនឃើញអ្នកប្រើ",
  "Password is incorrect": "ពាក្យសម្ងាត់មិនត្រឹមត្រូវ",
  "Please go to your account setting and reset your password": "សូមទៅកាន់ការកំណត់គណនី ហើយកំណត់ពាក្យសម្ងាត់ឡើងវិញ",
  "Only up to last 3 months transaction history": "បង្ហាញត្រឹមប្រវត្តិប្រតិបត្តិការ 3 ខែចុងក្រោយ",
  "Reload History": "ប្រវត្តិបញ្ចូល",
  "Transfer History": "ប្រវត្តិផ្ទេរ",
  "{{ point }} History": "ប្រវត្តិ {{ point }}",
  "Only up to last 3 months reload history": "បង្ហាញត្រឹមប្រវត្តិបញ្ចូល 3 ខែចុងក្រោយ",
  "Only up to last 3 months transfer history": "បង្ហាញត្រឹមប្រវត្តិផ្ទេរ 3 ខែចុងក្រោយ",
  "Only up to last 3 months {{ point }} history": "បង្ហាញត្រឹមប្រវត្តិ {{ point }} 3 ខែចុងក្រោយ",
  "Only up to last 3 months laundry pass history": "បង្ហាញត្រឹមប្រវត្តិ laundry pass 3 ខែចុងក្រោយ",
  "If require urgent response, please contact us through whatapp": "ប្រសិនបើត្រូវការឆ្លើយតបបន្ទាន់ សូមទាក់ទងយើងតាម WhatsApp",
  "Please scan the QR code again": "សូមស្កេន QR code ម្តងទៀត",
  "Home": "ទំព័រដើម",
  "Quick": "លឿន",
  "Super": "លឿនខ្លាំង",
  "Premium": "ពិសេស",
  "All users will have infinite referrals.": "អ្នកប្រើទាំងអស់អាចណែនាំមិត្តភក្តិបានគ្មានកំណត់",
  "Collect 10 stamps to get 1 Voucher": "ប្រមូល 10 ត្រា ទទួលបានប័ណ្ណ 1",
  "The voucher is only for customer use only, not for sale.": "ប័ណ្ណនេះសម្រាប់ប្រើប្រាស់តែប៉ុណ្ណោះ មិនមែនសម្រាប់លក់ទេ",
  "Outlet is currently offline, please try again later": "សាខាកំពុងក្រៅបណ្តាញ សូមព្យាយាមម្តងទៀតពេលក្រោយ",
  "The voucher will be given if you completed a transaction with a minimum spending of": "ប័ណ្ណនឹងត្រូវផ្តល់ជូន ប្រសិនបើអ្នកបញ្ចប់ប្រតិបត្តិការ ជាមួយការចំណាយអប្បបរមា",
  "The birthday voucher will be given on the first day of your birthday month.": "ប័ណ្ណថ្ងៃកំណើតនឹងផ្តល់ជូននៅថ្ងៃដំបូងនៃខែកំណើតរបស់អ្នក",
  "The voucher only will be given if you have exceed spending amount of": "ប័ណ្ណនឹងផ្តល់ជូន ប្រសិនបើអ្នកបានចំណាយលើសចំនួន",
  "Pay with KiplePay": "បង់ប្រាក់ដោយ KiplePay",
  "Pay with Scan2Pay": "បង់ប្រាក់ដោយ Scan2Pay",
  "Pay with Razer": "បង់ប្រាក់ដោយ Razer",
  "Pay with HitPay": "បង់ប្រាក់ដោយ HitPay",
  "Pay with Duitnow QR": "បង់ប្រាក់ដោយ DuitNow QR",
  "Pay with PagBank": "បង់ប្រាក់ដោយ PagBank",
  "Pay with PromptPay QR": "បង់ប្រាក់ដោយ PromptPay QR",
  "Pay with Card": "បង់ប្រាក់ដោយកាត",
  "Pay with PayWay": "បង់ប្រាក់ដោយ PayWay",
  "DISCOUNT CODE": "កូដបញ្ចុះតម្លៃ",
  "Enter code >": "បញ្ចូលកូដ >",
  "Enter Discount Code": "បញ្ចូលកូដបញ្ចុះតម្លៃ",
  "Remove Code": "លុបកូដ",
  "Discount Code": "កូដបញ្ចុះតម្លៃ",
  "Close": "បិទ",
  "Please fill in your email address": "សូមបំពេញអាសយដ្ឋានអ៊ីមែល",
  "Notification": "ការជូនដំណឹង",
  "Do you want to receive notification when wash cycle done?": "តើអ្នកចង់ទទួលការជូនដំណឹង នៅពេលបោករួចមែនទេ?",
  "pay extra": "បង់បន្ថែម",
  "Email Address": "អាសយដ្ឋានអ៊ីមែល",
  "Please fill in your phone number": "សូមបំពេញលេខទូរស័ព្ទ",
  "Invalid Phone Number": "លេខទូរស័ព្ទមិនត្រឹមត្រូវ",
  "Washing Complete": "បោករួចរាល់",
  "Drying Complete": "សម្ងួតរួចរាល់",
  "The voucher will be given if you registered your account successfully, but it only can be used when your total transaction spending reach": "ប័ណ្ណនឹងផ្តល់ជូន ប្រសិនបើអ្នកចុះឈ្មោះគណនីបានជោគជ័យ ប៉ុន្តែអាចប្រើបាននៅពេលចំណាយសរុបដល់",
  "and above.": "ឡើងទៅ",
  "This voucher is not applicable": "ប័ណ្ណនេះមិនអាចប្រើបាន",
  "Finish in": "បញ្ចប់ក្នុង",
  "Need to refresh to update": "ត្រូវធ្វើការធ្វើថ្មី (refresh) ដើម្បីអាប់ដេត",
  "It's indicative and may change based on washer load": "វាជាការប៉ាន់ស្មាន និងអាចផ្លាស់ប្តូរតាមបរិមាណសម្លៀកបំពាក់",
  "We'll let you know when it's ready to pick up": "យើងនឹងជូនដំណឹងនៅពេលអាចយកបាន",
  "FREE": "ឥតគិតថ្លៃ",
  "Enter voucher code (if got any)": "បញ្ចូលកូដប័ណ្ណ (ប្រសិនបើមាន)",
  "Please fill in the voucher code": "សូមបំពេញកូដប័ណ្ណ",
  "Available On": "អាចប្រើបានលើ",
  "Apply": "អនុវត្ត",
  "Enter a code": "បញ្ចូលកូដ",
  "Input Promo Code": "បញ្ចូលកូដប្រូម៉ូសិន",
  "Voucher is redeemed successfully!": "ប្ដូរប័ណ្ណបានជោគជ័យ!",
  "Not available": "មិនមាន",
  "Unable to register": "មិនអាចចុះឈ្មោះបាន",
  "Drop n Go Service": "សេវា Drop n Go",
  "Select Mode": "ជ្រើសរើសរបៀប",
  "Quantity": "ចំនួន",
  "Pack": "កញ្ចប់",
  "Add more": "បន្ថែម",
  "Select Size": "ជ្រើសរើសទំហំ",
  "Select Services": "ជ្រើសរើសសេវាកម្ម",
  "Are you sure to delete the item?": "តើអ្នកប្រាកដថាចង់លុបមុខទំនិញនេះមែនទេ?",
  "Delete": "លុប",
  "Your Duitnow QR code": "កូដ QR DuitNow របស់អ្នក",
  "Your PromptPay QR code": "កូដ QR PromptPay របស់អ្នក",
  "How to pay using Duitnow QR code?": "តើបង់ប្រាក់ដោយកូដ QR DuitNow យ៉ាងដូចម្តេច?",
  "How to pay using PromptPay QR code?": "តើបង់ប្រាក់ដោយកូដ QR PromptPay យ៉ាងដូចម្តេច?",
  "Launch": "បើក",
  "Launch your preferred Mobile Banking or eWallet app.": "បើកកម្មវិធីធនាគារចល័ត ឬ eWallet ដែលអ្នកចូលចិត្ត",
  "Scan QR code from Gallery": "ស្កេន QR code ពី Gallery",
  "Choose DuitNow QR from your gallery.": "ជ្រើសរើស DuitNow QR ពី Gallery របស់អ្នក",
  "Confirm payment details and pay.": "បញ្ជាក់ព័ត៌មានទូទាត់ ហើយបង់ប្រាក់",
  "Receive payment confirmation.": "ទទួលបានការបញ្ជាក់ទូទាត់",
  "expiring on": "ផុតកំណត់នៅ",
  "Expired on": "បានផុតកំណត់នៅ",
  "based on transaction payment amount": "ផ្អែកលើចំនួនទឹកប្រាក់ទូទាត់",
  "Join as our": "ចូលរួមជាមួយយើងជា",
  "Loyalty Member": "សមាជិកភាពស្មោះត្រង់",
  "now to get more reward": "ឥឡូវនេះ ដើម្បីទទួលបានរង្វាន់បន្ថែម",
  "Payment amount should be greater than 0": "ចំនួនទូទាត់ត្រូវតែធំជាង 0",
  // admin portal
  "Dashboard": "ផ្ទាំងគ្រប់គ្រង",
  "Report": "របាយការណ៍",
  "Store Performance": "ប្រសិទ្ធភាពសាខា",
  "User Performance": "ប្រសិទ្ធភាពអ្នកប្រើ",
  "Voucher Redemption": "ការប្រើប័ណ្ណ",
  "Token Report": "របាយការណ៍ Token",
  "SMS Report": "របាយការណ៍ SMS",
  "Discount Code Report": "របាយការណ៍កូដបញ្ចុះតម្លៃ",
  "User Details": "ព័ត៌មានអ្នកប្រើ",
  "User Compensation": "ការផ្តល់សំណងអ្នកប្រើ",
  "Voucher Settings": "ការកំណត់ប័ណ្ណ",
  "Token Settings": "ការកំណត់ Token",
  "Referral Settings": "ការកំណត់ការណែនាំ",
  "Voucher Code": "កូដប័ណ្ណ",
  "Customize Color": "ប្ដូរពណ៌",
  "User Migration": "ការផ្លាស់ប្តូរអ្នកប្រើ",
  "Back To": "ត្រឡប់ទៅ",
  "Eligibility": "លក្ខខណ្ឌសមរម្យ",
  "If ticked, the voucher will have expired date": "បើធីក ប័ណ្ណនឹងមានកាលបរិច្ឆេទផុតកំណត់",
  "Expiry": "ផុតកំណត់",
  "If ticked, the voucher can apply to washer machine transaction": "បើធីក អាចប្រើប័ណ្ណសម្រាប់ម៉ាស៊ីនបោកគក់",
  "Washer Use": "ប្រើសម្រាប់ម៉ាស៊ីនបោកគក់",
  "If ticked, the voucher can apply to dryer machine transaction": "បើធីក អាចប្រើប័ណ្ណសម្រាប់ម៉ាស៊ីនសម្ងួត",
  "Dryer Use": "ប្រើសម្រាប់ម៉ាស៊ីនសម្ងួត",
  "If ticked, the voucher can apply to Drop n Go transaction": "បើធីក អាចប្រើប័ណ្ណសម្រាប់ Drop n Go",
  "Package Use": "ប្រើសម្រាប់ Package",
  "If ticked, the voucher can apply to vending machine transaction": "បើធីក អាចប្រើប័ណ្ណសម្រាប់ម៉ាស៊ីនលក់ស្វ័យប្រវត្តិ",
  "Vending Use": "ប្រើសម្រាប់ម៉ាស៊ីនលក់ស្វ័យប្រវត្តិ",
  "If ticked, the voucher can apply to detergent vending machine transaction": "បើធីក អាចប្រើប័ណ្ណសម្រាប់ម៉ាស៊ីនលក់សាប៊ូបោក",
  "Detergent Use": "ប្រើសម្រាប់សាប៊ូបោក",
  "If ticked, the voucher can apply to car wash transaction": "បើធីក អាចប្រើប័ណ្ណសម្រាប់សេវាលាងឡាន",
  "Car Wash Use": "ប្រើសម្រាប់លាងឡាន",
  "Voucher Lifespan": "អាយុកាលប័ណ្ណ",
  "days": "ថ្ងៃ",
  "Discount Type": "ប្រភេទបញ្ចុះតម្លៃ",
  "Select a discount type": "ជ្រើសរើសប្រភេទបញ្ចុះតម្លៃ",
  "Flat": "ថេរ",
  "Rate": "ភាគរយ",
  "Voucher Title": "ចំណងជើងប័ណ្ណ",
  "Voucher Description": "ពិពណ៌នាប័ណ្ណ",
  "Voucher Amount": "ចំនួនប័ណ្ណ",
  "CONFIRM": "បញ្ជាក់",
  "If ticked, the system will give voucher to user who completed washer stamp collection": "បើធីក ប្រព័ន្ធនឹងផ្តល់ប័ណ្ណឲ្យអ្នកប្រើដែលប្រមូលស្តាំម៉ាស៊ីនបោកគក់បានគ្រប់",
  "If ticked, the system will give voucher to user who completed dryer stamp collection": "បើធីក ប្រព័ន្ធនឹងផ្តល់ប័ណ្ណឲ្យអ្នកប្រើដែលប្រមូលស្តាំម៉ាស៊ីនសម្ងួតបានគ្រប់",
  "If ticked, the user only can get/use the voucher after make a transaction": "បើធីក អ្នកប្រើអាចទទួល/ប្រើប័ណ្ណបាន បន្ទាប់ពីធ្វើប្រតិបត្តិការ",
  "Pay And Get Voucher": "បង់ប្រាក់ និងទទួលប័ណ្ណ",
  "Pay And Use Code": "បង់ប្រាក់ និងប្រើកូដ",
  "If ticked, the system will only give the voucher to user after the user make a transaction": "បើធីក ប្រព័ន្ធនឹងផ្តល់ប័ណ្ណឲ្យអ្នកប្រើ បន្ទាប់ពីធ្វើប្រតិបត្តិការ",
  "If ticked, the system will give voucher to user who completed registration process": "បើធីក ប្រព័ន្ធនឹងផ្តល់ប័ណ្ណឲ្យអ្នកប្រើបន្ទាប់ពីចុះឈ្មោះជោគជ័យ",
  "If ticked, the system will give voucher to user on their birthday month": "បើធីក ប្រព័ន្ធនឹងផ្តល់ប័ណ្ណឲ្យអ្នកប្រើក្នុងខែកំណើត",
  "If ticked, the system will give voucher to user who completed stamp collection": "បើធីក ប្រព័ន្ធនឹងផ្តល់ប័ណ្ណឲ្យអ្នកប្រើដែលប្រមូលស្តាំបានគ្រប់",
  "Minimum Payment Amount To Get/Use Register Voucher": "ចំនួនបង់អប្បបរមា ដើម្បីទទួល/ប្រើប័ណ្ណចុះឈ្មោះ",
  "Voucher Method": "វិធីសាស្ត្រប័ណ្ណ",
  "Select a voucher method": "ជ្រើសរើសវិធីសាស្ត្រប័ណ្ណ",
  "The user directly get the voucher after register but only can use it after make transaction": "អ្នកប្រើនឹងទទួលប័ណ្ណភ្លាមៗបន្ទាប់ពីចុះឈ្មោះ ប៉ុន្តែអាចប្រើបានបន្ទាប់ពីធ្វើប្រតិបត្តិការ",
  "The user only can get voucher after make a transaction": "អ្នកប្រើអាចទទួលប័ណ្ណបាន បន្ទាប់ពីធ្វើប្រតិបត្តិការ",
  "Minimum Payment Amount To Get Birthday Voucher": "ចំនួនបង់អប្បបរមា ដើម្បីទទួលប័ណ្ណថ្ងៃកំណើត",
  "Minimum Payment Amount To Use Discount Code": "ចំនួនបង់អប្បបរមា ដើម្បីប្រើកូដបញ្ចុះតម្លៃ",
  "Outlets": "សាខា",
  "E-Payment Sales": "ការលក់តាមអេឡិចត្រូនិក",
  "Number of stamps granted to users": "ចំនួនស្តាំដែលផ្តល់ឲ្យអ្នកប្រើ",
  "Total number of stamps granted": "ចំនួនស្តាំសរុបដែលបានផ្តល់",
  "Registered Users": "អ្នកប្រើបានចុះឈ្មោះ",
  "Stamps": "ស្តាំ",
  "Referral": "ការណែនាំ",
  "Register": "ចុះឈ្មោះ",
  "Top Outlets": "សាខាល្អបំផុត",
  "Users": "អ្នកប្រើ",
  "Sort by": "តម្រៀបតាម",
  "Top Users": "អ្នកប្រើល្អបំផុត",
  "User name": "ឈ្មោះអ្នកប្រើ",
  "Number": "ចំនួន",
  "Spending": "ការចំណាយ",
  "Number of registered users": "ចំនួនអ្នកប្រើបានចុះឈ្មោះ",
  "Number of voucher given to users": "ចំនួនប័ណ្ណដែលផ្តល់ឲ្យអ្នកប្រើ",
  "Total number of voucher given": "ចំនួនប័ណ្ណសរុបដែលបានផ្តល់",
  "Voucher Type": "ប្រភេទប័ណ្ណ",
  "Voucher Value": "តម្លៃប័ណ្ណ",
  "Date": "កាលបរិច្ឆេទ",
  "Discount Code Type": "ប្រភេទកូដបញ្ចុះតម្លៃ",
  "Discount Code Amount": "ចំនួនកូដបញ្ចុះតម្លៃ",
  "Number of Redemption": "ចំនួនប្រើប្រាស់",
  "Total Discount Amount": "ចំនួនបញ្ចុះតម្លៃសរុប",
  "Select Outlet": "ជ្រើសរើសសាខា",
  "Select Date": "ជ្រើសរើសកាលបរិច្ឆេទ",
  "Select Transaction Date": "ជ្រើសរើសកាលបរិច្ឆេទប្រតិបត្តិការ",
  "Reset": "កំណត់ឡើងវិញ",
  "Download Report": "ទាញយករបាយការណ៍",
  "Please fill in the remark": "សូមបំពេញចំណាំ",
  "Transaction Date": "កាលបរិច្ឆេទប្រតិបត្តិការ",
  "Machine Type": "ប្រភេទម៉ាស៊ីន",
  "Machine Capacity": "សមត្ថភាពម៉ាស៊ីន",
  "Total Amount": "ចំនួនសរុប",
  "Payment Amount": "ចំនួនទូទាត់",
  "Discount From": "បញ្ចុះតម្លៃពី",
  "Discount Amount": "ចំនួនបញ្ចុះតម្លៃ",
  "Action": "សកម្មភាព",
  "Remark": "ចំណាំ",
  "Refund Date": "កាលបរិច្ឆេទសងប្រាក់វិញ",
  "Refund": "សងប្រាក់វិញ",
  "Purchase Date": "កាលបរិច្ឆេទទិញ",
  "e-Token Purchased (Tokens)": "e-Token ដែលបានទិញ (Token)",
  "Bought e-Token using": "បានទិញ e-Token ដោយប្រើ",
  "Transaction ID": "លេខសម្គាល់ប្រតិបត្តិការ",
  "Method": "វិធីសាស្ត្រ",
  "Requery": "សួរឡើងវិញ",
  "Reward Date": "កាលបរិច្ឆេទរង្វាន់",
  "Reward Type": "ប្រភេទរង្វាន់",
  "Notification Method": "វិធីជូនដំណឹង",
  "Email Preview": "មើលអ៊ីមែលជាមុន",
  "Message for User": "សារ​សម្រាប់​អ្នក​ប្រើ",
  "SMS will send to user, please enter the message less than 130 characters": "SMS នឹងផ្ញើទៅអ្នកប្រើ សូមបញ្ចូលសារដែលមានតិចជាង 130 តួអក្សរ",
  "Enter the message to be sent to the user": "បញ្ចូលសារដែលត្រូវផ្ញើទៅអ្នកប្រើ",
  "Email Address to show on Email Template": "អាសយដ្ឋានអ៊ីមែលដែលបង្ហាញក្នុងទម្រង់អ៊ីមែល",
  "Input Company Email Address": "បញ្ចូលអ៊ីមែលក្រុមហ៊ុន",
  "Company Name to show on Email Template": "ឈ្មោះក្រុមហ៊ុនដែលបង្ហាញក្នុងទម្រង់អ៊ីមែល",
  "Input Company Name": "បញ្ចូលឈ្មោះក្រុមហ៊ុន",
  "Company Phone No. to show on Email Template": "លេខទូរស័ព្ទក្រុមហ៊ុនដែលបង្ហាញក្នុងទម្រង់អ៊ីមែល",
  "Input Company Phone No.": "បញ្ចូលលេខទូរស័ព្ទក្រុមហ៊ុន",
  "Voucher ID": "លេខសម្គាល់ប័ណ្ណ",
  "Washer Stamp": "ត្រាម៉ាស៊ីនបោកគក់",
  "Dryer Stamp": "ត្រាម៉ាស៊ីនសម្ងួត",
  "e-Token Amount": "ចំនួន e-Token",
  "Transfer Date": "កាលបរិច្ឆេទផ្ទេរ",
  "Transfer Amount (Token)": "ចំនួនផ្ទេរ (Token)",
  "Number (Transfer From)": "លេខ (ផ្ទេរពី)",
  "Name (Transfer From)": "ឈ្មោះ (ផ្ទេរពី)",
  "Member ID (Transfer From)": "លេខសមាជិក (ផ្ទេរពី)",
  "Number (Transfer To)": "លេខ (ផ្ទេរទៅ)",
  "Name (Transfer To)": "ឈ្មោះ (ផ្ទេរទៅ)",
  "Member ID (Transfer To)": "លេខសមាជិក (ផ្ទេរទៅ)",
  "Grant Date": "កាលបរិច្ឆេទផ្តល់",
  "Claim Date": "កាលបរិច្ឆេទទាមទារ",
  "Member Details Report": "របាយការណ៍ព័ត៌មានសមាជិក",
  "Transaction Status": "ស្ថានភាពប្រតិបត្តិការ",
  "Token Reload": "បញ្ចូល Token",
  "Token Transfer": "ផ្ទេរ Token",
  "Voucher History": "ប្រវត្តិប័ណ្ណ",
  "TOKEN": "TOKEN",
  "Message Sent": "សារបានផ្ញើ",
  "Date Sent": "កាលបរិច្ឆេទផ្ញើ",
  "Remaining SMS Credit": "ឥណទាន SMS នៅសល់",
  "Store": "ហាង",
  "Total Registered Users": "ចំនួនអ្នកប្រើបានចុះឈ្មោះសរុប",
  "User registered but no transaction record": "អ្នកប្រើបានចុះឈ្មោះ ប៉ុន្តែមិនមានប្រវត្តិប្រតិបត្តិការ",
  "Registered": "បានចុះឈ្មោះ",
  "User spending is less than": "ការចំណាយអ្នកប្រើតិចជាង",
  "Active": "សកម្ម",
  "User spending is from": "ការចំណាយអ្នកប្រើចាប់ពី",
  "until": "ដល់",
  "Tier 1": "កម្រិត 1",
  "User spending is": "ការចំណាយអ្នកប្រើគឺ",
  "and above": "និងលើសពីនេះ",
  "Tier 2": "កម្រិត 2",
  "Average spending in each transaction": "ចំណាយមធ្យមក្នុងមួយប្រតិបត្តិការ",
  "Average Spending": "ចំណាយមធ្យម",
  "Total number of transactions": "ចំនួនប្រតិបត្តិការសរុប",
  "Total Transactions": "ប្រតិបត្តិការសរុប",
  "Number of vouchers used in all the transactions": "ចំនួនប័ណ្ណដែលបានប្រើក្នុងប្រតិបត្តិការទាំងអស់",
  "Voucher Claimed": "ប័ណ្ណដែលបានប្រើ",
  "Total number of washer machine transactions": "ចំនួនប្រតិបត្តិការម៉ាស៊ីនបោកគក់សរុប",
  "Washer Usage": "ការប្រើម៉ាស៊ីនបោកគក់",
  "Total number of dryer machine transactions": "ចំនួនប្រតិបត្តិការម៉ាស៊ីនសម្ងួតសរុប",
  "Dryer Usage": "ការប្រើម៉ាស៊ីនសម្ងួត",
  "User Name": "ឈ្មោះអ្នកប្រើ",
  "e-Token Spent": "e-Token ដែលបានចំណាយ",
  "e-Token Detailed Report": "របាយការណ៍លម្អិត e-Token",
  "e-Token Purchase History": "ប្រវត្តិទិញ e-Token",
  "Select Purchase Date": "ជ្រើសរើសកាលបរិច្ឆេទទិញ",
  "Outlet Name": "ឈ្មោះសាខា",
  "Total number of e-token used in all the transactions": "ចំនួនសរុប e-token ដែលបានប្រើក្នុងប្រតិបត្តិការ​ទាំងអស់",
  "Total e-Token Collected": "ចំនួន e-Token សរុបដែលបានប្រមូល",
  "Total number of e-token used in washer machine transactions": "ចំនួន e-token ដែលបានប្រើក្នុងប្រតិបត្តិការម៉ាស៊ីនបោកគក់",
  "Washer e-Token Collected": "e-Token ប្រមូលពីម៉ាស៊ីនបោកគក់",
  "Total number of e-token used in dryer machine transactions": "ចំនួន e-token ដែលបានប្រើក្នុងប្រតិបត្តិការម៉ាស៊ីនសម្ងួត",
  "Dryer e-Token Collected": "e-Token ប្រមូលពីម៉ាស៊ីនសម្ងួត",
  "Vending Machine e-Token Collected": "e-Token ប្រមូលពីម៉ាស៊ីនលក់",
  "Purchase History": "ប្រវត្តិទិញ",
  "All": "ទាំងអស់",
  "Most Bought e-Token Package": "កញ្ចប់ e-Token ដែលទិញច្រើនបំផុត",
  "for": "សម្រាប់",
  "Tokens": "Tokens",
  "Total Earned from users buying e-Tokens": "ចំនួនសរុបដែលបានចំណូលពីអ្នកប្រើទិញ e-Tokens",
  "Total e-Tokens Bought from you": "ចំនួន e-Tokens សរុបដែលបានទិញពីអ្នក",
  "Join Date": "កាលបរិច្ឆេទចូលរួម",
  "Channel": "ឆានែល",
  "Tier": "កម្រិត",
  "Referrer": "អ្នកណែនាំ",
  "Referrals": "ការណែនាំ",
  "Number of transactions for last 7 days": "ចំនួនប្រតិបត្តិការសម្រាប់ 7 ថ្ងៃចុងក្រោយ",
  "Number of Usage (in week)": "ចំនួនប្រើប្រាស់ (ក្នុងមួយសប្តាហ៍)",
  "Number of transactions for last 1 month": "ចំនួនប្រតិបត្តិការសម្រាប់ 1 ខែចុងក្រោយ",
  "Number of Usage (in month)": "ចំនួនប្រើប្រាស់ (ក្នុងមួយខែ)",
  "Total amount spent in all the transactions": "ចំនួនសរុបបានចំណាយក្នុងប្រតិបត្តិការទាំងអស់",
  "Total Spent": "ចំណាយសរុប",
  "Last Transaction Date": "កាលបរិច្ឆេទប្រតិបត្តិការចុងក្រោយ",
  "Number of vouchers collected": "ចំនួនប័ណ្ណដែលបានប្រមូល",
  "Voucher Collected": "ប័ណ្ណដែលបានប្រមូល",
  "Number of vouchers used": "ចំនួនប័ណ្ណដែលបានប្រើ",
  "Voucher Spent": "ប័ណ្ណដែលបានចំណាយ",
  "Washer Used": "ម៉ាស៊ីនបោកគក់បានប្រើ",
  "Dryer Used": "ម៉ាស៊ីនសម្ងួតបានប្រើ",
  "Total number of e-Token spent in all the transactions": "ចំនួនសរុប e-Token ដែលបានចំណាយក្នុងប្រតិបត្តិការទាំងអស់",
  "Total number of stamps collected": "ចំនួនសរុបត្រាប្រមូល",
  "Total Stamps": "ត្រាសរុប",
  "Select Join Date": "ជ្រើសរើសកាលបរិច្ឆេទចូលរួម",
  "Select Grant Date": "ជ្រើសរើសកាលបរិច្ឆេទផ្តល់",
  "Amount": "ចំនួន",
  "The image size is over 2MB": "ទំហំរូបភាពលើស 2MB",
  "Duplicate language selected": "បានជ្រើសភាសាដូចគ្នា",
  "Are you sure you want to add FAQ?": "តើអ្នកប្រាកដថាចង់បន្ថែម FAQ មែនទេ?",
  "FAQ added successfully": "បានបន្ថែម FAQ ដោយជោគជ័យ",
  "FAQ Group added successfully": "បានបន្ថែមក្រុម FAQ ដោយជោគជ័យ",
  "Please provide the faq with the default language": "សូមផ្ដល់ FAQ ជាភាសាមូលដ្ឋាន",
  "Add FAQ": "បន្ថែម FAQ",
  "Default Language": "ភាសាមូលដ្ឋាន",
  "Select Default Language": "ជ្រើសភាសាមូលដ្ឋាន",
  "Image (Optional)": "រូបភាព (ជាជម្រើស)",
  "max": "អតិបរមា",
  "Question": "សំនួរ",
  "Select Language": "ជ្រើសភាសា",
  "Remove": "ដកចេញ",
  "Answer": "ចម្លើយ",
  "Add Translation": "បន្ថែមការប្រែសម្រួល",
  "Are you sure you want to add FAQ Group?": "តើអ្នកប្រាកដថាចង់បន្ថែមក្រុម FAQ មែនទេ?",
  "Please provide the faq group with the default language": "សូមផ្ដល់ក្រុម FAQ ជាភាសាមូលដ្ឋាន",
  "Add FAQ Group": "បន្ថែមក្រុម FAQ",
  "Title": "ចំណងជើង",
  "Title Language": "ភាសាចំណងជើង",
  "Please fill in the title": "សូមបំពេញចំណងជើង",
  "Please fill in the description": "សូមបំពេញការពណ៌នា",
  "Please fill in the short description": "សូមបំពេញការពណ៌នាខ្លី",
  "Please select the end date for your news": "សូមជ្រើសកាលបរិច្ឆេទបញ្ចប់សម្រាប់ព័ត៌មានរបស់អ្នក",
  "Please provide the news with the default language": "សូមផ្ដល់ព័ត៌មានជាភាសាមូលដ្ឋាន",
  "Please provide the banner image": "សូមផ្ដល់រូបភាពប័ណ័រ",
  "Please provide the news image": "សូមផ្ដល់រូបភាពព័ត៌មាន",
  "Are you sure you want to add news?": "តើអ្នកប្រាកដថាចង់បន្ថែមព័ត៌មានមែនទេ?",
  "News added successfully": "បានបន្ថែមព័ត៌មានដោយជោគជ័យ",
  "Please fill in all the required fields before submit": "សូមបំពេញវាលទាំងអស់ដែលត្រូវការមុនពេលបញ្ជូន",
  "Add News": "បន្ថែមព័ត៌មាន",
  "Banner Image": "រូបភាពប័ណ័រ",
  "News Image": "រូបភាពព័ត៌មាន",
  "Banner": "ប័ណ័រ",
  "aspect ratio": "អង្គភាពអាស្បតកម្ម",
  "Image": "រូបភាព",
  "Display in": "បង្ហាញនៅក្នុង",
  "Inbox Page": "ទំព័រ Inbox",
  "Promotion Banner": "ប័ណ័រសហព័ន្ធ",
  "Select Period: (optional)": "ជ្រើសរើសរយៈពេល៖ (ជាជម្រើស)",
  "Short Description": "ការពណ៌នាសង្ខេប",
  "Your theme has been updated successfully": "ស្ទីលរបស់អ្នកត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ",
  "Default Theme": "ស្ទីលលំនាំដើម",
  "Change Logo": "ផ្លាស់ប្តូររូបសញ្ញា",
  "REMOVE LOGO": "លុបរូបសញ្ញា",
  "Sms credit used up": "ឥណទាន SMS បានប្រើចប់",
  "Please top up your sms credit": "សូមបញ្ចូលឥណទាន SMS របស់អ្នក",
  "Please": "សូម",
  "Again": "ម្តងទៀត",
  "Welcome": "សូមស្វាគមន៍",
  "Ranking": "ចំណាត់ថ្នាក់",
  "Select Year": "ជ្រើសឆ្នាំ",
  "Missing Field": "វាលដែលខ្វះ",
  "Please select can be used for which type of transaction": "សូមជ្រើសអាចប្រើសម្រាប់ប្រភេទប្រតិបត្តិការណា",
  "Please fill in the start date and end date": "សូមបំពេញកាលបរិច្ឆេទចាប់ផ្តើម និងកាលបរិច្ឆេទបញ្ចប់",
  "Discount amount should be more than 0": "ចំនួនបញ្ចុះតម្លៃគួរតែលើស 0",
  "Redeem per user should be more than 0": "ការទទួលប្រើប្រាស់ត្រូវលើស 0 សម្រាប់អ្នកប្រើម្នាក់",
  "Redeem per day should be more than 0": "ការទទួលប្រើប្រាស់ប្រចាំថ្ងៃត្រូវលើស 0",
  "Your discount code have edited successfully": "កូដបញ្ចុះតម្លៃរបស់អ្នកត្រូវបានកែប្រែដោយជោគជ័យ",
  "Your discount code have added successfully": "កូដបញ្ចុះតម្លៃរបស់អ្នកត្រូវបានបន្ថែមដោយជោគជ័យ",
  "Delete this entry?": "តើអ្នកចង់លុបការបញ្ចូលនេះមែនទេ?",
  "Your discount code have deleted successfully": "កូដបញ្ចុះតម្លៃរបស់អ្នកត្រូវបានលុបដោយជោគជ័យ",
  "Created Date": "កាលបរិច្ឆេទបង្កើត",
  "Discount code": "កូដបញ្ចុះតម្លៃ",
  "General Discount Code": "កូដបញ្ចុះតម្លៃទូទៅ",
  "Unique Discount Code": "កូដបញ្ចុះតម្លៃតែមួយ",
  "Start Date": "កាលបរិច្ឆេទចាប់ផ្តើម",
  "End Date": "កាលបរិច្ឆេទបញ្ចប់",
  "Redeem Per User": "ការទទួលប្រើប្រាស់ប្រចាំអ្នកប្រើ",
  "Redeem Per Day": "ការទទួលប្រើប្រាស់ប្រចាំថ្ងៃ",
  "Add Discount Code": "បន្ថែមកូដបញ្ចុះតម្លៃ",
  "Generate Discount Code": "បង្កើតកូដបញ្ចុះតម្លៃ",
  "No Discount Code": "គ្មានកូដបញ្ចុះតម្លៃ",
  "Edit Discount Code": "កែប្រែកូដបញ្ចុះតម្លៃ",
  "Select Period": "ជ្រើសរយៈពេល",
  "Redeem per user": "ការទទួលប្រើប្រាស់ប្រចាំអ្នកប្រើ",
  "How many times the discount code can be used for each user": "កូដបញ្ចុះតម្លៃអាចប្រើប្រាស់ប៉ុន្មានដងសម្រាប់អ្នកប្រើម្នាក់",
  "Redeem per day": "ការទទួលប្រើប្រាស់ប្រចាំថ្ងៃ",
  "How many times the discount code can be used in one day": "កូដបញ្ចុះតម្លៃអាចប្រើប្រាស់ប៉ុន្មានដងក្នុងមួយថ្ងៃ",
  "If ticked, the discount code can apply to washer machine transaction": "បើបានធ្វើសញ្ញាដាក់ត្រង់, កូដបញ្ចុះតម្លៃអាចប្រើសម្រាប់ប្រតិបត្តិការម៉ាស៊ីនបោកគក់",
  "If ticked, the discount code can apply to dryer machine transaction": "បើបានធ្វើសញ្ញាដាក់ត្រង់, កូដបញ្ចុះតម្លៃអាចប្រើសម្រាប់ប្រតិបត្តិការម៉ាស៊ីនសម្ងួត",
  "If ticked, the discount code can apply to Drop n Go transaction": "បើបានធ្វើសញ្ញាដាក់ត្រង់, កូដបញ្ចុះតម្លៃអាចប្រើសម្រាប់ប្រតិបត្តិការ Drop n Go",
  "If ticked, the discount code can apply to vending machine transaction": "បើបានធ្វើសញ្ញាដាក់ត្រង់, កូដបញ្ចុះតម្លៃអាចប្រើសម្រាប់ប្រតិបត្តិការម៉ាស៊ីនលក់",
  "If ticked, the discount code can apply to detergent vending machine transaction": "បើបានធ្វើសញ្ញាដាក់ត្រង់, កូដបញ្ចុះតម្លៃអាចប្រើសម្រាប់ប្រតិបត្តិការម៉ាស៊ីនលក់សាប៊ូបោក",
  "If ticked, the discount code can apply to car wash transaction": "បើបានធ្វើសញ្ញាដាក់ត្រង់, កូដបញ្ចុះតម្លៃអាចប្រើសម្រាប់ប្រតិបត្តិការលាងរថយន្ត",
  "The user enter the discount code": "អ្នកប្រើបានបញ្ចូលកូដបញ្ចុះតម្លៃ",
  "in the payment page will get": "នៅទំព័រទូទាត់នឹងទទួលបាន",
  "discount": "ការបញ្ចុះតម្លៃ",
  "The discount code only can be used start from {{ start_date }} until {{ end_date }}": "កូដបញ្ចុះតម្លៃអាចប្រើបានចាប់ពី {{ start_date }} ដល់ {{ end_date }}",
  "Every user only can use the discount code {{ redeem_per_user }} times": "អ្នកប្រើម្នាក់អាចប្រើកូដបញ្ចុះតម្លៃ {{ redeem_per_user }} ដងប៉ុណ្ណោះ",
  "Every user only can use {{ redeem_per_user }} discount code from this batch of code": "អ្នកប្រើម្នាក់អាចប្រើកូដបញ្ចុះតម្លៃ {{ redeem_per_user }} ដងពីក្រុមកូដនេះ",
  "Only {{ redeem_per_day }} transactions can use the discount code in one day_one": "មានប្រតិបត្តិការតែមួយ {{ redeem_per_day }} អាចប្រើកូដបញ្ចុះតម្លៃក្នុងមួយថ្ងៃ",
  "Only {{ redeem_per_day }} transactions can use the discount code in one day_other": "មានប្រតិបត្តិការមួយច្រើន {{ redeem_per_day }} អាចប្រើកូដបញ្ចុះតម្លៃក្នុងមួយថ្ងៃ",
  "The discount code only can be used for washer machine": "កូដបញ្ចុះតម្លៃអាចប្រើបានសម្រាប់ម៉ាស៊ីនបោកគក់តែប៉ុណ្ណោះ",
  "The discount code only can be used for dryer machine": "កូដបញ្ចុះតម្លៃអាចប្រើបានសម្រាប់ម៉ាស៊ីនសម្ងួតតែប៉ុណ្ណោះ",
  "The discount code only can be used for Drop n Go transaction": "កូដបញ្ចុះតម្លៃអាចប្រើបានសម្រាប់ប្រតិបត្តិការ Drop n Go តែប៉ុណ្ណោះ",
  "The discount code only can be used for vending machine transaction": "កូដបញ្ចុះតម្លៃអាចប្រើបានសម្រាប់ប្រតិបត្តិការម៉ាស៊ីនលក់តែប៉ុណ្ណោះ",
  "The discount code only can be used for detergent vending machine transaction": "កូដបញ្ចុះតម្លៃអាចប្រើបានសម្រាប់ប្រតិបត្តិការម៉ាស៊ីនលក់សាប៊ូបោកតែប៉ុណ្ណោះ",
  "The discount code only can be used for car wash transaction": "កូដបញ្ចុះតម្លៃអាចប្រើបានសម្រាប់ប្រតិបត្តិការលាងរថយន្តតែប៉ុណ្ណោះ",
  "The discount code only can be used after user spending {{ currency }} {{ pay_and_use_amount }}": "កូដបញ្ចុះតម្លៃអាចប្រើបានបន្ទាប់ពីអ្នកប្រើបានចំណាយ {{ currency }} {{ pay_and_use_amount }}",
  "Are you sure you want to edit FAQ?": "តើអ្នកប្រាកដថាចង់កែប្រែ FAQ មែនទេ?",
  "FAQ updated successfully": "FAQ ត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ",
  "Edit FAQ": "កែប្រែ FAQ",
  "Are you sure you want to edit FAQ Group?": "តើអ្នកប្រាកដថាចង់កែប្រែក្រុម FAQ មែនទេ?",
  "FAQ Group updated successfully": "ក្រុម FAQ ត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ",
  "Edit FAQ Group": "កែប្រែក្រុម FAQ",
  "Are you sure you want to edit news?": "តើអ្នកប្រាកដថាចង់កែសម្រួលព័ត៌មានមែនទេ?",
  "News edit successfully": "ព័ត៌មានត្រូវបានកែសម្រួលដោយជោគជ័យ",
  "Edit News": "កែសម្រួលព័ត៌មាន",
  "All the FAQ under this group will be deleted. Are you sure you want to delete FAQ Group?": "FAQ ទាំងអស់នៅក្រោមក្រុមនេះនឹងត្រូវលុប។ តើអ្នកប្រាកដថាចង់លុបក្រុម FAQ មែនទេ?",
  "FAQ Group deleted successfully": "ក្រុម FAQ ត្រូវបានលុបដោយជោគជ័យ",
  "FAQ List": "បញ្ជី FAQ",
  "NO FAQ GROUP": "គ្មានក្រុម FAQ",
  "FAQ Group": "ក្រុម FAQ",
  "Are you sure you want to delete FAQ?": "តើអ្នកប្រាកដថាចង់លុប FAQ មែនទេ?",
  "FAQ deleted successfully": "FAQ ត្រូវបានលុបដោយជោគជ័យ",
  "NO FAQs": "គ្មាន FAQ",
  "FAQ": "FAQ",
  "Easy": "សាមញ្ញ",
  "Fast Laundromate": "Fast Laundromate",
  "Smart Laundry Management System": "ប្រព័ន្ធគ្រប់គ្រងបោកខោអាវឆ្លាត",
  "Enter your username and password to login": "បញ្ចូលឈ្មោះអ្នកប្រើ និងលេខសម្ងាត់ដើម្បីចូល",
  "Username": "ឈ្មោះអ្នកប្រើ",
  "Are you sure you want to delete news?": "តើអ្នកប្រាកដថាចង់លុបព័ត៌មានមែនទេ?",
  "News deleted successfully": "ព័ត៌មានត្រូវបានលុបដោយជោគជ័យ",
  "NO NEWS": "គ្មានព័ត៌មាន",
  "The referral setting has been updated successfully!": "ការកំណត់ referral ត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  "Number of Stamp": "ចំនួនស្លាបព្រិល",
  "Number of Washer Stamp": "ចំនួនស្លាបព្រិលម៉ាស៊ីនបោក",
  "Number of Dryer Stamp": "ចំនួនស្លាបព្រិលម៉ាស៊ីនសម្ងួត",
  "Enable Referral Feature?": "បើកមុខងារ Referral?",
  "Are you sure you want to delete the tier setting?": "តើអ្នកប្រាកដថាចង់លុបការកំណត់តំបន់រង់ចាំ?",
  "Minimum referee transaction amount for referrer to get referral rewards": "ចំនួនប្រតិបត្តិការតិចបំផុតសម្រាប់អ្នកត្រូវបានផ្តល់រង្វាន់ referral",
  "Maximum number of reward within this tier": "ចំនួនរង្វាន់អតិបរមានៅក្នុងតំបន់នេះ",
  "Maximum number of reward can get from same user": "ចំនួនរង្វាន់អតិបរមាអាចទទួលពីអ្នកប្រើដូចគ្នា",
  "Point Grant Type": "ប្រភេទផ្តល់ពិន្ទុ",
  "Select Point Grant Type": "ជ្រើសប្រភេទផ្តល់ពិន្ទុ",
  "Token Grant Type": "ប្រភេទផ្តល់ Token",
  "Select Token Grant Type": "ជ្រើសប្រភេទផ្តល់ Token",
  "Add Tier": "បន្ថែមតំបន់",
  "Stamp": "ស្លាបព្រិល",
  "If ticked, the system will give stamp to user": "បើបានធ្វើសញ្ញាដាក់ត្រង់, ប្រព័ន្ធនឹងផ្តល់ស្លាបព្រិលដល់អ្នកប្រើ",
  "If ticked, the system will give e-Token to user": "បើបានធ្វើសញ្ញាដាក់ត្រង់, ប្រព័ន្ធនឹងផ្តល់ e-Token ដល់អ្នកប្រើ",
  "If ticked, the system will give voucher to user": "បើបានធ្វើសញ្ញាដាក់ត្រង់, ប្រព័ន្ធនឹងផ្តល់វូឌ័រដល់អ្នកប្រើ",
  "Number of E-Token": "ចំនួន E-Token",
  "Reward Giveaway": "ការផ្តល់រង្វាន់",
  "Which type of reward you want to give to customer?": "តើអ្នកចង់ផ្តល់ប្រភេទរង្វាន់ណាដល់អតិថិជន?",
  "For machine uses (required)": "សម្រាប់ប្រើម៉ាស៊ីន (ចាំបាច់)",
  "leave blank if no expiry date": "ទុកទទេប្រសិនបើគ្មានកាលបរិច្ឆេទផុតកំណត់",
  "Remarks": "កំណត់ចំណាំ",
  "Reward": "រង្វាន់",
  "Please fill in all the required field. (Title, description, and amount must be more than 0)": "សូមបំពេញវាលទាំងអស់ដែលចាំបាច់ (ចំណងជើង, ការពណ៌នា និងចំនួនត្រូវលើស 0)",
  "Checkbox required": "ត្រូវការ Checkbox",
  "Must select voucher can be used for washer, dryer or package": "ត្រូវជ្រើសវូឌ័រអាចប្រើសម្រាប់ម៉ាស៊ីនបោក, ម៉ាស៊ីនសម្ងួត ឬ package",
  "How many e-token?": "ចំនួន e-token ប៉ុន្មាន?",
  "Number of e-Token": "ចំនួន e-Token",
  "Token value must be more than 0": "តម្លៃ Token ត្រូវលើស 0",
  "STAMP": "ស្លាបព្រិល",
  "Please fill in at least one of the required field": "សូមបំពេញយ៉ាងហោចណាស់មួយក្នុងចំណោមវាលចាំបាច់",
  "The value must be more than 0": "តម្លៃត្រូវលើស 0",
  "How many times rewarded to user": "ផ្តល់រង្វាន់ទៅអ្នកប្រើប៉ុន្មានដង",
  "Rewarded Times": "ចំនួនដងដែលបានផ្តល់",
  "How many times rewarded voucher to user": "ផ្តល់វូឌ័រទៅអ្នកប្រើប៉ុន្មានដង",
  "Voucher Rewarded (times)": "វូឌ័រដែលបានផ្តល់ (ដង)",
  "How many times rewarded stamp to user": "ផ្តល់ស្លាបព្រិលទៅអ្នកប្រើប៉ុន្មានដង",
  "Stamps Rewarded (times)": "ស្លាបព្រិលដែលបានផ្តល់ (ដង)",
  "Total number of washer stamps rewarded to user": "ចំនួនស្លាបព្រិលម៉ាស៊ីនបោកសរុបដែលបានផ្តល់ដល់អ្នកប្រើ",
  "Washer Stamps Granted (stamp)": "ស្លាបព្រិលម៉ាស៊ីនបោកដែលបានផ្តល់ (ស្លាបព្រិល)",
  "Total number of dryer stamps rewarded to user": "ចំនួនស្លាបព្រិលម៉ាស៊ីនសម្ងួតសរុបដែលបានផ្តល់ដល់អ្នកប្រើ",
  "Dryer Stamps Granted (stamp)": "ស្លាបព្រិលម៉ាស៊ីនសម្ងួតដែលបានផ្តល់ (ស្លាបព្រិល)",
  "How many times rewarded e-Token to user": "ផ្តល់ e-Token ទៅអ្នកប្រើប៉ុន្មានដង",
  "e-Token Rewarded (times)": "e-Token ដែលបានផ្តល់ (ដង)",
  "Total number of e-Token rewarded to user": "ចំនួន e-Token សរុបដែលបានផ្តល់ដល់អ្នកប្រើ",
  "Total e-Token Granted (token)": "ចំនួន e-Token សរុបដែលបានផ្តល់ (Token)",
  "Point Rewarded (times)": "ពិន្ទុដែលបានផ្តល់ (ដង)",
  "How many times rewarded point to user": "ផ្តល់ពិន្ទុទៅអ្នកប្រើប៉ុន្មានដង",
  "Total Point Granted (point)": "ចំនួនពិន្ទុសរុបដែលបានផ្តល់ (ពិន្ទុ)",
  "Total number of point rewarded to user": "ចំនួនពិន្ទុសរុបដែលបានផ្តល់ដល់អ្នកប្រើ",
  "Point Amount": "ចំនួនពិន្ទុ",
  "Reward History": "ប្រវត្តិរង្វាន់",
  "Are you sure you want to change how the stamping mechanics works?": "តើអ្នកប្រាកដថាចង់ផ្លាស់ប្ដូររបៀបមេកានិចស្លាបព្រិល?",
  "The stamping mechanics setting has updated successfully!": "ការកំណត់មេកានិចស្លាបព្រិលត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  "The voucher setting has been updated successfully!": "ការកំណត់វូឌ័រត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  "Mechanics Settings": "ការកំណត់មេកានិច",
  "Minimum transaction amount for getting stamp": "ចំនួនប្រតិបត្តិការតិចបំផុតសម្រាប់ទទួលស្លាបព្រិល",
  "Select User Stamping Mechanic": "ជ្រើសមេកានិចស្លាបព្រិលអ្នកប្រើ",
  "Separated Stamping": "ស្លាបព្រិលបំបែក",
  "Combined Stamping": "ស្លាបព្រិលរួម",
  "Stamp for?": "ស្លាបព្រិលសម្រាប់?",
  "Both": "ទាំងពីរ",
  "Washer Only": "ម៉ាស៊ីនបោកតែប៉ុណ្ណោះ",
  "Dryer Only": "ម៉ាស៊ីនសម្ងួតតែប៉ុណ្ណោះ",
  "Separated Stamping = Different washer and dryer stamp collection. (example: Using Washer will gain 1 washer's stamp, and Dryer will gain 1 dryer stamp)": "ស្លាបព្រិលបំបែក = ការប្រមូលស្លាបព្រិលម៉ាស៊ីនបោក និងម៉ាស៊ីនសម្ងួតផ្សេងគ្នា (ឧទាហរណ៍: ប្រើម៉ាស៊ីនបោកបានស្លាបព្រិលម៉ាស៊ីនបោក 1 និងប្រើម៉ាស៊ីនសម្ងួតបានស្លាបព្រិលម៉ាស៊ីនសម្ងួត 1)",
  "Combined Stamping = Washer and dryer has the same collection. (example: Using Washer or Dryer will gain 1 stamp)": "ស្លាបព្រិលរួម = ម៉ាស៊ីនបោក និងម៉ាស៊ីនសម្ងួតមានការប្រមូលដូចគ្នា (ឧទាហរណ៍: ប្រើម៉ាស៊ីនបោក ឬ ម៉ាស៊ីនសម្ងួតបានស្លាបព្រិល 1)",
  "Stamp for": "ស្លាបព្រិលសម្រាប់",
  "User will be able to collect both washer stamp and dryer stamp": "អ្នកប្រើអាចប្រមូលស្លាបព្រិលម៉ាស៊ីនបោក និងម៉ាស៊ីនសម្ងួតទាំងពីរ",
  "User will only able to collect Washer stamp": "អ្នកប្រើអាចប្រមូលស្លាបព្រិលម៉ាស៊ីនបោកតែប៉ុណ្ណោះ",
  "User will only able to collect Dryer stamp": "អ្នកប្រើអាចប្រមូលស្លាបព្រិលម៉ាស៊ីនសម្ងួតតែប៉ុណ្ណោះ",
  "Registration": "ការចុះឈ្មោះ",
  "Birthday": "ថ្ងៃកំណើត",
  "Please choose at least one payment method": "សូមជ្រើសយ៉ាងតិចមួយវិធីបង់ប្រាក់",
  "Please choose at least one member or non-member payment": "សូមជ្រើសយ៉ាងតិចការទូទាត់សមាជិក ឬ មិនសមាជិកមួយ",
  "Are you sure you want to change the payment setting?": "តើអ្នកប្រាកដថាចង់ផ្លាស់ប្ដូរការកំណត់ការទូទាត់?",
  "The payment setting has updated successfully!": "ការកំណត់ការទូទាត់ត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  "Invalid input": "ការបញ្ចូលមិនត្រឹមត្រូវ",
  "The price and token must be more than 0": "តម្លៃ និង Token ត្រូវលើស 0",
  "Maximum number of purchase must be more than 0": "ចំនួនអតិបរមាការទិញត្រូវលើស 0",
  "Point amount must be more than 1": "ចំនួនពិន្ទุต្រូវលើស 1",
  "Added a new Token Bundle Package": "បានបន្ថែមកញ្ចប់ Token ថ្មី",
  "Bundle deleted successfully!": "កញ្ចប់ត្រូវបានលុបដោយជោគជ័យ!",
  "Reload voucher setting have edited successfully!": "ការកំណត់វូឌ័រត្រូវបានកែប្រែដោយជោគជ័យ!",
  "Added on": "បានបន្ថែមនៅថ្ងៃទី",
  "remove": "លុប",
  "edit": "កែប្រែ",
  "NO PACKAGES ON SALES": "គ្មានកញ្ចប់លក់",
  "Point Settings": "ការកំណត់ពិន្ទុ",
  "Enable Loyalty Point": "បើកពិន្ទុស្មោះត្រង់",
  "Point Name": "ឈ្មោះពិន្ទុ",
  "Number Of Point Equals To": "ចំនួនពិន្ទុស្មើនឹង",
  "If ticked, the point will have expired date": "បើបានធ្វើសញ្ញាដាក់ត្រង់, ពិន្ទុនេះនឹងមានកាលបរិច្ឆេទផុតកំណត់",
  "Point Lifespan": "អាយុកាលពិន្ទុ",
  "months": "ខែ",
  "Minimum Transaction Amount To Get Point": "ចំនួនប្រតិបត្តិការតិចបំផុតដើម្បីទទួលពិន្ទុ",
  "Point Grant Amount": "ចំនួនពិន្ទុដែលផ្តល់",
  "Point Grant Period": "រយៈពេលផ្តល់ពិន្ទុ",
  "Optional": "ជាជម្រើស",
  "Drop n Go Eligibility": "លក្ខណៈសម្បត្តិ Drop n Go",
  "If ticked, Drop n Go transaction will get the point": "បើបានធ្វើសញ្ញាដាក់ត្រង់, ប្រតិបត្តិការកម្មវិធី Drop n Go នឹងទទួលពិន្ទុ",
  "Washer Eligibility": "លក្ខណៈសម្បត្តិម៉ាស៊ីនបោក",
  "If ticked, washer transaction will get the point": "បើបានធ្វើសញ្ញាដាក់ត្រង់, ប្រតិបត្តិការម៉ាស៊ីនបោកនឹងទទួលពិន្ទុ",
  "Dryer Eligibility": "លក្ខណៈសម្បត្តិម៉ាស៊ីនសម្ងួត",
  "If ticked, dryer transaction will get the point": "បើបានធ្វើសញ្ញាដាក់ត្រង់, ប្រតិបត្តិការម៉ាស៊ីនសម្ងួតនឹងទទួលពិន្ទុ",
  "Point settings updated successfully!": "ការកំណត់ពិន្ទុត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  "Point Eligibility": "លក្ខណៈសម្បត្តិពិន្ទុ",
  "If ticked, the system will give point to user when user reload token successfully": "បើបានធ្វើសញ្ញាដាក់ត្រង់, ប្រព័ន្ធនឹងផ្តល់ពិន្ទុទៅអ្នកប្រើពេលអ្នកប្រើធ្វើការតំឡើង Token បានជោគជ័យ",
  "{{ point_amount }} point will be given after user reload token successfully": "{{ point_amount }} ពិន្ទុ នឹងផ្តល់បន្ទាប់ពីអ្នកប្រើធ្វើការតំឡើង Token បានជោគជ័យ",
  "Payment Settings": "ការកំណត់ការទូទាត់",
  "Select Payment Method": "ជ្រើសវិធីបង់ប្រាក់",
  "Enable E-Payment?": "បើកការទូទាត់អេឡិចត្រូនិក?",
  "Enable Token Currency?": "បើកប្រភេទរូបិយប័ណ្ណ Token?",
  "Enable Cash Payment?": "បើកការទូទាត់សាច់ប្រាក់?",
  "Enable QR Payment?": "បើកការទូទាត់ QR?",
  "Member and Non-Member Settings": "ការកំណត់សមាជិក និងមិនសមាជិក",
  "Enable Member Payment?": "បើកការទូទាត់សមាជិក?",
  "Enable Non-Member Payment?": "បើកការទូទាត់មិនសមាជិក?",
  "Promotion Settings": "ការកំណត់ការផ្សព្វផ្សាយ",
  "Enable Non Member Promotion?": "បើកការផ្សព្វផ្សាយមិនសមាជិក?",
  "Enable Notification When Cycle Done?": "បើកការជូនដំណឹងពេលបញ្ចប់រង្វិល?",
  "SMS charges": "ចំណាយ SMS",
  "SMS Settings": "ការកំណត់ SMS",
  "Enable Free Sms For Members": "បើក SMS សម្រាប់សមាជិកដោយឥតគិតថ្លៃ",
  "If enable notification, user can choose either receive email or sms when complete washing or drying": "បើបើកការជូនដំណឹង, អ្នកប្រើអាចជ្រើសទទួលអ៊ីមែល ឬ SMS ពេលបញ្ចប់ការបោក ឬសម្ងួត",
  "If user choose sms, non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "បើអ្នកប្រើជ្រើស SMS, មិនសមាជិកត្រូវបង់បន្ថែម {{ currency }}{{ sms_notification_amount }} សម្រាប់ SMS",
  "If user choose sms, member and non member have to pay extra {{ currency }}{{ sms_notification_amount }} for the sms": "បើអ្នកប្រើជ្រើស SMS, សមាជិក និង មិនសមាជិកត្រូវបង់បន្ថែម {{ currency }}{{ sms_notification_amount }} សម្រាប់ SMS",
  "Add Package": "បន្ថែមកញ្ចប់",
  "Edit e-Token Package": "កែប្រែកញ្ចប់ e-Token",
  "Add e-Token Package": "បន្ថែមកញ្ចប់ e-Token",
  "Please only input numberic value to prevent any bugs.": "សូមបញ្ចូលតែលេខដើម្បីជៀសវាងបញ្ហា",
  "Price": "តម្លៃ",
  "If ticked, the system will limit the number of purchase": "បើបានធ្វើសញ្ញាដាក់ត្រង់, ប្រព័ន្ធនឹងកំណត់ចំនួនការទិញ",
  "Limit Number of Purchase": "កំណត់ចំនួនការទិញ",
  "Number of maximum purchase": "ចំនួនអតិបរមាការទិញ",
  "Reload Voucher": "បញ្ចូលវូឌ័រ",
  "If ticked, the system will give voucher to user when user reload token successfully": "បើបានធ្វើសញ្ញាដាក់ត្រង់, ប្រព័ន្ធនឹងផ្តល់វូឌ័រទៅអ្នកប្រើពេល Reload Token បានជោគជ័យ",
  "If ticked, the system will give voucher repeatly": "បើបានធ្វើសញ្ញាដាក់ត្រង់, ប្រព័ន្ធនឹងផ្តល់វូឌ័រជាបន្តបន្ទាប់",
  "Recurring": "ជាបន្តបន្ទាប់",
  "Total number of voucher given to user": "ចំនួនវូឌ័រសរុបដែលផ្តល់ដល់អ្នកប្រើ",
  "Period for giving next voucher": "រយៈពេលសម្រាប់ផ្តល់វូឌ័របន្ទាប់",
  "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens_one": "កញ្ចប់ Token {{ currency }}{{ price }} សម្រាប់ {{ numberOfToken }} Token",
  "Token package {{ currency }}{{ price }} for {{ numberOfToken }} tokens_other": "កញ្ចប់ Token {{ currency }}{{ price }} សម្រាប់ {{ numberOfToken }} Token",
  "Each user only can purchase {{ max_purchase }} times for the token package": "អ្នកប្រើម្នាក់អាចទិញកញ្ចប់ Token {{ max_purchase }} ដងតែប៉ុណ្ណោះ",
  "Voucher will be given after user reload token successfully": "វូឌ័រនឹងផ្តល់បន្ទាប់ពីអ្នកប្រើ Reload Token បានជោគជ័យ",
  "Voucher will not given after user reload tokens successfully": "វូឌ័រនឹងមិនផ្តល់បន្ទាប់ពី Reload Token បានជោគជ័យ",
  "The voucher will be expired after {{ voucher_duration }} days_one": "វូឌ័រនឹងផុតកំណត់បន្ទាប់ពី {{ voucher_duration }} ថ្ងៃ",
  "The voucher will be expired after {{ voucher_duration }} days_other": "វូឌ័រនឹងផុតកំណត់បន្ទាប់ពី {{ voucher_duration }} ថ្ងៃ",
  "The voucher will not expired": "វូឌ័រនឹងមិនផុតកំណត់",
  "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount_one": "វូឌ័រ {{ recurring_number }} សរុបនឹងផ្តល់ដល់អ្នកប្រើ និងវូឌ័រនីមួយៗនឹងបញ្ចុះតម្លៃ",
  "Total {{ recurring_number }} vouchers will be given to user and each voucher will discount_other": "វូឌ័រ {{ recurring_number }} សរុបនឹងផ្តល់ដល់អ្នកប្រើ និងវូឌ័រនីមួយៗនឹងបញ្ចុះតម្លៃ",
  "Edit Package": "កែប្រែកញ្ចប់",
  "Age": "អាយុ",
  "Total number of vouchers collected": "ចំនួនវូឌ័រដែលបានប្រមូលសរុប",
  "Vouchers Acquired": "វូឌ័រដែលបានទទួល",
  "Total amount spent in washer machine transactions": "ចំនួនសរុបដែលបានចំណាយក្នុងប្រតិបត្តិការម៉ាស៊ីនបោក",
  "Total Washer Payment": "ការទូទាត់ម៉ាស៊ីនបោកសរុប",
  "Total amount spent in dryer machine transactions": "ចំនួនសរុបដែលបានចំណាយក្នុងប្រតិបត្តិការម៉ាស៊ីនសម្ងួត",
  "Total Dryer Payment": "ការទូទាត់ម៉ាស៊ីនសម្ងួតសរុប",
  "Total amount spent in all transactions": "ចំនួនសរុបដែលបានចំណាយក្នុងប្រតិបត្តិការទាំងអស់",
  "Total Payment": "ការទូទាត់សរុប",
  "report": "របាយការណ៍",
  "Total amount spent for buying e-Token": "ចំនួនសរុបដែលបានចំណាយសម្រាប់ទិញ e-Token",
  "Total number of e-Token purchased": "ចំនួនសរុប e-Token ដែលបានទិញ",
  "Total e-Token Purchased (Tokens)": "ចំនួន e-Token ដែលបានទិញ (Token)",
  "Total number of e-Token used in washer machine transactions": "ចំនួន e-Token ដែលបានប្រើក្នុងប្រតិបត្តិការម៉ាស៊ីនបោក",
  "Washer Payment (Tokens)": "ការទូទាត់ម៉ាស៊ីនបោក (Token)",
  "Total number of e-Token used in dryer machine transactions": "ចំនួន e-Token ដែលបានប្រើក្នុងប្រតិបត្តិការម៉ាស៊ីនសម្ងួត",
  "Dryer Payment (Tokens)": "ការទូទាត់ម៉ាស៊ីនសម្ងួត (Token)",
  "Total number of e-Token used in all the transactions": "ចំនួន e-Token សរុបដែលបានប្រើក្នុងប្រតិបត្តិការទាំងអស់",
  "Total Payment (Tokens)": "ការទូទាត់សរុប (Token)",
  "Number of washer stamp collected currently": "ចំនួនស្លាកម៉ាស៊ីនបោកដែលបានប្រមូលបច្ចុប្បន្ន",
  "Number of dryer stamp collected currently": "ចំនួនស្លាកម៉ាស៊ីនសម្ងួតដែលបានប្រមូលបច្ចុប្បន្ន",
  "User Phone Number / Member ID / Email": "លេខទូរស័ព្ទអ្នកប្រើ / អត្តសញ្ញាណសមាជិក / អ៊ីមែល",
  "Example: 0123456789,A123456": "ឧទាហរណ៍: 0123456789,A123456",
  "SEARCH": "ស្វែងរក",
  "Total Users Registered": "ចំនួនអ្នកប្រើបានចុះឈ្មោះសរុប",
  "Total Active Outlets": "ចំនួនសាខាសកម្មសរុប",
  "Total Vouchers Given": "ចំនួនវូឌ័រដែលបានផ្តល់សរុប",
  "Total Transaction Counts": "ចំនួនប្រតិបត្តិការសរុប",
  "Total User Stamps Collected": "ចំនួនស្លាកអ្នកប្រើបានប្រមូលសរុប",
  "Distributor Login": "ចូលប្រើសម្រាប់អ្នកចែកចាយ",
  "Client Login": "ចូលប្រើសម្រាប់អតិថិជន",
  "Kiosk Login": "ចូលប្រើ Kiosk",
  "Promotion": "ការផ្សព្វផ្សាយ",
  "Please select operator": "សូមជ្រើសប្រតិបត្តិករ",
  "Please select distributor": "សូមជ្រើសអ្នកចែកចាយ",
  "Select Operator": "ជ្រើសប្រតិបត្តិករ",
  "Select Distributor": "ជ្រើសអ្នកចែកចាយ",
  "User can login or skip to payment without login to make the payment": "អ្នកប្រើអាចចូលប្រើ ឬរំលងទៅការទូទាត់ដោយមិនចូលប្រើ",
  "User have to login only can make the payment": "អ្នកប្រើត្រូវតែចូលប្រើទាំងអស់才能អាចធ្វើការទូទាត់",
  "User only can skip to payment without login to make the payment": "អ្នកប្រើអាចរំលងទៅការទូទាត់ដោយមិនចូលប្រើ",
  "Only CSV file is accepted": "គ្រាន់តែឯកសារ CSV ត្រូវបានទទួល",
  "The user and the balance have updated": "អ្នកប្រើ និងសមតុល្យត្រូវបានធ្វើបច្ចុប្បន្នភាព",
  "Register Time": "ម៉ោងចុះឈ្មោះ",
  "Upload User CSV file": "អាប់ឡូតឯកសារ CSV អ្នកប្រើ",
  "Sample CSV file": "ឯកសារ CSV ឧទាហរណ៍",
  "Please follow the CSV file format": "សូមអនុវត្តតាមទ្រង់ទ្រាយឯកសារ CSV",
  "User CSV file": "ឯកសារ CSV អ្នកប្រើ",
  "Only CSV file (comma delimited) is support now": "គ្រាន់តែឯកសារ CSV (បំបែកដោយកូម៉ា) ត្រូវបានគាំទ្រ",
  "Confirm uploaded data": "បញ្ជាក់ទិន្នន័យដែលបានអាប់ឡូត",
  "Operator": "ប្រតិបត្តិករ",
  "Distributor": "អ្នកចែកចាយ",
  "Refund By": "ត្រូវបានសងប្រាក់ដោយ",
  "Reward By": "រង្វាន់ដោយ",
  "Number Of Voucher Code": "ចំនួនកូដវូឌ័រ",
  "Number Of Discount Code": "ចំនួនកូដបញ្ចុះតម្លៃ",
  "New User Only": "សម្រាប់អ្នកប្រើថ្មីតែប៉ុណ្ណោះ",
  "Minimum Transaction Amount To Redeem": "ចំនួនប្រតិបត្តិការតិចបំផុតដើម្បីដោះស្រាយ",
  "Download": "ទាញយក",
  "Generate Voucher Code": "បង្កើតកូដវូឌ័រ",
  "Your voucher code is generating": "កំពុងបង្កើតកូដវូឌ័ររបស់អ្នក",
  "Your discount code is generating": "កំពុងបង្កើតកូដបញ្ចុះតម្លៃរបស់អ្នក",
  "Voucher Code Settings": "ការកំណត់កូដវូឌ័រ",
  "If ticked, the voucher code only can redeem in register page": "បើបានធ្វើសញ្ញាដាក់ត្រង់, កូដវូឌ័រនេះអាចដោះស្រាយបានតែនៅទំព័រ​ចុះឈ្មោះ",
  "If ticked, the user only can use the voucher after make a transaction": "បើបានធ្វើសញ្ញាដាក់ត្រង់, អ្នកប្រើអាចប្រើវូឌ័របន្ទាប់ពីធ្វើប្រតិបត្តិការ",
  "If ticked, the user only can use the discount code after make a transaction": "បើបានធ្វើសញ្ញាដាក់ត្រង់, អ្នកប្រើអាចប្រើកូដបញ្ចុះតម្លៃបន្ទាប់ពីធ្វើប្រតិបត្តិការ",
  "Expired Date Of Voucher Code": "កាលបរិច្ឆេទផុតកំណត់នៃកូដវូឌ័រ",
  "Minimum Transaction Amount To Use Voucher": "ចំនួនប្រតិបត្តិការតិចបំផុតដើម្បីប្រើវូឌ័រ",
  "Minimum Transaction Amount To Use Code": "ចំនួនប្រតិបត្តិការតិចបំផុតដើម្បីប្រើកូដ",
  "Max redemption per user in this batch voucher code": "ការដោះស្រាយអតិបរមាទៅនិយោជក្នងកូដវូឌ័រប៉ាត់នេះ",
  "Max redemption per user in this batch discount code": "ការដោះស្រាយអតិបរមាទៅនិយោជក្នងកូដបញ្ចុះតម្លៃប៉ាត់នេះ",
  "Add Voucher": "បន្ថែមវូឌ័រ",
  "Completed": "បានបញ្ចប់",
  "Voucher Code Report": "របាយការណ៍កូដវូឌ័រ",
  "Floating Token Report": "របាយការណ៍ Token រាវ",
  "Floating Point Report": "របាយការណ៍ពិន្ទុរាវ",
  "E-Payment Report": "របាយការណ៍ទូទាត់អេឡិចត្រូនិក",
  "Referral Reward History Report": "របាយការណ៍ប្រវត្តិរង្វាន់ណែនាំ",
  "Redemption Date": "កាលបរិច្ឆេទដោះស្រាយ",
  "Redemption Code": "កូដដោះស្រាយ",
  "Select Redemption Date": "ជ្រើសកាលបរិច្ឆេទដោះស្រាយ",
  "Select Voucher Type": "ជ្រើសប្រភេទវូឌ័រ",
  "Giveaway": "ផ្តល់ជាការផ្សព្វផ្សាយ",
  "Select Name": "ជ្រើសឈ្មោះ",
  "Amount must be more than 1": "ចំនួនត្រូវលើស 1",
  "Payment method setting have updated successfully!": "ការកំណត់វិធីទូទាត់ត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  "Edit Payment Method": "កែប្រែវិធីទូទាត់",
  "Minimum payment amount to include all the payment methods": "ចំនួនទូទាត់តិចបំផុតដើម្បីរួមបញ្ចូលវិធីទូទាត់ទាំងអស់",
  "Exclude Payment Method in Revenue Monster": "លុបចេញវិធីទូទាត់ក្នុង Revenue Monster",
  "Welcome to": "សូមស្វាគមន៍មកកាន់",
  "Instruction": "សេចក្តីណែនាំ",
  "Please select the machine": "សូមជ្រើសម៉ាស៊ីន",
  "Login your account": "ចូលគណនីរបស់អ្នក",
  "Select the setting and make the payment": "ជ្រើសការកំណត់ ហើយធ្វើការទូទាត់",
  "Phone Number / Email": "លេខទូរស័ព្ទ / អ៊ីមែល",
  "Reload & Transfer In": "បញ្ចូល និងផ្ទេរចូល",
  "Usage & Transfer Out": "ការប្រើប្រាស់ និងផ្ទេរចេញ",
  "Usage": "ប្រើប្រាស់",
  "Remaining": "នៅសល់",
  "Gain": "ទទួលបាន",
  "Type": "ប្រភេទ",
  "Order Date": "កាលបរិច្ឆេទបញ្ជាទិញ",
  "Pack Number": "លេខកញ្ចប់",
  "Pack Details": "ព័ត៌មានលម្អិតកញ្ចប់",
  "Size": "ទំហំ",
  "Mode": "របៀប",
  "Machine Payment": "ការទូទាត់ម៉ាស៊ីន",
  "DNG History": "ប្រវត្តិ Drop And Go",
  "Token History": "ប្រវត្តិ Token",
  "Stamp History": "ប្រវត្តិស្លាក",
  "Staff Login": "ចូលប្រើបុគ្គលិក",
  "Drop And Go Portal": "ទ្វារចូល Drop And Go",
  "Available Task": "កិច្ចការត្រូវបានគាំទ្រ",
  "Completed Task": "កិច្ចការបញ្ចប់",
  "Task ID": "លេខកូដកិច្ចការ",
  "Task": "កិច្ចការ",
  "Start Task": "ចាប់ផ្តើមកិច្ចការ",
  "Select Machine": "ជ្រើសម៉ាស៊ីន",
  "Start Machine": "ចាប់ផ្តើមម៉ាស៊ីន",
  "Reward To": "រង្វាន់ទៅ",
  "Reward From": "រង្វាន់ពី",
  "Transaction Account": "គណនីប្រតិបត្តិការ",
  "Point": "ពិន្ទុ",
  "POINT": "ពិន្ទុ",
  "Number of Point": "ចំនួនពិន្ទុ",
  "Point History": "ប្រវត្តិពិន្ទុ",
  "Customer Name": "ឈ្មោះអតិថិជន",
  "Number of Washer Transactions": "ចំនួនប្រតិបត្តិការម៉ាស៊ីនបោក",
  "Number of Dryer Transactions": "ចំនួនប្រតិបត្តិការម៉ាស៊ីនសម្ងួត",
  "Vouchers Redeemed": "វូឌ័រដែលបានដោះស្រាយ",
  "Discount Code Redemption": "ការដោះស្រាយកូដបញ្ចុះតម្លៃ",
  "Total Spend": "ចំនួនសរុបដែលបានចំណាយ",
  "Select Outlet(s)": "ជ្រើសសាខា(ស)",
  "User Usage Report": "របាយការណ៍ប្រើប្រាស់អ្នកប្រើ",
  // cleanpro plus km
  "Wash": "បោក",
  "Dry": "ស្ងួត",
  "Fold": "ជ្រុញ",
  "Scan QR": "ស្កេន QR",
  "Capacity": "សមត្ថភាព",
  "Duration": "រយៈពេល",
  "Custom duration": "រយៈពេលផ្ទាល់ខ្លួន",
  "Choose duration": "ជ្រើសរើសរយៈពេល",
  "Select the correct amount on the machine after payment.": "ជ្រើសចំនួនត្រឹមត្រូវលើម៉ាស៊ីនបន្ទាប់ពីបង់ប្រាក់។",
  "Offers": "ពិសេស",
  "Voucher Offers": "ការផ្តល់វូឌ័រ",
  "Discount Code Offers": "ការផ្តល់កូដបញ្ចុះតម្លៃ",
  "An easier way to pay": "វិធីងាយស្រួលក្នុងការទូទាត់",
  "Create account": "បង្កើតគណនី",
  "Login": "ចូល",
  "By signing up, you agree to": "ដោយចុះឈ្មោះ អ្នកយល់ព្រមលើ",
  "Amount to Pay": "ចំនួនដែលត្រូវបង់",
  "1 voucher selected": "បានជ្រើសវូឌ័រមួយ",
  "No voucher selected": "មិនបានជ្រើសវូឌ័រ",
  "Credits": "ឥណទាន",
  "credits": "ឥណទាន",
  "credit": "ឥណទាន",
  "Credit balance": "សមតុល្យឥណទាន",
  "Please ensure that the machine door is shut & your laundry is inside.": "សូមប្រាកដថាប្រអប់ម៉ាស៊ីនបានបិទ និងការកំអិនរបស់អ្នកនៅខាងក្នុង។",
  "Insufficient balance": "សមតុល្យមិនគ្រប់គ្រាន់",
  "Topup now": "បន្ថែមប្រាក់ឥឡូវនេះ",
  "Good Evening!": "ល្ងាចសុខសប្បាយ!",
  "Hello": "សួស្តី",
  "Wallet Balance": "សមតុល្យកាបូបប្រាក់",
  "Topup": "បន្ថែមប្រាក់",
  "More details": "ព័ត៌មានលម្អិតបន្ថែម",
  "Collect 10 e-stamps to earn x1 FREE wash or dry voucher": "ប្រមូលស្លាបព្រីងអេឡិចត្រូនិច ១០ ដើម្បីទទួលវូឌ័របោក/ស្ងួតមួយដោយឥតគិតថ្លៃ",
  "Credits OFF": "បិទឥណទាន",
  "% OFF": "% បញ្ចុះតម្លៃ",
  "Valid Till": "សុពលភាពរហូតដល់",
  "Used On": "បានប្រើនៅលើ",
  "Expired On": "ផុតកំណត់នៅ",
  "Available": "មានស្រាប់",
  "Expired": "ផុតកំណត់",
  "Used": "បានប្រើ",
  "Promotions": "ការផ្សព្វផ្សាយ",
  "Rewards": "រង្វាន់",
  "Inbox": "ប្រអប់សារចូល",
  "Activities": "សកម្មភាព",
  "Support": "គាំទ្រ",
  "Active Rewards": "រង្វាន់សកម្ម",
  "Past Rewards": "រង្វាន់មុន",
  "Get rewarded for your loyalty with Cleanpro Plus Rewards!": "ទទួលរង្វាន់សម្រាប់ភាពស្មោះត្រង់របស់អ្នកជាមួយរង្វាន់ Cleanpro Plus!",
  "Earn vouchers and redeem them for discounts, freebies and more. The more you use our services the more you save!": "ទទួលវូឌ័រនិងដោះស្រាយវាដើម្បីទទួលការបញ្ចុះតម្លៃ ឥតគិតថ្លៃ និងផ្សេងៗ។ ប្រើប្រាស់សេវាកម្មរបស់យើងច្រើន អ្នកនឹងសន្សំពេលច្រើន!",
  "Up to 3 months history": "ប្រវត្តិរហូតដល់ ៣ ខែ",
  "Filter": "ចម្រោះ",
  "All Transactions": "ប្រតិបត្តិការទាំងអស់",
  "Transactions": "ប្រតិបត្តិការ",
  "Select amount to topup": "ជ្រើសចំនួនបន្ថែមប្រាក់",
  "Balance": "សមតុល្យ",
  "You've just paid": "អ្នកបានបង់ប្រាក់រួចរាល់",
  "Need help?": "ត្រូវការជំនួយ?",
  "24-Hour Careline Number": "លេខទំនាក់ទំនង ២៤ ម៉ោង",
  "Email Us": "ផ្ញើអ៊ីមែលមកយើង",
  "Call Now": "ហៅឥឡូវនេះ",
  "Email Now": "ផ្ញើអ៊ីមែលឥឡូវនេះ",
  "Update name": "ធ្វើបច្ចុប្បន្នភាពឈ្មោះ",
  "Update email address": "ធ្វើបច្ចុប្បន្នភាពអាសយដ្ឋានអ៊ីមែល",
  "Update phone number": "ធ្វើបច្ចុប្បន្នភាពលេខទូរស័ព្ទ",
  "Change password": "ផ្លាស់ប្ដូរពាក្យសម្ងាត់",
  "Change language": "ផ្លាស់ប្ដូរភាសា",
  "User ID": "អត្តសញ្ញាណអ្នកប្រើ",
  "Let us know your feedback": "ប្រាប់យើងអំពីមតិរបស់អ្នក",
  "Poor": "ខ្សោយ",
  "Good": "ល្អ",
  "Leave addtional feedback here (optional)": "ទុកមតិបន្ថែមនៅទីនេះ (ជាជម្រើស)",
  "Submit feedback": "ដាក់ស្នើមតិ",
  "Pay as guest": "បង់ជាអ្នកភ្ញៀវ",
  "Pay now": "បង់ឥឡូវនេះ",
  "Select voucher to use": "ជ្រើសវូឌ័រដើម្បីប្រើ",
  "Use voucher": "ប្រើវូឌ័រ",
  "Total": "សរុប",
  "Transaction Type": "ប្រភេទប្រតិបត្តិការ",
  "E-Token Topup": "បន្ថែមអ៊ី-ទូកិន",
  "Credit Topup": "បន្ថែមឥណទាន",
  "Credit topup": "បន្ថែមឥណទាន",
  "Credit Transfer": "ផ្ទេរឥណទាន",
  "E-Token Transfer": "ផ្ទេរ​អ៊ី-ទូកិន",
  "Date/Time": "កាលបរិច្ឆេទ/ម៉ោង",
  "Reference ID": "អត្តសញ្ញាណយោង",
  "Status": "ស្ថានភាព",
  "Share Your Referral Code": "ចែករំលែកកូដឱ្យមិត្ត",
  "Use": "ប្រើ",
  "dryer or washer": "ម៉ាស៊ីនស្ងួតឬម៉ាស៊ីនបោក",
  "washer": "ម៉ាស៊ីនបោក",
  "dryer": "ម៉ាស៊ីនស្ងួត",
  "dryer and washer": "ម៉ាស៊ីនស្ងួត និង ម៉ាស៊ីនបោក",
  "machine with the minimum spending of": "ម៉ាស៊ីនដែលត្រូវមានការចំណាយអប្បបរមា",
  "Payment Confirmation": "ការបញ្ជាក់ការទូទាត់",
  "This campaign is only eligible for users who use the all-new Cleanpro Plus web application.": "យុទ្ធនាការនេះសម្រាប់អ្នកប្រើដែលប្រើកម្មវិធី Cleanpro Plus វែបថ្មីប៉ុណ្ណោះ។",
  "ONE e-stamp will be rewarded for each wash or dry cycle.": "អ្នកនឹងទទួលបានស្លាបព្រីងអេឡិចត្រូនិចមួយសម្រាប់មួយវដ្តបោកឬស្ងួត។",
  "ONE e-stamp will be rewarded for each wash cycle.": "អ្នកនឹងទទួលបានស្លាបព្រីងអេឡិចត្រូនិចមួយសម្រាប់មួយវដ្តបោក។",
  "ONE e-stamp will be rewarded for each dry cycle.": "អ្នកនឹងទទួលបានស្លាបព្រីងអេឡិចត្រូនិចមួយសម្រាប់មួយវដ្តស្ងួត។",
  "Regardless of the washer or dryer settings, the number of e-stamps being collected is the same.": "មិនថាការកំណត់ម៉ាស៊ីនបោក ឬម៉ាស៊ីនស្ងួតយ៉ាងណា ចំនួនស្លាបព្រីងអេឡិចត្រូនិចដែលប្រមូលបានគឺដូចគ្នា។",
  "The type of e-stamp collected is based on the services that you have used.": "ប្រភេទស្លាបព្រីងអេឡិចត្រូនិចដែលប្រមូលបានអាស្រ័យលើសេវាកម្មដែលអ្នកបានប្រើ។",
  "Washing service will reward washer e-stamp and drying service will reward dryer e-stamp.": "សេវាបោកនឹងផ្តល់ស្លាបព្រីងម៉ាស៊ីនបោក ហើយសេវាស្ងួតនឹងផ្តល់ស្លាបព្រីងម៉ាស៊ីនស្ងួត។",
  "Washing service will reward washer e-stamp.": "សេវាបោកនឹងផ្តល់ស្លាបព្រីងម៉ាស៊ីនបោក។",
  "Drying service will reward dryer e-stamp.": "សេវាស្ងួតនឹងផ្តល់ស្លាបព្រីងម៉ាស៊ីនស្ងួត។",
  "E-stamps will automatically be added to your account once the condition has been fulfilled.": "ស្លាបព្រីងអេឡិចត្រូនិចនឹងត្រូវបញ្ចូលទៅក្នុងគណនីរបស់អ្នកដោយស្វ័យប្រវត្តិ ពេលដែលលក្ខខណ្ឌបានបំពេញ។",
  "There is no limit on how many e-stamps can be gathered in a single day. So long as you meet the requirements to collect the e-stamps.": "មិនមានកំណត់ចំនួនស្លាបព្រីងអេឡិចត្រូនិចដែលអាចប្រមូលបានក្នុងមួយថ្ងៃ។ ត្រឹមតែអ្នកបំពេញលក្ខខណ្ឌសម្រាប់ប្រមូលស្លាបព្រីង។",
  "The type of e-stamps that have been collected is final and cannot be changed.": "ប្រភេទស្លាបព្រីងអេឡិចត្រូនិចដែលបានប្រមូលគឺចុងក្រោយ និងមិនអាចផ្លាស់ប្តូរ។",
  "There is no expiration for the e-stamps; only till the discontinuation of the campaign.": "ស្លាបព្រីងអេឡិចត្រូនិចមិនមានកំណត់ថ្ងៃផុតកំណត់ទេ; គឺមានតែដល់ពេលបញ្ឈប់យុទ្ធនាការ។",
  "E-stamps do not have any currency value, and they cannot be converted to cash or credits.": "ស្លាបព្រីងអេឡិចត្រូនិចមិនមានតម្លៃជាហិរញ្ញវត្ថុ ហើយមិនអាចបម្លែងទៅប្រាក់សុទ្ធ ឬឥណទានបានទេ។",
  "This campaign is not applicable with any other ongoing promotions, offers, vouchers, and/or discounts provided by the participating outlets.": "យុទ្ធនាការនេះមិនអាចប្រើជាមួយការផ្សព្វផ្សាយ ផ្តល់ជូន វូឌ័រ និង/ឬការបញ្ចុះតម្លៃផ្សេងទៀតនៅស្ថានីយ៍ដែលចូលរួមបាន។",
  "These terms and conditions are subject to change at any time without prior notice.": "លក្ខខណ្ឌទាំងនេះអាចផ្លាស់ប្តូរណាមួយពេលណាក៏បាន ដោយគ្មានការជូនដំណឹងមុន។",
  "Press START on the machine to begin washing.": "ចុចប៊ូតុង START លើម៉ាស៊ីនដើម្បីចាប់ផ្តើមបោក។",
  "Press START on the machine to begin drying.": "ចុចប៊ូតុង START លើម៉ាស៊ីនដើម្បីចាប់ផ្តើមស្ងួត។",
  "Reminder": "ការរំលឹក",
  "Remember to select the same settings you have paid for on the corresponding machine.": "ចងចាំជ្រើសការកំណត់ដូចគ្នាដែលអ្នកបានបង់លើម៉ាស៊ីននោះ។",
  "Please ensure that your laundry is inside the machine and door is properly shut.": "សូមប្រាកដថាសម្លៀកបំពាក់របស់អ្នកនៅក្នុងម៉ាស៊ីន ហើយទ្វារបិទបានត្រឹមត្រូវ។",
  "voucherCreditsOff_one": "{{currentVoucherAmount}} ឥណទានបញ្ចុះ",
  "voucherCreditsOff_other": "{{currentVoucherAmount}} ឥណទានបញ្ចុះ",
  "voucherPercentageOff": "{{currentVoucherAmount}}% បញ្ចុះតម្លៃ",
  "cleanproReferralFlatVoucher_one": "ទទួលឥណទានដោយឥតគិតថ្លៃពេលអ្នកចែករំលែកកូដ Cleanpro Plus របស់អ្នកទៅមិត្ត និងគ្រួសារ! សម្រាប់មិត្តរាប់ម្នាក់ដែលធ្វើប្រតិបត្តិការដំបូងបានជោគជ័យ អ្នកនឹងទទួលបានវូឌ័រឥណទាន {{ referralVoucherAmount }}។",
  "cleanproReferralFlatVoucher_other": "ទទួលឥណទានដោយឥតគិតថ្លៃពេលអ្នកចែករំលែកកូដ Cleanpro Plus របស់អ្នកទៅមិត្ត និងគ្រួសារ! សម្រាប់មិត្តរាប់ម្នាក់ដែលធ្វើប្រតិបត្តិការដំបូងបានជោគជ័យ អ្នកនឹងទទួលបានវូឌ័រឥណទាន {{ referralVoucherAmount }}។",
  "cleanproReferralRateVoucher": "ទទួលឥណទានដោយឥតគិតថ្លៃពេលអ្នកចែករំលែកកូដ Cleanpro Plus របស់អ្នកទៅមិត្ត និងគ្រួសារ! សម្រាប់មិត្តរាប់ម្នាក់ដែលធ្វើប្រតិបត្តិការដំបូងបានជោគជ័យ អ្នកនឹងទទួលបានវូឌ័រ {{ referralVoucherAmount }}% បញ្ចុះតម្លៃ។",
  "cleanproReferralTokenReward_one": "ទទួលឥណទានដោយឥតគិតថ្លៃពេលអ្នកចែករំលែកកូដ Cleanpro Plus របស់អ្នកទៅមិត្ត និងគ្រួសារ! សម្រាប់មិត្តរាប់ម្នាក់ដែលធ្វើប្រតិបត្តិការដំបូងបានជោគជ័យ អ្នកនឹងទទួលបាន {{ referralToken }} ឥណទាន។",
  "cleanproReferralTokenReward_other": "ទទួលឥណទានដោយឥតគិតថ្លៃពេលអ្នកចែករំលែកកូដ Cleanpro Plus របស់អ្នកទៅមិត្ត និងគ្រួសារ! សម្រាប់មិត្តរាប់ម្នាក់ដែលធ្វើប្រតិបត្តិការដំបូងបានជោគជ័យ អ្នកនឹងទទួលបាន {{ referralToken }} ឥណទាន។",
  "How to get & use code:": "របៀបទទួល និងប្រើកូដ៖",
  "Go to menu = icon and click “Refer friends”": "ចូលទៅម៉ឺនុយ = រូបតំណាង ហើយចុច “ផ្តល់អនុសាសន៍មិត្ត”",
  "Share with everyone who will likely to use Cleanpro Plus.": "ចែករំលែកទៅអ្នកដែលមានសក្តានុពលប្រើ Cleanpro Plus។",
  "Referral Terms & Conditions:": "លក្ខខណ្ឌនៃការផ្តល់អនុសាសន៍៖",
  "When your friend or family register using your referral code, and completed a transaction (a minimum spending of {{ currency }}{{ referralTransactionAmount }}) , you will be rewarded automatically.": "ពេលមិត្ត ឬគ្រួសាររបស់អ្នកចុះឈ្មោះដោយប្រើកូដផ្តល់អនុសាសន៍របស់អ្នក ហើយបានធ្វើប្រតិបត្តិការដោយចំណាយអប្បបរមា {{ currency }}{{ referralTransactionAmount }} អ្នកនឹងទទួលរង្វាន់ដោយស្វ័យប្រវត្តិ។",
  "cleanproNumberOfReferralReward": "អ្នកអាចចែករំលែកជាមួយមនុស្សបានច្រើនប៉ុណ្ណាដែលអ្នកចង់បាន ប៉ុន្តែមនុស្សម្នាក់នឹងទទួលបាន {{ numberOfReferral }} ការផ្តល់ជូនដោយយោងតែម្ដង។",
  "cleanproNumberOfReferral_one": "អ្នកអាចចែករំលែកជាមួយមនុស្សបានច្រើនប៉ុណ្ណាដែលអ្នកចង់បាន ប៉ុន្តែមនុស្សម្នាក់នឹងទទួលបាន {{ numberOfReferral }} វាវឺឆ័រដោយយោងតែម្ដង។",
  "cleanproNumberOfReferral_other": "អ្នកអាចចែករំលែកជាមួយមនុស្សបានច្រើនប៉ុណ្ណាដែលអ្នកចង់បាន ប៉ុន្តែមនុស្សម្នាក់នឹងទទួលបាន {{ numberOfReferral }} វាវឺឆ័រដោយយោង។",
  "The voucher is valid for {{ duration }} days from the day voucher be given._one": "វាវឺឆ័រនេះមានសុពលភាពរយៈពេល {{ duration }} ថ្ងៃ ចាប់ពីថ្ងៃដែលផ្តល់វាវឺឆ័រ។",
  "The voucher is valid for {{ duration }} days from the day voucher be given._other": "វាវឺឆ័រនេះមានសុពលភាពរយៈពេល {{ duration }} ថ្ងៃ ចាប់ពីថ្ងៃដែលផ្តល់វាវឺឆ័រ។",
  "The voucher is for customer use only and not for sale.": "វាវឺឆ័រនេះមានសម្រាប់អ្នកប្រើប្រាស់តែប៉ុណ្ណោះ ហើយមិនអាចលក់បានទេ។",
  "We believe that your special day deserves a little extra sparkle! That's why we're thrilled to introduce our exclusive birthday rewards program just for you! Starting this year, and every year thereafter, we're giving away {{ currency }}{{ voucherAmount }} credit vouchers to you on your birthday.": "យើងជឿជាក់ថា ថ្ងៃពិសេសរបស់អ្នកគួរតែទទួលបានភាពចំរូងបន្តិច! ដូចនេះយើងខ្ញុំមានមោទនភាពក្នុងការណែនាំកម្មវិធីរង្វាន់ថ្ងៃកំណើតពិសេសសម្រាប់អ្នកតែម្ដង! ចាប់ពីឆ្នាំនេះ និងរៀងរាល់ឆ្នាំក្រោយ យើងខ្ញុំនឹងផ្តល់វាវឺឆ័រក្រេឌីត {{ currency }}{{ voucherAmount }} ជូនអ្នកនៅថ្ងៃកំណើតរបស់អ្នក។",
  "cleanproBirthdayRateAmount": "យើងជឿជាក់ថា ថ្ងៃពិសេសរបស់អ្នកគួរតែទទួលបានភាពចំរូងបន្តិច! ដូចនេះយើងខ្ញុំមានមោទនភាពក្នុងការណែនាំកម្មវិធីរង្វាន់ថ្ងៃកំណើតពិសេសសម្រាប់អ្នកតែម្ដង! ចាប់ពីឆ្នាំនេះ និងរៀងរាល់ឆ្នាំក្រោយ យើងខ្ញុំនឹងផ្តល់វាវឺឆ័រ {{ voucherAmount }}% ជូនអ្នកនៅថ្ងៃកំណើតរបស់អ្នក។",
  "Make sure your account details include your birthdate. This way, we'll know exactly when to send you your special birthday surprise.": "សូមធ្វើឱ្យប្រាកដថា ព័ត៌មានគណនីរបស់អ្នកមានថ្ងៃកំណើតរបស់អ្នក។ ដូចនេះ យើងនឹងដឹងពេលដែលត្រូវផ្ញើរភាពភ្ញាក់ផ្អើលពិសេសក្នុងថ្ងៃកំណើតរបស់អ្នក។",
  "Birthday Voucher Terms & Conditions:": "លក្ខខណ្ឌនៃវាវឺឆ័រថ្ងៃកំណើត៖",
  "The voucher will be given on the first day of your birthday month.": "វាវឺឆ័រនឹងត្រូវផ្តល់នៅថ្ងៃដំបូងនៃខែដែលអ្នកមានថ្ងៃកំណើត។",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount._one": "ពេលអ្នកប្រើវាវឺឆ័រនៅពេលទូទាត់ វានឹងផ្តល់អ្នកនូវ {{ voucherAmount }} ក្រេឌីត ({{ currency }}{{ voucherAmount }}) ជាថយ។",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }} credits ({{ currency }}{{ voucherAmount }}) discount._other": "ពេលអ្នកប្រើវាវឺឆ័រនៅពេលទូទាត់ វានឹងផ្តល់អ្នកនូវ {{ voucherAmount }} ក្រេឌីត ({{ currency }}{{ voucherAmount }}) ជាថយ។",
  "When you applied the voucher during payment, it will give you {{ voucherAmount }}% discount.": "ពេលអ្នកប្រើវាវឺឆ័រនៅពេលទូទាត់ វានឹងផ្តល់អ្នកនូវ {{ voucherAmount }}% បញ្ចុះតម្លៃ។",
  "All vouchers is not valid with other ongoing promotions, discounts and offers.": "វាវឺឆ័រទាំងអស់នេះមិនអាចប្រើបានជាមួយការផ្សព្វផ្សាយ បញ្ចុះតម្លៃ និងជំពូកផ្សេងៗទេ។",
  "Claim a complimentary wash and dry for every 10 e-stamps collected! We value your loyalty and want to reward you for choosing Cleanpro Plus. Tap to learn more.": "ទទួលបានការលាងសំអាត និងស្ងួតឥតគិតថ្លៃសម្រាប់រាល់ e-stamp 10 ដុំដែលបានប្រមូល! យើងមានការគាំទ្រការភ្ជាប់ខ្ពស់របស់អ្នក និងចង់ផ្តល់រង្វាន់សម្រាប់ការជ្រើសរើស Cleanpro Plus។ ចុចដើម្បីស្វែងយល់បន្ថែម។",
  "cleanproStampFlat_one": "សម្រាប់រាល់ e-stamp 10 ដុំដែលអ្នកបានប្រមូល អ្នកអាចទទួលបានវាវឺឆ័រ {{ voucherAmount }} ក្រេឌីតសម្រាប់ការលាងសំអាតឬស្ងួតដោយឥតគិតថ្លៃជាមួយ Cleanpro Plus។ ធ្វើឲ្យការលាងបោកអនឡាញរបស់អ្នក មិនមែនគ្រាន់តែរលូនប៉ុណ្ណោះ ប៉ុន្តែមានរង្វាន់ផងដែរ។",
  "cleanproStampFlat_other": "សម្រាប់រាល់ e-stamp 10 ដុំដែលអ្នកបានប្រមូល អ្នកអាចទទួលបានវាវឺឆ័រ {{ voucherAmount }} ក្រេឌីតសម្រាប់ការលាងសំអាតឬស្ងួតដោយឥតគិតថ្លៃជាមួយ Cleanpro Plus។ ធ្វើឲ្យការលាងបោកអនឡាញរបស់អ្នក មិនមែនគ្រាន់តែរលូនប៉ុណ្ណោះ ប៉ុន្តែមានរង្វាន់ផងដែរ។",
  "cleanproStampRate": "សម្រាប់រាល់ e-stamp 10 ដុំដែលអ្នកបានប្រមូល អ្នកអាចទទួលបាន {{ voucherAmount }}% នៃការលាងសំអាតឬស្ងួតដោយឥតគិតថ្លៃជាមួយ Cleanpro Plus។ ធ្វើឲ្យការលាងបោកអនឡាញរបស់អ្នក មិនមែនគ្រាន់តែរលូនប៉ុណ្ណោះ ប៉ុន្តែមានរង្វាន់ផងដែរ។",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "វាវឺឆ័រមួយនឹងត្រូវបន្ថែមភ្លាមទៅទំព័រ Rewards របស់អ្នកនៅពេលអ្នកបំពេញការលាង 10 ដង។ ម៉ែត្ររបស់ e-stamp នឹងត្រូវស្ដារតម្លៃទៅសូន្យសម្រាប់ការប្រមូលលើកក្រោយ។ ទាមទារវាវឺឆ័រនៅទំព័រ Scan QR នៅពេលអ្នកបោកបោរបន្ទាប់។",
  "A voucher will be instantly added to your Rewards page when you reach 10 drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "វាវឺឆ័រមួយនឹងត្រូវបន្ថែមភ្លាមទៅទំព័រ Rewards របស់អ្នកនៅពេលអ្នកស្ងួត 10 ដង។ ម៉ែត្ររបស់ e-stamp នឹងត្រូវស្ដារតម្លៃទៅសូន្យសម្រាប់ការប្រមូលលើកក្រោយ។ ទាមទារវាវឺឆ័រនៅទំព័រ Scan QR នៅពេលអ្នកបោកបោរបន្ទាប់។",
  "A voucher will be instantly added to your Rewards page when you reach 10 washes or drys. Your e-stamp meter will be restored to zero for the next collection. Claim the voucher in the Scan QR page when you do your next laundry.": "វាវឺឆ័រមួយនឹងត្រូវបន្ថែមភ្លាមទៅទំព័រ Rewards របស់អ្នកនៅពេលអ្នកលាង 10 ដង ឬស្ងួត 10 ដង។ ម៉ែត្ររបស់ e-stamp នឹងត្រូវស្ដារតម្លៃទៅសូន្យសម្រាប់ការប្រមូលលើកក្រោយ។ ទាមទារវាវឺឆ័រនៅទំព័រ Scan QR នៅពេលអ្នកបោកបោរបន្ទាប់។",
  "Terms & Conditions:": "លក្ខខណ្ឌ និងលទ្ធភាព:",
  "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session._one": "ដើម្បីទទួល e-stamp មួយ អ្នកត្រូវចំណាយយ៉ាងតិច {{ stampTransactionAmount }} ក្រេឌីត ({{ currency }}{{ stampTransactionAmount }}) ក្នុងមួយសម័យ។",
  "To earn ONE e-stamp, you must spend at least {{ stampTransactionAmount }} credits ({{ currency }}{{ stampTransactionAmount }}) per session._other": "ដើម្បីទទួល e-stamp មួយ អ្នកត្រូវចំណាយយ៉ាងតិច {{ stampTransactionAmount }} ក្រេឌីត ({{ currency }}{{ stampTransactionAmount }}) ក្នុងមួយសម័យ។",
  "You will be automatically issued a voucher if you have collected 10 washer stamps.": "អ្នកនឹងទទួលបានវាវឺឆ័រដោយស្វ័យប្រវត្តិ ប្រសិនបើអ្នកបានប្រមូល e-stamp លាង 10 ដុំ។",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps.": "អ្នកនឹងទទួលបានវាវឺឆ័រដោយស្វ័យប្រវត្តិ ប្រសិនបើអ្នកបានប្រមូល e-stamp ស្ងួត 10 ដុំ។",
  "You will be automatically issued a voucher if you have collected 10 dryer stamps or 10 washer stamps.": "អ្នកនឹងទទួលបានវាវឺឆ័រដោយស្វ័យប្រវត្តិ ប្រសិនបើអ្នកបានប្រមូល e-stamp ស្ងួត 10 ដុំ ឬ e-stamp លាង 10 ដុំ។",
  "You will be automatically issued a voucher if you have collected 10 stamps.": "អ្នកនឹងទទួលបានវាវឺឆ័រដោយស្វ័យប្រវត្តិ ប្រសិនបើអ្នកបានប្រមូល e-stamp 10 ដុំ។",
  "The voucher is non-refundable and cannot be exchanged for cash; in part or in full.": "វាវឺឆ័រនេះមិនអាចសងប្រាក់វិញ និងមិនអាចបម្លែងទៅជាថវិកាប្រាក់សុទ្ធបានទេ; ទាំងមួយឬផ្នែកណាមួយ។",
  "This voucher is valid for single transaction only.": "វាវឺឆ័រនេះមានសុពលភាពសម្រាប់ប្រតិបត្តិការតែមួយតែប៉ុណ្ណោះ។",
  "General questions": "សំណួរទូទៅ",
  "E-stamps collection": "ការប្រមូល E-stamps",
  "Coin exchange machines": "ម៉ាស៊ីនប្តូរកាក់",
  "Washer machines": "ម៉ាស៊ីនលាង",
  "Dryer machines": "ម៉ាស៊ីនស្ងួត",
  "Paywave issues": "បញ្ហា Paywave",
  "Cleanpro franchise": "ហ្វ្រេនឈា Cleanpro",
  "How can I wash my laundry using Cleanpro Plus?": "តើខ្ញុំអាចលាងបោកបោរប្រើ Cleanpro Plus បានយ៉ាងដូចម្តេច?",
  "Here are the steps to wash your laundry using Cleanpro Plus:": "នេះជាជំហានក្នុងការលាងបោកបោររបស់អ្នកដោយប្រើ Cleanpro Plus៖",
  "Find an unoccupied washing machine in the store, and insert your laundry in the washer.": "សូមស្វែងរកម៉ាស៊ីនលាងដែលទំនេរនៅក្នុងហាង ហើយដាក់បោកបោររបស់អ្នកចូលក្នុងម៉ាស៊ីន។",
  "Select the desired temperature that you would like to use for your laundry.": "ជ្រើសសីតុណ្ហភាពដែលអ្នកចង់ប្រើសម្រាប់បោកបោររបស់អ្នក។",
  "Using the scanner in the app, scan the QR code provided on the washing machine. Then select the same settings that you have pressed on the machine.": "ប្រើស្កែននៅក្នុងកម្មវិធី ស្កែនកូដ QR ដែលផ្តល់នៅលើម៉ាស៊ីនលាង។ បន្ទាប់មកជ្រើសការកំណត់ដូចគ្នាដែលអ្នកបានចុចនៅលើម៉ាស៊ីន។",
  "Tap on “Pay with credits” to pay the amount shown on the app.": "ចុច “បង់ប្រាក់ជាមួយក្រេឌីត” ដើម្បីបង់ប្រាក់ចំនួនដែលបង្ហាញនៅក្នុងកម្មវិធី។",
  "Once the payment has been accepted, press the START button on the washer machine.": "ពេលដែលការទូទាត់ត្រូវទទួល សូមចុចប៊ូតុង START នៅលើម៉ាស៊ីនលាង។",
  "After the washing cycle ends, you can just remove your laundry from the machine.": "បន្ទាប់ពីសៀគ្វីលាងបោកបោរបញ្ចប់ អ្នកអាចយកបោកបោរចេញពីម៉ាស៊ីនបាន។",
  "How can I dry my laundry using Cleanpro Plus?": "តើខ្ញុំអាចស្ងួតបោកបោរប្រើ Cleanpro Plus បានយ៉ាងដូចម្តេច?",
  "Here are the steps to dry your laundry using Cleanpro Plus:": "នេះជាជំហានក្នុងការស្ងួតបោកបោររបស់អ្នកដោយប្រើ Cleanpro Plus៖",
  "Find an unoccupied drying machine in the store, and insert your laundry in the dryer.": "សូមស្វែងរកម៉ាស៊ីនស្ងួតដែលទំនេរនៅក្នុងហាង ហើយដាក់បោកបោររបស់អ្នកចូលក្នុងម៉ាស៊ីនស្ងួត។",
  "Select the desired temperature and duration that you would like to use for your laundry.": "ជ្រើសសីតុណ្ហភាព និងរយៈពេលដែលអ្នកចង់ប្រើសម្រាប់បោកបោររបស់អ្នក។",
  "Using the scanner in the app, scan the QR code provided on the drying machine. Then select the same settings that you have pressed on the machine.": "ប្រើស្កែននៅក្នុងកម្មវិធី ស្កែនកូដ QR ដែលផ្តល់នៅលើម៉ាស៊ីនស្ងួត។ បន្ទាប់មកជ្រើសការកំណត់ដូចគ្នាដែលអ្នកបានចុចនៅលើម៉ាស៊ីន។",
  "Once the payment has been accepted, press the START button on the dryer machine.": "ពេលដែលការទូទាត់ត្រូវទទួល សូមចុចប៊ូតុង START នៅលើម៉ាស៊ីនស្ងួត។",
  "After the drying cycle ends, you can just remove your laundry from the machine.": "បន្ទាប់ពីសៀគ្វីស្ងួតបញ្ចប់ អ្នកអាចយកបោកបោរចេញពីម៉ាស៊ីនបាន។",
  "Why does the QR code I scanned take me to a different machine?": "ហេតុអ្វីបានជាកូដ QR ដែលខ្ញុំស្កែនយកទៅម៉ាស៊ីនផ្សេង?",
  "Here are the steps to solve it:": "នេះជាជំហានដើម្បីដោះស្រាយ៖",
  "Make sure that the number on the QR code (e.g. W1, W2, etc) is the same as the machine that you would like to use.": "ប្រាកដថាចំនួនលើកូដ QR (ឧ. W1, W2…) គឺដូចគ្នានឹងម៉ាស៊ីនដែលអ្នកចង់ប្រើ។",
  "If the QR code number does not match the machine you want, use the other machine. Please contact our customer service line at 03-27700100 to report this issue.": "បើលេខកូដ QR មិនត្រូវនឹងម៉ាស៊ីនដែលអ្នកចង់ប្រើ សូមប្រើម៉ាស៊ីនផ្សេង។ សូមទាក់ទងសេវាកម្មអតិថិជនតាមលេខ 03-27700100 ដើម្បីរាយការណ៍បញ្ហានេះ។",
  "How can I add more time to the washer that I am currently using?": "តើខ្ញុំអាចបន្ថែមពេលលាងបោកដែលកំពុងប្រើបានយ៉ាងដូចម្តេច?",
  "The washing time for our washer is fixed and cannot add any additional time.": "រយៈពេលលាងសំអាតសម្រាប់ម៉ាស៊ីនលាងរបស់យើងត្រូវកំណត់ហើយមិនអាចបន្ថែមពេលបានទេ។",
  "How can I add more time to the dryer that I am currently using?": "តើខ្ញុំអាចបន្ថែមពេលស្ងួតដែលកំពុងប្រើបានយ៉ាងដូចម្តេច?",
  "Here are the steps to add more time to the dryer machine:": "នេះជាជំហានក្នុងការបន្ថែមពេលស្ងួត៖",
  "By using the scanner in the app, scan the QR code provided at the dryer machine.": "ប្រើស្កែននៅក្នុងកម្មវិធី ស្កែនកូដ QR ដែលផ្តល់នៅម៉ាស៊ីនស្ងួត។",
  "Select the amount of time that you would like to add to the machine.": "ជ្រើសរយៈពេលដែលអ្នកចង់បន្ថែមទៅម៉ាស៊ីន។",
  "After the drying cycle ends, you can just remove the clothes from the machine.": "បន្ទាប់ពីសៀគ្វីស្ងួតបញ្ចប់ អ្នកអាចយកសំលៀកបំពាក់ចេញពីម៉ាស៊ីនបាន។",
  "REMINDER - It is recommended to add drying time 5 minutes before the cycle ends. And you cannot add tokens for extra times when the machine finishes the drying cycle.": "រំលឹក - ផ្ដល់អនុសាសន៍ឲ្យបន្ថែមពេលស្ងួត 5 នាទី មុនសៀគ្វីបញ្ចប់។ អ្នកមិនអាចបន្ថែមកាក់សម្រាប់ពេលបន្ថែមបានទេ បន្ទាប់ពីម៉ាស៊ីនបញ្ចប់សៀគ្វីស្ងួត។",
  "Will the timer keep running when I have stopped the drying machine?": "តើម៉ោងនឹងបន្តដំណើរការបើខ្ញុំបានបញ្ឈប់ម៉ាស៊ីនស្ងួត?",
  "Yes. Even after you stop the machine, the timer will continue to run. If you want to extend the drying time, add drying time 5 minutes before the cycle ends. This prevents the cycle from ending before your clothes are completely dried.": "បាទ/ចាស។ បើទោះបីអ្នកបញ្ឈប់ម៉ាស៊ីន ក៏ម៉ោងនឹងបន្តដំណើរការ។ ប្រសិនបើអ្នកចង់បន្ថែមពេលស្ងួត សូមបន្ថែម 5 នាទី មុនសៀគ្វីបញ្ចប់ ដើម្បីមិនឲ្យសៀគ្វីបញ្ចប់មុនសំលៀកបំពាក់របស់អ្នកស្ងួតពេញលេញ។",
  "How do I reload my credits for Cleanpro Plus?": "តើខ្ញុំអាចបញ្ចូលក្រេឌីតឡើងវិញសម្រាប់ Cleanpro Plus បានយ៉ាងដូចម្តេច?",
  "Here are the steps to reload your credits:": "នេះជាជំហានក្នុងការបញ្ចូលក្រេឌីតឡើងវិញ៖",
  "Select the \"Top Up Credit\" button on the homepage.": "ជ្រើសប៊ូតុង “Top Up Credit” នៅលើទំព័រដើម។",
  "Choose the amount you want to reload and the payment method you want to use.": "ជ្រើសចំនួនដែលអ្នកចង់បញ្ចូលឡើងវិញ និងវិធីទូទាត់ដែលអ្នកចង់ប្រើ។",
  "You will be taken to the payment page. The screen will return to Cleanpro Plus once the transaction is completed.": "អ្នកនឹងត្រូវនាំទៅទំព័រទូទាត់។ អេក្រង់នឹងត្រឡប់ទៅ Cleanpro Plus ពេលការទូទាត់បានបញ្ចប់។",
  "How many credits can I reload in one transaction?": "តើខ្ញុំអាចបញ្ចូលក្រេឌីតប៉ុន្មានក្នុងមួយប្រតិបត្តិការបាន?",
  "Reloading credits requires a minimum of RM 10 and a maximum of RM 50.": "ការបញ្ចូលក្រេឌីតត្រូវការយ៉ាងតិច RM 10 និងយ៉ាងអតិបរមា RM 50។",
  "Can I pay using credits in the Cleanpro Plus app along with tokens or coins in a single transaction?": "តើខ្ញុំអាចបង់ប្រាក់ដោយប្រើក្រេឌីតក្នុងកម្មវិធី Cleanpro Plus រួមជាមួយកាក់ឬសាច់ប្រាក់ក្នុងប្រតិបត្តិការតែមួយបានទេ?",
  "No. Only a single payment method may be chosen when performing any transactions.": "ទេ។ អ្នកអាចជ្រើសវិធីទូទាត់តែមួយពេលធ្វើប្រតិបត្តិការណាមួយ។",
  "The amount I have reloaded in my account was not reflected in the app.": "ចំនួនក្រេឌីតដែលខ្ញុំបានបញ្ចូលក្នុងគណនី មិនបង្ហាញនៅក្នុងកម្មវិធីទេ។",
  "Please close and restart the application and check if the new balance has been updated.": "សូមបិទ និងចាប់ផ្តើមកម្មវិធីឡើងវិញ ហើយពិនិត្យមើលថាតើសមតុល្យថ្មីបានបន្ថែមរួចឬនៅ។",
  "If the amount is still not updated, please contact our customer service line at 03-27700110 to receive further assistance.": "បើចំនួនក្រេឌីតមិនទាន់បានធ្វើបច្ចុប្បន្នភាព សូមទាក់ទងសេវាកម្មអតិថិជនតាមលេខ 03-27700110 ដើម្បីទទួលជំនួយបន្ថែម។",
  "Can I cash out the credits I reloaded in my account for this app?": "តើខ្ញុំអាចដោះក្រេឌីតដែលបានបញ្ចូលក្នុងគណនីសម្រាប់កម្មវិធីនេះចេញជាថវិកាប្រាក់បានទេ?",
  "No. The credits that you have reloaded will remain in your Cleanpro Plus account.": "ទេ។ ក្រេឌីតដែលអ្នកបានបញ្ចូលនឹងនៅក្នុងគណនី Cleanpro Plus របស់អ្នក។",
  "I have requested a refund, but I still have not received it.": "ខ្ញុំបានស្នើសុំការសងប្រាក់វិញ ប៉ុន្តែខ្ញុំមិនទាន់ទទួលបានទេ។",
  "Please contact our customer service line at 03-27700100 to receive further assistance.": "សូមទាក់ទងសេវាកម្មអតិថិជនតាមលេខ 03-27700100 ដើម្បីទទួលជំនួយបន្ថែម។",
  "I have made the payment, and the app double or triple charged me.": "ខ្ញុំបានបង់ប្រាក់ ហើយកម្មវិធីបានគិតប្រាក់ខ្ញុំពីរឬបីដង។",
  "The washing machine cannot start even after I have paid using the app.": "ម៉ាស៊ីនលាងមិនអាចចាប់ផ្តើមទេ ទោះបីខ្ញុំបានបង់ប្រាក់ដោយប្រើកម្មវិធីរួចហើយ។",
  "Ensure that the temperature settings you have selected and paid for on the application are the same as what you have pressed on the washing machine. If not, select the correct temperature settings on the washing machine and try again.": "ប្រាកដថាការកំណត់សីតុណ្ហភាពដែលអ្នកបានជ្រើស និងបានបង់នៅក្នុងកម្មវិធី គឺដូចគ្នានឹងការចុចនៅលើម៉ាស៊ីនលាង។ បើមិនដូចគ្នា សូមជ្រើសការកំណត់សីតុណ្ហភាពត្រឹមត្រូវនៅលើម៉ាស៊ីន ហើយព្យាយាមម្តងទៀត។",
  "If the machine is still not able to be started, please contact our customer service line at 03-27700100 to receive further assistance.": "បើម៉ាស៊ីននៅតែមិនអាចចាប់ផ្តើមបាន សូមទាក់ទងសេវាកម្មអតិថិជនតាមលេខ 03-27700100 ដើម្បីទទួលជំនួយបន្ថែម។",
  "Can I use multiple vouchers together in the same washing or drying cycle?": "តើខ្ញុំអាចប្រើកាដូប៊ូណ៍ច្រើនក្នុងសៀគ្វីលាងឬស្ងួតតែមួយបានទេ?",
  "No. Only a single voucher can be used for each washing and drying cycle.": "ទេ។ តែប៊ូណ៍មួយត្រូវប្រើសម្រាប់សៀគ្វីលាងឬស្ងួតមួយតែប៉ុណ្ណោះ។",
  "Why can't I use my free wash voucher that I received after signing up?": "ហេតុអ្វីបានជាខ្ញុំមិនអាចប្រើប៊ូណ៍លាងឥតគិតថ្លៃដែលបានទទួលបន្ទាប់ពីចុះឈ្មោះបានទេ?",
  "To redeem or use the voucher, you must complete at least one washing or drying cycle.": "ដើម្បីប្រើប៊ូណ៍ អ្នកត្រូវបញ្ចប់សៀគ្វីលាង ឬស្ងួតយ៉ាងហោចណាស់មួយដង។",
  "Can I change my phone number even after registering my account?": "តើខ្ញុំអាចផ្លាស់លេខទូរស័ព្ទបន្ទាប់ពីចុះឈ្មោះគណនីរួចបានទេ?",
  "No. Once registered to an account, the phone number is locked into the account.": "ទេ។ បន្ទាប់ពីចុះឈ្មោះលេខទូរស័ព្ទនឹងត្រូវចាក់ចូលក្នុងគណនី ហើយមិនអាចផ្លាស់បានទេ។",
  "I have problems in the store, and who can I refer to for help?": "ខ្ញុំមានបញ្ហានៅក្នុងហាង តើខ្ញុំអាចយោងទៅអ្នកណាដើម្បីជួយបាន?",
  "Do not worry, as you can contact our customer service line at 03-27700100 to receive assistance at any time.": "កុំបារម្ភ ទេ អ្នកអាចទាក់ទងសេវាកម្មអតិថិជនតាមលេខ 03-27700100 ដើម្បីទទួលជំនួយគ្រប់ពេល។",
  "Should I add my own laundry detergent and softeners to the washing machine?": "តើខ្ញុំត្រូវបន្ថែមសាប៊ូបោក និងសូលផឺរបស់ខ្លួនឯងទៅម៉ាស៊ីនលាងទេ?",
  "There is no need for that, as all you have to do is bring your dirty clothes and put them in the washer. The detergent and softeners will be provided by us, and you can rest assured that the laundry detergents we used are certified industrial grade.": "មិនចាំបាច់ទេ អ្នកត្រឹមតែយកសំលៀកបំពាក់ចាស់មក និងដាក់ក្នុងម៉ាស៊ីន។ សាប៊ូ និងសូលផឺនឹងមានផ្តល់ដោយយើង ហើយអ្នកអាចទុកចិត្តបានថាសាប៊ូបោកដែលយើងប្រើមានវិញ្ញាបនបត្រថាមានគុណភាពឧស្សាហកម្ម។",
  "I would like to add my own laundry detergent and softener to the washing machine.": "ខ្ញុំចង់បន្ថែមសាប៊ូបោក និងសូលផឺររបស់ខ្លួនទៅម៉ាស៊ីនលាង។",
  "We do not recommend our customers add their own detergent, as the mixture of different detergents may affect the wash quality. And you can rest assured that the laundry detergent we used is certified industrial grade.": "យើងមិនផ្ដល់អនុសាសន៍ឲ្យអតិថិជនបន្ថែមសាប៊ូផ្ទាល់ខ្លួនទេ ព្រោះការលាយសាប៊ូផ្សេងៗគ្នាអាចប៉ះពាល់ដល់គុណភាពបោក។ ហើយអ្នកអាចទុកចិត្តបានថាសាប៊ូបោកដែលយើងប្រើមានវិញ្ញាបនបត្រថាមានគុណភាពឧស្សាហកម្ម។",
  "What time does the store close?": "ហាងបិទម៉ោងប៉ុន្មាន?",
  "Our self-service laundry operation is open 24 hours a day, which means you can always be sure to go back home with a fresh set of laundry.": "សេវាបោកខោអាវដោយខ្លួនឯងរបស់យើងបើក 24 ម៉ោងក្នុងមួយថ្ងៃ ដែលមានន័យថាអ្នកអាចប្រាកដថានឹងត្រឡប់ទៅផ្ទះជាមួយសំលៀកបំពាក់ស្អាត។",
  "Are you open on weekends?": "តើអ្នកបើកនៅចុងសប្តាហ៍ទេ?",
  "Yes. Cleanpro is also open on weekends and even on public holidays.": "បាទ/ចាស។ Cleanpro បើកនៅចុងសប្តាហ៍ និងនៅថ្ងៃឈប់សម្រាកផ្លូវការផងដែរ។",
  "How many clothes can I fit in the washing or drying machine?": "តើខ្ញុំអាចដាក់សំលៀកបំពាក់ប៉ុន្មានក្នុងម៉ាស៊ីនលាងឬស្ងួត?",
  "To ensure that your laundry is properly washed or dried, keep the amount of laundry inside the machine lower than the line of guide sticker on the machine.": "ដើម្បីធានាថាសំលៀកបំពាក់ត្រូវបានលាងឬស្ងួតបានត្រឹមត្រូវ សូមរក្សាចំនួនសំលៀកបំពាក់នៅក្នុងម៉ាស៊ីនក្រោមខ្សែបង្ហាញលើស្លាកណែនាំ។",
  "How many e-stamps can I collect in a single day?": "តើខ្ញុំអាចប្រមូលស្លាកអេឡិចត្រូនិកប៉ុន្មានក្នុងមួយថ្ងៃ?",
  "There is no limit to the amount of stamps that can be collected in a single day; ONE stamp will be awarded with every wash or dry.": "មិនមានកំណត់ចំនួនស្លាកដែលអាចប្រមូលបានក្នុងមួយថ្ងៃទេ; ស្លាក 1 ត្រូវផ្តល់ក្នុងរាល់សៀគ្វីលាងឬស្ងួត។",
  "When I use the washing service, can I change the collected stamp to a dryer stamp, and vice versa?": "ពេលខ្ញុំប្រើសេវាលាងខោអាវ តើខ្ញុំអាចបម្លែងស្លាកដែលប្រមូលបានទៅស្លាកស្ងួត និងវិញបានទេ?",
  "No, the type of stamp collected is only applied to the service that you have used.": "ទេ។ ប្រភេទស្លាកដែលប្រមូលបាន ត្រូវអនុវត្តត្រឹមសេវាដែលអ្នកបានប្រើ។",
  "What temperatures can I choose when I claim the free washing e-stamp reward?": "តើខ្ញុំអាចជ្រើសសីតុណ្ហភាពប៉ុន្មានពេលទទួលរង្វាន់ស្លាកអេឡិចត្រូនិកលាងឥតគិតថ្លៃ?",
  "Any washing temperature is available for the e-stamp reward.": "សីតុណ្ហភាពលាងណាមួយអាចប្រើសម្រាប់រង្វាន់ស្លាកអេឡិចត្រូនិក។",
  "What temperatures can I choose when I claim the free drying e-stamp reward? And how long can I set the time?": "តើខ្ញុំអាចជ្រើសសីតុណ្ហភាពប៉ុន្មានពេលទទួលរង្វាន់ស្លាកអេឡិចត្រូនិកស្ងួតឥតគិតថ្លៃ? ហើយអាចកំណត់រយៈពេលប៉ុន្មាន?",
  "Any drying temperature and duration can be selected for the e-stamp reward.": "សីតុណ្ហភាព និងរយៈពេលស្ងួតណាមួយអាចជ្រើសសម្រាប់រង្វាន់ស្លាកអេឡិចត្រូនិក។",
  "I'm unable to change the coin.": "ខ្ញុំមិនអាចផ្លាស់កាក់បាន។",
  "What colour is the light shown on the machine, red or green? If it is a red light, please contact our customer service line at 03-27700100 to receive further assistance.": "ពន្លឺលើម៉ាស៊ីនមានពណ៌អ្វី, ក្រហម ឬ បៃតង? បើពន្លឺក្រហម សូមទាក់ទងសេវាកម្មអតិថិជនតាមលេខ 03-27700100 ដើម្បីទទួលជំនួយបន្ថែម។",
  "Green Light": "ពន្លឺបៃតង",
  "Red Light": "ពន្លឺក្រហម",
  "Machine functions as normal. Please try again.": "ម៉ាស៊ីនដំណើរការប្រក្រតី។ សូមព្យាយាមម្តងទៀត។",
  "(flashing 2x) - There are no coins/tokens in the machine.": "(ភ្លឺ 2 ដង) - មិនមានកាក់/Token នៅក្នុងម៉ាស៊ីន។",
  "OR": "ឬ",
  "Note is jammed, please proceed to contact customer service": "កំណត់សម្គាល់ត្រូវផ្អាក សូមទាក់ទងសេវាកម្មអតិថិជន",
  "(flashing 3x) - Note is jammed, please proceed to contact customer service": "(ភ្លឺ 3 ដង) - កំណត់សម្គាល់ត្រូវផ្អាក សូមទាក់ទងសេវាកម្មអតិថិជន",
  "My notes are stuck in the machine.": "កំណត់សម្គាល់របស់ខ្ញុំដាច់នៅក្នុងម៉ាស៊ីន។",
  "My detergent is not dispensing in the vending machine.": "សាប៊ូរបស់ខ្ញុំមិនចេញពីម៉ាស៊ីនដាក់សាប៊ូ។",
  "The water is leaking out of the washing machine.": "ទឹករលកចេញពីម៉ាស៊ីនលាង។",
  "Please check the washer machine to see whether there are any clothes that are stuck at the door side.": "សូមពិនិត្យម៉ាស៊ីនលាង មើលថាតើមានសំលៀកបំពាក់ណាដែលរុញនៅចំហៀងទ្វារមែនទេ។",
  "If yes, here are the steps to solve it:": "បើមាន នេះជាជំហានដើម្បីដោះស្រាយ៖",
  "Press the emergency stop button (RED Button) for 3 seconds.": "ចុចប៊ូតុងបញ្ឈប់បន្ទាន់ (ប៊ូតុងក្រហម) រយៈពេល 3 វិនាទី។",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at 03-27700100 to receive further assistance)": "រង់ចាំសំឡេងឲ្យឈប់ ហើយបើកទ្វារបន្ទាប់បន្ទាន់តែប៉ុណ្ណោះ។ (បើ 30 នាទីហើយសំឡេងនៅមិនឈប់ សូមទាក់ទងសេវាកម្មអតិថិជន 03-27700100 ដើម្បីទទួលជំនួយបន្ថែម)",
  "Ensure the door is closed tightly, and press the START button.": "ប្រាកដថាទ្វារបិទរឹង ហើយចុចប៊ូតុង START។",
  "REMINDER - The emergency stop button can only be used once.": "រំលឹក - ប៊ូតុងបញ្ឈប់បន្ទាន់អាចប្រើបានតែម្ដងតែប៉ុណ្ណោះ។",
  "There is no detergent dispensing in the washing machine.": "មិនមានសាប៊ូចេញនៅក្នុងម៉ាស៊ីនលាង។",
  "Ensure that the machine is in operation and that the START button was pressed.": "ប្រាកដថាម៉ាស៊ីនកំពុងដំណើរការ និងបានចុចប៊ូតុង START។",
  "If the detergent is still not dispensing, please contact our customer service department at 03-27700100 for further assistance.": "បើសាប៊ូនៅតែមិនចេញ សូមទាក់ទងនាយកដ្ឋានសេវាកម្មអតិថិជន 03-27700100 ដើម្បីទទួលជំនួយបន្ថែម។",
  "The price displayed on the machine's screen did not change after inserting the token.": "តម្លៃបង្ហាញលើអេក្រង់ម៉ាស៊ីនមិនបានផ្លាស់ប្តូរបន្ទាប់ពីដាក់ token។",
  "Press the small button (in the centre) to reject the tokens that have been inserted. Press a few times till the coins come out.": "ចុចប៊ូតុងតូច (នៅកណ្តាល) ដើម្បីច្រាន token ដែលបានដាក់។ ចុចច្រើនដងរហូតកាក់ចេញ។",
  "If the coins still cannot come out or the button is not functioning, please contact our customer service line at 03-27700110 to receive further assistance.": "បើកាក់នៅតែមិនចេញ ឬប៊ូតុងមិនដំណើរការ សូមទាក់ទងសេវាកម្មអតិថិជន 03-27700110 ដើម្បីទទួលជំនួយបន្ថែម។",
  "The machine is not starting, and it displays an error code.": "ម៉ាស៊ីនមិនចាប់ផ្តើម ហើយបង្ហាញកូដកំហុស។",
  "We would like to apologise for any inconvenience caused. Please contact our customer service line at 03-27700100 to receive further assistance.": "យើងសូមអភ័យទោសចំពោះអាសន្នភាពណាមួយ។ សូមទាក់ទងសេវាកម្មអតិថិជន 03-27700100 ដើម្បីទទួលជំនួយបន្ថែម។",
  "I want to wash the clothes again, but why couldn't the machine start even after I added tokens to the machine?": "ខ្ញុំចង់លាងសំលៀកបំពាក់ម្តងទៀត តែហេតុអ្វីម៉ាស៊ីនមិនចាប់ផ្តើម បើទោះបីខ្ញុំបានដាក់ token។",
  "Try opening and closing the door again before starting the machine.": "សូមព្យាយាមបើក និងបិទទ្វារឡើងវិញ មុនចាប់ផ្តើមម៉ាស៊ីន។",
  "Can I change the water temperature of the machine?": "តើខ្ញុំអាចផ្លាស់ប្តូរសីតុណ្ហភាពទឹកនៅម៉ាស៊ីនបានទេ?",
  "Yes, but the washer temperature can only be changed from hot to cold after the machine has been started, and not from cold to hot.": "បាទ/ចាស ប៉ុន្តែសីតុណ្ហភាពម៉ាស៊ីនលាងអាចផ្លាស់ពីក្តៅទៅត្រជាក់ប៉ុណ្ណោះ បន្ទាប់ពីម៉ាស៊ីនចាប់ផ្តើម ហើយមិនអាចផ្លាស់ពីត្រជាក់ទៅក្តៅបានទេ។",
  "Can I stop the machine?": "តើខ្ញុំអាចបញ្ឈប់ម៉ាស៊ីនបានទេ?",
  "Here are the steps to stop the machine:": "នេះជាជំហានក្នុងការបញ្ឈប់ម៉ាស៊ីន៖",
  "Wait for the sound to stop, and then only open the door. (If after 30 minutes the sound still has not stopped, please contact our customer service line at to receive further assistance)": "រង់ចាំសំឡេងឲ្យឈប់ ហើយបើកទ្វារតែបន្ទាប់។ (បើ 30 នាទីហើយសំឡេងនៅមិនឈប់ សូមទាក់ទងសេវាកម្មអតិថិជន ដើម្បីទទួលជំនួយបន្ថែម)",
  "There is no water supply on the machine used.": "មិនមានការផ្គត់ផ្គង់ទឹកនៅម៉ាស៊ីនដែលប្រើ។",
  "Why is the washing temperature cold even when I have selected HOT.": "ហេតុអ្វីសីតុណ្ហភាពលាងទឹកត្រជាក់ បើទោះបីខ្ញុំបានជ្រើសក្តៅ?",
  "The water temperature is HOT or WARM only during washing. The water will turn COLD during rinsing.": "សីតុណ្ហភាពទឹកគឺក្តៅ ឬកំដៅសូម្បីតែប៉ុណ្ណោះក្នុងពេលលាង។ ទឹកនឹងត្រជាក់ពេលសម្អាត។",
  "The machine has already finished washing, but it does not spin well, and there is water left on the load.": "ម៉ាស៊ីនបានបញ្ចប់ការលាងរួច ហើយមិនបង្វិលល្អទេ ទឹកនៅសល់លើសំលៀកបំពាក់។",
  "Can I put wet laundry into the dryer to dry?": "តើខ្ញុំអាចដាក់សំលៀកបំពាក់សើមទៅម៉ាស៊ីនស្ងួតដើម្បីស្ងួតបានទេ?",
  "No, as the dripping wet laundry might cause the dryer to short circuit.": "ទេ សំលៀកបំពាក់សើមអាចបណ្តាលឲ្យម៉ាស៊ីនស្ងួតខូច។",
  "REMINDER - Refer to the labels on your clothes to know what kind of temperature is best for the kind of fabric that it uses. Then select the temperature on the machine accordingly.": "រំលឹក - មើលស្លាកលើសំលៀកបំពាក់ ដើម្បីដឹងថាសីតុណ្ហភាពណាសមស្របសម្រាប់វត្ថុធាតុដែលប្រើ។ បន្ទាប់ជ្រើសសីតុណ្ហភាពនៅម៉ាស៊ីនតាមលក្ខខណ្ឌ។",
  "My clothes are still wet even after drying.": "សំលៀកបំពាក់របស់ខ្ញុំនៅតែសើម បន្ទាប់ពីស្ងួត។",
  "How can I stop the dryer when the machine is still running?": "តើខ្ញុំអាចបញ្ឈប់ម៉ាស៊ីនស្ងួតបើម៉ាស៊ីននៅតែដំណើរការបានយ៉ាងដូចម្តេច?",
  "Just open the door and the machine will automatically stop.": "គ្រាន់តែបើកទ្វារ ហើយម៉ាស៊ីននឹងបញ្ឈប់ដោយស្វ័យប្រវត្តិ។",
  "I added extra tokens for extra times, but the machine did not update the time.": "ខ្ញុំបានដាក់ token បន្ថែមសម្រាប់ពេលបន្ថែម ប៉ុន្តែម៉ាស៊ីនមិនធ្វើបច្ចុប្បន្នភាពពេលទេ។",
  "For the time to be reflected accurately, it is recommended for you to add tokens 5 minutes before the services end.": "ដើម្បីឲ្យពេលបង្ហាញបានត្រឹមត្រូវ គួរដាក់ token 5 នាទីមុនសេវាបញ្ចប់។",
  "REMINDER - You cannot add tokens for extra times when the machine finishes the drying cycle.": "រំលឹក - អ្នកមិនអាចដាក់ token សម្រាប់ពេលបន្ថែមបើម៉ាស៊ីនបញ្ចប់សៀគ្វីស្ងួត។",
  "Why is the machine making noise?": "ហេតុអ្វីម៉ាស៊ីនមានសំឡេងរំខាន?",
  "Please check the drum to see if there are any coins or other small things inside.": "សូមពិនិត្យ drum មើលថាតើមានកាក់ ឬវត្ថុតូចផ្សេងៗនៅក្នុងទេ។",
  "I have pressed the START button on the dryer, but it is still not working.": "ខ្ញុំបានចុចប៊ូតុង START នៅម៉ាស៊ីនស្ងួត ប៉ុន្តែមិនដំណើរការ។",
  "Please try to open the door and close it again. Next, press the START button again to start drying.": "សូមព្យាយាមបើកទ្វារ និងបិទឡើងវិញ បន្ទាប់មកចុច START ម្តងទៀតដើម្បីចាប់ផ្តើមស្ងួត។",
  "If the dryer is still not functioning, please contact our customer service line at 03-27700100 to receive further assistance.": "បើម៉ាស៊ីនស្ងួតនៅតែមិនដំណើរការ សូមទាក់ទងសេវាកម្មអតិថិជន 03-27700100 ដើម្បីទទួលជំនួយបន្ថែម។",
  "Paywave has deducted an amount from the card but the machine did not reflect the transaction.": "Paywave បានកាត់ប្រាក់ពីកាត ប៉ុន្តែម៉ាស៊ីនមិនបង្ហាញប្រតិបត្តិការ។",
  "The Paywave transaction has failed but the amount has still been deducted from my card.": "ប្រតិបត្តិការរបស់ Paywave បរាជ័យ ប៉ុន្តែក៏ត្រូវបានកាត់ប្រាក់ពីកាតរបស់ខ្ញុំ។",
  "Paywave has double/triple charge but the machine cannot start.": "Paywave បានគិតទឹកប្រាក់ពីរឬបីដង ប៉ុន្តែម៉ាស៊ីនមិនចាប់ផ្តើម។",
  "Paywave after double/triple charge machines can't start.": "បន្ទាប់ពី Paywave គិតទឹកប្រាក់ពីរឬបីដង ម៉ាស៊ីនមិនចាប់ផ្តើម។",
  "Paywave is offline": "Paywave អត់តភ្ជាប់អ៊ីនធឺណិត",
  "Do Cleanpro Express offer franchise business/selling machines/laundry products?": "តើ Cleanpro Express ផ្តល់ជាកម្មវិធីហ្វ្រេនឆាយ ឬលក់ម៉ាស៊ីន/ផលិតផលបោកខោអាវទេ?",
  "For further inquiries, please email to info@cleanproexpress.com": "សម្រាប់សំណួរបន្ថែម សូមអ៊ីមែលទៅ info@cleanproexpress.com",
  "Step 6": "ជំហាន 6",
  "User Existed": "អ្នកប្រើមានរួចហើយ",
  "This email is registered": "អ៊ីមែលនេះបានចុះឈ្មោះរួចហើយ",
  "This phone number is registered": "លេខទូរស័ព្ទនេះបានចុះឈ្មោះរួចហើយ",
  "Invalid Email Address": "អាសយដ្ឋានអ៊ីមែលមិនត្រឹមត្រូវ",
  "Let's get started!": "ចាប់ផ្តើមគ្នា!",
  "Enter your e-mail/mobile number": "បញ្ចូលអ៊ីមែល/លេខទូរស័ព្ទ",
  "Enter your e-mail": "បញ្ចូលអ៊ីមែល",
  "Enter your mobile number": "បញ្ចូលលេខទូរស័ព្ទ",
  "Enter your e-mail address": "បញ្ចូលអាសយដ្ឋានអ៊ីមែល",
  "Proceed": "បន្ត",
  "Enter OTP number": "បញ្ចូលលេខ OTP",
  "You will receive a six-digit OTP via SMS sent to": "អ្នកនឹងទទួល OTP ៦ ខ្ទង់តាម SMS ផ្ញើទៅ",
  "You will receive a six-digit OTP via e-mail sent to": "អ្នកនឹងទទួល OTP ៦ ខ្ទង់តាមអ៊ីមែល ផ្ញើទៅ",
  "Verify": "ផ្ទៀងផ្ទាត់",
  "Resend OTP": "ផ្ញើ OTP ម្តងទៀត",
  "Welcome onboard!": "សូមស្វាគមន៍ចូលរួម!",
  "Please fill in the info below": "សូមបំពេញព័ត៌មានខាងក្រោម",
  "Enter your name*": "បញ្ចូលឈ្មោះរបស់អ្នក*",
  "Enter your email address*": "បញ្ចូលអាសយដ្ឋានអ៊ីមែលរបស់អ្នក*",
  "Please enter either phone number or email address": "សូមបញ្ចូលលេខទូរស័ព្ទ ឬអ៊ីមែលមួយ",
  "Create a password*": "បង្កើតពាក្យសម្ងាត់*",
  "Enter referral code (if got any)": "បញ្ចូលកូដណែនាំ (បើមាន)",
  "Get started": "ចាប់ផ្តើម",
  "Birthday updated successfully": "ថ្ងៃកំណើតបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ",
  "Date of birth": "ថ្ងៃខែឆ្នាំកំណើត",
  "Enter your date of birth": "បញ្ចូលថ្ងៃខែឆ្នាំកំណើតរបស់អ្នក",
  "Select your birth date": "ជ្រើសថ្ងៃខែឆ្នាំកំណើត",
  "Update date of birth": "ធ្វើបច្ចុប្បន្នភាពថ្ងៃខែឆ្នាំកំណើត",
  "Update birth date": "ធ្វើបច្ចុប្បន្នភាពថ្ងៃកំណើត",
  "Already have an account?": "មានគណនីរួចហើយ?",
  "Login now": "ចូលឥឡូវនេះ",
  "Sign in": "ចូល",
  "Sign up now": "ចុះឈ្មោះឥឡូវនេះ",
  "COMPLETED": "បានបញ្ចប់",
  "WASHING NOW": "កំពុងលាង",
  "DRYING NOW": "កំពុងស្ងួត",
  "It's done!": "បានរួចរាល់!",
  "Please collect your fresh, clean laundry in order to leave the machine available for the next person to use!": "សូមយកសំលៀកបំពាក់ស្អាតរបស់អ្នក ដើម្បីឲ្យម៉ាស៊ីនអាចប្រើបានសម្រាប់អ្នកបន្ទាប់!",
  "Leave a feedback": "ទុកមតិ",
  "Time left": "ពេលនៅសល់",
  "Add drying time": "បន្ថែមពេលស្ងួត",
  "Hi": "សួស្តី",
  "customer": "អតិថិជន",
  "Thank you for your payment. Don't forget to select the <b>correct temperature</b> and press <b>START</b> when you're ready.": "អរគុណសម្រាប់ការទូទាត់។ កុំភ្លេចជ្រើស <b>សីតុណ្ហភាពត្រឹមត្រូវ</b> ហើយចុច <b>START</b> ពេលអ្នករួចរាល់។",
  "Select how you want to receive a notification when your laundry is finished": "ជ្រើសរបៀបដែលអ្នកចង់ទទួលការជូនដំណឹងពេលសំលៀកបំពាក់រួចរាល់",
  "Sign up": "ចុះឈ្មោះ",
  "Continue to pay": "បន្តទូទាត់",
  "Register as a member to enjoy more benefits!": "ចុះឈ្មោះជាសមាជិក ដើម្បីទទួលអត្ថប្រយោជន៍ច្រើនជាងមុន!",
  "Get FREE {{ voucherAmount }} credits per new user_one": "ទទួល {{ voucherAmount }} ពិន្ទុឥតគិតថ្លៃសម្រាប់អ្នកប្រើថ្មី",
  "Get FREE {{ voucherAmount }} credits per new user_other": "ទទួល {{ voucherAmount }} ពិន្ទុឥតគិតថ្លៃសម្រាប់អ្នកប្រើថ្មី",
  "Get FREE {{ voucherAmount }}% per new user": "ទទួល {{ voucherAmount }}% ឥតគិតថ្លៃសម្រាប់អ្នកប្រើថ្មី",
  "Enjoy exclusive promotions": "រីករាយជាមួយការផ្សព្វផ្សាយពិសេស",
  "FREE voucher on your birthday": "សំបុត្រឥតគិតថ្លៃនៅថ្ងៃកំណើតរបស់អ្នក",
  "and more": "និងផ្សេងទៀត",
  "Denied camera access": "ការចូលប្រើកាមេរ៉ាត្រូវបានបដិសេធ",
  "Permission to access the camera has been denied. Please try again and click \"Allow\" to scan the QR code.": "ការអនុញ្ញាតចូលកាមេរ៉ាត្រូវបានបដិសេធ។ សូមព្យាយាមម្ដងទៀត ហើយចុច \"អនុញ្ញាត\" ដើម្បីស្កេន QR code។",
  "Okay": "យល់ព្រម",
  "Oops. You don't have enough balance to make the payment": "អូប! អ្នកមិនមានតុល្យភាពគ្រប់គ្រាន់សម្រាប់ទូទាត់",
  "Please confirm": "សូមបញ្ជាក់",
  "Do you want to proceed with this feedback?": "តើអ្នកចង់បន្តជាមួយមតិយោបល់នេះទេ?",
  "Are you sure to purchase": "តើអ្នកប្រាកដថាចង់ទិញ",
  "credits for": "ពិន្ទុសម្រាប់",
  "Topup credit": "បន្ថែមពិន្ទុ",
  "Extended duration will be instantly reflected on machine after payment": "រយៈពេលបន្ថែមនឹងបង្ហាញភ្លាមៗលើម៉ាស៊ីនបន្ទាប់ពីការទូទាត់",
  "Machine is currently busy": "ម៉ាស៊ីនកំពុងរវល់",
  "Do you want to extend drying time?": "តើអ្នកចង់បន្ថែមពេលស្ងួតទេ?",
  "OTHER": "ផ្សេងទៀត",
  "Welcome Voucher": "សំបុត្រស្វាគមន៍",
  "Welcome to the Cleanpro Plus family! This first gift is just the beginning. Stay tuned for a series of exciting promotions and campaigns, exclusively for Cleanpro Plus users.": "សូមស្វាគមន៍មកកាន់គ្រួសារជាមួយ Cleanpro Plus! អំណោយដំបូងនេះគ្រាន់តែជាចំណុចចាប់ផ្តើម។ សូមរង់ចាំការផ្សព្វផ្សាយ និងយុទ្ធនាការចាប់អារម្មណ៍ជាច្រើន សម្រាប់អ្នកប្រើ Cleanpro Plus តែប៉ុណ្ណោះ។",
  "Terms & Conditions": "លក្ខខណ្ឌ និងបញ្ញត្តិ",
  "TERMS AND CONDITIONS": "លក្ខខណ្ឌ និងបញ្ញត្តិ",
  "Welcome Voucher is valid for one-time use only.": "សំបុត្រស្វាគមន៍មានសុពលភាពសម្រាប់ការប្រើម្តងតែមួយ។",
  "There is no minimum spend required for the voucher to be used.": "មិនចាំបាច់មានការចំណាយអប្បបរមាដើម្បីប្រើសំបុត្រ។",
  "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only._one": "សំបុត្រស្វាគមន៍ត្រូវបានបញ្ចូលដោយស្វ័យប្រវត្តិទៅគណនីអ្នកប្រើនៅពេលចុះឈ្មោះលើ Cleanpro Plus ហើយមានសុពលភាព {{ duration }} ថ្ងៃ",
  "Welcome Voucher is auto-credited to the user's account at the point of registration on Cleanpro Plus and valid for {{ duration }} days only._other": "សំបុត្រស្វាគមន៍ត្រូវបានបញ្ចូលដោយស្វ័យប្រវត្តិទៅគណនីអ្នកប្រើនៅពេលចុះឈ្មោះលើ Cleanpro Plus ហើយមានសុពលភាព {{ duration }} ថ្ងៃ",
  "Users are eligible to use their Welcome Voucher AFTER the completion of their first wash or dry cycle using the same Cleanpro Plus account.": "អ្នកប្រើអាចប្រើសំបុត្រស្វាគមន៍ បន្ទាប់ពីបញ្ចប់សិចស៊ីលលាង ឬស្ងួតដំបូងដោយប្រើគណនី Cleanpro Plus ដូចគ្នា។",
  "Welcome Voucher cannot be used together with any ongoing promotions or any other promotional vouchers.": "សំបុត្រស្វាគមន៍មិនអាចប្រើរួមជាមួយការផ្សព្វផ្សាយកំពុងប្រព្រឹត្ត ឬសំបុត្រផ្សព្វផ្សាយផ្សេងទៀត។",
  "The voucher is final and cannot be refunded in form of cash or credit to the user.": "សំបុត្រនេះចុងក្រោយហើយ មិនអាចដកប្រាក់តាមរូបភាពសាច់ប្រាក់ ឬពិន្ទុទៅអ្នកប្រើបានទេ។",
  "Cleanpro reserves the right to change the terms and conditions without prior notice.": "Cleanpro សំរាប់អំណាចផ្លាស់ប្តូរលក្ខខណ្ឌដោយមិនបានជូនដំណឹងជាមុន។",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})_one": "ប្រមូល e-stamp 10 ដើម្បីទទួលសំបុត្រពិន្ទុឥតគិតថ្លៃ {{ voucherAmount }} (មានតម្លៃ {{ currency }}{{ voucherAmount }})",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }})_other": "ប្រមូល e-stamp 10 ដើម្បីទទួលសំបុត្រពិន្ទុឥតគិតថ្លៃ {{ voucherAmount }} (មានតម្លៃ {{ currency }}{{ voucherAmount }})",
  "Collect 10 e-stamps to earn FREE {{ voucherAmount }}% voucher (worth {{ voucherAmount }}%)": "ប្រមូល e-stamp 10 ដើម្បីទទួលសំបុត្រឥតគិតថ្លៃ {{ voucherAmount }}% (មានតម្លៃ {{ voucherAmount }}%)",
  "Collect 10 e-Stamp to earn FREE Voucher": "ប្រមូល e-stamp 10 ដើម្បីទទួលសំបុត្រឥតគិតថ្លៃ",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding._one": "ជាមួយ e-stamp 10 ដែលអ្នកប្រមូល អ្នកនឹងទទួលសំបុត្រពិន្ទុឥតគិតថ្លៃ {{ voucherAmount }} (មានតម្លៃ {{ currency }}{{ voucherAmount }}). ធ្វើឲ្យប្រតិបត្តិការលាងសំលៀកបំពាក់របស់អ្នកងាយស្រួល និងមានរង្វាន់។",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }} credits voucher (worth {{ currency }}{{ voucherAmount }}). Make your laundry routine not just hassle-free, but also rewarding._other": "ជាមួយ e-stamp 10 ដែលអ្នកប្រមូល អ្នកនឹងទទួលសំបុត្រពិន្ទុឥតគិតថ្លៃ {{ voucherAmount }} (មានតម្លៃ {{ currency }}{{ voucherAmount }}). ធ្វើឲ្យប្រតិបត្តិការលាងសំលៀកបំពាក់របស់អ្នកងាយស្រួល និងមានរង្វាន់។",
  "With every 10 e-stamps that you collected, you will be rewarded with a FREE {{ voucherAmount }}% credits voucher (worth {{ voucherAmount }}%). Make your laundry routine not just hassle-free, but also rewarding.": "ជាមួយ e-stamp 10 ដែលអ្នកប្រមូល អ្នកនឹងទទួលសំបុត្រឥតគិតថ្លៃ {{ voucherAmount }}% (មានតម្លៃ {{ voucherAmount }}%). ធ្វើឲ្យប្រតិបត្តិការលាងសំលៀកបំពាក់របស់អ្នកងាយស្រួល និងមានរង្វាន់។",
  "RM10 OFF Welcome Voucher": "សំបុត្រស្វាគមន៍ បញ្ចុះតម្លៃ RM10",
  "Welcome to the Cleanpro family, here is an appreciation voucher from us. Thank you for attending the COPE Investors Conference.": "សូមស្វាគមន៍មកកាន់គ្រួសារ Cleanpro, នេះជាសំបុត្រដើម្បីថ្លែងអំណរគុណពីពួកយើង។ អរគុណដែលបានចូលរួមសន្និសីទ COPE Investors។",
  "Welcome Voucher | COPE Investors Conference": "សំបុត្រស្វាគមន៍ | សន្និសីទ COPE Investors",
  "Payment methods": "វិធីសាស្ត្រទូទាត់",
  "Tap to proceed with your preferred mode of payment": "ចុចដើម្បីបន្តជាមួយវិធីទូទាត់ដែលអ្នកចូលចិត្ត",
  "Cleanpro Plus credits": "ពិន្ទុ Cleanpro Plus",
  "E-wallet or credit/debit cards": "កាបូបអេឡិចត្រូនិច ឬកាតឥណទាន/ឥណប័ត្រ",
  "Go to homepage": "ទៅទំព័រដើម",
  // backend response or error
  "Admin is unauthorized to login": "គណនី Admin មិនមានសិទ្ធិចូល",
  "Internal Error": "កំហុសខាងក្នុង",
  "Please enter the correct credentials": "សូមបញ្ចូលព័ត៌មានអត្តសញ្ញាណត្រឹមត្រូវ",
  "Operator not found": "មិនឃើញអ្នកប្រតិបត្តិការ",
  "Admin not found": "មិនឃើញ Admin",
  "Distributor not found": "មិនឃើញអ្នកចែកចាយ",
  "Client not found": "មិនឃើញអតិថិជន",
  "Outlet not found": "មិនឃើញហាង",
  "Token Package not found": "មិនឃើញកញ្ចប់ Token",
  "Top up history not found": "មិនឃើញប្រវត្តិការបញ្ចូលទឹកប្រាក់",
  "Voucher not found": "មិនឃើញសំបុត្រ",
  "Faq not found": "មិនឃើញសំណួរញឹកញាប់",
  "Faq Group not found": "មិនឃើញក្រុមសំណួរញឹកញាប់",
  "News not found": "មិនឃើញព័ត៌មាន",
  "Transaction not found": "មិនឃើញប្រតិបត្តិការ",
  "Please Login Again": "សូមចូលប្រើម្ដងទៀត",
  "Decoding Error": "កំហុសក្នុងការបំលែងកូដ",
  "Some error occured, please contact the dev team if this error continues.": "មានកំហុសកើតឡើង សូមទាក់ទងក្រុមអភិវឌ្ឍន៍ ប្រសិនបើកំហុសនេះបន្ត",
  "Please fill in all the required fields": "សូមបំពេញវាលទាំងអស់ដែលចាំបាច់",
  "Only success transaction can be refund": "អាចត្រឡប់ប្រាក់បានសម្រាប់ប្រតិបត្តិការដែលជោគជ័យប៉ុណ្ណោះ",
  "Only token payment method can be refund": "អាចត្រឡប់ប្រាក់បានសម្រាប់វិធីទូទាត់ Token ប៉ុណ្ណោះ",
  "The discount code has been used, please change to other code": "កូដបញ្ចុះតម្លៃបានប្រើរួច សូមប្រើកូដផ្សេង",
  "Cannot use ewallet in sandbox": "មិនអាចប្រើ e-wallet ក្នុង Sandbox",
  "Please close the door to proceed your payment": "សូមបិទទ្វារដើម្បីបន្តការទូទាត់",
  "Under Maintenance": "កំពុងស្ថិតក្នុងការថែទាំ",
  "This machine is being fixed. Please use another machine.": "ម៉ាស៊ីននេះកំពុងត្រូវបានជួសជុល សូមប្រើម៉ាស៊ីនផ្សេង",
  "Machine is currently running, please try again later": "ម៉ាស៊ីនកំពុងដំណើរការ សូមព្យាយាមនៅពេលក្រោយ",
  "Machine is currently offline, please try again later": "ម៉ាស៊ីនអอฟლაინ សូមព្យាយាមនៅពេលក្រោយ",
  "Outlet not participating in Loyalty program": "ហាងមិនចូលរួមកម្មវិធី Loyalty",
  "Please log in to make the payment": "សូមចូលប្រើដើម្បីទូទាត់",
  "Package not found, please refresh and try again": "មិនឃើញកញ្ចប់ សូមធ្វើការបន្ទាន់សម័យហើយព្យាយាមម្តងទៀត",
  "You have reached the maximum number of purchase": "អ្នកបានឈានដល់កំណត់ទិញអតិបរិមា",
  "Store not found, please try again later": "មិនឃើញហាង សូមព្យាយាមនៅពេលក្រោយ",
  "Incorrect Password": "ពាក្យសម្ងាត់មិនត្រឹមត្រូវ",
  "Token already top up": "Token ត្រូវបានបញ្ចូលរួចហើយ",
  "Payment failed": "ការទូទាត់បរាជ័យ",
  "Transaction Failure": "ប្រតិបត្តិការបរាជ័យ",
  "Transaction Refunded": "ប្រតិបត្តិការត្រូវបានត្រឡប់ប្រាក់",
  "Transaction Pending": "ប្រតិបត្តិការកំពុងរងចាំ",
  "Please enter your mobile number": "សូមបញ្ចូលលេខទូរស័ព្ទ",
  "User is unauthorized to register": "អ្នកប្រើមិនមានសិទ្ធិចុះឈ្មោះ",
  "Please proceed to sign up": "សូមបន្តចុះឈ្មោះ",
  "OTP expired, please request a new OTP": "OTP ផុតកំណត់ សូមស្នើសុំ OTP ថ្មី",
  "Incorrect verification code": "កូដផ្ទៀងផ្ទាត់មិនត្រឹមត្រូវ",
  "This referrer ID is not valid": "Referrer ID នេះមិនត្រឹមត្រូវ",
  "This referrer ID is different operator": "Referrer ID នេះសម្រាប់អ្នកប្រតិបត្តិការផ្សេង",
  "This referrer ID is exceed the limit": "Referrer ID នេះលើសកំណត់",
  "User is unauthorized to login": "អ្នកប្រើមិនមានសិទ្ធិចូល",
  "Click here to register": "ចុចទីនេះដើម្បីចុះឈ្មោះ",
  "User is unauthorized to login. Please contact the admin": "អ្នកប្រើមិនមានសិទ្ធិចូល។ សូមទាក់ទង Admin",
  "User is unauthorized": "អ្នកប្រើមិនមានសិទ្ធិ",
  "This outlet does not participate in the Loyalty Program": "ហាងនេះមិនចូលរួមកម្មវិធី Loyalty",
  "This outlet is not belongs to the operator": "ហាងនេះមិនស្ថិតនៅក្រោមអ្នកប្រតិបត្តិការ",
  "Processing request": "កំពុងដំណើរការសំណើ",
  "This user is not verified": "អ្នកប្រើនេះមិនទាន់ផ្ទៀងផ្ទាត់",
  "Insufficient token to make payment": "Token មិនគ្រប់គ្រាន់សម្រាប់ទូទាត់",
  "Insufficient token to transfer": "Token មិនគ្រប់គ្រាន់សម្រាប់ផ្ទេរ",
  "Insufficient point to make payment": "ពិន្ទុមិនគ្រប់គ្រាន់សម្រាប់ទូទាត់",
  "This voucher is not available for use": "សំបុត្រនេះមិនអាចប្រើបាន",
  "This voucher is belongs to other user": "សំបុត្រនេះសម្រាប់អ្នកប្រើផ្សេង",
  "Invalid Discount Code": "កូដបញ្ចុះតម្លៃមិនត្រឹមត្រូវ",
  "This discount code cannot use in this outlet": "កូដបញ្ចុះតម្លៃនេះមិនអាចប្រើនៅហាងនេះ",
  "This discount code was expired": "កូដបញ្ចុះតម្លៃនេះផុតកំណត់",
  "This discount code cannot use in washer machine transaction": "កូដបញ្ចុះតម្លៃនេះមិនអាចប្រើនៅប្រតិបត្តិការលាង",
  "This discount code cannot use in dryer machine transaction": "កូដបញ្ចុះតម្លៃនេះមិនអាចប្រើនៅប្រតិបត្តិការស្ងួត",
  "This discount code was fully redeemed today, try again tomorrow": "កូដបញ្ចុះតម្លៃនេះបានប្រើពេញថ្ងៃនេះ សូមព្យាយាមថ្ងៃស្អែក",
  "You have fully redeemed this discount code": "អ្នកបានប្រើកូដបញ្ចុះតម្លៃនេះពេញ",
  "This discount code have been redeemed": "កូដបញ្ចុះតម្លៃនេះបានប្រើរួច",
  "This discount code is not applicable": "កូដបញ្ចុះតម្លៃនេះមិនអាចប្រើបាន",
  "Insufficient stamp": "ស្លាកមិនគ្រប់គ្រាន់",
  "Please provide at least one voucher setting": "សូមផ្តល់ការកំណត់សំបុត្រយ៉ាងតិចមួយ",
  "Previous batch are still generating, please try again later": "ក្រុមមុនកំពុងបង្កើត សូមព្យាយាមនៅពេលក្រោយ",
  "Number of voucher code should be more than 0": "ចំនួនកូដសំបុត្រត្រូវតែច្រើនជាង 0",
  "Number of voucher code should be less than 50000": "ចំនួនកូដសំបុត្រត្រូវតែតិចជាង 50000",
  "Number of discount code should be more than 0": "ចំនួនកូដបញ្ចុះតម្លៃត្រូវតែច្រើនជាង 0",
  "Number of discount code should be less than 50000": "ចំនួនកូដបញ្ចុះតម្លៃត្រូវតែតិចជាង 50000",
  "No Item": "មិនមានអ៊ីតម",
  "Please add item": "សូមបន្ថែមអ៊ីតម",
  "Staff not found": "មិនឃើញបុគ្គលិក",
  "This task already completed": "ភារកិច្ចនេះបានបញ្ចប់រួច",
  "Please complete the wash task first": "សូមបញ្ចប់ភារកិច្ចលាងមុន",
  "Please complete the dry task first": "សូមបញ្ចប់ភារកិច្ចស្ងួតមុន",
  "Please select at least one outlet": "សូមជ្រើសហាងយ៉ាងតិចមួយ",
  "Touch to Start": "ចុចដើម្បីចាប់ផ្តើម",
  "New Users": "អ្នកប្រើថ្មី",
  "Get {{ voucher_amount }} FREE Credits!": "ទទួលបាន {{ voucher_amount }} ក្រដាសកាតឥតគិតថ្លៃ!",
  "Get {{ voucher_amount }}% FREE!": "ទទួលបាន {{ voucher_amount }}% ឥតគិតថ្លៃ!",
  "Load your clothes into the washing machine & note the machine number": "ដាក់សម្លៀកបំពាក់របស់អ្នកក្នុងម៉ាស៊ីនបោក និងចំណាំលេខម៉ាស៊ីន",
  "T&C Apply": "មានលក្ខខណ្ឌផ្ទាប់បង្កប់",
  "Mobile Number": "លេខទូរស័ព្ទចល័ត",
  "Member": "សមាជិក",
  "Please enter your mobile phone number / e-mail": "សូមបញ្ចូលលេខទូរស័ព្ទចល័ត / អ៊ីមែល",
  "Please verify your number": "សូមផ្ទៀងផ្ទាត់លេខរបស់អ្នក",
  "Please verify your e-mail": "សូមផ្ទៀងផ្ទាត់អ៊ីមែលរបស់អ្នក",
  "Please enter the correct phone number format. Example: 01xxxxxxxx": "សូមបញ្ចូលលេខទូរស័ព្ទត្រឹមត្រូវ ឧទាហរណ៍: 01xxxxxxxx",
  "Please enter the correct phone number format. Example: 09xxxxxxxx": "សូមបញ្ចូលលេខទូរស័ព្ទត្រឹមត្រូវ ឧទាហរណ៍: 09xxxxxxxx",
  "Scan QR to Complete your signup & access more benefits!": "ស្កែន QR ដើម្បីបញ្ចប់ការចុះឈ្មោះ និងទទួលបានអត្ថប្រយោជន៍បន្ថែម!",
  "Please choose your service": "សូមជ្រើសរើសសេវាកម្មរបស់អ្នក",
  "WASHER": "ម៉ាស៊ីនបោក",
  "DRYER": "ម៉ាស៊ីនស្ងួត",
  "VENDING MACHINE": "ម៉ាស៊ីនលក់",
  "Please tap your card on the reader": "សូមទុកកាតរបស់អ្នកលើឧបករណ៍អាន",
  "Payment Option": "ជម្រើសការទូទាត់",
  "Thank you for payment!": "សូមអរគុណចំពោះការទូទាត់!",
  "Please select your items at the vending machine": "សូមជ្រើសរើសទំនិញនៅម៉ាស៊ីនលក់",
  "Please choose the temperature on the machine and press": "សូមជ្រើសសីតុណ្ហភាពនៅលើម៉ាស៊ីន ហើយចុច",
  "START": "ចាប់ផ្តើម",
  "Need Help?": "ត្រូវការជំនួយ?",
  "Please choose the temperature": "សូមជ្រើសសីតុណ្ហភាព",
  "Confirm Payment": "បញ្ជាក់ការទូទាត់",
  "Select the time for": "ជ្រើសរើសពេលវេលាសម្រាប់",
  "Do you want to add drying time?": "តើអ្នកចង់បន្ថែមពេលវេលាស្ងួតទេ?",
  "minutes": "នាទី",
  "Your machine is": "ម៉ាស៊ីនរបស់អ្នកគឺ",
  "Please Collect your item from the vending machine": "សូមយកទំនិញរបស់អ្នកពីម៉ាស៊ីនលក់",
  "You've earned 1 e-stamp for your wash!": "អ្នកបានទទួល 1 ស្លាកអេឡិចត្រូនិចសម្រាប់ការបោករបស់អ្នក!",
  "You've earned 1 e-stamp for your dry!": "អ្នកបានទទួល 1 ស្លាកអេឡិចត្រូនិចសម្រាប់ការស្ងួតរបស់អ្នក!",
  "You've missed 1 e-stamp for your wash!": "អ្នកបានខកខាន 1 ស្លាកអេឡិចត្រូនិចសម្រាប់ការបោករបស់អ្នក!",
  "You've missed 1 e-stamp for your dry!": "អ្នកបានខកខាន 1 ស្លាកអេឡិចត្រូនិចសម្រាប់ការស្ងួតរបស់អ្នក!",
  "Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "ប្រមូល 10 ស្លាកបោក ដើម្បីទទួលសំបុត្រឥតគិតថ្លៃ {{ amount }} ក្រដាសកាត",
  "Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "ប្រមូល 10 ស្លាកបោក ដើម្បីទទួលសំបុត្រ {{ amount }}%",
  "Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "ប្រមូល 10 ស្លាកស្ងួត ដើម្បីទទួលសំបុត្រឥតគិតថ្លៃ {{ amount }} ក្រដាសកាត",
  "Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "ប្រមូល 10 ស្លាកស្ងួត ដើម្បីទទួលសំបុត្រ {{ amount }}%",
  "Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "ប្រមូល 10 ស្លាកបោក & ស្ងួត ដើម្បីទទួលសំបុត្រឥតគិតថ្លៃ {{ amount }} ក្រដាសកាត",
  "Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "ប្រមូល 10 ស្លាកបោក & ស្ងួត ដើម្បីទទួលសំបុត្រ {{ amount }}%",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn FREE {{ amount }} credits voucher.": "ចុះឈ្មោះ & ប្រមូល 10 ស្លាកបោក & ស្ងួត ដើម្បីទទួលសំបុត្រឥតគិតថ្លៃ {{ amount }} ក្រដាសកាត",
  "Sign Up & Collect 10 e-stamps Wash & Dry to earn a {{ amount }}% voucher.": "ចុះឈ្មោះ & ប្រមូល 10 ស្លាកបោក & ស្ងួត ដើម្បីទទួលសំបុត្រ {{ amount }}%",
  "Sign Up & Collect 10 e-stamps Wash to earn FREE {{ amount }} credits voucher.": "ចុះឈ្មោះ & ប្រមូល 10 ស្លាកបោក ដើម្បីទទួលសំបុត្រឥតគិតថ្លៃ {{ amount }} ក្រដាសកាត",
  "Sign Up & Collect 10 e-stamps Wash to earn a {{ amount }}% voucher.": "ចុះឈ្មោះ & ប្រមូល 10 ស្លាកបោក ដើម្បីទទួលសំបុត្រ {{ amount }}%",
  "Sign Up & Collect 10 e-stamps Dry to earn FREE {{ amount }} credits voucher.": "ចុះឈ្មោះ & ប្រមូល 10 ស្លាកស្ងួត ដើម្បីទទួលសំបុត្រឥតគិតថ្លៃ {{ amount }} ក្រដាសកាត",
  "Sign Up & Collect 10 e-stamps Dry to earn a {{ amount }}% voucher.": "ចុះឈ្មោះ & ប្រមូល 10 ស្លាកស្ងួត ដើម្បីទទួលសំបុត្រ {{ amount }}%",
  "For iOS users, press and hold the image, then choose \"Add to Photos\" or \"Save in Photos\" from the menu.": "សម្រាប់អ្នកប្រើ iOS ចុចហើយកាន់រូបភាព រួចជ្រើស \"បន្ថែមទៅរូបថត\" ឬ \"រក្សាទុកក្នុងរូបថត\" ពីម៉ឺនុយ",
  "Scan the QR code to pay": "ស្កែនកូដ QR ដើម្បីទូទាត់",
  "QR Code expires in {{ countdown }} seconds": "កូដ QR ផុតកំណត់ក្នុង {{ countdown }} វិនាទី",
  "Transfer In": "ផ្ទេរចូល",
  "Migrate": "ផ្ទេរទៅ",
  "Update": "ធ្វើបច្ចុប្បន្នភាព",
  "Transfer Out": "ផ្ទេរចេញ",
  "Total In": "សរុបចូល",
  "Total Out": "សរុបចេញ",
  "Laundry Pass": "ប៉ាស់លាងខោអាវ",
  "Number of wash": "ចំនួនការបោក",
  "Number of Wash": "ចំនួនការបោក",
  "Number of dry": "ចំនួនការស្ងួត",
  "Number of Dry": "ចំនួនការស្ងួត",
  "Laundry Pass Purchase": "ការទិញប៉ាស់លាងខោអាវ",
  "Laundry Pass Purchase Report": "របាយការណ៍ការទិញប៉ាស់លាងខោអាវ",
  "Please select distributor or operator": "សូមជ្រើសអ្នកចែកចាយ ឬ អ្នកប្រតិបត្តិការ",
  "Price should be more than 0": "តម្លៃត្រូវតែច្រើនជាង 0",
  "Number of wash or dry should be more than 0": "ចំនួនការបោក ឬ ស្ងួត ត្រូវតែច្រើនជាង 0",
  "Number of wash should be more than 0": "ចំនួនការបោកត្រូវតែច្រើនជាង 0",
  "Number of dry should be more than 0": "ចំនួនការស្ងួតត្រូវតែច្រើនជាង 0",
  "Duration must be more than 0": "រយៈពេលត្រូវតែច្រើនជាង 0",
  "Please fill in the name": "សូមបំពេញឈ្មោះ",
  "Purchase Start Date": "ថ្ងៃចាប់ផ្តើមទិញ",
  "Purchase End Date": "ថ្ងៃបញ្ចប់ទិញ",
  "Number of Maximum Purchase": "ចំនួនទិញអតិបរិមា",
  "Create Laundry Pass": "បង្កើតប៉ាស់លាងខោអាវ",
  "Select Purchase Period": "ជ្រើសរើសរយៈពេលទិញ",
  "If ticked, the Laundry Pass will have expired date": "បើបានមិនស្លាប, ប៉ាស់លាងខោអាវនឹងមានថ្ងៃផុតកំណត់",
  "Laundry Pass Lifespan": "អាយុកាលប៉ាស់លាងខោអាវ",
  "Edit Laundry Pass": "កែប្រែប៉ាស់លាងខោអាវ",
  "Washer Used Date": "ថ្ងៃប្រើម៉ាស៊ីនបោក",
  "Dryer Used Date": "ថ្ងៃប្រើម៉ាស៊ីនស្ងួត",
  "Laundry Pass Purchase History": "ប្រវត្តិការទិញប៉ាស់លាងខោអាវ",
  "Laundry Pass Usage Report": "របាយការណ៍ប្រើប្រាស់ប៉ាស់លាងខោអាវ",
  "Please Note! (Stacked Dryer)": "សូមកត់សម្គាល់! (ម៉ាស៊ីនស្ងួតច stacked)",
  "Ensure machine is vacant and select correct machine after payment press START": "ធានាម៉ាស៊ីនទំនេរ និងជ្រើសម៉ាស៊ីនត្រឹមត្រូវ បន្ទាប់ពីទូទាត់ ចុច START",
  "Start date": "ថ្ងៃចាប់ផ្តើម",
  "End date": "ថ្ងៃបញ្ចប់",
  "Today": "ថ្ងៃនេះ",
  "Yesterday": "ម្សិលមិញ",
  "Last 7 Days": "7 ថ្ងៃចុងក្រោយ",
  "Last 30 Days": "30 ថ្ងៃចុងក្រោយ",
  "This Month": "ខែនេះ",
  "Last Month": "ខែមុន",
  "Use Per Day": "ប្រើប្រាស់ក្នុងមួយថ្ងៃ",
  "Maximum use per day must be more than 0": "ការប្រើប្រាស់អតិបរិមាក្នុងមួយថ្ងៃត្រូវតែច្រើនជាង 0",
  "Only applicable to selected outlet": "អាចប្រើបានសម្រាប់សាខាត្រូវបានជ្រើស",
  "Applicable to all the outlets except selected outlet": "អាចប្រើបានសម្រាប់គ្រប់សាខ លើកលែងសាខាត្រូវបានជ្រើស",
  "If applicable to all the outlet, leave it blank": "បើអាចប្រើបានសម្រាប់គ្រប់សាខា ទុកទទេ",
  "Only applicable to selected weight": "អាចប្រើបានសម្រាប់ទំងន់ដែលបានជ្រើស",
  "Applicable to all the weight except selected weight": "អាចប្រើបានសម្រាប់គ្រប់ទំងន់ លើកលែងទំងន់ដែលបានជ្រើស",
  "Weight": "ទំងន់",
  "If applicable to all the weight, leave it blank": "បើអាចប្រើបានសម្រាប់គ្រប់ទំងន់ ទុកទទេ",
  "Add Weight": "បន្ថែមទំងន់",
  "Only applicable to selected mode": "អាចប្រើបានសម្រាប់ម៉ូដដែលបានជ្រើស",
  "Applicable to all the modes except selected mode": "អាចប្រើបានសម្រាប់គ្រប់ម៉ូដ លើកលែងម៉ូដដែលបានជ្រើស",
  "If applicable to all the mode, leave it blank": "បើអាចប្រើបានសម្រាប់គ្រប់ម៉ូដ ទុកទទេ",
  "Add Mode": "បន្ថែមម៉ូដ",
  "Laundry Pass not applicable in this outlet": "ប៉ាស់លាងខោអាវមិនអាចប្រើបាននៅសាខានេះ",
  "Discounted price should be more than 0": "តម្លៃបញ្ចុះត្រូវតែច្រើនជាង 0",
  "Discounted Price": "តម្លៃបញ្ចុះ",
  "Logo (Optional)": "ឡូហ្គោ (ជាជម្រើស)",
  "Save": "រក្សាទុក",
  "Cleanpro Laundry Pass": "ប៉ាស់លាងខោអាវ Cleanpro",
  "Save more with the Laundry Pass — ": "សន្សំពេលជាមួយប៉ាស់លាងខោអាវ — ",
  "wash and dry more clothes at a lower price while enjoying extra rewards from Cleanpro Plus!": "បោក និងស្ងួតខោអាវច្រើនជាង តម្លៃទាបជាង ខណៈពេលទទួលបានរង្វាន់បន្ថែមពី Cleanpro Plus!",
  "How to Purchase Laundry Pass": "របៀបទិញប៉ាស់លាងខោអាវ",
  "Step 1: Register as a Cleanpro Plus user.": "ជំហាន 1: ចុះឈ្មោះជាអ្នកប្រើ Cleanpro Plus",
  "Step 2: Choose the Laundry Pass package you wish to purchase.": "ជំហាន 2: ជ្រើសផែនការប៉ាស់លាងខោអាវដែលអ្នកចង់ទិញ",
  "Step 3: Make the payment through Cleanpro Plus.": "ជំហាន 3: ទូទាត់តាម Cleanpro Plus",
  "Step 4: Enjoy washing and drying services at any Cleanpro outlet in Malaysia with exclusive discounted prices!": "ជំហាន 4: រីករាយសេវាបោក និងស្ងួតនៅគ្រប់សាខា Cleanpro នៅម៉ាឡេស៊ី ជាមួយតម្លៃបញ្ចុះពិសេស!",
  "By purchasing and/or using the Cleanpro Laundry Pass, you agree to be bound by the following terms and conditions:": "ដោយការទិញ និង/ឬប្រើប្រាស់ប៉ាស់លាងខោអាវ Cleanpro អ្នកយល់ព្រមអនុវត្តតាមលក្ខខណ្ឌដូចខាងក្រោម៖",
  "Definitions": "និយមន័យ",
  "\"Laundry Pass\" refers to the package(s) for specific laundry services offered by Cleanpro.": "\"ប៉ាស់លាងខោអាវ\" ជាផែនការសេវាបោកខោអាវពិសេសដែលផ្តល់ដោយ Cleanpro",
  "\"Subscriber\" refers to the individual(s) purchasing and/or using the Laundry Pass.": "\"អ្នកជាវ\" ជាបុគ្គលដែលទិញ និង/ឬប្រើប៉ាស់លាងខោអាវ",
  "Pass Description": "ការពិពណ៌នាប៉ាស់",
  "The Laundry Pass is a promotional package that offers laundry services at any Cleanpro outlet in Malaysia.": "ប៉ាស់លាងខោអាវជាផែនការផ្សព្វផ្សាយដែលផ្តល់សេវាបោកខោអាវនៅគ្រប់សាខា Cleanpro ក្នុងម៉ាឡេស៊ី",
  "The Laundry Pass is valid for both Malaysians and non-Malaysians; and is exclusively available to Cleanpro Plus members.": "ប៉ាស់លាងខោអាវអាចប្រើបានសម្រាប់ប្រជាជនម៉ាឡេស៊ី និងមិនមែនម៉ាឡេស៊ី ហើយមានសម្រាប់សមាជិក Cleanpro Plus ប៉ុណ្ណោះ",
  "The campaign of Laundry Pass is valid from": "ការផ្សព្វផ្សាយប៉ាស់លាងខោអាវត្រូវបានអនុវត្តចាប់ពី",
  "1 March 2025 to 31 May 2025.": "១ មីនា ២០២៥ ដល់ ៣១ ឧសភា ២០២៥",
  "Each Laundry Pass subscription is": "ការជាវប៉ាស់លាងខោអាវនីមួយៗ",
  "valid for 30 days from the start date,": "មានសុពលភាព ៣០ ថ្ងៃចាប់ពីថ្ងៃចាប់ផ្តើម",
  "allowing subscribers to use the package": "អនុញ្ញាតឱ្យអ្នកជាវប្រើផែនការ",
  "up to 4 times per day.": "រហូតដល់ ៤ ដងក្នុងមួយថ្ងៃ",
  "During the promotional period, subscribers can repurchase the package unlimited times, but only after fully utilizing your current subscription.": "ក្នុងរយៈពេលផ្សព្វផ្សាយ អ្នកជាវអាចទិញម្តងទៀតបានដោយគ្មានកំណត់ ប៉ុន្តែបន្ទាប់ពីប្រើប្រាស់ការជាវបច្ចុប្បន្នរបស់អ្នករួចហើយ",
  "The Laundry Pass is": "ប៉ាស់លាងខោអាវ",
  "valid only for cold wash and drying of machines under 25kg.": "មានសុពលភាពសម្រាប់បោកទឹកត្រជាក់ និងស្ងួតម៉ាស៊ីនក្រោម 25kg",
  "Additional charges will apply for warm and hot wash services, based on the temperature selected.": "មានកម្រៃបន្ថែមសម្រាប់សេវាបោកក្តៅ និងក្តៅខ្លាំង ដោយផ្អែកលើសីតុណ្ហភាពដែលបានជ្រើស",
  "Unused wash or dry session(s) from the Laundry Pass cannot be carried forward to the next purchase, and are non-refundable, non-exchangeable for cash, and non-transferable.": "វគ្គបោក ឬ ស្ងួតដែលមិនបានប្រើពីប៉ាស់លាងខោអាវមិនអាចផ្ទេរទៅការទិញបន្ទាប់ ហើយមិនអាចត្រឡប់ប្រាក់ មិនអាចប្ដូរជាសាច់ប្រាក់ និងមិនអាចផ្ទេរបាន",
  "The Laundry Pass is valid for washing and/or drying standard laundry items only (e.g., clothing, linens), excluding large items (e.g., rugs), heavily soiled items (e.g., pet bedding), or specialty items requiring special treatment.": "ប៉ាស់លាងខោអាវអាចប្រើសម្រាប់បោក និង/ឬស្ងួតទំនិញស្តង់ដារតែប៉ុណ្ណោះ (ឧ. ខោអាវ កំរាស់កំរាល) មិនរួមបញ្ចូលទំនិញធំនានា (ឧ. កំរាល) ទំនិញកខ្វក់ខ្លាំង (ឧ. គ្រែសត្វ) ឬទំនិញពិសេសដែលត្រូវការព្យាបាលពិសេស",
  "The Laundry Pass can be cancelled within the first 7 days of subscription for a full refund, provided the subscriber has not used the Laundry Pass during this period. No refunds or transfers will be issued after the first 7 days.": "ប៉ាស់លាងខោអាវអាចបោះបង់ក្នុង ៧ ថ្ងៃដំបូងនៃការជាវ ដើម្បីទទួលបានការត្រឡប់ប្រាក់ពេញលេញ ប្រសិនបើអ្នកជាវមិនបានប្រើប៉ាស់លាងខោអាវក្នុងរយៈពេលនេះ។ មិនមានការត្រឡប់ប្រាក់ ឬផ្ទេរនៅក្រោយ ៧ ថ្ងៃដំបូង",
  "Refund process may take up to 21 working days.": "ដំណើរការត្រឡប់ប្រាក់អាចចំណាយរហូតដល់ ២១ ថ្ងៃធ្វើការ",
  "Subscribers are encouraged to regularly check Cleanpro Plus for reminders regarding the expiry date of their laundry pass.": "អ្នកជាវត្រូវបានលើកទឹកចិត្តអោយត្រួតពិនិត្យ Cleanpro Plus ជាប្រចាំសម្រាប់ការជូនដំណឹងអំពីថ្ងៃផុតកំណត់ប៉ាស់លាងខោអាវ",
  "This promotion is not valid in conjunction with the '10 Free 1 e-Stamp Campaign'.": "ការផ្សព្វផ្សាយនេះមិនអាចប្រើបានជាមួយ 'ប្រមូល ១០ ស្លាក ១ e-Stamp' ទេ",
  "Any misuse of the Laundry Pass will result in the immediate termination of the subscription without prior notice. Payments for the Laundry Pass are non-refundable, non-exchangeable for cash, and non-transferable.": "ការប្រើប្រាស់ប៉ាស់លាងខោអាវខុសប្រក្រតី នឹងបណ្តាលអោយការជាវត្រូវបញ្ឈប់ភ្លាមដោយគ្មានការជូនដំណឹង។ ការទូទាត់សម្រាប់ប៉ាស់លាងខោអាវមិនអាចត្រឡប់ប្រាក់ មិនអាចប្ដូរជាសាច់ប្រាក់ និងមិនអាចផ្ទេរបាន",
  "Payment must be made in full at the time of subscription via Cleanpro Plus.": "ត្រូវបង់ប្រាក់ពេញលេញនៅពេលចុះឈ្មោះតាម Cleanpro Plus",
  "For any questions or assistance regarding the Laundry Pass, please email Cleanpro Customer Service at enquiry@cleanpro.asia.": "សម្រាប់សំណួរ ឬជំនួយអំពីប៉ាស់លាងខោអាវ សូមអ៊ីមែលទៅសេវាកម្មអតិថិជន Cleanpro នៅ enquiry@cleanpro.asia",
  "Cleanpro reserves the right to change the terms and conditions at any time without prior notice.": "Cleanpro សន្សំពិទិ្ធភាពក្នុងការផ្លាស់ប្តូរលក្ខខណ្ឌណាមួយគ្រប់ពេល ដោយគ្មានការជូនដំណឹងមុន",
  "Search": "ស្វែងរក",
  "Scan to register as a member": "ស្កែនដើម្បីចុះឈ្មោះជាសមាជិក",
  "Select Product / Key in Amount": "ជ្រើសផលិតផល / បញ្ចូលចំនួន",
  "Discount code is not available in this payment type": "កូដបញ្ចុះតម្លៃមិនអាចប្រើបានក្នុងប្រភេទការទូទាត់នេះ",
  "This voucher is not available use in washer payment": "វ៉ូឈឺនេះមិនអាចប្រើបានក្នុងការទូទាត់ម៉ាស៊ីនបោក",
  "This voucher is not available use in dryer payment": "វ៉ូឈឺនេះមិនអាចប្រើបានក្នុងការទូទាត់ម៉ាស៊ីនស្ងួត",
  "This voucher is not available use in Drop n Go payment": "វ៉ូឈឺនេះមិនអាចប្រើបានក្នុងការទូទាត់ Drop n Go",
  "Voucher is not available in this payment type": "វ៉ូឈឺមិនអាចប្រើបានក្នុងប្រភេទការទូទាត់នេះ",
  "Select the price for": "ជ្រើសតម្លៃសម្រាប់",
  "Enable Stamping": "បើកការទិញស្លាក",
  "Please select your preferred outlet": "សូមជ្រើសសាខាដែលអ្នកចូលចិត្ត",
  "Select your preferred outlet": "ជ្រើសសាខាដែលអ្នកចូលចិត្ត",
  "State": "រដ្ឋ",
  "Select State": "ជ្រើសរដ្ឋ",
  "Payment Successful!": "ការទូទាត់ជោគជ័យ!",
  "Thank you for purchasing Laundry Pass!": "អរគុណចំពោះការទិញប៉ាស់លាងខោអាវ!",
  "Your Laundry Pass expired on": "ប៉ាស់លាងខោអាវរបស់អ្នកផុតកំណត់នៅ",
  "You have used all your Laundry Pass": "អ្នកបានប្រើប៉ាស់លាងខោអាវរបស់អ្នកទាំងអស់",
  "Purchase Again": "ទិញម្តងទៀត",
  "Save Big!": "សន្សំបានច្រើន!",
  "You've saved": "អ្នកបានសន្សំ",
  "on your package!": "លើផែនការរបស់អ្នក!",
  "Please select distributor, operator or outlet": "សូមជ្រើសអ្នកចែកចាយ អ្នកប្រតិបត្តិការ ឬសាខា",
  "Please enter your mobile phone number or e-mail": "សូមបញ្ចូលលេខទូរស័ព្ទចល័ត ឬអ៊ីមែលរបស់អ្នក",
  "We’ll send you an SMS when your laundry’s ready": "យើងនឹងផ្ញើ SMS ទៅអ្នកពេលបោកខោអាវរួច",
  "Skip": "រំលង",
  "Notice": "សេចក្ដីជូនដំណឹង",
  "User exists but not verified. Please verify your account by scanning the QR Code at Thank You Page.": "អ្នកប្រើមានរួចហើយ ប៉ុន្តែមិនបានផ្ទៀងផ្ទាត់។ សូមផ្ទៀងផ្ទាត់គណនីដោយស្កែន QR នៅទំព័រ Thank You",
  "User registered successfully. Please complete verification by scanning the QR Code at Thank You Page.": "អ្នកប្រើបានចុះឈ្មោះជោគជ័យ។ សូមបញ្ចប់ការផ្ទៀងផ្ទាត់ដោយស្កែន QR នៅទំព័រ Thank You",
  "Please enter email address to register": "សូមបញ្ចូលអាសយដ្ឋានអ៊ីមែលដើម្បីចុះឈ្មោះ",
  "Please enter phone number to register": "សូមបញ្ចូលលេខទូរស័ព្ទដើម្បីចុះឈ្មោះ",
  "Camera permission is denied": "ការអនុញ្ញាតប្រើកាមេរ៉ាត្រូវបានបដិសេធ",
  "No camera device found": "រកមិនឃើញឧបករណ៍កាមេរ៉ា",
  "Camera is already in use by another app": "កាមេរ៉ាកំពុងត្រូវបានប្រើដោយកម្មវិធីផ្សេង",
  "Preferred Outlet": "សាខាដែលចូលចិត្ត",
  "Purchase Now": "ទិញឥឡូវនេះ",
  "Cancel Date": "ថ្ងៃបោះបង់",
  "Cancel Laundry Pass": "បោះបង់ប៉ាស់លាងខោអាវ",
  "Download or takes a screenshot of the QR code.": "ទាញយក ឬថតអេក្រង់ QR",
  "Launch and login banking app.": "បើក និងចូលកម្មវិធីធនាគារ",
  "Choose QR code from your gallery.": "ជ្រើស QR ពីថតរូបរបស់អ្នក",
  "1 March 2025 - 30 April 2025": "១ មីនា ២០២៥ - ៣០ មេសា ២០២៥",
  "Payment Method to get point": "វិធីទូទាត់សម្រាប់ទទួលពិន្ទុ",
  "Payment Method to get voucher": "វិធីទូទាត់សម្រាប់ទទួលវ៉ូឈឺ",
  "If applicable to all the payment method, leave it blank": "បើអាចប្រើបានសម្រាប់គ្រប់វិធីទូទាត់ ទុកទទេ",
  "Add {{ currency }} {{ amount }} for {{ mode }} Wash": "បន្ថែម {{ currency }} {{ amount }} សម្រាប់បោកម៉ូដ {{ mode }}",
  "Add {{ currency }} {{ amount }} for an extra {{ runtime }} minutes!": "បន្ថែម {{ currency }} {{ amount }} សម្រាប់ {{ runtime }} នាទីបន្ថែម!",
  "via": "តាម",
  "Cash": "សាច់ប្រាក់",
  "Are you sure you have collected your laundry?": "តើអ្នកប្រាកដថាបានយកខោអាវរួច?",
  "Collected All": "យករួចទាំងអស់",
  "Collected": "យករួច",
  "Are you sure the customer have collected the laundry?": "តើអ្នកប្រាកដថាអតិថិជនបានយកខោអាវរួច?",
  "Pending Payment (Cash)": "ការទូទាត់កំពុងរង់ចាំ (សាច់ប្រាក់)",
  "You have received the cash payment": "អ្នកបានទទួលការទូទាត់សាច់ប្រាក់",
  "Print Receipt": "បោះពុម្ពវិក្កយបត្រ",
  "Are you sure you want to print receipt?": "តើអ្នកប្រាកដថាចង់បោះពុម្ពវិក្កយបត្រ?",
  "Are you sure you want to print sticker?": "តើអ្នកប្រាកដថាចង់បោះពុម្ពស្លាក?",
  "Copy": "ចម្លង",
  "low": "ទាប",
  "medium": "មធ្យម",
  "high": "ខ្ពស់",
  "About Us": "អំពីយើង",
  "ABOUT US": "អំពីយើង",
  "Only can request einvoice for Malaysia Outlet": "អាចស្នើសុំ E-Invoice សម្រាប់សាខាម៉ាឡេស៊ីតែប៉ុណ្ណោះ",
  "E-Invoice requested successfully": "ស្នើសុំ E-Invoice ជោគជ័យ",
  "Select machine": "ជ្រើសម៉ាស៊ីន",
  "Select transaction date": "ជ្រើសថ្ងៃប្រតិបត្តិការ",
  "Transaction Time": "ម៉ោងប្រតិបត្តិការ",
  "Select transaction time": "ជ្រើសម៉ោងប្រតិបត្តិការ",
  "Transaction Amount": "ចំនួនប្រាក់ប្រតិបត្តិការ",
  "Enter Transaction Amount, Example: 1.50": "បញ្ចូលចំនួនប្រាក់ប្រតិបត្តិការ ឧ. 1.50",
  "Select payment method": "ជ្រើសវិធីទូទាត់",
  "Cashless (e-Wallet / DuitNow QR)": "គ្មានសាច់ប្រាក់ (e-Wallet / DuitNow QR)",
  "Paywave (Tap with Debit/Credit Card)": "Paywave (ទាញដោយកាតឥណពល/ឥណកាត)",
  "Request as": "ស្នើសុំជា",
  "Individual": "បុគ្គល",
  "Company": "ក្រុមហ៊ុន",
  "ID Type": "ប្រភេទអត្តសញ្ញាណ",
  "Select ID Type": "ជ្រើសប្រភេទអត្តសញ្ញាណ",
  "Company Name": "ឈ្មោះក្រុមហ៊ុន",
  "Phone": "ទូរស័ព្ទ",
  "Address": "អាសយដ្ឋាន",
  "City": "ទីក្រុង",
  "Postcode": "លេខ​កូដ​ប្រៃសណីយ៍",
  "Request E-Invoice": "ស្នើសុំ E-Invoice",
  "Request e-Invoice": "ស្នើសុំ e-Invoice",
  "e-Invoice Validation Link": "តំណភ្ជាប់ផ្ទៀងផ្ទាត់ E-Invoice",
  "Credit Card": "កាតឥណពល",
  "Credit Card Number": "លេខកាតឥណពល",
  "Credit Card Expiry Month": "ខែផុតកំណត់កាតឥណពល",
  "Credit Card Expiry Year": "ឆ្នាំផុតកំណត់កាតឥណពល",
  "Credit Card Securtiy Code": "លេខសុវត្ថិភាពកាតឥណពល",
  "Credit Card Holder Name": "ឈ្មោះម្ចាស់កាតឥណពល",
  "Settlement Amount": "ចំនួនទូទាត់",
  "Paid": "បានទូទាត់",
  "Enable E-Wallet Payment?": "បើកការទូទាត់ E-Wallet?",
  "Enable DuitNow Payment?": "បើកការទូទាត់ DuitNow?",
  "Enable Credit Card Terminal Payment?": "បើកការទូទាត់តាម Terminal កាតឥណពល?",
  "Transaction date is more than 3 days": "ថ្ងៃប្រតិបត្តិការលើស ៣ ថ្ងៃ",
  "Select Recurrence Type": "ជ្រើសប្រភេទចាក់បន្ត",
  "Multiple Voucher": "វ៉ូឈឺច្រើន",
  "Period for giving next voucher (days)": "រយៈពេលសម្រាប់ផ្តល់វ៉ូឈឺបន្ទាប់ (ថ្ងៃ)",
  "General Voucher Code Report": "របាយការណ៍កូដវ៉ូឈឺទូទៅ",
  "Unique Voucher Code Report": "របាយការណ៍កូដវ៉ូឈឺផ្ទាល់ខ្លួន",
  "Select Code": "ជ្រើសកូដ",
  "Minimum transaction amount to use code cannot be negative": "ចំនួនប្រតិបត្តិការតិចបំផុតសម្រាប់ប្រើកូដមិនអាចអវិជ្ជមាន",
  "Redeem per user must at least 1": "ការបញ្ចេញសម្រាប់អ្នកប្រើមួយត្រូវមានយ៉ាងហោចណាស់ 1",
  "Start date must before end date": "ថ្ងៃចាប់ផ្តើមត្រូវមុនថ្ងៃបញ្ចប់",
  "Please select the start date and end date": "សូមជ្រើសថ្ងៃចាប់ផ្តើម និងថ្ងៃបញ្ចប់",
  "Please enter the voucher code": "សូមបញ្ចូលកូដវ៉ូឈឺ",
  "Successfully create the voucher code": "បង្កើតកូដវ៉ូឈឺជោគជ័យ",
  "General Voucher Code": "កូដវ៉ូឈឺទូទៅ",
  "Unique Voucher Code": "កូដវ៉ូឈឺផ្ទាល់ខ្លួន",
  "Add Voucher Code": "បន្ថែមកូដវ៉ូឈឺ",
  "How many times the voucher code can be used for each user": "ប៉ុន្មានដងដែលកូដវ៉ូឈឺអាចប្រើបានសម្រាប់អ្នកប្រើម្នាក់",
  "Update Version": "ធ្វើបច្ចុប្បន្នភាពកំណែ",
  "User profile updated successfully": "ព័ត៌មានអ្នកប្រើបានធ្វើបច្ចុប្បន្នភាពជោគជ័យ",
  "Salutation": "ការគោរព",
  "Nationality": "សញ្ជាតិ",
  "Race": "ជនជាតិ",
  "Gender": "ភេទ",
  "Update salutation": "ធ្វើបច្ចុប្បន្នភាពការគោរព",
  "Update ID Type": "ធ្វើបច្ចុប្បន្នភាពប្រភេទអត្តសញ្ញាណ",
  "Update Address": "ធ្វើបច្ចុប្បន្នភាពអាសយដ្ឋាន",
  "Update nationality": "ធ្វើបច្ចុប្បន្នភាពសញ្ជាតិ",
  "Male": "ប្រុស",
  "Female": "ស្រី",
  "Update gender": "ធ្វើបច្ចុប្បន្នភាពភេទ",
  "Number of Point cannot be 0": "ចំនួនពិន្ទុមិនអាចសូន្យបាន",
  "Token value cannot be 0": "តម្លៃ Token មិនអាចសូន្យបាន",
  "Activate": "ចាប់ផ្ដើមប្រើ",
  "Deactivate": "បិទប្រើ",
  "Activate User": "ចាប់ផ្ដើមប្រើអ្នកប្រើ",
  "Deactivate User": "បិទប្រើអ្នកប្រើ",
  "Are you sure you want to activate the user account?": "តើអ្នកប្រាកដថាចង់ចាប់ផ្ដើមប្រើគណនីអ្នកប្រើ?",
  "Are you sure you want to deactivate the user account?": "តើអ្នកប្រាកដថាចង់បិទប្រើគណនីអ្នកប្រើ?",
  "Your point redemption is successful": "ការបញ្ចេញពិន្ទុរបស់អ្នកជោគជ័យ",
  "Point Redemption": "ការបញ្ចេញពិន្ទុ",
  "This redemption has already been completed": "ការបញ្ចេញនេះបានបញ្ចប់រួចហើយ",
  "Transaction Details": "ព័ត៌មានលម្អិតប្រតិបត្តិការ",
  "Please login to redeem point": "សូមចូលប្រើដើម្បីបញ្ចេញពិន្ទុ",
  "Login as {{name}}": "ចូលប្រើជា {{name}}",
  "Payment Amount Settings": "ការកំណត់ចំនួនទូទាត់",
  "Allow washer pay less than cheapest mode price?": "អនុញ្ញាតឱ្យម៉ាស៊ីនបោកបង់តិចជាងតម្លៃម៉ូដទាបបំផុត?",
  "Allow dryer pay less than minimum price?": "អនុញ្ញាតឱ្យម៉ាស៊ីនស្ងួតបង់តិចជាងតម្លៃអប្បបរមា?",
  "Drop n Go Settings": "ការកំណត់ Drop n Go",
  "Allow user pay for specific service only?": "អនុញ្ញាតឱ្យអ្នកប្រើបង់សម្រាប់សេវាកម្មជាក់លាក់តែប៉ុណ្ណោះ?",
  "Display pricing for each service?": "បង្ហាញតម្លៃសម្រាប់សេវាកម្មនីមួយៗ?",
  "Delete Voucher": "លុបវ៉ូឈឺ",
  "Are you sure you want to delete this voucher?": "តើអ្នកប្រាកដថាចង់លុបវ៉ូឈឺនេះ?",
  "Display in Promotion Page": "បង្ហាញនៅទំព័រកម្មវិធីផ្សព្វផ្សាយ",
  "Add Promotion": "បន្ថែមកម្មវិធីផ្សព្វផ្សាយ",
  "Select Transaction Status": "ជ្រើសស្ថានភាពប្រតិបត្តិការ",
  "Give Stamp for Drop n Go Transaction?": "ផ្តល់ស្លាកសម្រាប់ប្រតិបត្តិការប្រភេទ Drop n Go?",
  "Display machine capacity?": "បង្ហាញសមត្ថភាពម៉ាស៊ីន?",
  "External Voucher Code": "កូដវ៉ូឈឺខាងក្រៅ",
  "Import Voucher Code": "នាំចូលកូដវ៉ូឈឺ",
  "Voucher Code Stamp Settings": "ការកំណត់ស្លាកកូដវ៉ូឈឺ",
  "Upload Date": "ថ្ងៃផ្ទុកឡើង",
  "Import External Voucher Code": "នាំចូលកូដវ៉ូឈឺខាងក្រៅ",
  "Import": "នាំចូល",
  "Please select a valid CSV file": "សូមជ្រើសឯកសារ CSV ត្រឹមត្រូវ",
  "Redeemed": "បានបញ្ចេញ",
  "Sales": "ការលក់",
  "Drop N Go Dashboard": "ផ្ទាំងគ្រប់គ្រង Drop N Go",
  "Total Drop N Go Sales by Month": "ការលក់ Drop N Go សរុបតាមខែ",
  "Total Drop N Go Sales by Day": "ការលក់ Drop N Go សរុបតាមថ្ងៃ",
}


// function findMissingKeys(oldVersion, newVersion) {
//   const missingKeys = {};
//   Object.keys(newVersion).forEach(key => {
//     if (!oldVersion.hasOwnProperty(key)) {
//       missingKeys[key] = newVersion[key];
//     }
//   });
//   return missingKeys;
// }

// const missingKeys = findMissingKeys(translationTh, translationEn);
// console.log(missingKeys);

const resources = {
  en: {
    translation: translationEn,
  },
  ms: {
    translation: translationMs,
  },
  zh: {
    translation: translationZh,
  },
  zhtw: {
    translation: translationZhtw
  },
  th: {
    translation: translationTh
  },
  pt: {
    translation: translationPt
  },
  ar: {
    translation: translationAr
  },
  km: {
    translation: translationKm
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng:
    localStorage.getItem("language") ||
    window.navigator.language.substring(0, 2),
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
